'use strict';

//
// Dev version - forwards API calls to current host port 8080
//

// in IE 8 if dev tools has not been opened at least once, the console object
// can be undefined which will cause breakage
if (!window.console){
	window.console = {
		log: function () {},
		error: function () {},
		warn: function () {}
	};
}

/* jshint wsh: true */
/* global ApiHostResolver */
window.ApiHostResolver = {
	'getApiHost': function(api){
		// Get hosts from configuration. Default to production APIs when config is absent.
		switch (api) {
			case 'legacyRest':
				// Note: unlike the other two cases, callers don't expect this URL to end with a slash
				return window.recogniaComponentsConfig && window.recogniaComponentsConfig.restApiPath ? window.recogniaComponentsConfig.restApiPath : 'https://rest.recognia.com';
			case 'rest':
				var restApi = window.recogniaComponentsConfig && window.recogniaComponentsConfig.tcApiPath ? window.recogniaComponentsConfig.tcApiPath : 'https://api.tradingcentral.com';
				return restApi + '/';
			case 'staticServer':
				return 'https://global.tradingcentral.com/';
		}
	}
};

'use strict';

/*
 * Defines a range between two numbers. For each end can specify if the range is
 * inclusive.
 */
function NumberRange(x, inclusiveX, y, inclusiveY) {
	x = parseFloat(x);
	y = parseFloat(y);
	if (isNaN(x) || isNaN(y)){
		throw new TypeError('NumberRange requires both values to be numeric: \''+x+'\', \''+y+'\'');
	} else if (x > y) {
		throw new Error('Lower value must be less than or equal to upper value.');
	}
	this.x = x;
	this.y = y;
	this.inclusiveX = inclusiveX ? 1 : 0;
	this.inclusiveY = inclusiveY ? 1 : 0;
}
NumberRange.prototype = {
	/*
	 * Return true if the value is in this range. Throws error if the value is
	 * not of type 'number'.
	 */
	contains: function (z) {
		// don't use isNaN because the NaN constant is valid
		if (typeof z !== 'number'){
			throw new TypeError('\''+z+'\' is not a number');
		}
		var xT = (this.inclusiveX) ? (this.x <= z) : (this.x < z);
		var yT = (this.inclusiveY) ? (this.y >= z) : (this.y > z);
		return xT && yT;
	},
	getLowerBound: function(){
		return this.x;
	},
	getUpperBound: function(){
		return this.y;
	}
};
/*
 * Special range that isn't really a range. The only acceptable value is the NaN
 * constant.
 */
NumberRange.NaNRange = {
	contains: function(z){
		// the NaN constant is actually considered a 'number'
		return isNaN(z) && typeof z === 'number';
	},
	getLowerBound: function(){ return NaN; },
	getUpperBound: function(){ return NaN; }
};


/**
 * Created with JetBrains WebStorm.
 * User: Hosam
 * Date: 2012-12-07
 * Time: 8:58 PM
 * To change this template use File | Settings | File Templates.
 */
'use strict';
/* App Module */

var recogniaApp = angular.module('recognia', ['ngSanitize']);

recogniaApp.config( [
	'$compileProvider',
	'$sceDelegateProvider',
	function( $compileProvider, $sceDelegateProvider )
	{
		$compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|javascript):/);

		// The CDN base is protocol-relative, so it follows the protocol of the page
		// hosting the widget - http when Featured Ideas runs locally in a container.
		$sceDelegateProvider.resourceUrlWhitelist([
			'self',
			'https://global.tradingcentral.com/**',
			'http://global.tradingcentral.com/**'
		]);
	}
]);

var isNewUISupportedBrowser = (function() {

	var UnsupportedIEVersion = 10;
	var IEVersion;
	
	if (document.documentMode) {
		IEVersion = document.documentMode;
	} else {
		for (var i = UnsupportedIEVersion; i > 0; i--) {
			var div = document.createElement("div");
			div.innerHTML = "<!--[if IE " + i + "]><span></span><![endif]-->";
			if (div.getElementsByTagName("span").length) {
				IEVersion = i;
				break;
			}
		}
	}
	
	if (IEVersion <= UnsupportedIEVersion) {
		return false;
	} else {
		return true;
	}
})();

if (isNewUISupportedBrowser) {
	angular.element(document).ready(function() {
		angular.bootstrap(document, ['recognia']);
	});
}


"use strict";
var RecogniaCoreServices = {};


/**
 * jQuery Flexdatalist.
 * Autocomplete for input fields with support for datalists.
 *
 * Version:
 * 1.5.0
 *
 * Depends:
 * jquery.js 1.7+
 *
 * Demo and Documentation:
 * http://projects.sergiodinislopes.pt/flexdatalist/
 *
 * Github:
 * https://github.com/sergiodlopes/jquery-flexdatalist/
 *
 */
(function($) {
	'use strict';
	//regularExpression is a optional parameter
	$.fn.flexdatalist = function(options, value,selectedCallbackFunc,keyCallbackFunc,regularExpression) {
		var $document = $(document),
			$input = $(this),
			_this = this;
		_this.selectedCallbackFunc = selectedCallbackFunc;
		_this.keyCallbackFunc = keyCallbackFunc;
		_this.regularExpression = regularExpression;

		/**
		 * Destroy.
		 */

		this._receiveResults = function(resultObjs, elem){

			if(resultObjs){
				_this.elem.data('flexdatalist').data = resultObjs;
				_this.elem._search(function (results) {
					_this.elem._showResults(results);
				});
			}else{
				_this.elem._removeResults();
			}
		}


		this._destroy = function () {
			$input.removeClass('flexdatalist-set')
				.data('flexdatalist', null)
				.off()
				.val('')
				.attr('type', 'text')
				.next('.flexdatalist-alias, ul.flexdatalist-multiple')
				.remove();
			return false;
		}

		/**
		 * Reset.
		 */
		this._reset = function () {
			this._destroy();
		}

		/**
		 * Handle options.
		 */
		if (typeof options === 'string') {
			if (typeof this['_' + options] === 'function') {
				if (!this['_' + options]()) {
					return;
				}
			} else if (value) {
				var _data = $input.data('flexdatalist');
				_data[options] = value;
				$input.data('flexdatalist', _data);
				return;
			}
		}

		/**
		 * Get key code from event.
		 */
		this._keyNum = function (event) {
			return event.which || event.keyCode;
		}

		// Handle selection list keyboard shortcuts and events.
		if (!$document.data('flexdatalist')) {
			// Remove results on outside click
			$(document).mouseup(function (event) {
				var $container = $('.flexdatalist-results'),
					$target = $container.data('target');
				if ((!$target || !$target.is(':focus')) && !$container.is(event.target) && $container.has(event.target).length === 0) {
					$container.remove();
				}
				// Keyboard navigation
			}).keydown(function (event) {
				var $ul = $('.flexdatalist-results'),
					$li = $ul.find('li'),
					$active = $li.filter('.active'),
					index = $active.index(),
					length = $li.length,
					keynum = _this._keyNum(event);

				if (length === 0) {
					return;
				}

				// Enter key
				if (keynum === 13) {
					event.preventDefault();
					$active.click();
					// Up/Down key
				} else if (keynum === 40 || keynum === 38) {
					event.preventDefault();
					// Down key
					if (keynum === 40) {
						if (index < length && $active.nextAll('.item').first().length > 0) {
							$active = $active.removeClass('active').nextAll('.item').first().addClass('active');
						} else {
							$active = $li.removeClass('active').filter('.item:first').addClass('active');
						}
						// Up key
					} else if (keynum === 38) {
						if (index > 0 && $active.prevAll('.item').first().length > 0) {
							$active = $active.removeClass('active').prevAll('.item').first().addClass('active');
						} else {
							$active = $li.removeClass('active').filter('.item:last').addClass('active');
						}
					}

					// Scroll to
					var position = ($active.prev().length === 0 ? $active : $active.prev()).position().top;
					$ul.animate({
						scrollTop: position + $ul.scrollTop()
					}, 100);
				}
			}).data('flexdatalist', true);
		}

		/**
		 * Is variable empty.
		 */
		this._isEmpty = function (value) {
			if (!_this._isDefined(value)) {
				return true;
			} else if (value === null) {
				return true;
			} else if (value === true) {
				return false;
			} else if (this._length(value) === 0) {
				return true;
			} else if ($.trim(value) === '') {
				return true;
			}
			return false;
		}

		/**
		 * Is variable an object.
		 */
		this._isObject = function (value) {
			return (value && typeof value === 'object')
		}

		/**
		 * Get length of variable.
		 */
		this._length = function (value) {
			if (this._isObject(value)) {
				return Object.keys(value).length;
			} else if (typeof value.length === 'number') {
				return value.length;
			}
			return 0;
		}
		/**
		 * Check if variable (and optionally property) is defined.
		 */
		this._isDefined = function (variable, property) {
			var _variable = (typeof variable !== 'undefined');
			if (_variable && typeof property !== 'undefined') {
				return (typeof variable[property] !== 'undefined');
			}
			return _variable;
		}

		/**
		 * Each element iteration.
		 */
		return this.each(function() {
			var $this = $(this),
				_cache = {},
				_previousText = '',
				_inputName = $this.attr('name');
			_this.elem = $this;

			if ($this.hasClass('flexdatalist-set')) {
				return;
			}

			/**
			 * Option management.
			 */


			$this._options = function (option, value) {
				var _options = $this.data('flexdatalist');
				if (!_this._isDefined(option)) {
					return $this.data('flexdatalist');
				} else if (_this._isDefined(value)) {
					_options[option] = value;
				} else if (!_this._isObject(option)) {
					return (_this._isDefined(_options, option) ? _options[option] : null);
				} else {
					_options = option;
				}

				_options.searchIn = typeof _options.searchIn === 'string' ? _options.searchIn.split(',') : _options.searchIn;
				_options.relatives = _options.relatives && $(_options.relatives).length > 0 ? $(_options.relatives) : null;

				$this.data('flexdatalist', _options);
				_cache = {};
				return $this;
			}

			/**
			 * Get text property.
			 */
			$this._textProperty = function () {
				var _options = $this._options();
				return _options.textProperty === null ? _options.searchIn[0] : _options.textProperty;
			}

			$this._options($.extend({
					url: null,
					data: [],
					params: {},
					relatives: null,
					chainedRelatives: false,
					cache: true,
					minLength: 2,
					groupBy: false,
					selectionRequired: false,
					focusFirstResult: false,
					textProperty: null,
					valueProperty: null,
					visibleProperties: [],
					searchIn: ['label'],
					searchContain: false,
					searchEqual: false,
					normalizeString: null,
					multiple: $this.attr('multiple'),
					maxShownResults: 100
				}, options, $this.data()
			));

			// Handle multiple values
			var $_this = $this
				.clone(false)
				.attr({'list': null})
				.addClass('flexdatalist-alias')
				.removeClass('flexdatalist');
			if ($this._options('multiple')) {
				var $ulMultiple = $('<ul>')
					.addClass('flexdatalist-multiple')
					.css({
						'background-color': $this.css("background-color"),
						'border-color': $this.css("border-left-color"),
						'border-width': $this.css("border-left-width"),
						'border-style': $this.css("border-left-style"),
						'border-radius': $this.css("border-top-left-radius")
					})
					.insertAfter($this);
				var $li = $('<li class="input-container">')
					.addClass('flexdatalist-multiple-value')
					.append($_this)
					.appendTo($ulMultiple);
			} else {
				$_this.insertAfter($this);
			}
			$this.addClass('flexdatalist').attr('type', 'hidden');

			/**
			 * Initialize.
			 */
				// Sasan created
			$this._getData = function(val){

				if( _this.keyCallbackFunc){
					_this.keyCallbackFunc(val);
				}
			};

			$this._init = function () {
				var _options = $this._options();

				// Listen to parent input key presses and state events.
				$_this.on('input keydown', function (event) {
					var val = $this._keyword();
					// Comma separated values
					if (_this._keyNum(event) === 188 && !_options.selectionRequired && _options.multiple) {
						event.preventDefault();
						$this._value(val);
						$this._removeResults();
					}
					//listener shift key+tab, tab and esc
					if(_this._keyNum(event) === 9||_this._keyNum(event) === 27){
						$this._removeResults();
					}

					//User press enter key
					if(_this._keyNum(event) ===13){
						$this._data(function (data) {
							_this.selectedCallbackFunc(data[0]);
						});
					}

					// delete key and when it is the last char
					if(_this._keyNum(event) ===8&&val.length===0){
						$this._removeResults();
					}


				}).on('input keyup', function (event) {
					if ($this._changed() && _this._keyNum(event) !== 13) {
						var val = $this._keyword();
						if (val.length >= _options.minLength) {
							$this._getData(val); // Sasan modified
							/*
							 $this._search(function (results) {
							 $this._showResults(results);
							 });*/

						} else {
							$this._removeResults();
						}
						if (!_options.multiple) {
							if (!_options.selectionRequired) {
								$this._value(val);
							} else if (val.length === 0 || !$this._selected()) {
								$this._value('');
							}
						}
					}
					_previousText = $this._keyword();
				}).focus(function () {
					if (_options.minLength === 0) {
						if ($this._keyword() === '') {
							$this._data(function (data) {
								$this._showResults(data);
							});
						} else {
							$_this.trigger('keyup');
						}
					}
				}).blur(function () {
					if (_options.selectionRequired && !$this._selected()) {
						$this._value('');
					}
				})
					.attr('autocomplete', 'off');

				$this.addClass('flexdatalist-set');

				window.onresize = function(event) {
					$this._position();
				};
			}

			/**
			 * Check if field's text has changed.
			 */
			$this._changed = function () {
				return _previousText !== $this._keyword();
			}

			/**
			 * Check chained relatives.
			 */
			$this._chained = function () {
				/* var _options = $this._options();
				 if (!_options.relatives || !_options.chainedRelatives) {
				 return;
				 }
				 var toggle = function (init) {
				 _options.relatives.each(function () {
				 var disabled = _this._isEmpty($(this).val()),
				 empty = _this._isEmpty($this.val());
				 $_this.prop('disabled', disabled);
				 if (!init && (disabled || !empty)) {
				 $this._value('');
				 $_this.val('');
				 if (_options.multiple) {
				 $ulMultiple.find('li .remove').click();
				 }
				 }
				 });
				 }
				 _options.relatives.on('change', function () {
				 toggle();
				 _cache = {};
				 });
				 toggle(true);*/
			}

			/**
			 * Set value on load.
			 */
			$this._initValue = function () {
				/* var value = $this.attr('value');
				 if (_this._isEmpty(value)) {
				 return;
				 }
				 $this._parseValue(value, function (values) {
				 if (!_this._isEmpty(values)) {
				 $this.val('');
				 $this._values(values);
				 }
				 _previousText = $this._keyword();
				 });*/
			}

			/**
			 * Parse initial value.
			 */
			/* $this._parseValue = function (data, callback) {
			 var _options = $this._options();
			 if ($this._toJSON()) {
			 try {
			 callback(JSON.parse(data));
			 } catch (e) {}
			 } else if ($this._toCSV() || typeof _options.valueProperty === 'string') {
			 var values = data.split(',');
			 if (typeof _options.valueProperty === 'string') {
			 var _searchIn = _options.searchIn;
			 _options.searchIn = _options.valueProperty.split(',');
			 _options.searchEqual = true;
			 $this._search(function (results, matches) {
			 if (matches.length > 0) {
			 callback(matches);
			 }
			 _options.searchIn = _searchIn;
			 _options.searchEqual = false;
			 }, values);
			 } else {
			 callback(values);
			 }
			 } else {
			 callback(data);
			 }
			 }
			 */
			/**
			 * Get data.
			 */
			$this._data = function (callback) {
				var _options = $this._options(),
					url = _options.url;

				if (_this._isObject(_options.data) && !_this._isEmpty(_options.data)) {
					callback(_options.data);
					return;
				} else if (typeof _options.data === 'string') {
					url = _options.data;
				}

				else if (_this._isEmpty(_options.url) && _this._isEmpty(_options.data)) {
					return;
				}

				/* var keyword = $this._keyword(),
				 keywordTruncated = keyword.substring(0, _options.minLength),
				 cachedData = $this._cache(keywordTruncated);

				 // Check cache
				 if (cachedData) {
				 callback(cachedData);
				 return;
				 }

				 if ($this.hasClass('flexdatalist-loading')) {
				 return;
				 }
				 $this.addClass('flexdatalist-loading');

				 $.ajax({
				 url: url,
				 data: $.extend($this._relativesData(), _options.params, {
				 keyword: keyword,
				 contain: _options.searchContain,
				 selected: $this.val()
				 }
				 ),
				 type: 'post',
				 dataType: 'json',
				 success: function (data) {
				 $this.removeClass('flexdatalist-loading');
				 var _data = data.results ? data.results : data;
				 if (typeof _data === 'string' && _data.indexOf('[{') === 0) {
				 _data = JSON.parse(_data);
				 }
				 if (_this._isObject(_data)) {
				 callback(_data);
				 if (typeof _options.data === 'string') {
				 _options.data = _data;
				 } else if (!_this._isEmpty(_options.url) && !_this._isEmpty(_data)) {
				 $this._cache(keywordTruncated, _data);
				 }
				 }
				 }
				 });*/
			}

			/**
			 * Get data.
			 */
			$this._relativesData = function () {
				/*var relatives = $this._options('relatives'),
				 data = {};
				 if (relatives) {
				 data['relatives'] = {};
				 relatives.each(function () {
				 var $input = $(this);
				 data['relatives'][$input.attr('name')] = $input.val();
				 });
				 }
				 return data;*/
			}

			/**
			 * Set datalist data, if exists.
			 */
			$this._datalist = function () {
				var _options = $this._options(),
					list = $this.attr('list');
				if (!_this._isEmpty(list)) {
					_options.data = [];
					$('#' + list).find('option').each(function() {
						var val = $(this).val();
						_options.data.push({
							label: val,
							value: val
						});
					});
				}
				return $this;
			}

			/**
			 * Cached data.
			 */
			$this._cache = function (key, data) {
				/* if ($this._options('cache')) {
				 key = $this._normalizeString(key);
				 if (!_this._isDefined(data)) {
				 if (_this._isDefined(_cache, key)) {
				 data = _cache[key];
				 }
				 return data;
				 }
				 _cache[key] = data;
				 }
				 return null;*/
			}

			/**
			 * Search for keywords in data and return matches.
			 */
			$this._search = function (callback, keywords) {
				$this._data(function (data) {
					var results = [],
						matches = [];

					if (!_this._isDefined(keywords)) {
						keywords = $this._keyword();
					}
					if (typeof keywords === 'string') {
						keywords = [keywords];
					}
					var groupProperty = $this._options('groupBy');
					for (var kwindex = 0; kwindex < keywords.length; kwindex++) {
						var keyword = keywords[kwindex];
						for (var index = 0; index < data.length; index++) {
							var _data = $this._matches(data[index], keyword);
							if (!_data) {
								continue;
							}
							matches.push(_data);
							if (groupProperty) {
								if (_this._isDefined(_data, groupProperty)) {
									var propertyValue = _data[groupProperty];
									if (!_this._isDefined(results, propertyValue)) {
										results[propertyValue] = [];
									}
									results[propertyValue].push(_data);
								}
							} else {
								results.push(_data);
							}
						}
					}
					callback(results, matches);
				});
			}

			/**
			 * Match against searchable properties.
			 */
			$this._matches = function (item, keyword) {
				var hasMatches = false,
					searchIn = $this._options('searchIn');

				for (var index = 0; index < searchIn.length; index++) {
					var searchProperty = searchIn[index];
					if (!_this._isDefined(item, searchProperty)) {
						continue;
					}
					var propertyValue = item[searchProperty];
					if ($this._find(keyword, propertyValue, item)) {
						item[searchProperty + '_highlight'] = $this._highlight(keyword, propertyValue);
						hasMatches = true;
					}
				}
				return hasMatches ? item : null;
			}

			/**
			 * Wrap found keyword with span.highlight.
			 */
			$this._highlight = function (keyword, text) {

				var reg =_this.regularExpression ? _this.regularExpression +keyword : keyword;

				return text.replace(
					new RegExp(reg, ($this._options('searchContain') ? "ig" : "i")),
					'<span class="highlight">$&</span>'
				);
			}

			/**
			 * Search for keyword in string.
			 */
			$this._find = function (keyword, text, item) {
				var _options = $this._options();
				text = $this._normalizeString(text),
					keyword = $this._normalizeString(keyword);
				if (_options.searchEqual) {
					return (text == keyword);
				}
				return (_options.searchContain ? (text.indexOf(keyword) >= 0) : (text.indexOf(keyword) === 0));
			}

			/**
			 * Show results.
			 */
			$this._showResults = function (data) {
				$this._removeResults();
				var $ul = $this._getResultsContainer(),
					_options = $this._options();

				if ($this._selected()) {
					$this._selected(false)._value('');
				}
				if (!_options.groupBy) {
					$this._items(data, $ul);
				} else {
					Object.keys(data).forEach(function (groupName, index) {
						var items = data[groupName],
							property = _options.groupBy,
							groupText = $this._getHighlight(items[0], property, groupName);

						var $li = $('<li>')
							.addClass('group')
							.append($('<span>')
								.addClass('group-name')
								.html(groupText)
						)
							.append($('<span>')
								.addClass('group-item-count')
								.text(' ' + items.length)
						)
							.appendTo($ul);

						$this._items(items, $ul);
					});
				}

				var $li = $ul.find('li:not(.group)');
				$li.on('click', function (event) {
					var item = $(this).data('item');
					_this.selectedCallbackFunc(item);
					if (item) {
						$this._selected(true)._removeResults();
						$_this.val('');
						$this.trigger('select:flexdatalist', [item, _options]);
					}
				}).hover(function() {
					$li.removeClass('active');
					$(this).addClass('active');
				}, function() {
					$(this).removeClass('active');
				});

				if (_options.focusFirstResult) {
					$li.filter(':first').addClass('active');
				}

				$this._position();
				$ul.insertAfter($_this);
			}

			/**
			 * Get/create list container.
			 */
			$this._getResultsContainer = function () {
				var $target = $this;
				if ($this._options('multiple')) {
					$target = $ulMultiple;
				}
				var $container = $('ul.flexdatalist-results');
				if ($container.length === 0) {
					$container = $('<ul>')
						.addClass('flexdatalist-results')
						.appendTo('body')
						.css({
							'border-color': $target.css("border-left-color"),
							'border-width': '1px',
							'border-bottom-left-radius': $target.css("border-bottom-left-radius"),
							'border-bottom-right-radius': $target.css("border-bottom-right-radius")
						}).data('target', $_this);
				}
				$container.attr("id","autoCompleteList");
				return $container;
			}

			/**
			 * Items iteration.
			 */
			$this._items = function (items, $ul) {
				var max = $this._options('maxShownResults');
				for (var index = 0; index < items.length; index++) {
					if (max > 0 && max === index) {
						break;
					}
					$this._item(items[index]).appendTo($ul);
				}
			}

			/**
			 * Result item creation.
			 */
			$this._item = function (item) {
				var $li = $('<li>')
						.data('item', item)
						.addClass('item'),
					_options = $this._options(),
					visibleProperties = _options.visibleProperties.length === 0 ? _options.searchIn : _options.visibleProperties;

				for (var index = 0; index < visibleProperties.length; index++) {
					var property = visibleProperties[index];
					if (_options.groupBy && _options.groupBy === property || !_this._isDefined(item, property)) {
						continue;
					}
					var $item = {};
					if (property === 'thumb') {
						// Thumbnail image
						$item = $('<img>')
							.addClass('item item-' + property)
							.attr('src', item[property]);
					} else {
						var propertyText = $this._getHighlight(item, property);
						// Other text properties
						$item = $('<span>')
							.addClass('item item-' + property)
							.html(propertyText + ' ');
					}
					$item.appendTo($li);
				}
				return $li;
			}

			/**
			 * Remove results.
			 */
			$this._removeResults = function () {
				$('ul.flexdatalist-results').remove();
				_this.elem.data('flexdatalist').data = [];
				return $this;
			}

			/**
			 * Check if is selected or set field as selected.
			 */
			$this._selected = function (selected) {
				var className = 'flexdatalist-selected';
				if (!_this._isDefined(selected)) {
					return $this.hasClass(className);
				}
				selected ? $this.addClass(className) : $this.removeClass(className);
				return $this;
			}

			/**
			 * Set multiple values.
			 */
			$this._values = function (values) {
				if ($.isArray(values) && !_this._isEmpty(values)) {
					$.each(values, function (i, value) {
						$this._value(value);
					});
					return;
				}
				$this._value(values);
			}

			/**
			 * Set value on item selection.
			 */
			$this._value = function (val) {
				var text = $this._getText(val),
					value = $this._getValue(val);

				if ($this._options('multiple')) {
					if (val === '') {
						return $this;
					}
					$_this.val('');
					var $li = $('<li>')
						.addClass('value')
						.append('<span class="text">' + text + '</span>')
						.append('<span class="fdl-remove">&times;</span>')
						.insertBefore($ulMultiple.find('li.input-container'));

					$li.find('span.fdl-remove').click(function () {
						var $container = $(this).parent();
						if ($this._toJSON() || $this._toCSV()) {
							var currentValue = $this._inputValue();
							currentValue.splice($container.index(), 1);
							$this._inputValue(currentValue);
						}
						$container.remove();
					});
				} else if (text && text !== $_this.val()) {
					$_this.val(text);
				}
				$this._inputValue(value, text);
				_previousText = $this._keyword();
				return $this;
			}

			/**
			 * Get/Set input value.
			 */
			$this._inputValue = function (value, text) {
				var isJSON = $this._toJSON(),
					isCSV = $this._toCSV();

				if (!_this._isDefined(value)) {
					value = $this.val();
					if (value) {
						if (isJSON) {
							value = JSON.parse(value);
						} else if (isCSV) {
							value = value.split(',');
						}
					} else if (isJSON || isCSV) {
						value = [];
					}
					return value;
				}

				if (_this._isObject(value)) {
					if (isJSON && !_this._isEmpty(value)) {
						value = JSON.stringify(value);
					} else if (isCSV) {
						value = value.join(',');
					}
				}
				$this.val(value);
				$this.trigger('change:flexdatalist', [value, text, $this._options()]).trigger('change');
				return value;
			}

			/**
			 * Get text that will be shown to user on input field.
			 */
			$this._getText = function (item) {
				var text = item,
					searchIn = $this._options('searchIn'),
					textProperty = $this._textProperty();

				if (_this._isObject(item)) {
					text = item[searchIn[0]];
					if (_this._isDefined(item, textProperty)) {
						text = item[textProperty];
					} else {
						text = $this._replacePlaceholders(item, textProperty, text);
					}
				}
				return text;
			}

			/**
			 * Get the value that will be added to hidden input.
			 * This is the value that eventually will be sent on form submittion.
			 */
			$this._getValue = function (item) {
				var value = item,
					_options = $this._options();
				if (_this._isObject(item)) {
					value = item[_options.searchIn[0]];
					if (_options.valueProperty === '*') {
						value = item;
					} else if (_this._isDefined(item, _options.valueProperty)) {
						value = item[_options.valueProperty];
					} /*else if ($this._toJSON()) {
					 var value = {},
					 properties = _options.valueProperty,
					 textProperties = $this._textProperty();

					 // Add placeholder properties to list
					 if (textProperties) {
					 var _properties = textProperties;
					 if (typeof textProperties === 'string') {
					 _properties = $this._parsePlaceholders(textProperties);
					 }
					 if (_this._isObject(_properties)) {
					 $.each(_properties, function (string, property) {
					 properties.push(property);
					 });
					 }
					 } else if (_this._isDefined(item, textProperties)) {
					 properties.push(textProperties);
					 }

					 $.each(properties, function (i, property) {
					 if (_this._isDefined(item, property)) {
					 value[property] = item[property];
					 }
					 });
					 }*/
				}
				/* if (_options.multiple && ($this._toJSON() || $this._toCSV())) {
				 var currentValue = $this._inputValue();
				 if (!_this._isEmpty(value) && _this._isObject(currentValue)) {
				 currentValue.push(value);
				 value = currentValue;
				 }
				 }*/
				return value;
			}

			/**
			 * Replace placeholders ('{property_name}') in text
			 * with respective property value.
			 */
			$this._replacePlaceholders = function (item, pattern, value) {
				if (_this._isObject(item) && typeof pattern === 'string') {
					var properties = $this._parsePlaceholders(pattern);
					if (!_this._isEmpty(item) && properties) {
						$.each(properties, function (string, property) {
							if (_this._isDefined(item, property)) {
								pattern = pattern.replace(string, item[property]);
							}
						});
						return pattern;
					}
				}
				return value;
			}

			/**
			 * Extract placeholders property names.
			 */
			$this._parsePlaceholders = function (pattern) {
				var matches = pattern.match(/\{.+?\}/g);
				if (matches) {
					var properties = {};
					matches.map(function (string) {
						properties[string] = string.slice(1, -1);
					});
					return properties;
				}
				return false;
			}

			/**
			 * Normalize string to a consistent one to perform the search/match.
			 */
			$this._normalizeString = function (string) {

				if (typeof string === 'string') {
					var normalizeString = $this._options('normalizeString');
					if (typeof normalizeString === 'function') {
						string = normalizeString(string);
					}
					return string.toUpperCase();
				}
				return string;

			}

			/**
			 * Get keyword with left trim.
			 */
			$this._keyword = function () {
				return $_this.val().replace(/^\s+/, "");
			}

			/**
			 * Check if input value must be a JSON string.
			 */
			$this._toJSON = function () {

				/* var valueProperty = $this._options('valueProperty');
				 return _this._isObject(valueProperty) || valueProperty === '*';*/

			}

			/**
			 * Check if input value must be a CSV string.
			 */
			$this._toCSV = function () {

				/* return (!$this._toJSON() && $this._options('multiple'));*/

			}

			/**
			 * Check if highlighted property value exists,
			 * if true, return it, if not, fallback to given string
			 */
			$this._getHighlight = function (item, property, fallback) {
				if (_this._isDefined(item, property + '_highlight')) {
					return item[property + '_highlight'];
				}
				return (_this._isDefined(item, property) ? item[property] : fallback);
			}

			/**
			 * Position results below parent element.
			 */
			$this._position = function () {
				var $target = $_this;
				if ($this._options('multiple')) {
					$target = $ulMultiple;
				}
				var width;
				width = $target.outerWidth() > 250 ? $target.outerWidth() : 300;
				// Set some required CSS properties
				$('ul.flexdatalist-results').css({
					'width': width + 'px',
					//'top': (($target.offset().top + $target.outerHeight())) + 'px',
					//'left': $target.offset().left + 'px',
					'z-index': ($target.css('z-index') + 1)
				});
			};

			// Set datalist data
			//$this._datalist();
			// Initialize
			$this._init();
			// Process default value
			//   $this._initValue();
			// Handle chained fields
			//  $this._chained();
			_previousText = $this._keyword();
		});
	}
	//$('input.flexdatalist').flexdatalist();
})(jQuery);
'use strict';
var RecogniaCoreServices = RecogniaCoreServices  || {};

(function(coreServices, $){

	coreServices.getAutoComplete = function(inputClass, configObj,selectedcallback, keyCallback,regularExpression){
		inputClass = "." + inputClass;

		try{
			return $(inputClass).flexdatalist(configObj,null,selectedcallback,keyCallback,regularExpression);

		}catch(e){

			throw new Error('could not create autoComplete control ---> ' + e.message);
		}
	};

})(RecogniaCoreServices, jQuery);
/**
 * Copyright Recognia Inc. 2016
 * Copyright TradingCentral 2016
 */

/**
 * Main namespace for charting objects
 * @export
 * @type {{}}
 */
var charting = {};

/**
 * Main namespace for plot and section definitions
 */
charting.definition = {};

/**
 * Copyright Recognia Inc. 2016
 * Copyright TradingCentral 2016
 *
 * Created by Hosam on 2016-05-09.
 */


/**
 * Defines built-in plots for each timeseries
 * Each plot has:
 *  id
 *  renderer
 *  timeseries (accessor)
 *  css class
 *  section
 */
charting.definition.defaultPlotClass = function(entry, plot) {
	if (!plot) return;
	return 'tc-plot-' + plot.id;
};

charting.definition.slowStochasticStrokeWidth = function(entry) {
	if (!entry) return;
	return entry === 'stochasticfast'? 1: 0.5;
};

charting.definition.fastStochasticStrokeWidth = function(entry) {
	if (!entry) return;
	return entry === 'stochastic'? 1: 0.5;
};

charting.definition.defaultStrokeWidth = function(entry) {
	return 0.75;
};

var defaultStrokeWidth = 0.75;


charting.definition.plot = {
	'plot-price-candlestick': {
		strokeWidth: defaultStrokeWidth,
		id: 'price',
		render: 'price-plot',
		accessors: [
			{
				name: 'open',
				accessor: 'open'
			},
			{
				name: 'high',
				accessor: 'high'
			},
			{
				name: 'low',
				accessor: 'low'
			},
			{
				name: 'close',
				accessor: 'close'
			}
		],
		class: function (entry, plot) {
			if (!entry) return;

			var dir = entry.open < entry.close ? "up" : "down";

			return 'tc-plot-candlestick-' + dir;
		},
		section: 'section-price'
	},
	'plot-price-ohlc': {
		strokeWidth: defaultStrokeWidth,
		id: 'price',
		render: 'price-plot',
		accessors: [
			{
				name: 'open',
				accessor: 'open'
			},
			{
				name: 'high',
				accessor: 'high'
			},
			{
				name: 'low',
				accessor: 'low'
			},
			{
				name: 'close',
				accessor: 'close'
			}
		],
		class: 'tc-plot-ohlc',
		section: 'section-price'
	},
	'plot-close': {
		id: 'close',
		render: 'area-plot',
		accessors: [
			{
				name: 'close',
				accessor: 'close'
			}],
		class: 'tc-plot-close',
		section: 'section-close'
	},
	'plot-volume': {
		id: 'volume',
		render: 'bar-plot',
		accessors: [
			{
				name: 'volume',
				accessor: 'volume'
			}],
		class: 'tc-plot-volume',
		section: 'section-volume'
	},
	'plot-macd': {
		class: charting.definition.defaultPlotClass,
		strokeWidth: charting.definition.defaultStrokeWidth
	},
	'plot-momentum': {
		class: charting.definition.defaultPlotClass,
		strokeWidth: charting.definition.defaultStrokeWidth
	},
	'plot-bollinger': {
		strokeWidth: defaultStrokeWidth,
		id: 'bollinger',
		render: 'line-plot',
		accessors: [
			{
				name: 'bollinger',
				accessor: 'bollinger'
			}],
		class: 'tc-plot-bollinger',
		section: 'section-price'
	},
	'plot-bblower': {
		strokeWidth: defaultStrokeWidth,
		id: 'bblower',
		render: 'line-plot',
		accessors: [
			{
				name: 'bblower',
				accessor: 'bblower'
			}],
		class: 'tc-plot-bblower',
		section: 'section-price'
	},
	'plot-bbupper': {
		strokeWidth: defaultStrokeWidth,
		id: 'bbupper',
		render: 'line-plot',
		accessors: [
			{
				name: 'bbupper',
				accessor: 'bbupper'
			}],
		class: 'tc-plot-bbupper',
		section: 'section-price'
	},
	'plot-sma4': {
		strokeWidth: defaultStrokeWidth,
		id: 'sma4',
		render: 'line-plot',
		accessors: [
			{
				name: 'sma4',
				accessor: 'sma4'
			}],
		class: 'tc-plot-sma4',
		section: 'section-price'
	},
	'plot-rsi': {
		class: charting.definition.defaultPlotClass,
		strokeWidth: charting.definition.defaultStrokeWidth
	},

	'plot-cci': {
		class: charting.definition.defaultPlotClass,
		strokeWidth: charting.definition.defaultStrokeWidth
	},
	'plot-faststochastic': {
		class: charting.definition.defaultPlotClass,
		strokeWidth: charting.definition.fastStochasticStrokeWidth
	},
	'plot-slowstochastic': {
		class: charting.definition.defaultPlotClass,
		strokeWidth: charting.definition.slowStochasticStrokeWidth
	},
	'plot-williams': {
		class: charting.definition.defaultPlotClass,
		strokeWidth: charting.definition.defaultStrokeWidth
	},
	'plot-sma9': {
		strokeWidth: defaultStrokeWidth,
		id: 'sma9',
		render: 'line-plot',
		accessors: [
			{
				name: 'sma9',
				accessor: 'sma9'
			}
		],
		class: 'tc-plot-sma9',
		section: 'section-price'
	},
	'plot-sma18': {
		strokeWidth: defaultStrokeWidth,
		id: 'sma18',
		render: 'line-plot',
		accessors: [
			{
				name: 'sma18',
				accessor: 'sma18'
			}
		],
		class: 'tc-plot-sma18',
		section: 'section-price'
	},
	'plot-sma21': {
		strokeWidth: defaultStrokeWidth,
		id: 'sma21',
		render: 'line-plot',
		accessors: [
			{
				name: 'sma21',
				accessor: 'sma21'
			}
		],
		class: 'tc-plot-sma21',
		section: 'section-price'
	},
	'plot-sma50': {
		strokeWidth: defaultStrokeWidth,
		id: 'sma50',
		render: 'line-plot',
		accessors: [
			{
				name: 'sma50',
				accessor: 'sma50'
			}
		],
		class: 'tc-plot-sma50',
		section: 'section-price'
	},
	'plot-sma200': {
		strokeWidth: defaultStrokeWidth,
		id: 'sma200',
		render: 'line-plot',
		accessors: [
			{
				name: 'sma200',
				accessor: 'sma200'
			}
		],
		class: 'tc-plot-sma200',
		section: 'section-price'
	}
};

/**
 * Copyright Recognia Inc. 2016
 * Copyright TradingCentral 2016
 *
 * Created by Hosam on 2016-05-09.
 */

/**
 * Defines the built-in sections.
 * For each section, it has a default order, Y-axis label format and the height of the section
 * @type {{section-price: {id: string, order: number, yAxisTickFormat: *, height: recogniaCharting.definition.section.section-price.height}, section-close: {id: string, order: number, yAxisTickFormat: *, height: recogniaCharting.definition.section.section-close.height}, section-volume: {id: string, order: number, yAxisTickFormat: *, height: recogniaCharting.definition.section.section-volume.height}, section-macd: {id: string, order: number, yAxisTickFormat: *, height: recogniaCharting.definition.section.section-macd.height}, section-momentum: {id: string, order: number, yAxisTickFormat: *, height: recogniaCharting.definition.section.section-momentum.height}, section-rsi: {id: string, order: number, yAxisTickFormat: *, height: recogniaCharting.definition.section.section-rsi.height}, section-cci: {id: string, order: number, yAxisTickFormat: *, height: recogniaCharting.definition.section.section-cci.height}, faststochastic: {id: string, order: number, yAxisTickFormat: *, height: recogniaCharting.definition.section.faststochastic.height}, slowstochastic: {id: string, order: number, yAxisTickFormat: *, height: recogniaCharting.definition.section.slowstochastic.height}, williams: {id: string, order: number, yAxisTickFormat: *, height: recogniaCharting.definition.section.williams.height}}}
 */
charting.definition.section = {
	'section-price': {
		id: 'section-price',
		yAxisTickFormat: '.4s',
		height: function (section, parentWidth, parentHeight) {
			return Math.max(section.width() * 0.4, 250);
		}
	},
	'section-spacer': {
		id: 'section-spacer',
		topMargin: 0,
		bottomMargin:0,
		height: 10,
		grid:false,
		xAxis:{
			position:"bottom",
			height:0,
			show:false
		},
		yAxis:{
			position:"right",
			"show":false
		}
	},
	'section-close': {
		id: 'section-close',
		yAxisTickFormat: '.4s',
		height: function (section, parentWidth, parentHeight) {
			return Math.max(section.width() * 0.1, 100);
		},
		yAxis:{
			position:"right",
			"show":false
		}
	},
	'section-volume': {
		id: 'section-volume',
		yAxisTickFormat: '.1s',
		topMargin: 0,
		height: function (section, parentWidth, parentHeight) {
			return Math.max(section.width() * 0.1, 100);
		}

	},
	'section-macd': {
		id: 'section-macd',
		yAxisTickFormat: '.01f',
		height: function (section, parentWidth, parentHeight) {
			return Math.max(section.width() * 0.3, 150);
		}
	},
	'section-momentum': {
		id: 'section-momentum',
		yAxisTickFormat: '.4s',
		height: function (section, parentWidth, parentHeight) {
			return Math.max(section.width() * 0.3, 150);
		}
	},
	'section-rsi': {
		id: 'section-rsi',
		yAxisTickFormat: 'd',
		height: function (section, parentWidth, parentHeight) {
			return Math.max(section.width() * 0.3, 250);
		}
	},
	'section-cci': {
		id: 'section-cci',
		yAxisTickFormat: 'd',
		height: function (section, parentWidth, parentHeight) {
			return Math.max(section.width() * 0.3, 250);
		}
	},
	'section-faststochastic': {
		id: 'section-faststochastic',
		yAxisTickFormat: 'd',
		height: function (section, parentWidth, parentHeight) {
			return Math.max(section.width() * 0.3, 250);
		}
	},
	'section-slowstochastic': {
		id: 'section-slowstochastic',
		yAxisTickFormat: 'd',
		height: function (section, parentWidth, parentHeight) {
			return Math.max(section.width() * 0.3, 250);
		}
	},
	'section-williams': {
		id: 'section-williams',
		yAxisTickFormat: 'd',
		height: function (section, parentWidth, parentHeight) {
			return Math.max(section.width() * 0.3, 250);
		}
	}
};



/**
 * Copyright Recognia Inc. 2016
 * Copyright TradingCentral 2016
 *
 * Created by Hosam on 2016-05-09.
 */

/**
 * @type {{}}
 */
charting.tools = {};

charting.tools.dateFormat = function (d) {
	d = new Date(d);
	var format = d3.time.format.multi([
		[".%L", function (d) {
			return d.getMilliseconds();
		}],
		[":%S", function (d) {
			return d.getSeconds();
		}],
		["%b %d", function (d) {
			return d.getMinutes() == 45 && d.getHours() == 9;
		}],
		["%H:%M", function (d) {
			return d.getMinutes() || d.getHours();
		}],
		["%I %p", function (d) {
			return d.getHours();
		}],
		["%b %d", function (d) {
			return d.getDay() && d.getDate() != 1;
		}],
		["%b %d", function (d) {
			return d.getDate() != 1;
		}],
		["%B", function (d) {
			return d.getMonth();
		}],
		["%Y", function () {
			return true;
		}]
	]);

	return format(d);
};

charting.tools.createSection = function (container, sectionId) {

	if (container.attr('type') != 'chart') {
		console.error('Invalid object to use with section: ' + container.attr('type'));
		return;
	}
	return container.append('section')
		.attr(charting.definition.section[sectionId]);

};

charting.tools.createPlot = function (container, plotId, eventId, id) {
	var section = container;
	if (container.attr('type') === 'chart') {
		// Get the section
		section = container.getById(charting.definition.plot[plotId].section);
		if (!section) {
			// Create section
			section = charting.tools.createSection(container, charting.definition.plot[plotId].section);
		}
	}

	var plotAttr = charting.definition.plot[plotId];
	return section.append(plotAttr.render)
		.attr({
			id: plotAttr.id + '!' + id + '-' + eventId,
			accessors: plotAttr.accessors,
			class: plotAttr.class,
			strokeWidth: plotAttr.strokeWidth
		});

};


'use strict';
/**
 * Created by arizvi on 6/16/16.
 */

/**
 * Generate the price chart
 * @param services
 * @param parentElement
 * @param config
 * @param idea
 * @returns {bling.TimeseriesChart}
 * @constructor
 */

var RecogniaChart = (function(recogChart){
    var priceChartObject;
    recogChart.PriceChartGenerator = function (services,parentElement,config,idea) {
        // initialize the d3 locale
        blingUtils.initializeD3Locale(services.Lexicon,services.NumberFormatter);

        var blingChartInst = new bling.TimeseriesChart($(parentElement));

        // disable the chart on load
        blingChartInst.attr('enable', false);

        if (config.ideaType === 'stock') {
            priceChartObject = (config.largeChart) ?
                new LargeStocksPriceChart(services,config,blingChartInst) : new SmallStocksPriceChart(services,config,blingChartInst);
        } else if (config.ideaType === 'option') {
            priceChartObject = (config.largeChart) ?
                new LargeOptionsPriceChart(services,config,blingChartInst) : new SmallOptionsPriceChart(services,config,blingChartInst);
        } else if (config.ideaType === 'forex') {
            priceChartObject = (config.largeChart) ?
                new LargeForexPriceChart(services,config,blingChartInst) : new SmallForexPriceChart(services,config,blingChartInst);
        }
        var newIdea = (JSON.parse(JSON.stringify(idea)));
        newIdea.productType = config.productType;

        priceChartObject.init(newIdea);

        return blingChartInst;
    }

    /**
     * Disable the old idea, and enable the new idea (the one in view)
     * @param blingChartInst
     * @param newval
     * @param idea
     */
    recogChart.enableDisableIdea = function(blingChartInst,newval,idea) {
        blingChartInst.attr('enable', newval === idea);
    }

    /**
     * Turn on watched idea blue style if the idea already watched
     *@param blingChartInst
     *@param on
     * */
    recogChart.turnOnWatchIdeaStyle = function(blingChartInst,on){
        priceChartObject.turnOnWatchedStopStyle(blingChartInst,on);
    }
    
    return recogChart;
    
})(RecogniaChart || {}); // using loose augmentation


/**
 * Most parent object for all Bling charts
 * @constructor
 */
var RecogniaChart = (function (recogChart) {        
    return recogChart;
})(RecogniaChart || {}); // using loose augmentation
'use strict';

/**
 * Parent object for all price chart. Holds all the common functionality
 */
function PriceChart(services, blingChartInst, instrumentType) {
	this.services = services;
	this.blingChartInst = blingChartInst;
	this.instrumentType = instrumentType;
	this.lastpriceElement = undefined;
	this.priceFormatSpecifier = undefined;

	// stores a mapping between all bling event objects and its corresponding events
	this.EVENT_MAPPING = {};
	this.timeseriesDataSource = new bling.TimeseriesDataSource();
}

PriceChart.prototype = Object(RecogniaChart._proto_);
PriceChart.prototype.constructor = PriceChart;

PriceChart.prototype.barDetailTimeseries = ["open", "high", "low", "close"];
PriceChart.prototype.abreviatedBarDetailTimeseries = ["open", "close"];
PriceChart.prototype.volumeTimeseries = "volume";


PriceChart.prototype.registerEventListeners = function(events,target) {
	var self = this;
	var eventInfo = blingUtils.getEventClass(events,self.services);   
	
      self.sectionExitCallback = function(){               
		self.setElementsToNormal(null, null, self, eventInfo);         
        // making the legend visible but only if type of chart is forex
        if(typeof self.setIndicatorLegentObj === 'function' ){         
		   if(!self.counter){
			    self.setIndicatorLegentObj();
		   }		   			
        }                       
    }
    
	self.blingChartInst.bindSectionEvents('mouseMove.' + target.attr('id'), target, target._onSectionMove);
	self.blingChartInst.bindSectionEvents('mouseExit.' + "forexChart", self, self.sectionExitCallback);

	target.on('mouseEnter.' + target.attr('id'), this, function(eventName, target) {
		var targetId = target.attr('id').split('-');
		targetId.shift();	// drop first element, the rest is the event id
		var targetEventId = targetId.join('-');
		var selectedEvent = this.EVENT_MAPPING[targetEventId];
    
		for (var eventId in this.EVENT_MAPPING) {
			var elementObjs = this.EVENT_MAPPING[eventId];
			for (var i=0; i < elementObjs.length; i++) {
				if (eventId === targetEventId) {
					elementObjs[i].handler("foreground", self.blingChartInst.getById(elementObjs[i].elementId));
				} else {
					elementObjs[i].handler("background", self.blingChartInst.getById(elementObjs[i].elementId), selectedEvent[1].eventName, self.blingChartInst);
				}
			}
		}
		self.fadeUnfadeCrosshair(eventInfo, "fade");
	});     
    
    target.on('mouseExit.' + target.attr('id'), this, function(eventName, target){        
        self.setElementsToNormal(eventName, target, self, eventInfo);            
	});
};

PriceChart.prototype.setElementsToNormal =function(eventName, target, contextObj, eventInfo){
    
    for (var eventId in this.EVENT_MAPPING) {
			var elementIds = this.EVENT_MAPPING[eventId];
			for (var i=0; i < elementIds.length; i++) {    
				elementIds[i].handler("normal", contextObj.blingChartInst.getById(elementIds[i].elementId), null, contextObj.blingChartInst);                
			}
		}
		contextObj.fadeUnfadeCrosshair(eventInfo, "unfade");
}

//Hide/show selected event's name
PriceChart.prototype.showHideEventName= function(state, section, eventName, blingChartInst) {
	if(state === "background"){
		section.attr('text', eventName);
		blingChartInst.getById(blingChartConstants.SECTION.hoverEventHeaderDesktop).attr({opacity: 1, transition: 50});
		blingChartInst.getById(blingChartConstants.SECTION.hoverEventHeaderMobile).attr({opacity: 1, transition: 50});
		blingChartInst.getById(blingChartConstants.SECTION.barDetailsDesktop).attr({opacity: 0, transition: 0});
		blingChartInst.getById(blingChartConstants.SECTION.barDetailsMobile).attr({opacity: 0, transition: 0});
	} else {
		blingChartInst.getById(blingChartConstants.SECTION.hoverEventHeaderDesktop).attr({opacity: 0, transition: 0});
		blingChartInst.getById(blingChartConstants.SECTION.hoverEventHeaderMobile).attr({opacity: 0, transition: 0});
		blingChartInst.getById(blingChartConstants.SECTION.barDetailsDesktop).attr({opacity: 1, transition: 0});
		blingChartInst.getById(blingChartConstants.SECTION.barDetailsMobile).attr({opacity: 1, transition: 0});
	}
};


PriceChart.prototype.visibleElement= function(state, elemObj) {	
    if(state === "foreground"){
		elemObj.attr({opacity:1, transition: 50});
	} else if (state === "background" || state === "normal"){
		elemObj.attr({opacity:0, transition: 50});
	}
};

//Highlight/dim event markup lines and timeseries lines
PriceChart.prototype.highlightDimElement= function(state, elementId) {
	var self = this;
	var strokeWidth = 0;
	var exp = new RegExp("(.*)!(.*)-.*");
	var match = exp.exec(elementId._attr.id);
	if(match){
		var plot = match[1];
		var timeseries = match[2];
		var plotName = charting.definition.plot['plot-' + plot];
		if(typeof plotName.strokeWidth === 'function'){
			strokeWidth = plotName.strokeWidth(timeseries);
		} else {
			strokeWidth = plotName.strokeWidth;
		}
	}
	if (elementId._attr.type === "event-markup"){
		strokeWidth = blingChartConstants.MARKUP_STROKE_WIDTH;
	}

	switch(state){
		case "foreground":
			elementId.attr({opacity:1, transition: 0, strokeWidth: strokeWidth * 2 });
			break;
		case "background":
			elementId.attr({opacity:0.3, transition: 0, strokeWidth: strokeWidth});
			break;
		case "normal":
			elementId.attr({opacity:1, transition: 0, strokeWidth: strokeWidth});
			break;
	}
};

PriceChart.prototype.fadeUnfadeCrosshair= function(eventInfo, state) {
	var self = this;
	var crosshairClass = 'tc-crosshair-line';
	if (state === "fade"){
		crosshairClass = 'tc-crosshair-line-fade';
	}
	this.blingChartInst.getById(blingChartConstants.SECTION.price).attr({'crosshair.lineClass': crosshairClass});
	if (eventInfo.class === self.services.CommonConstants.EVENT_CATEGORY.oscillator) {
		var spacer = this.blingChartInst.getById(blingChartConstants.SECTION.spacer);
		if(spacer){
			spacer.attr({'crosshair.lineClass': crosshairClass});
			this.blingChartInst.getById(blingChartConstants.SECTION[eventInfo.chart]).attr({'crosshair.lineClass': crosshairClass});
		}
	} else if (eventInfo.class === self.services.CommonConstants.EVENT_CATEGORY.classic) {
		this.blingChartInst.getById(blingChartConstants.SECTION.spacer).attr({'crosshair.lineClass': crosshairClass});
		this.blingChartInst.getById(blingChartConstants.SECTION.volume).attr({'crosshair.lineClass': crosshairClass});
	}

};

PriceChart.prototype.addEventMapping = function(key, elementId, handler, eventName) {       
	var values = this.EVENT_MAPPING[key] === undefined? [] : this.EVENT_MAPPING[key];
	var obj = new Object();
	obj.elementId = elementId;
	obj.handler = handler;
	obj.eventName = eventName;
	values.push(obj);
	this.EVENT_MAPPING[key] = values;
};

PriceChart.prototype.addEventNameSection = function () {
	this._addEventNameSection(true);
	this._addEventNameSection(false);
}
PriceChart.prototype._addEventNameSection = function (isMobile) {
	var section = this.blingChartInst.getById(isMobile ? blingChartConstants.SECTION.hoverEventHeaderMobile : blingChartConstants.SECTION.hoverEventHeaderDesktop);
	//var section = this.blingChartInst.getById(blingChartConstants.SECTION.hoverEventHeader);
	section.append('text').attr({
		id: "selected-event-name" + (isMobile ? '-mobile' : '-desktop'),
		class: "price-chart-bar-details-label",
		transition: 0,
		leftMargin: 20,
		autoCollapse: true
	});
	this.addEventMapping("AllEvents", "selected-event-name" + (isMobile ? '-mobile' : '-desktop') , this.showHideEventName);
};

PriceChart.prototype.setPricePrecision = function (decimalPlaces) {
	if (decimalPlaces === null) {
		console.error("Null precision specified");
		return;
	}
	this.priceFormatSpecifier = "." + decimalPlaces + "f";
};

/**
 * Add timeseries to the Bling chart object
 * @param timeseries
 */
PriceChart.prototype.addTimeseriesToChart = function (timeseries) {
	this.timeseriesDataSource.updateFromAPI(timeseries);
	this.blingChartInst.attr('timeseriesSource', this.timeseriesDataSource);
};

PriceChart.prototype._mouseEnter = function(section, index, coords, x, y, data) {
	this.blingChartInst.getById(blingChartConstants.SECTION.normalHeaderMobile).attr({opacity: 0, transition: 0});
	this.blingChartInst.getById(blingChartConstants.SECTION.normalHeaderDesktop).attr({opacity: 0, transition: 0});
	this.blingChartInst.getById(blingChartConstants.SECTION.hoverHeaderMobile).attr({opacity: 1, transition: 0});
	this.blingChartInst.getById(blingChartConstants.SECTION.hoverHeaderDesktop).attr({opacity: 1, transition: 0});
};

PriceChart.prototype._mouseExit = function(section, index, coords, x, y, data) {
	this.blingChartInst.getById(blingChartConstants.SECTION.normalHeaderMobile).attr({opacity: 1, transition: 0});
	this.blingChartInst.getById(blingChartConstants.SECTION.normalHeaderDesktop).attr({opacity: 1, transition: 0});
	this.blingChartInst.getById(blingChartConstants.SECTION.hoverHeaderMobile).attr({opacity: 0, transition: 0});
	this.blingChartInst.getById(blingChartConstants.SECTION.hoverHeaderDesktop).attr({opacity: 0, transition: 0});
};

PriceChart.prototype._mouseMove = function(section, index, coords, x, y, data) {
	var self = this;

	function hasRequiredData(bar) {
		if (!bar) {
			return false;
		}
		// Return true if any of the OHLC properties are present
		return self.barDetailTimeseries.some(function(item) {
			return bar.hasOwnProperty(item);
		});
	}

	// If data is null, don't show any data, because there is no time value associated with the location.
	if (data) {
		if (!hasRequiredData(data)) {
			// Data is not null, but doesn't have required properties.
			// We are hovering over a valid time on the chart, but there is no data there (probably the green section of an options chart).
			// Use most recent bar.
			var timeseries = self.blingChartInst.attr('timeseriesSource').timeseries();
			// Go through timeseries in reverse from end until we get one with required data
			for (var i = timeseries.length; i > 0; i--) {
				if (hasRequiredData(timeseries[i])) {
					data = timeseries[i];
					break;
				}
			}
		}
	}

	var priceTimeseries = self.barDetailTimeseries;
	priceTimeseries.forEach(function(item) {
		self._updateBarDetail(data, item, blingUtils.numberFormat(self.priceFormatSpecifier), true);
		self._updateBarDetail(data, item, blingUtils.numberFormat(self.priceFormatSpecifier), false);
	});

	// Volume (if present) is an integer instead of a price, so handle separately
	self._updateBarDetail(data, self.volumeTimeseries, self.services.NumberFormatter.formatInteger, true);
	self._updateBarDetail(data, self.volumeTimeseries, self.services.NumberFormatter.formatInteger, false);
};

PriceChart.prototype._updateBarDetail = function(data, property, formatter, isMobile) {
	var self = this;

	var text = this.blingChartInst.getById(property + '-value-' + (isMobile ? 'mobile' : 'desktop'));
	if (text) {
		var label = self.services.Lexicon.translateDefaultNS('timeseries.hover-' + property) + ' ';
		// Show a dash for any missing values
		text.attr('text', data && data.hasOwnProperty(property) ? label + formatter(data[property]) : label + '-');
	}

};

PriceChart.prototype._onChartResize = function() {
	var threshold = 480;

	var isCompact = this.blingChartInst.width() < threshold;

	// Show desktop or mobile version of chart header section as required
	this._setVisibility(blingChartConstants.SECTION.headerMobile, isCompact);
	this._setVisibility(blingChartConstants.SECTION.headerDesktop, !isCompact);
};

PriceChart.prototype._setVisibility = function(id, visible) {
	var element = this.blingChartInst.getById(id);

	if (element) {
		element.attr({
			opacity: visible ? 1 : 0,
			transition: 50
		});
	}
};

PriceChart.prototype.setHideOnHover = function(id) {
	this.blingChartInst.bindSectionEvents('mouseEnter.' + id, this, function() {
		this._setVisibility(id, false);
	});
	this.blingChartInst.bindSectionEvents('mouseExit.' + id, this, function() {
		this._setVisibility(id, true);
	});
};

PriceChart.prototype.addBarDetails = function(includeVolume) {
	this._addBarDetails(includeVolume, true);
	this._addBarDetails(includeVolume, false);
};

PriceChart.prototype._addBarDetails = function(includeVolume, isMobile) {
	var barTimeseries = isMobile ? this.abreviatedBarDetailTimeseries : this.barDetailTimeseries;
	if (includeVolume) {
		barTimeseries = barTimeseries.concat([this.volumeTimeseries]);
	}
	var section = this.blingChartInst.getById(isMobile ? blingChartConstants.SECTION.barDetailsMobile : blingChartConstants.SECTION.barDetailsDesktop);
	var services = this.services;

	barTimeseries.forEach(
		function (detailType) {
			section.append('text').attr({
				class: "price-chart-bar-details-value",
				id: detailType + '-value-' + (isMobile ? 'mobile' : 'desktop'),
				text: services.Lexicon.translateDefaultNS('timeseries.hover-' + detailType) + '-',
				leftMargin: 20,
				transition: 0,
				autoCollapse: true
			});
		});
};

/**
 * Get the default configuration and pass it to the Bling object. This will draw the chart according
 * to what is defined in the configuration (legend, price chart, copyright link)
 * @param idea
 * @param isBullish
 * @param stopPrice
 * @param forceCandlesticks Force the chart to show candlesticks, regardless of the event type
 */
PriceChart.prototype.addConfigToChart = function (idea, stopPrice, forceCandlesticks) {
	var config = blingChartConstants.getConfig(this.services, idea, stopPrice, forceCandlesticks);
	this.blingChartInst.config(config);
	this.setPricePrecision(idea.instrument.precision);
	this.blingChartInst.getById(blingChartConstants.SECTION.price).attr('yAxisTickFormat', blingUtils.numberFormat(this.priceFormatSpecifier));

	// Handle resizing the chart
	this.blingChartInst.getById(blingChartConstants.SECTION.header).on('resize', this, PriceChart.prototype._onChartResize);
	// Execute the resize handler immediately so it uses the correct layout for the initial size
	this._onChartResize();

	// Set the locale object in the chart for axis labels
	this.blingChartInst.attr('locale', this.services.NumberFormatter.d3Object);

	// Handle mouse events for showing bar details
	this.blingChartInst.bindSectionEvents('mouseEnter.ohlc', this, PriceChart.prototype._mouseEnter);
	this.blingChartInst.bindSectionEvents('mouseExit.ohlc', this, PriceChart.prototype._mouseExit);
	this.blingChartInst.bindSectionEvents('mouseMove.ohlc', this, PriceChart.prototype._mouseMove);

};

/**
 * Draw the event markup on the chart
 * @param timeseries
 * @param idea
 * @param firstEvent
 * @param pricePeriod
 */
PriceChart.prototype.addMarkup = function (timeseries, idea, firstEvent, pricePeriod) {
	// save the instance of this object
	var self = this;

	var markupSource = new bling.Markup().fromAPI(firstEvent['linkId'], firstEvent.markup, firstEvent.eventType.name, firstEvent.eventType.chart);

	//getting the boundaries of the markup to see if the boundaries are in the scope of timeseries data we have
	var firstTimestampString = timeseries[0];
	var lastTimestampString = timeseries[timeseries.length - 1];
	var firstTimestamp = self.services.DateFormatter.parseDate(firstTimestampString);
	var lastTimestamp = self.services.DateFormatter.parseDate(lastTimestampString);
	var xDomain = markupSource.xDomain();

	var markupTradingCalendarPast = [];
	var markupTradingCalendarFuture = [];
	//Extra data needs to be extracted from Trading Calendar for markup
	if (xDomain[0] < firstTimestamp || xDomain[1] > lastTimestamp) {
		var apiCall,params;
		if (xDomain[0] < firstTimestamp) {
			//Needs more data from past and future
			if (xDomain[1] > lastTimestamp) {
				params = {start: self.services.DateFormatter.formatDateAsIsoString(xDomain[0]),
						end: self.services.DateFormatter.formatDateAsIsoString(xDomain[1])};
				apiCall = [self.services.REST.getTradingCalendar(idea.instrument.exchange.id, pricePeriod, params)];

			} else {
				//Needs more data just from past
				params = {start: self.services.DateFormatter.formatDateAsIsoString(xDomain[0]), end: firstTimestampString};
				apiCall = [self.services.REST.getTradingCalendar(idea.instrument.exchange.id, pricePeriod, params)];
				var index = 1;
				while (index<timeseries.length) {
					var timestamp = self.services.DateFormatter.parseDate(timeseries[index]).getTime();
					if (timestamp<=xDomain[1]) {
						markupTradingCalendarFuture.push(timestamp);
					} else {
						break;
					}
					index++;
				}
			}
		} else if (xDomain[1] > lastTimestamp) {
			//Needs more data from future
			params = {start: lastTimestampString, end: self.services.DateFormatter.formatDateAsIsoString(xDomain[1])};
			apiCall = [self.services.REST.getTradingCalendar(idea.instrument.exchange.id, pricePeriod, params)];
			var index = timeseries.length-2;
			while (index>=0) {
				var timestamp = self.services.DateFormatter.parseDate(timeseries[index]).getTime();
				if (timestamp>=xDomain[0]) {
					markupTradingCalendarPast.splice(0, 0, timestamp);
				} else {
					break;
				}
				index--;
			}
		}

		//Only make the tradingCalendar call when needed
		self.services.$q.all(apiCall).then(function (response) {

			var data = response[0].timestamps.map(function (date) {
				return parseDate(date).getTime();
			});
			var trandingCalendar = markupTradingCalendarPast.concat(data, markupTradingCalendarFuture);
			var markup = self.blingChartInst.getById(blingChartConstants.SECTION.price).append('event-markup').attr({
				id: 'markup-' + firstEvent.id,
				markup: markupSource,
				calendar: trandingCalendar,
				strokeWidth: blingChartConstants.MARKUP_STROKE_WIDTH
			});

			// save mapping for this event in the event mapping
			self.addEventMapping(firstEvent.id, markup.attr('id'), self.highlightDimElement, firstEvent.eventType.name);

			// register event listeners on the object passed
			self.registerEventListeners(idea.events,markup);
		});

	} else {
		var markup = self.blingChartInst.getById(blingChartConstants.SECTION.price).append('event-markup').attr({
			id: 'markup-' + firstEvent.id,
			markup: markupSource,
			strokeWidth: blingChartConstants.MARKUP_STROKE_WIDTH
		});

		// save mapping for this event in the event mapping
		self.addEventMapping(firstEvent.id, markup.attr('id'), self.highlightDimElement, firstEvent.eventType.name);

		// register event listeners on the object passed
		self.registerEventListeners(idea.events,markup);
	}

	this.drawDots(idea, firstEvent);
};

PriceChart.prototype.drawDots = function (idea, event, offsetLevel) {
	var self = this;
	offsetLevel = offsetLevel || 0;

	var high = event.endPrices.high;
	var low = event.endPrices.low;
	if (high !== undefined && high !== null && low !== undefined && low !== null) {
		self.actualDrawDots(idea, event, offsetLevel);
	} else {
		var timeseriesParams = {
			instrumentId: idea.instrument.id,
			period: event.pricePeriod,
			series: "high,low",
			start: event.dates.eventEnd,
			end: event.dates.eventEnd
		};

		// do a timeseries call to get the values for high and low because they were removed from the event.endPrices;
		// should happen once for each event, when the chart ( which contains that event ) is displayed the first time
		self.REST.instrumentTimeseries(timeseriesParams).then(function (response) {
			event.endPrices.high = response.result.high[0];
			event.endPrices.low = response.result.low[0];

			self.actualDrawDots(idea, event, offsetLevel);
		});
	}
};

PriceChart.prototype.actualDrawDots = function (idea, event, offsetLevel) {
	var self = this;

	// Event markup green dot or red box markup
	// This needs to be fixed for gapUp and gapDown. (Bling does not support gapUp and gapDown yet)
	var priceSection = self.blingChartInst.getById(blingChartConstants.SECTION.price);
	var circle;
	if (self.isBullish(idea)) {
		circle = priceSection
			.append('circle-plot')
			.attr('class', 'price-chart-eventclose_bull')
			.attr('opacity', 1)
			.attr('id', 'eventdot-' + event.id)
			.attr({
				r: 3,
				date: self.services.DateFormatter.parseDate(event.dates.eventEnd),
				value: event.endPrices.high,
				yOffset: -15 * (1 + offsetLevel)
			});
	} else {
		circle = priceSection
			.append('rect-plot')
			.attr('class', 'price-chart-eventclose_bear')
			.attr('opacity', 1)
			.attr('id', 'eventdot-' + event.id)
			.attr({
				dx: 5, dy: 5,
				date: self.services.DateFormatter.parseDate(event.dates.eventEnd),
				value: event.endPrices.low,
				yOffset: 8 * (1 + offsetLevel)
			});
	}

	// save mapping for this event in the event mapping
	self.addEventMapping(event.id, circle.attr('id'), self.highlightDimElement, event.eventType.name);

	// register event listeners on the object passed
	self.registerEventListeners(idea.events, circle);
};

/**
 * Draw the latest price indicator on the price chart
 * @param idea
 */
PriceChart.prototype.addLatestPrice = function (idea) {
	var priceValue = idea.instrument.latestPrice.price;
	var precision = idea.instrument.precision;
	this.lastpriceElement = this.blingChartInst.getById(blingChartConstants.SECTION.price)
		.append('axis-annotation')
		.attr({
			value: priceValue,
			class: 'price-chart-lastprice',
			format: this.services.NumberFormatter.d3Service.numberFormatter('.'+precision+'f',this.services.Config.languageCode())
		});
};
/**
 * Update the latest price indicator on the price chart
 */
PriceChart.prototype.updateLatestPrice = function (priceValue,precision) {
	if(this.lastpriceElement!==undefined){
		this.lastpriceElement
			.attr({
				value: priceValue,
				format: this.services.NumberFormatter.d3Service.numberFormatter('.'+precision+'f',this.services.Config.languageCode())
			});
	}
};

PriceChart.prototype.addChartEvent = function (isBullish) {
	var self = this;
	var text  = self.services.Lexicon.translateDefaultNS("eventdetails.event-flag");

	var section = this.blingChartInst.getById(blingChartConstants.SECTION.price);

	section.attr({topMargin: 0});
	// adding legend
	var layout = section.append('layout')
		.attr({
			id:"event-legend",
			direction: "horizontal",
			verticalAlign: 'top'
		});

	layout.append('rect')
		.attr({
			leftMargin:  5,
			rightMargin: 5,
			topMargin: 5,
			bottomMargin: 5,
			dx: 5,
			dy: 5,
			'class': isBullish ? "price-chart-eventclose_bull" : "price-chart-eventclose_bear"
		});
	layout.append('text')
		.attr({
			leftMargin: 0,
			text: text,
			'class': "price-chart-marker-legend-text"
		});

	// Hide legend when crosshairs appear
	this.setHideOnHover('event-legend');
};


/**
 * Update the latest stop price on the price chart
 */
PriceChart.prototype.updateLatestStop = function (latestStop,precision) {
	var label = this.services.Lexicon.translateDefaultNS('common.stop',{
			'sprintf': {
				"stop": latestStop ? this.services.NumberFormatter.formatCurrency(latestStop,precision) :this.services.Lexicon.translateDefaultNS('common.not-applicable')
			}
		});
	this.blingChartInst.getById('last-stop-desktop').attr('text', label);
};

/**
 * Checks to see if the limit to update the chart is reached.
 * @returns {boolean}
 */
PriceChart.prototype.isLimitReached = function (idea, lastBarTime) {
	return true;
};

/**
 * subscribe the instrument to get updates
 */
PriceChart.prototype.subscribe = function (idea, timeseries) {
	// save the instance of this object
	var self = this;
	var LoopHttpCallService = self.services.LoopHttpCallService;
	var $scope = self.services.$scope;
	var $timeout = self.services.$timeout;
	var regobj = {
		entityId: "PriceChartCtrl",
		keyData: idea.instrument.latestPrice,
		callbackFunc: function (data) {
			$timeout(function() {
				self.updateLatestPrice(Number(data.price), idea.instrument.precision);
			}, 0);
		}
	};

	// check whether the user has stream permission or not
	if (typeof idea.instrument.latestPrice.streamable !== "undefined") {
		LoopHttpCallService.subscribe($scope, 'selectedIdea', 'featured', regobj, self.services.CommonConstants.SUBSCRIPTION_TYPE.quote);
	}

	var isBullish = self.isBullish(idea);
	var stopParameter = self.getStopParametersByTrend(isBullish);
	if (typeof timeseries !== "undefined" && timeseries !== null) {
		var timeseriesApiParameters = {
			instrumentId: idea.instrument.id,
			series: self.getAllTimeseries(isBullish),
			period: timeseries.id[1], // see timeseriesMapper() method in rest.js service
			date: timeseries.lastBarTime,
			after: 1
		};

		var timeseriesObj = {
			parameters: timeseriesApiParameters,
			callbackFunc: function (apiResponse) {
				var timestamps = apiResponse.result.timestamp;
				// with the ( old ) subscription method we always received new data that had to be added to the chart,
				// therefore we used to check if the timestamps.length > 0
				// however with the ( new ) periodical calls method we always receive one entry of data that is already
				// present on the chart, therefore we want to check if the timestamps.length > 1 and if so then it
				// means we received new data that needs to be added to the chart
				var firstNewBarTime;
				if (timestamps && timestamps.length > 1) {
					firstNewBarTime = timestamps[1];
				}

				// update the latest stop price
				if (idea.productType !== self.services.CommonConstants.VIEW.watchedForex) {
					self.updateLatestStop(getLatestStopPrice(apiResponse.result[stopParameter], apiResponse.result['infill']), idea.instrument.precision);
				}
				if (typeof firstNewBarTime !== 'undefined' && !self.isLimitReached(idea, self.DateFormatter.parseDate(firstNewBarTime))) {
					self.timeseriesDataSource.addApiBars(apiResponse.result);
					var lastBarTime = self.blingChartInst.attr('timeseriesSource').lastBarTime();
					timeseriesApiParameters.date = self.DateFormatter.formatTimestampForTimeseriesAPI(lastBarTime);
				}
			}
		};
		// Subscribe to the new timeseries bars
		LoopHttpCallService.subscribe($scope, 'selectedIdea', 'featured', timeseriesObj, self.services.CommonConstants.SUBSCRIPTION_TYPE.timeseries);
	}

};

/**
 * Update the stop price by using the watched time stamp
 * @param pricePeriod
 * @param idea
 */
PriceChart.prototype.updateWatchedStopPrice = function (idea,pricePeriod){
		var self = this;
		var isWatched = self.services.Ideas.watched(idea.ideaType).isWatched({'idea': idea});
		this.turnOnWatchedStopStyle(this.blingChartInst,isWatched);
		if(!self.services.CommonConstants.WATCHED_IDEAS_TYPE[idea.productType] || isWatched){
			return;
		}
		var isBullish = self.isBullish(idea);
		var stopParameter = this.getStopParametersByTrend(isBullish);

		var stopTimeseries = {
			instrumentId: idea.instrument.id,
			period: pricePeriod,
			series: stopParameter,
			start: idea.watchedBarTime,
			end: idea.watchedBarTime
		}

		var promiseList = [
			self.REST.instrumentTimeseries(stopTimeseries)
		];

		self.$q.all(promiseList).then(function (responses) {
			self.updateLatestStop(responses[0].result[stopParameter][0],idea.instrument.precision);
		});
};

/**
 * Add common chart header component
 * @param chart
 * @param result
 * @param idea
 */
PriceChart.prototype.addCommonHeaderComponent = function(chart,result,idea, forceCandlesticks){
	var self = chart;
	self.addTimeseriesToChart(result);
	var isBullish = self.isBullish(idea);
	var stopParameter = this.getStopParametersByTrend(isBullish);
	//add the latest stop price
	self.addConfigToChart(idea, getLatestStopPrice(result[stopParameter],result['infill']), forceCandlesticks);
	self.addChartEvent(isBullish);
};

/**
 * Add common chart footer component
 * @param chart
 * @param idea
 */
PriceChart.prototype.addCommonFooterComponent = function(chart,idea, timeseries){
	var self = chart;
	self.addLanguageSupport();
	self.addLatestPrice(idea);
	self.subscribe(idea, timeseries);
	self.sendCopyrightToEnd();
	self.setDimensions();
};

/**
 * if the idea is bullish return stopmediumlower otherwise return stopmediumupper
 * @param isBullish
 */
PriceChart.prototype.getStopParametersByTrend = function(isBullish){
	return isBullish ? 'stopmediumlower': 'stopmediumupper';
};

/**
 * return timeseries by type and trend
 * @param type
 * @param isBullish
 */
PriceChart.prototype.getAllTimeseries = function(type,isBullish) {
	var requiredTimeseries = [];
	for(var i=0; i<type.length;i++){
		this.ChartSections.byId(type[i]).requiredTimeseriesIds.forEach(function (timeseries) {
			requiredTimeseries.push(timeseries);
		});
	}

	if(typeof isBullish === 'undefined'){
		return requiredTimeseries;
	}

	if(isBullish) {
		return requiredTimeseries.concat(this.getStopParametersByTrend(isBullish)).join();
	}
	else{
		return requiredTimeseries.concat(this.getStopParametersByTrend(isBullish)).join();
	}
};

/**
 * Include the close section on the chart
 * @param idea
 */
PriceChart.prototype.addClose = function (idea) {
	// calculate number of bars to get before and after the event
	var event = idea.events[0];
	var bars = blingUtils.calculateBufferBars(
		this.services,
		idea,
		event.dates.eventEnd,
		event.eventType['class'],
		event.eventType.eventTypeId,
		event.dates.duration,
		event.dates.trendDuration,
		event.targetPrice
	);

	charting.tools.createPlot(this.blingChartInst, blingChartConstants.PLOT.close);

	// draw brush on close section
	var barCount = (bars.forward + bars.backward) * 2;
	this.blingChartInst.attr({
		brush: {
			enable: true,
			initialBarCount: barCount,
			section: blingChartConstants.SECTION.close,
			pan: true
		}
	});
};

/**
 * Functionality to send the copyright to the end of the chart
 */
PriceChart.prototype.sendCopyrightToEnd = function () {
	this.blingChartInst.getById(blingChartConstants.SECTION.copyright).sendForward();
};

/**
 * Check if the idea passed in is bullish or bearish
 * @param idea
 * @returns {boolean}
 */
PriceChart.prototype.isBullish = function (idea) {
	return idea.events[0].eventType.tradeType === this.services.CommonConstants.TRADE_TYPE.long_type;
};

/**
 * Get the latest price for the given idea
 * @param idea
 * @returns {boolean}
 */
PriceChart.prototype.hasLatestPrice = function (idea) {
	return idea.instrument.latestPrice.dataType === this.services.CommonConstants.PRICE_DATA_TYPES.close;
};

PriceChart.prototype.addCrosshair = function (timeseries){
	var self = this;
	self.blingChartInst.getById(blingChartConstants.SECTION.price)
		.attr({
			'crosshair.enable': true,
			'crosshair.xAnnotate': true,
			'crosshair.yTickClass': 'tc-crosshair-label',
			'crosshair.xTickClass': 'tc-crosshair-label',
			'crosshair.lineClass': 'tc-crosshair-line',
			'crosshair.xTickWidth':78,
			'crosshair.xTickFormat': blingUtils.intradayCrosshairTimeFormat,
			background: {
				enable: true,
				class:"tc-section-background"
			}

		});
	var spacer = self.blingChartInst.getById(blingChartConstants.SECTION.spacer)
		if(spacer){
			spacer.attr({
				'crosshair.enable': true,
				'crosshair.xAnnotate': false,
				'crosshair.yAnnotate': false,
				'crosshair.yTickClass': 'tc-crosshair-label',
				'crosshair.xTickClass': 'tc-crosshair-label',
				'crosshair.lineClass': 'tc-crosshair-line',
				background: {
					enable: true,
					class:"tc-section-background"
				}
			});

		}

	//Crosshair timeformat differs for EOD and Intraday timeseries.
	self.crosshairTimeFormat(timeseries);
};

PriceChart.prototype.crosshairTimeFormat = function (){
	this.blingChartInst.getById(blingChartConstants.SECTION.volume)
		.attr({
			'crosshair.enable': true,
			'crosshair.yTickClass': 'tc-crosshair-label',
			'crosshair.xTickClass': 'tc-crosshair-label',
			'crosshair.lineClass': 'tc-crosshair-line',
			'crosshair.xTickFormat': blingUtils.crosshairTimeFormat,
			'crosshair.xTickWidth':75,
			background: {
				enable: true,
				class:"tc-section-background"
			}
		});
};

PriceChart.prototype.turnOnWatchedStopStyle = function(blingChartInst,on){
	if(typeof  blingChartInst.getById('last-stop-desktop') === 'undefined'){
		return;
	}
	var style = on ? "price-chart-stop-watched-idea": "price-chart-marker-legend-text";
	blingChartInst.getById('last-stop-desktop').attr('class', style);
}

/**
 * Merge an array of additional dates into an existing array of timestamps
 * @param timestamps
 * 	Sorted array of timestamps. This array will be modified.
 * @param additionalDates
 * 	Sorted array of date string to convert to timestamps and add to the end of the first array.
 * 	Only timestamps later than the last element of the first array will be added.
 */
PriceChart.prototype.addExtraTimestamps = function(timestamps, additionalDates) {
	additionalDates.forEach(function(date){
		// Skip any timestamps that are repeated from the timeseries
		// (otherwise we'll have duplicates for timestamps between the event end and the end of the timeseries)
		var calendarTimestamp = date.length === 19 ? date : date + 'T00:00:00';
		if (calendarTimestamp > timestamps[timestamps.length - 1]) {
			timestamps.push(calendarTimestamp);
		}
	});
};

/**
 * get the dates required to plot the target range
 */
PriceChart.prototype.getTargetRangeDates = function(exchangeId, pricePeriod, eventClose, eventDuration) {
	var deferredObject = jQuery.Deferred();

	// get the bars following the event close matching the event duration
	var rangeDate = eventClose.length === 19 ? eventClose : eventClose + 'T00:00:00';
	var params = {date: rangeDate, after: eventDuration};
	this.services.REST.getTradingCalendar(exchangeId, pricePeriod, params).then(function (response) {
		deferredObject.resolve(response);
	});
	return deferredObject.promise();
};

/**
 * Add the target region
 * @param idea
 * @param eventEnd
 * @param calendarTimestamps
 */
PriceChart.prototype.addTargetRegion = function(timestamps, event, rangeEnd) {
	// save the instance of this object
	var self = this;

	// the target region limits
	var x1 = self.services.DateFormatter.getEpoch(event.dates.eventEnd);
	var rangeDate = rangeEnd.length === 19 ? rangeEnd : rangeEnd + 'T00:00:00';
	var x2 = self.services.DateFormatter.getEpoch(rangeDate);
	var y1 = event.endPrices.breakout;
	var y2 = event.targetPrice.lower;
	var y3 = event.targetPrice.upper;

	// define style for trade type
	var style = event.eventType.tradeType === 'long' ? 'price-chart-eventclose_bull' : 'price-chart-eventclose_bear';

	// draw the break-out to lower target and push pack
	self.blingChartInst.getById(blingChartConstants.SECTION.price)
		.append('regions-plot')
		.attr('class', style)
		.attr('opacity', 0.25)
		.appendRegion(x1, x2, y1, y2)
		.sendBack();

	// draw the lower to upper target and push pack
	self.blingChartInst.getById(blingChartConstants.SECTION.price)
		.append('regions-plot')
		.attr('class', style)
		.attr('opacity', 0.50)
		.appendRegion(x1, x2, y2, y3)
		.sendBack();
};

function getLatestStopPrice(stopPrices,infills){
	for(var i = infills.length-1; i>=0; i--){
		if(!infills[i]){
			return stopPrices[i];
		}
	}
	return 0;
}

'use strict';

/**
 * Helper objects for drawing the chart
 * @type {{initializeD3Locale, numberFormat, timeFormat, getBars, getOptionsGreenAreaEndDate}}
 */
var blingUtils;
blingUtils = (function () {
	var d3_locale, time_format, crosshair_format, intraday_crosshair_format;

	function initializeD3Locale(Lexicon, NumberFormatter) {
		d3_locale = NumberFormatter.d3Object;

		crosshair_format = d3_locale.timeFormat.multi(
			[
				//Current year
				[Lexicon.translateDefaultNS('common.date-month'), function (d) {
					var today = new Date();
					return d.getFullYear() === today.getUTCFullYear();
				}],
				//Not in current year
				[Lexicon.translateDefaultNS('common.date-month-year'), function (d) {
					return d.getFullYear() !== (new Date()).getUTCFullYear();
				}]
			]);

		intraday_crosshair_format = d3_locale.timeFormat.multi(
			[
				//if in current year and current day
				[Lexicon.translateDefaultNS('common.time'), function (d) {
					var today = new Date();
					return d.getFullYear() === today.getUTCFullYear() && d.getMonth() === today.getUTCMonth() && d.getDate() === today.getUTCDate();
				}],
				//Current year, not current day
				[Lexicon.translateDefaultNS('common.time-date-month'), function (d) {
					var today = new Date();
					return d.getFullYear() === today.getUTCFullYear();
				}],
				//Not in current year
				[Lexicon.translateDefaultNS('common.time-date-month-year'), function (d) {
					var today = new Date();
					return d.getFullYear() !== today.getUTCFullYear();
				}]
			]);

		time_format = d3_locale.timeFormat.multi(
			[
				[".%L", function (d) {
					return d.getMilliseconds();
				}],
				[":%S", function (d) {
					return d.getSeconds();
				}],
				["%b %d", function (d) {
					return d.getMinutes() === 45 && d.getHours() === 9;
				}],
				["%H:%M", function (d) {
					return d.getMinutes() || d.getHours();
				}],
				["%I %p", function (d) {
					return d.getHours();
				}],
				["%b %d", function (d) {
					return d.getDay() && d.getDate() !== 1;
				}],
				["%b %d", function (d) {
					return d.getDate() !== 1;
				}],
				["%B", function (d) {
					return d.getMonth();
				}],
				["%Y", function () {
					return true;
				}]
			]);
	}

	/**
	 * Formats the number using the given format
	 * @param format
	 * @returns {*}
	 */
	function numberFormat(format) {
		return d3_locale.numberFormat(format);
	}

	/**
	 * Formats the time using the given format
	 * @param d
	 * @returns {Function}
	 */
	function timeFormat(d) {
		d = new Date(d);
		return time_format(d);
	}

	/**
	 * Formats the time using the given format for crosshair
	 * @param d
	 * @returns {Function}
	 */
	function crosshairTimeFormat(d) {
		d = new Date(d);
		return crosshair_format(d);
	}

	/**
	 * Formats the time using the given format for intraday crosshair
	 * @param d
	 * @returns {Function}
	 */
	function intradayCrosshairTimeFormat(d) {
		d = new Date(d);
		return intraday_crosshair_format(d);
	}

	// get the end date for the options green area
	function getOptionsGreenAreaEndDate(services, calendarUrl, pricePeriod, eventCloseDate, targetExpiryDate) {
		var eventClose = eventCloseDate.length === 19 ? eventCloseDate : eventCloseDate + 'T00:00:00',
			expiryDate = targetExpiryDate.length === 19 ? targetExpiryDate : targetExpiryDate + 'T00:00:00',
			params;

		var deferredObject = jQuery.Deferred();
		// get timestamps between eventClose and expiryDate
		params = {start: eventClose, end: expiryDate};
		services.REST.getTradingCalendar(calendarUrl, pricePeriod, params).then(function (response) {
			// Forwarding padding is one-fourth of the distance b/w eventClose date and expiry.
			var forwardPaddingDistance = Math.ceil(response.data.result.timestamp.length / 4);

			// get timestamp for forwarding padding of the green section
			params = {date: expiryDate, after: forwardPaddingDistance};
			services.REST.getTradingCalendar(calendarUrl, pricePeriod, params).then(function (response) {
				var greenSectionEndTimestamp = response.data.result.timestamp[response.data.result.timestamp.length - 1];

				// get the bars of the entire green section, from eventClose to the expiryDate + forward padding
				params = {start: eventClose, end: greenSectionEndTimestamp};
				services.REST.getTradingCalendar(calendarUrl, pricePeriod, params).then(function (response) {
					deferredObject.resolve(response.data.result);
				});
			});
		});
		return deferredObject.promise();
	}

	// calculate the number of bars for backward and forward buffer
	function calculateBufferBars(services, idea, eventEnd, eventClass, eventTypeId, patternDuration, trendDuration, eventTarget) {
		var bars = {},
			minClassicBars = 21;

		// options logic is different than from stocks/forex logic
		if (idea.ideaType === 'option') {
			var tradeLegs = idea.trade.legs,
				count, todayDate, eventClose, eventCloseDate;
			Object.keys(tradeLegs).forEach(function (legType) {
				if (tradeLegs[legType].instrument['resourceType'] === 'optionsContract' && count === undefined) {
					count = 0;
					bars.backward = minClassicBars * 9;

					todayDate = new Date().getTime();
					eventCloseDate = eventEnd;
					eventClose = services.DateFormatter.getEpoch(eventCloseDate);
					eventCloseDate = new Date(eventClose);

					while (eventClose <= todayDate) {
						eventClose = eventCloseDate.setDate(eventCloseDate.getDate() + 1);
						eventCloseDate = new Date(eventClose);
						if ((eventCloseDate.getDay() === 6) || (eventCloseDate.getDay() === 0)) {
							continue;
						}
						count++;
					}
					bars.forward = count;
				}
			});
		} else {
			if (eventClass === services.CommonConstants.EVENT_CATEGORY.shortterm && eventTypeId !== "islandTop" && eventTypeId !== "islandBottom") {
				bars.backward = minClassicBars * 3;
				bars.forward = 15;
			} else if (eventClass === services.CommonConstants.EVENT_CATEGORY.classic ||
				(eventClass === services.CommonConstants.EVENT_CATEGORY.shortterm && ((eventTypeId === "islandTop") || (eventTypeId === "islandBottom"))) ||
				eventClass === services.CommonConstants.EVENT_CATEGORY.indicator || eventClass === services.CommonConstants.EVENT_CATEGORY.oscillator) {
				if (patternDuration + trendDuration <= 50) {
					bars.backward = minClassicBars * 3;
					bars.forward = 15;
				}
				else if (patternDuration + trendDuration <= 100) {
					bars.backward = minClassicBars * 6;
					bars.forward = patternDuration;
				}
				else if (patternDuration + trendDuration <= 150) {
					bars.backward = minClassicBars * 9;
					bars.forward = patternDuration;
				}
				else if (patternDuration + trendDuration <= 200) {
					bars.backward = minClassicBars * 12;
					bars.forward = patternDuration;
				}
				else if (patternDuration + trendDuration <= 300) {
					bars.backward = minClassicBars * 18;
					bars.forward = patternDuration;
				}
				else {
					bars.backward = minClassicBars * 24;
					bars.forward = patternDuration;
				}
			}

			// ensure we have padding for target region
			if (eventTarget) {
				bars.forward = Math.max(bars.forward, patternDuration);
			}
		}

		return bars;
	}

	// get the date range for chart given any number of events
	function getChartDateRange(services, idea) {
		var promiseList = [];
		for (var key in idea.events) {
			if (idea.events.hasOwnProperty(key)) {
				var event = idea.events[key],
					pricePeriod = event.pricePeriod,
					eventClass = event.eventType['class'],
					eventTypeId = event.eventType.eventTypeId,
					eventEnd = event.dates.eventEnd,
					patternDuration = event.dates.duration,
					trendDuration = event.dates.trendDuration,
					eventTarget = event.targetPrice,
					params;

				// get the forward and backward buffer bars
				var bars = calculateBufferBars(services, idea, eventEnd, eventClass, eventTypeId,
						patternDuration, trendDuration, eventTarget);

				// for each event, push the call to be made on the promise list
				params = {date: eventEnd, before: bars.backward, after: bars.forward};
				promiseList.push(
					services.REST.getTradingCalendar(idea.instrument.exchange.id, pricePeriod, params)
				);
			}
		}

		var deferredObject = jQuery.Deferred();
		services.$q.all(promiseList).then(function (responses) {
			var startDate, endDate;
			for (var key in responses) {
				if (responses.hasOwnProperty(key)) {
					var timestamps = responses[key].timestamps;

					// if start date is undefined or new start date is older than the current start date
					if (!startDate || (services.DateFormatter.getEpoch(startDate) > services.DateFormatter.getEpoch(timestamps[0]))) {
						startDate = timestamps[0];
					}

					// if end date is undefined or new end date is more recent than the current end date
					if (!endDate || (services.DateFormatter.getEpoch(endDate) < services.DateFormatter.getEpoch(timestamps[timestamps.length - 1]))) {
						endDate = timestamps[timestamps.length - 1];
					}
				}
			}

			var result = {
				startDate: startDate,
				endDate: endDate
			};
			deferredObject.resolve(result);
		});
		return deferredObject.promise();
	}

	// get the event class
	function getEventClass(events, services) {
		var eventInfo = {};
		for (var event in events) {
			if (events[event].eventType.class === services.CommonConstants.EVENT_CATEGORY.oscillator ||
				events[event].eventType.class === services.CommonConstants.EVENT_CATEGORY.indicator) {
				eventInfo.chart = events[event].eventType.chart;
				eventInfo.class = events[event].eventType.class;
			}
		}

		// check if object is empty
		if ((Object.keys(eventInfo).length === 0)) {
			eventInfo.chart = 'price';
			eventInfo.class = 'classic';
		}
		return eventInfo;
	}

	return {
		initializeD3Locale: initializeD3Locale,
		numberFormat: numberFormat,
		timeFormat: timeFormat,
		getOptionsGreenAreaEndDate: getOptionsGreenAreaEndDate,
		calculateBufferBars: calculateBufferBars,
		getChartDateRange: getChartDateRange,
		crosshairTimeFormat: crosshairTimeFormat,
		intradayCrosshairTimeFormat: intradayCrosshairTimeFormat,
		getEventClass: getEventClass
	}
})();
'use strict';

/**
 * Constants defined for the Bling charts
 * @type {{getSection, getPlot, getConfig, getChartDimensions}}
 */
var blingChartConstants = (function() {

	var section = {
		header:			'section-header',
		headerMobile:	'section-header-mobile',
		headerDesktop:	'section-header-desktop',
		hoverHeaderMobile:	'section-header-mobile-hover',
		normalHeaderMobile:	'section-header-mobile-normal',
		hoverHeaderDesktop:	'section-header-desktop-hover',
		hoverEventHeaderDesktop:	'section-header-desktop-hover-event',
		hoverEventHeaderMobile:	'section-header-mobile-hover-event',
		normalHeaderDesktop:	'section-header-desktop-normal',
		barDetailsMobile:	'section-bar-details-mobile',
		barDetailsDesktop:	'section-bar-details-desktop',
		copyright:		'section-copyright',
		price:			'section-price',
		spacer:			'section-spacer',
		close:			'section-close',
		volume:			'section-volume',
		macd:			'section-macd',
		momentum:		'section-momentum',
		rsi:			'section-rsi',
		cci:			'section-cci',
		faststochastic:	'section-faststochastic',
		slowstochastic:	'section-slowstochastic',
		williams:		'section-williams'
	};

	var plot = {
		price:			'plot-price',
		close:			'plot-close',
		volume:			'plot-volume',
		macd:			'plot-macd',
		momentum:		'plot-momentum',
		bollinger:		'plot-bollinger',
		rsi:			'plot-rsi',
		cci:			'plot-cci',
		faststochastic:	'plot-faststochastic',
		slowstochastic:	'plot-slowstochastic',
		williams:		'plot-williams',
		sma4:			'plot-sma4',
		sma9:			'plot-sma9',
		sma18:			'plot-sma18',
		sma21:			'plot-sma21',
		sma50:			'plot-sma50',
		sma200:			'plot-sma200'
	};

	var markupStrokeWidth = 1;

	// Returns the default configuration used to create a price chart
	function getConfig(services, idea, stopPrice, forceCandlesticks) {
		var config = {
			// Forex needs a larger margin to make room for higher-precision prices
			sectionRightMargin: idea.ideaType === services.CommonConstants.IDEA_TYPE.forex ? 80 : 60,
			type: "chart",
			class: 'tc-chart-background',
			children: [
				_getSectionHeader(services,idea,stopPrice),
				{
					topMargin: 0,
					bottomMargin: 0,
					id: "section-price",
					grid: false,
					xAxis: {
						position: "bottom",
						height: 0,
						tickWidth: 100,
						show: idea.ideaType === services.CommonConstants.IDEA_TYPE.forex
					},
					type: "section",
					children: [
						{
							id: "price",
							barType: !forceCandlesticks && idea.events[0].eventType.barType === services.CommonConstants.BAR_TYPE.bar ? "ohlc" : "candlestick",
							'class': !forceCandlesticks && idea.events[0].eventType.barType === services.CommonConstants.BAR_TYPE.bar ? charting.definition.plot["plot-price-ohlc"].class : charting.definition.plot["plot-price-candlestick"].class,
							type: "price-plot",
							strokeWidth: !forceCandlesticks && idea.events[0].eventType.barType === services.CommonConstants.BAR_TYPE.bar ? charting.definition.plot["plot-price-ohlc"].strokeWidth : charting.definition.plot["plot-price-candlestick"].strokeWidth,
						},
						{
							leftMargin: 15,
							bottomMargin: 5,
							verticalAlign: "bottom",
							id: "recognia_watermark",
							href: recogniaComponentsConfig.staticBaseUrl + "img/watermark_" + services.Platform.data().brand + ".png",
							dx: 60,
							dy: services.Platform.data().brand === services.CommonConstants.BRAND.recognia ? 23 : 39,
							type: "image"
						}
					]
				},
				{
					horizontalAlign: "right",
					id: "section-copyright",
					type: "layout",
					children: [
						{
							leftMargin: 0,
							rightMargin: 60,
							horizontalAlign: "right",
							text:'© ' + (new Date()).getFullYear() + services.Lexicon.translateDefaultNS('common.chart-' + services.Platform.data().brand),
							class: "price-chart-copy-right",
							type: "text"
						}
					]
				}
			]
		};

		return config;
	}

	// Gets the config for the header section. Includes overlay of 2 different versions for different screen widths.
	function _getSectionHeader(services,idea,stopPrice) {
		// Header is an overlay of 2 possible headers shown depending on screen width.
		var headerConfig = {
			direction: "overlay",
			id: section.header,
			type: "layout",
			width: "100%",
			children: [
				_getDesktopHeaderSection(services, idea, stopPrice),
				_getMobileHeaderSection(services, idea, stopPrice)
			]
		};
		return headerConfig;
	}
	function _getSymbolLabel(idea) {
		return {
			width: "auto",
			leftMargin: 18,
			rightMargin: 10,
			text: idea.instrument.symbol,
			'class': "tc-chart-symbol-text",
			type: "text"
		};
	}

	function _getPricePeriodLabel(services, idea) {
		return {
			direction: "horizontal",
			leftMargin: 5,
			rightMargin: 10,
			type: "layout",
			width: "auto",
			height: "auto",
			background: {
				enable: true,
				'class': "tc-chart-period-rect",
				r: 3
			},
			children: [
				{
					leftMargin: 4,
					rightMargin: 4,
					topMargin: 2,
					bottomMargin: 2,
					text: services.Lexicon.translateDefaultNS('timeseries.' + idea.events[0].pricePeriod),
					class: "tc-chart-period-text",
					type: "text"
				}
			]
		};
	}

	function _getTargetLabel(services, idea) {
		var showTarget = idea.targetPrice.lower !== null || idea.targetPrice.upper !== null;
		return {
			horizontalAlign: 'left',
			leftMargin: 18,
			width: "50%",
			text: showTarget ? services.Lexicon.translateDefaultNS('common.target-with-values', {
				'sprintf': {
					"lowerTargetPrice": services.NumberFormatter.formatCurrency(idea.targetPrice.lower, idea.instrument.precision) || null,
					"upperTargetPrice": services.NumberFormatter.formatCurrency(idea.targetPrice.upper, idea.instrument.precision) || null
				}
			}) : "",
			'class': "price-chart-marker-legend-text",
			type: "text"
		};
	}

	function _getStopLabel(services,stopPrice,precision, productType) {
		return {
			horizontalAlign: 'left',
			leftMargin: 18,
			width: "50%",
			'class': services.CommonConstants.WATCHED_IDEAS_TYPE.hasOwnProperty(productType)?"price-chart-stop-watched-idea": "price-chart-marker-legend-text",
			'text': services.Lexicon.translateDefaultNS('common.stop',{
				'sprintf': {
					"stop": stopPrice ? services.NumberFormatter.formatCurrency(stopPrice,precision) :services.Lexicon.translateDefaultNS('common.not-applicable')
				}
			}),
			type: "text",
			id: 'last-stop-desktop'
		};
	}

	// Get the mobile ("standalone") version of the header section.
	// Uses more lines to allow for narrower display
	function _getMobileHeaderSection(services, idea, stopPrice) {
		var headerConfig = {
			autoCollapse: true,
			// Hide mobile version by default
			opacity: 0,
			id: section.headerMobile,
			direction: "vertical",
			type: "layout",
			width: "100%",
			children: [
				{
					direction: "horizontal",
					type: "layout",
					width: "100%",
					children: [
						{
							direction: "horizontal",
							type: "layout",
							children: [
								_getSymbolLabel(idea),
								_getPricePeriodLabel(services, idea)
							]
						}
					]
				},
				{
					direction: "overlay",
					type: "layout",
					children: [
						{
							id: section.normalHeaderMobile,
							direction: "horizontal",
							type: "layout",
							horizontalAlign: 'right',
							rightMargin: 0,
							width: "100%",
							children: getDesktopHeader(services,idea,stopPrice)
						},
						{
							id: section.hoverHeaderMobile,
							opacity: 0,
							direction: "overlay",
							type: "layout",
							width: "100%",
							children: [
								{
									id: section.barDetailsMobile,
									direction: "horizontal",
									leftMargin: 12,
									type: "layout",
									children: []
								},
								{
									id: section.hoverEventHeaderMobile,
									direction: "horizontal",
									leftMargin: 12,
									type: "layout",
									width: "auto",
									children: []
								}

							]
						}
					]
				}
			]
		};
		return headerConfig;
	}

	// Get the desktop ("hosted") version of the header section.
	function _getDesktopHeaderSection(services, idea,stopPrice) {
		var headerConfig = {
			autoCollapse: true,
			opacity: 1,
			id: section.headerDesktop,
			direction: "overlay",
			type: "layout",
			width: "100%",
			children: [
				{
					id: section.normalHeaderDesktop,
					direction: "horizontal",
					type: "layout",
					width: "100%",
					children: [
						{
							direction: "horizontal",
							type: "layout",
							width: "30%",
							children: [
								_getSymbolLabel(idea),
								_getPricePeriodLabel(services, idea)
							]
						},
						{
							direction: "horizontal",
							type: "layout",
							width: "70%",
							children: [
								{
									direction: "horizontal",
									type: "layout",
									horizontalAlign: 'right',
									rightMargin: 0,
									// See comment in previous sibling for 1-99 split.
									width: "100%",
									children: getDesktopHeader(services,idea,stopPrice)
								}
							]
						}
					]
				},
				{
					id: section.hoverHeaderDesktop,
					direction: "horizontal",
					opacity: 0,
					type: "layout",
					width: "auto",
					children: [
						//_getSymbolLabel(idea),
						//_getPricePeriodLabel(services, idea),
						{
							direction: "overlay",
							type: "layout",
							children: [
								{
									id: section.barDetailsDesktop,
									direction: "horizontal",
									leftMargin: 0,
									type: "layout",
									children: []
								},
								{
									id: section.hoverEventHeaderDesktop,
									direction: "horizontal",
									leftMargin: 0,
									type: "layout",
									width: "auto",
									children: []
								}
							]
						}
					]
				}
			]
		};
		return headerConfig;
	}

	function getDesktopHeader(services,idea,stopPrice){
		var showTarget = idea.targetPrice.lower !== null || idea.targetPrice.upper !== null;
		var ret = [];
		if(showTarget){
			ret.push(_getTargetLabel(services,idea));
		}
		ret.push(_getStopLabel(services,stopPrice,idea.instrument.precision, idea.productType));
		return ret;
	}

	// get chart dimensions of the given asset category
	function getChartDimensions(product) {
		var chartDimensions;

		if (product === CommonConstants.IDEA_TYPE.stock) {
			chartDimensions = {
				smallChartHeight: 303,
				largeChartHeight: 303+83,
				legendSectionHeight: 30,
				priceSectionHeight: 175,
				largeChartPriceSectionHeight: 175,
				volumeSectionHeight: 70,
				closeSectionHeight: 80
			};
		} else if (product === CommonConstants.IDEA_TYPE.option) {
			chartDimensions = {
				smallChartHeight: 272,
				largeChartHeight: 272+106,
				legendSectionHeight: 30,
				priceSectionHeight: 135,
				largeChartPriceSectionHeight: 167,
				volumeSectionHeight: 70,
				closeSectionHeight: 80
			};
		} else if (product === CommonConstants.IDEA_TYPE.forex) {
			chartDimensions = {
				smallChartHeight: 303,
				largeChartHeight: 303+83,
				legendSectionHeight: 30,
				priceSectionHeight: 175,
				largeChartPriceSectionHeight: 175,
				volumeSectionHeight: 70,
				closeSectionHeight: 80
			};
		}

		return chartDimensions;
	}

	return {
		SECTION: section,
		PLOT: plot,
		getConfig: getConfig,
		getChartDimensions: getChartDimensions,
		MARKUP_STROKE_WIDTH: markupStrokeWidth
	};
})();

"use strict";
/**
 * Parent object for the stocks price chart
 * @param services
 * @param blingChartInst
 * @constructor
 */
function StocksPriceChart(services,blingChartInst) {
	this.services = services;
	this.blingChartInst = blingChartInst;
	this.ChartSections = services.ChartSections;

	// call parent constructor to pass data
	PriceChart.call(this, services,blingChartInst);
};

StocksPriceChart.prototype = Object.create(PriceChart.prototype);
StocksPriceChart.prototype.constructor = StocksPriceChart;

/**
 * Formatting for x-axis and y-axis for the volume section
 */
StocksPriceChart.prototype.addLanguageSupport = function() {
	var volumeSection = this.blingChartInst.getById(blingChartConstants.SECTION.volume);
	var xAxis = volumeSection.attr('xAxis');
	xAxis.tickFormat = blingUtils.timeFormat;
	volumeSection.attr('xAxis', xAxis);
	volumeSection.attr('yAxisTickFormat', blingUtils.numberFormat(".2s"));
};

/**
 * Add common component to stock chart
 * @param chart
 * @param idea
 * @param chartType
 * @param responses
 * @param firstEvent
 * @param pricePeriod
 */
StocksPriceChart.prototype.addStockCommonComponent = function (chart,chartType, idea, responses, firstEvent, pricePeriod) {
	var self = chart;

	// Add extra target region timestamps, if available
	if (responses[1]) {
		self.addExtraTimestamps(responses[0].result.timestamp, responses[1].timestamps);
	}

	self.addCommonHeaderComponent(self,responses[0].result,idea);
	self.addBarDetails(true);
	self.addEventNameSection();
	self.addMarkup(responses[0].result.timestamp, idea, firstEvent, pricePeriod);
	self.addVolume();
	if(chartType === self.CommonConstants.CHART_TYPE.largeStocksPriceChart){
		self.addClose(idea);
	}

	// Add target region markup, if req'd
	if (responses[1]) {
		var lastRangeDate = responses[1].timestamps[responses[1].timestamps.length - 1];
		self.addTargetRegion(responses[0].result.timestamp, firstEvent, lastRangeDate);
	}

	self.addCommonFooterComponent(self,idea);
	self.addCrosshair();
	self.updateWatchedStopPrice(idea,pricePeriod);
};

/**
 * Add the volume section
 */
StocksPriceChart.prototype.addVolume = function() {
	// Add spacer between price and volume
	var spacer = charting.tools.createSection(this.blingChartInst, blingChartConstants.SECTION.spacer);

	charting.tools.createPlot(this.blingChartInst, blingChartConstants.PLOT.volume);

	var volume = this.blingChartInst.getById(blingChartConstants.SECTION.volume);

	//adding legend and shade background for the volume section
	volume.append('rect')
		.attr({
			dx: '100%',
			dy: '100%',
			width: '100%',
			height: '100%',
			id: 'volume-background',
			class: 'volume-chart-background'
		}).sendBack();

	var volumeLayout = volume.append('layout')
		.attr({
			id: 'volume-legend',
			direction: 'horizontal',
			topMargin: 7,
			verticalAlign: 'top'
		});

	// Hide legend when crosshairs appear
	this.setHideOnHover('volume-legend');

	volumeLayout.append('rect')
		.attr({
			dx: 5, dy: 5,
			leftMargin: 5,
			topMargin:5,
			bottomMargin:5,
			rightMargin:5,
			verticalAlign: 'middle',
			width: 'auto',
			height: 'auto',
			class:'tc-plot-volume'
		});
	volumeLayout.append('text')
		.attr({
			text: this.services.Lexicon.translateDefaultNS('common.volume-upper'),
			leftMargin: 0,
			topMargin:5,
			bottomMargin:0,
			rightMargin:5,
			verticalAlign: 'middle',
			width: 'auto',
			height: 'auto',
			class:'price-chart-marker-legend-text'
		});
};

"use strict";
/**
 * Small stocks price chart object
 * @param services
 * @param config
 * @param blingChartInst
 * @constructor
 */
function SmallStocksPriceChart(services,config,blingChartInst) {
	// call parent constructor to pass data
	StocksPriceChart.call(this, services,blingChartInst);

	this.$q = services.$q;
	this.REST = services.REST;
	this.CommonConstants = services.CommonConstants;
	this.DateFormatter = services.DateFormatter;
	this.Lexicon = services.Lexicon;

	this.services = services;
	this.config = config;
	this.blingChartInst = blingChartInst;

	this.priceSectionHeight = 175;
	this.volumeSectionHeight = 70;
};

SmallStocksPriceChart.prototype = Object.create(StocksPriceChart.prototype);
SmallStocksPriceChart.prototype.constructor = SmallStocksPriceChart;

/**
 * Draw the small stocks price chart
 * @param idea
 */
SmallStocksPriceChart.prototype.init = function(idea) {
	// save the instance of this object
	var self = this;

	var firstEvent = idea.events[0],
		pricePeriod = firstEvent.pricePeriod,
		eventEnd = firstEvent.dates.eventEnd;

	// calculate number of bars to get before and after the event
	blingUtils.getChartDateRange(self.services,idea).then(function (response) {
		var displayedEndDate =  response.endDate;
		var timeseriesParameters = {
			instrumentId: idea.instrument.id,
			series: self.getAllTimeseries(['price','volume'],self.isBullish(idea)),
			period: pricePeriod,
			date: response.startDate,
			after: '1000'
		};

		var promiseList = [
			self.REST.instrumentTimeseries(timeseriesParameters)
		];

		// add the target price range dates, if req'd
		if (firstEvent.targetPrice) {
			promiseList.push(
				self.getTargetRangeDates(idea.instrument.exchange.id, pricePeriod, eventEnd,
					firstEvent.dates.duration)
			);
		}

		self.$q.all(promiseList).then(function (responses) {
			timeseriesDataFilter(responses[0].result,displayedEndDate,self);
			self.addStockCommonComponent(self,self.CommonConstants.CHART_TYPE.smallStocksPriceChart,idea,responses,firstEvent,pricePeriod);
		});
	});
};

/**
 * Return the timeseries range based on the given endDate.
 * @param timeseriesData
 * @param endDate ending time inclusive
 * @param service
 */
function timeseriesDataFilter(timeseriesData,endDate,service){
    var endIndex = getTimeseriesIndexBytime(timeseriesData,endDate,service);
    if(endIndex === -1){
        return ;
    }

    filterDataByTimeseriesType(timeseriesData,endIndex,service);

    //filter out timestamps that are beyond end index.
    timeseriesData['timestamp'] = timeseriesData['timestamp'].slice(0, endIndex+1);

}

/**
 *
 * @param timeseriesData
 * @param endIndex inclusive
 * @param service
 */
function filterDataByTimeseriesType(timeseriesData,endIndex,service){
    var timeSeries = service.getAllTimeseries(['price','volume']);
    timeSeries.forEach(function(series){
        timeseriesData[series] = timeseriesData[series].slice(0, endIndex+1);
    });
}

/**
 * Return the corresponding index in the timeseries data source by the given time, if nothing found return -1;
 * @param timeseriesData
 * @param date
 * @param service
 */
function getTimeseriesIndexBytime(timeseriesData,date,service){
    var referenceDate = service.DateFormatter.parseDate(date).getTime();
    for(var i = timeseriesData.timestamp.length-1; i>= 0; i--){
        if(referenceDate === service.DateFormatter.getEpoch(timeseriesData.timestamp[i])){
            return i;
        }
    }
    return -1;
}

/**
 * Set dimensions for all sections in the chart
 */
SmallStocksPriceChart.prototype.setDimensions = function() {
	this.blingChartInst.getById(blingChartConstants.SECTION.price).attr({height: this.priceSectionHeight});
	this.blingChartInst.getById(blingChartConstants.SECTION.volume).attr({height: this.volumeSectionHeight});
};

"use strict";
/**
 * Large stocks price chart object
 * @param services
 * @param config
 * @param blingChartInst
 * @constructor
 */
function LargeStocksPriceChart(services,config,blingChartInst) {
	// call parent constructor to pass data
	StocksPriceChart.call(this, services,blingChartInst);

	this.$q = services.$q;
	this.REST = services.REST;
	this.CommonConstants = services.CommonConstants;

	this.services = services;
	this.config = config;
	this.blingChartInst = blingChartInst;

	this.priceSectionHeight = 175;
	this.volumeSectionHeight = 70;
	this.closeSectionHeight = 80;
};

LargeStocksPriceChart.prototype = Object.create(StocksPriceChart.prototype);
LargeStocksPriceChart.prototype.constructor = LargeStocksPriceChart;

/**
 * Draw the large stocks price chart
 * @param idea
 */
LargeStocksPriceChart.prototype.init = function(idea) {
	// save the instance of this object
	var self = this;

	var firstEvent = idea.events[0],
		pricePeriod = firstEvent.pricePeriod,
		eventEnd = firstEvent.dates.eventEnd;

	// Limit the API to max of 6000 bars
	var timeseriesParameters = {
		instrumentId: idea.instrument.id,
		series: self.getAllTimeseries(['price','volume'],self.isBullish(idea)),
		period: pricePeriod,
		before: '5000',
		after: '1000',
		date: eventEnd
	};

	var promiseList = [
		self.REST.instrumentTimeseries(timeseriesParameters)
	];

	// add the target price range dates, if req'd
	if (firstEvent.targetPrice) {
		promiseList.push(
			self.getTargetRangeDates(idea.instrument.exchange.id, pricePeriod, eventEnd,
				firstEvent.dates.duration)
		);
	}

	self.$q.all(promiseList).then(function (responses) {
		self.addStockCommonComponent(self,self.CommonConstants.CHART_TYPE.largeStocksPriceChart,idea,responses,firstEvent,pricePeriod);
	});
};

/**
 * Set dimensions for all sections in the chart
 */
LargeStocksPriceChart.prototype.setDimensions = function() {
	this.blingChartInst.getById(blingChartConstants.SECTION.price).attr({height: this.priceSectionHeight});
	this.blingChartInst.getById(blingChartConstants.SECTION.volume).attr({height: this.volumeSectionHeight});
	this.blingChartInst.getById(blingChartConstants.SECTION.close).attr({height: this.closeSectionHeight});
};

"use strict"
/**
 * Parent object for the options price chart
 * @param services
 * @param blingChartInst
 * @constructor
 */
function OptionsPriceChart(services,blingChartInst) {
	this.services = services;
	this.blingChartInst = blingChartInst;
	this.ChartSections = services.ChartSections;

	// call parent constructor to pass data
	PriceChart.call(this, services,blingChartInst);
};

OptionsPriceChart.prototype = Object.create(PriceChart.prototype);
OptionsPriceChart.prototype.constructor = OptionsPriceChart;

/**
 * Formatting for x-axis and y-axis for the volume section
 */
OptionsPriceChart.prototype.addLanguageSupport = function() {
	var volumeSection = this.blingChartInst.getById(blingChartConstants.SECTION.volume);
	var xAxis = volumeSection.attr('xAxis');
	xAxis.tickFormat = blingUtils.timeFormat;
	volumeSection.attr('xAxis', xAxis);
	volumeSection.attr('yAxisTickFormat', blingUtils.numberFormat(".2s"));
};

/**
 * Add the volume section
 */
OptionsPriceChart.prototype.addVolume = function() {
	// Add spacer between price and volume
	var spacer = charting.tools.createSection(this.blingChartInst, blingChartConstants.SECTION.spacer);

	charting.tools.createPlot(this.blingChartInst, blingChartConstants.PLOT.volume);

	var volume = this.blingChartInst.getById(blingChartConstants.SECTION.volume);

	//adding legend and shade background for the volume section
	volume.append('rect')
		.attr({
			dx: '100%',
			dy: '100%',
			width: '100%',
			height: '100%',
			id: 'volume-background',
			class: 'volume-chart-background'
		}).sendBack();

	var volumeLayout = volume.append('layout')
		.attr('direction', 'horizontal')
		.attr({
			leftMargin: 0,
			topMargin: 7,
			bottomMargin: 0,
			rightMargin: 0,
			verticalAlign: 'top'
		});

	volumeLayout.append('rect')
		.attr({
			dx: 5, dy: 5,
			leftMargin: 5,
			topMargin:5,
			bottomMargin:5,
			rightMargin:5,
			verticalAlign: 'middle',
			width: 'auto',
			height: 'auto',
			class:'tc-plot-volume'
		});
	volumeLayout.append('text')
		.attr({
			text: this.services.Lexicon.translateDefaultNS('common.volume-upper'),
			leftMargin: 0,
			topMargin:5,
			bottomMargin:0,
			rightMargin:5,
			verticalAlign: 'middle',
			width: 'auto',
			height: 'auto',
			class:'price-chart-marker-legend-text'
		});
};

/**
 * Merge an array of additional dates into an existing array of timestamps
 * @param timestamps
 * 	Sorted array of timestamps. This array will be modified.
 * @param additionalDates
 * 	Sorted array of date string to convert to timestamps and add to the end of the first array.
 * 	Only timestamps later than the last element of the first array will be added.
 */
OptionsPriceChart.prototype.addExtraTimestamps = function(timestamps, additionalDates) {
	additionalDates.forEach(function(date){
		// Skip any timestamps that are repeated from the timeseries
		// (otherwise we'll have duplicates for timestamps between the event end and the end of the timeseries)
		var calendarTimestamp = date + 'T00:00:00';
		if (calendarTimestamp > timestamps[timestamps.length - 1]) {
			timestamps.push(calendarTimestamp);
		}
	});
};

/**
 * Add common component to option chart
 * @param chart
 * @param chartType
 * @param idea
 * @param responses
 * @param firstEvent
 * @param pricePeriod
 */
OptionsPriceChart.prototype.addOptionCommonComponent = function (chart,chartType,idea,responses,firstEvent,pricePeriod,eventEnd) {
	var self = chart;
	// Add extra timestamps at the right side of the price chart to make space for the green area
	self.addExtraTimestamps(responses[0].result.timestamp, responses[1].timestamp);
	self.addCommonHeaderComponent(self,responses[0].result,idea);
	self.addBarDetails(true);
	self.addEventNameSection();
	self.addMarkup(responses[0].result.timestamp,idea,firstEvent,pricePeriod);
	self.addVolume();
	self.addGreenSection(idea,eventEnd,responses[1].timestamp);
	if(chartType === self.CommonConstants.CHART_TYPE.largeOptionsPriceChart){
		self.addClose(idea);
	}

	self.addCommonFooterComponent(self,idea);
	self.addCrosshair();
	self.updateWatchedStopPrice(idea,pricePeriod);
}


/**
 * Add the green section
 * @param idea
 * @param eventEnd
 * @param calendarTimestamps
 */
OptionsPriceChart.prototype.addGreenSection = function(idea,eventEnd,calendarTimestamps) {
	// save the instance of this object
	var self = this;

	// in each section of the chart, we want to draw the green section on the right side
	[blingChartConstants.SECTION.price,blingChartConstants.SECTION.spacer,blingChartConstants.SECTION.volume].forEach(function(section) {
		var region = self.blingChartInst.getById(section)
			.append('regions-plot')
			.attr('class', 'price-chart-target-profit-padding')
			.attr('opacity', 0.5)
			.appendRegion(
			self.services.DateFormatter.getEpoch(eventEnd),
			self.services.DateFormatter.getEpoch(calendarTimestamps[calendarTimestamps.length - 1])
		);

		// Send region back behind other elements
		region.sendBack();

		// Exception: move region one level forward for volume section so it is on top of the background
		if (section === blingChartConstants.SECTION.volume) {
			region.sendForward(1);
		}
	});

	// draw the green bubble in the green section
	var tradeLegs = idea.trade.legs;
	var targetDate = self.services.DateFormatter.getEpoch(self.services.OptionsStrategy.getEarliestExpiryDate(tradeLegs) + "T00:00:00");
	// Use closest end of target range (lower for bullish ideas, upper for bearish)
	var targetPrice = idea.targetPrice.lower;
	if (idea.tradeType === 'short') {
		targetPrice = idea.targetPrice.upper;
	}
	var priceChart = self.blingChartInst.getById(blingChartConstants.SECTION.price);

	var marker = priceChart.append('symbol').attr({
		date: targetDate,
		value: targetPrice,
		shape: 'cross',
		class: 'chart-target-profit-pointer-cross'
	});
	// Offset arrow up by half the height of the "X" marker, plus a couple pixels
	var yOffset = -(marker.getOwnExtent().height/2 + 2);
	var arrow = priceChart.append('symbol').attr({
		date: targetDate,
		value: targetPrice,
		yOffset: yOffset,
		shape: 'downArrow',
		class: 'chart-target-profit-pointer-arrow'
	});
	// for the bubble, increase the offset by the full height of the arrow
	yOffset -= arrow.getOwnExtent().height;

	// Need to create the text before the bubble so we know how big the bubble needs to be
	var bubbleMargin = 3;
	var bubbleText = priceChart.append('text-plot').attr({
		date: targetDate,
		value: targetPrice,
		yOffset: yOffset,
		class: 'chart-target-profit-text',
		text: self.services.NumberFormatter.percentInTextBlock(idea.trade.targetProfitPercent, 0)
	});

	// create the green bubble
	var bubble = priceChart.append('rect-plot').attr({
		date: targetDate,
		value: targetPrice,
		class: 'chart-target-profit-bubble',
		rx: 2,
		ry: 2
	});
	// bubble needs to be behind the bubble text
	bubble.sendBack(1);

	// called when the bubbletext is resized, meaning when it's container has dimensions when
	// it is being rendered.
	bubbleText.on('resize', this, function (eventName, element) {
		var textExtents = element.getOwnExtent();

		// IE doesn't respect the SVG properties for centering text vertically,
		// so we make our best attempt here by shifting the position by 20% of height
		bubbleText.attr({yOffset: yOffset - bubbleMargin - textExtents.height * 0.2});

		var bubbleWidth = textExtents.width + bubbleMargin*2;
		var bubbleHeight = textExtents.height + bubbleMargin*2;

		bubble.attr({dx: bubbleWidth, dy: bubbleHeight, yOffset: yOffset - bubbleHeight});
	});

	var dashOffset = 0;
	// For the volume and spacer sections, the line should cross the full height of the section
	[blingChartConstants.SECTION.volume,blingChartConstants.SECTION.spacer].forEach(function(sectionId) {
		var section = self.blingChartInst.getById(sectionId);
		section.append('axis-annotation')
			.attr({
				value: targetDate,
				orient: 'vertical',
				line: true,
				annotate: false,
				dashOffset: dashOffset,
				// Set transition to 0, otherwise line will appear in each section at slightly different times
				transition: 0,
				class: 'chart-target-profit-pointer-line'
			});
		// Set the dash offset to the bottom of the chart so that it looks like a continuous dashed line
		dashOffset += (section.attr('height') - section.attr('topMargin') - section.attr('bottomMargin'));
	});

	// Add the line from the X to the bottom of the graph
	priceChart.append('axis-annotation')
		.attr({
			value: targetDate,
			orient: 'vertical',
			line: true,
			annotate: false,
			// Line should only go up to target price, not entire height of chart
			extent: [targetPrice],
			dashOffset: dashOffset,
			transition: 0,
			class: 'chart-target-profit-pointer-line'
		});
};
'use strict';
/**
 * Small options price chart object
 * @param services
 * @param config
 * @param blingChartInst
 * @constructor
 */
function SmallOptionsPriceChart(services,config,blingChartInst) {
	// call parent constructor to pass data
	OptionsPriceChart.call(this, services,blingChartInst);

	this.$q = services.$q;
	this.REST = services.REST;
	this.CommonConstants = services.CommonConstants;
	this.DateFormatter = services.DateFormatter;
	this.Lexicon = services.Lexicon;

	this.services = services;
	this.config = config;
	this.blingChartInst = blingChartInst;

	this.priceSectionHeight = 135;
	this.volumeSectionHeight = 70;
};

SmallOptionsPriceChart.prototype = Object.create(OptionsPriceChart.prototype);
SmallOptionsPriceChart.prototype.constructor = SmallOptionsPriceChart;

/**
 * Draw the small options price chart
 * @param idea
 */
SmallOptionsPriceChart.prototype.init = function(idea) {
	// save the instance of this object
	var self = this;

	var firstEvent = idea.events[0],
		pricePeriod = firstEvent.pricePeriod,
		eventEnd = firstEvent.dates.eventEnd;

	// calculate number of bars to get before and after the event
	blingUtils.getChartDateRange(self.services,idea).then(function (response) {
		var timeseriesParameters = {
			instrumentId: idea.instrument.id,
			series: self.getAllTimeseries(['price','volume'],self.isBullish(idea)),
			period: pricePeriod,
			start: response.startDate,
			end: response.endDate
		};

		var promiseList = [
			self.REST.instrumentTimeseries(timeseriesParameters)
		];
		// calculate the green area using the event end date and the trade leg expiry date
		var tradeLegs = idea.trade.legs;
		var done = false;
		Object.keys(tradeLegs).forEach(function (legType) {
			if (tradeLegs[legType].instrument['resourceType'] === 'optionsContract' && !done) {
				promiseList.push(
					blingUtils.getOptionsGreenAreaEndDate(self.services,idea.instrument.exchange.id,pricePeriod,eventEnd,tradeLegs[legType].instrument.expiryDate)
				);
				done = true;
			}
		});

		self.$q.all(promiseList).then(function (responses) {
			self.addOptionCommonComponent(self,self.CommonConstants.CHART_TYPE.smallOptionsPriceChart,idea,responses,firstEvent,pricePeriod,eventEnd);
		});
	});
};

/**
 * Set dimensions for all sections in the chart
 */
SmallOptionsPriceChart.prototype.setDimensions = function() {
	this.blingChartInst.getById(blingChartConstants.SECTION.price).attr({height: this.priceSectionHeight});
	this.blingChartInst.getById(blingChartConstants.SECTION.volume).attr({height: this.volumeSectionHeight});
};
'use strict'
/**
 * Large options price chart object
 * @param services
 * @param config
 * @param blingChartInst
 * @constructor
 */
function LargeOptionsPriceChart(services,config,blingChartInst) {
	// call parent constructor to pass data
	OptionsPriceChart.call(this, services,blingChartInst);

	this.$q = services.$q;
	this.REST = services.REST;
	this.CommonConstants = services.CommonConstants;

	this.services = services;
	this.config = config;
	this.blingChartInst = blingChartInst;

	this.priceSectionHeight = 167;
	this.volumeSectionHeight = 70;
	this.closeSectionHeight = 80;
};

LargeOptionsPriceChart.prototype = Object.create(OptionsPriceChart.prototype);
LargeOptionsPriceChart.prototype.constructor = LargeOptionsPriceChart;

/**
 * Draw the large options price chart
 * @param idea
 */
LargeOptionsPriceChart.prototype.init = function(idea) {
	// save the instance of this object
	var self = this;

	var firstEvent = idea.events[0],
		pricePeriod = firstEvent.pricePeriod,
		eventEnd = firstEvent.dates.eventEnd;

	// Limit the API to max of 6000 bars
	var timeseriesParameters = {
		instrumentId: idea.instrument.id,
		series: self.getAllTimeseries(['price','volume'],self.isBullish(idea)),
		period: pricePeriod,
		before: '5000',
		after: '1000',
		date: eventEnd
	};

	var promiseList = [
		self.REST.instrumentTimeseries(timeseriesParameters)
	];
	// calculate the green area using the event end date and the trade leg expiry date
	var tradeLegs = idea.trade.legs;
	var done = false;
	Object.keys(tradeLegs).forEach(function (legType) {
		if (tradeLegs[legType].instrument['resourceType'] === 'optionsContract' && !done) {
			promiseList.push(
				blingUtils.getOptionsGreenAreaEndDate(self.services,idea.instrument.exchange.id,pricePeriod,eventEnd,tradeLegs[legType].instrument.expiryDate)
			);
			done = true;
		}
	});

	self.$q.all(promiseList).then(function (responses) {
		self.addOptionCommonComponent(self,self.CommonConstants.CHART_TYPE.largeOptionsPriceChart,idea,responses,firstEvent,pricePeriod,eventEnd);
	});
};

/**
 * Set dimensions for all sections in the chart
 */
LargeOptionsPriceChart.prototype.setDimensions = function() {
	this.blingChartInst.getById(blingChartConstants.SECTION.price).attr({height: this.priceSectionHeight});
	this.blingChartInst.getById(blingChartConstants.SECTION.volume).attr({height: this.volumeSectionHeight});
	this.blingChartInst.getById(blingChartConstants.SECTION.close).attr({height: this.closeSectionHeight});
};

'use strict';

/**
 * Parent object for the forex price chart
 * @param services
 * @param blingChartInst
 * @constructor
 */
function ForexPriceChart(services,blingChartInst) {
	this.services = services;
	this.blingChartInst = blingChartInst;
	this.ChartSections = services.ChartSections;
	this.lastpriceElement = undefined;

	// call parent constructor to pass data
	PriceChart.call(this, services,blingChartInst, 'currency');
}

ForexPriceChart.prototype = Object.create(PriceChart.prototype);
ForexPriceChart.prototype.constructor = ForexPriceChart;

// making the legend visible
ForexPriceChart.prototype.setIndicatorLegentObj = function(){        
     if(!this.indicatorLegentObj){
         this.indicatorLegentObj = this.blingChartInst.getById("section-indicator-legend");
         if(this.indicatorLegentObj){          
             this.visibleElement("foreground",this.indicatorLegentObj);
        }                          
    }
}

ForexPriceChart.prototype.initSections = function(mandatorySections, events) {
	if (events.length > 2) {
		console.error("More than 2 events not supported in FOREX charts.");
	}

	var self = this;
	self.oscillatorSectionId = null;
	// Ensure we add each section only once
	var sectionsAdded = {};
	var requiredTimeseries = {};
	var oscillatorTimeseries = {};

	// Mandatory sections are already added; don't add them again if an event needs them.
	mandatorySections.forEach(function(section) {
		sectionsAdded[section] = true;
	});

	// Add sections required by each event
	events.forEach(function(event) {
		var section = event.eventType.chart;
		// Oscillators appear in a separate section
		if (!sectionsAdded[section]) {
			sectionsAdded[section] = true;
			if (self.oscillatorSectionId === null) {
				self.oscillatorSectionId = section;
				// Add the required timeseries for this section
				self.ChartSections.byId(section).requiredTimeseriesIds.forEach(function (timeseries) {
					oscillatorTimeseries[timeseries] = true;
				});
			}
			else {
				// Multiple extra sections found. We don't support this
				console.error("Multiple oscillator sections found: " + self.oscillatorSectionId + ", " + section);
			}
		}
		// Require any additional timeseries associated with each event
		event.additionalTimeseries.forEach(function (timeseries) {
			requiredTimeseries[timeseries] = true;
		});
	});
	self.indicatorTimeseriesIds = Object.keys(requiredTimeseries);

	// Require any timeseries required by the sections we are displaying
	mandatorySections.forEach(function(section) {
		self.ChartSections.byId(section).requiredTimeseriesIds.forEach(function (timeseries) {
			requiredTimeseries[timeseries] = true;
		});
	});

	self.timeseriesIds = Object.keys(requiredTimeseries);
	self.oscillatorTimeseriesIds = Object.keys(oscillatorTimeseries);
};

ForexPriceChart.prototype.getAllTimeseries = function(isBullish) {
	return this.timeseriesIds.concat(this.oscillatorTimeseriesIds).concat(this.getStopParametersByTrend(isBullish)).join();
};

ForexPriceChart.prototype.addOscillator = function(idea,event) {
	var self = this;

	if (self.oscillatorSectionId === null) {
		// No oscillator to add
		return;
	}

	// Remove the x-axis and bottom margin on the price section
	self.blingChartInst.getById(blingChartConstants.SECTION.price).attr({bottomMargin:0, xAxis: {hidden: true}});

	// Add spacer between price and oscillator
	charting.tools.createSection(this.blingChartInst, blingChartConstants.SECTION.spacer);

	var section = charting.tools.createSection(this.blingChartInst, blingChartConstants.SECTION[this.oscillatorSectionId]);

	// Accessor for each timeseries
	self.oscillatorTimeseriesIds.forEach(function(id) {

		var plot = section.append('line-plot').attr({
			id: self.oscillatorSectionId + '!' + id + '-' + event.id,
			accessors: [{name: id, accessor: id}],
			class: charting.definition.plot['plot-' + self.oscillatorSectionId].class,
			strokeWidth: charting.definition.plot['plot-' + self.oscillatorSectionId].strokeWidth(id)
		});
		// save mapping for this event in the event factory
		self.addEventMapping(event.id, plot.attr('id'), self.highlightDimElement, event.eventType.name);

		// register event listeners on the object passed
		self.registerEventListeners(idea.events,plot);
	});

	section.attr({topMargin: 0});

	self.drawIoMarkup(idea,event);

	// Add threshold lines for oscillator section as a separate plot so we don't include them when
	// responding to mouse events.
	var accessors = [];
	self.ChartSections.byId(self.oscillatorSectionId).thresholds.forEach(function(threshold) {
		accessors.push({name: self.oscillatorSectionId + threshold, accessor: threshold});
	});
	section.append('line-plot').attr({
		id: self.oscillatorSectionId + '-threshold-' + event.id,
		accessors: accessors,
		class: charting.definition.plot['plot-' + self.oscillatorSectionId].class
	});

	// format y-axis for the oscillator section
	var oscillatorSection = this.blingChartInst.getById(blingChartConstants.SECTION[self.oscillatorSectionId]);
	if (self.ChartSections.byId(self.oscillatorSectionId).dataType === 'integer') {
		oscillatorSection.attr('yAxisTickFormat', blingUtils.numberFormat(".0f"));
	} else if (self.ChartSections.byId(self.oscillatorSectionId).dataType === 'decimal') {
		oscillatorSection.attr('yAxisTickFormat', blingUtils.numberFormat(".2g"));
	} else if (self.ChartSections.byId(self.oscillatorSectionId).dataType === 'percentage') {
		oscillatorSection.attr('yAxisTickFormat', blingUtils.numberFormat(".1%"));
	}

	this.addEventMapping(event.id, 'oscillator-legend', this.visibleElement, event.eventType.name);
	// adding legend
	var layout = section.append('layout')
		.attr({
			direction: 'horizontal',
			id: 'oscillator-legend',
			leftMargin: 0,
			topMargin: 7,
			bottomMargin: 0,
			rightMargin: 0,
			verticalAlign: 'top'
		});

	// Hide legend when crosshairs appear
	this.setHideOnHover('oscillator-legend');

	// Note: only show legend for first timeseries
	layout.append('rect')
		.attr({
			dx: 8, dy: 1,
			leftMargin: 2,
			topMargin: 5,
			bottomMargin: 5,
			rightMargin: 5,
			verticalAlign: 'middle',
			width: 'auto',
			height: 'auto',
			class: 'tc-plot-' + self.oscillatorTimeseriesIds[0]
		});
	layout.append('text')
		.attr({
			text: self.services.Lexicon.translateDefaultNS('timeseries.' + self.oscillatorSectionId + '-' + self.oscillatorTimeseriesIds[0]),
			leftMargin: 0,
			topMargin: 5,
			bottomMargin: 0,
			rightMargin: 5,
			verticalAlign: 'middle',
			width: 'auto',
			height: 'auto',
			class: 'price-chart-marker-legend-text'
		});

};

/**
 * Draw the square event markup on the IO chart
 * @param event
 */
ForexPriceChart.prototype.drawIoMarkup = function (idea,event) {
	var markupSource = new bling.Markup().fromAPI(event['linkId'], event.markup, event.eventType.name, event.eventType.chart);

	var markup = this.blingChartInst.getById(blingChartConstants.SECTION[this.oscillatorSectionId]).append('event-markup').attr({
		id: 'markup-' + event.id,
		markup: markupSource
	});

	// save mapping for this event in the event factory
	this.addEventMapping(event.id, markup.attr('id'), this.highlightDimElement, event.eventType.name);

	// register event listeners on the object passed
	this.registerEventListeners(idea.events,markup);
};

/**
 * Draw the latest price indicator on the price chart
 * @param idea
 */
ForexPriceChart.prototype.addLatestPrice = function (idea) {
	var priceValue = idea.instrument.latestPrice.price;
	this.lastpriceElement = this.blingChartInst.getById(blingChartConstants.SECTION.price)
		.append('axis-annotation')
		.attr({
			value: priceValue,
			class: 'price-chart-lastprice',
			format: this.priceFormatSpecifier
		});
};

/**
 * Formatting for x-axis and y-axis for the price section
 */
ForexPriceChart.prototype.addLanguageSupport = function() {
	var priceSection = this.blingChartInst.getById(blingChartConstants.SECTION.price);
	var xAxis = priceSection.attr('xAxis');
	xAxis.tickFormat = blingUtils.timeFormat;
	priceSection.attr('xAxis', xAxis);
	priceSection.attr('yAxisTickFormat', blingUtils.numberFormat(this.priceFormatSpecifier));
};

ForexPriceChart.prototype.addIndicator = function(idea,event) {

	var self = this;

	var priceSection = this.blingChartInst.getById(blingChartConstants.SECTION.price);
	this.addEventMapping(event.id, 'section-indicator-legend', self.visibleElement, event.eventType.name);

	var legendVerticalLayout = priceSection.append('layout')
		.attr({
			id: 'section-indicator-legend',
			direction: 'vertical',
			topMargin: 7,
			verticalAlign: 'top'
		});

	// Hide legend when crosshairs appear
	this.setHideOnHover('section-indicator-legend');

	var firstTime = true;
	var bollingerArray= ["bblower", "bbupper", "bollinger"];
	self.indicatorTimeseriesIds.forEach(function(id){
		var plot = charting.tools.createPlot(self.blingChartInst, 'plot-'+id,  event.id, id);

		// add the element to the event mapping
		self.addEventMapping(event.id, plot.attr('id'), self.highlightDimElement, event.eventType.name);

		// register event listeners on the object passed
		self.registerEventListeners(idea.events,plot);

		var legendHorizontalLayout  = legendVerticalLayout.append('layout')
			.attr({
				direction: 'horizontal',
				topMargin: 15,
				verticalAlign: 'top'
			});
		if(bollingerArray.indexOf(id) > -1 && firstTime){
			firstTime = false;
			self.createLegends(legendHorizontalLayout,id);
		}
		if(bollingerArray.indexOf(id) < 0){
			self.createLegends(legendHorizontalLayout,id);
		}
	});
};

ForexPriceChart.prototype.createLegends = function (legendLayout, timeseriesId) {
	legendLayout.append('rect')
		.attr({
			dx: 8, dy: 1,
			leftMargin: 2,
			topMargin:5,
			bottomMargin:5,
			rightMargin:5,
			verticalAlign: 'middle',
			class:'chart-indicator-legend-'+timeseriesId
		});

	legendLayout.append('text')
		.attr({
			text: this.services.Lexicon.translateDefaultNS('timeseries.price-'+timeseriesId),
			leftMargin: 0,
			bottomMargin:0,
			verticalAlign: 'middle',
			class:'price-chart-marker-legend-text'
		});

}

/**
 * Add common component to forex chart
 * @param chart
 * @param chartType
 * @param idea
 * @param responses
 * @param firstEvent
 * @param pricePeriod
 * @param secondEvent
 * @param forceCandlesticks Indicates whether to use candlestick-style chart regardless of the event type
 */
ForexPriceChart.prototype.addForexCommonComponent = function (chart, chartType, idea, responses, firstEvent, pricePeriod, secondEvent, forceCandlesticks) {
	var self = chart;

	// Add extra target region timestamps, if available
	if (responses[1]) {
		self.addExtraTimestamps(responses[0].result.timestamp, responses[1].timestamps);
	}

	self.addCommonHeaderComponent(self, responses[0].result,idea, forceCandlesticks);

	if(chartType === self.CommonConstants.CHART_TYPE.largeForexPriceChart){
		// Remove the x-axis and bottom margin on the price section
		self.blingChartInst.getById(blingChartConstants.SECTION.price).attr({bottomMargin:0});
		// add some padding so copyright does not fall under price section x-axis
		self.blingChartInst.getById(blingChartConstants.SECTION.copyright).attr({topMargin: 0});
	}

	self.addBarDetails(false);
	self.addEventNameSection();
	self.addMarkup(responses[0].result.timestamp,idea,firstEvent,pricePeriod);
	if(secondEvent){
		var offsetLevel = 0;
		if (firstEvent.dates.eventEnd === secondEvent.dates.eventEnd) {
			offsetLevel = 1;
		}
		self.drawDots(idea,secondEvent,offsetLevel);
		if(secondEvent.eventType.chart === 'price'){
			self.addIndicator(idea,secondEvent);
			if(chartType === self.CommonConstants.CHART_TYPE.largeForexPriceChart){
				self.blingChartInst.getById(blingChartConstants.SECTION.price).attr({bottomMargin:20});
			}
			else if(chartType === self.CommonConstants.CHART_TYPE.smallForexPriceChart){
				// add some padding so copyright does not fall under price section x-axis
				self.blingChartInst.getById(blingChartConstants.SECTION.copyright).attr({topMargin: 20});
			}
		}
	}
	self.addOscillator(idea,secondEvent);
	if(chartType === self.CommonConstants.CHART_TYPE.largeForexPriceChart){
		self.addClose(idea);
	}

	// Add target region markup, if req'd
	if (responses[1]) {
		var lastRangeDate = responses[1].timestamps[responses[1].timestamps.length - 1];
		self.addTargetRegion(responses[0].result.timestamp, firstEvent, lastRangeDate);
	}

	self.addCommonFooterComponent(self,idea,responses[0].result);
	self.addCrosshair(responses[0].result.timestamp);
	self.updateWatchedStopPrice(idea,pricePeriod);
}

ForexPriceChart.prototype.crosshairTimeFormat = function (timeseries){
	var self = this,
		sectionId = blingChartConstants.SECTION.price;
	if(self.oscillatorSectionId){
		sectionId = blingChartConstants.SECTION[self.oscillatorSectionId];
	}
	var xTickWidth;
	var date = self.services.DateFormatter.parseDate(timeseries[timeseries.length - 1]);

	if(date.getFullYear() === new Date().getUTCFullYear() ){
		xTickWidth = 80;
	} else {
		xTickWidth = 107;
	}

	this.blingChartInst.getById(sectionId)
		.attr({
			'crosshair.enable': true,
			'crosshair.yTickClass': 'tc-crosshair-label',
			'crosshair.xTickClass': 'tc-crosshair-label',
			'crosshair.lineClass': 'tc-crosshair-line',
			'crosshair.xTickFormat': blingUtils.intradayCrosshairTimeFormat,
			'crosshair.xTickWidth':xTickWidth,
			background: {
				enable: true,
				class:"tc-section-background"
			}
		});
}

ForexPriceChart.prototype.isLimitReached = function (idea, lastBarTime) {
	var lastPossibleActive = Math.max(this.DateFormatter.getEpoch(idea.events[1].lastPossibleActive),
		this.DateFormatter.getEpoch(idea.events[0].lastPossibleActive));
	return lastPossibleActive < lastBarTime.getTime();
};

"use strict";
/**
 * Small forex price chart object
 * @param services
 * @param config
 * @param blingChartInst
 * @constructor
 */
function SmallForexPriceChart(services,config,blingChartInst) {
	// call parent constructor to pass data
	ForexPriceChart.call(this, services,blingChartInst);

	this.$q = services.$q;
	this.REST = services.REST;
	this.CommonConstants = services.CommonConstants;
	this.DateFormatter = services.DateFormatter;
	this.Lexicon = services.Lexicon;
	this.ChartSections = services.ChartSections;

	this.services = services;
	this.config = config;
	this.blingChartInst = blingChartInst;

	this.priceSectionHeight = 235;
	this.oscillatorSectionHeight = 70;
}

SmallForexPriceChart.prototype = Object.create(ForexPriceChart.prototype);
SmallForexPriceChart.prototype.constructor = SmallForexPriceChart;

/**
 * Draw the small forex price chart
 * @param idea
 */
SmallForexPriceChart.prototype.init = function(idea) {
	// save the instance of this object
	var self = this;

	var firstEvent = idea.events[0],
		secondEvent = idea.events[1],
		pricePeriod = firstEvent.pricePeriod,
		eventEnd = firstEvent.dates.eventEnd;

	// calculate number of bars to get before and after the event
	blingUtils.getChartDateRange(self.services,idea).then(function (response) {
		self.initSections(["price"],idea.events);
		var timeseriesParameters = {
			instrumentId: idea.instrument.id,
			series: self.getAllTimeseries(self.isBullish(idea)),
			period: pricePeriod,
			start: response.startDate,
			end: response.endDate
		};

		var promiseList = [
			self.REST.instrumentTimeseries(timeseriesParameters)
		];

		// add the target price range dates, if req'd
		if (firstEvent.targetPrice) {
			promiseList.push(
				self.getTargetRangeDates(idea.instrument.exchange.id, pricePeriod, eventEnd,
					firstEvent.dates.duration)
			);
		}

		self.$q.all(promiseList).then(function (responses) {
			self.addForexCommonComponent(self, self.CommonConstants.CHART_TYPE.smallForexPriceChart,idea,responses,firstEvent,pricePeriod,secondEvent);
		});
	});
};

/**
 * Set dimensions for all sections in the chart
 */
SmallForexPriceChart.prototype.setDimensions = function() {
	if (this.oscillatorSectionId) {
		// Reduce height of price section by height of optional section plus 10 for spacer
		this.blingChartInst.getById(blingChartConstants.SECTION.price).attr({height: this.priceSectionHeight - 60});
		this.blingChartInst.getById('section-' + this.oscillatorSectionId).attr({height: this.oscillatorSectionHeight});
	}
	else {
		this.blingChartInst.getById(blingChartConstants.SECTION.price).attr({height: this.priceSectionHeight});
	}
};

"use strict";
/**
 * Large forex price chart object
 * @param services
 * @param config
 * @param blingChartInst
 * @constructor
 */
function LargeForexPriceChart(services,config,blingChartInst) {
	// call parent constructor to pass data
	ForexPriceChart.call(this, services,blingChartInst);

	this.$q = services.$q;
	this.REST = services.REST;
	this.CommonConstants = services.CommonConstants;
	this.DateFormatter = services.DateFormatter;
	this.services = services;
	this.config = config;
	this.blingChartInst = blingChartInst;

	this.priceSectionHeight = 245;
	this.closeSectionHeight = 80;

	this.oscillatorSectionHeight = 70;
	this.limitTime = null;
}

LargeForexPriceChart.prototype = Object.create(ForexPriceChart.prototype);
LargeForexPriceChart.prototype.constructor = LargeForexPriceChart;

/**
 * Draw the large forex price chart
 * @param idea
 */
LargeForexPriceChart.prototype.init = function(idea) {
	// save the instance of this object
	var self = this;

	var firstEvent = idea.events[0],
		secondEvent = idea.events[1],
		pricePeriod = firstEvent.pricePeriod,
		eventEnd = firstEvent.dates.eventEnd;

	self.initSections(["price"],idea.events);

	// Limit the API to max of 6000 bars
	var timeseriesParameters = {
		instrumentId: idea.instrument.id,
		series: self.getAllTimeseries(self.isBullish(idea)),
		period: pricePeriod,
		before: '5000',
		after: '1000',
		date: eventEnd
	};

	var promiseList = [
		self.REST.instrumentTimeseries(timeseriesParameters)
	];

	// add the target price range dates, if req'd
	if (firstEvent.targetPrice) {
		promiseList.push(
			self.getTargetRangeDates(idea.instrument.exchange.id, pricePeriod, eventEnd,
				firstEvent.dates.duration)
		);
	}

	//the limit for larger watched chart is 1000 forward bars
	if(idea.productType === this.services.CommonConstants.VIEW.watchedForex){
		var params = {date: eventEnd,after: 1000};
		promiseList.push(self.REST.getTradingCalendar(idea.instrument.exchange.id,pricePeriod,params));
	}

	self.$q.all(promiseList).then(function (responses) {
		// forward bar response may be the second or third in the original promise list
		var forwardResponseIndex = firstEvent.targetPrice ? 2 : 1;
		self.addForexCommonComponent(self,self.CommonConstants.CHART_TYPE.largeForexPriceChart,idea,
			// Don't inlude the forward bar response in the responses passed to addForexCommonComponent
			responses.slice(0, forwardResponseIndex),
			firstEvent,pricePeriod,secondEvent, self.config.forceCandlesticks);
		if(responses[forwardResponseIndex]){
			var timestamp = responses[forwardResponseIndex].timestamps;
			self.limitTime = timestamp[timestamp.length-1];
		}
	});
};

/**
 * Set dimensions for all sections in the chart
 */
LargeForexPriceChart.prototype.setDimensions = function() {
	this.blingChartInst.getById(blingChartConstants.SECTION.close).attr({height: this.closeSectionHeight});
	if (this.oscillatorSectionId) {
		// Reduce height of price section by height of optional section plus 10 for spacer
		this.blingChartInst.getById(blingChartConstants.SECTION.price).attr({height: this.priceSectionHeight - 70});
		this.blingChartInst.getById('section-' + this.oscillatorSectionId).attr({height: this.oscillatorSectionHeight});
	}
	else {
		this.blingChartInst.getById(blingChartConstants.SECTION.price).attr({height: this.priceSectionHeight});
	}
};

LargeForexPriceChart.prototype.isLimitReached = function (idea, lastBarTime) {
	var self = this;
	if(idea.productType === this.services.CommonConstants.VIEW.watchedForex){
		return lastBarTime.getTime() > (new Date(self.limitTime)).getTime();
	}
};

'use strict';

var API_CALL_FREQUENCY = 10 * 1000;

recogniaApp.factory('LoopHttpCallService',
    ['REST', '$interval', 'CommonConstants', function (REST, $interval, CommonConstants) {
        function subscribe(scope, watchExpr, scopeExpr, resource, subscriptionType) {
            function callCorrespondingApi() {
                if (subscriptionType === CommonConstants.SUBSCRIPTION_TYPE.quote) {
                    REST.getLatestPrice(scope.featured.idea.instrument.id).then(function (response) {
                        // update the featured idea with the new data
                        resource.callbackFunc(response);
                    });
                } else if (subscriptionType === CommonConstants.SUBSCRIPTION_TYPE.timeseries) {
                    REST.instrumentTimeseries(resource.parameters).then(function (response) {
                        // update the chart with the new prices
                        resource.callbackFunc(response);
                    });
                }
            }

            var realTimeData = false;
            var realTimeUpdate;

            scope.$watch(watchExpr, function (newSelectedIdea) {
                if (newSelectedIdea === scope[scopeExpr] && !realTimeData) {
                    realTimeData = true;
                    // one instant call
                    callCorrespondingApi();
                    // then periodical calls every 10s
                    realTimeUpdate = $interval(callCorrespondingApi, API_CALL_FREQUENCY);
                } else if (newSelectedIdea !== scope[scopeExpr] && realTimeData) {
                    realTimeData = false;
                    // cancel the real time update for ideas that are not displayed
                    $interval.cancel(realTimeUpdate);
                }
            });


            // cancel the real time update when the view is destroyed
            scope.$on('$destroy', function closeConnection() {
                if (realTimeData) {
                    $interval.cancel(realTimeUpdate);
                }
            });
        }

        /**
         * This method will be called from `featured_stocks\controller.js` because at this level we have access to
         * all the eventIdeas that are currently in the view ( it can be either FOREX ideas, or WATCHED FOREX ideas,
         * or STOCK ideas, etc ) and we want to do one call with the eventIds corresponding to all ideas. We will
         * use the scope variable from that controller to detect whenever the viewed ideaList is changed so that we
         * can execute the following workflow.
         * @param scope the scope variable from the featured stocks controller
         */
        function oneTimeSubscribeToIdeasState(scope) {
            /**
             * <ol>
             *     <li>Transforms the `eventIdsByInstrumentIdMap` to a list of eventIds</li>
             *     <li>Calls the <i>eventscreener</i> API with the eventIds list and gets a new list that contains only
             *     inactive eventIds</li>
             *     <li>For each inactive event:
             *          <ul>
             *              <li>Calls the `removeEntryFromMap` method ( we don't want to use this eventId or
             *              other sibling eventIds belonging to the same idea in the following calls )</li>
             *              <li>If the returned instrumentId is not null then we need to set the idea as inactive.
             *              It can be null only if we've already called that method with a different eventId
             *              that belonged to the same idea ( therefore same instrumentId )</li>
             *          </ul>
             * </ol>
             */
            function getEventsData() {
                var eventIds = mapToList(eventIdsByInstrumentIdMap);
                if (eventIds.length > 0) {
                    REST.findInactiveEvents(eventIds).then(function (inactiveEvents) {
                        if (inactiveEvents.length > 0) {
                            inactiveEvents.forEach(function (inactiveEvent) {
                                if (eventIdsByInstrumentIdMap.size > 0) {
                                    var instrumentId = removeEntryFromMap(eventIdsByInstrumentIdMap, inactiveEvent);
                                    if (instrumentId !== null) {
                                        for (var i = 0; i < scope.ideas.length; i++) {
                                            if (scope.ideas[i].idea.instrument.id === instrumentId) {
                                                // change style for idea ribbon
                                                scope.ideas[i].idea.active = false;
                                                break;
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
            }

            /**
             * Transforms a map into a list of eventIds
             * @param map map where { key = instrumentId } and { value = array of eventIds }
             */
            function mapToList(map) {
                var list = [];
                map.forEach(function (value) {
                    value.forEach(function (eventId) {
                        list.push(eventId);
                    });
                });
                return list;
            }

            /**
             * Removes an entry ( that contains the input inactive event ) from the map and returns the corresponding
             * key ( which is an instrumentId )
             * @param map map where { key = instrumentId } and { value = array of eventIds }
             * @param inactiveEvent the event to look for
             */
            function removeEntryFromMap(map, inactiveEvent) {
                var instrumentId = null;
                map.forEach(function (value, key) {
                    // if at least one event id becomes inactive then the idea becomes inactive
                    // so we need to completely remove the corresponding entry
                    if (value.includes(inactiveEvent)) {
                        instrumentId = key;
                        map.delete(key);
                    }
                });
                return instrumentId;
            }

            var realTimeUpdate;
            var eventIdsByInstrumentIdMap = new Map();

            // everytime the viewed ideasList is modified ( from the dropdown or by modifying the filters ) we will:
            // 1. cancel calls for the previous ideasList ( if applicable )
            // 2. iterate over the new ideasList and check which ideas are streamable ( allowed for real time updates )
            // 3. for each streamable idea add a new entry inside the eventIdsByInstrumentIdMap
            // 4. do periodical calls using the event ids from the eventIdsByInstrumentIdMap
            scope.$watch('ideas', function (newIdeasList) {
                // cancel the periodical calls that are done for the previous list of ideas
                if (typeof realTimeUpdate !== 'undefined') {
                    $interval.cancel(realTimeUpdate);
                    eventIdsByInstrumentIdMap.clear();
                }

                if (typeof newIdeasList !== 'undefined') {
                    newIdeasList.forEach(function (ideaObject) {
                        // check whether the user has stream permission or not for the new list of ideas
                        if (typeof ideaObject.idea.streamable !== 'undefined' && ideaObject.idea.streamable) {
                            var instrumentId = ideaObject.idea.instrument.id;
                            var eventIds = [];
                            ideaObject.idea.events.forEach(function (event) {
                                // each event has only one item in the id array
                                eventIds.push(event.id[0]);
                            });
                            eventIdsByInstrumentIdMap.set(instrumentId, eventIds);
                        }
                    });
                }
                if (eventIdsByInstrumentIdMap.size > 0) {
                    // one instant call
                    getEventsData();
                    // then periodical calls every 10s
                    realTimeUpdate = $interval(getEventsData, API_CALL_FREQUENCY);
                }
            });

            // cancel the real time update when the view is destroyed
            scope.$on('$destroy', function closeConnection() {
                if (typeof realTimeUpdate !== 'undefined') {
                    $interval.cancel(realTimeUpdate);
                }
            });

        }

        return {
            'subscribe': subscribe,
            'oneTimeSubscribeToIdeasState': oneTimeSubscribeToIdeasState
        };
    }]);

'use strict';

/**
 * This service contains generic utility methods for Arrays
 */
recogniaApp.factory('ArrayUtil',
	[function () {

		function reversableComparator(fn, descending){
			if (!descending) {
				return fn;
			}
			else {
				// For descending order, just negate the results of the ascending comparator
				return function () {
					return -1 * fn.apply(this, arguments);
				};
			}
		}

		/**
		 * Function that returns a comparator function to alphabetically sort a list of
		 * objects by a given property.
		 */
		function alphaComparatorByProperty (property, descending) {
			if (property){
				return reversableComparator(function (a, b) {
						// check that properties aren't null or undefined
						if (a[property] && b[property]){
							var c1 = a[property].toLowerCase(),
								c2 = b[property].toLowerCase();
							return (c1 < c2) ? -1 : ((c1 > c2) ? 1 : 0);
						} else {
							// return the one with non null as being greater
							return (a[property]) ? 1 : ((b[property]) ? -1 : 0);
						}
					}, descending);
			} else {
				console.error("No property passed to alphaComparatorByProperty");
				return null;
			}
		}

		function numericComparatorByProperty (property, descending) {
            if (property) {
				return reversableComparator(function (a, b) {
					var aValue = Number(a[property]);
					var bValue = Number(b[property]);
                    // Check that properties aren't null or undefined (don't check for "truthiness" because 0 is perfectly valid)
					var aHasProp = (a[property] !== undefined && a[property] !== null && !isNaN(aValue));
					var bHasProp = (b[property] !== undefined && b[property] !== null && !isNaN(bValue));
                    if (aHasProp && bHasProp) {
                        if (aValue > bValue) {
                            return 1;
                        }
                        else if (aValue < bValue) {
                            return -1;
                        }
                        return 0;
                    }
                    else {
                        // return the one with non null as being greater
                        if (aHasProp) {
                            return 1;
                        }
                        else if (bHasProp) {
                            return -1;
                        }
                        return 0;
                    }
				}, descending);
            }
            else {
                console.error("No property passed to numericComparatorByProperty");
				return null;
            }
        }

		return {

			/**
			 * @param {Array} objList A list of objects.
			 * @param {string} property The property to sort the objects by.
			 * @param {bool} descending True to sort in descending order, otherwise ascending will be used.
			 * @returns The list objects sorted in alphabetical order
			 */
			sortObjectsByPropertyAlpha: function(objList, property, descending){
				return objList.sort(alphaComparatorByProperty(property, descending));
			},


            /**
             * @param {Array} objList A list of objects.
             * @param {string} property The property (containing numeric values) to sort the objects by.
             * @param {bool} descending True to sort in descending order, otherwise ascending will be used.
             * @returns The list objects sorted in numerical order
             */
            sortObjectsByPropertyNumeric: function(objList, property, descending){
                return objList.sort(numericComparatorByProperty(property, descending));
            },

			/**
			 * @param {Array} objList A list of objects.
			 * @param {string} property The object property to compare the value to.
			 * @param value The value to search for.
			 * @returns The first index of an object that has the property matching value that was
			 *          passed in. If no match found, returns -1.
			 */
			indexOfByProperty: function(objList, property, value){
				var found = -1;
				for (var i=0; i < objList.length; i++){
					if (objList[i][property] === value){
						found = i;
						break;
					}
				}
				return found;
			}

		};
	}
]);
/**
 * Created with JetBrains WebStorm.
 * User: Hosam
 * Date: 2012-12-12
 * Time: 4:23 PM
 * To change this template use File | Settings | File Templates.
 */

'use strict';

/* Services */

recogniaApp.factory ('Config',
['$window', '$q', '$rootScope', 'CommonConstants',
function ($window, $q, $rootScope, CommonConstants) {

	var currentLanguage = {},
		enableDebug='',
		publicApiBaseUrl = '//' + $window.location.hostname + '/api',
		transactionId,
		sessionId,
		referencePageId,
		platform,
		legacyApiParameters="_xslparam_SYMBOL_FORMAT=dir_config::SYMBOL_FORMAT&_xslparam_SYMBOL_EXCHANGE_FORMAT=dir_config::SYMBOL_EXCHANGE_FORMAT&_xsl_id=xml_display_symbol:xml_display_exchange:asjson",
		baseFolder = '',
		authUid ='',
		bearerToken = '';

	// Component has been embedded into another page
	if ($window.recogniaComponentsConfig !== undefined) {

		// Used for locating resources irrelevant of the current document path
		if ($window.recogniaComponentsConfig.staticBaseUrl !== undefined) {
			baseFolder = $window.recogniaComponentsConfig.staticBaseUrl;
		}

		// Used for selecting a specific transaction
		if ($window.recogniaComponentsConfig.tid!==undefined) {
			transactionId = $window.recogniaComponentsConfig.tid;
		}

		// Used for url prefix for API public calls
		if ($window.recogniaComponentsConfig.apiBaseUrl!==undefined) {
			publicApiBaseUrl = $window.recogniaComponentsConfig.apiBaseUrl;
		}

		// Used for authenticating users
		if ($window.recogniaComponentsConfig.sessionId!==undefined) {
			sessionId = $window.recogniaComponentsConfig.sessionId;
		}

		// Used for tracking user activity
		if ($window.recogniaComponentsConfig.referencePageId!==undefined) {
			referencePageId = $window.recogniaComponentsConfig.referencePageId;
		}

		// Used for authenticating users
		if ($window.recogniaComponentsConfig.platform!==undefined) {
			platform = $window.recogniaComponentsConfig.platform;
		}

		// Used for language
		if ($window.recogniaComponentsConfig.language!==undefined) {
			var langCode = $window.recogniaComponentsConfig.language;
			if (CommonConstants.LANGUAGE_MAP[langCode] !== undefined && CommonConstants.LANGUAGE_WITH_LOCALE_MAP[langCode] !== undefined) {
				currentLanguage = {
					code: langCode,
					language: CommonConstants.LANGUAGE_MAP[langCode],
					languageWithLocale: CommonConstants.LANGUAGE_WITH_LOCALE_MAP[langCode]
				};
			}
		}

		// If in hosted websites, get auth from there
		if ($window.recogniaComponentsConfig.userAuth!==undefined) {
			authUid = $window.recogniaComponentsConfig.userAuth;
		}

		// Used int the newer REST API calls, where the authentication is not done via uid, but via token
		if ($window.recogniaComponentsConfig.bearerToken !== undefined) {
			bearerToken = $window.recogniaComponentsConfig.bearerToken;
		}
	}

	// need this because the
	var ready = $q.defer();
	var endLtrWatch = $rootScope.$watch(
		function (){
			if ($window.RecogniaResourceLoader !== undefined)
				return $window.RecogniaResourceLoader.textDirection;
			else
				return $('.recognia').length > 0;
		},
		function (newVal){
			if (newVal !== null && newVal !== undefined){
				ready.resolve();
				endLtrWatch();
			}
		}
	);

	/**
	 * Publish generic get API
	 */
	return {
		init: function () {
			var progress = $q.defer();
			ready.promise.then(function(){
				progress.resolve();
			});
			return progress.promise;
		},

		api_url: function() {
			return window.ApiHostResolver.getApiHost('legacyRest') + '/api/v1/rest';
		},

		new_api_url: function() {
			return window.ApiHostResolver.getApiHost('rest');
		},

		static_server_url: function() {
			return window.ApiHostResolver.getApiHost('staticServer');
		},

		/**
		 * Used to set the authorization uid
		 * @param auth
		 */
		setUserAuthorization: function (auth) {
			authUid = auth;
		},

		/**
		 * Get the user's authorization uid
		 * @returns {*}
		 */
		getUserAuthorization: function() {
			return authUid;
		},

		/**
		 * Used to set the authorization token
		 * @param token to authenticate the user for REST requests
		 */
		setUserTokenAuthorization: function (token) {
			bearerToken = token;
		},

		/**
		 * Get the user's authorization token
		 * @returns authorization token received from config
		 */
		getUserTokenAuthorization: function () {
			return bearerToken;
		},

		/**
		 * Get the protocol, host and port where this page is hosted
		 * @returns {string}
		 */
		webBaseUrl: function() {
			return $window.location.protocol + '//' + $window.location.host;
		},

		/**
		 * Used for accessing resources (JS/image,.etc)
		 */
		baseFolder: function() {
			return baseFolder;
		},

		/**
		 * Used by the front-end to build URLs
		 * @returns {*}
		 */
		getTransactionId: function() {
			return transactionId;
		},

		/**
		 * Gets the current platform
		 * @returns {*}
		 */
		getPlatform: function () {
			return platform;
		},

		/**
		 * Returns true if the current platform is standalone
		 * @returns {boolean}
		 */
		isStandalonePlatform: function() {
			return platform === 'standalone';
		},

		/**
		 * Sets current platform to standlone
		 */
		setStandalonePlatform: function () {
			platform = 'standalone';
		},

		/**
		 * Sets the current platform
		 * @returns {*}
		 */
		setPlatform: function (newPlatform) {
			platform = newPlatform;
		},

		/**
		 * Used by the front-end to build URLs
		 * @returns {*}
		 */
		getPublicApiBaseUrl: function() {
			return publicApiBaseUrl;
		},

		/**
		 * Used by the legacyApi to build URLS
		 * @returns {*}
		 */
		getSessionId: function() {
			return sessionId;
		},

		/**
		 * Used by the legacyApi to build URLS
		 * @returns {*}
		 */
		getReferencePageId: function() {
			return referencePageId;
		},

		setEnableDebug : function(enabled) {
			enableDebug = enabled;
		},

		getEnableDebug: function(){
			return enableDebug;
		},

		language: function() {
			return currentLanguage.language || '';
		},

		languageWithLocale: function() {
			return currentLanguage.languageWithLocale || '';
		},

		languageCode: function() {
			return currentLanguage.code || '';
		},

		setLanguage : function(languageCode) {
			currentLanguage = {
				code: languageCode,
				language: CommonConstants.LANGUAGE_MAP[languageCode],
				languageWithLocale: CommonConstants.LANGUAGE_WITH_LOCALE_MAP[languageCode]
			};
			// Sets the language on the page on standalone
			if(this.isStandalonePlatform()) {
				document.documentElement.lang = languageCode;
			}

		},

		setLanguageFromRest : function(languageWithLocale) {
			// Do a reverse lookup to find the legacy version of the language code
			for (var code in CommonConstants.LANGUAGE_WITH_LOCALE_MAP) {
				if (CommonConstants.LANGUAGE_WITH_LOCALE_MAP[code] === languageWithLocale) {
					this.setLanguage(code);
					return;
				}
			}
		},

		getLegacyApiParameters: function(){
			return legacyApiParameters;
		},

		isRtl: function(){
			var isRtl;
			try{
				isRtl = $window.RecogniaResourceLoader.textDirection === 'rtl';
			} catch (err) {
				isRtl = $('.recognia').css('direction') === 'rtl';
			}
			return isRtl;
		},

		getPageDirection: function(){
			var isRtl = this.isRtl();
			return {
				ltr: !isRtl,
				rtl: isRtl
			};
		}
	};
}]);

'use strict';

recogniaApp.factory('REST',
['$http', '$q', '$window', 'Config', 'CommonConstants',
function ($http, $q, $window, Config, CommonConstants) {

	var PARAMS = {
		LANG: 'lang',
		PLATFORM: 'platform',
		AUTHORIZATION: 'uid',
		TOKEN: 'token'
	};

	var HEADERS = {
		LEGACY_AUTHORIZATION: 'X-auth',
		AUTHORIZATION: 'Authorization'
	};

	var apiProtocol = Config.api_url().match(/^https?:/)[0];

	/**
	 * Sets the appropriate protocol on an absolute URL to a REST API
	 * @param sourceUrl A URL typically retrieved from the linkId property of a REST object
	 */
	function setRestUrlProtocol (sourceUrl) {
		// Remove any existing protocol
		var independent = sourceUrl.replace (/^https?:\/\//, '//');
		// Add slashes if URL just starts with domain
		if (!independent.match(/^\/\//)) {
			independent = '//' + independent;
		}
		// Add the protocol used by the REST API
		return apiProtocol + independent;
	}

	/**
	 * Sends an $http call to the recognia restapi. Modifies the config passed
	 * in to prepend with /api/v1/rest/ and add needed parameters/headers if they
	 * are not already defined.
	 *
	 * @httpCall
	 *    Expects a config object the same as Angular's $http.
	 * @isFullUrl
	 *    Optional. boolean to indicate if /api/v1/rest/ should be prepended
	 * @skipParams
	 *    Optional. Array of any of the usual parameters that would be added to
	 *    a call. Will override and not add those parameters passed in.
	 */
	function legacyWrappedHttpCall(httpCall, isFullUrl, skipParams){
		if (!isFullUrl){
			httpCall.url = Config.api_url() + httpCall.url;
		} else {
			httpCall.url = setRestUrlProtocol(httpCall.url);
		}
		skipParams = skipParams || [];

		// add needed parameters
		httpCall = addParameters(httpCall,skipParams);

		// add needed headers
		httpCall = addHeaders(httpCall,skipParams);

		return $http(httpCall);
	}

	/**
	 * Sends an $http call to the tradingcentral restapi.
	 * @httpCall
	 *    Expects a config object the same as Angular's $http.
	 * @skipParams
	 *    Optional. Array of any of the usual parameters that would be added to
	 *    a call. Will override and not add those parameters passed in.
	 */
	function wrappedHttpCall(httpCall, skipParams) {
		httpCall.url = Config.new_api_url() + httpCall.url;

		skipParams = skipParams || [];

		// add needed parameters
		httpCall = addParameters(httpCall, skipParams);

		// new api calls need the Authorization header
		httpCall.headers = {};
		if (Config.getUserAuthorization() && !httpCall.headers[HEADERS.AUTHORIZATION]) {
			httpCall.headers[HEADERS.AUTHORIZATION] = 'Bearer ' + Config.getUserTokenAuthorization();
		}

		return $http(httpCall);
	}

	/**
	 * Sends an $http call to the recognia restapi(legacy) using jQuery ajax call. This will make a direct http call
	 * to the restapi instead of going through the normal angular path. When we make an http call to restapi
	 * using angular, angular will re-initialize all its elements. This is a performance hit we would like
	 * to avoid for the case of charting. Instead we will use the ajax call to make the appropriate http call.
	 *
	 * Modifies the config passed in to prepend with /api/v1/rest/ and add needed parameters/headers if they
	 * are not already defined.
	 *
	 * @httpCall
	 *    Expects a config object the same as Angular's $http.
	 * @isFullUrl
	 *    Optional. boolean to indicate if /api/v1/rest/ should be prepended
	 * @skipParams
	 *    Optional. Array of any of the usual parameters that would be added to
	 *    a call. Will override and not add those parameters passed in.
	 */
	function legacyAjaxHttpCall(httpCall, isFullUrl, skipParams) {
		if (!isFullUrl){
			httpCall.url = Config.api_url() + httpCall.url;
		}
		skipParams = skipParams || [];

		// add needed parameters
		httpCall = addParameters(httpCall,skipParams);

		// add needed headers
		httpCall = addHeaders(httpCall,skipParams);

		var params = '';
		var delimiter = '';

		// extract parameters to put in ajax call
		Object.keys(httpCall.params).forEach(function (key) {
			params = params + delimiter + key + '=' + httpCall.params[key];
			delimiter = '&';
		});
		return $.ajax({
			method: 'GET',
			url: httpCall.url,
			data: params,
			beforeSend: function (xhr) {
				xhr.setRequestHeader(HEADERS.LEGACY_AUTHORIZATION, Config.getUserAuthorization());
			}
		});
	}

    /**
     * Sends an $http call to the tradingcentral restapi using jQuery ajax call. This will make a direct http call
     * to the restapi instead of going through the normal angular path. When we make an http call to restapi
     * using angular, angular will re-initialize all its elements. This is a performance hit we would like
     * to avoid for the case of charting. Instead we will use the ajax call to make the appropriate http call.
     *
     * Modifies the response to be in the json format of the legacy recognia api call.
     *
     * @httpCall
     *    Expects a config object the same as Angular's $http.
     * @skipParams
     *    Optional. Array of any of the usual parameters that would be added to
     *    a call. Will override and not add those parameters passed in.
     */
	function ajaxHttpCall(httpCall, skipParams, apiMapperFunction) {
        httpCall.url = Config.new_api_url() + httpCall.url;

        skipParams = skipParams || [];

        // add needed parameters
        httpCall = addParameters(httpCall, skipParams);

        // add needed headers
        httpCall = addHeaders(httpCall, skipParams);

        var params = '';
        var delimiter = '';

        // extract parameters to put in ajax call
        Object.keys(httpCall.params).forEach(function (key) {
            params = params + delimiter + key + '=' + httpCall.params[key];
            delimiter = '&';
        });
        return $.ajax({
            method: 'GET',
            url: httpCall.url,
            data: params,
            beforeSend: function (xhr) {
                xhr.setRequestHeader('Authorization', 'Bearer ' + Config.getUserTokenAuthorization());
            },
            // Add a data filter to convert the new REST API json output into the json format of the old API and return it further in this
            // 'expected' format.
            dataFilter: function (newApiResponse) {
                if (typeof apiMapperFunction !== 'undefined') {
                    return apiMapperFunction(newApiResponse, httpCall);
                } else {
                    return newApiResponse;
                }
            }
        });
    }

    /**
     * Add parameters to the http call if necessary
     * @param httpCall
     * @param skipParams
     * @returns {*}
     */
    function addParameters(httpCall, skipParams) {
        if (!httpCall.params) {
            httpCall.params = {};
        }
        if (Config.getPlatform() && !httpCall.params[PARAMS.PLATFORM]
            && skipParams.indexOf(PARAMS.PLATFORM) === -1) {
            httpCall.params[PARAMS.PLATFORM] = Config.getPlatform();
        }
        if (Config.languageWithLocale() && !httpCall.params[PARAMS.LANG]
            && skipParams.indexOf(PARAMS.LANG) === -1) {
            httpCall.params[PARAMS.LANG] = Config.languageWithLocale();
        }

        if (Config.getUserTokenAuthorization() && !httpCall.params[PARAMS.TOKEN] && skipParams.indexOf(PARAMS.TOKEN) === -1) {
            httpCall.params[PARAMS.TOKEN] = Config.getUserTokenAuthorization();
        }
        return httpCall;
    }

	/**
	 * Add headers to the http call if necessary
	 * @param httpCall
	 * @returns {*}
	 */
	function addHeaders(httpCall) {
		if (!httpCall.headers){
			httpCall.headers = {};
		}
		if (Config.getUserAuthorization() && !httpCall.headers[HEADERS.LEGACY_AUTHORIZATION]){
			httpCall.headers[HEADERS.LEGACY_AUTHORIZATION] = Config.getUserAuthorization();
		}
		return httpCall;
	}

	/**
	 * If the product passed in is a watched one, we want to return the actual product equivalent of that
	 *
	 * @param product
	 * @returns the product equivalent for watched
	 */
	function checkIfWatchedProduct(product) {
		if (product === CommonConstants.VIEW.watchedStocks) return CommonConstants.VIEW.stocks;
		if (product === CommonConstants.VIEW.watchedOptions) return CommonConstants.VIEW.options;
		if (product === CommonConstants.VIEW.watchedForex) return CommonConstants.VIEW.forex;
		return product;
	}

	/**
	 * Maps the new timeseries API response to the old response object expected by the application
	 * @param newApiResponse response returned by the new timeseries API
	 * @param httpCall object containing the call data
	 * @returns {string}
	 */
	function timeseriesMapper(newApiResponse, httpCall) {
		// this is needed because pricePeriod is a path param...
		var params = httpCall.url.split('/');
		var pricePeriod = params[params.length - 2];

		var newApiResponseObject = JSON.parse(newApiResponse);
		var expectedResponse = {'result': {}};
		expectedResponse.result['resourceType'] = 'timeseries';
		expectedResponse.result['id'] = [newApiResponseObject.instrument.instrumentId, pricePeriod, httpCall.params.series];
		expectedResponse.result['lastBarTime'] = newApiResponseObject.timestamps[newApiResponseObject.timestamps.length - 1];
		expectedResponse.result['infill'] = newApiResponseObject.infill;
		expectedResponse.result['timestamp'] = newApiResponseObject.timestamps;

		// for the series, go over them and add em one by one
		var seriesArray = httpCall.params.series.split(',');
		for (var i = 0; i < seriesArray.length; i++) {
			var seriesName = seriesArray[i];
			expectedResponse.result[seriesName] = newApiResponseObject[seriesName];
		}
		return JSON.stringify(expectedResponse);
	}

	/**
	 * Maps the response returned by the `eventscreener` API call to a list of inactive event ids.<br>
	 * In order to do this, it will store the request event ids in an array, then store the response event ids in
	 * another array and then do the difference between the two arrays <br>( because the response from the API contains
	 * only active events )
	 * @param apiResponse the response from the call that contains only active events
	 * @param httpCall object containing the call data
	 * @returns {string}
	 */
	function inactiveEventsMapper(apiResponse, httpCall) {
		var requestEventIds = httpCall.url.substring(httpCall.url.indexOf('=') + 1).split(',');
		var responseEventIds = [];

		var apiResponseObject = JSON.parse(apiResponse);
		apiResponseObject.forEach(function (item) {
			item.events.forEach(function (event) {
				responseEventIds.push(event.eventId);
			});
		});

		var inactiveEventIds = requestEventIds.filter(function (event) {
			return !responseEventIds.includes(event);
		});
		return JSON.stringify(inactiveEventIds);
	}

	/**
	 * Publish generic get API
	 */
	return {

		PARAMS: PARAMS,

		HEADERS: HEADERS,

		// resources are equal if @ids are same
		resourcesEqual: function (a, b) {
			if (typeof(a) === 'object') {
				a = a['linkId'];
			}
			if (typeof(b) === 'object') {
				b = b['linkId'];
			}
			return a === b;
		},


		/**
		 * This method is doing an ajax HttpCall, because if we go through the normal restapi path,
		 * the angular dom re-initializes everything after the call returns.
		 * This is a performance hit we would like to avoid for the case of charting.
		 * Instead we will use the ajax HttpCall path to make the appropriate http call.
		 */
		getTradingCalendar: function (exchangeId, pricePeriod, parameters) {
			var url = 'calendars/v3/'+ exchangeId + '/' + pricePeriod;
			var params = {};

			// if start/end dates are passed, use those. Otherwise assume other format is passed in
			if (parameters.start !== undefined && parameters.end !== undefined) {
				params.start = parameters.start;
				params.end = parameters.end;
			}
			else if(parameters.date !== undefined) {
				params.date = parameters.date;
				if (parameters.before) params.before = parameters.before;
				if (parameters.after)  params.after = parameters.after;
			}

			var httpCall = {
				method: 'GET',
				url: url,
				params: params
			};

			return ajaxHttpCall(httpCall, []);
		},

		/**
		 * Calls the new GET endpoint for the `eventscreener` API, gets the set of instruments with events that match
		 * the input event ids and then uses the mapping function `eventsDataMapper` to return an array containing
		 * the inactive events (basically it calls that API to check which events are still active )
		 * @param eventIds array containing multiple event ids
		 * @returns {*}
		 */
		findInactiveEvents: function (eventIds) {
			var url = 'eventscreener/v3?eventIds=';
			eventIds.forEach(function (eventId) {
				url += eventId + ',';
			});
			// we need to remove the last character from the url which will be a ','
			var httpCall = {
				method: 'GET',
				url: url.slice(0, -1)
			};
			return ajaxHttpCall(httpCall, [], inactiveEventsMapper);
		},

		/**
		 * Returns a quote for an instrument
		 * @param instrumentId the id of the input instrument
		 * @returns {*}
		 */
		getLatestPrice: function (instrumentId) {
			var url = 'quotes/v3/' + instrumentId;
			var httpCall = {
				method: 'GET',
				url: url
			};
			return ajaxHttpCall(httpCall, []);
		},

		/**
		 * Returns a quote for a list of instruments
		 * @param instrumentIds concatenated by comma
		 * @returns {*}
		 */
		getLatestPrices: function (instrumentIds) {
			var url = 'quotes/v3?ids=' + instrumentIds;
			var httpCall = {
				method: 'GET',
				url: url
			};
			return ajaxHttpCall(httpCall, []);
		},

		/**
		 * This method is doing an ajax HttpCall, because if we go through the normal restapi path,
		 * the angular dom re-initializes everything after the call returns.
		 * This is a performance hit we would like to avoid for the case of charting.
		 * Instead we will use the ajax HttpCall path to make the appropriate http call.
		 */
		instrumentTimeseries: function (parameters) {
			var url = 'timeseries/v3/'+ parameters.period + '/' + parameters.instrumentId;
			var params = {
				series: parameters.series
			};

			// if start/end dates are passed, use those. Otherwise assume other format is passed in
			if (parameters.start !== undefined && parameters.end !== undefined) {
				params.start = parameters.start;
				params.end = parameters.end;
			}
			else if(parameters.date !== undefined) {
				params.date = parameters.date;
				if (parameters.before) params.before = parameters.before;
				if (parameters.after)  params.after = parameters.after;
			}
			else{
				params.latest = parameters.latest;
			}

			var httpCall = {
				method: 'GET',
				url: url,
				params: params
			};

			return ajaxHttpCall(httpCall, [], timeseriesMapper);
		},

		EventTypes: function () {
			return wrappedHttpCall({
				method: 'GET',
				url: 'eventtypes/v3',
				cache: true

			});
		},

		ChartSections: function() {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: '/chartsections',
				cache: true
			});
		},

		User: function () {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: '/users/self',
				cache: true,
				params: {
					expand: 'client'
				}
			});
		},

		UserComparedIdeas: function (params) {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: '/users/self/ideas/compared',
				params: params
			});
		},

		UserPreferences: function (product) {
			product = checkIfWatchedProduct(product);
			var url = '/users/self/preferences/';
			if (product) {
				url = url + product;
			}
			return legacyWrappedHttpCall({
				method: 'GET',
				url: url
			});
		},

		ExpandedUserPreferences: function (expand) {
			var url = '/users/self/preferences/';

			return legacyWrappedHttpCall({
				method: 'GET',
				url: url,
				params: {
					expand: expand
				}
			});
		},

		UserPreferencesCached: function (product) {
			product = checkIfWatchedProduct(product);
			var url = '/users/self/preferences/';
			if (product) {
				url = url + product;
			}
			return legacyWrappedHttpCall({
				cache: true,
				method: 'GET',
				url: url
			},
			false,
			// there is nothing in the user preferences that is translated, and adding the lang
			// parameter makes it a different call the 2nd time, so would cache 2 different calls
			[PARAMS.LANG]);
		},

		UserStocksIdeas: function (expand) {
			var config = {
				method: 'GET',
				url: '/users/self/ideas/stocks',
				params: {
				}
			};
			if (expand){
				config.params.expand = expand;
			}
			return legacyWrappedHttpCall(config);
		},

		UserWatchedIdeas: function (params) {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: '/users/self/ideas/watched',
				params: params
			});
		},

		UserWatchedStockIdeas: function (params) {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: '/users/self/ideas/watched/stocks',
				params: params
			});
		},

		UserWatchedOptionIdeas: function (params) {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: '/users/self/ideas/watched/options',
				params: params
			});
		},

		UserWatchedForexIdeas: function (params) {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: '/users/self/ideas/watched/forex',
				params: params
			});
		},

		UserOptionsIdeas: function (expand) {
			var config = {
				method: 'GET',
				url: '/users/self/ideas/options',
				params: {
				}
			};
			if (expand){
				config.params.expand = expand;
			}
			return legacyWrappedHttpCall(config);
		},

		UserForexIdeas: function (expand) {
			var config = {
				method: 'GET',
				url: '/users/self/ideas/forex',
				params: {
				}
			};
			if (expand){
				config.params.expand = expand;
			}
			return legacyWrappedHttpCall(config);
		},


		CountriesWithExchanges: function() {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: '/',
				cache: true,
				params: {
					expand: 'country(exchange)'
				}
			});
		},

		Countries: function () {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: '/',
				cache: true,
				params: {
					expand: 'country'
				}
			});
		},

		// TODO change this to take a country code instead of full url
		country: function (countryURL) {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: countryURL,
				cache: true
			}, true);
		},

		Criteria: function () {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: '/criteria',
				cache: true
			});
		},

		// Cached
		Platform: function() {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: '/platforms/' + Config.getPlatform(),
				cache: true
			}, false, [PARAMS.PLATFORM]);
		},

        // Make a POST to get the alternative trade for the trade block that you posted.
		alternativeTrades: function(url, body){
			return legacyWrappedHttpCall({
				method: 'POST',
				url: url,
				data: body,
				params: {
					expand: 'instrument(quote),optionsStrategy,optionsContract(quote)'
				}
			}, true);
		},

		PersonalizedSettingsDefinition: function (product) {
			product = checkIfWatchedProduct(product);
			var url = '/personalizedsettingsdefinition/';
			if (product) {
				url = url + product;
			}
			return legacyWrappedHttpCall({
				method: 'GET',
				url: url,
				cache: true
			});
		},

		ExpandedPersonalizedSettingsDefinition: function (expand) {
			var url = '/personalizedsettingsdefinition/';
			return legacyWrappedHttpCall({
				method: 'GET',
				url: url,
				cache: true,
				params: {
					expand: expand
				}
			});
		},

		InstrumentOptionsIdeas: function (instrumentId, params) {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: '/instruments/' + instrumentId + '/ideas/options',
				params: params
			});
		},

		OptionsStrategies: function (params) {
			return legacyWrappedHttpCall({
					method: 'GET',
					url: '/options/strategies/',
					params: params
				})
				.then(function (listResponse){
					return listResponse;
				},
				function (reason){
					console.error("Api call failed " + reason);
				});
		},

		OptionsStrategiesExpand: function (params) {
			if (!params)
				params = {};
			params.expand = 'optionsStrategy';
			return legacyWrappedHttpCall({
				method: 'GET',
				url: '/options/strategies/',
				params: params
			})
				.then(function (listResponse){
					return listResponse;
				},
				function (reason){
					console.error("Api call failed " + reason);
				});
		},

		Search: function(searchStr, assetCategory, optionable, fundamental, limit) {
			var config = {
				method: 'GET',
				url: '/search',
				params: {
					q: searchStr,
					assetCategory:assetCategory
				}
			};
			if ( optionable    ) { config.params.optionable = optionable; }
			if ( fundamental   ) { config.params.fundamental = fundamental; }
			if ( !isNaN(limit) ) { config.params.limit = limit; }
			return legacyAjaxHttpCall(config);
		},

		getUserSettings: function (category) {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: '/users/self/settings/' + category
			});
		},

		saveUserSettings: function (category, settings) {
			return legacyWrappedHttpCall({
				method: 'POST',
				url: '/users/self/settings/' + category,
				data: settings
			});
		},

		get: function (url) {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: url
			}, true);
		},

		CachedGet: function (url) {
			return legacyWrappedHttpCall({
				method: 'GET',
				url: url,
				cache: true
			}, true);
		},

		Post: function (url, body) {
			return legacyWrappedHttpCall({
				method: 'POST',
				url: url,
				data: body
			}, true);
		},

		put: function (url, body) {
			return legacyWrappedHttpCall({
				method: 'PUT',
				url: url,
				data: body
			}, true);
		},

		Delete: function (url) {
			return legacyWrappedHttpCall({
				method: 'DELETE',
				url: url
			}, true);
		},

		forexLink: function(){
			var forexLink =  '/users/self/ideas/forex';
			return Config.api_url() + forexLink;
		}
	};
}]);

/**
 * Created with JetBrains WebStorm.
 * User: Hosam Aly
 * Date: 2012-12-19
 * Time: 12:01 PM
 * To change this template use File | Settings | File Templates.
 */


'use strict';

/* Services */

recogniaApp.factory('Lexicon',
['$http', '$q', 'Config', 'REST',
function ($http, $q, Config, REST) {

	var translate,
		loadedNamespaces = [],
		DEFAULT_NAMESPACE = 'lexicon';

	function initializeLanguage(platformPath, language) {
		window.i18n.init(
			{
				useCookie: false,
				lowerCaseLng: true,
				lng: language,
				load: 'current',
				fallbackLng: false,
				resGetPath: platformPath + '/locales/__lng__/__ns__.json',
				getAsync: true,
				postProcess: 'sprintf',
				ns: {
					namespaces: [DEFAULT_NAMESPACE],
					defaultNs: DEFAULT_NAMESPACE
				},
				missingKeyHandler: function(lng, ns, key) {
					console.warn('Lexicon key not found: \''+key+'\' Language: '+lng);
				},
				customLoad: function (lng, ns, options, loadComplete) {
					// load the file for given language and namespace
					var config = {
						cache: true
					};

					$http.get(Config.baseFolder() + platformPath + '/locales/' + lng + '/' + ns + '.json', config).success(function (results) {
						// callback with parsed json data
						loadComplete(null, results);

					}, function (err) {
						loadComplete(err);
					});
				}
			},
			function (t) {
				window.i18n.loadNamespace(DEFAULT_NAMESPACE, function () {
					translate = t;

					loadedNamespaces[DEFAULT_NAMESPACE] = true;

					initDoneCallbacks.forEach(function (func){
						func();
					});
				});
			}
		);
	}


	var language,
		initLangPromises = [
			REST.Platform()
		];
	if (Config.languageWithLocale() !== undefined && Config.languageWithLocale() !== null && Config.languageWithLocale() !== ''){

		language = Config.languageWithLocale();

	} else {

		initLangPromises.push(
			REST.UserPreferencesCached().then(function (response) {
				Config.setLanguageFromRest(response.data.result.defaultLanguage);
				language = Config.languageWithLocale();
				return response;
			})
		);
	}
	$q.all(initLangPromises).then(function (responses){
		var platformPath = responses[0].data.result['rawResourcesPath'];
		initializeLanguage(platformPath, language);
	});

	var initDoneCallbacks = [];

	return {

		/**
		 * Returns a promise that resolves when the service has finished loading
		 */
		init: function () {
			var progress = $q.defer();
			if (translate !== undefined) {
				progress.resolve({});
			} else {
				initDoneCallbacks.push(function () { progress.resolve({}); });
			}
			return progress.promise;
		},

		/**
		 * Takes same arguments as the i18n.t() function, but assumes default
		 * namespace.
		 *
		 * Read the docs at http://i18next.com/
		 */
		translateDefaultNS: function(key) {
			if (translate === undefined) {
				console.error('Lexicon not yet initialized!');

			} else if (key.indexOf(':') !== -1){
				throw new Error('Invalid namespace for key: ' + key);

			} else {
				return translate.apply(this, arguments);
			}
		},

		/**
		 * Takes a parent object, a list of keys and returns a transated list
		 * assumming the default namespace.
		 * Any additional parameters are forwarded to the translate function.
		 *
		 * For documention of the translate function, See http://i18next.com/
		 */
		translateSetDefaultNS: function (parentObj, keyList) {
			var textList = [],
				extraArgs = [].slice.call(arguments, 2);
			for(var i = 0, l = keyList.length; i < l; i++){
				textList.push(
					this.translateDefaultNS(parentObj + '.' + keyList[i], extraArgs)
				);
			}
			return textList;
		}
	};
}]);

/**
 * Created with JetBrains WebStorm.
 * User: Hosam
 * Date: 2012-12-07
 * Time: 8:25 PM
 * To change this template use File | Settings | File Templates.
 */

'use strict';
// TODO this could be greatly improved by implementing the publish/subscribe pattern
recogniaApp.factory('Broadcast',
['$rootScope',
function ($rootScope) {

	return {
		CountryChangeMessage: 'country change',
		sendCountryChangeMessage : function (country) {
			$rootScope.$broadcast(this.CountryChangeMessage, country);
		},
		SETTINGS_CHANGED_MESSAGE: 'updateIdeas',
		sendSettingsChangedMessage : function (idea) {
			$rootScope.$broadcast(this.SETTINGS_CHANGED_MESSAGE, idea);
		}
	};
}]);


'use strict';

recogniaApp.factory('CriteriaApi',
	['REST',
	function (REST) {
		var criteriaAPI = {},
			backlogCallback = [],
			initalized = false;

		// Pre-load
		REST.Criteria().success(function (data) {
			var i, j;
			criteriaAPI.sectors = {};
			criteriaAPI.criteria = {};
			criteriaAPI.data = data.result;
			if (criteriaAPI.data.category !== undefined && criteriaAPI.data.category[0].criteria !== undefined) {
				for (j=0; j< criteriaAPI.data.category.length; j+=1) {
					for (i = 0; i < criteriaAPI.data.category[j].criteria.length; i+=1) {
						criteriaAPI.criteria[criteriaAPI.data.category[j].criteria[i].id] = criteriaAPI.data.category[j].criteria[i];
					}
				}
			}

			if (criteriaAPI.data.sectors !== undefined) {
				for (i = 0; i < criteriaAPI.data.sectors.length; i++) {
					criteriaAPI.sectors[criteriaAPI.data.sectors[i].id] = criteriaAPI.data.sectors[i];
				}
			}
			for (i=0; i<backlogCallback.length; i++) {
				backlogCallback[i](criteriaAPI);
			}
			backlogCallback = [];
			initalized = true;
		});

		return {
			getData: function (callback) {

				if (initalized === true) {
					callback(criteriaAPI);
				} else {
					backlogCallback.push(callback);
				}
			}
		};
	}]
);
'use strict';

recogniaApp.factory('D3Locale', ['Config', 'CriteriaApi', 'CommonConstants', 'Lexicon',
function (Config, CriteriaApi, CommonConstants, Lexicon) {
	// declare d3 locale
	var d3_locale = {};

	/**
	 * Get the d3 locale object for the language passed in
	 */
	function getD3Locale(languageCode) {
		if (typeof d3_locale[languageCode] === 'undefined') {
			d3_locale[languageCode] = d3.locale({
				decimal: Lexicon.translateDefaultNS('common.decimalSeperator'),
				thousands: Lexicon.translateDefaultNS('common.thousandsSeperator'),
				grouping: [3],
				currency: ["$", ""],
				dateTime: "%a %b %e %X %Y",
				date: "%m/%d/%Y",
				time: "%H:%M:%S",
				periods: [Lexicon.translateDefaultNS('common.AM'), Lexicon.translateDefaultNS('common.PM')],
				days: [Lexicon.translateDefaultNS('Sunday'), Lexicon.translateDefaultNS('Monday'), Lexicon.translateDefaultNS('Tuesday'), Lexicon.translateDefaultNS('Wednesday'), Lexicon.translateDefaultNS('Thursday'), Lexicon.translateDefaultNS('Friday'), Lexicon.translateDefaultNS('Saturday')],
				shortDays: [Lexicon.translateDefaultNS('common.Sun'), Lexicon.translateDefaultNS('common.Mon'), Lexicon.translateDefaultNS('common.Tue'), Lexicon.translateDefaultNS('common.Wed'), Lexicon.translateDefaultNS('common.Thu'), Lexicon.translateDefaultNS('common.Fri'), Lexicon.translateDefaultNS('common.Sat')],
				months: [Lexicon.translateDefaultNS('common.January'), Lexicon.translateDefaultNS('common.February'), Lexicon.translateDefaultNS('common.March'), Lexicon.translateDefaultNS('common.April'), Lexicon.translateDefaultNS('common.May'), Lexicon.translateDefaultNS('common.June'), Lexicon.translateDefaultNS('common.July'), Lexicon.translateDefaultNS('common.August'), Lexicon.translateDefaultNS('common.September'), Lexicon.translateDefaultNS('common.October'), Lexicon.translateDefaultNS('common.November'), Lexicon.translateDefaultNS('common.December')],
				shortMonths: [Lexicon.translateDefaultNS('common.Jan'), Lexicon.translateDefaultNS('common.Feb'), Lexicon.translateDefaultNS('common.Mar'), Lexicon.translateDefaultNS('common.Apr'), Lexicon.translateDefaultNS('common.May'), Lexicon.translateDefaultNS('common.Jun'), Lexicon.translateDefaultNS('common.Jul'), Lexicon.translateDefaultNS('common.Aug'), Lexicon.translateDefaultNS('common.Sep'), Lexicon.translateDefaultNS('common.Oct'), Lexicon.translateDefaultNS('common.Nov'), Lexicon.translateDefaultNS('common.Dec')]
			});
		}
		return d3_locale[languageCode];
	}

	function crosshairFormatter(language) {
		return getD3Locale(language).timeFormat.multi(
			[
				//Current year
				[Lexicon.translateDefaultNS('common.date-month'), function (d) {
					var today = new Date();
					return d.getFullYear() === today.getUTCFullYear();
				}],
				//Not in current year
				[Lexicon.translateDefaultNS('common.date-month-year'), function (d) {
					return d.getFullYear() !== (new Date()).getUTCFullYear();
				}]
			]);
	}

	function intradayCrosshairFormatter(language) {
		return getD3Locale(language).timeFormat.multi(
			[
				//if in current year and current day
				[Lexicon.translateDefaultNS('common.time'), function (d) {
					var today = new Date();
					return d.getFullYear() === today.getUTCFullYear() && d.getMonth() === today.getUTCMonth() && d.getDate() === today.getUTCDate();
				}],
				//Current year, not current day
				[Lexicon.translateDefaultNS('common.time-date-month'), function (d) {
					var today = new Date();
					return d.getFullYear() === today.getUTCFullYear();
				}],
				//Not in current year
				[Lexicon.translateDefaultNS('common.time-date-month-year'), function (d) {
					var today = new Date();
					return d.getFullYear() !== today.getUTCFullYear();
				}]
			]);
	}

	function numberFormatter(format,language) {
		return getD3Locale(language).numberFormat(format);
	}

	function timeFormatter(language) {
		return getD3Locale(language).timeFormat.multi(
			[
				[".%L", function (d) {
					return d.getMilliseconds();
				}],
				[":%S", function (d) {
					return d.getSeconds();
				}],
				["%b %d", function (d) {
					return d.getMinutes() == 45 && d.getHours() == 9;
				}],
				["%H:%M", function (d) {
					return d.getMinutes() || d.getHours();
				}],
				["%I %p", function (d) {
					return d.getHours();
				}],
				["%b %d", function (d) {
					return d.getDay() && d.getDate() != 1;
				}],
				["%b %d", function (d) {
					return d.getDate() != 1;
				}],
				["%B", function (d) {
					return d.getMonth();
				}],
				["%Y", function () {
					return true;
				}]
			]);
	}

	return {
		getD3Locale: getD3Locale,
		crosshairFormatter: crosshairFormatter,
		intradayCrosshairFormatter: intradayCrosshairFormatter,
		numberFormatter: numberFormatter,
		timeFormatter: timeFormatter
	}

}]);

/**
 * Created with JetBrains WebStorm.
 * User: aahmed
 * Date: 2/3/14
 * Time: 8:37 AM
 * To change this template use File | Settings | File Templates.
 */

'use strict';

recogniaApp.factory('ClientServices', [
	function () {
		return{
			getUserParameters: function () {
				return window.userParameters;
			}
		};
	}
]);
'use strict';

/**
 * This service provides methods to manipulate JSON objects
 */
recogniaApp.factory('JsonUtil', [function () {

	function deepExtend(destination, source) {
		for (var property in source) {
			if (source[property] && source[property].constructor &&
				source[property].constructor === Object) {
				destination[property] = destination[property] || {};
				deepExtend(destination[property], source[property]);
			} else {
				if (destination[property]===undefined) {
					destination[property] = source[property];
				}
			}
		}
		return destination;
	}

	function collapse(destination, source, omit) {

		Object.keys(source).forEach(function (property){

			// Skip the keys in omit if any exist
			var skip = false;
			if (omit !== undefined && omit !== null) {
				for (var omitKey in omit) {
					if (omitKey === property) {
						skip = true;
					}
				}
			}

			if (skip === false && typeof source[property] === 'object' && property !== '$$hashKey') {
				if (source[property] instanceof Array) {
					if (source[property][0] !== undefined && source[property][0]["linkId"] !== undefined) {
						destination[property] = [];
						for (var i=0; i<source[property].length; i++) {
							destination[property].push(source[property][i]["linkId"]);
						}
					} else {
						destination[property] = source[property];
					}
				} else {

					if (source[property] && source[property]["linkId"] && source[property]["resourceType"]) {
						destination[source[property]["resourceType"]] = source[property]["linkId"];
					} else {
						destination[property] = source[property];
					}
				}
			} else {
				destination[property] = source[property];
			}
		});
		return destination;
	}

	function objectSize(obj) {
		var size = 0, key;
		for (key in obj) {
			if (obj.hasOwnProperty(key)) size++;
		}
		return size;
	}

	return {


		/**
		 * Takes an objArray of objects and transforms it into a dictionary. The key to use is passed in. The
		 * resulting object uses the value of that key in each object.
		 */
		objArrayToDict: function (array, idKey) {
			if (!array){
				throw 'First argument must be a non-empty objArray';
			} else if (!idKey || typeof idKey !== 'string'){
				throw 'Second argument must be a string';
			}

			var dict = {}, index, key;
			for (index =0; index < array.length; index++){
				if (!array[index] || typeof array[index] !== 'object'){
					throw 'First argument must be an objArray of objects';
				} else if (!array[index].hasOwnProperty(idKey)){
					throw 'Each object in the objArray must have the key specified as the second argument';
				}
				key = array[index][idKey];
				dict[key] = array[index];
			}
			return dict;
		},


		/**
		 * Extends the destination object based on the data in the source
		 * @param destination
		 * @param source
		 * @returns {*}
		 */
		deepExtend: function (destination, source) {
			return deepExtend(destination, source);
		},

		/**
		 * Collapse the source object
		 * @param destination
		 * @param source
		 * @returns {*}
		 */
		collapse: function (destination, source, omit) {
			return collapse(destination, source, omit);
		},

		/**
		 * Return the number of nodes of an object
		 * @param object
		 * @returns {*}
		 */
		objectSize: function (obj) {
			return objectSize(obj);
		}

	};
}]);

/**
 * Created with JetBrains WebStorm.
 */

'use strict';

/* Services */
/* Allows to make calls on the public api */
recogniaApp.factory('LegacyApi', ['$http', 'Config', function ($http, Config) {
	var httpHeaders = {'If-Modified-Since': "0"};
	function ajaxUrl(command, parameters) {
		var url = './ajax.shtml?' + command +
			'&session_id=' + Config.getSessionId();
		if (typeof parameters !== 'undefined') {
			url += '&' + parameters;
		}

		return url;
	}

	return {
		/** Make a request to ajax.shtml for a public api */
		api: function (api, parameters) {
			return $http.get(ajaxUrl('_api=' + api, parameters), {headers: httpHeaders});
		},
		/** Make a request to ajax.shtml for a mason component */
		comp: function (component, parameters) {
			return $http.get(ajaxUrl('_comp=' + component, parameters), {headers: httpHeaders});
		}
	};
}]);

'use strict';

/*
 A service that defines chart types and any other constants used when using Price/Performance, etc. charts
 */

recogniaApp.factory('ChartConfig',
['NumberFormatter',
function (NumberFormatter) {
	// Get current year
	var date = new Date();

	return {

		Title: {
			EventTypeName: ''
		},

		Type: {
			Candlestick: 'candlestick',
			Bar: 'column',
			Ohlc: 'ohlc',
			Line: 'line'
		},

		// These map between a Key (represents how the series is used and referenced in the front-end, and the values that should be passed to the rest API
		Series: {
			Price: {
				Id: 0,
				yAxis: 0,
				Api: ['open', 'high', 'low' , 'close'],
				DefaultPlot: 'candlestick',
				Name: 'price'
			},
			Volume: {
				Id: 1,
				yAxis: 1,
				Api: ['volume'],
				DefaultPlot: 'bar',
				colorMethod: 'getChartVolumeSeriesColor',
				Name: 'volume'
			}
		},

		EventMarkup: {
			Region: {
				Name: 'Region',
				Id: 0
			},
			InboundTrendLines: {
				Name: 'Inbound Trend Lines',
				Id: 1
			},
			TargetPrice: {
				Name: 'Target Price',
				Id: 2
			},
			BollingerBands: {
				Name: 'Bollinger Bands',
				Id: 3
			},
			EventMarker: {
				Name: 'Event Markers',
				Id: 4
			}
		},

		MarkersList: {
			LastPrice: 0,
			EventClosePrice: 1,
			EventTargetPrice: 2,
			VolumeName: 3,
			TargetProfit: 5
		},

		Markers: {
			LastPrice: function (value, instrument, name) {
				return {
					Id: 0,
					Value: value,
					FormattedValue: NumberFormatter.formatCurrency(value,instrument),
					Align: "left",
					drawMarkerLine: true,
					Name: name,
					ValueStyle: 'chart-lastprice',
					NameStyle: 'chart-last-price-numeric',
					LegendStyle: 'chart-marker-legend-lastprice'
				};
			},
			EventClosePrice: function (value, instrument, isBull, name) {
				return {
					Id: 1,
					Value: value,
					FormattedValue: NumberFormatter.formatCurrency(value,instrument),
					Align: "left",
					drawMarkerLine: true,
					Name: name,
//					ValueStyle: (isBull) ? 'chart-eventclose_bull' : 'chart-eventclose_bear',
					ValueStyle: 'chart-eventclose-value',
					NameStyle: 'chart-marker-text',
					LegendStyle: 'chart-marker-legend-text'
				};
			},
			EventTargetPrice: function (value,name) {
				return {
					Id: 2,
					Value: value, // Target Range (type: String)
					FormattedValue: value,
					Align: "right",
					drawMarkerLine: false,
					Name: name,
					ValueStyle: 'chart-marker-target-value',
					NameStyle: 'chart-marker-target-text',
					LegendStyle: 'chart-marker-legend-text'
				};
			},
			VolumeName: function(name) {
				return {
					Id: 3,
					Value:' ',
					FormattedValue:' ',
					Align: "left",
					drawMarkerLine: false,
					Name: name,
					NameStyle: '',
					LegendStyle: 'chart-marker-legend-text'
				};
			},
			EventName: function (value, instrument, isBull, name) {
				return {
					Id: 4,
					Value: value,
					FormattedValue: NumberFormatter.formatCurrency(value,instrument),
					Align: "left",
					drawMarkerLine: false,
					Name: name,
					ValueStyle: (isBull) ? 'chart-eventclose_bull' : 'chart-eventclose_bear',
					NameStyle: 'chart-marker-text',
					LegendStyle: 'chart-marker-legend-text'
				};
			}
		},

		// Markers for OptionsIdeas Target Profit
		OptionsMarkers: {
			TargetProfit: function (date, value, target, eventDate, expiryText, expiryDateStr) {
				return {
					Id: 5,
					Value: value,				// Target Profit in percentage (type: String)
					FormattedValue: value,
					Date: date,
					Target: target,
					EventDate: eventDate,
					Expiry: expiryText,
					DrawBackground: true, // green padding
					ExpiryDateStr: expiryDateStr,
					ValueStyle: 'chart-target-profit-text',
					DateStyle: 'chart-target-profit-date',
					DateRectStyle: 'chart-target-profit-date-rect',
					ValueBubbleStyle: 'chart-target-profit-bubble',
					PointerArrowStyle: 'chart-target-profit-pointer-arrow',
					PointerLineStyle: 'chart-target-profit-pointer-line',
					PointerCrossStyle: 'chart-target-profit-pointer-cross',
					PaddingStyle: 'chart-target-profit-padding'
				};
			}
		},

		// Used by all charts in the front-end
		DefaultConfig: {
			chart: {
				spacingBottom: 20,
				borderRadius: 0,
				pinchType : 'none',
				reflow:false
			},
			legend: {
				enabled: false
			},
			scrollbar: {
				enabled: false
			},
			rangeSelector: {
				enabled: false
			},
			useHighStocks: true,

			credits: {
				text: '© ' + date.getFullYear() + ' TRADING CENTRAL',
				href: 'https://www.tradingcentral.com',
				style:{direction:'ltr'},
				position: {
					y: -10 // position the copyright close to the x-axis
				}
			},
			plotOptions: {
				series: {
					marker: {
						enabled: false // show line points or not
					}
				}
			},
			exporting: {
				enabled: false
			},
			yAxis: {
				opposite: false
			}

		},

		DefaultConstants: {
			NavigatorHeight: 40,
			ChartTopSpacing: 10,
			SectionSpacing: 10
		}

	};

}]);


/**
 * Created with JetBrains WebStorm.
 * User: Pengfei
 * Check browser is IE8
 */

'use strict';
recogniaApp.factory('CheckIE8', ['$window',
	function ($window) {
		return{
			isIE8: function () {
				return !document.addEventListener;
			},
			isIE: function(){
				return (/trident/i).test ($window.navigator.userAgent);
			}
		};
	}
]);
'use strict';
// These are global constants for the client side
recogniaApp.factory('HighChartsUtils',
['DateFormatter', 'CommonConstants', 'Lexicon',
function (DateFormatter, CommonConstants, Lexicon) {
	return {

		// this function is to transform Performance timestamp and data arraies into
		// one two dimenstional array i.e. [[ts1, data1],[ts2, data2]]
		transformPerformanceData: function (arrayTime, arrayData) {
			if (!arrayTime || !arrayData) {
				throw 'Input array must be a non-empty objArray';
			}
			var chartData = [], index, ms;
			for (index = 0; index < arrayTime.length; index++) {
				ms = DateFormatter.getEpoch(arrayTime[index]);
				chartData[index] = [ms, parseFloat(arrayData[index]) * 100];
			}
			return chartData;
		},

		/** transform the timeseries data into chart data
		 *
		 * also find out the price and volume Max and Min values
		 **/
		buildChartData: function (data, series, referenceDate) {
			var chartData = [], index, seriesIndex, seriesEntryIndex, date, seriesEntry, referenceDateIndex;

			if (data !== null) {
				for (seriesIndex = 0; seriesIndex < series.length; seriesIndex += 1) {
					chartData[seriesIndex] = [];
				}

				for (index = 0; index < data.timestamp.length; index += 1) {

					// Parse the date
					date = DateFormatter.getEpoch(data.timestamp[index]);
					if (referenceDate === date) {
						// Identify which index is the reference date
						referenceDateIndex = index;
					}

					for (seriesIndex = 0; seriesIndex < series.length; seriesIndex += 1) {
						// Each series should have a date
						seriesEntry = [date];

						// Loop through all parameters of the series to add its data
						for (seriesEntryIndex = 0; seriesEntryIndex < series[seriesIndex].series.Api.length; seriesEntryIndex += 1) {
							seriesEntry.push(parseFloat(data[series[seriesIndex].series.Api[seriesEntryIndex]][index]));
						}
						chartData[seriesIndex].push(seriesEntry);
					}
				}
			}
			return {
				data: chartData,
				referenceDateIndex: referenceDateIndex
			};
		},

		// by passing into the event markup object
		// the fuction will return markup extent for yAxis and xAxis
		getMarkupExtent: function (markup) {
			var markupExtent = {}, date, val;
			if (markup.length > 0 && markup[0].points!==undefined && markup[0].points.length>0) {

				markupExtent.yAxisMax = parseFloat(markup[0].points[0][1]);
				markupExtent.yAxisMin = parseFloat(markup[0].points[0][1]);
				markupExtent.xAxisMin = DateFormatter.getEpoch(markup[0].points[0][0]);
				markupExtent.xAxisMax = DateFormatter.getEpoch(markup[0].points[0][0]);

				markup.map (function (eachMarkup) {

					if (eachMarkup.category !== 'trend') {
						eachMarkup.points.map (function (point) {
							date = DateFormatter.getEpoch(point[0]);
							markupExtent.xAxisMin = Math.min (date, markupExtent.xAxisMin);
							markupExtent.xAxisMax = Math.max (date, markupExtent.xAxisMax);

							val = parseFloat(point[1]);
							markupExtent.yAxisMin = Math.min(val, markupExtent.yAxisMin);
							markupExtent.yAxisMax = Math.max(val, markupExtent.yAxisMax);
						});
					}

				});
			}
			return markupExtent;
		},

		// Used by Chart to adjust x-axis
		// Set Total Bars to Request
		getBars: function (event,idea) {
			var forwardBars,
				backwardBars,
				count,
				eventTypeId = event.eventType.eventTypeId,
				eventClass = event.eventType['class'],
				eventClose,
				eventCloseDate,
				patternDuration = event.dates.duration,
				tradeLegs,
				trendDuration = event.dates.trendDuration,
				todayDate,
				patternAndTrentDuration = patternDuration + trendDuration,
				barsInAMonth = 21,
				bars = {};

			if (idea.ideaType !== 'option')  {
				if (eventClass === CommonConstants.EVENT_CATEGORY.shortterm && eventTypeId !== "islandTop" && eventTypeId !== "islandBottom") {
					backwardBars = barsInAMonth * 3;
					forwardBars = 15;
				} else if (eventClass === CommonConstants.EVENT_CATEGORY.classic || (eventClass === CommonConstants.EVENT_CATEGORY.shortterm && ((eventTypeId === "islandTop") || (eventTypeId === "islandBottom")))) {
					if (patternAndTrentDuration <= 50) {
						backwardBars = barsInAMonth * 3;
						forwardBars = 15;
					}
					else if (patternAndTrentDuration <= 100) {
						backwardBars = barsInAMonth * 6;
						forwardBars = patternDuration;
					}
					else if (patternAndTrentDuration <= 150) {
						backwardBars = barsInAMonth * 9;
						forwardBars = patternDuration;
					}
					else if (patternAndTrentDuration <= 200) {
						backwardBars = barsInAMonth * 12;
						forwardBars = patternDuration;
					}
					else if (patternAndTrentDuration <= 300) {
						backwardBars = barsInAMonth * 18;
						forwardBars = patternDuration;
					}
					else {
						backwardBars = barsInAMonth * 24;
						forwardBars = patternDuration;
					}
				}
			} else {
				tradeLegs = idea.trade.legs;
				Object.keys(tradeLegs).forEach(function (legType) {
					if (tradeLegs[legType].instrument['resourceType'] === 'optionsContract' && count === undefined) {
						count = 0;
						backwardBars = barsInAMonth * 9;

						todayDate = new Date().getTime();
						eventCloseDate = event.dates.eventEnd;
						eventClose = DateFormatter.getEpoch(eventCloseDate);
						eventCloseDate = new Date(eventClose);

						while (eventClose <= todayDate) {
							eventClose = eventCloseDate.setDate(eventCloseDate.getDate() + 1);
							eventCloseDate = new Date(eventClose);
							if ( (eventCloseDate.getDay() === 6) || (eventCloseDate.getDay() === 0) ) {
								continue;
							}
							count++;
						}
						forwardBars = count;
					}
				});
			}

			bars.forward = forwardBars;
			bars.backward = backwardBars;
			bars.backwardBuffer = bars.backward * 3; // for initial query
			bars.forwardBuffer = bars.forward * 3; // for initial query

			return bars;
		},

		/**
		 * @param timeSeries
		 * @param eventCloseDate
		 * @param targetExpiryDate
		 * @returns mockData
		 */
		appendExtraTimeSeries: function(timeSeries, eventCloseDate, targetExpiryDate) {

			var priceMock = [], volumeMock=[], mockData = {};

			mockData.referenceDateIndex = timeSeries.referenceDateIndex;

			var todayDate = new Date().getTime();
			var lastDateEpoch = timeSeries.data[0][timeSeries.data[0].length-1][0];
			var lastDate = new Date(lastDateEpoch);
			var thisDate = lastDateEpoch;
			var expiryDate = DateFormatter.getEpoch(targetExpiryDate + 'T00:00:00');
			var count = 1;

			// Add entries to priceMock and volumeMock for as long as thisDate is less
			// than the options expityDate. Skipping Saturdays and Sundays.
			while (thisDate < expiryDate || thisDate < todayDate) {
				thisDate = lastDate.setDate(lastDate.getDate() + 1);
				lastDate = new Date(thisDate);
				if ( (lastDate.getDay() === 6) || (lastDate.getDay() === 0) ) {
					continue;
				}
				priceMock.push([thisDate,null,null,null,null]);
				volumeMock.push([thisDate,null]);
				count++;
			}

			// find the index of event close date in allData &
			// get the days count between event close and expiry date.
			var eventClose = DateFormatter.getEpoch(eventCloseDate);
			var eventExpiryDays=0;
			for (var j=0; j<timeSeries.data[0].length; j++) {
				if (eventClose === timeSeries.data[0][j][0]) {
					eventExpiryDays = timeSeries.data[0].length - j + count;
					break;
				}
			}

			// Forwarding padding is one-fourth of the distance b/w eventClose date and expiry.
			var expiryDateObj = new Date(expiryDate);
			if (priceMock.length > 0) {
				for (var i = 1; i < eventExpiryDays / 4; i++) {
					var extraDate = expiryDateObj.setDate(expiryDateObj.getDate() + 1);
					expiryDateObj = new Date(extraDate);
					if (priceMock[priceMock.length - 1][0] >= extraDate) {
						continue;
					}
					priceMock.push([extraDate, null, null, null, null]);
					volumeMock.push([extraDate, null]);
				}
			}

			mockData.data = [];
			mockData.data[0] = timeSeries.data[0].concat(priceMock);
			mockData.data[1] = timeSeries.data[1].concat(volumeMock);

			return mockData;
		},

		getLexiconLastPrice: function (priceObject) {
			switch (priceObject.dataType) {
				case CommonConstants.PRICE_DATA_TYPES.tick:
					return Lexicon.translateDefaultNS('optionsProfitLossChart.price-at-time',
						{
							time: DateFormatter.formatTime(DateFormatter.parseDate(priceObject.timestamp), false)
						}
					);
				case CommonConstants.PRICE_DATA_TYPES.close:
					return Lexicon.translateDefaultNS('optionsProfitLossChart.last-close');
			}
		}
	};
}]);

'use strict';
/*
 * Provides access to chart styles set in the css which are set by less
 * variables configurable per customer
 */
recogniaApp.factory('HighChartsTheme',
['$window', '$q', '$rootScope',
function ($window, $q, $rootScope) {

	/**
	 * Have to make sure css is loaded before any charts configured
	 *
	 * Current method of adding a customizable color:
	 * - Color variables are defined in chart_variables.less
	 * - Used in a style in chart_styles.less
	 * - An span is place in the DOM with this style and given an id
	 * - The HighChartsTheme service uses jquery to select the span and access
	 *   the css property
	 * - Various chart configs use the HighChartsTheme to get colors.
	 *
	 * Side note: If chart styles were built into javascript at grunt build time
	 * or something similar there would be no need for this
	 */
	var ready = $q.defer();
	var endCssWatch = $rootScope.$watch(
		function (){
			if ($window.RecogniaResourceLoader !== undefined)
				return $window.RecogniaResourceLoader.loaded;
			else
				return $('.recognia').length > 0;
		},
		function (newVal){
			if (newVal === true){
				ready.resolve();
				endCssWatch();
			}
		}
	);

	return {
		init: function () {
			var progress = $q.defer();
			ready.promise.then(function(){
				progress.resolve();
			});
			return progress.promise;
		},
		// return background color
		chartBG: function () {
			return $( "#chartBackground" ).css( "background-color" );
		},
		// return X/Y Axis gridline color
		chartGL: function () {
			return $( "#chartGridline" ).css( "color" );
		},
		chartMinorGridlineColor: function () {
			return $( "#chartMinorGridline" ).css( "color" );
		},
		// return xAxis line color
		chartXL: function () {
			return $( "#chartxAxisline" ).css( "color" );
		},
		// return title color
		chartTitle: function () {
			return $( "#chartTitleColor" ).css( "color" );
		},
		// return tlabel color
		chartLabel: function () {
			return $( "#chartLabelColor" ).css( "color" );
		},
		// return legend color
		chartLegend: function () {
			return $( "#chartLegendColor" ).css( "color" );
		},
		// return tick color
		chartTick: function () {
			return $( "#chartTickColor" ).css( "color" );
		},
		// return series color
		chartSC: function () {
			return $( "#seriesColor" ).css( "color" );
		},
		// return volume background color
		chartVB: function () {
			return $( "#volumeColor" ).css( "color" );
		},
		// return navigator background color
		chartNB: function () {
			return $( "#navigatorColor" ).css( "color" );
		},
		// return navigator outline color
		chartNBOL: function () {
			return $( "#navigatorOutlineColor" ).css( "color" );
		},
		// return tooltip background color
		chartTTBG: function () {
			return $( "#chartTTBackground" ).css( "background-color" );
		},
		// return tooltip border color
		chartTTBC: function () {
			return $( "#chartTTBorderColor" ).css( "color" );
		},
		// return tooltip font color
		chartTTFC: function () {
			return $( "#chartTTFontColor" ).css( "color" );
		},
		// return backtesting strategy series color
		strategyTS: function () {
			return $( "#seriesStrategy" ).css( "color" );
		},
		// return backtesting stop series color
		stopTS: function () {
			return $( "#seriesStop" ).css( "color" );
		},

		// return marker element's dark color
		chartMarkerDark: function () {
			return $( "#chartMarkerDark" ).css( "color" );
		},

		// return marker element's light color
		chartMarkerLight: function () {
			return $( "#chartMarkerLight" ).css( "color" );
		},

		// return marker element's bullish color
		chartMarkerBullish: function () {
			return $( "#chartMarkerBullish" ).css( "color" );
		},

		// return marker options target profit background color
		chartMarkerTargetProfitBackground: function () {
			return $( "#chartMarkerTargetProfitBackground" ).css( "color" );
		},

		// return marker options target profit background color
		chartProfitLossStrikePrice: function () {
			return $( "#chartProfitLossStrikePrice" ).css( "color" );
		},

		// return marker options target profit background color
		chartProfitLossTargetPrice: function () {
			return $( "#chartProfitLossTargetPrice" ).css( "color" );
		},

		chartOplLastPriceColor: function () {
			return $("#chartOplLastPriceColor").css("color");
		},

		chartProfitLossFontColor: function () {
			return $( ".headerTitle" ).css( "color" );
		},

		chartProfitLossBGColor: function () {
			return $( ".headerTitle" ).css( "background-color" );
		},

		chartProfitLossLineColor: function () {
			return $( "#chartProfitLossLine" ).css( "color" );
		},

		chartProfitLossLineHighlightColor: function () {
			return $( "#chartProfitLossLineHighlightColor" ).css( "color" );
		},

		chartOPLTooltip: function () {
			var _elem = $("#chartOPLTooltip");
			return {
				bgColor: _elem.css("background-color"),
				textColor: _elem.css("color")
			};
		},

		chartAxisTitleColor: function () {
			return $( "#chartAxisTitle" ).css( "color" );
		},

		chartBorderColor: function(){
			return $( "#chartBorderColor" ).css( "color" );
		},

		getChartTargetProfitTextProperty: function(property){
			return $('#chartTargetProfitText').css(property);
		},

		getChartMarkerLegendTextProperty: function(property){
			return $('#chartMarkerLegendText').css(property);
		},

		getChartMarkerTargetValueProperty: function(property){
			return $('#chartMarkerTargetValue').css(property);
		},

		getChartLastPriceNumericProperty: function(property){
			return $('#chartLastPriceNumeric').css(property);
		},

		getChartVolumeSeriesColor: function(){
			return $('#chartVolumeSeries').css('color');
		},

		getChartMarkerTextFontSize: function(){
			return $('#chartMarkerText').css( "font-size" );
		}
	};
}
]);
'use strict';

recogniaApp.factory('NumberFormatter', ['Config', 'CriteriaApi', 'CommonConstants', 'Lexicon', 'D3Locale',
function (Config, CriteriaApi, CommonConstants, Lexicon, D3Locale) {

	var criteriaAPIData,
	SMALLEST_NUMBER = 0.00001,

	PERCENT_DECIMAL_THRESHOLD = 9.95,
	PERCENT_PRECISION_RANGES = [
		new NumberRange(SMALLEST_NUMBER, false, PERCENT_DECIMAL_THRESHOLD, false),
		new NumberRange(-1*PERCENT_DECIMAL_THRESHOLD, false, -1*SMALLEST_NUMBER, false)
	],
	PERCENT_OPPOSITE_SIDE_LANGS = [
		CommonConstants.LANGUAGE_MAP.tr
	],
	RTL_LANGS = [
		CommonConstants.LANGUAGE_MAP.ar
	],

	SHORT_FORMAT = "ENABLE_SI_SYMBOLS",
	LONG_FORMAT = "DISABLE_SI_SYMBOLS",

	DATA_TYPE = {
		real: "REAL",
		integer: "INTEGER"
	},

	SI_SYMBOL = {
		million: 'M',
		billion: 'B',
		trillion: 'T'
	},

	UNIT = {
		currency: "CURRENCY"
	},

	// DO NOT modify criterion constants as they are API dependent.
	CRITERION_TYPE = {
		real: "real",
		integer: "integer",
		percent: "percent",
		currency: "currency"
	},
	DEFAULT_FLOAT_PRECISION = 2;


	var PRICE_PRECISIONS = {
		DEFAULT: 2,
		EXCHANGE: {
			'BHD': 3,
			'OMR': 3,
			'HKD': 3
		},
		INSTRUMENT_TYPE: {
			'currency': 4
		}
	};
	var CURRENCY_SYMBOLS = {
		'USD': '$',
		'CAD': '$'
	};
	var CUR_SYMBOL_AFTER_LANGS = ['fr'];

	// default parameters
	var DEFAULT_SCIENTIFIC_NOTATION_PRECISION = 3;

	// factory of different formats
	var FORMAT_FACTORY = {
		currency : {},
		integer : {},
		real : {}
	}

	/**
	 *
	 * @param num
	 * @param unit
	 * @param formatType
	 * @param dataType
	 * @param instrument
	 * @returns {Number}
	 *
	 * Determine number precision based on unit, formatType, dataType & currency
	 * (derived from instrument)
	 */
	function roundNumber (num, unit, formatType, dataType, instrument) {
		var negative = false,
			decimalPlaces,
			precision;

		num = parseFloat(num);
		if (isNaN(num)) {
			return num;
		}

		if (num < 0) {
			negative = true;
			num = Math.abs(num);
		}

		if ((instrument !== "" &&
				instrument !== null &&
				instrument !== undefined &&
				instrument['resourceType'] === 'instrument' &&
				instrument.currencySymbol !== '' &&
				instrument.currencySymbol !== undefined)
			&&
			((num > 0 && num < 0.01) ||
				instrument.currencySymbol === 'BHD' ||
				instrument.currencySymbol === 'OMR' ||
				instrument.currencySymbol === 'HKD' ||
				instrument.type === 'currency')
			&&
			formatType === LONG_FORMAT) {

			if (instrument.type === 'currency') {
				num = num.toFixed(4);
			}
			else {
				num = num.toFixed(3);
			}

		} else if (num < 0.0999) {
			if (dataType === DATA_TYPE.real) {
				num = num.toFixed(2);
			} else {
				num = 0;
			}

		} else if (num < 0.999) {
			if (dataType === DATA_TYPE.real) {
				num = num.toFixed(2);
			} else {
				num = 0;
			}

		} else if (num < 9.999) {
			if (dataType === DATA_TYPE.real) {
				num = num.toFixed(2);
			} else {
				num = Math.round(num);
			}

		} else if (num < 99.999) {
			if (dataType === DATA_TYPE.real) {
				if (unit === UNIT.currency) {
					num = num.toFixed(2);
				} else {
					num = num.toFixed(1);
				}
			} else {
				num = Math.round(num);
			}
		} else {
			if (formatType === SHORT_FORMAT) {
				num = Math.round(num);

			} else if (formatType === LONG_FORMAT) {

				if ((parseFloat(num) - Math.floor(num) === 0) &&
						(Math.abs(parseFloat(num)) >= 100)) {
					num = Math.floor(num);
				}
				num = num.toFixed(2);
			}
		}

		if (negative) {
			decimalPlaces = 0;
			precision = num.toString().split(".")[1];
			if (precision !== undefined) {
				decimalPlaces = precision.length;
			}
			num *= -1;
			num = num.toFixed(parseFloat(decimalPlaces));
		}
		return num;
	}

	/**
	 *
	 * @param nStr
	 * @param lang
	 * @returns {string}
	 *
	 * Add seperator based on language.
	 */
	function thousandSeparator (nStr) {
		var seperator = ',', x, x1, x2, rgx, num;

		if (Config.language() === CommonConstants.LANGUAGE_MAP.fr) {
			seperator = ' ';
		}

		nStr += '';
		x = nStr.split('.');
		x1 = x[0];
		x2 = x.length > 1 ? '.' + x[1] : '';
		rgx = /(\d+)(\d{3})/;
		while (rgx.test(x1)) {
			x1 = x1.replace(rgx, '$1' + seperator + '$2');
		}
		num = x1 + x2;

		// Replace '.' with ',' for french
		if (Config.language() === CommonConstants.LANGUAGE_MAP.fr) {
			num = num.toString().replace('.', ',');
		}
		return num;
	}

	/**
	 *
	 * @param num
	 * @param si_symbol
	 * @returns {string}
	 *
	 * Replace zeros with coresponding SI Symbols (e.g: M for million, B for billion, T for trillion)
	 */
	function formatBigNumber (num) {
		var zeros,
		pos,
		si_symbol;
		if (Math.abs(parseFloat(num)) >= 1000000000000) {
			si_symbol = SI_SYMBOL.trillion;
			zeros = 12;
		} else if (Math.abs(parseFloat(num)) >= 1000000000) {
			si_symbol = SI_SYMBOL.billion;
			zeros = 9;
		} else if (Math.abs(parseFloat(num)) >= 1000000) {
			si_symbol = SI_SYMBOL.million;
			zeros = 6;
		} else {
			return thousandSeparator(num);
		}

		num = num.toString();

		pos = num.indexOf('.');
		if (pos === -1) {
			num = num.substring(0, num.length - zeros) + '.' + num.substring(num.length - zeros);
		} else {
			num = num.replace('.', '');
			num = num.substring(0, pos - zeros) + '.' + num.substring(pos - zeros);
		}
		num = Math.round(num * 100) / 100;
		var fmted = parseFloat(num).toString() + si_symbol;
		if (Config.language() === CommonConstants.LANGUAGE_MAP.fr) {
			fmted = fmted.replace('.', ',');
		}
		return fmted;

	}

	/**
	 * Format a value passed in with the given precision
	 * @param value - value to format
	 * @param factoryKey - key for the factory hash where to save the d3 numberFormat
	 * @param format - Pass the format which will be used to format the value
	 */
	function formatNumber(value, factoryKey, format) {
		var result = '';
		var num = parseFloat(value);

		if (!isNaN(num)) {
			var key = Config.languageCode() + '-' + format;
			if (typeof FORMAT_FACTORY[factoryKey][key] === 'undefined') {
				FORMAT_FACTORY[factoryKey][key] = D3Locale.numberFormatter(format,Config.languageCode());
			}
			result = FORMAT_FACTORY[factoryKey][key](num);
		}
		return result;
	}

	/**
	 * This method will take in a number and format the number from d3 scientific notation
	 * to our currency scientific notation.
	 * @param x
	 * @returns {*}
	 */
	function formatAbbreviation(s) {
		switch (s[s.length - 1]) {
			case "G": return s.slice(0, -1) + "B";
		}
		return s;
	}

	/**
	 * Pre-load Criteria Data
	 */
	CriteriaApi.getData(function (criteriaAPI) {
		criteriaAPIData = criteriaAPI;
	});

	var nf = {

		formatCriterion: function (criterion, value, precision) {
			var criterionId = criterion.id, criterionValue, formatterToCall;

			if (value !== undefined && value !== null && value !== '') {
				criterionValue = value;
			}
			else {
				criterionValue = criterion.value;
			}

			if (criteriaAPIData !== undefined && criteriaAPIData !== ''
					&& criteriaAPIData.criteria[criterionId] !== undefined) {

				formatterToCall = criteriaAPIData.criteria[criterionId].type;
				if (formatterToCall === CRITERION_TYPE.integer) {
					return nf.formatInteger(criterionValue);
				}
				else if (formatterToCall === CRITERION_TYPE.percent) {
					return nf.percentInTextBlock(criterionValue);
				}
				else if (formatterToCall === CRITERION_TYPE.real || formatterToCall === CRITERION_TYPE.currency) {
					return nf.formatCurrencyShort(criterionValue,precision);
				}
			}
		},

		/**
		 * Format currency normally or in scientific notation depending on how big the value is
		 * @param sign - if true, show sign even for positive number
		 */
		formatCurrencyShort: function (value, precision, sign) {
			var result = '';
			var num = parseFloat(value);

			// TODO remove when there is enough confidence
			if (isNaN(precision)) {
				console.log("formatCurrencyShort: precision missing");
			}

			if (!isNaN(num) && !isNaN(precision))  {
				// if the number is bellow 1 million, format it as a normal currency,
				// else format the number in scientific notation.
				// This is done to be consistent with google finance
				if (num <= 0.999999e6) {
					result = nf.formatCurrency(num,precision,sign);
				} else {
					result = nf.formatScientificNotation(num,DEFAULT_SCIENTIFIC_NOTATION_PRECISION,sign);
				}
			}
			return result;
		},

		/**
		 * Format the number in scientific notation, using the given precision
		 * @param sign - if true, show sign even for positive number
		 */
		formatScientificNotation: function (value, precision, sign) {
			// TODO remove when there is enough confidence
			if (isNaN(precision)) {
				console.log("formatScientificNotation: precision missing");
			}

			var format = '.' + precision + 's';
			if (sign) format = '+' + format;
			var result = formatNumber(value, 'currency', format);
			return formatAbbreviation(result);
		},


		/**
		 * Pass in value and precision to format it to a currency
		 * @param value - value to format
		 * @param precision - precision for formatted value
		 * @param sign - if true, show sign even for positive number
		 */
		formatCurrency: function (value, precision, sign) {
			// TODO remove when there is enough confidence
			if (isNaN(precision)) {
				console.log("formatCurrency: precision missing");
			}

			var format = ',.' + precision + 'f';
			if (sign) format = '+' + format;
			return formatNumber(value, 'currency', format);
		},

		/**
		 * Formats a number rounded to a specified number of decimal places.
		 * Default precision is 2. Formats by locale set in the Config.
		 * If the value isn't a number, returns an empty string.
		 * @param sign - if true, show sign even for positive number
		 */
		formatReal: function(value, precision, sign) {
			// TODO remove when there is enough confidence
			if (isNaN(precision)) {
				console.log("formatReal: precision missing");
			}

			var format = ',.' + precision + 'f';
			if (sign) format = '+' + format;
			return formatNumber(value, 'real', format);
		},

		formatInteger: function (value) {
			var num = parseInt(value, 10);
			if (!isNaN(num)) {
				var number = parseFloat(roundNumber(num, null, SHORT_FORMAT, DATA_TYPE.integer, null));
				return formatBigNumber(number);
			}
			return "";
		},

		/**
		 * Formats a number in abbreviated form if it is greater that 1 million.
		 * Otherwise format as normal. Will be rounded to a specificed number of
		 * decimal places. Default precision is 2. Format is locale specific by
		 * locale set in the Config.
		 * If the value isn't a number, returns an empty string.
		 */
		abbreviated: function(value, precision) {
			if (precision === undefined) precision = DEFAULT_FLOAT_PRECISION;
			var num = parseFloat(value);
			if (!isNaN(num)) {
				return formatBigNumber(num.toFixed(precision));
			}
			return '';
		},

		/**
		 * Formats a number as a percent rounded to a specificed number of
		 * decimal places. If number of decimal places is not specified will use
		 * zero places, unless the number is between -9.5 and 9.5, in that case
		 * will use precision of 2.
		 *
		 * Format is locale specific by locale set in the Config.
		 *
		 * @arg {Number} value - Value to be formatted
		 * @arg {Number} [decimalPlaces=] - Override number of decimal places
		 *
		 * @arg {Object}  [options={}]
		 * @arg {Boolean} options.explicitSign - Explicitly show the sign (+/-)
		 * @arg {Boolean} options.inTextBlock - For rtl languages, the percent
		 *   is reflowed differently if in a block of text vs on it's own.
		 * @arg {Number}  options.lessThanThreshold - If defined, the value will
		 *   be expressed as <{threshhold}% when the value is smaller than the
		 *   given threshold. Acts symmetrically if the value is negative.
		 *   If the value is actually zero, with return 0% instead of <X%.
		 *
		 * @returns {String} - A number formatted as a percent. If the value
		 *   isn't a number, returns an empty string.
		 */
		percent: function (value, decimalPlaces, options) {
			// default to empty if not set so we don't have to check multiple times later
			if (!options)
				options = {};

			var num = parseFloat(value);
			if (isNaN(num)) {
				return '';
			}
			// convert from decimal to percent
			num = (num * 100);

			var fmted;
			var belowThreshold = false;

			if (options.lessThanThreshold !== undefined){
				if (isNaN(options.lessThanThreshold) || options.lessThanThreshold <= 0){
					throw 'Invalid threshold: \'' + options.lessThanThreshold
						+ '\'. Should be a small positive number';
				}
				if (num !== 0 && num > -1*options.lessThanThreshold && num < options.lessThanThreshold){
					fmted = (num > 0) ? options.lessThanThreshold : -1*options.lessThanThreshold;
					belowThreshold = true;
				}
			}

			// if number wasn't in the lessThanThreshold, or threshold not set
			if (!belowThreshold){
				// if places not specified, use special check for small numbers
				if (decimalPlaces === undefined) {
					if (PERCENT_PRECISION_RANGES[0].contains(num)
							|| PERCENT_PRECISION_RANGES[1].contains(num)){
						fmted = num.toPrecision(2);
					} else {
						decimalPlaces = 0;
					}
				}
				// if value wasn't 'small' then round to decimalPlaces
				if (fmted === undefined){
					fmted = num.toFixed(decimalPlaces);
				}
			}

			// Add thousands seperators if needed and localize the decimal separator
			fmted = thousandSeparator(fmted);
			if (options.explicitSign && num > 0){
				fmted = '+' + fmted;
			}

			// depending on language/locale, add a percent sign on left/right
			// also, if rtl language, have to check if negative/explicitSign because %-25 will
			// reflow with css direction rtl to 25-% instead of the desired %25-
			if (PERCENT_OPPOSITE_SIDE_LANGS.indexOf(Config.languageCode()) !== -1 ||
					(RTL_LANGS.indexOf(Config.languageCode()) !== -1 && !options.inTextBlock)){

				if(num < 0 || (options.explicitSign && num > 0)){
					fmted = fmted.slice(0,1) + '%' + fmted.slice(1);
				} else {
					fmted = '%' + fmted;
				}
			}
			// normal case percent is on the right
			else {
				fmted = fmted + '%';
			}

			if (belowThreshold){
				fmted = '< '+ fmted;
			}
			return fmted;
		},

		/**
		 * Forwards to the percent method with the explicitSign flag set
		 */
		percentWithSign: function (value, decimalPlaces) {
			return nf.percent(value, decimalPlaces, {explicitSign: true});
		},

		/**
		 * Forwards to the percent method with the lessThanThreshold set
		 */
		percentWithLessThanThreshold: function (value, decimalPlaces, lessThanThreshold) {
			return nf.percent(value, decimalPlaces, {lessThanThreshold: lessThanThreshold});
		},

		/**
		 * Forwards to the percent method with the inTextBlock flag set
		 */
		percentInTextBlock: function (value, decimalPlaces) {
			return nf.percent(value, decimalPlaces, {inTextBlock: true});
		},

		/**
		 * Return the d3 locale object for formatting
		 */
		d3Object: D3Locale.getD3Locale(Config.languageCode()),

		/**
		 * Return the d3 locale object for formatting
		 */
		d3Service: D3Locale,

		/**
		 * Return an object containing the value, pip, and micro pip using the instrument precision value
		 * @param value
		 * @param instrument
		 * @returns {{}}
		 */
		forexPip: function(value,instrument) {
			var result = {};
			var absoluteValue = Math.abs(value);
			var precision = instrument.precision;

			result.absoluteValue = (absoluteValue * 1).toFixed(precision);

			var multiplier = Math.pow(10,precision - 1);
			// Truncate any decimal value instead of rounding, since this will be followed by the micropip.
			// Only round up in the case of a floating point exception.
			var parsedNumber = +(parseFloat(absoluteValue * multiplier).toPrecision(9));
			result.pip = nf.formatInteger(parsedNumber);

			multiplier = Math.pow(10,precision);
			// The micropip can be rounded since no further digits will be shown
			parsedNumber = +(parseFloat(absoluteValue * multiplier).toPrecision(9));
			var micropip = (parsedNumber).toFixed(0) % 10;
			result.micropip = nf.formatInteger(micropip);

			if (value > 0) {
				result.sign = "+";
			} else if (value < 0) {
				result.sign = "-";
			} else {
				result.sign = "";
			}

			return result;
		}
	};
	return nf;
}]);

/**
 * Created with JetBrains WebStorm.
 * User: aahmed
 * Date: 1/23/14
 * Time: 3:21 PM
 * To change this template use File | Settings | File Templates.
 */

'use strict';

recogniaApp.factory('DateFormatter', ['REST', 'Config', 'Lexicon', 'CommonConstants','HostedWebsite','Platform',
	function (REST, Config, Lexicon, CommonConstants,HostedWebsite,Platform) {

		function pad(number) {
			var r = String(number);
			if ( r.length === 1 ) {
				r = '0' + r;
			}
			return r;
		}

		// Converts the integer to a string and makes sure it has a leading zero for less than 10
		function formatLeadingZero(num) {
			return (num < 10) ? ("0" + num.toString()) : num.toString();
		}

		var dateLocale;

		dateLocale = Platform.data().dateLocale;


		return {
			/**Parses string formatted as YYYY-MM-DD to a Date object.
			 * If the supplied string does not match the format, an
			 * invalid Date (value NaN) is returned.
			 * @param {string} dateStringInRange format YYYY-MM-DD, with year in
			 * range of 0000-9999, inclusive.
			 * @return {Date} Date object representing the string.
			 * reference to: http://jibbering.com/faq/#parseDate
			 */
			parseISO8601: function (dateStringInRange) {
				var isoExp = /^\s*(\d{4})-(\d\d)-(\d\d)\s*$/,
					date = new Date(NaN), month,
					parts = isoExp.exec(dateStringInRange);

				if(parts) {
					month = +parts[2];
					date.setFullYear(parts[1], month - 1, parts[3]);
					if(month !== date.getMonth() + 1) {
						date.setTime(NaN);
					}
				}
				return date;
			},

			/**
			 * Format a Date as a given style. Style options are short, long, or
			 * monthYear.
			 *
			 * short:
			 *   zh-hans || zh-hant:
			 *     yyyy年{SHORT_MONTH_NAME}dd日
			 *   fr || europe:
			 *     dd {SHORT_MONTH_NAME} yyyy
			 *   us:
			 *     {SHORT_MONTH_NAME} dd, yyyy
			 *   default:
			 *     yyyy {SHORT_MONTH_NAME} dd
			 *
			 * long:
			 *   zh-hans || zh-hant:
			 *     yyyy年{LONG_MONTH_NAME}dd日
			 *   fr || europe:
			 *     dd {LONG_MONTH_NAME} yyyy
			 *   us:
			 *     {LONG_MONTH_NAME} dd, yyyy
			 *   default:
			 *     yyyy {LONG_MONTH_NAME} dd
			 *
			 * monthYear:
			 *   zh-hans || zh-hant:
			 *     yyyy-mm-dd
			 *   fr || europe:
			 *     dd/mm/yyyy
			 *   us:
			 *     mm/yyyy
			 *   default:
			 *     yyyy-mm
			 *
			 * none:
			 *   zh-hans || zh-hant:
			 *     yyyy-mm-dd
			 *   fr || europe:
			 *     dd/mm/yyyy
			 *   us:
			 *     mm/dd/yyyy
			 *   default:
			 *     yyyy-mm-dd
			 */
			formatDate: function (dateToFormat, style) {

				var formattedDate,
					language = Config.language(),
					year = dateToFormat.getFullYear().toString(),
					date = dateToFormat.getDate(),
					month = dateToFormat.getMonth() + 1;

				// The lexicon is two-digits key
				month = formatLeadingZero(month);
				date = formatLeadingZero(date);

				if(style===undefined || style===null || style===''){
					style = 'none';
				}

				if(dateLocale===undefined || dateLocale===null || dateLocale===''){
					dateLocale='international';
				}

				if(language === CommonConstants.LANGUAGE_MAP.zh){

					if(style === 'short'){
						month = Lexicon.translateDefaultNS("date.short." + month);
						formattedDate = year + "年" + month + date + "日";
					}

					else if(style === 'long'){
						month = Lexicon.translateDefaultNS("date.long." + month);
						formattedDate = year + "年" + month + date + "日";
					}

					else{
						formattedDate = year + "-" + month + "-"  + date;
					}
				}


				else if(language === CommonConstants.LANGUAGE_MAP.fr || dateLocale === 'europe'){

					if(style === 'short'){
						month = Lexicon.translateDefaultNS("date.short." + month);
						formattedDate = date + " " + month + " "  + year;
					}

					else if(style === 'long'){
						month = Lexicon.translateDefaultNS("date.long." + month);
						formattedDate = date + " " + month + " "  + year;
					}

					else {
						formattedDate = date + "/" + month + "/"  + year;
					}
				}

				else if(dateLocale ==='us'){

					if(style === 'short'){
						month = Lexicon.translateDefaultNS("date.short." + month);
						formattedDate = month + " " + date + ", "  + year;
					}
					else if(style === 'long'){
						month = Lexicon.translateDefaultNS("date.long." + month);
						formattedDate = month + " " + date + ", "  + year;
					}
					else if(style === 'monthYear'){
						formattedDate = month + "/" + year;
					}
					else{
						formattedDate = month + "/" + date + "/"  + year;
					}
				}

				else {

					if(style === 'short'){
						month = Lexicon.translateDefaultNS("date.short." + month);
						formattedDate = year + " " + month + " " + date;
					}

					else if(style === 'long'){
						month = Lexicon.translateDefaultNS("date.long." + month);
						formattedDate = year + " " + month + " " + date;
					}

					else if(style === 'monthYear'){
						formattedDate = year + "-" + month;
					}

					else{
						formattedDate = year + "-" + month + "-" + date;
					}
				}

				return formattedDate;
			},

			formatTimeStamp: function(dateToFormat, style){

				var date, time, dateParts;
				dateLocale = "international";

				if (typeof dateToFormat === 'string'){

					dateParts = dateToFormat.split (/[-T:Z]/);
					dateToFormat = new Date(dateParts[0], dateParts[1]-1, dateParts[2], dateParts[3], dateParts[4], dateParts[5],0);

				}

				date = this.formatDate(dateToFormat, style);
				time = this.formatTime(dateToFormat);
				return date + " " + time;
			},

			formatTime: function(timeToFormat, showSecs) {
				var dateObj;
				if (typeof timeToFormat === 'string')
					dateObj = this.parseDate(timeToFormat);
				else if (typeof timeToFormat === 'object')
					dateObj = timeToFormat;
				if ( !(dateObj) || isNaN( dateObj.getHours() ) ) return false;
				var hr  = formatLeadingZero( dateObj.getHours() );
				var min = formatLeadingZero( dateObj.getMinutes() );
				var formattedTime = hr + ":" + min;
				showSecs = typeof showSecs !== 'undefined' ? showSecs : true;
				if (showSecs) {
					var sec = formatLeadingZero( dateObj.getSeconds() );
					formattedTime = formattedTime + ":" + sec;
				}
				return formattedTime;
			},

			/**
			 * Parses date that is in the same format as the REST API
			 * @param dateString
			 * @returns Date object
			 */
			parseDate: function(dateString) {
				var dateParts = dateString.split (/[-T:]/);
				if( dateParts.length > 3 ){
					return new Date(dateParts[0], dateParts[1]-1, dateParts[2], dateParts[3], dateParts[4], dateParts[5],0);
				}
				else{
					return new Date(dateParts[0], dateParts[1]-1, dateParts[2],0,0,0,0);
				}
			},

			parseLegacyDate: function(dateString) {
				var dateParts = dateString.split(/[-.:]/);
				return new Date(dateParts[0], dateParts[1]-1, dateParts[2], dateParts[3], dateParts[4], dateParts[5],0);
			},

			getEpoch: function(dateString) {
				var dateParts = dateString.split (/[-T:]/);
				return new Date(dateParts[0], dateParts[1]-1, dateParts[2], dateParts[3], dateParts[4], dateParts[5],0).getTime();
			},

			/**
			 * Support for Legacy API
			 * @param date
			 * @returns {string}
			 */

			// This is used by Legacy API before initiating call to a server.
			parseDateWithFormat: function(dateFormat, dateString){
				return $.datepicker.parseDate(dateFormat, dateString);
			},

			convertDateToLegacyApiFormat: function (date){
				return date.toISOString().substr(0,10);
			},

			/**
			 * formats the date into string without timestamp
			 * @param date
			 */
			formatUTCDateYMD: function(date) {

				return date.getUTCFullYear() +
					'-' + pad( date.getUTCMonth() + 1 ) +
					'-' + pad( date.getUTCDate() );
			},

			/**
			 * formats the date into timestamp matching the REST API format
			 * @param date
			 */
			formatTimestampREST: function(date) {

				return date.getUTCFullYear() +
					'-' + pad( date.getUTCMonth() + 1 ) +
					'-' + pad( date.getUTCDate() ) +
					'T' + pad( date.getUTCHours() ) +
					':' + pad( date.getUTCMinutes() ) +
					':' + pad( date.getUTCSeconds() ) +
					'.' + String( (date.getUTCMilliseconds()/1000).toFixed(3) ).slice( 2, 5 );
			},

			formatTimestampForTimeseriesAPI: function(date) {
				return date.getFullYear() +
					'-' + pad(date.getMonth() + 1) +
					'-' + pad(date.getDate()) +
					'T' + pad(date.getHours()) +
					':' + pad(date.getMinutes()) +
					':' + pad(date.getSeconds());
			},

			// Sample Date Format (e.g. YYYY-MM-DD)
			getSampleDateFormat: function () {
					var SampleFormat = '';
					var DateFormat =  HostedWebsite.programmingFieldValue('DateFormat');
					var Day = Lexicon.translateDefaultNS("date.DateFormatDay");
					var Month = Lexicon.translateDefaultNS("date.DateFormatMonth");
					var Year = Lexicon.translateDefaultNS("date.DateFormatYear");
					if (DateFormat === 'dd/mm/yy') {
						SampleFormat = Day + '/' + Month + '/' + Year;
					} else if (DateFormat === 'mm/dd/yy') {
						SampleFormat = Month + '/' + Day + '/' + Year;
					} else {
						SampleFormat = Year + '-' + Month + '-' + Day;
					}
					return "("+SampleFormat+")";
			},
			// Checks that the date is valid
			isValidDate : function  (YEAR, MONTH, DAY) {
				MONTH--;
				var objTempDate = new Date(YEAR, MONTH, DAY);
				var tempYear = Number(objTempDate.getFullYear());
				var tempMonth = Number(objTempDate.getMonth());
				var tempDay = Number(objTempDate.getDate());
				
				return (tempYear === Number(YEAR) && tempMonth === Number(MONTH) && tempDay === Number(DAY));
			},

			//get the real date from differnet client base on different format
			fetchDateForDifferentFormat:function (displayDate,DateFormat){
				var year = '';
				var month = '';
				var day = '';
				if (DateFormat === 'dd/mm/yy') {
					day = displayDate.substring(0,2);
					month = displayDate.substring(3,5);
					year = displayDate.substring(6,10);
				} else if (DateFormat === 'mm/dd/yy') {
					month = displayDate.substring(0,2);
					day = displayDate.substring(3,5);
					year = displayDate.substring(6,10);
				} else {
					return displayDate;
				}
				return year + '-' + month + '-' + day;
			},

			// gets an ISO string from a date - time zone is ignored
			formatDateAsIsoString: function (date){
				function pad(delim, number){
					var output = delim;
					if (number < 10){
						output += '0';
					}
					return output += number;
				}
				return date.getFullYear().toString() + pad('-', date.getMonth() + 1) + pad('-', date.getDate())
					+ pad('T', date.getHours()) + pad(':', date.getMinutes()) + pad(':', date.getSeconds());
			},

			isVaildFormat : function(displayDate,DateFormat){
				var date = '';
				var Day = '';
				var Month = '';
				var Year = '';
				if (DateFormat === 'dd/mm/yy') {
					Day = displayDate.substring(0,2);
					Month = displayDate.substring(3,5);
					Year = displayDate.substring(6,10);
					date = Day + '/' + Month + '/' + Year;
				} else if (DateFormat === 'mm/dd/yy') {
					Month = displayDate.substring(0,2);
					Day = displayDate.substring(3,5);
					Year = displayDate.substring(6,10);
					date = Month + '/' + Day + '/' + Year;
				} else {
					Year = displayDate.substring(0,4);
					Month = displayDate.substring(5,7);
					Day = displayDate.substring(8,10);
					date = Year + '-' + Month + '-' + Day;
				}
				return date===displayDate;
			}
		};
	}
]);

'use strict';

/**
 * Created with JetBrains WebStorm.
 * User: aahmed
 */
recogniaApp.factory('EventFormatter', ['Lexicon', 'EventTypes',
	function (Lexicon, EventTypes) {

		var continueSearch = true;
		var eventGroups = [
			["bullishClassicAnyType", ["doublebottom","triplebottom","headshouldersbottom","upsidebreakout","ascendtriangle","bullwedge","bullsymtriangle","trianglebottom","bullflag","bullpennant","megaphonebottom","diamondbottom","bulldiamond","roundedbottom","bullcuphandle"]],
			["bullishClassicAnyType", ["doublebottom","triplebottom","headshouldersbottom","upsidebreakout","ascendtriangle","bullwedge","bullsymtriangle","trianglebottom","bullflag","bullpennant","megaphonebottom","diamondbottom","bulldiamond","roundedbottom"]],
			["bullishClassicContinuation", ["upsidebreakout","ascendtriangle","bullwedge","bullsymtriangle","bullflag","bullpennant","bulldiamond"]],
			["bullishClassicReversal", ["doublebottom","triplebottom","headshouldersbottom","trianglebottom","megaphonebottom","diamondbottom","roundedbottom"]],
			["bearishClassicAnyType", ["doubletop","tripletop","headshoulderstop","downsidebreakout","bearwedge","bearsymtriangle","descendtriangle","triangletop","bearflag","bearpennant","megaphonetop","diamondtop","beardiamond","roundedtop"]],
			["bearishClassicContinuation", ["downsidebreakout","bearwedge","bearsymtriangle","descendtriangle","bearflag","bearpennant","beardiamond"]],
			["bearishClassicReversal", ["doubletop","tripletop","headshoulderstop","triangletop","megaphonetop","diamondtop","roundedtop"]],
			["bearishShortTerm", ["islandtop","shootingstar","hangingman","bearengulfingline","bearoutsidebar","bearinsidebar","bearkeyreversal","bearexhaustion","beartwobarreversal","beargravestone"]],
			["bullishIndicators", ["bullsinglemovingaverage","bulldoublemovingaverage","bulltriplemovingaverage"]],
			["bullishOscillators", ["bullrsi","bullmacd","bullmomentum","bullshortkst","bullintermediatekst","bulllongkst","bullwilliams","bullcci","bullbollinger","bullfaststochastic","bullslowstochastic"]],
			["bearishIndicators", ["bearsinglemovingaverage","beardoublemovingaverage","beartriplemovingaverage"]],
			["bearishOscillators", ["bearrsi","bearmacd","bearmomentum","bearshortkst","bearintermediatekst","bearlongkst","bearwilliams","bearcci","bearbollinger","bearfaststochastic","bearslowstochastic"]],
			["bullishShortTerm",["islandbottom","bullengulfingline","bullgravestone","hammer","invertedhammer","bulloutsidebar","bullinsidebar","bullkeyreversal","bullexhaustion","bulltwobarreversal"]]
		];

		return {
			process: function (data) {
				if (data.length > 1) {
					var eventGroupName;
					for (var i = 0; i < eventGroups.length; i++) {
						if (data.length === eventGroups[i][1].length) {
							for (var k = 0; k < eventGroups[i][1].length; k++) {
								if (data.indexOf(eventGroups[i][1][k]) < 0) {
									continueSearch = true;
									break;
								}
							}
							if (continueSearch === false) {
								eventGroupName = Lexicon.translateDefaultNS('criteria.' + eventGroups[i][0] + "GroupName");
								return eventGroupName;
							}
							else {
								continueSearch = false;
							}
						}
					}
				}

				else {
					var eventName;
					eventName = EventTypes.byId(data[0]).name;
					return eventName;
				}
			}
		};
	}
]);
'use strict';

/**
 * Created with JetBrains WebStorm.
 * User: aahmed
 */
recogniaApp.factory('SectorFormatter', ['Lexicon', 'CriteriaApi',
	function (Lexicon, CriteriaApi) {
		var continueSearch = true;
		var sectorGroups = [
			["nonEnergyMinerals", ["1105", "1115", "1120", "1125", "1130", "1135"]],
			["producerManufacturing", ["1205", "1210", "1220", "1225", "1230", "1235", "1245", "1250", "1255"]],
			["electronicTechnology", ["1305", "1310", "1315", "1320", "1330", "1340", "1345", "1352", "1355"]],
			["consumerDurables", ["1405", "1410", "1415", "1420", "1425", "1430", "1435", "1445"]],
			["energyMinerals" , ["2105", "2110", "2120", "2125"]],
			["processIndustries" , ["2205", "2210", "2215", "2220", "2225", "2230", "2235", "2240"]],
			["healthTechnology" , ["2305", "2310", "2315", "2320", "2325"]],
			["consumerNonDurables" , ["2405", "2410", "2415", "2420", "2425", "2430", "2435", "2440", "2450"]],
			["industrialServices" , ["3105", "3110", "3115", "3120", "3130"]],
			["commercialServices" , ["3205", "3210", "3215", "3220", "3235"]],
			["distributionServices" , ["3255", "3260", "3265", "3270"]],
			["technologyServices" , ["3305", "3308", "3310", "3320"]],
			["healthServices" , ["3355", "3360", "3365", "3370"]],
			["consumerServices" , ["3405", "3410", "3415", "3420", "3425", "3430", "3435", "3440", "3445", "3450"]],
			["retailTrade" , ["3505", "3510", "3515", "3520", "3525", "3530", "3535", "3540", "3545", "3550"]],
			["transportation" , ["4605", "4610", "4615", "4620", "4625", "4630"]],
			["utilities" , ["4705", "4735", "4755", "4760"]],
			["finance" , ["4805", "4810", "4825", "4830", "4840", "4845", "4850", "4855", "4860", "4865", "4875", "4880", "4885", "4890"]],
			["communications" , ["4905", "4910", "4915"]],
			["miscellaneous" , ["6005", "6010"]],
			["agricultureForestryAndFishing" , ["01", "02", "07", "08", "09"]],
			["Mining" , ["10", "12", "13", "14"]],
			["Construction" , ["15", "16", "17"]],
			["Manufacturing" , ["20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39"]],
			["transportationCommunicationsElectricGasAndSanitaryServices" , ["40", "41", "42", "43", "44", "45", "46", "47", "48", "49"]],
			["wholesaleTrade" , ["50", "51"]],
			["retailTrade" , ["52", "53", "54", "55", "56", "57", "58", "59"]],
			["financeInsuranceAndRealEstate" , ["60", "61", "62", "63", "64", "65", "67"]],
			["Services" , ["70", "72", "73", "75", "76", "78", "79", "80", "81", "82", "83", "84", "86", "87", "88", "89"]],
			["publicAdministration" , ["91", "92", "93", "94", "95", "96", "97", "99"]]
		];

		return {
			process: function (data) {
				var sector;
				if (data.length > 1) {
					for (var i = 0; i < sectorGroups.length; i++) {
						if (data.length === sectorGroups[i][1].length) {
							for (var k = 0; k < sectorGroups[i][1].length; k++) {
								if (data.indexOf(sectorGroups[i][1][k]) < 0) {
									continueSearch = true;
									break;
								}
							}
							if (continueSearch === false) {
								sector = Lexicon.translateDefaultNS('sectors.' + sectorGroups[i][0]);
								return sector;
							}
							else {
								continueSearch = false;
							}
						}
					}
				}

				else {
					// CALL Criteria API and return the name
					CriteriaApi.getData(function (criteriaAPI) {
						if (criteriaAPI.sectors[data[0]] !== undefined) {
							sector = criteriaAPI.sectors[data[0]].name;
						}
					});
					return sector;
				}
			}
		};
	}
]);
'use strict';

/**
 * User: Aoun Rizvi
 */
recogniaApp.factory('BooleanFormatter', ['Lexicon',
	function (Lexicon) {

		var yes = Lexicon.translateDefaultNS('common.yes'),
			no = Lexicon.translateDefaultNS('common.no');

		return {
			process: function (data) {
					if (data === "F") {
						return no;
					} else {
						return yes;
					}
				}
		};
	}
]);
'use strict';

/* Services */

/* Integration helpers for hosted websites */
recogniaApp.factory('HostedWebsite', ['LegacyApi', 'Config', '$window', function (LegacyApi, Config, $window) {
	// Cache some api returns, since the legacy ajax calls explicitly defeat HTTP caching
	var cache = {};
	var requests = {};

	/* provide caching component calls for the service */
	function cachedComp(comp, parameters, callback) {
		var key = comp + '?' + parameters;
		if (cache[key]) {
			callback(cache[key]);
		} else {
			if (!requests[key]) {
				// create requests queue and make call first time only
				requests[key] = [];
				LegacyApi.comp(comp, parameters).success(function(data) {
					cache[key] = data;
					requests[key].forEach(function(cb) { cb(data); });
				});
			}
			// record all the callbacks
			requests[key].push(callback);
		}
	}

	return {
		mapInstrumentType: function(instrumentType){
			var types = { security: 'S'};
			return types[instrumentType];
		},

		instrumentDetails: function (symbol, exchange, type, callback) {
			cachedComp(
				'/components/instrument_details_json.mason',
				'SYMBOL=' + symbol + '&EXCHANGES=' + exchange + '&INSTRUMENT_TYPE=' + type,
				callback
			);
		},

		/** Get the list of exchanges for instrument lookup */
		instrumentLookupExchanges: function (callback, parameters) {
			if (parameters === undefined || parameters === null) {
				parameters = null;
			}
			cachedComp('/components/instrument_lookup_exchanges.mason', parameters, callback);
		},

		/** Get the list of exchanges for instrument lookup */
		instrumentLookupIndexes: function (callback) {
			cachedComp('/components/index_popup.mason:IndexList', null, callback);
		},

		/** Get the URL for linking to another page */
		pageUrl: function (page, parameters) {
			var url = './serve.shtml?page=' + page +
				'&ref=' + Config.getReferencePageId() +
				'&sid=' + Config.getSessionId();
			if (typeof parameters !== 'undefined') {
				url += '&' + parameters;
			}

			return url;
		},

		/** Get the value of a programming field */
		programmingFieldValue: function(field) {
			return $window.GetProgrammingFieldValue(field);
		}
	};
}]);

'use strict';

recogniaApp.factory('Ideas',
['$rootScope', '$q', 'REST', 'CommonConstants', 'NumberFormatter', 'DateFormatter', 'JsonUtil', 'OptionsStrategy',
function ($rootScope, $q, REST, CommonConstants, NumberFormatter, DateFormatter, JsonUtil, OptionsStrategy) {
	// IDs for broadcast events
	var COMPARED_IDEAS_UPDATED = 'Ideas.compared.IDEAS_UPDATED',
		WATCHED_IDEAS_ADD_ERROR = 'Ideas.watched.ADD_ERROR',
		WATCHED_IDEAS_REMOVE_ERROR = 'Ideas.watched.REMOVE_ERROR',
		WATCHED_IDEAS_UPDATED = 'Ideas.watched.IDEAS_UPDATED',
		WATCHING_IDEA_ACTION = 'Ideas.watching_ACTION';

	// State for compared ideas
	var comparedIdeas = [],
		MAX_COMPARED_COUNT = 4;

	// State for watched ideas
	var	watchedIdeasInitialised = {};
		watchedIdeasInitialised[CommonConstants.IDEA_TYPE.stock] = false;
		watchedIdeasInitialised[CommonConstants.IDEA_TYPE.option] = false;
		watchedIdeasInitialised[CommonConstants.IDEA_TYPE.forex] = false;


	var	MAX_WATCHED_COUNT = {};
		MAX_WATCHED_COUNT[CommonConstants.IDEA_TYPE.stock] = 40;
		MAX_WATCHED_COUNT[CommonConstants.IDEA_TYPE.option] = 40;
		MAX_WATCHED_COUNT[CommonConstants.IDEA_TYPE.forex] = 40;

	var watchedIdeas = [];
		watchedIdeas[CommonConstants.IDEA_TYPE.stock] = [];
	    watchedIdeas[CommonConstants.IDEA_TYPE.option] = [];
		watchedIdeas[CommonConstants.IDEA_TYPE.forex] = [];


	/* Build action request content */
	function action(idea, action, suppressOptionsFields) {
		var content = {'action': action};

		if (!suppressOptionsFields && idea.idea.ideaType === CommonConstants.IDEA_TYPE.option) {
			if (action === CommonConstants.ACTION.compare
				|| action === CommonConstants.ACTION.watch
			) {
				content.trade = idea.idea.trade;
				if (content.trade.legs.instrument) {
					var omitKeys = {latestPrice: 'latestPrice'};
					var instrument = JsonUtil.collapse({}, content.trade.legs.instrument.instrument, omitKeys);
					content.trade.legs.instrument.instrument = instrument;
				}
			}
			if (action === CommonConstants.ACTION.watch) {
				content.tagsMatched = idea.tagsMatched;
			}
		}
		if(idea.idea.ideaType === CommonConstants.IDEA_TYPE.forex){
			//if idea.watchLink is undefined which means it is the first time to watch the forex idea
			if (idea.watchLink === undefined&&action === CommonConstants.ACTION.watch) {
				content.tagsMatched = idea.tagsMatched;
				content.forexIdea = angular.copy(idea.idea);

				//Fetch out the event id for events
				var events = [];
				for(var i=0 ; i<content.forexIdea.events.length; i++){
					// first element in ID array contains event ID
					var event = content.forexIdea.events[i].id[0];
					events.push(event);

				}
				content.forexIdea.events = events;

				var instrumentId = content.forexIdea.instrument.id;
				content.forexIdea.instrument = instrumentId;

			}
		}

		return content;
	}

	/* Copy an idea, optionally replacing the id. */
	function copyIdea(idea, id) {
		var copy = angular.copy(idea);
		delete copy.$$hashKey; // Defeat angular's check for the ideas equality
		if (id !== undefined) {
			copy.idea["linkId"] = id;
		}

		return copy;
	}

	/* Equality comparison for compared ideas, based on screen, target, and trade */
	function equalCompared(a, b) {
		return a.idea.ideaType === b.idea.ideaType
			&& a.idea.targetPrice.expectedMove === b.idea.targetPrice.expectedMove
			&& a.idea.dates.targetBegin === b.idea.dates.targetBegin
			&& a.idea.dates.targetEnd === b.idea.dates.targetEnd
			&& REST.resourcesEqual(a.idea.instrument, b.idea.instrument)
			&& REST.resourcesEqual(a.idea.strategy, b.idea.strategy)
			&& (a.idea.ideaType !== CommonConstants.IDEA_TYPE.option
			|| tradesEqual(a.idea.trade, b.idea.trade));
	}
	/* Check resources equality */
	function checkResourcesEqual(a, b) {

		for (var i = 0; i < a.length; i++) {
			if(!REST.resourcesEqual(a[i], b[i]))
			{
				return false;
			}
		}
		return true;
	}
	/* Equality comparison for watched ideas, based on screen, instrument, and events */
	function equalWatched(a, b) {
		if (a.idea.ideaType !== b.idea.ideaType) {
			return false;
		}
		if (!REST.resourcesEqual(a.idea.instrument, b.idea.instrument)
				|| a.idea.events.length !== b.idea.events.length
				|| !checkResourcesEqual(a.idea.events, b.idea.events)
		) {
			return false;
		}
		//already check events and instrument
		if (a.idea.ideaType === CommonConstants.IDEA_TYPE.forex) {
			return true;
		}
		if (a.idea.ideaType === CommonConstants.IDEA_TYPE.option) {
			return angular.equals(a.idea.trade, b.idea.trade) && REST.resourcesEqual(a.idea.strategy, b.idea.strategy);
		}
		if(a.idea.ideaType === CommonConstants.IDEA_TYPE.stock){
			return  REST.resourcesEqual(a.idea.strategy, b.idea.strategy);
		}
		return true;
	}

	function getCorrespondingWatchedIdea(idea,product){
		for (var watchedIdea = 0; watchedIdea < watchedIdeas[product].length; watchedIdea++) {
			if ( equalWatched(idea, watchedIdeas[product][watchedIdea]))
			{
				return watchedIdeas[product][watchedIdea].idea;
			}
		}
		return;
	}

	/* Populate any extra values for an idea when it is retrieved. */
	function populateIdea(idea) {
		if (idea.idea.ideaType === CommonConstants.IDEA_TYPE.option) {
			idea.idea.perShareValues =  OptionsStrategy.getPerShareValues(idea.idea.trade);
			idea.earliestExpiryDate = DateFormatter.formatDate(
				DateFormatter.parseISO8601(OptionsStrategy.getEarliestExpiryDate(idea.idea.trade.legs)),
				'short'
			);
		}
	}

	/* Post an idea action that adds the idea to a list. */
	function sendListAdd(idea, actionId, messageId, list, equalFn,watchedBarTime) {
		// REST API cannot accept the watch action with the options fields for
		// already watched ideas, so we have to suppress the options fields
		// for watched ideas
		var suppressOptionsFields = ((actionId === CommonConstants.ACTION.watch)
			&& idea.watchLink !== undefined);

		var id = idea.watchLink || idea.idea['linkId'];


		//forex has a special case use static link when load forex data at the first time
		if(idea.idea.ideaType === CommonConstants.IDEA_TYPE.forex&& idea.watchLink === undefined){
			id = REST.forexLink();

		}
		// Add idea to local list and server
		var post = action(idea, actionId, suppressOptionsFields);

		//if watchedBarTime is undefined which means this idea does not belong to watched idea section
		if(idea.idea.watchedBarTime === undefined){
			post.watchedBarTime = watchedBarTime;
		}

		return REST.Post(id, post).then(function (response) {
			var result = response.data.result;
			// Check for success
			if (result.status === CommonConstants.ACTION_STATUS.compared
				|| result.status === CommonConstants.ACTION_STATUS.watched
				|| result.status === CommonConstants.ACTION_STATUS.duplicate
			) {
				// Mark original idea to streamline checking watched and
				// ensure re-watch goes to correct resource
				// Also do this prior to copy so that we can determine not
				// to send the trade/tags on a re-watch action.
				if (actionId === CommonConstants.ACTION.watch) {
					idea.watchLink = result.location;
				}

				// Create new idea object with new @id
				var copy = copyIdea(idea, result.location);
					copy.idea.watchedBarTime = post.watchedBarTime;
				// Add idea to list
				if (!list.some(function (i) { return equalFn(copy, i); })) {
					list.unshift(copy);
				}
				$rootScope.$broadcast(messageId, list);

				// Return the new idea
				return copy;

			} else {
				return $q.reject(response);
			}
		});

	}

	/* Post an idea action that removes the idea from a list. If the action is
	 * null, uses delete instead of post. */
	function sendListDelete(idea, actionId, messageId, list, equalFn, updateFn) {

		// Helper function to update the idea list
		var updateList = function (c) {
			list = list.filter(function (i) { return c.idea['linkId'] !== i.idea['linkId']; });
			updateFn(list);
			$rootScope.$broadcast(messageId, list);
		};

		// Find the idea in the local list
		for (var j = 0; j < list.length; j++) {
			var c = list[j];

			if (equalFn(c, idea)) {
				// Remove idea from local list and server
				var promise = (actionId === null)
					? REST.Delete(c.idea['linkId'])
					: REST.Post(c.idea['linkId'], action(idea, actionId));
				return promise.then(function (response) {
					updateList(c);
					return response;
				}, function (response) {
					if (response.status === 404) {
						updateList(c);
						response.status = 200;
						return response;
					}
					return $q.reject(response);
				});
			}
		}
		return $q.reject('No such idea');
	}

	function tradesEqual(a, b) {
		if (!REST.resourcesEqual(a.tradeStrategy, b.tradeStrategy)) {
			return false;
		}
		for (var leg in a.legs) {
			if (a.legs.hasOwnProperty(leg)
					&& (a.legs[leg].action !== b.legs[leg].action
						|| !REST.resourcesEqual(a.legs[leg].instrument, b.legs[leg].instrument)
			)) {
				return false;
			}
		}
		return true;
	}

//In the new structure of idea object 'bullish/bearish' are indicated in 'tags' property and not 'ideaType' property
	function findIdeaType(idea){
		if(idea.ideaType !== CommonConstants.IDEA_TYPE.option){
			var bullishIdeaType;
			var bearishIdeaType;

			if(idea.ideaType === CommonConstants.IDEA_TYPE.stock) {
				bullishIdeaType = idea.tags.filter(function (obj) {
					return obj.id === 'stocks_'.concat(CommonConstants.EVENT_TYPE.bullish);
				})[0];
				bearishIdeaType = idea.tags.filter(function (obj) {
					return obj.id === 'stocks_'.concat(CommonConstants.EVENT_TYPE.bearish);
				})[0];
			} else if(idea.ideaType === CommonConstants.IDEA_TYPE.forex){
				bullishIdeaType = idea.tags.filter(function (obj) {
					return obj.id === CommonConstants.EVENT_TYPE.bullish;
				})[0];
				bearishIdeaType = idea.tags.filter(function (obj) {
					return obj.id === CommonConstants.EVENT_TYPE.bearish;
				})[0];
			}
			if (bullishIdeaType){
				return CommonConstants.EVENT_TYPE.bullish;
			} else if (bearishIdeaType){
				return CommonConstants.EVENT_TYPE.bearish;
			} else {
				console.error("Invalid ideaType for stock/forex!");
			}
		} else {
			return idea.ideaType;
		}

	}

	function populateIdeasPrices(ideas, product) {
		if (ideas.length > 0) {
			var instrumentList = [];
			ideas.forEach(function (ideaObj) {
				instrumentList.push(ideaObj.idea.instrument.id);
			});
			REST.getLatestPrices(instrumentList.join()).then(
				function (response) {
					response.quotes.forEach(function (quotePrice) {
						ideas.forEach(function (ideaObj) {
							if (ideaObj.idea.instrument.id === quotePrice.instrument.instrumentId) {
								ideaObj.idea.instrument.latestPrice =
									{
										price: quotePrice.price,
										resourceType: quotePrice.dataType,
										dataType: quotePrice.dataType,
										timestamp: quotePrice.timestamp
									};
							}
						});
					});

					// Filter out suppressed instruments for the client if it's the case.
					// This is needed because old wildfly quote API was ignoring the instrument suppression,
					// while the new API takes it into account.
					// It returns the suppressed instrument ids under the unmatchedIds array.
					response.unmatchedIds.forEach(function (unmatchedId) {
						for (var i = ideas.length - 1; i >= 0; --i) {
							if (ideas[i].idea.instrument.id === unmatchedId) {
								ideas.splice(i, 1);
							}
						}
					});

					// Emit the updated watchedIdeas without the suppressed instruments
					// in order to display the correct count on them.
					$rootScope.$broadcast(WATCHED_IDEAS_UPDATED + '.' + product, ideas);
				});
		} else {
			// Emit the ideas also when it's empty. Needed to have the drop down option with 0 count displayed.
			$rootScope.$broadcast(WATCHED_IDEAS_UPDATED + '.' + product, ideas);
		}
	}
	/*****************************************************************
	 * Define service API
	 */
	return {
		/* Idea actions */
		action: function(linkId){
			return {
				WATCHING: WATCHING_IDEA_ACTION+'WATCHING'+'.'+linkId,
				UNWACTHING: WATCHING_IDEA_ACTION+'UNWATCHING'+'.'+linkId
			};
		},

		/* List of compared ideas. Call get method to initialise. */
		compared: {
			/* Compared idea list updated. */
			IDEAS_UPDATED: COMPARED_IDEAS_UPDATED,

			/* Maximum number of ideas in compared list (constant). */
			MAX_COUNT: MAX_COMPARED_COUNT,

			/* Add idea to compare list. Returns a promise returning the compared idea */
			add: function(idea) {
				return sendListAdd(idea, CommonConstants.ACTION.compare,
					COMPARED_IDEAS_UPDATED, comparedIdeas, equalCompared);
			},

			/* Count the number of ideas in compare list. */
			count: function() {
				return comparedIdeas.length;
			},

			/* Equality comparison, based on screen, target, and trade */
			equal: equalCompared,

			/* Get list of compared ideas fom server. Returns a promise. */
			get: function(params) {
				return REST.UserComparedIdeas(params)
					.then(function(response) {
						comparedIdeas = response.data.result.ideas;
						comparedIdeas.forEach(populateIdea);
						$rootScope.$broadcast(COMPARED_IDEAS_UPDATED, comparedIdeas);
						return comparedIdeas;
					});
			},

			/* Check if idea is in compare list. */
			isCompared: function(idea) {
				return comparedIdeas.some(function (i) { return equalCompared(idea, i); });
			},

			/* Current list of ideas in the compare list. */
			list: function() {
				return comparedIdeas;
			},

			/* Remove idea from compare list. Returns a promise */
			remove: function(idea) {
				return sendListDelete(idea, null, COMPARED_IDEAS_UPDATED,
					comparedIdeas, equalCompared, function(list) {
						comparedIdeas = list;
				});
			}
		},

		watched: function(product){
			return {
			/* Compared idea list updated event. */
			IDEAS_UPDATED: WATCHED_IDEAS_UPDATED+'.'+product,

			/* Error adding idea event. */
			ADD_ERROR: WATCHED_IDEAS_ADD_ERROR+'.'+product,

			/* Error removing idea event. */
			REMOVE_ERROR: WATCHED_IDEAS_REMOVE_ERROR+'.'+product,

			/* Maximum number of ideas in compared list (constant). */
			MAX_COUNT: MAX_WATCHED_COUNT[product],

			/* Add idea to compare list. Returns a promise returning the compared idea */
			add: function(idea,watchedBarTime) {

				return sendListAdd(idea,CommonConstants.ACTION.watch,
					WATCHED_IDEAS_UPDATED+'.'+product, watchedIdeas[product], equalWatched,watchedBarTime);
			},

			/* Count the number of ideas in compare list. */
			count: function() {
				return watchedIdeas[product].length;
			},

			/* Equality comparison, based on screen, target, and trade */
			equal: equalWatched,

			/* Get list of compared ideas fom server. Returns a promise. */
			get: function(params) {
				if(product===CommonConstants.IDEA_TYPE.stock){
					return REST.UserWatchedStockIdeas(params)
						.then(function(response) {
							// Copy ideas list and mark each with watchLink, so rewatch works
							watchedIdeas[product] = response.data.result.ideas;
							watchedIdeas[product].forEach(function (i) {
								i.watchLink = i.idea['linkId'];
							});
							populateIdeasPrices(watchedIdeas[product], product);
						});
				}
				else if(product===CommonConstants.IDEA_TYPE.option){
					return REST.UserWatchedOptionIdeas(params)
						.then(function(response) {
							// Copy ideas list and mark each with watchLink, so rewatch works
							watchedIdeas[product] = response.data.result.ideas;
							watchedIdeas[product].forEach(function (i) {
								i.watchLink = i.idea['linkId'];
								populateIdea(i);
							});
							populateIdeasPrices(watchedIdeas[product], product);
						});
				}
				else if(product===CommonConstants.IDEA_TYPE.forex){
					return REST.UserWatchedForexIdeas(params)
						.then(function(response) {
							// Copy ideas list and mark each with watchLink, so rewatch works
							watchedIdeas[product] = response.data.result.ideas;
							watchedIdeas[product].forEach(function (i) {
								i.watchLink = i.idea['linkId'];
							});
							populateIdeasPrices(watchedIdeas[product], product);
						});
				}

			},

			/* Return the index of the idea in the watched list. */
			indexOf: function(idea) {
				return watchedIdeas[product].indexOf(idea);
			},

			/* Return whether the watched ideas have been initialised by calling get. */
			initialised: function() {
				return watchedIdeasInitialised[product];
			},

			/* Check if idea is in compare list. */
			isWatched: function(idea) {
				var watchedIdea = getCorrespondingWatchedIdea(idea,product);
				return watchedIdea ? true : false;
			},

			getWatchedTime: function(idea){
				var watchedIdea = getCorrespondingWatchedIdea(idea,product);
				return watchedIdea ? watchedIdea.watchedBarTime : undefined;
			},

			/* Current list of ideas in the compare list. */
			list: function() {
				return watchedIdeas[product];
			},

			/* Remove idea from compare list. Returns a promise */
			remove: function(idea) {
				return sendListDelete(idea, CommonConstants.ACTION.unwatch,
					WATCHED_IDEAS_UPDATED+'.'+product, watchedIdeas[product], equalWatched, function(list) {
						watchedIdeas[product] = list;

				});
			}
		};
		},

		/* Check if two trades are equal (i.e. strategy and legs the same). */
		tradesEqual: tradesEqual,

		/*
		 * Depending if the idea is bearish or bullish, return the more cautious
		 * end of the target price range
		 */
		getConservativeTargetPrice: function(idea){
			var tPrice;
			if (idea.targetPrice === undefined && idea.targetPrice === null) {
				tPrice = Number.NaN;
			} else {
				if (idea.ideaType === CommonConstants.IDEA_TYPE.option){
					tPrice = idea.trade.targetPrice;
				} else if (findIdeaType(idea) === CommonConstants.EVENT_TYPE.bearish){
					tPrice = idea.targetPrice.upper;
				} else if (findIdeaType(idea) === CommonConstants.EVENT_TYPE.bullish){
					tPrice = idea.targetPrice.lower;
				}
			}
			return tPrice;
		},

		//finds the ideaType of the idea (i.e bearish or bullish)
		findIdeaType : findIdeaType
	};
}]);


'use strict';

/* Log usage of whatever */
recogniaApp.factory('UsageLogging',
['$http', 'Config', 'REST',
function ($http, Config, REST) {
	return {
		log: function(page) {
			var url = Config.getPublicApiBaseUrl() + '/logwebapp'
					+ '?uid=' + encodeURIComponent(Config.getUserAuthorization())
					+ '&page=' + page;
			if (Config.getReferencePageId() !== undefined) {
				url += '&ref=' + Config.getReferencePageId();
			}
			return $http.get(url);
		}
	};
}]);

/**
 * Created by arizvi on 9/23/14.
 */

'use strict';

recogniaApp.factory('CommonConstants', [function () {

	return {

		ACTION: {
			compare:        'compare',
			watch:          'watch',
			unwatch:        'unwatch'
		},

		ACTION_STATUS: {
			compared:        'compared',
			duplicate:       'duplicate',
			watched:         'watched',
			unwatched:       'unwatched'
		},

		ERROR_CODE: {
			limit_exceeded: 400006
		},

		PRODUCT: {
			stocks:         'stocks',
			options:        'options',
			forex:          'forex'
		},

		VIEW: {
			stocks:         'stocks',
			options:        'options',
			forex:          'forex',
			watchedStocks:  'watchedStocks',
			watchedOptions: 'watchedOptions',
			watchedForex:   'watchedForex'
		},

		WATCHED_IDEAS_TYPE: {
			watchedStocks:  'watchedStocks',
			watchedOptions: 'watchedOptions',
			watchedForex:   'watchedForex'
		},

		IDEA_TYPE: {
			option:         'option',
			stock:			'stock',
			forex:			'forex'
		},

		EVENT_TYPE: {
			bullish:        'bullish',
			bearish:        'bearish'
		},

		WATCHED_IDEAS: {
			watchLimit:     40
		},

		TRADE_TYPE: {
			long_type:		'long',
			short_type:		'short'
		},

		BRAND: {
			recognia:		'recognia',
			tradnig_central:'trading_central'
		},

		LANGUAGE_WITH_LOCALE_MAP: {
			// These are mapping language codes from the legacy front-end to the new front end
			en:  'en',
			ar:  'ar',
			de:  'de',
			cs:  'zh-hans',
			ct:  'zh-hant',
			fr:  'fr',
			ff:  'fr-fr',
			id:  'id',
			nl:  'nl',
			pl:  'pl',
			pt:  'pt',
			ru:  'ru',
			th:  'th',
			tr:  'tr',
			ja:  'ja',
			es:  'es',
			xe:  'xe'
		},

		LANGUAGE_MAP: {
			// These are mapping language codes from the legacy front-end to the new front end
			en:  'en',
			ar:  'ar',
			de:  'de',
			cs:  'zh',
			ct:  'zh',
			fr:  'fr',
			ff:  'fr',
			id:  'id',
			nl:  'nl',
			pl:  'pl',
			pt:  'pt',
			ru:  'ru',
			th:  'th',
			tr:  'tr',
			ja:  'ja',
			es:  'es',
			xe:  'xe'
		},

		BAR_TYPE: {
			candleStick:    'candlestick',
			bar:            'bar'
		},

		EVENT_CATEGORY: {
			classic:        'classic',
			indicator:     'indicator',
			oscillator:    'oscillator',
			shortterm:      'shortterm',
			elliottWave:    'elliottwave'
		},

		PRICE_DATA_TYPES : {
			tick:   'tick',
			close:  'close'
		},

		CHART_TYPE :{
			smallForexPriceChart: 'smallForexPriceChart',
			largeForexPriceChart: 'largeForexPriceChart',
			smallStocksPriceChart: 'smallStocksPriceChart',
			largeStocksPriceChart: 'largeStocksPriceChart',
			smallOptionsPriceChart: 'smallOptionsPriceChart',
			largeOptionsPriceChart: 'largeOptionsPriceChart'
		},

		SUBSCRIPTION_TYPE: {
			quote: 'quote',
			timeseries: 'timeseries'
		},

		buy:            'buy',
		sell:           'sell',
		market:         'market',
		exchange:       'exchange',
		BackTesting:    'BackTesting',
		StrategyBuilder:'Strategy Builder',
		instrument:     'instrument'
	};

}]);

/**
 * Created by arizvi on 9/23/14.
 */

'use strict';

recogniaApp.factory('CriteriaConstants', [function () {

	return {
		event:                          'event',
		bullishClassic:                 'bullishClassic',
		bearishClassic:                 'bearishClassic',
		bearishShortTerm:               'bearishShortTerm',
		bullishShortTerm:               'bullishShortTerm',
		bullishIndicatorsOscillators:   'bullishIndicatorsOscillators',
		bearishIndicatorsOscillators:   'bearishIndicatorsOscillators',
		options:                        'options',
		exchangeSymbol:                 'exchangeSymbol',
		issueType:                      'issueType',
		sectorId:                       'sectorId',
		volume90DayAvg:                 'volume90DayAvg'
	};
}]);

/*
 * Define constants for key codes
 */

'use strict';

recogniaApp.factory('KeyCode', [function () {
	return {
		ENTER: 13,
		SPACE: 32,
		TAB: 9
	};
}]);

/**
 * Created by arizvi on 9/22/14.
 */

'use strict';

recogniaApp.factory('OptionsStrategyConstants', [function () {

	return {

		OPTIONS_STRATEGY: {
			longcall:               'longcall',
			longput:                'longput',
			buywrite:               'buywrite',
			marriedput:             'marriedput',
			bullcallspread:         'bullcallspread',
			bullputspread:          'bullputspread',
			bearcallspread:         'bearcallspread',
			bearputspread:          'bearputspread',
			longotmcallbutterfly:   'longotmcallbutterfly',
			longotmputbutterfly:    'longotmputbutterfly'
		},


		CONTRACT_TYPE: {
			optionsContract:        'optionsContract',
			instrument:             'instrument'
		}

	};

}]);

'use strict';

/**
 * User: Aoun Rizvi
 */
recogniaApp.factory('OptionsIdeasCsv',
['REST', 'OptionsStrategy', 'OptionsStrategyConstants', 'Ideas',
function (REST, OptionsStrategy, OptionsStrategyConstants, Ideas) {

	function validateParameters(params) {
		// We need to expand objects to get all the required data
		params.expand = 'instrument(exchange,sector,quote),optionsContract(quote),optionsStrategy';

		if (params.event !== undefined && params.event !== null && params.event !== '') {
			params.expand += ',event';
		}

		return true;
	}

	function processOptionsIdeas(instrumentId, params, success, error) {
		if (validateParameters(params)) {
			REST.InstrumentOptionsIdeas(instrumentId,params).success(function (data) {
				var fields = [
						'instrument_id',
						'symbol',
						'exchange',
						'event',
						'stock_price_current',
						'stock_volume_current',
						'stock_price_event',
						'stock_volume_event',
						'sector',
						'target_lower',
						'target_upper',
						'target_date_begin',
						'target_date_end',
						'idea_date',
						'score_letter',
						'score_numeric',
						'strategy',
						'leg1_type',
						'leg1_action',
						'leg1_quantity',
						'leg1_instrument',
						'leg1_instrument_date',
						'leg1_instrument_strike',
						'leg1_instrument_price',
						'leg2_type',
						'leg2_action',
						'leg2_quantity',
						'leg2_instrument',
						'leg2_instrument_date',
						'leg2_instrument_strike',
						'leg2_instrument_price',
						'leg3_type',
						'leg3_action',
						'leg3_quantity',
						'leg3_instrument',
						'leg3_instrument_date',
						'leg3_instrument_strike',
						'leg3_instrument_price',
						'net_cost',
						'net_cost_per_share',
						'net_recieved',
						'net_recieved_per_share',
						'max_loss',
						'max_loss_per_share',
						'max_loss_percent',
						'target_price',
						'target_profit',
						'target_profit_per_share',
						'return_on_investment',
						'reward_to_risk',
						'breakeven_point',
						'profit_zone'
					],
					csv = fields.join(',') + "\n";

				data.result.ideas.forEach(function (idea) {
					var perShareValues = OptionsStrategy.getPerShareValues(idea.trade);

					fields = [];
					fields.push(instrumentId);
					fields.push(idea.instrument.symbol);
					fields.push(idea.instrument.exchange.symbol);
					fields.push(params.event);
					fields.push(idea.instrument.latestPrice.price);
					fields.push(idea.instrument.latestPrice.volume);
					if (idea.events[0] !== undefined && idea.events[0] !== null) {
						fields.push(idea.events[0].endPrices.close);
						fields.push(idea.events[0].endPrices.volume);
					} else {
						fields.push('');
						fields.push('');
					}
					if (idea.instrument.sectors[0] !== undefined && idea.instrument.sectors[0] !== null) {
						fields.push(idea.instrument.sectors[0].name);
					} else {
						fields.push('');
					}
					fields.push(idea.targetPrice.lower);
					fields.push(idea.targetPrice.upper);
					fields.push(idea.dates.targetBegin);
					fields.push(idea.dates.targetEnd);
					fields.push(idea.ideaDate);
					fields.push(idea.trade.scoreGrade);
					fields.push(idea.trade.score);
					fields.push(idea.trade.tradeStrategy.name);

					var legCount = 0;
					Object.keys(idea.trade.legs).forEach(function (legType) {
						legCount++;
						fields.push(legType);
						var leg = idea.trade.legs[legType],
							type = leg.instrument['resourceType'];

						fields.push(leg.action);
						fields.push(leg.quantity);

						if (type === OptionsStrategyConstants.CONTRACT_TYPE.optionsContract) {
							fields.push(leg.instrument.id[1]);
							fields.push(leg.instrument.expiryDate);
							fields.push(leg.instrument.strikePrice);
							var contract_price = leg.instrument.latestPrice.bid;
							if (leg.action === 'buy') {
								contract_price = leg.instrument.latestPrice.ask;
							}
							fields.push(contract_price);
						} else {
							fields.push(leg.instrument.id);
							fields.push('');
							fields.push('');
							fields.push(leg.instrument.latestPrice.price);
						}
					});
					// populate missing legs
					while (legCount < 3) {
						legCount++;
						for (var i = 0; i < 7; i++) {
							fields.push('');
						}
					}

					if (idea.trade.tradeStrategy.isNetCredit) {
						fields.push('');
						fields.push('');
						fields.push(idea.trade.netCost);
						fields.push(perShareValues.premiumReceived);
					} else {
						fields.push(idea.trade.netCost);
						fields.push(perShareValues.netCost);
						fields.push('');
						fields.push('');
					}
					fields.push(idea.trade.maxLoss);
					fields.push(perShareValues.maxLoss);
					fields.push(idea.trade.maxLossPercent);
					fields.push(Ideas.getConservativeTargetPrice(idea));
					fields.push(idea.trade.targetProfit);
					fields.push(perShareValues.targetProfit);
					fields.push(idea.trade.targetProfitPercent);
					fields.push(idea.trade.rewardRiskRatio);
					if (idea.trade.profitZone.length !== 0) {
						// We currently only support strategies with a single profit zone
						var lower = Number(idea.trade.profitZone[0].lower);
						var upper = Number(idea.trade.profitZone[0].upper);
						// Show break even point only if there is exactly one (i.e. the other end of the profit zone is 0 or infinity)
						if (lower === 0 && upper === Infinity) {
							fields.push('');
						} else {
							if (lower === 0) {
								fields.push(upper);
							} else {
								fields.push(lower);
							}
						}
						// Profit zone
						if (lower === 0) {
							fields.push('below ' + upper);
						} else if (upper === Infinity) {
							fields.push('above ' + lower);
						} else {
							fields.push(lower + ' - ' + upper);
						}
					} else {
						// No profit zones or break even points
						fields.push('');
						fields.push('');
					}

					csv += fields.join(',') + "\n";
				});

				success(csv);
			}).error(error);
		} else {
			error('Parameters not correct');
		}
	}

	return {
		/**
		 * Return the number of nodes of an object
		 * @param object
		 * @returns {*}
		 */
		instrumentIdeas: function (instrumentId, params, success, error) {
			return processOptionsIdeas(instrumentId, params, success, error);
		}
	};
}]);

'use strict';

/**
 * Provides the base implementation for all the OptionStrategy{X} services
 */
recogniaApp.factory('OptionsStrategyBase',
['REST', '$q', 'OptionsStrategyConstants',
function (REST, $q, OptionsStrategyConstants) {

	function OptionsStrategyBase (bearish, strategyId) {
		if (bearish !== true && bearish !== false){
			throw new TypeError('The bearish argument must a boolean');
		}
		if (!strategyId){
			throw new Error('Options strategies must provide a strategyId');
		}
		this.strategyId = strategyId;
		this.bearish = bearish;
	}
	OptionsStrategyBase.prototype = {
		isBearish: function(){
			return this.bearish;
		},

		/**
		 * Return true if any leg in the trade has an expired contract
		 */
		isContractExpired: function(trade) {
			var legType;
			for (legType in trade.legs) {
				if (trade.legs.hasOwnProperty(legType) && trade.legs[legType].instrument["resourceType"] !== "instrument") {
					if (new Date() > new Date(trade.legs[legType].instrument.expiryDate)) {
						return true;
					}
				}
			}
			return false;
		},

		/**
		 * A string representing the name of the tooltip context in the lexicon
		 */
		getTurningPointsToolTipNames: function () {
			return null;
		},

		getLegComparator: function(){
			return function (legA, legB) {
				return (legA.action === legB.action) ? 0 :
					(legA.action > legB.action) ? 1 : -1;
			};
		},

		/*
		 * Return per share values for several values on a trade, assumes all
		 * contracts have equal block size.
		 */
		getPerShareValues: function (trade) {
			var blockSize;
			for (var key in trade.legs){
				if (trade.legs.hasOwnProperty(key)
					&& trade.legs[key].instrument['resourceType'] === OptionsStrategyConstants.CONTRACT_TYPE.optionsContract){
					blockSize = trade.legs[key].instrument.blockSize;
					break;
				}
			}
			return {
				maxLoss: trade.maxLoss / blockSize,
				maxProfit: trade.maxProfit / blockSize,
				netCost: trade.netCost / blockSize,
				premiumReceived: trade.netCost * -1 / blockSize,
				premiumPaid: trade.netCost / blockSize,
				targetProfit: trade.targetProfit / blockSize
			};
		},
		/**
		 * Compares the price difference b/w now and when the option idea was first watched
		 */
		getPriceMove: function(trade){
			var contractPriceMovePromise;

			if (!this.isContractExpired(trade)) {
				var contractLegsAPICalls = [];
				Object.keys(trade.legs).forEach(function (legType) {
					contractLegsAPICalls.push(
						REST.get(trade.legs[legType].instrument.latestPrice["linkId"]));
				});
				contractPriceMovePromise = $q.all(contractLegsAPICalls).then(function (responses) {
					var initialNetCost = trade.netCost;
					var tradeWithLatestPrices = angular.copy(trade);
					var maxLoss = trade.maxLoss;

					// Update legs with latest pricing
					var i = 0;
					for (var legType in tradeWithLatestPrices.legs) {
						if (tradeWithLatestPrices.legs.hasOwnProperty(legType)) {
							tradeWithLatestPrices.legs[legType].instrument.latestPrice = responses[i++].data.result;
						}
					}

					// trade.currentNetValue is the close Price - enter price upon watching, initialNetCost
					var priceDiff = trade.currentNetValue;
					var currentClosePrice = trade.currentNetValue + initialNetCost;

					var percentageDiff = 0;
					if (initialNetCost !== 0) {
						if (trade.tradeStrategy.isNetCredit === false) {
							percentageDiff = (priceDiff / initialNetCost);
						} else {
							percentageDiff = (priceDiff / maxLoss);
						}

					}
					return {
						status: "success",
						currentClosePrice: currentClosePrice,
						priceDifference: priceDiff,
						percentageDifference: percentageDiff,
						tradeWithLatestPrices: tradeWithLatestPrices
					};
				},
				function (errResponse){
					// rethrow
					return $q.reject({
						status: "error",
						http_status: errResponse.status
					});
				});
			} else {
				var contractPriceMove = $q.defer();
				contractPriceMove.resolve({
					status: "expired"
				});
				contractPriceMovePromise = contractPriceMove.promise;
			}
			return contractPriceMovePromise;
		}
	};

	return OptionsStrategyBase;
}]);

'use strict';

/**
 * This is the implementation for Bear Call Spread strategy
 * Do not inject this service, instead use the OptionsStrategy service
 *
 * NOTE: Methods are stubbed out for now to assist implementation of charting
 */
recogniaApp.factory('OptionsStrategyBearCallSpread',
['OptionsStrategyCreditSpread', 'Lexicon', 'NumberFormatter', 'OptionsStrategyConstants', 'Ideas',
function (OptionsStrategyCreditSpread, Lexicon, NumberFormatter, OptionsStrategyConstants, Ideas) {

	var textKeys = [
		'net-received-bear-call','max-loss-bear-call','max-profit-bear-call',
		'target-price','target-profit','lower-strike-price-plus-net-premium-paid-per-share',
		'break-even-point-upper','lower-strike-price-plus-net-premium-paid-per-share',
		'break-even-point-upper','higher-strike-price-plus-net-premium-paid-per-share',
		'break-even-point-lower','higher-strike-price-plus-net-premium-paid-per-share',
		'target-profit-bullish-long-call-otm-butterfly-between-middle-and-upper-strike',
		'target-profit-bullish-long-call-otm-butterfly-between-lower-and-middle-strike',
		'premium-paid','quantity-of-contracts-x-shares-per-contract','quantity-of-contracts',
		'max-loss-per-share','higher-strike-price-to-lower-strike-price','lower-strike-obligation',
		'target-price-to-purchase-shares','target-price-bear-call','shares-per-contract',
		'greater-of-target-and-lower','target-profit-bear-call-equal-or-lower-than-lower-strike',
		'return-on-max-loss','return','net-premium-received','premium-paid-per-share-for-long-call',
		'premium-received-per-share-short-call','max-profit','net-premium-received-per-share','max-loss',
		'max-profit', 'target-profit-per-share','max-profit-per-share',
		'target-profit-bear-call-between-lower-and-higher-strike'
	];
	var ogtext = {};
	textKeys.forEach(
		function(value) {
			ogtext[value] = Lexicon.translateDefaultNS('options_strategy_details.' + value);
		}
	);

	var OptionsStrategyBearCallSpread = new OptionsStrategyCreditSpread(true,
			OptionsStrategyConstants.OPTIONS_STRATEGY.bearcallspread);

	/**
	 *
	 * A string representing the name of the tooltip context in the lexicon
	 */
	OptionsStrategyBearCallSpread.getTurningPointsToolTipNames = function () {
		return ["tt-max-profit-X-or-lower", "tt-max-loss-X-or-higher"];
	};

	OptionsStrategyBearCallSpread.getPopoverText = function($scope, $interpolate, idea, trade) {
		var popoverText = {};
		$scope.netCost = NumberFormatter.formatCurrency(
			Math.abs(trade.netCost),
			idea.instrument.precision
		);
		$scope.shareCost =  NumberFormatter.formatCurrency(
			idea.instrument.latestPrice.ask,
			idea.instrument.precision
		); //???????????

		$scope.maxLoss = NumberFormatter.formatCurrency(
			Math.abs(trade.maxLoss),
			idea.instrument.precision
		);//

		$scope.maxLossPercent = NumberFormatter.percent(
			Math.abs(idea.trade.maxLossPercent), 0
		);//

		$scope.maxLossPerShare = NumberFormatter.formatCurrency(
			Math.abs(trade.maxLoss)/trade.legs.upper_contract.instrument.blockSize,
			idea.instrument.precision
		);//

		$scope.premiumPaidPerShare = NumberFormatter.formatCurrency(
			Math.abs(trade.netCost)/trade.legs.upper_contract.instrument.blockSize,
			idea.instrument.precision
		);//
		$scope.netCostPerShare = NumberFormatter.formatCurrency(
			Math.abs(trade.netCost)/trade.legs.upper_contract.instrument.blockSize,
			idea.instrument.precision
		);//
		$scope.quantityOfContracts = NumberFormatter.formatInteger(trade.legs.upper_contract.quantity);//

		$scope.targetPrice = NumberFormatter.formatCurrency(
			Ideas.getConservativeTargetPrice(idea),
			idea.instrument.precision
		);//
		$scope.targetPriceLower = NumberFormatter.formatCurrency(
			idea.targetPrice.lower,
			idea.instrument.precision
		);//
		$scope.targetPriceUpper = NumberFormatter.formatCurrency(
			idea.targetPrice.upper,
			idea.instrument.precision
		);//

		$scope.premiumPaidPerShareLongCall = NumberFormatter.formatCurrency(
			trade.legs.upper_contract.instrument.latestPrice.ask,
			idea.instrument.precision
		);//
		$scope.premiumPaidLongCall = NumberFormatter.formatCurrency(
			trade.legs.upper_contract.instrument.latestPrice.ask*trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);//

		$scope.premiumReceivedShortCall = NumberFormatter.formatCurrency(
			trade.legs.lower_contract.instrument.latestPrice.bid*trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);//

		$scope.premiumReceivedPerShareShortCall = NumberFormatter.formatCurrency(
			trade.legs.lower_contract.instrument.latestPrice.bid,
			idea.instrument.precision
		);//
		$scope.strikePriceLower = NumberFormatter.formatCurrency(
			trade.legs.lower_contract.instrument.strikePrice,
			idea.instrument.precision
		);//

		$scope.strikePriceUpper = NumberFormatter.formatCurrency(
			trade.legs.upper_contract.instrument.strikePrice,
			idea.instrument.precision
		);//


		$scope.maxProfitPerShare = NumberFormatter.formatCurrency(
			trade.maxProfit/trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);//

		$scope.maxProfit = NumberFormatter.formatCurrency(
			trade.maxProfit,
			idea.instrument.precision
		);//

		$scope.netPremiumReceived = NumberFormatter.formatCurrency(
			Math.abs(trade.netCost),
			idea.instrument.precision
		);//

		$scope.netPremiumReceivedPerShare = NumberFormatter.formatCurrency(
			Math.abs(trade.netCost)/trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);//


		$scope.maxProfitPercentage = NumberFormatter.percent(
			trade.maxProfitPercent, 0
		);//


		$scope.targetProfitPercent =  NumberFormatter.percent(
			idea.trade.targetProfitPercent, 0
		);//
		$scope.targetProfit = NumberFormatter.formatCurrency(
			trade.targetProfit,
			idea.instrument.precision
		);//

		$scope.targetProfitPerShare = NumberFormatter.formatCurrency(
			trade.targetProfit/trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);//

		var text = {};
		Object.keys(ogtext).forEach(function (i){
			text[i] = $scope.$eval( $interpolate( ogtext[i] ) );
		});
		//IF ON TARGET PROFIT (TODO)
		if ( ( parseFloat($scope.targetPrice) > parseFloat($scope.strikePriceLower)  )
				&& ( parseFloat($scope.targetPrice) < parseFloat($scope.strikePriceUpper) ) ) {
			$scope.greaterOfTargetOrLowerStrike = $scope.strikePriceUpper;
			popoverText.targetProfit = '<p>'  + text['target-profit-bear-call-between-lower-and-higher-strike'] + '</p>'
									 + '<h5>' + text['target-profit'] + '</h5>'
									 + '<table>'
									 + '<tr><td></td><td>' + text['net-premium-received-per-share']  + ' (' + $scope.netPremiumReceivedPerShare + ')' + '</td></tr>'
									 + '<tr><td><strong>&minus;</strong></td><td>' + text['target-price-to-purchase-shares'] + ' (' + $scope.targetPrice + ')' + '</td></tr>'
									 + '<tr><td><strong>&plus;</strong></td><td>' + text['lower-strike-obligation'] + ' (' + $scope.strikePriceLower + ')' + '</td></tr>'
									 + '<tr><td><strong>=</td><td>' + text['target-profit-per-share']  + ' ('  + $scope.targetProfitPerShare + ')' + '</strong></td></tr>'
								     + '<tr><td><strong>&times;</strong></td><td>' + $scope.quantityOfContracts
								                + ' <strong>&times;</strong> '
								                + trade.legs.upper_contract.instrument.blockSize
								                + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</td></tr>'
								     + '<tr><td><strong>=</td><td>' + text['target-profit']  + ' (' + $scope.targetProfit + ')' +  '</strong></td></tr>'
									 + '<tr><td><strong>&divide;</strong></td><td>' + text['max-loss']  + ' ('+ $scope.maxLoss + ')' + '</strong></td></tr>'
									 + '<tr><td><strong>=</td><td>' + text['return-on-max-loss']  + ' ('+ $scope.targetProfitPercent + ')' + '</strong></td></tr>';

		} else if ( parseFloat($scope.targetPrice) <= parseFloat($scope.strikePriceLower) ) {

			$scope.greaterOfTargetOrLowerStrike = $scope.targetPrice;
			popoverText.targetProfit = '<p>'  + text['target-profit-bear-call-equal-or-lower-than-lower-strike'] + '</p>'
									 + '<h5>' + text['target-profit'] + '</h5>'
									 + '<p>' + $scope.netPremiumReceivedPerShare + ' (' + text['net-premium-received-per-share'] + ')' + '</p>'
									 + '<p><strong>= ' + $scope.targetProfitPerShare + ' (' +  text['target-profit-per-share']  + ')' + '</strong></p>'
								     + '<p><strong>&times;</strong> ' + $scope.quantityOfContracts
								                + ' <strong>&times;</strong> '
								                + trade.legs.upper_contract.instrument.blockSize
								                + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
								     + '<p><strong>= '  + $scope.targetProfit + ' (' + text['target-profit'] + ')' +  '</strong></p>'
									 + '<p><strong>&divide;</strong> ' + $scope.maxLoss + ' ('+ text['max-loss'] + ')' + '</strong></p>'
									 + '<p><strong>= ' + $scope.targetProfitPercent + ' ('+ text['return-on-max-loss'] + ')' + '</strong></p>';

		}


		popoverText.netReceived = '<p>'  + text['net-received-bear-call'] + '</p>'
							+ '<h5>' + text['net-premium-received'] + '</h5>'
							+ '<p>'  + $scope.premiumReceivedPerShareShortCall  + ' ('+ text['premium-received-per-share-short-call'] + ')' + '</p>'
							+ '<p><strong>&minus; </strong> ' + $scope.premiumPaidPerShareLongCall   + ' ('+ text['premium-paid-per-share-for-long-call'] + ')' + '</p>'
							+ '<p><strong>= ' + $scope.netPremiumReceivedPerShare + ' ('+ text['net-premium-received-per-share'] + ')' + '</strong></p>'
							+ '<p><strong>&times;</strong> '
									+ $scope.quantityOfContracts
									+ ' <strong>&times;</strong> '
									+ trade.legs.upper_contract.instrument.blockSize
									+ ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
							+ '<p><strong>= ' + $scope.netCost + ' ('+ text['net-premium-received'] + ')' + '</strong></p>';

		popoverText.maxProfit = '<p>'  + text['max-profit-bear-call'] + '</p>'
							  + '<h5>' + text['max-profit'] + '</h5>'
							  + '<p>'  + $scope.netPremiumReceivedPerShare  + ' ('+ text['net-premium-received-per-share'] + ')' + '</p>'
							  + '<p><strong>= '  + $scope.maxProfitPerShare    + ' ('+ text['max-profit-per-share'] + ')' + '</strong></p>'
							  + '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' <strong>&times;</strong> ' + trade.legs.upper_contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
							  + '<p><strong>= ' + $scope.maxProfit + ' ('+ text['max-profit'] + ')' + '</strong></p>'
							  + '<p><strong>&divide;</strong> ' + $scope.maxLoss + ' ('+ text['max-loss'] + ')' + '</strong></p>'
							  + '<p><strong>= ' + $scope.maxProfitPercentage + ' ('+ text['return-on-max-loss'] + ')' + '</strong></p>';

		popoverText.maxLoss = '<p>'  + text['max-loss-bear-call'] + '</p>'
							+ '<h5>' + text['max-loss'] + '</h5>'
							+ '<p>'  + $scope.strikePriceUpper + ' - ' + $scope.strikePriceLower  + ' ('+ text['higher-strike-price-to-lower-strike-price'] + ')' + '</p>'
							+ '<p><strong>&minus;</strong> '  + $scope.netPremiumReceivedPerShare
									 + ' ('+ text['net-premium-received-per-share'] + ')' + '</p>'
							+ '<p><strong>= ' + $scope.maxLossPerShare + ' ('+ text['max-loss-per-share'] + ')' + '</strong></p>'
							+ '<p><strong>&times;</strong> ' + $scope.quantityOfContracts
															 + ' <strong>&times;</strong> '
															 + trade.legs.upper_contract.instrument.blockSize
															 + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
							+ '<p><strong>= ' + $scope.maxLoss + ' ('+ text['max-loss'] + ')' + '</strong></p>'
						    + '<p><strong>= ' + $scope.maxLossPercent + ' ('+ text['return-on-max-loss'] + ')' + '</strong></p>';

		popoverText.targetPrice  = '<p>'  + text['target-price-bear-call'] + '</p>';

		return popoverText;
	};

	// return the singleton object
	return OptionsStrategyBearCallSpread;
}]);

'use strict';

/*
 * Provides the base implementation for all credit spread OptionStrategy{X} services
 */
recogniaApp.factory('OptionsStrategyCreditSpread',
['OptionsStrategyBase', 'OptionsIdeasScore',
function (OptionsStrategyBase, OptionsIdeasScore) {

	function OptionsStrategyCreditSpread (bearish, strategyId) {
		OptionsStrategyBase.call(this, bearish, strategyId);

		OptionsIdeasScore.addStrategySpecificRanges('targetProfitPercent',
			this.strategyId,
			OptionsIdeasScore.getBaseActualFn('targetProfitPercent'),
			function () {
				return [
					{
						scores: ['AAA'],
						range: new NumberRange(1.0, true, Infinity, true),
						lexKey: 'fsTarget.j_profit_c1',
						lexKeyLimiting: 'fsTarget.j_profit_c1'
					},
					{
						scores: ['AA'],
						range: new NumberRange(0.75, true, 1.0, false),
						lexKey: 'fsTarget.j_profit_c3',
						lexKeyLimiting: 'fsTarget.j_profit_c2'
					},
					{
						scores: ['A'],
						range: new NumberRange(0.5, true, 0.75, false),
						lexKey: 'fsTarget.j_profit_c3',
						lexKeyLimiting: 'fsTarget.j_profit_c2'
					},
					{
						scores: ['C'],
						range: new NumberRange(0.0, false, 0.5, false),
						lexKey: 'fsTarget.j_profit_c5',
						lexKeyLimiting: 'fsTarget.j_profit_c4'
					},
					{
						scores: ['X'],
						range: new NumberRange(-Infinity, true, 0.0, true),
						lexKey: null,
						lexKeyLimiting: 'fsTarget.j_profit_c6'
					}
				];
			});
	}
	OptionsStrategyCreditSpread.prototype = Object.create(OptionsStrategyBase.prototype);
	OptionsStrategyCreditSpread.prototype.constructor = OptionsStrategyCreditSpread;

	return OptionsStrategyCreditSpread;
}]);

'use strict';

/**
 * This is the implementation for Bear Call Spread strategy
 * Do not inject this service, instead use the OptionsStrategy service
 *
 * NOTE: Methods are stubbed out for now to assist implementation of charting
 */
recogniaApp.factory('OptionsStrategyBearPutSpread',
['OptionsStrategyBase','Lexicon','NumberFormatter', 'Ideas', 'OptionsStrategyConstants',
function (OptionsStrategyBase, Lexicon, NumberFormatter, Ideas, OptionsStrategyConstants) {

	var ogtext = {};
	var textKeys = [
		'net-cost-bear-put','max-loss-bear-put','net-premium-paid','premium-paid-per-share-for-long-call',
		'premium-paid-per-share-for-long-put', 'premium-received-per-share-short-put',
		'premium-received-per-share-short-call','net-premium-paid-per-share','max-profit-bear-put',
		'max-profit','higher-strike-price-to-lower-strike-price','quantity-of-contracts-x-shares-per-contract',
		'return-on-max-loss','target-price','target-price-bear-put','target-price-bear-put-less-than-strike',
		'max-profit-per-share','target-profit-bear-put-greater-than-equal-strike','target-profit-bear-put-less-than-strike',
		'target-price-bear-put-less-than-strike','stock-purchase-price','premium-paid-per-share','target-profit-per-share',
		'return','target-profit','greater-of-target-and-lower','higher-strike-price','target-profit-bear-put'

	];
	textKeys.forEach(
		function(value) {
			ogtext[value] = Lexicon.translateDefaultNS('options_strategy_details.' + value);
		}
	);

	var OptionsStrategyBearPutSpread = new OptionsStrategyBase(true,
			OptionsStrategyConstants.OPTIONS_STRATEGY.bearputspread);

	/**
	 *
	 * A string representing the name of the tooltip context in the lexicon
	 */
	OptionsStrategyBearPutSpread.getTurningPointsToolTipNames = function () {
		return ["tt-max-profit-X-or-lower", "tt-max-loss-X-or-higher"];
	};

	OptionsStrategyBearPutSpread.getPopoverDisaplyObj = function( idea, trade ) {
		return {
			"netCost": NumberFormatter.formatCurrency(
				trade.netCost,
				idea.instrument.precision
			),//
			"shareCost": NumberFormatter.formatCurrency(
				idea.instrument.latestPrice.ask,
				idea.instrument.precision
			),
			"strikePrice": NumberFormatter.formatCurrency(
				idea.instrument.strikePrice,
				idea.instrument.precision
			),//
			"stockPurchasePrice": NumberFormatter.formatCurrency(
				trade.legs.lower_contract.instrument.latestPrice.bid,
				idea.instrument.precision
			),//
			"premiumPaidPerShare": NumberFormatter.formatCurrency(
				trade.netCost/trade.legs.upper_contract.instrument.blockSize,
				idea.instrument.precision
			),//
			"premiumPaid": NumberFormatter.formatCurrency(
				trade.netCost,
				idea.instrument.precision
			),//
			"premiumPaidPerShareLongCall": NumberFormatter.formatCurrency(
				trade.legs.upper_contract.instrument.latestPrice.ask,
				idea.instrument.precision
			),//
			"premiumPaidLongCall": NumberFormatter.formatCurrency(
				trade.legs.upper_contract.instrument.latestPrice.ask*trade.legs.upper_contract.instrument.blockSize,
				idea.instrument.precision
			),//
			"premiumReceivedPerShareShort": NumberFormatter.formatCurrency(
				trade.legs.lower_contract.instrument.latestPrice.bid,
				idea.instrument.precision
			),//
			"premiumReceivedShort": NumberFormatter.formatCurrency(
				trade.legs.lower_contract.instrument.latestPrice.bid*trade.legs.upper_contract.instrument.blockSize,
				idea.instrument.precision
			),//
			"netCostPerShare": NumberFormatter.formatCurrency(
				trade.netCost/trade.legs.upper_contract.instrument.blockSize,
				idea.instrument.precision
			),//
			"quantityOfContracts": NumberFormatter.formatInteger(trade.legs.upper_contract.quantity),//
			"targetPrice": NumberFormatter.formatCurrency(
				Ideas.getConservativeTargetPrice(idea),
				idea.instrument.precision
			),//
			"targetPriceLower": NumberFormatter.formatCurrency(
				idea.targetPrice.lower,
				idea.instrument.precision
			),//
			"targetPriceUpper": NumberFormatter.formatCurrency(
				idea.targetPrice.upper,
				idea.instrument.precision
			),//
			"strikePriceLower": NumberFormatter.formatCurrency(
				trade.legs.lower_contract.instrument.strikePrice,
				idea.instrument.precision
			),//
			"strikePriceUpper": NumberFormatter.formatCurrency(
				trade.legs.upper_contract.instrument.strikePrice,
				idea.instrument.precision
			),//
			"maxProfit": NumberFormatter.formatCurrency(
				trade.maxProfit,
				idea.instrument.precision
			),//
			"maxProfitPercentage": NumberFormatter.percent(
				trade.maxProfitPercent, 0
			),//
			"maxProfitPerShare": NumberFormatter.formatCurrency(
				trade.maxProfit/trade.legs.upper_contract.instrument.blockSize,
				idea.instrument.precision
			),//
			"maxLossPercentage": NumberFormatter.percent(
				idea.trade.maxLossPercent, 0
			),//
			"maxLoss": NumberFormatter.formatCurrency(
				trade.maxLoss,
				idea.instrument.precision
			),//
			"targetProfit": NumberFormatter.formatCurrency(
				trade.targetProfit,
				idea.instrument.precision
			),//
			"targetProfitPercent": NumberFormatter.percent(
				idea.trade.targetProfitPercent, 0
			),//
			"targetProfitPerShare": NumberFormatter.formatCurrency(
				trade.targetProfit/trade.legs.lower_contract.instrument.blockSize,
				idea.instrument.precision
			),//
			"netPremiumPaidPerShare": NumberFormatter.formatCurrency(
				trade.netCost/trade.legs.upper_contract.instrument.blockSize,
				idea.instrument.precision
			),//
			"stockPrice": NumberFormatter.formatCurrency(
				idea.instrument.latestPrice.price,
				idea.instrument.precision
			)//

		};
	};

	OptionsStrategyBearPutSpread.getPopoverText = function($scope, $interpolate, idea, trade) {
		var popoverText = {};
		$scope.popover = OptionsStrategyBearPutSpread.getPopoverDisaplyObj( idea, trade );
		var text = {};

		Object.keys(ogtext).forEach(function (i){
			text[i] = $scope.$eval( $interpolate( ogtext[i] ) );
		});

		if ($scope.popover.strikePriceLower > $scope.popover.targetPrice) {
			$scope.popover.greaterOfTargetPriceAndLowerStrike = $scope.popover.strikePriceLower;
			popoverText.targetProfit = '<p>'  + text['target-profit-bear-put-less-than-strike'] + '</p>';
		} else if ($scope.popover.strikePriceLower <= $scope.popover.targetPrice) {
			$scope.popover.greaterOfTargetPriceAndLowerStrike = $scope.popover.targetPrice;
			popoverText.targetProfit = '<p>'  + text['target-profit-bear-put-greater-than-equal-strike'] + '</p>';

		}

		popoverText.netCost = '<p>'  + text['net-cost-bear-put'] + '</p>'
							+ '<h5>' + text['net-premium-paid'] + '</h5>'
							+ '<p>' + $scope.popover.premiumPaidPerShareLongCall   + ' ('+ text['premium-paid-per-share-for-long-put'] + ')' + '</p>'
							+ '<p><strong>-</strong> '  + $scope.popover.premiumReceivedPerShareShort  + ' ('+ text['premium-received-per-share-short-put'] + ')' + '</p>'
							+ '<p><strong>= ' + $scope.popover.premiumPaidPerShare + ' ('+ text['net-premium-paid-per-share'] + ')' + '</strong></p>'
							+ '<p><strong>&times;</strong> ' + $scope.popover.quantityOfContracts + ' <strong>&times;</strong> ' + trade.legs.upper_contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
							+ '<p><strong>= ' + $scope.popover.premiumPaid + ' ('+ text['net-premium-paid'] + ')' + '</strong></p>';

		popoverText.maxProfit = '<p>'  + text['max-profit-bear-put'] + '</p>'
							  + '<h5>' + text['max-profit'] + '</h5>'
							  + '<p>'  + $scope.popover.strikePriceUpper + ' <strong>-</strong> ' + $scope.popover.strikePriceLower  + ' ('+ text['higher-strike-price-to-lower-strike-price'] + ')' + '</p>'
							  + '<p><strong>-</strong> '  + $scope.popover.netPremiumPaidPerShare  + ' ('+ text['net-premium-paid-per-share'] + ')' + '</p>'
							  + '<p><strong>= '  + $scope.popover.maxProfitPerShare    + ' ('+ text['max-profit-per-share'] + ')' + '</strong></p>'
							  + '<p><strong>&times;</strong> ' + $scope.popover.quantityOfContracts + ' <strong>&times;</strong> ' + trade.legs.upper_contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
							  + '<p><strong>= ' + $scope.popover.maxProfit + ' ('+ text['max-profit'] + ')' + '</strong></p>'
							  + '<p><strong>&divide;</strong> '+ $scope.popover.premiumPaid  + ' ('+ text['net-premium-paid'] + ')' + '</strong></p>'
							  + '<p><strong>= ' + $scope.popover.maxProfitPercentage + ' ('+ text['return'] + ')' + '</strong></p>';

		popoverText.maxLoss = '<p>'  + text['max-loss-bear-put'] + '</p>';

		popoverText.targetPrice  = '<p>'  + text['target-price-bear-put'] + '</p>';

		popoverText.targetProfit += '<h5>' + text['target-profit'] + '</h5>'
								 + '<p>' + $scope.popover.strikePriceUpper   + ' ('+ text['higher-strike-price'] + ')' + '</p>'
								 + '<p><strong>-</strong> '  + $scope.popover.greaterOfTargetPriceAndLowerStrike + ' (' + text['greater-of-target-and-lower'] + ')' +  '</p>'
								 + '<p><strong>-</strong> ' + $scope.popover.premiumPaidPerShare         + ' (' + text['net-premium-paid-per-share'] + ')' +  '</p>'
								 + '<p><strong>= ' + $scope.popover.targetProfitPerShare        + ' (' + text['target-profit-per-share'] + ')' +  '</strong></p>'
								 + '<p><strong>&times; </strong> ' + $scope.popover.quantityOfContracts + ' <strong>&times;</strong> ' + trade.legs.upper_contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
								 + '<p><strong>= ' + $scope.popover.targetProfit + ' (' + text['target-profit'] + ')' +  '</strong></p>'
								 + '<p><strong>&divide;</strong> ' + $scope.popover.netCost + ' ('+ text['net-premium-paid'] + ')' + '</strong></p>'
								 + '<p><strong>= ' + $scope.popover.targetProfitPercent + ' ('+ text['return'] + ')' + '</strong></p>';
		return popoverText;
	};

	// return the singleton object
	return OptionsStrategyBearPutSpread;
}]);

'use strict';
/**
 * This is the implementation for Bull Call Spread strategy
 * Do not inject this service, instead use the OptionsStrategy service
 *
 * NOTE: Methods are stubbed out for now to assist implementation of charting
 */
recogniaApp.factory('OptionsStrategyBullCallSpread',
['OptionsStrategyBase', 'Lexicon', 'NumberFormatter', 'Ideas', 'OptionsStrategyConstants',
function (OptionsStrategyBase, Lexicon, NumberFormatter, Ideas, OptionsStrategyConstants) {

	var ogtext = {};
	var textKeys = [
		'net-cost-bull-call-spread','max-profit-bull-call-spread','max-loss-bull-call-spread',
		'target-price-bull-call-spread','target-profit-bull-call-spread','net-premium-paid',
		'net-premium-paid-title','premium-paid-for-long-call','premium-paid-per-share-short-call',
		'premium-paid-per-share-short-call','premium-paid-per-share-for-long-call',
		'premium-received-per-share-short-call','net-premium-paid-per-share',
		'quantity-of-contracts-x-shares-per-contract','quantity-of-contracts','higher-strike-price-to-lower-strike-price',
		'max-profit-per-share','maximum-profit','return','breakeven-point','target-profit-per-share',
		'target-profit','lower-strike-exercised', 'higher-strike-obligated', 'target-price-sell',
		'target-profit-bull-call-spread-exceeds-strike'
	];
	textKeys.forEach(
		function(value) {
			ogtext[value] = Lexicon.translateDefaultNS('options_strategy_details.' + value);
		}
	);

	var OptionsStrategyBullCallSpread = new OptionsStrategyBase(false,
			OptionsStrategyConstants.OPTIONS_STRATEGY.bullcallspread);

	/**
	 *
	 * A string representing the name of the tooltip context in the lexicon
	 */
	OptionsStrategyBullCallSpread.getTurningPointsToolTipNames = function () {
		return ["tt-max-loss-X-or-lower", "tt-max-profit-X-or-higher"];
	};

	OptionsStrategyBullCallSpread.getPopoverText = function($scope, $interpolate, idea, trade) {
		var popoverText = {};
		var text = {};
		var exceedsStrike = Ideas.getConservativeTargetPrice(idea) > trade.legs.upper_contract.instrument.strikePrice;

		$scope.netCost = NumberFormatter.formatCurrency(
			trade.netCost,
			idea.instrument.precision
		);
		$scope.netCostPerShare = NumberFormatter.formatCurrency(
			trade.netCost,
			idea.instrument.precision
		);
		$scope.netPremiumPaid = NumberFormatter.formatCurrency(
			trade.netCost,
			idea.instrument.precision
		);
		$scope.netPremiumPaidPerShare = NumberFormatter.formatCurrency(
			trade.netCost/trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);
		$scope.premiumPaidLongCall = NumberFormatter.formatCurrency(
			trade.legs.lower_contract.instrument.latestPrice.ask*trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);
		$scope.premiumPaidLongCallPerShare = NumberFormatter.formatCurrency(
			trade.legs.lower_contract.instrument.latestPrice.ask,
			idea.instrument.precision
		);
		$scope.premiumReceivedShort = NumberFormatter.formatCurrency(
			trade.legs.upper_contract.instrument.latestPrice.bid*trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);
		$scope.premiumReceivedShortPerShare = NumberFormatter.formatCurrency(
			trade.legs.upper_contract.instrument.latestPrice.bid,
			idea.instrument.precision
		);

		$scope.quantityOfContracts = NumberFormatter.formatInteger(trade.legs.lower_contract.quantity);


		$scope.strikePriceLower = NumberFormatter.formatCurrency(
			trade.legs.lower_contract.instrument.strikePrice,
			idea.instrument.precision
		);

		$scope.strikePriceUpper = NumberFormatter.formatCurrency(
			trade.legs.upper_contract.instrument.strikePrice,
			idea.instrument.precision
		);

		$scope.maxProfitPerShare = NumberFormatter.formatCurrency(
			trade.maxProfit/trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);

		$scope.maxProfit = NumberFormatter.formatCurrency(
			trade.maxProfit,
			idea.instrument.precision
		);

		$scope.maxProfitPercentage = NumberFormatter.percent(
			trade.maxProfitPercent, 0
		);

		$scope.targetPrice = NumberFormatter.formatCurrency(
			Ideas.getConservativeTargetPrice(idea),
			idea.instrument.precision
		);
		$scope.targetPriceLower = NumberFormatter.formatCurrency(
			idea.targetPrice.lower,
			idea.instrument.precision
		);
		$scope.targetPriceUpper = NumberFormatter.formatCurrency(
			idea.targetPrice.upper,
			idea.instrument.precision
		);
		$scope.targetProfitPercent =  NumberFormatter.percent(
			idea.trade.targetProfitPercent, 0
		);
		$scope.targetProfit = NumberFormatter.formatCurrency(
			trade.targetProfit,
			idea.instrument.precision
		);

		$scope.targetProfitPerShare = NumberFormatter.formatCurrency(
			trade.targetProfit/trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);

		Object.keys(ogtext).forEach(function (i){
			text[i] = $scope.$eval( $interpolate( ogtext[i] ) );
		});
		popoverText.netCost = '<p>'  + text['net-cost-bull-call-spread'] + '</p>'
							+ '<h5>' + text['net-premium-paid-title'] + '</h5>'
							+ '<p>'  + $scope.premiumPaidLongCallPerShare  + ' ('+ text['premium-paid-per-share-for-long-call'] + ')' + '</p>'
							+ '<p><strong>&minus;</strong> ' + $scope.premiumReceivedShortPerShare   + ' ('+ text['premium-received-per-share-short-call'] + ')' + '</p>'
							+ '<p><strong>= ' + $scope.netPremiumPaidPerShare + ' ('+ text['net-premium-paid-per-share'] + ')' + '</strong></p>'
							+ '<p><strong>&times; </strong>' + $scope.quantityOfContracts + ' <strong>&times;</strong> ' + trade.legs.lower_contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
							+ '<p><strong>= ' + $scope.netPremiumPaid + ' ('+ text['net-premium-paid-title'] + ')' + '</strong></p>';

		popoverText.maxProfit = '<p>'  + text['max-profit-bull-call-spread'] + '</p>'
							  + '<h5>' + text['maximum-profit'] + '</h5>'
							  + '<p>'  + $scope.strikePriceUpper  + ' - ' + $scope.strikePriceLower + ' (' + text['higher-strike-price-to-lower-strike-price'] + ')' + '</p>'
							  + '<p><strong>&minus;</strong> '  + $scope.netPremiumPaidPerShare + ' ('  + text['net-premium-paid-per-share'] + ')' + '</p>'
							  + '<p><strong>= '  + $scope.maxProfitPerShare + ' ('+ text['max-profit-per-share'] + ')' + '</strong></p>'
							  + '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' <strong>&times;</strong> ' + trade.legs.lower_contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
							  + '<p><strong>= ' + $scope.maxProfit   + ' (' + text['maximum-profit'] + ')' + '</strong></p>'
							  + '<p><strong>&divide;</strong> ' + $scope.netPremiumPaid   + ' (' + text['net-premium-paid-title'] + ')' + '</p>'
							  + '<p><strong>= ' + $scope.maxProfitPercentage   + ' (' + text['return'] + ')' + '</strong></p>';

		popoverText.maxLoss = '<p>' + text['max-loss-bull-call-spread'] + '</p>';
		popoverText.targetPrice = '<p>' + text['target-price-bull-call-spread'] + '</p>';
		popoverText.targetProfit = '<p>' + text['target-profit-bull-call-spread' + (exceedsStrike ? '-exceeds-strike' : '')] + '</p>'
								 + '<h5>' + text['target-profit'] + '</h5>'
								 + '<p><strong>&minus;</strong> '  + $scope.netPremiumPaidPerShare + ' (' + text['net-premium-paid-per-share'] + ')'  + '</p>'
								 + '<p><strong>&minus;</strong> '  + text['lower-strike-exercised'] + '</p>'
								 + '<p><strong>&plus;</strong> '  + text[exceedsStrike ? 'higher-strike-obligated' : 'target-price-sell'] + '</p>'
								 + '<p><strong>= ' + $scope.targetProfitPerShare   + ' (' + text['target-profit-per-share'] + ')' + '</strong></p>'
								 + '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' <strong>&times;</strong> ' + trade.legs.lower_contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
								 + '<p><strong>= ' + $scope.targetProfit + ' (' + text['target-profit'] + ')' +  '</strong></p>'
								 + '<p><strong>&divide;</strong> ' + $scope.netPremiumPaid + ' ('+ text['net-premium-paid'] + ')' + '</strong></p>'
								 + '<p><strong>= ' + $scope.targetProfitPercent + ' ('+ text['return'] + ')' + '</strong></p>';

		return popoverText;
	};

	// return the singleton object
	return OptionsStrategyBullCallSpread;
}]);

'use strict';
/**
 * This is the implementation for Bull Call Spread strategy
 * Do not inject this service, instead use the OptionsStrategy service
 *
 * NOTE: Methods are stubbed out for now to assist implementation of charting
 */
recogniaApp.factory('OptionsStrategyBullPutSpread',
['OptionsStrategyCreditSpread', 'Lexicon', 'NumberFormatter', 'OptionsStrategyConstants', 'Ideas',
function (OptionsStrategyCreditSpread, Lexicon, NumberFormatter, OptionsStrategyConstants, Ideas) {

	var ogtext = {};
	var textKeys = [
		'max-loss',
		'max-loss-bull-put',
		'max-profit',
		'max-profit-bull-put',
		'net-premium-received',
		'net-premium-received-per-share',
		'net-received-bull-put',
		'premium-paid-per-share-long-put',
		'premium-received-per-share-short-put',
		'target-price-bull-put',
		'bull-put-target-price-less-than-or-equal-higher-strike',
		'bull-put-target-price-greater-than-higher-strike',
		'higher-strike-price-to-lower-strike-price',
		'return-on-max-loss',
		'negative-return-on-max-loss',
		'quantity-of-contracts-x-shares-per-contract',
		'max-loss-per-share',
		'lesser-of-target-price-or-higher-strike',
		'target-profit',
		'target-profit-per-share',
		'breakeven-point',
		'return',
		'max-profit-per-share',
		'higher-strike-obligation',
		'target-price-to-sell'
	];
	textKeys.forEach(
		function(value) {
			ogtext[value] = Lexicon.translateDefaultNS('options_strategy_details.' + value);
		}
	);

	var OptionsStrategyBullPutSpread = new OptionsStrategyCreditSpread(false,
			OptionsStrategyConstants.OPTIONS_STRATEGY.bullputspread);

	/**
	 *
	 * A string representing the name of the tooltip context in the lexicon
	 */
	OptionsStrategyBullPutSpread.getTurningPointsToolTipNames = function () {
		return ["tt-max-loss-X-or-lower", "tt-max-profit-X-or-higher"];
	};

	OptionsStrategyBullPutSpread.getPopoverText = function($scope, $interpolate, idea, trade) {

		var popoverText = {};
		var text = {};

		$scope.netCost = NumberFormatter.formatCurrency(
			Math.abs(trade.netCost),
			idea.instrument.precision
		);//
		$scope.netPremiumReceived = NumberFormatter.formatCurrency(
			Math.abs(trade.netCost),
			idea.instrument.precision
		);//
		$scope.netPremiumReceivedPerShare = NumberFormatter.formatCurrency(
			Math.abs(trade.netCost)/trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);//
		$scope.shareCost =  NumberFormatter.formatCurrency(
			idea.instrument.latestPrice.ask,
			idea.instrument.precision
		); //???????????
		$scope.breakEvenPoint = NumberFormatter.formatCurrency(
			idea.trade.profitZone[0].lower,
			idea.instrument.precision
		);//

		$scope.netCostPerShare = NumberFormatter.formatCurrency(
			trade.netCost/trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);//
		$scope.quantityOfContracts = NumberFormatter.formatInteger(trade.legs.lower_contract.quantity);

		$scope.targetPrice = NumberFormatter.formatCurrency(
			Ideas.getConservativeTargetPrice(idea),
			idea.instrument.precision
		);//
		$scope.targetProfit = NumberFormatter.formatCurrency(
			trade.targetProfit,
			idea.instrument.precision
		);//

		$scope.targetProfitPercent =  NumberFormatter.percent(
			idea.trade.targetProfitPercent, 0
		);//

		$scope.targetProfitPerShare = NumberFormatter.formatCurrency(
			trade.targetProfit/trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);//
		$scope.targetPriceLower = NumberFormatter.formatCurrency(
			idea.targetPrice.lower,
			idea.instrument.precision
		);//
		$scope.targetPriceUpper = NumberFormatter.formatCurrency(
			idea.targetPrice.upper,
			idea.instrument.precision
		);//

		$scope.premiumReceivedShortPutPerShare = NumberFormatter.formatCurrency(
			trade.legs.upper_contract.instrument.latestPrice.bid,
			idea.instrument.precision
		);//

		$scope.premiumReceivedLongPutPerShare = NumberFormatter.formatCurrency(
			trade.legs.lower_contract.instrument.latestPrice.ask,
			idea.instrument.precision
		);//

		$scope.premiumReceivedShortPut = NumberFormatter.formatCurrency(
			trade.legs.upper_contract.instrument.latestPrice.bid*trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);//

		$scope.premiumReceivedLongPut = NumberFormatter.formatCurrency(
			trade.legs.lower_contract.instrument.latestPrice.ask*trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);//

		$scope.strikePriceLower = NumberFormatter.formatCurrency(
			trade.legs.lower_contract.instrument.strikePrice,
			idea.instrument.precision
		);//
		$scope.strikePriceUpper = NumberFormatter.formatCurrency(
			trade.legs.upper_contract.instrument.strikePrice,
			idea.instrument.precision
		);//
		$scope.maxLossPercentage = NumberFormatter.percent(
			Math.abs(idea.trade.maxLossPercent), 0
		);//
		$scope.maxLoss = NumberFormatter.formatCurrency(
			Math.abs(trade.maxLoss),
			idea.instrument.precision
		);//
		$scope.maxLossPerShare = NumberFormatter.formatCurrency(
			Math.abs(trade.maxLoss)/trade.legs.lower_contract.instrument.blockSize,
			idea.instrument.precision
		);//


		$scope.maxProfitPercentage = NumberFormatter.percent(
			Math.abs(trade.maxProfitPercent), 0
		);//
		$scope.maxProfitPerShare = NumberFormatter.formatCurrency(
			Math.abs(trade.maxProfit)/trade.legs.upper_contract.instrument.blockSize,
			idea.instrument.precision
		);//
		$scope.maxProfit = NumberFormatter.formatCurrency(
			Math.abs(trade.maxProfit),
			idea.instrument.precision
		);//

		$scope.stockPrice =  NumberFormatter.formatCurrency(
			idea.instrument.latestPrice.price,
			idea.instrument.precision
		);//

		Object.keys(ogtext).forEach(function (i){
			text[i] = $scope.$eval( $interpolate( ogtext[i] ) );
		});

		if ( $scope.targetPrice <= $scope.strikePriceUpper) {
			$scope.lesserTargetPriceOrHigherStrike = $scope.targetPrice;
			popoverText.targetProfit = '<p>' + text['bull-put-target-price-less-than-or-equal-higher-strike'] + '</p>'
									 + '<h5>' + text['target-profit'] + '</h5>'
									 + '<p> ' + $scope.netPremiumReceivedPerShare + ' (' + text['net-premium-received-per-share'] + ')' + '</p>'
									 + '<p><strong>-</strong> ' + $scope.strikePriceUpper +  ' (' + text['higher-strike-obligation'] + ')' + '</p>'
									 + '<p><strong>+</strong> ' + $scope.targetPrice + ' (' +  text['target-price-to-sell'] + ')' + '</p>'
									 + '<p><strong>= ' + $scope.targetProfitPerShare + ' (' + text['target-profit-per-share'] + ')' + '</strong></p>'
									 + '<p><strong>&times; </strong>' + $scope.quantityOfContracts
										+ ' <strong>&times;</strong> '
										+ trade.legs.lower_contract.instrument.blockSize
										+ ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
									 + '<p><strong>= ' + $scope.targetProfit + ' (' + text['target-profit'] + ')' + '</strong></p>'
									 + '<p><strong>&divide;</strong> ' + $scope.maxLoss + ' (' + text['max-loss'] + ')' + '</p>'
									 + '<p><strong>= ' + $scope.targetProfitPercent + ' (' + text['return-on-max-loss'] + ')' + '</strong></p>';
		} else if ($scope.targetPrice > $scope.strikePriceUpper) {
			$scope.lesserTargetPriceOrHigherStrike = $scope.strikePriceUpper;
			popoverText.targetProfit = '<p>'  + text['bull-put-target-price-greater-than-higher-strike'] + '</p>'
									 + '<h5>' + text['target-profit'] + '</h5>'
									 + '<p>' + $scope.netPremiumReceivedPerShare + ' (' + text['net-premium-received-per-share'] + ')' + '</p>'
									 + '<p><strong>= ' + $scope.targetProfitPerShare + ' (' + text['target-profit-per-share'] + ')' + '</strong></p>'
									 + '<p><strong>&times; </strong>' + $scope.quantityOfContracts
										+ ' <strong>&times;</strong> '
										+ trade.legs.lower_contract.instrument.blockSize
										+ ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
									 + '<p><strong>= ' + $scope.maxProfit + ' (' + text['max-profit'] + ')' + '</strong></p>'
									 + '<p><strong>&divide;</strong> ' + $scope.maxLoss + ' (' + text['max-loss'] + ')' + '</p>'
									 + '<p><strong>= ' + $scope.maxProfitPercentage + ' (' + text['return-on-max-loss'] + ')' + '</strong></p>';
		}
		popoverText.netReceived = '<p>'  + text['net-received-bull-put'] + '</p>'
								+ '<h5>' + text['net-premium-received']  + '</h5>'
								+ '<p>'  + $scope.premiumReceivedShortPutPerShare + ' (' + text['net-premium-received-per-share'] + ')' + '</p>'
								+ '<p><strong>&minus;</strong> '  + $scope.premiumReceivedLongPutPerShare + ' (' + text['premium-paid-per-share-long-put'] + ')' + '</p>'
								+ '<p><strong>= ' + $scope.netPremiumReceivedPerShare + ' (' + text['net-premium-received-per-share'] + ')' + '</strong></p>'
								+ '<p><strong>&times; </strong>' + $scope.quantityOfContracts
												+ ' <strong>&times;</strong> '
												+ trade.legs.lower_contract.instrument.blockSize
												+ ' (' + text['quantity-of-contracts-x-shares-per-contract']
												+ ')' +  '</p>'
								+ '<p><strong>= ' + $scope.netPremiumReceived + ' (' + text['net-premium-received'] + ')' + '</strong></p>';
		popoverText.maxProfit = '<p>'  + text['max-profit-bull-put'] + '</p>'
							  + '<h5>' + text['max-profit'] + '</h5>'
							  + '<p>'  + $scope.maxProfitPerShare + ' (' + text['premium-received-per-share-short-put'] + ')' + '</p>'
							  + '<p><strong>= ' + $scope.maxProfitPerShare + ' (' + text['max-profit-per-share'] + ')' + '</strong></p>'
							  + '<p><strong>&times; </strong>' + $scope.quantityOfContracts
												+ ' <strong>&times;</strong> '
												+ trade.legs.lower_contract.instrument.blockSize
												+ ' (' + text['quantity-of-contracts-x-shares-per-contract']
												+ ')' +  '</p>'
							  + '<p><strong>= ' + $scope.maxProfit + ' (' + text['max-profit'] + ')' + '</strong></p>'
							  + '<p><strong>&divide;</strong> ' + $scope.maxLoss + ' (' + text['max-loss'] + ')' + '</p>'
							  + '<p><strong>= ' + $scope.maxProfitPercentage + ' (' + text['return-on-max-loss'] + ')' + '</strong></p>';
		popoverText.maxLoss = '<p>'  + text['max-loss-bull-put'] + '</p>'
							+ '<h5>' + text['max-loss'] + '</h5>'
							+ '<p>'  + $scope.strikePriceUpper
									 + ' - ' + $scope.strikePriceLower
									 + ' (' + text['higher-strike-price-to-lower-strike-price']+ ')'
									 + '</p>'
							+ '<p><strong>-</strong> ' + $scope.netPremiumReceivedPerShare + ' (' + text['net-premium-received-per-share'] + ')' + '</p>'
							+ '<p><strong>= ' + $scope.maxLossPerShare + ' (' + text['max-loss-per-share'] + ')' + '</strong></p>'
							+ '<p><strong>&times; </strong>' + $scope.quantityOfContracts
															 + ' <strong>&times;</strong> '
															 + trade.legs.lower_contract.instrument.blockSize
															 + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')'
															 +  '</p>'
							+ '<p><strong>= ' + $scope.maxLoss + ' (' + text['max-loss'] + ')' + '</strong></p>'
							+ '<p><strong>= ' + $scope.maxLossPercentage + ' (' + text['negative-return-on-max-loss'] + ')' + '</strong></p>';

		popoverText.targetPrice = '<p>'  + text['target-price-bull-put'] + '</p>';

		return popoverText;
	};

	// return the singleton object
	return OptionsStrategyBullPutSpread;
}]);

'use strict';
/**
 * This is the implementation for BuyWrite strategy
 * Do not inject this service, instead use the OptionsStrategy service
 */
recogniaApp.factory('OptionsStrategyBuyWrite',
['OptionsStrategyBase', 'Lexicon', 'NumberFormatter','OptionsStrategyConstants', 'OptionsIdeasScore', 'Ideas',
function (OptionsStrategyBase, Lexicon, NumberFormatter, OptionsStrategyConstants, OptionsIdeasScore, Ideas) {

	var OptionsStrategyBuyWrite = new OptionsStrategyBase(false,
			OptionsStrategyConstants.OPTIONS_STRATEGY.buywrite);

	OptionsIdeasScore.disableFactorForStrategy('volume', OptionsStrategyBuyWrite.strategyId);
	OptionsIdeasScore.disableFactorForStrategy('priceSpread', OptionsStrategyBuyWrite.strategyId);
	OptionsIdeasScore.addStrategySpecificRanges('targetProfitPercent',
		OptionsStrategyBuyWrite.strategyId,
		OptionsIdeasScore.getBaseActualFn('targetProfitPercent'),
		function () {
			return [
				{
					scores: ['AAA', 'AA'],
					range: new NumberRange(0.10, true, Infinity, true),
					lexKey: 'fsTarget.j_profit_b1',
					lexKeyLimiting: 'fsTarget.j_profit_b1'
				},
				{
					scores: ['A'],
					range: new NumberRange(0.04, true, 0.10, false),
					lexKey: 'fsTarget.j_profit_b3',
					lexKeyLimiting: 'fsTarget.j_profit_b2'
				},
				{
					scores: ['C'],
					range: new NumberRange(0.0, false, 0.04, false),
					lexKey: 'fsTarget.j_profit_b5',
					lexKeyLimiting: 'fsTarget.j_profit_b4'
				},
				{
					scores: ['X'],
					range: new NumberRange(-Infinity, true, 0.0, true),
					lexKey: null,
					lexKeyLimiting: 'fsTarget.j_profit_b6'
				}
			];
		});


	OptionsIdeasScore.addStrategySpecificRanges('moneyness',
		OptionsStrategyBuyWrite.strategyId,
		function (idea) {
			return parseFloat(idea.trade.legs.contract.instrument.strikePrice);
		},
		function (idea) {
			var currentPrice = parseFloat(idea.trade.legs.instrument.instrument.latestPrice.price);
			return [
				{
					scores: ['X'],
					range: new NumberRange(0, true, currentPrice, false),
					lexKey: null,
					lexKeyLimiting: 'fsTarget.j_moneyness_a1'
				}
			];
		});
	OptionsIdeasScore.addStrategySpecificRanges('contractToStockPriceRatio',
		OptionsStrategyBuyWrite.strategyId,
		function (idea) {
			var contractBid = parseFloat(idea.trade.legs.contract.instrument.latestPrice.bid),
			instrumentAsk = parseFloat(idea.trade.legs.instrument.instrument.latestPrice.price);
			return contractBid / instrumentAsk;
		},
		function () {
			return [
				{
					scores: ['AAA'],
					range: new NumberRange(0.04, true, Infinity, true),
					lexKey: 'fsTarget.j_optionstockprice_a1',
					lexKeyLimiting: 'fsTarget.j_optionstockprice_a1'
				},
				{
					scores: ['AA'],
					range: new NumberRange(0.03, true, 0.4, false),
					lexKey: 'fsTarget.j_optionstockprice_a2',
					lexKeyLimiting: 'fsTarget.j_optionstockprice_a2'
				},
				{
					scores: ['A'],
					range: new NumberRange(0.02, true, 0.03, false),
					lexKey: 'fsTarget.j_optionstockprice_a1',
					lexKeyLimiting: 'fsTarget.j_optionstockprice_a2'
				},
				{
					scores: ['C'],
					range: new NumberRange(0.01, false, 0.02, false),
					lexKey: 'fsTarget.j_optionstockprice_a1',
					lexKeyLimiting: 'fsTarget.j_optionstockprice_a2'
				},
				{
					scores: ['X'],
					range: new NumberRange(-Infinity, true, 0.01, true),
					lexKey: null,
					lexKeyLimiting: 'fsTarget.j_optionstockprice_a3'
				}
			];
		});

	var ogtext = {};
	var textKeys = [
		'net-cost-buy-rite','max-profit-buy-rite','max-profit',
		'target-price-buy-rite','target-profit-buy-rite-1','target-profit-buy-rite-2',
		'quantity-of-contracts-x-shares-per-contract','strike-price',
		'net-cost','return','stock-purchase-price','premium-paid-per-share','net-cost-per-share',
		'max-profit-title','max-loss-per-share','target-price','target-profit',
		'break-even-point','target-profit-per-share','target-profit','maximum-loss',
		'max-loss-buy-rite','premium-received-per-share-short-call','premium-received-per-share',
		'strike-price-of-the-call','max-profit-per-share','lesser-of-strike-and-target'

	];
	textKeys.forEach(
		function(value) {
			ogtext[value] = Lexicon.translateDefaultNS('options_strategy_details.' + value);
		}
	);

	/**
	 *
	 * A string representing the name of the tooltip context in the lexicon
	 */
	OptionsStrategyBuyWrite.getTurningPointsToolTipNames = function () {
		return ["tt-max-profit-X-or-higher"];
	};

	OptionsStrategyBuyWrite.getPopoverText = function($scope, $interpolate, idea, trade) {
		var popoverText = {};

		$scope.netCost = NumberFormatter.formatCurrency(
			trade.netCost,
			idea.instrument.precision
		);//
		$scope.netCostPerShare = NumberFormatter.formatCurrency(
			trade.netCost/trade.legs.contract.instrument.blockSize,
			idea.instrument.precision
		);//

		$scope.maxLoss = NumberFormatter.formatCurrency(
			idea.trade.breakevenPrice,
			idea.instrument.precision
		);
		$scope.strikePrice = NumberFormatter.formatCurrency(
			trade.legs.contract.instrument.strikePrice,
			idea.instrument.precision
		);//

		$scope.stockPurchasePrice = NumberFormatter.formatCurrency(
			trade.legs.instrument.instrument.latestPrice.price,
			idea.instrument.precision
		);
		$scope.totalStockCost = NumberFormatter.formatCurrency(
			trade.legs.instrument.instrument.latestPrice.price*trade.legs.contract.instrument.blockSize,
			idea.instrument.precision
		);
		$scope.premiumReceivedPerShare = NumberFormatter.formatCurrency(
			trade.legs.contract.instrument.latestPrice.bid,
			idea.instrument.precision
		);//
		$scope.premiumReceived = NumberFormatter.formatCurrency(
			trade.legs.contract.instrument.latestPrice.bid*trade.legs.contract.instrument.blockSize,
			idea.instrument.precision
		);//
		$scope.quantityOfContracts = NumberFormatter.formatInteger(trade.legs.contract.quantity);//

		$scope.targetPrice = NumberFormatter.formatCurrency(
			Ideas.getConservativeTargetPrice(idea),
			idea.instrument.precision
		);//

		$scope.targetPriceLower = NumberFormatter.formatCurrency(
			idea.targetPrice.lower,
			idea.instrument.precision
		);//
		$scope.targetPriceUpper = NumberFormatter.formatCurrency(
			idea.targetPrice.upper,
			idea.instrument.precision
		);//
		$scope.targetProfit = NumberFormatter.formatCurrency(
			trade.targetProfit,
			idea.instrument.precision
		);//
		$scope.targetProfitPerShare = NumberFormatter.formatCurrency(
			trade.targetProfit/trade.legs.contract.instrument.blockSize,
			idea.instrument.precision
		);//

		$scope.targetProfitPercent =  NumberFormatter.percent(
			idea.trade.targetProfitPercent, 0
		);//
		$scope.maxProfit =  NumberFormatter.formatCurrency(
			trade.maxProfit,
			idea.instrument.precision
		);
		$scope.maxProfitPercent = NumberFormatter.percent(
			idea.trade.maxProfitPercent, 0
		);

		$scope.maxProfitPerShare =  NumberFormatter.formatCurrency(
			trade.maxProfit/trade.legs.contract.instrument.blockSize,
			idea.instrument.precision
		);
		var text = {};
		Object.keys(ogtext).forEach(function (i){
			text[i] = $scope.$eval( $interpolate( ogtext[i] ) );
		});

		if (parseFloat(trade.legs.contract.instrument.strikePrice) < Ideas.getConservativeTargetPrice(idea)) {
			text['target-profit-buy-rite'] = text['target-profit-buy-rite-1'];
			$scope.lesserOfStrikeOrTarget = $scope.strikePrice;
		} else {
			text['target-profit-buy-rite'] = text['target-profit-buy-rite-2'];
			$scope.lesserOfStrikeOrTarget = $scope.targetPrice;
		}

		popoverText.netCost = '<p>'  + text['net-cost-buy-rite'] + '</p>'
							+ '<h5>' + text['net-cost'] + '</h5>'
							+ '<p> '  + $scope.stockPurchasePrice  + ' ('+ text['stock-purchase-price'] + ')' + '</p>'
							+ '<p><strong>-</strong> ' + $scope.premiumReceivedPerShare   + ' ('+ text['premium-received-per-share-short-call'] + ')' + '</p>'
							+ '<p><strong>= ' + $scope.netCostPerShare + ' ('+ text['net-cost-per-share'] + ')' + '</strong></p>'
							+ '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' <strong>&times;</strong> ' + trade.legs.contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
							+ '<p><strong>= ' + $scope.netCost + ' ('+ text['net-cost'] + ')' + '</strong></p>';

		popoverText.maxProfit = '<p>'  + text['max-profit-buy-rite'] + '</p>'
							  + '<h5>' + text['max-profit-title'] + '</h5>'
							  + '<p>'  + $scope.strikePrice    + ' ('+ text['strike-price-of-the-call'] + ')' + '</p>'
							  + '<p><strong>-</strong> ' + $scope.stockPurchasePrice   + ' (' + text['stock-purchase-price'] + ')' + '</p>'
							  + '<p><strong>+</strong> ' + $scope.premiumReceivedPerShare   + ' (' + text['premium-received-per-share'] + ')' + '</p>'
							  + '<p><strong>= ' + $scope.maxProfitPerShare + ' ('+ text['max-profit-per-share'] + ')' + '</strong></p>'
							  + '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' <strong>&times;</strong> ' + trade.legs.contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
							  + '<p><strong>= ' + $scope.maxProfit + ' ('+ text['max-profit'] + ')' + '</strong></p>'
							  + '<p><strong>&divide;</strong> ' + $scope.netCost + ' ('+ text['net-cost'] + ')' + '</strong></p>'
							  + '<p><strong>= ' + $scope.maxProfitPercent + ' ('+ text['return'] + ')' + '</strong></p>';

		popoverText.maxLoss = '<p>'  + text['max-loss-buy-rite'] + '</p>';

		popoverText.targetPrice  = '<p>'  + text['target-price-buy-rite'] + '</p>';

		popoverText.targetProfit = '<p>'  + text['target-profit-buy-rite'] + '</p>'
								 + '<h5>' + text['target-profit'] + '</h5>'
								 + '<p> '  + $scope.lesserOfStrikeOrTarget + ' (' + text['lesser-of-strike-and-target'] + ')' +  '</p>'
								 + '<p><strong>-</strong> ' + $scope.stockPurchasePrice  		+ ' (' + text['stock-purchase-price'] + ')' +  '</p>'
								 + '<p><strong>+</strong> ' + $scope.premiumReceivedPerShare  		+ ' (' + text['premium-received-per-share'] + ')' +  '</p>'
								 + '<p><strong>= ' + $scope.targetProfitPerShare 		+ ' (' + text['target-profit-per-share'] + ')' +  '</strong></p>'
								 + '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' <strong>&times;</strong> ' + trade.legs.contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
								 + '<p><strong>= ' + $scope.targetProfit + ' (' + text['target-profit'] + ')' +  '</strong></p>'
								 + '<p><strong>&divide;</strong> ' + $scope.netCost + ' ('+ text['net-cost'] + ')' + '</strong></p>'
								 + '<p><strong>= ' + $scope.targetProfitPercent + ' ('+ text['return'] + ')' + '</strong></p>';

		return popoverText;
	};

	OptionsStrategyBuyWrite.getLegComparator = function(){
		// stock leg first, option leg second (#11084)
		return function (legA) {
			return (legA.instrument['resourceType'] === 'optionsContract') ? 1 : -1;
		};
	};

	// return the singleton object
	return OptionsStrategyBuyWrite;
}]);

/**
 * Created with JetBrains WebStorm.
 * User: hosam
 * Date: 9/6/14
 * Time: 8:37 AM
 * To change this template use File | Settings | File Templates.
 */
'use strict';
/**
 * This is the implementation for Long Call strategy
 * Do not inject this service, instead use the OptionsStrategy service
 */
recogniaApp.factory('OptionsStrategyLongCall',
['OptionsStrategyBase', 'Lexicon', 'NumberFormatter', 'Ideas', 'OptionsStrategyConstants',
function (OptionsStrategyBase, Lexicon, NumberFormatter, Ideas, OptionsStrategyConstants) {

	var textKeys = [
		'net-cost-long-call','target-profit','premium-paid',
		'quantity-of-contracts-x-shares-per-contract',
		'base-quantity-of-contracts-x-shares-per-contract',
		'base-quantity-of-contracts-x-shares-per-contract',
		'quantity-of-contracts','shares-per-contract',
		'shares-per-contract','premium-paid-per-share',
		'premium-paid-per-share','premium-paid','max-profit-long-call',
		'break-even-point','strike-price','premium-paid-per-share',
		'max-loss-long-call','target-price-long-call','target-profit-long-call',
		'target-profit','target-price-of-underlying-stock','strike-price-of-the-call',
		'target-profit-per-share','net-cost','return'

	];
	var ogtext = {};
	textKeys.forEach(
		function(value) {
			ogtext[value] = Lexicon.translateDefaultNS('options_strategy_details.' + value);
		}
	);

	var OptionsStrategyLongCall = new OptionsStrategyBase(false,
			OptionsStrategyConstants.OPTIONS_STRATEGY.longcall);

	/**
	 *
	 * A string representing the name of the tooltip context in the lexicon
	 */
	OptionsStrategyLongCall.getTurningPointsToolTipNames = function () {
		return ["tt-max-loss-X-or-lower"];
	};

	OptionsStrategyLongCall.getPopoverText = function($scope, $interpolate, idea, trade) {
		var popoverText = {};
		$scope.quantityOfContracts = NumberFormatter.formatInteger(trade.legs.contract.quantity);
		$scope.sharesPerContract = NumberFormatter.formatInteger(trade.legs.contract.instrument.blockSize);
		$scope.premiumPaidPerShare = NumberFormatter.formatCurrency(
			trade.netCost/trade.legs.contract.instrument.blockSize,
			idea.instrument.precision
		);//
		$scope.premiumPaid = NumberFormatter.formatCurrency(
			trade.netCost,
			idea.instrument.precision
		);//
		$scope.netCost = NumberFormatter.formatCurrency(
			trade.netCost,
			idea.instrument.precision
		);//
		$scope.breakEvenPoint = NumberFormatter.formatCurrency(
			idea.trade.profitZone[0].lower,
			idea.instrument.precision
		);//
		$scope.targetPrice = NumberFormatter.formatCurrency(
			Ideas.getConservativeTargetPrice(idea),
			idea.instrument.precision
		);//
		$scope.targetPriceLower = NumberFormatter.formatCurrency(
			idea.targetPrice.lower,
			idea.instrument.precision
		);//
		$scope.targetPriceUpper = NumberFormatter.formatCurrency(
			idea.targetPrice.upper,
			idea.instrument.precision
		);//
		$scope.contractPrice = NumberFormatter.formatCurrency(
			trade.netCost/trade.legs.contract.instrument.blockSize,
			idea.instrument.precision
		);
		$scope.strikePrice = NumberFormatter.formatCurrency(
			trade.legs.contract.instrument.strikePrice,
			idea.instrument.precision
		);//
		$scope.targetProfitPercent =  NumberFormatter.percent(
			idea.trade.targetProfitPercent, 0
		);//
		$scope.targetProfit =  NumberFormatter.formatCurrency(
			trade.targetProfit,
			idea.instrument.precision
		);//
		$scope.targetProfitPerShare = NumberFormatter.formatCurrency(
			trade.targetProfit/trade.legs.contract.instrument.blockSize,
			idea.instrument.precision
		);//

		var text = {};
		Object.keys(ogtext).forEach(function (i){
			text[i] = $scope.$eval( $interpolate( ogtext[i] ) );
		});
		popoverText.netCost = '<p>'  + text['net-cost-long-call'] + '</p>'
							+ '<h5>' + text['premium-paid'] + '</h5>'
							+ '<p>'  + $scope.quantityOfContracts  + ' ('+ text['quantity-of-contracts'] + ')' + '</p>'
							+ '<p><strong>&times;</strong> ' + $scope.sharesPerContract   + ' ('+ text['shares-per-contract'] + ')' + '</p>'
							+ '<p><strong>&times;</strong> ' + $scope.premiumPaidPerShare + ' ('+ text['premium-paid-per-share'] + ')' + '</p>'
							+ '<p><strong>= ' + $scope.premiumPaid + ' ('+ text['premium-paid'] + ')' + '</strong></p>';

		popoverText.maxProfit = '<p>'  + text['max-profit-long-call'] + '</p>'
							  + '<h5>' + text['break-even-point'] + '</h5>'
							  + '<p>'  + $scope.strikePrice    + ' ('+ text['strike-price'] + ')' + '</p>'
							  + '<p><strong>+</strong> ' + $scope.premiumPaidPerShare   + ' (' + text['premium-paid-per-share'] + ')' + '</p>'
							  + '<p><strong>= ' + $scope.breakEvenPoint + ' ('+ text['break-even-point'] + ')' + '</strong></p>';
		popoverText.maxLoss = '<p>' + text['max-loss-long-call'] + '</p>';
		popoverText.targetPrice  = '<p>'  + text['target-price-long-call'] + '</p>';
		popoverText.targetProfit = '<p>'  + text['target-profit-long-call'] + '</p>'
								 + '<h5>' + text['target-profit'] + '</h5>'
								 + '<p>'  + $scope.targetPrice + ' (' + text['target-price-of-underlying-stock'] + ')' +  '</p>'
								 + '<p><strong>- </strong>' + $scope.strikePrice  		+ ' (' + text['strike-price-of-the-call'] + ')' +  '</p>'
								 + '<p><strong>- </strong>' + $scope.premiumPaidPerShare  		+ ' (' + text['premium-paid-per-share'] + ')' +  '</p>'
								 + '<p><strong>= ' + $scope.targetProfitPerShare 		+ ' (' + text['target-profit-per-share'] + ')' +  '</strong></p>'
								 + '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' <strong>&times;</strong> ' + trade.legs.contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
								 + '<p><strong>= ' + $scope.targetProfit + ' (' + text['target-profit'] + ')' +  '</strong></p>'
								 + '<p><strong>&divide;</strong> ' + $scope.netCost + ' ('+ text['net-cost'] + ')' + '</strong></p>'
								 + '<p><strong>= ' + $scope.targetProfitPercent + ' ('+ text['return'] + ')' + '</strong></p>';
		return popoverText;
	};

	// return the singleton object
	return OptionsStrategyLongCall;
}]);

'use strict';
/**
 * This is the implementation for Long Put strategy
 * Do not inject this service, instead use the OptionsStrategy service
 *
 * NOTE: Methods are stubbed out for now to assist implementation of charting
 */
recogniaApp.factory('OptionsStrategyLongPut',
['OptionsStrategyBase', 'Lexicon', 'NumberFormatter', 'Ideas', 'OptionsStrategyConstants',
function (OptionsStrategyBase, Lexicon, NumberFormatter, Ideas, OptionsStrategyConstants) {

	var ogtext = {};
	ogtext['net-cost-long-put'] = Lexicon.translateDefaultNS('options_strategy_details.net-cost-long-put');

	ogtext['max-profit-long-put'] = Lexicon.translateDefaultNS('options_strategy_details.max-profit-long-put');

	ogtext['max-loss-long-put'] = Lexicon.translateDefaultNS('options_strategy_details.max-loss-long-put');

	ogtext['target-price-long-put'] = Lexicon.translateDefaultNS('options_strategy_details.target-price-long-put');

	ogtext['target-profit-long-put'] = Lexicon.translateDefaultNS('options_strategy_details.target-profit-long-put');

	ogtext['max-loss-long-put'] = Lexicon.translateDefaultNS('options_strategy_details.max-loss-long-put');

	ogtext['premium-paid'] = Lexicon.translateDefaultNS('options_strategy_details.premium-paid');

	ogtext['shares-per-contract'] = Lexicon.translateDefaultNS('options_strategy_details.shares-per-contract');

	ogtext['premium-paid-per-share'] = Lexicon.translateDefaultNS('options_strategy_details.premium-paid-per-share');

	ogtext['net-cost'] = Lexicon.translateDefaultNS('options_strategy_details.net-cost');

	ogtext['max-profit'] = Lexicon.translateDefaultNS('options_strategy_details.max-profit');

	ogtext['max-profit-title'] = Lexicon.translateDefaultNS('options_strategy_details.max-profit-title');

	ogtext['strike-price'] = Lexicon.translateDefaultNS('options_strategy_details.strike-price');

	ogtext['theoretical-lowest-price'] = Lexicon.translateDefaultNS('options_strategy_details.theoretical-lowest-price');

	ogtext['max-profit-per-share'] = Lexicon.translateDefaultNS('options_strategy_details.max-profit-per-share');

	ogtext['quantity-of-contracts-x-shares-per-contract'] = Lexicon.translateDefaultNS('options_strategy_details.quantity-of-contracts-x-shares-per-contract');

	ogtext['return'] = Lexicon.translateDefaultNS('options_strategy_details.return');

	ogtext['quantity-of-contracts'] = Lexicon.translateDefaultNS('options_strategy_details.quantity-of-contracts');

	ogtext['target-profit-title'] = Lexicon.translateDefaultNS('options_strategy_details.target-profit-title');

	ogtext['strike-price-of-the-call'] = Lexicon.translateDefaultNS('options_strategy_details.strike-price-of-the-call');

	ogtext['target-price-of-underlying-stock'] = Lexicon.translateDefaultNS('options_strategy_details.target-price-of-underlying-stock');

	ogtext['target-profit-per-share'] = Lexicon.translateDefaultNS('options_strategy_details.target-profit-per-share');


	var OptionsStrategyLongPut = new OptionsStrategyBase(true,
			OptionsStrategyConstants.OPTIONS_STRATEGY.longput);

	/**
	 *
	 * A string representing the name of the tooltip context in the lexicon
	 */
	OptionsStrategyLongPut.getTurningPointsToolTipNames = function () {
		return ["tt-max-loss-X-or-higher"];
	};

	OptionsStrategyLongPut.getPopoverText = function($scope, $interpolate, idea, trade) {
		var popoverText = {};
		var text = {};
		$scope.quantityOfContracts = NumberFormatter.formatInteger(trade.legs.contract.quantity);
		$scope.premiumPaid = NumberFormatter.formatCurrency(
			trade.netCost,
			idea.instrument.precision
		);//
		$scope.premiumPaidPerShare = NumberFormatter.formatCurrency(
			trade.netCost/trade.legs.contract.instrument.blockSize,
			idea.instrument.precision
		);//

		$scope.breakevenPoint = NumberFormatter.formatCurrency(
			idea.trade.profitZone[0].upper,
			idea.instrument.precision
		);//
		$scope.targetPrice = NumberFormatter.formatCurrency(
			Ideas.getConservativeTargetPrice(idea),
			idea.instrument.precision
		);//
		$scope.targetPriceLower = NumberFormatter.formatCurrency(
			idea.targetPrice.lower,
			idea.instrument.precision
		);//
		$scope.targetPriceUpper = NumberFormatter.formatCurrency(
			idea.targetPrice.upper,
			idea.instrument.precision
		);//
		$scope.strikePrice = NumberFormatter.formatCurrency(
			trade.legs.contract.instrument.strikePrice,
			idea.instrument.precision
		);//

		$scope.maxProfit =  NumberFormatter.formatCurrency(
			trade.maxProfit,
			idea.instrument.precision
		);//
		$scope.sharesPerContract = trade.legs.contract.instrument.blockSize;//
		$scope.maxProfitPerShare =  NumberFormatter.formatCurrency(
			trade.maxProfit/$scope.sharesPerContract,
			idea.instrument.precision
		);//

		$scope.netCost = NumberFormatter.formatCurrency(
			trade.netCost,
			idea.instrument.precision
		);//
		$scope.targetPrice = NumberFormatter.formatCurrency(
			Ideas.getConservativeTargetPrice(idea),
			idea.instrument.precision
		);//

		$scope.targetProfit = NumberFormatter.formatCurrency(
			trade.targetProfit,
			idea.instrument.precision
		);//

		$scope.targetProfitPerShare = NumberFormatter.formatCurrency(
			trade.targetProfit/$scope.sharesPerContract,
			idea.instrument.precision
		);//
		$scope.targetProfitPercent =  NumberFormatter.percent(
			idea.trade.targetProfitPercent, 0
		);//
		$scope.maxProfitPercentage =  NumberFormatter.percent(
			trade.maxProfit/trade.netCost, 0
		);//
		Object.keys(ogtext).forEach(function (i){
			text[i] = $scope.$eval( $interpolate( ogtext[i] ) );
		});

		popoverText.netCost = '<p>' + text['net-cost-long-put']  + '</p>'
							+ '<h5>' + text['premium-paid'] + '</h5>'
							+ '<p>' + $scope.quantityOfContracts + ' (' + text['quantity-of-contracts'] + ')' + '</p>'
							+ '<p><strong>&times;</strong> ' + $scope.sharesPerContract   + ' (' + text['shares-per-contract'] + ')' + '</p>'
							+ '<p><strong>&times;</strong> ' + $scope.premiumPaidPerShare + ' (' + text['premium-paid-per-share'] + ')' + '</p>'
							+ '<p><strong>= ' + $scope.premiumPaid + ' (' + text['premium-paid'] + ')' + '</strong></p>';
		popoverText.maxProfit = '<p>'  + text['max-profit-long-put']  + '</p>'
							  + '<h5>' + text['max-profit-title'] + '</h5>'
							  + '<p>' + $scope.strikePrice + ' (' + text['strike-price'] + ')' + '</p>'
							  + '<p><strong>-</strong> ' + ' 0.00 (' + text['theoretical-lowest-price'] + ')' + '</p>'
							  + '<p><strong>-</strong> '  + $scope.premiumPaidPerShare + ' (' + text['premium-paid-per-share'] + ')' + '</p>'
							  + '<p><strong>= ' + $scope.maxProfitPerShare + ' (' + text['max-profit-per-share'] + ')' + '</strong></p>'
							  + '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' <strong>&times;</strong> ' + trade.legs.contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
							  + '<p><strong>= ' + $scope.maxProfit + ' ('+ text['max-profit'] + ')' + '</strong></p>'
							  + '<p><strong>&divide;</strong>' + $scope.netCost + ' ('+ text['net-cost'] + ')' + '</strong></p>'
							  + '<p><strong>= ' + $scope.maxProfitPercentage + ' ('+ text['return'] + ')' + '</strong></p>';
		popoverText.maxLoss = '<p>'  + text['max-loss-long-put']  + '</p>';
		popoverText.targetPrice  = '<p>'  + text['target-price-long-put']   + '</p>';
		popoverText.targetProfit = '<p>'  + text['target-profit-long-put']  + '</p>'
								 + '<h5>' + text['target-profit-title'] + '</h5>'
								 + '<p>'  + $scope.strikePrice + ' (' + text['strike-price']  + ')' + '</p>'
								 + '<p><strong>-</strong> '  + $scope.targetPrice + ' (' + text['target-price-of-underlying-stock'] + ')' + '</p>'
								 + '<p><strong>-</strong> '  + $scope.premiumPaidPerShare + ' (' + text['premium-paid-per-share'] + ')' + '</p>'
								 + '<p><strong>= ' + $scope.targetProfitPerShare + ' (' + text['target-profit-per-share'] + ')' + '</strong></p>'
								 + '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' <strong>&times;</strong> ' + trade.legs.contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
								 + '<p><strong>= ' + $scope.targetProfit + ' ('+ text['target-profit-title'] + ')' + '</strong></p>'
								 + '<p><strong>&divide;</strong> ' + $scope.netCost + ' ('+ text['net-cost'] + ')' + '</strong></p>'
								 + '<p><strong>= ' + $scope.targetProfitPercent + ' ('+ text['return'] + ')' + '</strong></p>';
		return popoverText;
	};

	// return the singleton object
	return OptionsStrategyLongPut;
}]);

'use strict';
/**
 * This is the implementation for MarriedPut strategy
 * Do not inject this service, instead use the OptionsStrategy service
 */
recogniaApp.factory('OptionsStrategyMarriedPut',
['OptionsStrategyBase', 'Lexicon', 'NumberFormatter', 'OptionsIdeasScore', 'OptionsStrategyConstants', 'Ideas',
function (OptionsStrategyBase, Lexicon, NumberFormatter, OptionsIdeasScore, OptionsStrategyConstants, Ideas) {

	var OptionsStrategyMarriedPut = new OptionsStrategyBase(false,
			OptionsStrategyConstants.OPTIONS_STRATEGY.marriedput);

	OptionsIdeasScore.disableFactorForStrategy('volume', OptionsStrategyMarriedPut.strategyId);
	OptionsIdeasScore.addStrategySpecificRanges('targetProfitPercent',
		OptionsStrategyMarriedPut.strategyId,
		OptionsIdeasScore.getBaseActualFn('targetProfitPercent'),
		function () {
			return [
				{
					scores: ['AAA', 'AA'],
					range: new NumberRange(0.10, true, Infinity, true),
					lexKey: 'fsTarget.j_profit_b1',
					lexKeyLimiting: 'fsTarget.j_profit_b1'
				},
				{
					scores: ['A'],
					range: new NumberRange(0.04, true, 0.10, false),
					lexKey: 'fsTarget.j_profit_b3',
					lexKeyLimiting: 'fsTarget.j_profit_b2'
				},
				{
					scores: ['C'],
					range: new NumberRange(0.0, false, 0.04, false),
					lexKey: 'fsTarget.j_profit_b5',
					lexKeyLimiting: 'fsTarget.j_profit_b4'
				},
				{
					scores: ['X'],
					range: new NumberRange(-Infinity, true, 0.0, true),
					lexKey: null,
					lexKeyLimiting: 'fsTarget.j_profit_b6'
				}
			];
		});
	OptionsIdeasScore.addStrategySpecificRanges('rewardToRisk',
		OptionsStrategyMarriedPut.strategyId,
		function (idea){
			return idea.trade.rewardRiskRatio;
		},
		function () {
			return [
				{
					scores: ['AAA'],
					range: new NumberRange(2.0, true, Infinity, true),
					lexKey: 'fsTarget.j_rewardrisk_a1',
					lexKeyLimiting: 'fsTarget.j_rewardrisk_a1'
				},
				{
					scores: ['AA'],
					range: new NumberRange(1.5, true, 2.0, false),
					lexKey: 'fsTarget.j_rewardrisk_a3',
					lexKeyLimiting: 'fsTarget.j_rewardrisk_a2'
				},
				{
					scores: ['A'],
					range: new NumberRange(1.0, true, 1.5, false),
					lexKey: 'fsTarget.j_rewardrisk_a4',
					lexKeyLimiting: 'fsTarget.j_rewardrisk_a2'
				},
				{
					scores: ['C'],
					range: new NumberRange(0.0, true, 1.0, false),
					lexKey: null,
					lexKeyLimiting: 'fsTarget.j_rewardrisk_a5'
				},
				{
					scores: ['X'],
					range: new NumberRange(-Infinity, true, 0.0, false),
					lexKey: 'fsTarget.j_rewardrisk_a7',
					lexKeyLimiting: 'fsTarget.j_rewardrisk_a6'
				}
			];
		});
	OptionsIdeasScore.addStrategySpecificRanges('moneyness',
		OptionsStrategyMarriedPut.strategyId,
		function (idea) {
			return parseFloat(idea.trade.legs.contract.instrument.strikePrice);
		},
		function (idea) {
			var currentPrice = parseFloat(idea.trade.legs.instrument.instrument.latestPrice.price);
			return [
				{
					scores: ['X'],
					range: new NumberRange(0, true, currentPrice, false),
					lexKey: null,
					lexKeyLimiting: 'fsTarget.j_moneyness_a1'
				}
			];
		});


	var ogtext = {};
	//Long Call: Net Cost
	ogtext['net-cost-married-put'] = Lexicon.translateDefaultNS('options_strategy_details.net-cost-married-put');

	ogtext['quantity-of-contracts-x-shares-per-contract'] = Lexicon.translateDefaultNS('options_strategy_details.quantity-of-contracts-x-shares-per-contract');

	ogtext['strike-price'] = Lexicon.translateDefaultNS('options_strategy_details.strike-price');

	ogtext['net-cost'] = Lexicon.translateDefaultNS('options_strategy_details.net-cost');

	ogtext['return'] = Lexicon.translateDefaultNS('options_strategy_details.return');

	ogtext['negative-return'] = Lexicon.translateDefaultNS('options_strategy_details.negative-return');

	ogtext['stock-purchase-price'] = Lexicon.translateDefaultNS('options_strategy_details.stock-purchase-price');

	ogtext['premium-paid-per-share'] = Lexicon.translateDefaultNS('options_strategy_details.premium-paid-per-share');

	ogtext['premium-paid-per-share-for-the-put'] = Lexicon.translateDefaultNS('options_strategy_details.premium-paid-per-share-for-the-put');

	ogtext['net-cost-per-share'] = Lexicon.translateDefaultNS('options_strategy_details.net-cost-per-share');

	ogtext['max-profit-married-put'] = Lexicon.translateDefaultNS('options_strategy_details.max-profit-married-put');

	ogtext['max-loss-per-share'] = Lexicon.translateDefaultNS('options_strategy_details.max-loss-per-share');

	ogtext['max-loss-married-put'] = Lexicon.translateDefaultNS('options_strategy_details.max-loss-married-put');

	ogtext['target-price-married-put'] = Lexicon.translateDefaultNS('options_strategy_details.target-price-married-put');

	ogtext['target-price'] = Lexicon.translateDefaultNS('options_strategy_details.target-price');

	ogtext['target-profit'] = Lexicon.translateDefaultNS('options_strategy_details.target-profit');

	ogtext['target-profit-married-put'] = Lexicon.translateDefaultNS('options_strategy_details.target-profit-married-put');

	ogtext['break-even-point'] = Lexicon.translateDefaultNS('options_strategy_details.break-even-point');

	ogtext['target-profit-per-share'] = Lexicon.translateDefaultNS('options_strategy_details.target-profit-per-share');

	ogtext['target-profit'] = Lexicon.translateDefaultNS('options_strategy_details.target-profit');

	ogtext['maximum-loss'] = Lexicon.translateDefaultNS('options_strategy_details.maximum-loss');

	ogtext['max-loss'] = Lexicon.translateDefaultNS('options_strategy_details.max-loss');

	ogtext['premium-paid-per-share-for-the-put'] = Lexicon.translateDefaultNS('options_strategy_details.premium-paid-per-share-for-the-put');

	/**
	 *
	 * A string representing the name of the tooltip context in the lexicon
	 */
	OptionsStrategyMarriedPut.getTurningPointsToolTipNames = function () {
		return ["tt-max-loss-X-or-lower"];
	};

	OptionsStrategyMarriedPut.getPopoverText = function($scope, $interpolate, idea, trade) {
		var popoverText = { };
		$scope.netCost = NumberFormatter.formatCurrency(
			trade.netCost,
			idea.instrument.precision
		);//
		$scope.premiumPaidPerShare = NumberFormatter.formatCurrency(
			trade.legs.contract.instrument.latestPrice.ask,
			idea.instrument.precision
		);//
		$scope.netCostPerShare = NumberFormatter.formatCurrency(
			trade.netCost/trade.legs.contract.instrument.blockSize,
			idea.instrument.precision
		);//
		$scope.totalPremiumPaid =  NumberFormatter.formatCurrency(
			trade.legs.contract.instrument.latestPrice.ask*trade.legs.contract.instrument.blockSize,
			idea.instrument.precision
		);
		$scope.stockPurchasePrice = NumberFormatter.formatCurrency(
			trade.legs.instrument.instrument.latestPrice.price,
			idea.instrument.precision
		);
		$scope.totalStockCost = NumberFormatter.formatCurrency(
			trade.legs.instrument.instrument.latestPrice.price*trade.legs.contract.instrument.blockSize,
			idea.instrument.precision
		);
		$scope.maxLoss = NumberFormatter.formatCurrency(
			trade.maxLoss,
			idea.instrument.precision
		);//
		$scope.maxLossPerShare = NumberFormatter.formatCurrency(
			trade.maxLoss/trade.legs.contract.instrument.blockSize,
			idea.instrument.precision
		);//

		$scope.quantityOfContracts = NumberFormatter.formatInteger(trade.legs.contract.quantity);//
		$scope.sharesPerContract = NumberFormatter.formatInteger(trade.legs.contract.instrument.blockSize);//
		$scope.targetProfit =  NumberFormatter.formatCurrency(
			trade.targetProfit,
			idea.instrument.precision
		);//
		$scope.targetProfitPerShare = NumberFormatter.formatCurrency(
			trade.targetProfit/trade.legs.contract.instrument.blockSize,
			idea.instrument.precision
		);//
		$scope.targetProfitPercent =  NumberFormatter.percent(
			idea.trade.targetProfitPercent, 0
		);//
		$scope.breakEvenPoint = NumberFormatter.formatCurrency(
			idea.trade.profitZone[0].lower,
			idea.instrument.precision
		);//
		$scope.targetPrice = NumberFormatter.formatCurrency(
			Ideas.getConservativeTargetPrice(idea),
			idea.instrument.precision
		);//
		$scope.targetPriceLower = NumberFormatter.formatCurrency(
			idea.targetPrice.lower,
			idea.instrument.precision
		);//
		$scope.targetPriceUpper = NumberFormatter.formatCurrency(
			idea.targetPrice.upper,
			idea.instrument.precision
		);//
		$scope.strikePrice = NumberFormatter.formatCurrency(
			trade.legs.contract.instrument.strikePrice,
			idea.instrument.precision
		);//
		$scope.maxLossPercentage = NumberFormatter.percent(
			idea.trade.maxLossPercent, 0
		);//

		var text = {};
		Object.keys(ogtext).forEach(function (i){
			text[i] = $scope.$eval( $interpolate( ogtext[i] ) );
		});

		popoverText.netCost = '<p>'  + text['net-cost-married-put'] + '</p>'
							+ '<h5>' + text['net-cost'] + '</h5>'
							+ '<p> '  + $scope.stockPurchasePrice  + ' ('+ text['stock-purchase-price'] + ')' + '</p>'
							+ '<p><strong>+</strong> ' + $scope.premiumPaidPerShare   + ' ('+ text['premium-paid-per-share-for-the-put'] + ')' + '</p>'
							+ '<p><strong>= ' + $scope.netCostPerShare + ' ('+ text['net-cost-per-share'] + ')' + '</strong></p>'
							+ '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' <strong><strong>&times;</strong></strong> ' + trade.legs.contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
							+ '<p><strong>= ' + $scope.netCost + ' ('+ text['net-cost'] + ')' + '</strong></p>';

		popoverText.maxProfit = '<p>'  + text['max-profit-married-put'] + '</p>'
							  + '<h5>' + text['break-even-point'] + '</h5>'
							  + '<p>'  + $scope.stockPurchasePrice    + ' ('+ text['stock-purchase-price'] + ')' + '</p>'
							  + '<p><strong>+</strong> ' + $scope.premiumPaidPerShare   + ' (' + text['premium-paid-per-share-for-the-put'] + ')' + '</p>'
							  + '<p><strong>= ' + $scope.breakEvenPoint + ' ('+ text['break-even-point'] + ')' + '</strong></p>';

		popoverText.maxLoss = '<p>' + text['max-loss-married-put'] + '</p>'
							+ '<h5>' + text['max-loss'] + '</h5>'
							+ '<p> '  + $scope.stockPurchasePrice  + ' ('+ text['stock-purchase-price'] + ')' + '</p>'
							+ '<p><strong>&minus;</strong> ' + $scope.strikePrice   + ' ('+ text['strike-price'] + ')' + '</p>'
							+ '<p><strong>+</strong> ' + $scope.premiumPaidPerShare   + ' ('+ text['premium-paid-per-share-for-the-put'] + ')' + '</p>'
							+ '<p><strong>= '  + $scope.maxLossPerShare + ' ('+ text['max-loss-per-share'] + ')' + '</strong></p>'
							+ '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' <strong>&times;</strong>  ' + trade.legs.contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
							+ '<p><strong>= '  + $scope.maxLoss + ' ('+ text['maximum-loss'] + ')' + '</strong></p>'
							+ '<p><strong>&divide;</strong> ' + $scope.netCost + ' ('+ text['net-cost'] + ')' + '</strong></p>'
							+ '<p><strong>= ' + $scope.maxLossPercentage + ' ('+ text['negative-return'] + ')' + '</strong></p>';

		popoverText.targetPrice  = '<p>'  + text['target-price-married-put'] + '</p>';

		popoverText.targetProfit = '<p>'  + text['target-profit-married-put'] + '</p>'
								 + '<h5>' + text['target-profit'] + '</h5>'
								 + '<p> '  + $scope.targetPrice + ' (' + text['target-price'] + ')' +  '</p>'
								 + '<p><strong>&minus;</strong> ' + $scope.stockPurchasePrice  		+ ' (' + text['stock-purchase-price'] + ')' +  '</p>'
								 + '<p><strong>&minus;</strong> ' + $scope.premiumPaidPerShare  		+ ' (' + text['premium-paid-per-share-for-the-put'] + ')' +  '</p>'
								 + '<p><strong>= ' + $scope.targetProfitPerShare 		+ ' (' + text['target-profit-per-share'] + ')' +  '</strong></p>'
								 + '<p><strong>&times; </strong> ' + $scope.quantityOfContracts + ' <strong>&times;</strong>  ' + trade.legs.contract.instrument.blockSize  + ' (' + text['quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
								 + '<p><strong>= ' + $scope.targetProfit + ' (' + text['target-profit'] + ')' +  '</strong></p>'
								 + '<p><strong>&divide;</strong> ' + $scope.netCost + ' ('+ text['net-cost'] + ')' + '</strong></p>'
								 + '<p><strong>= ' + $scope.targetProfitPercent + ' ('+ text['return'] + ')' + '</strong></p>';
		return popoverText;
	};

	OptionsStrategyMarriedPut.getLegComparator = function(){
		// stock leg first, option leg second (#11084)
		return function (legA) {
			return (legA.instrument['resourceType'] === 'optionsContract') ? 1 : -1;
		};
	};

	// return the singleton object
	return OptionsStrategyMarriedPut;
}]);

'use strict';
/**
 * This is the implementation for Long OTM Butterfly strategy
 * Do not inject this service, instead use the OptionsStrategy service
 */
recogniaApp.factory('OptionsStrategyLongOTMButterfly',
['OptionsStrategyBase', 'Lexicon', 'NumberFormatter', 'OptionsStrategyConstants', 'Ideas',
function (OptionsStrategyBase, Lexicon, NumberFormatter, OptionsStrategyConstants, Ideas) {
	var ogtext = {};
	var textKeys = [
		'max-profit-bearish-long-call-otm-butterfly','higher-strike-price','two-middle-strike-obligation-to-buy',
		'two-middle-strike-obligation-to-sell','target-price-to-sell','higher-strike-to-sell',
		'target-profit-bearish-long-call-otm-butterfly-between-middle-and-upper-strike',
		'target-price-bearish-long-call-otm-butterfly','base-quantity-of-contracts-x-shares-per-contract',
		'target-price-to-buy','lower-strike-to-buy','loss-from-middle-strike-short-call',
		'loss-from-middle-strike-short-call','middle-strike-to-target-price','gain-exercising-lower-strike-long-call',
		'middle-strike-obligation','middle-strike-obligation-to-buy',
		'gain','maximum-profit','loss','target-price-to-lower-strike','target-price',
		'max-profit-title','max-profit-per-share','middle-strike-to-lower-strike','target-profit-per-share',
		'target-profit','return','max-loss-per-share','strike-price','maximum-loss',
		'premium-paid-per-share','max-profit-bullish-long-call-otm-butterfly',
		'quantity-of-contracts-x-shares-per-contract','net-cost-per-share','premium-paid-per-share-for-the-put',
		'stock-purchase-price','net-premium-paid-title','net-cost',
		'target-profit-bullish-long-call-otm-butterfly-between-lower-and-middle-strike',
		'target-profit-bullish-long-call-otm-butterfly-between-middle-and-upper-strike',
		'max-loss-bullish-long-call-otm-butterfly','higher-strike-price-plus-net-premium-paid-per-share',
		'higher-strike-price-plus-net-premium-paid-per-share','break-even-point-upper',
		'lower-strike-price-plus-net-premium-paid-per-share','break-even-point',
		'break-even-point-lower','target-price-bullish-long-call-otm-butterfly',
		'premium-received-for-2-short-puts-per-share', 'premium-received-for-2-short-calls-per-share',
		'premium-paid-2-long-calls','net-premium-paid-per-share','premium-paid-2-long-puts',
		'target-profit-bearish-long-call-otm-butterfly-between-lower-and-middle-strike',
		'net-cost-bearish-long-call-otm-butterfly','net-cost-bullish-long-call-otm-butterfly',
		'max-loss-bearish-long-call-otm-butterfly','higher-strike-to-middle-strike'
	];

	textKeys.forEach(
		function(value) {
			ogtext[value] = Lexicon.translateDefaultNS( 'options_strategy_details.' + value);
		}
	);


	function OptionsStrategyLongOTMButterfly (bearish, strategyId) {
		OptionsStrategyBase.call(this, bearish, strategyId);
	}
	OptionsStrategyLongOTMButterfly.prototype = Object.create(OptionsStrategyBase.prototype);
	OptionsStrategyLongOTMButterfly.prototype.constructor = OptionsStrategyLongOTMButterfly;

	/**
	 *
	 * A string representing the name of the tooltip context in the lexicon
	 */
	OptionsStrategyLongOTMButterfly.prototype.getTurningPointsToolTipNames = function () {
		return ["tt-max-loss-X-or-lower", "tt-max-profit-X", "tt-max-loss-X-or-higher"];
	};

	OptionsStrategyLongOTMButterfly.prototype.getPopoverText = function($scope, $interpolate, idea, trade) {
		var popoverText = {};
		$scope.netCost = NumberFormatter.formatCurrency(
			trade.netCost,
			idea.instrument.precision
		);//

		$scope.maxLoss = NumberFormatter.formatCurrency(
			trade.netCost,
			idea.instrument.precision
		);//
		$scope.maxLossPerShare = NumberFormatter.formatCurrency(
			trade.netCost/trade.legs.head.instrument.blockSize,
			idea.instrument.precision
		);//
		$scope.strikePrice = NumberFormatter.formatCurrency(
			trade.legs.head.instrument.strikePrice,
			idea.instrument.precision
		);//??

		$scope.netPremiumPaid = NumberFormatter.formatCurrency(
			trade.netCost,
			idea.instrument.precision
		);//
		$scope.netCostPerShare = NumberFormatter.formatCurrency(
			trade.netCost/trade.legs.head.instrument.blockSize,
			idea.instrument.precision
		);//
		$scope.premiumPaidPerShare = NumberFormatter.formatCurrency(
			trade.netCost/trade.legs.head.instrument.blockSize,
			idea.instrument.precision
		);//
		$scope.quantityOfContracts = NumberFormatter.formatInteger(trade.legs.upper_wing.quantity);

		$scope.targetPrice = NumberFormatter.formatCurrency(
			Ideas.getConservativeTargetPrice(idea),
			idea.instrument.precision
		);//

		$scope.targetPriceLower = NumberFormatter.formatCurrency(
			idea.targetPrice.lower,
			idea.instrument.precision
		);//
		$scope.targetPriceUpper = NumberFormatter.formatCurrency(
			idea.targetPrice.upper,
			idea.instrument.precision
		);//
		$scope.targetProfit = NumberFormatter.formatCurrency(
			trade.targetProfit,
			idea.instrument.precision
		);//

		$scope.targetProfitPercent =  NumberFormatter.percent(
			idea.trade.targetProfitPercent, 0
		);//

		$scope.targetProfitPerShare = NumberFormatter.formatCurrency(
			trade.targetProfit/trade.legs.head.instrument.blockSize,
			idea.instrument.precision
		);//


		$scope.longCall1 = NumberFormatter.formatCurrency(
			trade.legs.lower_wing.instrument.latestPrice.ask*trade.legs.head.instrument.blockSize,
			idea.instrument.precision
		);
		$scope.longCall2 = NumberFormatter.formatCurrency(
			trade.legs.upper_wing.instrument.latestPrice.ask*trade.legs.head.instrument.blockSize,
			idea.instrument.precision
		);
		$scope.premiumReceivedShortCall = NumberFormatter.formatCurrency(
			trade.legs.head.instrument.latestPrice.bid,
			idea.instrument.precision
		);
		$scope.netPremiumReceivedShortCall = NumberFormatter.formatCurrency(
			(trade.legs.head.instrument.latestPrice.bid*2)*trade.legs.head.instrument.blockSize,
			idea.instrument.precision
		);
		$scope.premiumPaidLowerStrikeLongCall = NumberFormatter.formatCurrency(
			trade.legs.lower_wing.instrument.latestPrice.ask,
			idea.instrument.precision
		);
		$scope.premiumPaidHigherStrikeLongCall = NumberFormatter.formatCurrency(
			trade.legs.upper_wing.instrument.latestPrice.ask,
			idea.instrument.precision
		);
		$scope.strikePriceMiddle = NumberFormatter.formatCurrency(
			trade.legs.head.instrument.strikePrice,
			idea.instrument.precision
		);//
		$scope.strikePriceLower = NumberFormatter.formatCurrency(
			trade.legs.lower_wing.instrument.strikePrice,
			idea.instrument.precision
		);//
		$scope.strikePriceUpper = NumberFormatter.formatCurrency(
			trade.legs.upper_wing.instrument.strikePrice,
			idea.instrument.precision
		);//
		$scope.maxProfit =  NumberFormatter.formatCurrency(
			trade.maxProfit,
			idea.instrument.precision
		);//
		$scope.maxProfitPercent =  NumberFormatter.percent(
			trade.maxProfitPercent, 0
		);//
		$scope.maxProfitPerShare =  NumberFormatter.formatCurrency(
			trade.maxProfit/trade.legs.head.instrument.blockSize,
			idea.instrument.precision
		);//

		var text = {};
		Object.keys(ogtext).forEach(function (i){
			text[i] = $scope.$eval( $interpolate( ogtext[i] ) );
		});


		if (trade.tradeStrategy.strategyId === OptionsStrategyConstants.OPTIONS_STRATEGY.longotmputbutterfly) {
			popoverText.maxLoss = '<p>'  + text['max-loss-bearish-long-call-otm-butterfly'] + '</p>';
			popoverText.netCost = '<p>'  + text['net-cost-bearish-long-call-otm-butterfly'] + '</p>'
								+ '<h5>' + text['net-premium-paid-title'] + '</h5>'
								+ '<p>'  + $scope.premiumPaidLowerStrikeLongCall + ' + '
										 + $scope.premiumPaidHigherStrikeLongCall
										 + ' (' + text['premium-paid-2-long-puts'] + ')' + '</p>'
								+ '<p><strong>&minus;</strong> '
										+ $scope.premiumReceivedShortCall
										+ ' <strong>&minus;</strong> '
										+ $scope.premiumReceivedShortCall
										+ ' (' + text['premium-received-for-2-short-puts-per-share'] + ')'
								+ '<p><strong>= ' + $scope.netCostPerShare + ' ('+ text['net-premium-paid-per-share'] + ')' + '</strong></p>'
								+ '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' <strong>&times;</strong> '
									+ trade.legs.head.instrument.blockSize
										+ ' (' + text['base-quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
								+ '<p><strong>= ' + $scope.netPremiumPaid + ' ('+ text['net-premium-paid-title'] + ')' + '</strong></p>';
			popoverText.targetPrice  = '<p>'  + text['target-price-bearish-long-call-otm-butterfly'] + '</p>';
			popoverText.maxProfit = '<p>'  + text['max-profit-bearish-long-call-otm-butterfly'] + '</p>'
							  + '<h5>' + text['maximum-profit'] + '</h5>'
							  + '<p>' +  $scope.strikePriceUpper + ' - ' + $scope.strikePriceMiddle + ' ' + text['higher-strike-to-middle-strike']
							  + '<p><strong>-</strong> ' + $scope.premiumPaidPerShare   + ' (' + text['net-premium-paid-per-share'] + ')' + '</p>'
							  + '<p><strong>= ' + $scope.maxProfitPerShare
							        + ' ('+ text['max-profit-per-share'] + ')' + '</strong></p>'
							  + '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' &times; '
							            + trade.legs.head.instrument.blockSize
							            + ' (' + text['base-quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
							  + '<p><strong>= '  + $scope.maxProfit + ' ('+ text['max-profit-title'] + ')' + '</strong></p>'
							  + '<p><strong>&divide;</strong> ' + $scope.netCost + ' ('+ text['net-cost'] + ')' + '</strong></p>'
							  + '<p><strong>= ' + $scope.maxProfitPercent + ' ('+ text['return'] + ')' + '</strong></p>';
			if ($scope.targetPrice < $scope.strikePriceMiddle) {
				popoverText.targetProfit =  '<p>'  + text['target-profit-bearish-long-call-otm-butterfly-between-lower-and-middle-strike'] + '</p>'
										 + '<h5>' + text['target-profit'] + '</h5>'
										 // + '<p>'  + $scope.targetPrice + ' - ' + $scope.strikePriceLower + ' (' + text['target-price-to-lower-strike'] + ')' + '</p>'
										 + '<p><strong>-</strong> ' + $scope.premiumPaidPerShare +  ' (' + text['net-premium-paid-per-share'] + ') ' + '</p>'
										 + '<p><strong>-</strong> ' + $scope.strikePriceMiddle + ' <strong>-</strong> ' + $scope.strikePriceMiddle + ' (' + text['two-middle-strike-obligation-to-buy']  + ')' + '</p>'
										 + '<p><strong>+</strong> ' + $scope.strikePriceUpper + ' (' + text['higher-strike-to-sell'] + ') ' + '</p>'
										 + '<p><strong>+</strong> ' + $scope.targetPrice
										        + ' (' + text['target-price-to-sell'] + ')' + '</p>'
										 + '<p><strong>= ' + $scope.targetProfitPerShare
										        + ' (' + text['target-profit-per-share'] + ') ' + '</strong></p>'
										 + '<p><strong>&times;</strong> ' + $scope.quantityOfContracts
										        + ' <strong>&times;</strong> ' + trade.legs.head.instrument.blockSize
										            + ' (' + text['base-quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
										 + '<p><strong>= ' + $scope.targetProfit + ' (' + text['target-profit'] + ')' +  '</strong></p>'
										 + '<p><strong>&divide;</strong> ' + $scope.netCost + ' ('+ text['net-cost'] + ')' + '</strong></p>'
										 + '<p><strong>= ' + $scope.targetProfitPercent + ' ('+ text['return'] + ')' + '</strong></p>';

				popoverText.targetPrice  = '<p>'  + text['target-price-bearish-long-call-otm-butterfly'] + '</p>';
			} else if ($scope.targetPrice >= $scope.strikePriceMiddle) {
				popoverText.targetProfit = '<p>'  + text['target-profit-bearish-long-call-otm-butterfly-between-middle-and-upper-strike'] + '</p>'
										 + '<h5>' + text['target-profit'] + '</h5>'
										 + '<p>' + $scope.strikePriceUpper +  ' (' + text['higher-strike-price'] + ')' + '</p>'
										 + '<p><strong>-</strong> ' + $scope.targetPrice + ' (' + text['target-price'] + ')' + '</p>'
										 + '<p><strong>-</strong> ' + $scope.premiumPaidPerShare +  ' (' + text['net-premium-paid-per-share'] + ') ' + '</p>'
										 +  '<p><strong>= ' + $scope.targetProfitPerShare + ' ('+ text['target-profit-per-share'] + ')' + '</strong></p>'
										 + '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' <strong>&times;</strong> '
										        + trade.legs.head.instrument.blockSize
										            + ' (' + text['base-quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
										 + '<p><strong>= ' + $scope.targetProfit + ' (' + text['target-profit'] + ')' +  '</strong></p>'
										 + '<p><strong>&divide;</strong> ' + $scope.netCost + ' ('+ text['net-cost'] + ')' + '</strong></p>'
										 + '<p><strong>= ' + $scope.targetProfitPercent + ' ('+ text['return'] + ')' + '</strong></p>';

			}

		} else if (trade.tradeStrategy.strategyId === OptionsStrategyConstants.OPTIONS_STRATEGY.longotmcallbutterfly) {

			popoverText.maxLoss = '<p>'  + text['max-loss-bullish-long-call-otm-butterfly'] + '</p>';
			popoverText.netCost = '<p>'  + text['net-cost-bullish-long-call-otm-butterfly'] + '</p>'
								+ '<h5>' + text['net-premium-paid-title'] + '</h5>'
								+ '<p>'  + $scope.premiumPaidLowerStrikeLongCall + ' + '
										 + $scope.premiumPaidHigherStrikeLongCall
										 + ' (' + text['premium-paid-2-long-calls'] + ')' + '</p>'
								+ '<p><strong>&minus;</strong> '
										+ $scope.premiumReceivedShortCall
										+ ' <strong>&minus;</strong> '
										+ $scope.premiumReceivedShortCall
										+ ' (' + text['premium-received-for-2-short-calls-per-share'] + ')'
								+ '<p><strong>= ' + $scope.netCostPerShare + ' ('+ text['net-premium-paid-per-share'] + ')' + '</strong></p>'
								+ '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' <strong>&times;</strong> '
									+ trade.legs.head.instrument.blockSize
										+ ' (' + text['base-quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
								+ '<p><strong>= ' + $scope.netPremiumPaid + ' ('+ text['net-premium-paid-title'] + ')' + '</strong></p>';
			popoverText.targetPrice  = '<p>'  + text['target-price-bullish-long-call-otm-butterfly'] + '</p>';
			popoverText.maxProfit = '<p>'  + text['max-profit-bullish-long-call-otm-butterfly'] + '</p>'
								  + '<h5>' + text['maximum-profit'] + '</h5>'
								  + '<p>' +  $scope.strikePriceMiddle + ' - ' + $scope.strikePriceLower + ' ' + text['middle-strike-to-lower-strike']
								  + '<p><strong>-</strong> ' + $scope.premiumPaidPerShare   + ' (' + text['net-premium-paid-per-share'] + ')' + '</p>'
								  + '<p><strong>= ' + $scope.maxProfitPerShare + ' ('+ text['max-profit-per-share'] + ')' + '</strong></p>'
								  + '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' &times; '
								        + trade.legs.head.instrument.blockSize
								            + ' (' + text['base-quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
								  + '<p><strong>= '  + $scope.maxProfit + ' ('+ text['max-profit-title'] + ')' + '</strong></p>'
								  + '<p><strong>&divide;</strong> ' + $scope.netCost + ' ('+ text['net-cost'] + ')' + '</strong></p>'
								  + '<p><strong>= ' + $scope.maxProfitPercent + ' ('+ text['return'] + ')' + '</strong></p>';
			if ($scope.targetPrice <= $scope.strikePriceMiddle) {
				popoverText.targetProfit =  '<p>'  + text['target-profit-bullish-long-call-otm-butterfly-between-lower-and-middle-strike'] + '</p>'
										 +  '<h5>' + text['target-profit'] + '</h5>'
										 +  '<p>'  + $scope.targetPrice + ' - ' + $scope.strikePriceLower + ' (' + text['target-price-to-lower-strike'] + ')' + '</p>'
										 +  '<p><strong>-</strong> ' + $scope.premiumPaidPerShare +  ' (' + text['net-premium-paid-per-share'] + ') ' + '</p>'
										 + '<p><strong>= ' + $scope.targetProfitPerShare + ' (' + text['target-profit-per-share'] + ') ' + '</strong></p>'
										 + '<p><strong>&times;</strong> ' + $scope.quantityOfContracts + ' <strong>&times;</strong> ' + trade.legs.head.instrument.blockSize  + ' (' + text['base-quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
										 + '<p><strong>= ' + $scope.targetProfit + ' (' + text['target-profit'] + ')' +  '</strong></p>'
										 + '<p><strong>&divide;</strong> ' + $scope.netCost + ' ('+ text['net-cost'] + ')' + '</strong></p>'
										 + '<p><strong>= ' + $scope.targetProfitPercent + ' ('+ text['return'] + ')' + '</strong></p>';
				popoverText.targetPrice  = '<p>'  + text['target-price-bullish-long-call-otm-butterfly'] + '</p>';

			} else if ( $scope.strikePriceMiddle < $scope.targetPrice <=  $scope.strikePriceUpper) {
				popoverText.targetProfit = '<p>'  + text['target-profit-bullish-long-call-otm-butterfly-between-middle-and-upper-strike'] + '</p>'
										 + '<h5>' + text['target-profit'] + '</h5>'
										 + '<p><strong>-</strong> ' + $scope.premiumPaidPerShare +  ' (' + text['net-premium-paid-per-share'] + ') ' + '</p>'
										 + '<p><strong>+</strong> ' + $scope.strikePriceMiddle + ' <strong>+</strong> ' + $scope.strikePriceMiddle + ' (' + text['two-middle-strike-obligation-to-sell'] + ') ' + '</p>'
										 + '<p><strong>-</strong> ' + $scope.strikePriceLower + ' (' + text['lower-strike-to-buy'] + ')' + '</p>'
										 + '<p><strong>-</strong> ' + $scope.targetPrice + ' (' + text['target-price-to-buy'] + ')' + '</p>'
										 +  '<p><strong>= ' + $scope.targetProfitPerShare + ' ('+ text['target-profit-per-share'] + ')' + '</strong></p>'
										 + '<p><strong>&times;</strong> ' + $scope.quantityOfContracts
										        + ' <strong>&times;</strong> ' + trade.legs.head.instrument.blockSize
										            + ' (' + text['base-quantity-of-contracts-x-shares-per-contract'] + ')' +  '</p>'
										 + '<p><strong>= ' + $scope.targetProfit + ' (' + text['target-profit'] + ')' +  '</strong></p>'
										 + '<p><strong>&divide;</strong> ' + $scope.netCost + ' ('+ text['net-cost'] + ')' + '</strong></p>'
										 + '<p><strong>= ' + $scope.targetProfitPercent + ' ('+ text['return'] + ')' + '</strong></p>';
			}
		}

		return popoverText;
	};

	OptionsStrategyLongOTMButterfly.prototype.getLegComparator = function(){
		// sort by strikes ascending (#11084)
		return function (legA, legB) {
			return (legA.instrument.strikePrice === legB.instrument.strikePrice) ? 0 :
				(legA.instrument.strikePrice > legB.instrument.strikePrice) ? 1 : -1;
		};
	};

	return OptionsStrategyLongOTMButterfly;
}]);

recogniaApp.factory('OptionsStrategyLongOTMPutButterfly',
['OptionsStrategyLongOTMButterfly', 'OptionsStrategyConstants',
function (OptionsStrategyLongOTMButterfly, OptionsStrategyConstants) {

	var OptionsStrategyLongOTMPutButterfly =
		new OptionsStrategyLongOTMButterfly(false,
			OptionsStrategyConstants.OPTIONS_STRATEGY.longotmputbutterfly);

	return OptionsStrategyLongOTMPutButterfly;
}]);

recogniaApp.factory('OptionsStrategyLongOTMCallButterfly',
['OptionsStrategyLongOTMButterfly', 'OptionsStrategyConstants',
function (OptionsStrategyLongOTMButterfly, OptionsStrategyConstants) {

	var OptionsStrategyLongOTMCallButterfly =
		new OptionsStrategyLongOTMButterfly(false,
			OptionsStrategyConstants.OPTIONS_STRATEGY.longotmcallbutterfly);

	return OptionsStrategyLongOTMCallButterfly;
}]);

/**
 * Created with JetBrains WebStorm.
 * User: hosam
 * Date: 9/6/14
 * Time: 8:37 AM
 * To change this template use File | Settings | File Templates.
 */

'use strict';

/*
 * Provides an interface to all the OptionScore{StrategyX} services
 */
recogniaApp.factory('OptionsStrategy',
['OptionsStrategyConstants', 'OptionsStrategyBase', '$injector',
function (OptionsStrategyConstants, OptionsStrategyBase, $injector) {

	var baseInstance = new OptionsStrategyBase(false, 'fallback');

	// retrieve strategy singleton service by name
	var getScoreServiceImpl = function(strategyId) {
		switch (strategyId) {
			case OptionsStrategyConstants.OPTIONS_STRATEGY.longcall:
				return $injector.get('OptionsStrategyLongCall');
			case OptionsStrategyConstants.OPTIONS_STRATEGY.longput:
				return $injector.get('OptionsStrategyLongPut');
			case OptionsStrategyConstants.OPTIONS_STRATEGY.buywrite:
				return $injector.get('OptionsStrategyBuyWrite');
			case OptionsStrategyConstants.OPTIONS_STRATEGY.marriedput:
				return $injector.get('OptionsStrategyMarriedPut');
			case OptionsStrategyConstants.OPTIONS_STRATEGY.bullcallspread:
				return $injector.get('OptionsStrategyBullCallSpread');
			case OptionsStrategyConstants.OPTIONS_STRATEGY.bullputspread:
				return $injector.get('OptionsStrategyBullPutSpread');
			case OptionsStrategyConstants.OPTIONS_STRATEGY.bearcallspread:
				return $injector.get('OptionsStrategyBearCallSpread');
			case OptionsStrategyConstants.OPTIONS_STRATEGY.bearputspread:
				return $injector.get('OptionsStrategyBearPutSpread');
			case OptionsStrategyConstants.OPTIONS_STRATEGY.longotmcallbutterfly:
				return $injector.get('OptionsStrategyLongOTMCallButterfly');
			case OptionsStrategyConstants.OPTIONS_STRATEGY.longotmputbutterfly:
				return $injector.get('OptionsStrategyLongOTMPutButterfly');
			default:
				console.warn('OptionsStrategy service not found for ' + strategyId);
				return baseInstance;
		}
	};

	// return the singleton object with redirects to proper strategy implementation
	return {
		/**
		 * Make sure a strategy specific service is loaded
		 */
		loadStrategy: function (strategyId) {
			getScoreServiceImpl(strategyId);
		},

		/**
		 * Gets the turning points tooltip lexicon name for a trade
		 */
		getTurningPointsToolTipNames: function (trade) {
			var service = getScoreServiceImpl(trade.tradeStrategy.strategyId);
			return service.getTurningPointsToolTipNames(trade);
		},

		/**
		 * Compares the price difference b/w now and when the option idea was first watched
		 */
		getPriceMove: function(trade) {
			var service = getScoreServiceImpl(trade.tradeStrategy.strategyId);
			return service.getPriceMove(trade);
		},

		/**
		 * Return the popover text for this strategy
		 */
		getPopoverText: function($scope, $interpolate, idea, trade) {
			var service = getScoreServiceImpl(trade.tradeStrategy.strategyId);
			return service.getPopoverText($scope, $interpolate, idea, trade);
		},

		/**
		 * Get the earliest expiry date
		 * (not defined in base or derived class)
		 */
		getEarliestExpiryDate: function(tradeLegs) {
			var earliestExpiry;
			Object.keys(tradeLegs).forEach(function (legType) {
				var leg = tradeLegs[legType],
					type = leg.instrument['resourceType'];

				if (type === OptionsStrategyConstants.CONTRACT_TYPE.optionsContract) {
					if (!earliestExpiry || leg.instrument.expiryDate < earliestExpiry){
						earliestExpiry = leg.instrument.expiryDate;
					}
				}
			});
			return earliestExpiry;
		},

		isBearish: function(trade){
			var service = getScoreServiceImpl(trade.tradeStrategy.strategyId);
			return service.isBearish();
		},

		getPerShareValues: function(trade){
			var service = getScoreServiceImpl(trade.tradeStrategy.strategyId);
			return service.getPerShareValues(trade);
		},

		getLegComparator : function(trade) {
			var service = getScoreServiceImpl(trade.tradeStrategy.strategyId);
			return service.getLegComparator(trade);
		}
	};
}]);

'use strict';

/**
 * Created by arizvi on 6/23/14.
 */

recogniaApp.factory('HasNoTarget', [ function () {

		return {
			process: function (idea) {
				return (
					idea.events[0] === undefined ||
					idea.events[0] === null ||
					idea.events[0].targetPrice === undefined ||
					idea.events[0].targetPrice === null ||
					idea.events[0].targetPrice.percentageMove === undefined ||
					idea.events[0].targetPrice.percentageMove === null
				);
			}
		};
	}
]);
'use strict';

recogniaApp.factory('SettingsTemplate',
['$q', 'REST', 'ArrayUtil','CommonConstants',
function ($q, REST, ArrayUtil, CommonConstants) {

	function getMarketAndExchangeAnswerLists() {
		return REST.CountriesWithExchanges().then(function (response) {
			return getMarketAndExchangeFromCountries(response.data.result.countries);
		});
	}

	function getMarketAndExchangeFromCountries(countries) {
		var exchangeAnswerList = [],
			marketAnswerList = [];
		for (var i= 0; i < countries.length; i++) {
			marketAnswerList.push({
				"id" : countries[i].code,
				"name" : countries[i].name
			});
			for (var j= 0; j < countries[i].exchanges.length; j++) {
				if (countries[i].exchanges[j].hasSecurites !== false) {
					exchangeAnswerList.push({
						"id" : countries[i].exchanges[j].symbolAlternates.RECOGNIA,
						"name" : countries[i].exchanges[j].name
					});
				}
			}
		}
		exchangeAnswerList = ArrayUtil.sortObjectsByPropertyAlpha(exchangeAnswerList, 'name');
		marketAnswerList = ArrayUtil.sortObjectsByPropertyAlpha(marketAnswerList, 'name');
		return {
			exchangeAnswerList: exchangeAnswerList,
			marketAnswerList: marketAnswerList
		};
	}

	function updatePreferenceDefinitionSettings(settings,answerLists) {
		var exchangeAnswerList = answerLists.exchangeAnswerList || [];
		var marketAnswerList = answerLists.marketAnswerList || [];
		settings.map(function (group) {
			for (var count = 0; count < group.questions.length; count++) {
				if (group.questions[count].dataType === 'exchange') {
					group.questions[count].answers = exchangeAnswerList;
				} else if (group.questions[count].dataType === 'market') {
					var marketList = marketAnswerList;
					var oldAnswerList = group.questions[count].answers || [];
					var newAnswerList = [];
					for (var j = 0; j < oldAnswerList.length; j++){
						var index = ArrayUtil.indexOfByProperty(marketList, 'id', oldAnswerList[j].id);
						if (index !== -1) {
							newAnswerList.push(marketList[index]);
						}
					}
					group.questions[count].answers = newAnswerList;
				}
				else if(group.questions[count].dataType === 'instrument'){
					//TODO Need to do something

				}

				// TODO why is this limited to an arbitrary number?
				if (group.questions[count].answers
					&&group.questions[count].answers.length < 9
					&& group.questions[count].uiControl === 'buttonToDropdown') {
					group.questions[count].uiControl = 'button';
				}
			}
		});
		return settings;
	}

	return {

		getSettings: function(product){
			var promiseList = [
				REST.PersonalizedSettingsDefinition(product),
				getMarketAndExchangeAnswerLists()
			];

			var promise = $q.all(promiseList).then(function (responses) {
				var settings = responses[0].data.result.settings;
				var answerLists = responses[1];
				return updatePreferenceDefinitionSettings(settings,answerLists);
			});

			return promise;
		},

		updateSettings: function(settings, countries){
			return updatePreferenceDefinitionSettings(settings,getMarketAndExchangeFromCountries(countries));
		}

	};
}]);
'use strict';

recogniaApp.factory('OptionsProfitLossChart',
['OptionsStrategy', 'HighChartsTheme', 'NumberFormatter', 'Ideas', 'Platform', 'Lexicon',
function (OptionsStrategy, HighChartsTheme, NumberFormatter, Ideas, Platform, Lexicon) {

	var EDGE_MARKER_CONFIG = {
			enabled: false,
			states: {
				hover: {
					enabled: false
				}
			}
		},
	BASE_CONFIG = {
		title: {
			text: ''
		},
		xAxis: {
			title: {
				style: {
					color: HighChartsTheme.chartAxisTitleColor()
				},
				text: ''
			},
			labels: {
				style: {
					color: HighChartsTheme.chartLabel()
				},
				step: 2,
				staggerLines: 1,
				overflow: 'justify',
				formatter: function (){
					return NumberFormatter.formatCurrency(this.value,precision);
				}
			},
			startOnTick: false,
			endOnTick: false,
			tickPixelInterval: 40,
			gridLineColor: HighChartsTheme.chartGL(),
			minorGridLineColor: HighChartsTheme.chartMinorGridlineColor(),
			plotLines: []
		},
		yAxis: {
			title: {
				style: {
					color: HighChartsTheme.chartAxisTitleColor(),
					direction: "ltr" // IE8 doesn't respect text-direction for vertically rendered text.
				},
				text: ''
			},
			offset: 45,
			labels: {
				style: {
					color: HighChartsTheme.chartLabel()
				},
				align: 'center',
				x: 20,
				formatter: function (){
					return NumberFormatter.formatCurrency(this.value,precision);
				}
			},
			startOnTick: false,
			endOnTick: false,
			tickPixelInterval: 60,
			gridLineColor: HighChartsTheme.chartGL(),
			minorGridLineColor: HighChartsTheme.chartMinorGridlineColor(),
			plotLines: [
				{
					id:'_zeroEmphasis',
					color: HighChartsTheme.chartGL(),
					value: 0,
					width: '2'
				}
			]
		},
		series: [
			_createDottedSeriesConfig('dottedLineLeft'),
			{
				id: 'mainData',
				showInLegend: false,
				marker:{
					symbol: 'circle',
					fillColor: HighChartsTheme.chartProfitLossLineColor(),
					states: {
						hover: {
							fillColor: HighChartsTheme.chartProfitLossLineHighlightColor()
						}
					}
				},
				color: HighChartsTheme.chartProfitLossLineColor(),
				lineWidth: 1,
				data: []
			},
			_createDottedSeriesConfig('dottedLineRight'),
			{
				// Hidden series for putting dots that allow for showing the vertical lines
				id: 'hidden',
				showInLegend: false,
				lineWidth: 0,
				data: []

			}
		],

		// Need this because same directive is used for highstocks, has check for reflowing
		options: {},

		// =====================================
		// TODO the common elements here should be abstacted to the chartConfig service
		chart: {
			style: {
				'font-family': "'Open Sans', Arial, Helvetica, sans-serif"
			},
			backgroundColor: HighChartsTheme.chartBG(),
			borderRadius: 0,
			pinchType : 'none',
			reflow: false
		},
		legend: {
			enabled: false
		},
		credits: {
			text: '© ' + (new Date()).getFullYear() + Lexicon.translateDefaultNS('common.chart-' + Platform.data().brand),
			href: 'http://www.recognia.com',
			style:{direction:'ltr'}
		},
		exporting: {
			enabled: false
		}
		// =====================================
	},
	// proportion of center chart section to the sides
	DEFAULT_HORIZONTAL_EDGE_PROPORTION = 0.75,
	DEFAULT_VERTICAL_EDGE_PROPORTION = 0.3,
	DEFAULT_VERT_DOTTED_PROPORTION = 0.35,
	DEFAULT_HORIZ_DOTTED_PROPORTION = 0.15;


	// return common config for dotted line
	function _createDottedSeriesConfig (name)  {
		return {
			id: name,
			dashStyle: 'dot',
			showInLegend: false,
			enableMouseTracking: false,
			marker: EDGE_MARKER_CONFIG,
			color: HighChartsTheme.chartProfitLossLineColor(),
			lineWidth: 2,
			data: []
		};
	}


	function _orderByX(a, b) {
		if (a.x < b.x) return -1;
		else if (a.x > b.x) return 1;
		else return 0;
	}

	// Tooltip priority for the case of overlapping points
	var DEFAULT_TT_PRIORITY = 0;
	var NO_TT_PRIORITY = -100;

	/*
	 * If any points overlap, compare tooltip priorities and make the lower
	 * priority point invisible
	 */
	function _hideOverlapingPointTooltips (dataPoints) {
		var i, j;
		for (i = 0; i < dataPoints.length; i++){
			if (dataPoints[i]._tooltip === undefined)
				dataPoints[i].ttPriority = dataPoints[i].ttPriority || NO_TT_PRIORITY;
			else
				dataPoints[i].ttPriority = dataPoints[i].ttPriority || DEFAULT_TT_PRIORITY;
		}

		var point1, point2;
		for (i = 0; i < dataPoints.length; i++){
			point1 = {
				x: parseFloat(parseFloat(dataPoints[i].x).toFixed(2)),
				y: parseFloat(parseFloat(dataPoints[i].y).toFixed(2))
			};
			for (j = i+1; j < dataPoints.length; j++){
				point2 = {
					x: parseFloat(parseFloat(dataPoints[j].x).toFixed(2)),
					y: parseFloat(parseFloat(dataPoints[j].y).toFixed(2))
				};

				if (point1.x === point2.x && point1.y === point2.y){

					if (dataPoints[i].ttPriority > dataPoints[j].ttPriority){
						dataPoints.splice(j, 1);

					} else if (dataPoints[i].ttPriority < dataPoints[j].ttPriority) {
						dataPoints.splice(i, 1);
						break;

					} else {
						console.warn("Two data points that overlap have the same tooltip priority");
					}
				}
			}
		}
		return dataPoints;
	}


	// object that holds equation of a line y = mx + b
	function Line(slope, point){
		this.m = slope;
		this.b = point.y - this.m * point.x;
	}
	Line.prototype = {
		xFromY: function (y){
			return (y - this.b) / this.m;
		},
		yFromX: function (x){
			return this.m * x + this.b;
		}
	};

	var precision;
	return {

		buildChartConfig : function(idea, trade, lastPrice, horizEdgeProportion, vertEdgeProportion, vertDottedProportion, horizDottedProportion) {
			horizEdgeProportion = horizEdgeProportion || DEFAULT_HORIZONTAL_EDGE_PROPORTION;
			vertEdgeProportion = vertEdgeProportion || DEFAULT_VERTICAL_EDGE_PROPORTION;
			vertDottedProportion = vertDottedProportion || DEFAULT_VERT_DOTTED_PROPORTION;
			horizDottedProportion = horizDottedProportion || DEFAULT_HORIZ_DOTTED_PROPORTION;

			precision = idea.instrument.precision;

			var chartConfig = angular.copy(BASE_CONFIG),
			horizEdgeWidth,
			vertEdgeWidth,
			vertDottedLen,
			horizDottedLen,
			centerMinY,
			centerMaxY,
			maxYBeforeDotted,
			minYBeforeDotted,
			leftExtremePoint,
			rightExtremePoint,
			turningPoints,
			profitZonePoints,
			targetProfitPoint,
			leftLineEquation,
			rightLineEquation,
			data = [],
			dottedLeftData,
			dottedRightData;


			// == Get break even points, target point ==

			targetProfitPoint = {
				ttPriority: -1,
				_tooltip: {},
				x: parseFloat(Ideas.getConservativeTargetPrice(idea))

			};
			targetProfitPoint.y = parseFloat(trade.targetProfit);
			if (targetProfitPoint.y < 0){
				targetProfitPoint._tooltip.contentLexiconKey = 'optionsProfitLossChart.tt-loss-X-at-expiry';
			} else {
				targetProfitPoint._tooltip.contentLexiconKey = 'optionsProfitLossChart.tt-profit-X-at-expiry';
			}

			data.push(targetProfitPoint);

			// Profit zone
			profitZonePoints = [];
			trade.profitZone.forEach(
				function (profitRange) {

					var getPoint = function (value) {
						var num = parseFloat(value);
						if (num !== 0 && num !== Infinity && num !== -Infinity) {
							return {
								_tooltip: {},
								x: num,
								y: 0 // No profit

							};
						} else {
							return null;
						}
					};

					var point;

					if (profitRange.upper === profitRange.lower) {
						point = getPoint(profitRange.lower);
						if (point!==null) {
							point.contentLexiconKey = 'optionsProfitLossChart.tt-break-even-is-X';
							profitZonePoints.push(point);
						}
					} else {
						var point1 = getPoint(profitRange.lower);
						var point2 = getPoint(profitRange.upper);

						if (point1!==null && point2!==null) {
							point1._tooltip.contentLexiconKey= 'optionsProfitLossChart.tt-break-even-2-profit-between';
							point1._tooltip.breakEvens = [point1.x, point2.x];
							point2._tooltip.contentLexiconKey= 'optionsProfitLossChart.tt-break-even-2-profit-between';
							point2._tooltip.breakEvens = [point1.x, point2.x];
							profitZonePoints.push(point1);
							profitZonePoints.push(point2);

						} else if (point1 !== null) {
							point1._tooltip.contentLexiconKey = 'optionsProfitLossChart.tt-break-even-is-X';
							profitZonePoints.push(point1);
						} else if (point2 !== null) {
							point2._tooltip.contentLexiconKey = 'optionsProfitLossChart.tt-break-even-is-X';
							profitZonePoints.push(point2);
						}
					}
				}
			);
			data = data.concat(profitZonePoints);


			// == Get turning points ==
			// assuming that there will always be at least one turning point
			turningPoints = [];
			var tooltipLexicons = OptionsStrategy.getTurningPointsToolTipNames(trade);
			for (var index=0; index <  trade.profitLossPlot.strikePricePoints.length; index++) {
				turningPoints.push ({
						_tooltip: {
							contentLexiconKey:  'optionsProfitLossChart.' + tooltipLexicons[index]
						},
						x: parseFloat(trade.profitLossPlot.strikePricePoints[index].price),
						y: parseFloat(trade.profitLossPlot.strikePricePoints[index].profit)
				});
			}
			data = data.concat(turningPoints);

			// sort these key points by X value
			data.sort(_orderByX);


			// == set Axis min and max so that lines go right to the edge ==

			horizEdgeWidth = (data[data.length-1].x - data[0].x) * horizEdgeProportion;

			chartConfig.xAxis.min = data[0].x - horizEdgeWidth;
			if (chartConfig.xAxis.min < 0)chartConfig.xAxis.min = 0;
			chartConfig.xAxis.max = data[data.length-1].x + horizEdgeWidth;

			if(lastPrice < chartConfig.xAxis.min) {
				chartConfig.xAxis.min = lastPrice -1;
			} else if (lastPrice > chartConfig.xAxis.max) {
				chartConfig.xAxis.max = Number(lastPrice) + 1;
			}
			// data sorted by x, not y, have to find extremes
			centerMinY = data[0].y;
			centerMaxY = data[0].y;
			data.forEach(function (point){
				if (centerMinY > point.y) centerMinY = point.y;
				if (centerMaxY < point.y) centerMaxY = point.y;
			});
			vertEdgeWidth = (centerMaxY - centerMinY) * vertEdgeProportion;

			chartConfig.yAxis.min = centerMinY - vertEdgeWidth;
			chartConfig.yAxis.max = centerMaxY + vertEdgeWidth;


			// == Calculate the right and left extremes ==

			vertDottedLen = vertEdgeWidth * vertDottedProportion;
			maxYBeforeDotted = chartConfig.yAxis.max - vertDottedLen;
			minYBeforeDotted  = chartConfig.yAxis.min + vertDottedLen;

			horizDottedLen = horizEdgeWidth * horizDottedProportion;


			// get equation of the line
			var point  = trade.profitLossPlot.strikePricePoints[0];
			leftLineEquation = new Line(trade.profitLossPlot.initialSlope, {
				x: parseFloat(point.price),
				y: parseFloat(point.profit)
			});

			// stock price can't go below zero, so if zero is on the chart,
			// draw right to the edge
			leftExtremePoint = {
				marker: EDGE_MARKER_CONFIG,
				x: (chartConfig.xAxis.min === 0) ? 0 : chartConfig.xAxis.min + horizDottedLen
			};
			leftExtremePoint.y = leftLineEquation.yFromX(leftExtremePoint.x);


			// if leftExtremePoint.y above upper boundary or below lower boundary,
			// choose point at boundary
			if (leftExtremePoint.y >= maxYBeforeDotted){
				// get the point at the boundary
				leftExtremePoint.x = leftLineEquation.xFromY(maxYBeforeDotted);
				leftExtremePoint.y = maxYBeforeDotted;

			} else if (leftExtremePoint.y < minYBeforeDotted){
				// get the point at the boundary
				leftExtremePoint.x = leftLineEquation.xFromY(minYBeforeDotted);
				leftExtremePoint.y = minYBeforeDotted;
			}

			// slope of the line determines tooltip
			// if (lineEquation.m === 0) no tooltip
			if (leftLineEquation.m > 0){
				leftExtremePoint._tooltip = {
					contentLexiconKey: 'optionsProfitLossChart.tt-unlimited-loss-but-zero',
					price: 0,
					profit: leftLineEquation.yFromX(0)
				};
			} else if (leftLineEquation.m < 0){
				leftExtremePoint._tooltip = {
					contentLexiconKey: 'optionsProfitLossChart.tt-unlimited-profit-but-zero',
					price: 0,
					profit: leftLineEquation.yFromX(0)
				};
			}


			// get equation of the line
			point = trade.profitLossPlot.strikePricePoints[trade.profitLossPlot.strikePricePoints.length-1];
			rightLineEquation = new Line(trade.profitLossPlot.finalSlope, {
				x: parseFloat(point.price),
				y: parseFloat(point.profit)
			});

			rightExtremePoint = {
				marker: EDGE_MARKER_CONFIG,
				x: chartConfig.xAxis.max - horizDottedLen
			};
			rightExtremePoint.y = rightLineEquation.yFromX(rightExtremePoint.x);



			// if rightExtremePoint.y above upper boundary or below lower boundary, choose point at boundary
			if (rightExtremePoint.y > maxYBeforeDotted){
				// get the point at the boundary
				rightExtremePoint.x = rightLineEquation.xFromY(maxYBeforeDotted);
				rightExtremePoint.y = maxYBeforeDotted;

			} else if (rightExtremePoint.y < minYBeforeDotted){
				// get the point at the boundary
				rightExtremePoint.x = rightLineEquation.xFromY(minYBeforeDotted);
				rightExtremePoint.y = minYBeforeDotted;
			}

			// slope of the line determines tooltip
			// if (lineEquation.m === 0) no tooltip
			if (rightLineEquation.m < 0){
				rightExtremePoint._tooltip = {
					contentLexiconKey: 'optionsProfitLossChart.tt-unlimited-loss'
				};
			} else if (rightLineEquation.m > 0){
				rightExtremePoint._tooltip = {
					contentLexiconKey: 'optionsProfitLossChart.tt-unlimited-profit'
				};
			}


			data.splice(0, 0, leftExtremePoint);
			data.push(rightExtremePoint);


			// in the extremely unlikely case where a turning point is below
			// a stock price of zero, need to sort again
			data.sort(_orderByX);

			data = _hideOverlapingPointTooltips(data);

			chartConfig.series[1].data = data;


			// == Get the dotted lines ==
			// draw from edge data point to beyond edge of chart
			dottedLeftData = [
				{
					x: chartConfig.xAxis.min - 1
				},
				leftExtremePoint
			];
			dottedLeftData[0].y = leftLineEquation.yFromX(dottedLeftData[0].x);
			dottedRightData = [
				rightExtremePoint,
				{
					x: chartConfig.xAxis.max + 1
				}
			];
			dottedRightData[1].y = rightLineEquation.yFromX(dottedRightData[1].x);


			chartConfig.series[0].data = dottedLeftData;
			chartConfig.series[2].data = dottedRightData;


			// Add latest stock price as an invisible point to make sure the
			// vertical line is on the chart. Only need to add if it's
			// outside the range of the other points

			chartConfig.series[3].data = (chartConfig.xAxis.plotLines || [])
				.map(function (line) {
					// return a point config
					return {
						marker: EDGE_MARKER_CONFIG,
						x: line.value,
						y:0
					};
				});

			return chartConfig;
		}

	};
}]);

'use strict';

/*
 * This file is filtered during the jenkins build to evaluate environment
 * variables using:
 * eval "echo -e \"`<path/to/jenkins.js`\"" > path/to/jenkins.js
 */
recogniaApp.factory('Jenkins', [
	function () {
		return{

			OS: '$OS',

			ARCH: '$ARCH',

			STOP: '$STOP',

			BRANCH: '$BRANCH',

			REVISION: '$REVISION',

			TIMESTAMP: '$TIMESTAMP',

			// The current build number, such as "153"
			BUILD_NUMBER: '$BUILD_NUMBER',

			JOB_URL: '$JOB_URL'
		};
	}
]);

'use strict';

recogniaApp.factory('GoogleAnalytics',
['REST','$q','Platform',
function (REST, $q, Platform) {
	var GoogleAnalytics = {
		"gaAccount"    		: null,
		"gaIdentifier" 		: null,
		"accountLoaded"		: false,
		"userIdLoaded" 		: false,
		"recogUserId"  		: null,
		"productLabels" 	: {
			"alternatives": "alternatives",
			"compared": "compared",
			"stocks" : "featured-stocks",
			"options": "featured-options",
			"watched": "watched",
			"personal-settings": "custom-settings"
		},

		"ideaLabels": {
			"alternatives-stock":  "alternatives-stock-idea",
			"alternatives-option": "alternatives-option-idea",
			"compared-stock":  "compared-stock-idea",
			"compared-option": "compared-option-idea",
			"stocks-stock": "featured-stock-idea",
			"options-option": "featured-option-idea",
			"watchedStocks-stock":  "watched-stock-idea",
			"watchedOptions-option": "watched-option-idea",
			"watchedForex-forex": "watched-forex-idea"
		},

		"gaEvents": function(data) {
			return {
				"ideas-platform": {
					"view-personal-link": {
						"label" : data.productType,
						"action": "view-personal-link"
					},

					"prompt-custom-settings-answered": {
						"label" : "answered",
						"action": "prompt-custom-settings"
					},
					"prompt-custom-settings-dismissed": {
						"label" : "dismissed",
						"action": "prompt-custom-settings"
					},

					"close-custom-settings": {
						"label" : 'changed | unchanged',
						"action": "close-custom-settings"
					},
					"click-company-info":{
						"label": 	data.ideaType + ":"
								  + data.instrumentSymbol,
						"action" : "click-company-info"
					},
					"click-watch":{
						"label": 	data.ideaType + ":"
								  + data.instrumentSymbol,
						"action" : "click-watch"
					},
					"click-unwatch":{
						"label": 	data.ideaType + ":"
								  + data.instrumentSymbol,
						"action" : "click-unwatch"
					},
					"view-backtesting":{
						"label": 	data.ideaType + ":"
								  + data.instrumentSymbol,
						"action" : "view-backtesting"
					},
					"toggle-backtesting-trailing-stop": {
						"label": 	data.ideaType + ":"
								  + data.instrumentSymbol,
						"action" : "toggle-backtesting-trailing-stop"
					},
					"click-summary": {
						"label": 	data.ideaType + ":"
								  + data.instrumentSymbol,
						"action" : "click-summary"
					},
					"click-idea": {
						"label": 	data.ideaType + ":"
								  + data.instrumentSymbol,
						"action" : "click-idea"
					},
					"switch-idea": {
						"label": 	data.ideaType + ":"
								  + data.instrumentSymbol,
						"action" : "click-idea"
					},
					"click-commentary": {
						"label": 	data.ideaType + ":"
								  + data.instrumentSymbol,
						"action" : "click-commentary"
					},
					"view-large-chart": {
						"label": 	data.ideaType + ":"
								  + data.instrumentSymbol,
						"action" : "view-large-chart"
					},
					"click-trade-button": {
						"label": 	data.ideaType + ":"
								  + data.instrumentSymbol,
						"action" : "click-trade-button"
					},
					"view-profit-loss": {
						"label": 	data.ideaType + ":"
								  + data.instrumentSymbol,
						"action" : "view-profit-loss"
					},
					"view-alternative-strategies": {
						"label": 	data.ideaType + ":"
								  + data.instrumentSymbol,
						"action" : "view-alternative-strategies"
					},
					"view-options-calculations": {
						"label": 	data.ideaType + ":"
								  + data.instrumentSymbol,
						"action" : "view-options-calculations"
					},
					"click-category": {
						"label": 	"watched",
						"action" : "click-category"
					},
					"select-category": {
						"label" : data.productType,
						"action": "select-category"
					}
				}
			};
		},

		"getInstrumentType": function() {
			return GoogleAnalytics.instrumentType;
		},

		"setInstrumentType": function(value) {
			GoogleAnalytics.instrumentType = value;
		},

		"infoAvailable": function() {
			return (
				GoogleAnalytics.gaAccount &&
				GoogleAnalytics.gaIdentifier &&
				GoogleAnalytics.recogUserId
			);
		},

		"getAccountInfo": function() {
			return {
				"gaAccount": 	GoogleAnalytics.gaAccount,
				"gaIdentifier": GoogleAnalytics.gaIdentifier,
				"recogUserId":  GoogleAnalytics.recogUserId
			};
		},

		"setUp": function() {

			GoogleAnalytics.httpRequests = [
				REST.UserPreferencesCached().success(function (data) {
					GoogleAnalytics.recogUserId = data.result.recogniaUserId;
				}).error(function () {
					console.error('failed to get the user');
				}),
				Platform.init()
			];
			GoogleAnalytics.promise = $q.all(GoogleAnalytics.httpRequests).then(
				function() {
					GoogleAnalytics.gaIdentifier = Platform.data().googleView;
					GoogleAnalytics.gaAccount = Platform.data().googleAccount;
					GoogleAnalytics.loadGoogleAnalytics();
				}
			);
		},
		"loadGoogleAnalytics": function() {
			/* jshint ignore:start */
			(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
				(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
				m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
			})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
			/* jshint ignore:end */
			window.ga('create',
				GoogleAnalytics.gaAccount,
				{
					'storage': 'none',
					'clientId': GoogleAnalytics.recogUserId,
					'siteSpeedSampleRate': 20
				}
			);
			window.ga('require', 'displayfeatures');
		},

		"sendPageView": function(pageId) {
		},

		"sendEvent": function(category, action, label) {
		}
	};
	
	return GoogleAnalytics;
}]);

'use strict';

recogniaApp.factory('OptionsIdeasScore',
['$interpolate', '$injector', 'Lexicon', 'CommonConstants', 'OptionsStrategyConstants',
function ($interpolate, $injector, Lexicon, CommonConstants, OptionsStrategyConstants) {

	var DEFAULT_MIN_VOLUME = 1000000,
	EXCHANGE_MIN_VOLUME = {
		"TORONTO": 1000000,
		"TSXV": 1000000,
		"AMEX": 1000000,
		"NASDAQ": 1000000,
		"NYSE": 1000000,
		"LONDON": 1000000
	},
	DISABLED = "OFF";

	var scoreFactors = {};
	scoreFactors.targetProfitPercent = {};
	scoreFactors.targetProfitPercent.base = {
		getRanges: function(){
			return [
				{
					scores: ['AAA'],
					range: new NumberRange(2.0, true, Infinity, true),
					lexKey: 'fsTarget.j_profit_a1',
					lexKeyLimiting: 'fsTarget.j_profit_a1'
				},
				{
					scores: ['AA'],
					range: new NumberRange(1.5, true, 2.0, false),
					lexKey: 'fsTarget.j_profit_a3',
					lexKeyLimiting: 'fsTarget.j_profit_a2'

				},
				{
					scores: ['A'],
					range: new NumberRange(1.0, true, 1.5, false),
					lexKey: 'fsTarget.j_profit_a4',
					lexKeyLimiting: 'fsTarget.j_profit_a2'
				},
				{
					scores: ['C'],
					range: new NumberRange(0.0, false, 1.0, false),
					lexKey: null,
					lexKeyLimiting: 'fsTarget.j_profit_a5'
				},
				{
					scores: ['X'],
					range: new NumberRange(-Infinity, true, 0.0, true),
					lexKey: null,
					lexKeyLimiting: 'fsTarget.j_profit_a6'
				}
			];
		},
		getActual: function(idea){
			return idea.trade.targetProfitPercent;
		}
	};
	scoreFactors.volume = {};
	scoreFactors.volume.base = {
		getRanges: function(idea){
			var vThreshold = (EXCHANGE_MIN_VOLUME[idea.instrument.exchange.symbol]) ?
					EXCHANGE_MIN_VOLUME[idea.instrument.exchange.symbol] : DEFAULT_MIN_VOLUME;
			return [
				{
					scores: ['AAA', 'AA'],
					range: new NumberRange(vThreshold, true, Infinity, true),
					lexKey: 'fsTarget.j_volume_a1',
					lexKeyLimiting: 'fsTarget.j_volume_a1'
				},
				{
					scores: ['A'],
					range: new NumberRange(0, true, vThreshold, false),
					lexKey: null,
					lexKeyLimiting: 'fsTarget.j_volume_a2'
				}
			];
		},
		getActual: function(idea){
			var stockVolume;
			if (idea.events.length !== 0) {
				stockVolume = Number(idea.events[0].endPrices.volume);
			} else {
				stockVolume = Number(idea.instrument.latestPrice.volume);
			}
			return stockVolume;
		}
	};
	scoreFactors.priceSpread = {};
	scoreFactors.priceSpread.base = {
		getRanges: function(){
			return [
				{
					scores: ['AAA'],
					range: new NumberRange(0.00, true, 0.05, true),
					lexKey: 'fsTarget.j_pricespread_a1',
					lexKeyLimiting: 'fsTarget.j_pricespread_a1'
				},
				{
					scores: ['AA'],
					range: new NumberRange(0.05, false, 0.10, true),
					lexKey: 'fsTarget.j_pricespread_a2',
					lexKeyLimiting: 'fsTarget.j_pricespread_a2'
				},
				{
					scores: ['A'],
					range: new NumberRange(0.10, false, 0.12, true),
					lexKey: 'fsTarget.j_pricespread_a2',
					lexKeyLimiting: 'fsTarget.j_pricespread_a2'
				},
				{
					scores: ['C'],
					range: new NumberRange(0.12, false, Infinity, true),
					lexKey: null,
					lexKeyLimiting: 'fsTarget.j_pricespread_a3'
				},
				{
					scores: ['C'],
					range: NumberRange.NaNRange,
					lexKey: null,
					lexKeyLimiting: 'fsTarget.j_pricespread_a3'
				}
			];
		},
		getActual: function(idea){
			var maxSpread = null;
			// find the largest bid/ask spread of all the options contracts
			var legKeys = Object.keys(idea.trade.legs);
			for (var i = 0, l = legKeys.length; i< l; i++) {
				// assume if it's not a instrument leg it's an options contract
				if (legKeys[i] !== OptionsStrategyConstants.CONTRACT_TYPE.instrument){
					var ask = parseFloat(idea.trade.legs[legKeys[i]].instrument.latestPrice.ask),
					bid = parseFloat(idea.trade.legs[legKeys[i]].instrument.latestPrice.bid);

					if (!isNaN(ask) && !isNaN(bid)) {
						var legSpread = (ask - bid) / ask;
						maxSpread = (legSpread > maxSpread) ? legSpread : maxSpread;
					} else {
						// if any contract is missing either bid or ask, get downgraded
						maxSpread = Number.NaN;
						break;
					}
				}
			}
			return maxSpread;
		}
	};
	// this is for the OptionsStrategy service which will be lazily loaded
	var OptionsStrategy = null;

	return {

		/*
		 * Disables a factor for a given strategy type.
		 */
		disableFactorForStrategy: function (factor, strategyId) {
			if (!scoreFactors[factor]){
				scoreFactors[factor] = {};
			}
			scoreFactors[factor][strategyId] = DISABLED;
		},

		/*
		 * Adds a custom set of ranges to a factor for a strategy type. If the
		 * factor does not exist yet it will be created.
		 */
		addStrategySpecificRanges: function(factor, strategyId, actualValFn, rangesFn){
			if (!scoreFactors[factor]){
				scoreFactors[factor] = {};
			}
			scoreFactors[factor][strategyId] = {
				getRanges: rangesFn,
				getActual: actualValFn
			};
		},

		/*
		 * For some factor, get the range function for the base case. Useful if
		 * you want to inherit the range function.
		 */
		getBaseRangeFn: function(factor){
			return (scoreFactors[factor].base)
				? scoreFactors[factor].base.getRanges : null;
		},

		/*
		 * For some factor, get the actual value function for the base case.
		 * Useful if you want to inherit the actual value function.
		 */
		getBaseActualFn: function(factor){
			return (scoreFactors[factor].base)
				? scoreFactors[factor].base.getActual : null;
		},

		/*
		 * Takes an idea with an expanded trade and tradeStrategy.
		 */
		getScoreJustificationList: function (idea) {
			// make sure strategy specific things have been added
			if (OptionsStrategy === null){
				OptionsStrategy = $injector.get('OptionsStrategy');
			}
			OptionsStrategy.loadStrategy(idea.trade.tradeStrategy.strategyId);

			if (idea.ideaType !== CommonConstants.IDEA_TYPE.option){
				throw 'Only works with an options idea';
			}

			var jList = [];
			var stratId = idea.trade.tradeStrategy.strategyId;

			var factorKeys = Object.keys(scoreFactors);
			for (var i = 0, l = factorKeys.length; i < l; i++) {

				var factor = scoreFactors[factorKeys[i]];
				var specific = (factor[stratId]) ? stratId : 'base';
				// this factor may not be defined for base or for this strategy
				// or it may be intentionally disabled for this strategy
				if (factor[specific] && factor[specific] !== DISABLED) {
					var actualVal = parseFloat(factor[specific].getActual(idea));
					if (isNaN(actualVal)) continue;

					// find what range, if any, the actual value fits in
					var ranges = factor[specific].getRanges(idea);
					var justification = null;
					for (var j = 0, m = ranges.length; j < m; j++) {
						if (ranges[j].range.contains(actualVal)){
							// if the actual score matches, then this was one of the limiting factors
							var lexiconKey = (ranges[j].scores.indexOf(idea.trade.scoreGrade) !== -1) ?
									ranges[j].lexKeyLimiting : ranges[j].lexKey;
							if (lexiconKey){
								// interpolate to avoid putting these values in scope.
								// the bounds don't change, and if the score changed
								// you would want to call this whole method again anyways
								justification = $interpolate(
									Lexicon.translateDefaultNS(lexiconKey)
								)({
									lowerBound: ranges[j].range.getLowerBound(),
									upperBound: ranges[j].range.getUpperBound(),
									idea: idea,
									actualValue: actualVal
								});
							}
							break;
						}
					}
					if (justification){
						jList.push(justification);
					}
				}
			}
			return jList;
		}
	};
}]);
'use strict';

recogniaApp.factory('UserPreferences',
    [
        function () {
            var userPreferences = {};
            return {
                setUserPreferences: function (_userPreferences) {
                    userPreferences = _userPreferences;
                },

                getUserPreferences: function () {
                    return userPreferences;
                }
            };
        }
    ]
);

'use strict';

/* EventTypes Services */

var ELLIOT_WAVE_EVENT_CODE = 2000;


recogniaApp.factory('EventTypes',
	['$q', 'Config', 'REST',
		function ($q, Config, REST) {

			var events;
			var idMap = {};
			var initDoneCallbacks = [];

			$q.all([REST.EventTypes()]).then(function (responses) {
				events = {
					'resourceType': 'eventtypes',
					'eventTypes': []
				};

				// Filter the events returned, in order to remove the Elliot Wave event (event type code 2000),
				// which is not supported anymore.
				var eventTypes = responses[0].data.eventTypes.filter(function (eventType) {
					return eventType.eventTypeCode !== ELLIOT_WAVE_EVENT_CODE;
				});

				eventTypes.forEach(function (eventType) {
					var transformedEventType = eventTypeMapper(eventType);
					events.eventTypes.push(transformedEventType);

					idMap[eventType.eventTypeId] = transformedEventType;
				});

				initDoneCallbacks.forEach(function (func) {
					func();
				});
			});

			/**
			 * Maps the new eventtypes/v3 API response to the old response object expected by the application,
			 * by changing `eventClass` property to `class`.
			 *
			 * @param eventType an event type from the event types response array returned by the new eventtypes/v3 API
			 * @returns {object}
			 */
			function eventTypeMapper(eventType) {
				eventType['resourceType'] = 'eventType';
				eventType['class'] = eventType['eventClass'];
				// delete the old key
				delete eventType['eventClass'];

				return eventType;
			}

			return {

				/**
				 * Returns a promise that resolves when the service has finished loading
				 */
				init: function () {
					var progress = $q.defer();
					if (events !== undefined) {
						progress.resolve({});
					} else {
						initDoneCallbacks.push(function () { progress.resolve({}); });
					}
					return progress.promise;
				},

				all: function() {
					return events;
				},

				byId: function(id) {
					return idMap[id];
				}
			};
		}]);


'use strict';

/* ChartSection Services */

recogniaApp.factory('ChartSections',
	['$q', 'Config', 'REST',
		function ($q, Config, REST) {

			var dataModel;
			var idMap = {};
			var initDoneCallbacks = [];

			$q.all ([REST.ChartSections()]).then (function(responses) {
				dataModel = responses[0].data.result;

				dataModel.sections.forEach(function (section) {
					idMap[section.sectionId] = section;
				});
				initDoneCallbacks.forEach(function (func){
					func();
				});
			});


			return {

				/**
				 * Returns a promise that resolves when the service has finished loading
				 */
				init: function () {
					var progress = $q.defer();
					if (dataModel !== undefined) {
						progress.resolve({});
					} else {
						initDoneCallbacks.push(function () { progress.resolve({}); });
					}
					return progress.promise;
				},

				byId: function(id) {
					return idMap[id];
				}
			};
		}]);


'use strict';

/* Platform Services */

recogniaApp.factory('Platform',
    ['$q', 'Config', 'REST',
        function ($q, Config, REST) {

            var dataModel;
            var initDoneCallbacks = [];

            $q.all ([REST.Platform()]).then (function(responses) {

                dataModel = responses[0].data.result;

                initDoneCallbacks.forEach(function (func){
                    func();
                });
            });


            return {

                /**
                 * Returns a promise that resolves when the service has finished loading
                 */
                init: function () {
                    var progress = $q.defer();
                    if (dataModel !== undefined) {
                        progress.resolve({});
                    } else {
                        initDoneCallbacks.push(function () { progress.resolve({}); });
                    }
                    return progress.promise;
                },

                data: function() {
                    return dataModel;
                }
            };
        }]);

'use strict';


/**
 * Service used to retrieve a static resource, which is a html file containing an event education (short description) from a static server
 */
recogniaApp.factory('EventEducationStaticService',
    ['$http', 'Config',
        function ($http, Config) {

            return {
                getEventShortDescription: function (eventTypeCode) {
                    var shortDescriptionUrl = Config.static_server_url() +
                        'education/events/' + Config.languageWithLocale() + '/short/event-' + eventTypeCode + '.html';

                    return $http.get(shortDescriptionUrl, {cache: true});
                }
            };
        }]);

/**
 * Created by arizvi on 6/19/14.
 * Disables scrolling (and hides scrollbar) for the background main page while the modal is open
 */

'use strict';

recogniaApp.directive('disableScrollbar', function() {
	return {
		restrict: 'A',
		link: function(scope, element) {
			$(element).on("hide", function() {
				$('body').css({
					'overflow' : 'auto'
				});
			});
			$(element).on("show", function() {
				$('body').css({
					'overflow' : 'hidden'
				});
			});
		}
	};
});
/**
 * Created with JetBrains WebStorm.
 * User: Hosam
 * Date: 2012-12-08
 * Time: 4:36 PM
 * To change this template use File | Settings | File Templates.
 */

/* global Swipe */

'use strict';

var directiveName = 'swipeScroll';

recogniaApp.directive(directiveName,
	['GoogleAnalytics',
	function(GoogleAnalytics) {
		return {
			restrict: 'A',
			replace: false,

			link:function (scope, element, attrs) {

				element.addClass("swipe-wrapped-item");
				if (scope.$last) {

					if (window.swipers === undefined) {
						window.swipers = [];
					}

					if (window.swipers[attrs[directiveName]] !== undefined) {
						window.swipers[attrs[directiveName]].kill();
					}

					// Add necessary css classes
					element.parent().addClass('swipe-wrap');
					element.parent().parent().addClass('swipe');
					window.swipers[attrs[directiveName]] = new Swipe(element.get(0).parentElement.parentElement, {
						startSlide: 0,
						speed: 500,
						direction: $('.recognia').css('direction') !== "" ? $('.recognia').css('direction') : 'ltr',
	//					auto: 3000,
						continuous: true,
						disableScroll: false,
						callback: function() {
							var ideaType = GoogleAnalytics.ideaLabels[scope.selectedProduct + "-" + scope.selectedIdea.idea.ideaType] + ":" + scope.selectedIdea.idea.instrument.symbol;

							if (ideaType === undefined) {
								console.log('broken');
							}
							GoogleAnalytics.sendEvent(
								'ideas-platform',
								'switch-idea',
								ideaType
							);
						},
						transitionEnd: function(index) {

							// Notify the parent controller of a scroll end
							if (scope.onSwipeEnd !== undefined) {
								scope.onSwipeEnd(attrs[directiveName], index);
							}
						}
					});

					// Notify the parent controller of our creation
					if (scope.onSwiperCreate !== undefined) {
						scope.onSwiperCreate (attrs[directiveName], window.swipers[attrs[directiveName]]);
					}
				}
			}
		};
}]);

/**
 * Created with JetBrains WebStorm.
 * User: recognia
 * Date: 12/12/12
 * Time: 2:06 PM
 * To change this template use File | Settings | File Templates.
 */

'use strict';

recogniaApp.directive('scrollBar', function() {

    return {
        restrict: 'A',
        replace: false,

        link:function (scope, element) {

            element.addClass("scrollbox");

            var isWebkit = 'WebkitAppearance' in document.documentElement.style;
            if (!isWebkit) {
                element.enscroll();
                //below line will fix the bug in enscroll.js line 825
                //that sets the width of the div containing the text
                //which prevents it from reflowing and resizing on window resize.
                element.css('width','');
            }
        }
    };
});
/**
 * Created with JetBrains WebStorm.
 * User: recognia
 * Date: 17/12/12
 * Time: 12:28 PM
 */

'use strict';

recogniaApp.directive('highstocksEnhanced',
	['JsonUtil', 'ChartConfig', 'Lexicon', 'CheckIE8', 'HighChartsTheme','Config', 'DateFormatter', 'CommonConstants',
	function (JsonUtil, ChartConfig, Lexicon, CheckIE8, HighChartsTheme, Config, DateFormatter, CommonConstants) {

	var cache = {}, langCode=Config.language(), TEXT_ALIGN_PROPERTY = "text-align";

	function prependMethod(obj, method, func) {
		var original = obj[method];
		obj[method] = function () {
			var args = Array.prototype.slice.call(arguments);
			func.apply(this, args);
			if (original) {
				return original.apply(this, args);
			} else {
				return;
			}
		};
	}

	var seriesId = 0;
	var ensureIds = function (series) {
		series.forEach(function (s) {
			if (!angular.isDefined(s.id)) {
				s.id = "series-" + seriesId++;
			}
		});
	};

	var getMergedOptions = function (scope, element, config) {
		var mergedOptions = {};

		var defaultOptions = {
			chart: {
				events: {}
			},
			title: {},
			subtitle: {},
			series: [],
			credits: {},
			plotOptions: {}
		};

		if (config) {
			// Copy the config
			mergedOptions = JsonUtil.deepExtend(defaultOptions, config);
		} else {
			mergedOptions = defaultOptions;
		}

		mergedOptions.chart.renderTo = element[0];

		if (config.xAxis) {
			prependMethod(mergedOptions.chart.events, 'selection', function (e) {
				var thisChart = this;
				if (e.xAxis) {
					scope.$apply(function () {
						scope.config.xAxis.currentMin = e.xAxis[0].min;
						scope.config.xAxis.currentMax = e.xAxis[0].max;
					});
				} else {
					//handle reset button - zoom out to all
					scope.$apply(function () {
						scope.config.xAxis.currentMin = thisChart.xAxis[0].dataMin;
						scope.config.xAxis.currentMax = thisChart.xAxis[0].dataMax;
					});
				}
			});

			prependMethod(mergedOptions.chart.events, 'addSeries', function () {
				scope.config.xAxis.currentMin = this.xAxis[0].min || scope.config.xAxis.currentMin;
				scope.config.xAxis.currentMax = this.xAxis[0].max || scope.config.xAxis.currentMax;
			});

		}
		prependMethod(mergedOptions.chart.events, 'redraw', function () {
			drawOverlay(this);
		});

		if (config.xAxis) {
			mergedOptions.xAxis = config.xAxis;
		}

		if (config.yAxis) {
			mergedOptions.yAxis = config.yAxis;
		}

		if (config.title) {
			mergedOptions.title = config.title;
		}

		if (config.subtitle) {
			mergedOptions.subtitle = config.subtitle;
		}

		if (config.credits) {
			mergedOptions.credits = config.credits;
		}

		if (config.legend) {
			mergedOptions.legend = config.legend;
		}

		if (config.scrollbar) {
			mergedOptions.scrollbar = config.scrollbar;
		}

		if (config.exporting) {
			mergedOptions.exporting = config.exporting;
		}

		if (config.tooltip) {
			mergedOptions.tooltip = config.tooltip;
		}

		if (config.markup) {
			mergedOptions.markup = config.markup;
		}

		if (config.markupExtent) {
			mergedOptions.markupExtent = config.markupExtent;
		}

		if (config.marker) {
			mergedOptions.marker = config.marker;
		}

		if (config.eventMarkup) {
			mergedOptions.eventMarkup = config.eventMarkup;
		}

		if (config.eventType) {
			mergedOptions.eventType = config.eventType;
		}

		return mergedOptions;
	};

	var updateZoom = function (axis, modelAxis) {
		var extremes = axis.getExtremes();
		if (modelAxis.currentMin !== extremes.dataMin || modelAxis.currentMax !== extremes.dataMax) {
			axis.setExtremes(modelAxis.currentMin, modelAxis.currentMax, false);
		}
	};

	var processSeries = function (chart, series) {

		var ids = [];
		if (series) {
			ensureIds(series);

			//Find series to add or update
			series.forEach(function (s) {
				ids.push(s.id);
				var chartSeries = chart.get(s.id);
				if (chartSeries) {
					chartSeries.update(s, true);
				} else {
					chart.addSeries(s, false);
				}
			});
		}

		//Now remove any missing series
		// Commented out as it removes the navigator series
		for (var i = chart.series.length - 1; i >= 0; i--) {
			var s = chart.series[i];
			if (s.options.id!==undefined &&
				// we do not want to remove the navigator if exists since it is added by Highchart
				s.options.id !== "highcharts-navigator-series" &&
				ids.indexOf(s.options.id) < 0) {
				s.remove(false);
			}
		}
	};

	// Remove the markup from the DOM
	var removeEventMarkup = function (chart) {
		if (chart.markupElement !== undefined) {
			chart.markupElement.destroy();
			chart.markupElement = undefined;
		}

		if (chart.markupClipBox !== undefined) {
			chart.markupClipBox.destroy();
			chart.markupClipBox = undefined;
		}

		if (chart.customMarkup !== undefined){
			chart.customMarkup.forEach(function (element) {
				element.destroy();
			});
		}
		chart.customMarkup = [];
	};

	// detect if browser is IE8
	var ie8 = CheckIE8.isIE8();

		/**
		 * Text alignment mechanism:
		 * Highcharts library uses textAlign property to derive textAnchor property which is then used to
		 * render text.
		 *
		 * BUG:
		 * For all IE, textAnchor property is reversed in RTL mode.
		 * The bug has already been logged on microsoft website, link is as below:
		 * http://connect.microsoft.com/IE/feedbackdetail/view/964272/all-ie-versions-render-svg-text-in-rtl-wrong
		 */
		var reverseTextAlignment = function (textAlignment) {
			if (Config.getPageDirection().rtl && CheckIE8.isIE()) {
				if (textAlignment === 'left') {
					return 'right';
				}
				else if (textAlignment === 'right') {
					return 'left';
				}
				else if (textAlignment === 'center') {
					return textAlignment;
				}
			} else {
				return textAlignment;
			}
		};

	// Builds the SVG path (array)
	// Needs the axis to map the timeseries to pixels
	// Uses:
	// chart-{event|trend}-{pattern|boundary|region} for styling the markup
	var eventMarkup = function (chart, markups, xAxis, yAxis) {

		removeEventMarkup(chart);

		if (markups !== undefined) {

			// Create a clipping path based on the chart plotting area
			chart.markupClipBox = chart.renderer.clipRect(chart.plotBox.x, chart.plotBox.y, chart.plotBox.width, yAxis.height);
			chart.markupElement = chart.renderer.g('event-markup').add().attr('clip-path', 'url(#' + chart.markupClipBox.id + ')');
			chart.markupElement.clip(chart.markupClipBox);

			//check if eventMarkup has Region
			var eventMarkups = chart.options.eventMarkup, hasRegion=false, hasEventMarker=false, eventMarkerDrawn=false;
			for (var i=0; i<eventMarkups.length; i++) {
				if (eventMarkups[i].Id === ChartConfig.EventMarkup.Region.Id) {hasRegion=true;}
				if (eventMarkups[i].Id === ChartConfig.EventMarkup.EventMarker.Id) {hasEventMarker=true;}
			}

			// Loop through the markups
			markups.map(function (markup) {
				var strokeColor;
				if ( markup["resourceType"] === 'region' && hasRegion ) { // region all around the markups
					// Build the rectangle
					var rectX1 = xAxis.toPixels(DateFormatter.getEpoch(markup.points[0][0]), false);
					var rectY1 = yAxis.toPixels(markup.points[0][1], false);
					var rectX2 = xAxis.toPixels(DateFormatter.getEpoch(markup.points[1][0]), false);
					var rectY2 = yAxis.toPixels(markup.points[1][1], false);

					var region = chart.renderer.rect(Math.min(rectX1, rectX2), Math.min(rectY1, rectY2,0,1),Math.abs(rectX2 - rectX1), Math.abs(rectY2 - rectY1));
					// Apply the styles
					if (!ie8) {
						region.attr('class', 'chart-' + markup.category + '-region');
					} else {
						var regionColor = '#0000ff';
						if (markup.category === 'trend') {
							regionColor = '#808080';
						}
						region.attr({
							stroke: regionColor,
							'stroke-width': '1px',
							fill: regionColor
						});
					}
					region.add(chart.markupElement);
				}
				else if (markup["resourceType"] === 'region' && markup.category === 'event' && markup.represents === 'boundary') {
					var xTime = DateFormatter.getEpoch(markup.points[0][0]);
					var xLastTime, x1Last;
					var x1 = xAxis.toPixels(xTime, false);
					var x2 = xAxis.toPixels(DateFormatter.getEpoch(markup.points[1][0]), false);
					var y1 = yAxis.toPixels(markup.points[0][1], false);
					var y2 = yAxis.toPixels(markup.points[1][1], false);

					if ( chart.series.length > 1 ) { // get the previous bar x value
						for(var i=0; i<chart.series.length; i++) {
							if (chart.series[i].name !== 'Navigator') {
								for (var j=chart.series[i].xData.length-1; j>=0; j--) {
									if (xTime === chart.series[i].xData[j] ) {
										xLastTime = chart.series[i].xData[j-1];
										break;
									}
								}
							}
						}
					}
					if (xLastTime) {x1Last = xAxis.toPixels(xLastTime, false);}
					var midPoint = x1Last + Math.abs((x1-x1Last)/2), boxWidth = Math.abs(x1-x1Last);

					if ( markup.points[0][0] !== markup.points[1][0] ) { // two bar width
						boxWidth = x2+x1-midPoint*2;
					}
					var regionIO = chart.renderer.rect(midPoint, y2-5, boxWidth, Math.abs(y2 - y1)+10, 0, 1);
					if (!ie8) {
						regionIO.attr('class', 'chart-' + markup.category + '-' + markup.represents);
					} else {
						strokeColor = '#808080';
						if (markup.category === 'event' && (markup.represents === 'pattern' || markup.represents === 'boundary') ) {
							strokeColor = '#ff0000';
						} else if (markup.category === 'event' && markup.represents === 'region') {
							strokeColor = '#0000ff';
						}
						regionIO.attr({
							stroke: strokeColor,
							'stroke-width': '1px'
						});
					}
					regionIO.add(chart.markupElement);

					// event markup green dot or red box markup
					if (hasEventMarker) {
						if ( chart.options.eventType.tradeType === 'long' ) {
							var eventCircle = chart.renderer.circle(x2, y2-8, 3).add();
							if (!ie8) {
								eventCircle.attr('class', 'chart-eventclose_bull');
							} else {
								eventCircle.attr({
									fill: '#45A300',
									stroke: '#45A300',
									'stroke-width': '1px'
								});
							}
							chart.customMarkup.push(eventCircle);
						}
						else {
							var eventRect = chart.renderer.rect(x2-2,  Math.abs(y2 - y1)+y2+10, 5, 5).add();
							if (!ie8) {
								eventRect.attr('class', 'chart-eventclose_bear');
							} else {
								eventRect.attr({
									fill: '#ff0000',
									stroke: '#ff0000',
									'stroke-width': '1px'
								});
							}
							chart.customMarkup.push(eventRect);
						}
					}
				}
				else if (!(markup["resourceType"] === 'line' && markup.category === 'trend' && markup.represents === 'pattern')) {
					if (markup.points.length > 1 && markup.represents !== 'region' ) {// Need at least 2 points
						var eventMarkerX, eventMarkerY, isBull=true, pathMarkup = [];

						for (var markupIndex=0; markupIndex<markup.points.length; markupIndex+=1) {
							var point = markup.points[markupIndex];

							if (eventMarkerDrawn === false && eventMarkerX === undefined
								&&  eventMarkerY === undefined && markup.category === 'event') {
								eventMarkerX = xAxis.toPixels(DateFormatter.getEpoch(point[0]), false);
								eventMarkerY = yAxis.toPixels(point[1], false) - 10;
								if ( chart.options.eventType.tradeType === 'short' ) {
									isBull = false;
									eventMarkerX -= 2;
									eventMarkerY += 20;
								}
							}
							pathMarkup = pathMarkup.concat(['L', xAxis.toPixels(DateFormatter.getEpoch(point[0]), false), yAxis.toPixels(point[1], false)]);
						}

						pathMarkup[0] = 'M';
						var path = chart.renderer.path(pathMarkup);
						// apply the styles
						if (!ie8) {
							path.attr('class', 'chart-' + markup.category + '-' + markup.represents);
						} else {
							strokeColor = '#808080';
							if (markup.category === 'event' && (markup.represents === 'pattern' || markup.represents === 'boundary') ) {
								strokeColor = '#ff0000';
							} else if (markup.category === 'event' && markup.represents === 'region') {
								strokeColor = '#0000ff';
							}
							path.attr({
								stroke: strokeColor,
								'stroke-width': '1px'
							});
						}
						path.add(chart.markupElement);

						if (eventMarkerDrawn === false && hasEventMarker && markup.category === 'event') {
							if (isBull === true) {
								var eventMarkerCircle = chart.renderer.circle(eventMarkerX, eventMarkerY, 3).add();
								if (!ie8) {
									eventMarkerCircle.attr('class', 'chart-eventclose_bull');
								} else {
									eventMarkerCircle.attr({
										fill: '#45A300',
										stroke: '#45A300',
										'stroke-width': '1px'
									});
								}
								chart.customMarkup.push(eventMarkerCircle);
							}
							else {
								var eventMarkerRect = chart.renderer.rect(eventMarkerX, eventMarkerY, 5, 5).add();
								if (!ie8) {
									eventMarkerRect.attr('class', 'chart-eventclose_bear');
								} else {
									eventMarkerRect.attr({
										fill: '#ff0000',
										stroke: '#ff0000',
										'stroke-width': '1px'
									});
								}
								chart.customMarkup.push(eventMarkerRect);
							}

							eventMarkerDrawn = true;
						}
					}
				}
			});

		}
	};


	var removeMarkerElement = function (chart,element) {
		if (chart.markerElements[element] !== undefined) {
			chart.markerElements[element].destroy();
			chart.markerElements[element] = undefined;
		}
	};

	// Adds/Updates the last price markup on the chart
	// Uses:
	// chart-lastprice-text for the text styling
	// chart-lastprice for the horizontal line and text background
	var drawMarker = function (chart, marker, xAxis, yAxis, yAxisOptions, legendPadding, price) {
		var markerValue = marker.Value, markerFormattedValue = marker.FormattedValue, xPos, xPosText,
		LAST_PRICE_NUMERIC_ALIGNMENT = HighChartsTheme.getChartLastPriceNumericProperty(TEXT_ALIGN_PROPERTY);

		// some marker's Value is a range i.e. target
		// if so, use a price from price marker
		if ( marker.Id === ChartConfig.Markers.EventTargetPrice().Id
			|| marker.Id === ChartConfig.Markers.VolumeName().Id
			|| marker.Id === ChartConfig.OptionsMarkers.TargetProfit().Id ) {
			markerValue = price;
		}

		removeMarkerElement(chart, marker.Id);
		removeMarkerElement(chart, marker.Id+'line');

		// getPlotLinePath is not documented method in HighCharts but was the only way to a path that is perfectly clipped to the plotting area
		var lastPriceBar = yAxis.getPlotLinePath(markerValue);

		if (lastPriceBar !== null && lastPriceBar !== undefined) {

			// Create the text to get the size then destroy and create the proper one
			if (chart.bBoxCache===undefined) {
				chart.bBoxCache = cache;
			}
			var cacheKey = markerValue + '|' + lastPriceBar[2];
			var cachedMarkerInfo = chart.bBoxCache[cacheKey];

			if (cachedMarkerInfo===undefined) {
				cachedMarkerInfo = {};
				var textElement = chart.renderer.text(markerFormattedValue, 0, lastPriceBar[2]).attr({'class': marker.NameStyle, align:LAST_PRICE_NUMERIC_ALIGNMENT}).add();

				cachedMarkerInfo.textRect = textElement.getBBox();
				cachedMarkerInfo.marginLeft = parseInt($(textElement.element).css('margin-left'), 10);
				cachedMarkerInfo.marginRight = parseInt($(textElement.element).css('margin-right'), 10);
				textElement.destroy();

				chart.bBoxCache[cacheKey] = cachedMarkerInfo;
			}

			var textRect = cachedMarkerInfo.textRect,
				marginLeft = cachedMarkerInfo.marginLeft,
				marginRight = cachedMarkerInfo.marginRight;

			if ( isNaN(marginLeft) ) { marginLeft = 0; }
			if ( isNaN(marginRight) ) { marginRight = 0; }

			chart.markerElements[marker.Id] = chart.renderer.g(marker.Name).add().toFront();
			chart.markerElements[marker.Id+'line'] = chart.renderer.g(marker.Name).add();

			var lineLeftEdge = lastPriceBar[1];
			// Correct lineY based on the text box
			var lineY = textRect.y + textRect.height / 2;
			// center the text in the gap between the horizontal line and left edge of the chart
			var textPosX = marginLeft + Math.floor(lineLeftEdge/2);
			var textPosY = lineY + textRect.height / 2;
			// style for IE8
			var markerText = {
					fontFamily: 'Open Sans',
					fontSize: '10px'
				},
				markerTextDark,
				markerTextLight,
				markerTextDarkColor = HighChartsTheme.chartMarkerDark(),
				markerTextLightColor = HighChartsTheme.chartMarkerLight(),
				markerBullishColor = HighChartsTheme.chartMarkerBullish();

				markerTextDark = {
					fill: markerTextDarkColor
				};
				markerTextLight = {
					fill: markerTextLightColor,
					align:'center'
				};

			var legendX = marginLeft + lineLeftEdge - marginRight - marginLeft + 3;
			if (marker.Align === 'right') {
				var strLength = marker.Name.length;
				if ( marker.Id === ChartConfig.Markers.EventTargetPrice().Id && marker.FormattedValue !== undefined) {
					strLength = marker.Name.length + marker.FormattedValue.length;
				}
				legendX = lastPriceBar[4] - strLength * 3.2 ;
			}

			if ( marker.drawMarkerLine === true ) { // draw marker line
				var lastPricePath = chart.renderer.path(lastPriceBar).add(chart.markerElements[marker.Id+'line']);
				if (!ie8) {
					lastPricePath.attr('class', marker.ValueStyle);
				} else {
					lastPricePath.attr({
						zIndex: 1,
						'stroke-width': '1px',
						stroke: '#FF8C00'
					});
				}

				var lastPriceRect = chart.renderer.rect(marginLeft, lineY - 2, lineLeftEdge, textRect.height - 2,0,1).add(chart.markerElements[marker.Id]);
				if (!ie8) {
					lastPriceRect.attr('class', marker.ValueStyle);
				} else {
					lastPriceRect.attr({
						'stroke-width': '1px',
						stroke: '#FF8C00',
						fill: '#FF8C00'
					});
				}

				var lastPriceName = chart.renderer.text(markerFormattedValue, textPosX, textPosY).add(chart.markerElements[marker.Id]);
				if (!ie8) {
					lastPriceName.attr({'class': marker.NameStyle, 'style':'', align:LAST_PRICE_NUMERIC_ALIGNMENT});
				} else {
					lastPriceName.css({
						fontFamily: 'Open Sans',
						fontSize: '10px',
						verticalAlign: 'middle',
						marginLeft: '3px',
						marginRight: '3px',
						marginTop: '-2px'
					});
					lastPriceName.attr({
						fill: '#ffffff',
						align: LAST_PRICE_NUMERIC_ALIGNMENT
					});
				}
			}

			xPos = legendX+ legendPadding;
			xPosText = xPos + 12;
			if (marker.Align === 'right') {
				xPos = legendX;
				xPosText = xPos - (marker.Name.length * 3.2) - 20;
			}

			// draw marker legend
			if ( marker.Id === ChartConfig.Markers.EventTargetPrice().Id ) { // target

				//var EVENT_TARGET_VALUE_ALIGNMENT = HighChartsTheme.getChartMarkerTargetValueProperty(TEXT_ALIGN_PROPERTY);
				var targetVal = chart.renderer.text(marker.FormattedValue, 0, 0).add(chart.markerElements[marker.Id]);


				if ( marker.FormattedValue !== undefined ) {
					if (!ie8) {
						targetVal.attr({'class': marker.ValueStyle, style: 'direction:ltr', align: 'left'});

					} else {
						targetVal.css(markerText);
						targetVal.attr(JsonUtil.deepExtend(markerTextDark,{align: 'left'}));
					}
					//Position target-profit on the right side of the chart, independent of language changes.
					// IE has a bug when the text includes arabic characters, then right-aligned text seems to have issues with positioning ref Trac #11505
					targetVal.align({align: "left",  x: chart.renderer.width - targetVal.getBBox().width - 10, verticalAlign: "top", y: 20});
				}
			}
			else if (marker.Id === ChartConfig.Markers.VolumeName().Id ) {
				var LEGEND_VOLUME_TEXT_ALIGNMENT = HighChartsTheme.getChartMarkerLegendTextProperty(TEXT_ALIGN_PROPERTY);
				var vHeight = yAxisOptions.height;
				var volumeRect = chart.renderer.rect(lastPriceBar[1]+10, vHeight+48, 7, 7, 0,1).add(chart.markerElements[marker.Id]);
				var volumeName = chart.renderer.text(marker.Name, lastPriceBar[1]+22, vHeight+55).add(chart.markerElements[marker.Id]);
				volumeName.attr({'class': marker.LegendStyle, align: reverseTextAlignment(LEGEND_VOLUME_TEXT_ALIGNMENT)});
				volumeRect.attr({
					fill: HighChartsTheme.getChartVolumeSeriesColor(),
					stroke: HighChartsTheme.getChartVolumeSeriesColor()
				});
			}
			// OptionsIdeas Target Profit Marker
			else if (marker.Id === ChartConfig.OptionsMarkers.TargetProfit().Id ) {
				var xVal = xAxis.toPixels(DateFormatter.getEpoch(marker.Date), false),
					 yVal=yAxis.toPixels(Math.round(marker.Target), false),
					// Padding for the target profit (green bubble)
					TARGET_TEXT_PADDING = 6,
					// Target profit text alignment
					TARGET_PROFIT_TEXT_ALIGNMENT = HighChartsTheme.getChartTargetProfitTextProperty(TEXT_ALIGN_PROPERTY),
					//dotted line pointer
					 pointerLine,
					//x pointer
					offset = 3, // to control how big the "x" will be.
					leftCrossLine,
					rightCrossLine,
					//green bubble
					tpBubbleRect,
					//Target Profit Value
					targetProfitValue,
					//Bubble Arrow
					bubbleArrow,
					// green padding
					xValEvent = xAxis.toPixels(DateFormatter.getEpoch(marker.EventDate), false),
					xWidth = lastPriceBar[4] - xValEvent;
					var markerTargetProfitBackground = HighChartsTheme.chartMarkerTargetProfitBackground();
					var tpPadding = chart.renderer.rect(xValEvent, chart.plotTop, xWidth, chart.chartHeight-chart.marginBottom-chart.plotTop, 0);
					tpPadding.add(chart.markerElements[marker.Id]);
					// draw expiry date
					var tempExpiryText = chart.renderer.text( marker.Expiry, xVal, chart.chartHeight-17).add(chart.markerElements[marker.Id]);
					var tempExpiryDate = chart.renderer.text( marker.ExpiryDateStr, xVal, chart.chartHeight+17).add(chart.markerElements[marker.Id]);

					tempExpiryDate.destroy();
					tempExpiryText.destroy();

					/**
					 * Team's collective decision:
					 * Comment out expiry date to avoid any overlaps with x-axis.
					 * Similar changes have been made to 119 as well.
					 */

//					var expiryDateRect = chart.renderer.rect(xVal-expiryWidth/2-10, chart.chartHeight-25, expiryWidth, 22, 2);
//					expiryDateRect.add(chart.markerElements[marker.Id]).toFront().attr('class', marker.DateRectStyle);
//
//					var expiryDateText = chart.renderer.text( marker.ExpiryDateStr,xVal - expiryDateWidth/2, chart.chartHeight-17).add(chart.markerElements[marker.Id]).toFront();
//					var expiryText = chart.renderer.text( marker.Expiry, xVal - expiryTextWidth/2, chart.chartHeight-7).add(chart.markerElements[marker.Id]).toFront();
//					chart.credits.x = xVal - 100;

				var TARGET_PROFIT_X_POSITION,
					TARGET_PROFIT_Y_POSITION,
					TARGET_PROFIT_TEXT_WIDTH,
					TARGET_PROFIT_TEXT_HEIGHT;

				if (!ie8) {
					//move below render elements outside ie8 check will not make them working properly in IE8.
					pointerLine = chart.renderer.path(['M', xVal, chart.chartHeight-30, 'V', yVal]).add(chart.markerElements[marker.Id]);
					bubbleArrow = chart.renderer.path(['M', xVal-5, yVal-12, 'L', xVal, yVal-6, 'L', xVal+5, yVal-12]).add(chart.markerElements[marker.Id]);
					leftCrossLine = chart.renderer.path(['M', xVal, yVal, 'L', xVal-offset, yVal-offset, 'L', xVal+offset, yVal+offset]).add(chart.markerElements[marker.Id]);
					rightCrossLine = chart.renderer.path(['M', xVal, yVal, 'L',xVal+offset, yVal-offset, 'L',xVal-offset, yVal+offset]).add(chart.markerElements[marker.Id]);
					/**
					 * TARGET PROFIT *
					 Special Case (order matters)
					 Green bubble is dependent on text.
					 Draw the text first, get measurements,
					 and draw green bubble using the measurements.
					 **/
					TARGET_PROFIT_X_POSITION = Math.floor(xVal);
					TARGET_PROFIT_Y_POSITION = yVal- 12 - TARGET_TEXT_PADDING;

					// Render text to get the measurements, and then re-draw with proper positioning (center align).
					targetProfitValue = chart.renderer.text(marker.FormattedValue, TARGET_PROFIT_X_POSITION, TARGET_PROFIT_Y_POSITION).add(chart.markerElements[marker.Id]);
					targetProfitValue.attr({'class': marker.ValueStyle, 'style': '', align:TARGET_PROFIT_TEXT_ALIGNMENT});

					// Get measurements: width, height & x,y coordinates
					TARGET_PROFIT_TEXT_WIDTH = targetProfitValue.getBBox().width;
					TARGET_PROFIT_TEXT_HEIGHT = targetProfitValue.getBBox().height;

					// Draw green bubble using the measurements above.
					tpBubbleRect = chart.renderer.rect(
							TARGET_PROFIT_X_POSITION - TARGET_TEXT_PADDING + 0.5 - (TARGET_PROFIT_TEXT_WIDTH / 2),			// X-Coordinates: OFFSET +0.5
							Math.floor(TARGET_PROFIT_Y_POSITION - (TARGET_PROFIT_TEXT_HEIGHT / 2) - TARGET_TEXT_PADDING),	// Y-Coordinates
							TARGET_PROFIT_TEXT_WIDTH + 2 * TARGET_TEXT_PADDING,												// Width
							Math.ceil((TARGET_PROFIT_TEXT_HEIGHT / 2) + 2 * TARGET_TEXT_PADDING),							// Height
						1).add(chart.markerElements[marker.Id]);

					// Bring the drawn text to the front.
					targetProfitValue.toFront();

					// End drawing the target profit

					// Assigning Attributes
					pointerLine.attr('class', marker.PointerLineStyle);
					leftCrossLine.attr('class', marker.PointerCrossStyle);
					rightCrossLine.attr('class', marker.PointerCrossStyle);
					tpBubbleRect.attr('class', marker.ValueBubbleStyle);
					bubbleArrow.attr('class', marker.PointerArrowStyle);
					tpPadding.attr('class', marker.PaddingStyle);
//					expiryDateText.attr({'class': marker.DateStyle, 'style':''});
//					expiryText.attr({'class': marker.DateStyle, 'style':''});
				} else {
					tpPadding.attr( {
						fill: markerTargetProfitBackground,
						'fill-opacity': '0.002'
					} );
					var lineStyle = {
						stroke: markerTextDarkColor,
						'stroke-width': '1px',
						fill: markerTextDarkColor
					},
					pointerLineStyle = {
						stroke: markerTextDarkColor,
						'stroke-width': '1px'
					};
					pointerLine = chart.renderer.path(['M', xVal, chart.chartHeight-30, 'L', xVal, yVal]).add(chart.markerElements[marker.Id]);
					bubbleArrow = chart.renderer.path(['M', xVal-5, yVal-12, 'L', xVal, yVal-6, 'L', xVal+5, yVal-12]).add(chart.markerElements[marker.Id]);
					leftCrossLine = chart.renderer.path(['M', xVal, yVal, 'L', xVal-offset, yVal-offset, 'L', xVal+offset, yVal+offset]).add(chart.markerElements[marker.Id]);
					rightCrossLine = chart.renderer.path(['M', xVal, yVal, 'L',xVal+offset, yVal-offset, 'L',xVal-offset, yVal+offset]).add(chart.markerElements[marker.Id]);

					pointerLine.attr(pointerLineStyle);
					leftCrossLine.attr(lineStyle);
					rightCrossLine.attr(lineStyle);
					bubbleArrow.attr({
						stroke: markerTextDarkColor,
						fill: markerTextDarkColor,
						color: markerTextDarkColor
					});

					/***
					 * Draw Target Profit
					 **/

					TARGET_PROFIT_X_POSITION = Math.floor(xVal);
					TARGET_PROFIT_Y_POSITION = yVal- 12 - TARGET_TEXT_PADDING;
					// Render text to get the measurements, and then re-draw with proper positioning (center align).
					targetProfitValue = chart.renderer.text(
						marker.FormattedValue,
						TARGET_PROFIT_X_POSITION,
						TARGET_PROFIT_Y_POSITION
					).add(chart.markerElements[marker.Id]);

					targetProfitValue.css(markerText);
					targetProfitValue.attr(JsonUtil.deepExtend(markerTextLight,{align:TARGET_PROFIT_TEXT_ALIGNMENT}));

					// Get measurements: width & height of the text-box
					TARGET_PROFIT_TEXT_WIDTH = targetProfitValue.getBBox().width;
					TARGET_PROFIT_TEXT_HEIGHT = targetProfitValue.getBBox().height;

					// Draw green bubble using the measurements above.
					tpBubbleRect = chart.renderer.rect(
							TARGET_PROFIT_X_POSITION - TARGET_TEXT_PADDING - (TARGET_PROFIT_TEXT_WIDTH / 2),														// X-Coordinates
							Math.floor(TARGET_PROFIT_Y_POSITION - (TARGET_PROFIT_TEXT_HEIGHT / 2) - TARGET_TEXT_PADDING),		// Y-Coordinates
							TARGET_PROFIT_TEXT_WIDTH + 2 * TARGET_TEXT_PADDING,													// Width
							Math.ceil(TARGET_PROFIT_TEXT_HEIGHT / 2) + 2 * TARGET_TEXT_PADDING,									// Height
						1).add(chart.markerElements[marker.Id]);

					tpBubbleRect.attr({
							fill: markerBullishColor,
							'stroke-width': '1px',
							stroke: markerBullishColor,
							'fill-opacity': '0.8'
						}
					);

					// Bring the text to the front
					targetProfitValue.toFront();

					// End drawing the target profit
//					expiryText.css(markerText);
//					expiryText.attr(markerTextDark);
				}

			}
			else {
				var LEGEND_CHART_MARKER_TEXT_ALIGNMENT = HighChartsTheme.getChartMarkerLegendTextProperty(TEXT_ALIGN_PROPERTY);
				var markerStyle = marker.ValueStyle;
				if (marker.Id === ChartConfig.Markers.LastPrice().Id ) {
					markerStyle = 'fs-legend-lastprice';
				}
				var lengendRect = chart.renderer.rect(xPos, 12, 7, 7, 0, 1).add(chart.markerElements[marker.Id]);
				var lengendName = chart.renderer.text(marker.Name, xPosText, 20).add(chart.markerElements[marker.Id]);
				if (!ie8) {
					lengendRect.attr('class', markerStyle);
					lengendName.attr({'class': marker.LegendStyle, 'style':'', align:  reverseTextAlignment(LEGEND_CHART_MARKER_TEXT_ALIGNMENT)});
				} else {
					var fillcolor = '#FF8C00';
					if (marker.Id !== ChartConfig.Markers.LastPrice().Id ) {
						fillcolor = '#ff0000';
						if (markerStyle.indexOf('bull') !== -1 ) {fillcolor = '#45A300'; }
					}
					lengendRect.attr({
						stroke: fillcolor,
						'stroke-width': '1px',
						fill: fillcolor,
						color: '#ffffff'
					});
					lengendName.css(markerText );
					lengendName.attr(JsonUtil.deepExtend(markerTextDark,{align: reverseTextAlignment(LEGEND_CHART_MARKER_TEXT_ALIGNMENT)}));
				}
			}
		}
		orderSVG(chart);
		return lastPriceBar;
	};

	/**
	 *  This is to fix the order of SVGs the way they are displayed.
	 *  Think of it as setting z-index.
	 **/
	var orderSVG = function (chart) {
		/** Bring the chartTooltip to the front**/
		chart.tooltip.label.toFront();
	};

	// Update/add the path for the markup and markers on the chart
	var drawOverlay = function (chart) {

		var xAxis, yAxis, paddingOffset = 80;

		if (chart.series !== undefined &&
			chart.series.length > chart.options.mainSeriesIndex &&
			chart.series[chart.options.mainSeriesIndex].visible) {

			xAxis = chart.xAxis[chart.options.mainSeriesIndex];
			yAxis = chart.yAxis[chart.options.mainSeriesIndex];

			if (chart.markerElements === undefined) {
				chart.markerElements = [];
			}

			if ( chart.options.marker !==undefined) {
				var marker=chart.options.marker, legendPadding, price, lastPriceBar;
				for (var i=0; i<marker.length; i++ ) {
					legendPadding = i * paddingOffset;
					if (i>0 && lastPriceBar === null ) { legendPadding = (i-1) * paddingOffset; }
					if ( marker[i].Id === ChartConfig.Markers.EventClosePrice().Id
						|| marker[i].Id === ChartConfig.Markers.LastPrice().Id ) {
						price=marker[i].Value;
					}
					lastPriceBar = drawMarker(chart, marker[i], xAxis, yAxis, chart.options.yAxis[chart.options.mainSeriesIndex], legendPadding, price, chart.options.yAxis[chart.options.volume]);
				}
			}
			if (chart.options.markup !== undefined) {
				eventMarkup(chart, chart.options.markup, xAxis, yAxis);
			}

		} else {
			removeEventMarkup(chart);
		}
	};


	var initialiseChart = function (scope, element, config) {

		Highcharts.setOptions({
			lang: {
				shortMonths: Lexicon.translateSetDefaultNS('date.short',
					['01','02','03','04','05','06','07','08','09','10','11','12']),
				decimalPoint: (langCode === CommonConstants.LANGUAGE_MAP.fr) ? ',' : '.'
			}
		});

		config = config || {};
		var mergedOptions = getMergedOptions(scope, element, config);
		var chart = config.useHighStocks ? new Highcharts.StockChart(mergedOptions) : new Highcharts.Chart(mergedOptions);
		processSeries(chart, config.series);
		if (config.loading) {
			chart.showLoading();
		}

		// Need this because of media queries, default highcharts reflow has a tiny delay (100ms),
		// which doesn't catch media query change events.
		// Ideally we would have a small delay, not zero, and handle media query events
		$(window).bind('resize', function(){
			setTimeout(function() {
				if (chart!==undefined && chart.options!==undefined) {
					chart.reflow();
				}
			}, 0);
		});



		return chart;
	};


	return {
		restrict: 'EAC',
		replace: true,
		template: '<div></div>',
		scope: {
			config: '=',
			reflow: '='
		},
		link: function (scope, element) {

			var chart = initialiseChart(scope, element, scope.config);

			scope.$watch("reflow", function () {
				if (scope.reflow !== undefined) {
					chart.reflow();
				}
			});

			scope.$watch("config.series.length", function (newSeries, oldSeries) {

				// do nothing when called on registration
				if (newSeries === oldSeries || newSeries===undefined || newSeries===0) {
					return;
				}
				processSeries(chart, scope.config.series);
				chart.redraw();
			});


			scope.$watch("config.series[0].data.length", function (newSeriesLength, oldSeriesLength) {

				//do nothing when called on registration
				if (newSeriesLength === oldSeriesLength) {
					return;
				}
				processSeries(chart, scope.config.series);
			});

			scope.$watch("config.title", function (newTitle) {
				chart.setTitle(newTitle, true);
			});

			scope.$watch("config.subtitle", function (newSubitle) {
				chart.setTitle(true, newSubitle);
			});

			scope.$watch("config.loading", function (loading) {
				if (loading) {
					chart.showLoading();
				} else {
					chart.hideLoading();
				}
			});

			scope.$watch("config.credits.enabled", function (credits) {
				if(chart.credits){
					if (credits) {
						chart.credits.show();
					} else {
						chart.credits.hide();
					}
				}
			});

			scope.$watch("config.price", function (price, oldPrice) {
				if (price === oldPrice) {
					return;
				}
				chart.options.price = price;
			});


			scope.$watch("config.markup", function (markup, oldMarkup) {
				if (markup === oldMarkup) {
					return;
				}
				chart.options.markup = markup;
			});



			scope.$watch("config.eventMarkup", function (markup, oldMarkup) {
				if (markup === oldMarkup) {
					return;
				}
				chart.options.eventMarkup = eventMarkup;
			});

			scope.$watch("config.eventType", function (Type, oldType) {
				if (Type === oldType) {
					return;
				}
				chart.options.eventType = Type;
			});

			scope.$watch("config.markupExtent", function (markupExtent, oldMarkupExtent) {
				if (markupExtent === oldMarkupExtent) {
					return;
				}
				chart.options.markupExtent = markupExtent;
			});

			scope.$watch("config.marker", function (marker, oldMarker) {
				if (marker === oldMarker) {
					return;
				}
				chart.options.marker = marker;
				chart.redraw();
			});

			scope.$watch("config.optionsMarker", function (marker, oldMarker) {
				if (marker === oldMarker) {
					return;
				}
				chart.options.optionsMarker = marker;
				chart.redraw();
			});

			scope.$watch("config.useHighStocks", function () {
				chart.destroy();
				chart = initialiseChart(scope, element, scope.config);
			});

			scope.$watch("config.xAxis", function (newAxes, oldAxes) {
				if (newAxes === oldAxes) {
					return;
				}
				if (newAxes) {
					chart.xAxis[0].update(newAxes);
					updateZoom(chart.xAxis[0], newAxes);
				}
			}, true);

			scope.$watch("config.yAxis", function (newAxes) {

				if (newAxes) {
					for (var index = 0; index < chart.yAxis.length; index++) {
						chart.yAxis[index].update(newAxes[index]);
					}
				}
			}, true);

			scope.$watch("config.options", function (newOptions, oldOptions, scope) {
				//do nothing when called on registration
				if (newOptions === oldOptions) return;
				chart.destroy();
				chart = initialiseChart(scope, element, scope.config);

			});

		}
	};
}]);

/**
 * Toggles the popover box when user **hovers** on an element that has a popover
 */

'use strict';

recogniaApp.directive('popOver', function() {
	return {
		link:function(scope, element) {
			var textDirection = $('.recognia').css('direction') !== "" ? $('.recognia').css('direction') : 'ltr';
			$(element).popover({
				trigger: 'manual',
				html: 'true',
				container: ".recognia",
				placement: function() {
					var setting;
					if (element[0].attributes['data-placement'] !== undefined ) {
						setting = element[0].attributes['data-placement'].value;
						if (textDirection === 'ltr') {
							if ( (setting === "right") && (element[0].attributes['data-container'].value === "#options_calculator") ) {
								if ( $('.recognia').width() > 768 )
									if ( ( $('.recognia').width() < 990 ) || ( $(element).trigger('myEvent.sample').width() > 57) )
										return "left";
							}
						} else {
							if ( (setting === "right") && (element[0].attributes['data-container'].value === "#options_calculator") ) {
								if ( $('.recognia').width() > 768 )
									if ( ( $('.recognia').width() < 990 ) || ( $(element).trigger('myEvent.sample').width() > 57) )
										return "right";
							}
							if ( setting === 'right') {
								$('.popover').removeClass('right').addClass('left');
								return 'left';
							}
							if ( setting === 'left') {
								$('.popover').removeClass('left').addClass('right');
								return'right';
							}
						}

					} else return 'bottom';
					return setting;
				},
				// need these because angular expressions inside html attributes cause race conditions
				content: function() {
					if (element[0].attributes['data-content'] !== undefined )
						return element[0].attributes['data-content'].value;
				},
				title: function() {
					if (element[0].attributes['data-title'] !== undefined )
						return element[0].attributes['data-title'].value;
				}
			}).on("mouseenter", function () {
				$(this).popover("show");
			}).on("click", function () {
				$(this).popover("toggle");
			}).on("mouseleave", function () {
				// allow user to mouseover the popover to keep it open
				var elem = $(this),
					delayedHide = setTimeout(function(){ elem.popover("hide"); }, 150);
				element.data('delayedHide', delayedHide);
			})//for keyboard accessibility
				.on("focus", function () {
				$(this).popover("show");
			}).on("blur", function () {
				// allow user to mouseover the popover to keep it open
				var elem = $(this),
					delayedHide = setTimeout(function(){ elem.popover("hide"); }, 150);
				element.data('delayedHide', delayedHide);
			});

			var popover = element.data('bs.popover');
			popover.show = function() {
				var r = $.fn.popover.Constructor.prototype.show.apply(this, arguments);
				$('.popover').on("mouseenter", function() {clearTimeout(element.data('delayedHide'));});
				$('.popover').on("mouseleave click", function() { $('.popover').hide(); } );
				if (textDirection === 'rtl') {
					if ($('.popover').hasClass('left') && (element[0].attributes['data-placement'].value === 'left') ) {
						$('.popover').removeClass('left').addClass('right');
					} else if ( $('.popover').hasClass('right')	&& (element[0].attributes['data-placement'].value === 'right') ) {
						$('.popover').removeClass('right').addClass('left');
					} else if ( $('.popover').hasClass('right')	&& (element[0].attributes['data-placement'].value === 'left')  ) {
						$('.popover').removeClass('right').addClass('left');
					} else if ( $('.popover').hasClass('left')	&& (element[0].attributes['data-placement'].value === 'right') ) {
						$('.popover').removeClass('left').addClass('right');
					}
				}
				return r;
			};
		}
	};
});

/**
 * Similar to ngHtmlBindUnsafe but also lets angularjs "compile" the HTML tag being added
 */
'use strict';

recogniaApp.directive('bindHtmlUnsafe',
['$compile',
function ($compile) {
    return function(scope, element, attr) {
        element.addClass('ng-binding').data('$binding', attr.bindHtmlUnsafe);
        scope.$watch(attr.bindHtmlUnsafe, function bindHtmlUnsafeWatchAction(value) {
            element.html(value || '');
            $compile(element.contents())(scope);
        });
    };
}]);
'use strict';

recogniaApp.directive('datepicker', function() {
	return {
		restrict: "A",
		scope: {
			dateFormat: '=',
			dateValue: '=',
			maxDate: '=',
			minDate: '='
		},
		link: function(scope, element) {
			var updateModel = function (dateText) {
				// call $apply to bring stuff to angular model
				scope.$apply(function () {
					scope.dateValue = dateText;
				});
			};

			var options = {
				showOn: "button",
				buttonText: "<i class='fa fa-calendar'></i>",
				dateFormat: scope.dateFormat,
				changeMonth: true,
				changeYear: true,
				isRTL: false,
				maxDate: scope.maxDate,
				minDate: scope.minDate,
				// handle jquery date change
				onSelect: function () {
					updateModel($.datepicker.formatDate(options.dateFormat, element.datepicker('getDate')));
				}
			};

			// jqueryfy the element
			element.datepicker(options);

			/** watch the date
			 * Disable datepicker before using 'set' method. This will avoid datepicker taking focus of the screen.
			 */
			scope.$watch('dateValue', function(value) {
				element.datepicker("disable");
				element.datepicker("setDate", value);
				element.datepicker("enable");
			});
		}
	};
});

'use strict';

recogniaApp.directive('repeatDirective',['$timeout', function(timeout) {
	return{
	restrict: "A",
	link:function(scope) {
		//listen to the last element
		if (scope.$last === true) {
			timeout(function () {
				//listener in the event_detail/controller.js
				scope.$broadcast('onRepeatLast');
			});
		}
	}
} ;
}])
/**
 * Modal directive for showing/hiding modal elements.
 *
 * Use by:
 *   - defining a scope variable containing the visibility of the element
 *   - adding the modal-show attribute to the modal element; the value is the
 *     visibility variable name
 *   - if specific element should be focused when the modal is shown, add the
 *     modal-focus-show attribute; the value should be a jquery filter expression
 *     of an element inside the modal to focus
 *   - if specific element should be focused when the modal is hidden, add the
 *     modal-focus-hide attribute; the value should be a jquery filter expression
 *     of an element on the page to focus
 *   - if the chart-resize fix is required, add the modal-resize-fix attribute
 *     to the element
 *
 * Example:
 *     $scope.showEdit = false;
 *
 *     <div class="modal"
 *          modal-show="showEdit"
 *          modal-focus-show="#edit"
 *          modal-focus-hide="#next"
 *          modal-resize-fix>
 *        ...
 *     </div>
 */
'use strict';

function inScrollingWindow() {
	// Check if the height of the document is greater than the height of the viewport.
	// If we're not in a scrolling window, there's a good chance that we're inside an auto-resizing iframe.
	var doc = document.documentElement;
	if (doc.offsetHeight) {
		return doc.offsetHeight > doc.clientHeight;
	} else {
		return doc.scrollHeight > doc.clientHeight;
	}
}

recogniaApp.directive('modalShow',['$parse', '$timeout', function($parse, $timeout) {
	return {
		restrict: "A",
		link: function(scope, element, attrs) {

			// Accessor for actual show/hide variable
			var modalShow = $parse(attrs.modalShow);

			// Anchor the position of the modal to the element that receives focus when modal closes.
			var anchor = attrs['modalFocusHide'];

			//Hide or show the modal
			scope.showModal = function (visible, elem) {
				if (!elem)
					elem = element;

				var action, focusAttr;
				if (visible) {
					action = 'show';
					focusAttr = 'modalFocusShow';
				} else {
					action = 'hide';
					focusAttr = 'modalFocusHide';
				}

				// DOM update to show element
				$(elem).modal(action);

				// If we're not in a scrolling window and an anchor was specified, align modal vertically with it.
				// (If we're in a scrolling window, then the full viewport should be visible, so allow the default 
				// behaviour of vertically centering the modal)
				if (!inScrollingWindow() && anchor) {
					var offset = $(anchor).offset().top;
					if (offset != null) {
						offset = Math.round(offset);
						$(elem).css('top', offset + 'px');
						$(elem).css('margin-top', '0px');
					}
				}

				// Set focus to required element
				var filter = attrs[focusAttr];
				if (filter) {
					$timeout(function() {
						if (visible) {
							$(elem).find(filter).focus();
						} else {
							$(filter).focus();
						}
					});
				}
			}

			// Show immediately if initial modalShow value is true
			if (modalShow(scope)) {
				$timeout(function() {
					scope.showModal(true);
				});
			}
			// Watch for changes to the modal-visible attribute
			scope.$watch(attrs.modalShow, function (newValue, oldValue) {
				if (newValue !== oldValue) {
					scope.showModal(newValue, attrs.$$element);
				}
			});

			function setModalShow(value) {
				if (modalShow(scope) !== value) {
					$timeout(function() {
						modalShow.assign(scope, value);
					});
				}
			}
			$(element).bind("hidden", function() { setModalShow(false); });
			$(element).bind("shown", function() { setModalShow(true); });

			/** Charts do not resize unless resize event is triggered.
			* In the scenario where modal is hidden and a window resize takes place
			* then the charts on modal will never know that the resize happened. To fix this issue
			* it is important to conduct resize upon each time the modal 'show' is triggered.
			*/
			if (attrs.hasOwnProperty('modalResizeFix')) {
				element.bind('shown', function(){
					$(window).trigger('resize');
				});
			}
		}
	};
}]);

recogniaApp.directive('focusTab', function () {
		return {
			link: function (scope, elem, attrs) {
				scope.instanceName = attrs.name;

				scope.firstTab = attrs.firstTab;
				scope.lastTab = attrs.lastTab;
				elem.bind('keydown', function (event) {
					if (event.keyCode === 9) {
						scope.$broadcast('tabdown', {
							code: event.keyCode, shiftKey: event.shiftKey, event: event
						});
					}
				});
			}
		};
});

/**
 * Created by jbannerman on 27/05/2014.
 * used to add the no-hover class when a touch event occurs, so hover styles can be disabled for mobile browsers
 */

'use strict';

recogniaApp.directive('mobileHover', function () {
	return {
		link: function (scope, element) {
			$(element).bind('touchstart', function () {
				$(this).addClass('no-hover');
			});
		}
	};
});

/**
 * navigation scroll for event item navigation scroll.
 */

'use strict';

recogniaApp.directive('naviScroll', ['Config', '$timeout', function (Config, timeout) {

	function setArrowEnabled(arrow, enabled) {
		if (enabled) {
			arrow.removeClass("disabled");
		} else {
			arrow.addClass("disabled");
		}
	}
	return {
		restrict: 'A',
		link: function (scope, element, attrs) {

			var $outerWidget = $('#en-widget-outer'),
				$innerWidget = $('#en-widget-inner'),
				$arrowBack = $('#arrow-back'),
				$arrowForward = $('#arrow-forward');

			//touch device need scrollable with hand
			if (document.documentElement.ontouchstart !== undefined) {
				$outerWidget.css({"overflow-x": "auto"});
			}

			function setScrollWidth() {

				var totalEventsWidth = 0,
					childrenItems = $innerWidget.children(),
					index,
					containerWidth = $outerWidget.width();

				if (childrenItems.length>0) {
					for (index = 0; index < childrenItems.length; index += 1) {

						// Because the arrow gets executed before the idea is ready and its class is not set, we need to set the class here to get the correct width
						var isOptionClass = scope.ideaTypes[index]==='option';
						$(childrenItems[index]).toggleClass('en-item-box-large', isOptionClass);
						$(childrenItems[index]).toggleClass('en-item-box', !isOptionClass);


						// There doesn't seem to be a way to get an element's margins programmatically in IE8,
						// so value is hard-coded here.
						var childWidth = $(childrenItems[index]).width() + 3;
						if (childWidth>= containerWidth) {
							// Make sure that the navigator does not expand wildly
							childWidth = 110;
						}
						totalEventsWidth += childWidth;
					}
					if (totalEventsWidth < containerWidth) {
						// Expand inner container to fill the outer container so ideas appear on the
						// right side for RTL languages
						totalEventsWidth = containerWidth - 1;
					}
					else if (totalEventsWidth > containerWidth) {
						// Need to enable scroll buttons.  Add space to inner widget to account for them.
						totalEventsWidth += $('#scroll-forward').width();
					}
					$innerWidget.width(totalEventsWidth);
				}

				if (totalEventsWidth > containerWidth) {
					$('#scroll-forward').show();
					$('#scroll-back').show();
					$outerWidget.css({
						"padding-left": "32px",
						"padding-right": "32px"
					});
					$outerWidget.parent().css({
						"padding-right": "0px",
						"padding-left": "0px"
					});
				} else {
					$('#scroll-forward').hide();
					$('#scroll-back').hide();
					$outerWidget.css({
						"padding-left": "0px",
						"padding-right": "0px"
					});
					$outerWidget.parent().css({
						"padding-right": "10px",
						"padding-left": "10px"
					});
				}
				setArrowStates();
			}

			function setArrowStates() {
				// In LTR languages, "back" is left and "forward" is right
				var arrowLeft = $arrowBack;
				var arrowRight = $arrowForward;
				if (!Config.getPageDirection().ltr) {
					// ... but opposite for RTL languages
					arrowLeft = $arrowForward;
					arrowRight = $arrowBack;
				}

				var end = $innerWidget.width() - $outerWidget.width();
				setArrowEnabled(arrowLeft, (scope.ribbonPosition === -1) ? false : scope.ribbonPosition !== 0);
				setArrowEnabled(arrowRight, scope.ribbonPosition !== end);
			}

			// Enable/disable arrows whenever scroll position changes
			scope.$watch('ribbonPosition',
				function() {
					setArrowStates();
				});

			attrs.$observe('naviScroll', function () {
				scope.disableClick = false;
				// Use timeout to delay setting the scroll buttons until after rendering.
				// Otherwise, we won't know the sizes of the elements of the navigator to
				// determine if scrolling is needed.
				timeout(function() {
					setScrollWidth();
					if ($innerWidget.width() > 0) {
						// Suppress animation for scrolling to initial position
						if (Config.getPageDirection().ltr) {
							scope.setRibbonPosition(0, true);
						}
						else {
							scope.setRibbonPosition($innerWidget.width(), true);
						}
					}
				}, 0);
			}, true);

			$(window).resize(function () {
				setScrollWidth();
			});

			function findMovePixels(scrollDirection, scrollPosition, childrenItems, windowSize) {
				var index, hiddenChildren = 0, hiddenPixels = 0, movePixels = 0;

				if (scrollPosition === 0) {
					// the beginning of the list
					for (index = 0; index < childrenItems.length; index += 1) {
						if ((movePixels + $(childrenItems[index]).width()) < windowSize) {
							movePixels += $(childrenItems[index]).width();
							movePixels += 3; // 3 pixels for the space between children
						} else {
							break;
						}
					}
				} else {
					// somewhere in the middle or end of the list
					// meaning some children are hiding
					for (index = 0; index < childrenItems.length; index += 1) {
						if ((hiddenPixels + $(childrenItems[index]).width()) <= scrollPosition) {
							hiddenPixels += $(childrenItems[index]).width();
							hiddenPixels += 3; // 3 pixels for the space between children
							hiddenChildren += 1;
						} else {
							break;
						}
					}
					// If scrolling back, need to make sure to compensate any difference if there is any
					if (scrollDirection === 'scroll-back') {
						if (scrollPosition - hiddenPixels !== 0) {
							hiddenChildren += 1;
							hiddenPixels += $(childrenItems[hiddenChildren]).width();
							hiddenPixels += 3; // 3 pixels for the space between children
						}
						movePixels = scrollPosition - hiddenPixels;
					}
					// Once we have found the number of hidden children, now we know which ones are
					// possibly visible. Some of these visible ones need to be hidden
					for (index = hiddenChildren; index < childrenItems.length; index += 1) {
						if ((movePixels + $(childrenItems[index]).width()) <= windowSize) {
							movePixels += $(childrenItems[index]).width();
							movePixels += 3; // 3 pixels for the space between children
						} else {
							break;
						}
					}
				}
				return movePixels;
			}


			function scroll() {
				// Get the number of pixels to scroll
				var movePixels = findMovePixels(element[0].id, $outerWidget.scrollLeft(), $innerWidget.children(), $outerWidget.width());

				// In LTR languages, "back" is left and "forward" is right
				var moveLeft = (element[0].id === 'scroll-back');
				if (!Config.getPageDirection().ltr) {
					// ... but opposite for RTL languages
					moveLeft = !moveLeft;
				}
				if (moveLeft) {
					scope.setRibbonPosition($outerWidget.scrollLeft() - movePixels);
				}
				else {
					scope.setRibbonPosition($outerWidget.scrollLeft() + movePixels);
				}
				scope.$apply();
			}

			element.click(scroll);
		}
	};
}]);

/**
 * A directive that can be used by any html element to be able
 */
'use strict';

recogniaApp.directive('hideContainer', function() {
	return {
		link: function(scope, element, attr) {
			$(element).click(function() {
				$(attr.hideContainer).slideUp();
			});

			// keyboard accessible close
			element.bind('keydown', function( event ) {
				if (event.keyCode === 13) {
					$(attr.hideContainer).slideUp();
				}
			});
		}
	};
});

/**
 * Bootstrap Tooltip for AngularJS referring: http://mgcrea.github.io/angular-strap/#/tooltip
 */

'use strict';
recogniaApp.directive('bsTooltip', [
'Config',
function (Config) {
	// This function overide is required so that it will close on tap on mobile
	var originalShow = $.fn.tooltip.Constructor.prototype.show;
	$.fn.tooltip.Constructor.prototype.show = function () {
		originalShow.apply(this, arguments);
		$('.tooltip').click(function() { $('.tooltip').hide(); } );
	};

	return {
		restrict: 'A',
		transclude: false,
		link: function(scope, element, attrs){

			var trigger = attrs.trigger || 'click hover focus',
			isRtl = Config.isRtl(),
			placement = attrs.placement || 'auto';
			if (isRtl && attrs.placement !== undefined) {
				if (attrs.placement.indexOf('left') !== -1){
					placement = attrs.placement.replace('left', 'right');
				}
				else if (attrs.placement.indexOf('right') !== -1){
					placement = attrs.placement.replace('right', 'left');
				}
			}

			element.addClass('help-cursor');

			function initTooltip(){
				element.tooltip({
					title: scope[attrs.bsTooltip],
					html: true,
					trigger: trigger,
					placement: placement,
					container: '.recognia'
				});
			}
			initTooltip();

			scope.$watch(attrs.bsTooltip, initTooltip);
		}
	};
}
]);

'use strict';

/* Log page access via directive */
recogniaApp.directive('logUsage', ['UsageLogging', function(UsageLogging) {
	return {
		restrict: 'AM',
		link: function (scope, element, attrs) {

			UsageLogging.log(attrs.logUsage);
		}
	};
}]);

/**
 * Created by arizvi on 6/30/14.
 */

'use strict';

recogniaApp.directive('templateVars', function() {
	return {
		restrict: 'A',
		link: function(scope) {
			scope.optionsStrategy = true;
		}
	};
});
'use strict';

/*
 * For lazy loading with Bootstrap tabs. Sets a tab's content ng-include the
 * first time it's shown. Target must initially have ng-include="deferredTabSrc"
 *
 * Example:
 * <a data-toggle="tab" data-target="#my-tab-content"
 *     deferred-tab-src="'example/template.html'">Tab Title</a>
 * ...
 * <div id="my-tab-content" ng-include="deferredTabSrc"></div>
 */
recogniaApp.directive('deferredTabSrc', function() {
	return {
		restrict: 'A',
		link: function(scope, element, attrs) {
			// when Bootstrap tabs are shown they trigger 'shown' event
			element.on('shown.bs.tab', function(){
				// target can be defined in 2 attributes, data-target or href
				var target = attrs.target || attrs.href,
					sc = angular.element(target).scope();
				// only set src once
				if (!sc.deferredTabSrc){
					sc.$apply(function(){
						sc.deferredTabSrc = attrs.deferredTabSrc;
					});
				}
			});
		}
	};
});

'use strict';

/*
 * ngInclude functionality but waits until a list of dependencies have resolved.
 *
 * = Directive args =
 * deps-ng-include = <path/to/template.html>
 * deps = <comma separated list of dependencies>
 *
 * == Example ==
 * <div deps-ng-include="'my_widget/template.html'" deps="ServiceX,ServiceY"></div>
 *
 * = Dependency Interface Sample =
 * // when ServiceX starts loading
 * var initDoneCallbacks = [];
 * ...
 * // public facing function
 * init: function () {
 *     var progress = $q.defer();
 *     if (serviceIsReady) {
 *         progress.resolve({});
 *     } else {
 *         initDoneCallbacks.push(function () {
 *             progress.resolve({});
 *         });
 *     }
 *     return progress.promise;
 * }
 * ...
 * // when ServiceX finishes loading
 * initDoneCallbacks.forEach(function (func){
 *      func();
 * });
 */
recogniaApp.directive('depsNgInclude',
	['$q', '$injector',
	function ($q, $injector) {
		return {
			restrict: 'A',
			replace: true,
			template: '<div ng-include="depsNgIncludeUrl"></div>',
			transclude: false,
			// need this to isolate scope
			scope: {
				depsNgIncludeUrl: '@',
				depsNgIncludeSrc: '&depsNgInclude'
			},
			compile: function() {
				return {
					pre: function(scope, element, attrs) {
						scope.$eval(attrs.initWith);
					},
					post: function(scope, element, attrs) {

						var depsNames = attrs.deps.split(','),
							deps = depsNames.map(
								function(name){
									return $injector.get(name).init();
								}
							);

						$q.all(deps).then(function(){

							scope.depsNgIncludeUrl = scope.depsNgIncludeSrc();

							scope.$watch('depsNgIncludeSrc()',function(){
								scope.depsNgIncludeUrl = scope.depsNgIncludeSrc();
							});
						});

					}
				};
			}
		};
	}]
);

'use strict';

/**
 * A directive to set the values for the google analytics methods
 */
recogniaApp.directive('gaPageView',
	['GoogleAnalytics',
	function (GoogleAnalytics) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				GoogleAnalytics.sendPageView(attrs["gaPageView"]);
			}
		};
	}
]);

'use strict';

recogniaApp.directive('gaClickEvent',
['GoogleAnalytics',
function (GoogleAnalytics) {
	return {
		link: function(scope, element, attrs) {
			$(element).click(function() {
				var data = {};
				if ( Object.prototype.hasOwnProperty.call(attrs, "widget") )
					  data.widget = attrs["widget"];
				else  data.widget = null;
				if ( Object.prototype.hasOwnProperty.call(attrs, "symbol") )
					  data.instrumentSymbol = attrs["symbol"];
				else  data.widget = null;
				data.ideaType = GoogleAnalytics.ideaLabels[attrs["widget"] + "-" + attrs["ideaType"]];
				data.productType = GoogleAnalytics.productLabels[attrs["widget"]];
				var Events = GoogleAnalytics.gaEvents(data);
				if (Object.prototype.hasOwnProperty.call(Events[attrs["category"]], attrs["gaClickEvent"])) {
					GoogleAnalytics.sendEvent(
						attrs["category"],
						Events[attrs["category"]][attrs["gaClickEvent"]]["action"],
						Events[attrs["category"]][attrs["gaClickEvent"]]["label"]
					);
				}
				//else {
				// 	console.log('Category: ' + attrs["category"]);
				// 	console.log('Action: ' + attrs["gaClickEvent"]);
				// 	console.log('GA event could not be sent.');
				// };
			});
		}
	};
}]);

recogniaApp.directive('inputClickEvent',
	['$timeout',
		function (timeout) {
			return {
				restrict: "A",
				scope: {
					clickButtonId: '='
				},
				link: function(scope, element, attrs) {
					element.bind('keydown', function (event){
						if(event.keyCode === 13){
							event.preventDefault();
							timeout(function() {
								angular.element("#"+scope.clickButtonId).trigger('click');
							}, 100);
						}
					});
				}
			};
}]);
/**
 * Toggles the popover box when user **clicks** on an element that has a popover
 */

'use strict';

recogniaApp.directive('popOverClick', function() {

	return {
		link:function(scope, element, attrs) {
			function initPopOver() {
			$(element).popover({
				trigger: 'manual',
				placement: attrs.popOverClick || 'bottom',
				html: 'true',
				content: function() {}
			}).on("click", function () {
					if ($(this).next('div.popover:visible').length){
						$(this).popover("hide");	//toggle hide/show
					}else {
						$(this).popover("show");

						// set initial focus, if specified
						if (attrs.popOverInitFocus && attrs.popOverInstance) {
							$('personal-url-button[name="' + attrs.popOverInstance + '"]').find('#'+attrs.popOverInitFocus).focus();
						}
					}
				});
			}
			scope.$watch(
				function(){return attrs.popOverClick;},
				function(){ initPopOver(); }
			);
		}
	};
});
'use strict';

recogniaApp.directive('personalUrlButton',
['$window', 'REST', 'Config', 'CommonConstants','Platform',
	function ($window, REST, Config, CommonConstants, Platform) {
	return {
		restrict: 'E',
		templateUrl: 'templates/directives/personal_url_button.html',
		controller: [
			'$scope', 'Lexicon',
			function PersonalUrlCtrl($scope, Lexicon) {
				$scope.personalUrlPopoverTitle = Lexicon.translateDefaultNS('personalsettings.personal-url-popover-title');
				$scope.personalUrlPopoverContent = Lexicon.translateDefaultNS('personalsettings.personal-url-popover-content');
				$scope.sendButtonCopy = Lexicon.translateDefaultNS('personalsettings.send-button-copy');
				$scope.sendButtonCancel = Lexicon.translateDefaultNS('personalsettings.send-button-cancel');
				$scope.personalUrl = Lexicon.translateDefaultNS('personalsettings.personal-url');

				// customization for the mobile link
				$scope.showMobileLink = false;
				var result = Platform.data();
				$scope.showMobileLink = result.showMobileLink;

				// Get the personal url
				REST.User().success(function (data) {
					var clientWebFolder = data.result.client.clientWebFolder;
					if (clientWebFolder !== '') {
						clientWebFolder = '/' + clientWebFolder;
					}
					$scope.clientWebFolder = clientWebFolder;
				});

				var brand = Platform.data().brand;
				/**
				 * Strings are hard-coded for english - BUG#9220
				 * Temporary solution to UTF-8 problem
				 */
				if (Config.language() === CommonConstants.LANGUAGE_MAP.en) {
					$scope.sendEmailMessage = {
						"personalUrlEmailSubject": "Link to "+ Lexicon.translateDefaultNS('common.'+brand)+" Featured Ideas",
						"personalUrlPopoverEmailContent": "Here is your "+ Lexicon.translateDefaultNS('common.'+brand)+" Featured Ideas link to bookmark on your mobile device. Be sure to add your bookmark to your home screen for easy access! %0D%0A%0D%0A"
					};
				} else {
					$scope.sendEmailMessage = {
						"personalUrlEmailSubject": "Recognia",
						"personalUrlPopoverEmailContent": ""
					};
				}

				/**
				 * Function to restrict tab navigation to the popup window
				 */
				$scope.$on('tabdown', function( msg, obj ) {
					var selectedAttrs = angular.element(document.activeElement)[0].attributes;
					if (selectedAttrs.id !== undefined) {
						var selectedId = selectedAttrs.id.value;
						if (!obj.shiftKey && (selectedId === $scope.lastTab)) {
							$('personal-url-button[name="' + $scope.instanceName + '"]').find('#' + $scope.firstTab).focus();
							event.preventDefault();
						} else if (obj.shiftKey && (selectedId === $scope.firstTab)) {
							$('personal-url-button[name="' + $scope.instanceName + '"]').find('#' + $scope.lastTab).focus();
							event.preventDefault();
						}
					}
				});
			}
		],
		transclude: false,
		scope: {
			popoverPosition: '&',
			product: '&'
		},
		link: function(scope, elem, attrs) {
			scope.getPopoverPosition = function(){
				return scope.popoverPosition() || 'bottom';
			};

			scope.getPersonalUrl = function() {
				var pageid;
				// TODO: Yuck! There should be a better way to get the asset category.
				switch (scope.product()) {
					case CommonConstants.VIEW.stocks:
					case CommonConstants.VIEW.watchedStocks:
						pageid = "featured_stocks";
						break;
					case CommonConstants.VIEW.options:
					case CommonConstants.VIEW.watchedOptions:
						pageid = "featured_options";
						break;
					case CommonConstants.VIEW.forex:
					case CommonConstants.VIEW.watchedForex:
						pageid = "featured_forex";
						break;
				}
				return $window.location.protocol + '//' + $window.location.hostname + scope.clientWebFolder + '/webapp/page.html?pageid=' + pageid + '&uid=' + encodeURIComponent(Config.getUserAuthorization());
			};

			scope.instanceName = attrs.name;

			scope.firstTab = attrs.firstTab;
			scope.lastTab = attrs.lastTab;
			elem.bind('keydown', function( event ) {
				if (event.keyCode === 9) {
					scope.$broadcast('tabdown', { code: event.keyCode, shiftKey: event.shiftKey, event: event
					} );
				}
			});
		}
	};
}]
);

/**
 * Created by dmcdougall on 5/30/16.
 */

'use strict';
recogniaApp.directive('bling', [
	'CommonConstants',
	function (CommonConstants) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				scope.parentElement = $(element);

			}
		};
	}
]);

'use strict';


recogniaApp.directive('formatstringchars', ['$compile', function($compile){
    return {
        restrict:'E',
        replace:true,
        scope:{
            value:"@"
        },

        link: function(scope,elem,attrs){

            var charsToFormatLength = parseInt(attrs["charsToFormat"]), strLastPartLength, strFirstPartLength, dynamicUpdate = attrs["dynamicUpdate"];
            scope.cssClass = attrs["cssClass"];

            // if we need to have a watch on the value passed in, since the value changes dynamically
            // otherwise we just use the diretive without needing to update it
            if(dynamicUpdate){
                scope.$watch('value', updateValue);

            }else{
                updateValue();
            }

            function updateValue(){
                if(charsToFormatLength){
                    strFirstPartLength = scope.value.length - charsToFormatLength;
                    scope.strFirstPart = scope.value.substring(0, strFirstPartLength);
                    scope.strLastPart = scope.value.substr(-charsToFormatLength);
                }else{
                    scope.strFirstPart = scope.value;
                    scope.strLastPart = "";
                }
                var linkfn = $compile("<span id='lastPrice' >{{strFirstPart}}<span id='testchild' class='{{cssClass}}'>{{strLastPart}}</span></span>");
                elem.first().replaceWith(linkfn(scope));
            }
        }
    };
}])
'use strict';

recogniaApp.directive('showHideIdea', function(){
    return {
        restrict:'A',
        replace:false,
        scope:true,
       
        link: function(scope,elem,attrs){
            scope.$watch('selectedIdea.idea', function(newValue){            
                if(scope.featured.idea === newValue){                    
                   elem.css("display", "block");  
                }else{                    
                    elem.css("display", "none");
                }                
            })            
        }
    }
});

'use strict';

/**
 * This file contains filters that expose base javascript funcitonality
 */

recogniaApp.filter('encodeURIComponent', [
	function () {
		return function (str) {
			return encodeURIComponent(str);
		};
	}
]);

recogniaApp.filter('Math_abs', [
	function () {
		return function (val) {
			return Math.abs(val);
		};
	}
]);

'use strict';

// TODO rename all filters to have a common prefix and then the method name
// Example: nf_percent, nf_real, nf_currency ...
var filterMapping = {
	'criterionValue': 'formatCriterion',
	'formatCurrency': 'formatCurrency',
	'formatCurrencyShort': 'formatCurrencyShort',
	'formatScientificNotation': 'formatScientificNotation',
	'formatInteger': 'formatInteger',
	'realRoundedToPlaces': 'formatReal',
	'NFabbreviated': 'abbreviated',
	'nf_percent': 'percent',
	'nf_percentWithSign': 'percentWithSign',
	'nf_percentWithLessThanThreshold': 'percentWithLessThanThreshold',
	'nf_percentInTextBlock': 'percentInTextBlock',
	'nf_price': 'price'
};

// Filters should all just forward arguments to service
Object.keys(filterMapping).forEach(function (filterName) {

	recogniaApp.filter(filterName, ['NumberFormatter',
	function (NumberFormatter) {
		var nfMethod = filterMapping[filterName];
		if (!NumberFormatter[nfMethod]){
			throw 'NumberFormatter does not have method "' + nfMethod + '"';
		}
		return function() {
			return NumberFormatter[nfMethod].apply(this, arguments);
		};
	}]);

});

'use strict';

/**
 * This file contains filters that are used for options trades
 */

recogniaApp.filter('tradeLegSort',
['OptionsStrategy',
function (OptionsStrategy) {
	return function(items, trade, reverse) {
		// convert trade object to array
		var filtered = Object.keys(items).map(function(k) {
			return items[k] ;
		});
		// sort with whatever the strategy defines
		filtered.sort(OptionsStrategy.getLegComparator(trade));
		if(reverse) filtered.reverse();
		return filtered;
	};
}]);

recogniaApp.filter('tradeLegOneLineFormat',
['Lexicon', 'DateFormatter', 'NumberFormatter',
function (Lexicon, DateFormatter, NumberFormatter) {
	return function(leg, precision, skipExpiry) {
		var formatted = '';
		if (leg.instrument['resourceType'] === 'instrument'){
			// Example output "100 LVNTA @ 36.22"
			formatted = leg.quantity + ' ' +
				leg.instrument.symbolAlternates.COMMON + ' @ ' +
				NumberFormatter.formatCurrency(parseFloat(leg.instrument.latestPrice.price),precision);
		} else if (leg.instrument['resourceType'] === 'optionsContract'){
			// Example output "1 /2015 Jul 17/ 105.00 Put @ 13.35"
			formatted = leg.quantity + ' / ' +
				((!skipExpiry) ? DateFormatter.formatDate(DateFormatter.parseISO8601(leg.instrument.expiryDate), 'short') + ' / ' : '') +
				NumberFormatter.formatCurrency(parseFloat(leg.instrument.strikePrice),precision) + ' ' +
				Lexicon.translateDefaultNS('featuredoptions.'+ leg.instrument.contractType) + ' @\u00A0' +
				NumberFormatter.formatCurrency(
					parseFloat( (leg.action === 'sell') ? leg.instrument.latestPrice.bid : leg.instrument.latestPrice.ask ),
					precision);
		} else {
			console.error('Invalid leg type');
		}
		return formatted;
	};
}]);

'use strict';

/**
 * Expose the Lexicon translation function to templates
 */
recogniaApp.filter('lexicon',
['Lexicon',
function (Lexicon) {
	var ready = false;
	Lexicon.init().then(function () {
		ready = true;
	});
	/* takes lexiconKey and then optional arguments. See the Lexicon service*/
	return function() {
		return (ready) ? Lexicon.translateDefaultNS.apply(this, arguments) : '';
	};
}]);

'use strict';

/**
 * This file contains filters that are used for ideas
 */

/**
 * Takes a idea object with expanded target. Depending if the idea is bearish or
 * bullish, return the more cautious end of the target price range
 */
recogniaApp.filter('conservativeTarget',
['Ideas',
function (Ideas) {
	return function (idea) {
		return Ideas.getConservativeTargetPrice(idea);
	};
}]);

'use strict';

/*
 * This is modal window comparing alternative trades
 */
recogniaApp.controller('AlternativeTradesCtrl',
['$scope', 'Lexicon', 'OptionsProfitLossChart', 'HighChartsTheme',
function ($scope, Lexicon, OptionsProfitLossChart, HighChartsTheme) {

	var comparableIdeasChartConfig;
	$scope.compareText = {};
	$scope.hideTable = false;

	// Translated scope variables
	var textKeys = [
		"score-title", "profit-loss-chart", "expiry-sub-heading", "to-open", "net-cost-in-total",
		"net-cost-per-share", "net-received-in-total", "net-received-per-share", "max-loss-as-a-percent", "max-loss-in-total", "max-loss-per-share", "reward",
		"target-price", "target-profit-in-total", "target-profit-per-share", "return-on-investment", "breakeven-point",
		"profit-zone", "risk", "trade-now-btn", "above", "below"
	];

	textKeys.forEach(
		function (value, index) {
			var currKey = 'alternativetrades.' + textKeys[index];
			$scope.compareText[value] = Lexicon.translateDefaultNS(currKey);
		}
	);

	// default compare type is alternative strategy
	$scope.isCompare = ($scope.isCompare === undefined) ? false : $scope.isCompare;

	//Determine column makeup for desktop
	$scope.setViewSplit = function() {
		switch ($scope.comparableIdeas.length) {
			case 4:
				$scope.viewSplit = 'col_25';
				break;
			case 3:
				$scope.viewSplit = 'col_33';
				break;
			case 2:
				$scope.viewSplit = 'col_50';
				break;
			case 1:
				$scope.viewSplit = 'col_100';
				break;
			default:
				$scope.viewSplit = 'col_25';
		}
	};

	// tell child to re-initialize columns in modal
	$scope.$on('reinitializeModalColumns', function(){
		$scope.setViewSplit();
		// toggle reflow to trigger watch on highcharts to re-size itself
		$scope.reflow = ($scope.reflow === undefined) ? true : $scope.reflow;
		$scope.reflow = ($scope.reflow === true) ? false : true;
	});

	/* Chart Configurations based for different screen sizes */
	$scope.SCREEN_CONFIG = {
		'default': {
			height: 150
		},
		mobile: {
			height: 200
		},
		desktop: {
			height: 150
		}
	};

	/* Make y-axis the same for all charts */
	var adjustYAxis = function (profitLossChartConfig, minY, maxY) {
		profitLossChartConfig.yAxis.min = minY;
		profitLossChartConfig.yAxis.max = maxY;
	};
	/* Build chart with default configurations */
	var buildChartConfig = function (idea, trade) {
		return angular.copy(
			OptionsProfitLossChart.buildChartConfig(
				idea,
				trade
			)
		);
	};

	/* Configure Tooltips */
	var stripoutChartDefaultConfigurations= function (profitLossChartConfig) {
		profitLossChartConfig.credits = {"enabled" : false};
		profitLossChartConfig.tooltip = {"enabled": false};
	};

	var updateChartAxisFontSize = function(profitLossChartConfig){
		profitLossChartConfig.yAxis.labels.style["fontSize"]= '9px';
		profitLossChartConfig.xAxis.labels.style["fontSize"]= '9px';
	};

	var setChartHeight = function (profitLossChartConfig, screenConfig) {
		if (screenConfig === undefined)
			screenConfig = $scope.SCREEN_CONFIG["default"];
		profitLossChartConfig.chart.height = screenConfig.height;
	};

	var setChartBorder = function (profitLossChartConfig){
		profitLossChartConfig.chart.borderColor= HighChartsTheme.chartBorderColor();
		profitLossChartConfig.chart.borderWidth= 1;
		profitLossChartConfig.chart.type= 'line';
	};

	var initializeProfitLossChartConfig2 = function () {
		var chartsConfig=[], featuredTrade, config, minY, maxY;
		$scope.comparableIdeas.map(function (comparableIdeas) {
			featuredTrade = comparableIdeas.idea.trade;
			config = buildChartConfig(comparableIdeas.idea,featuredTrade);
			minY = (minY !== undefined) ? Math.min(config.yAxis.min, minY): config.yAxis.min;
			maxY = (maxY !== undefined) ? Math.max(config.yAxis.max, maxY) : config.yAxis.max;
			chartsConfig.push({'trade':featuredTrade, 'config': config});
		});

		chartsConfig.map(function (chartConfig) {
			stripoutChartDefaultConfigurations(chartConfig.config);
			updateChartAxisFontSize(chartConfig.config);
			adjustYAxis(chartConfig.config, minY, maxY);
			setChartBorder(chartConfig.config);
		});
		return chartsConfig;
	};

	$scope.getProfitLossChartConfig = function (trade, screenConfig) {
		var chartConfig, index;
		for (var i = 0; i < comparableIdeasChartConfig.length; i++) {
			if (comparableIdeasChartConfig[i].trade === trade) {
				index = i;
				break;
			}
		}
		if (index >= 0) {
			chartConfig = comparableIdeasChartConfig[index].config;
			setChartHeight(chartConfig, screenConfig);
			return angular.copy(chartConfig);
		}
	};

	$scope.initializeProfitLossChartConfig = function (trade) {
		return $scope.getProfitLossChartConfig(trade, $scope.SCREEN_CONFIG.desktop);
	};

	$scope.updateSelectedIdea = function(tradeIdea){
		$scope.setSelectedTradeIdea(tradeIdea);
		$scope.chartConfig = $scope.getProfitLossChartConfig(tradeIdea.idea.trade, $scope.SCREEN_CONFIG.mobile);
	};

	var initializeAlternativeTrades = function() {
		// Initialize all charts when the controller gets loaded
		$scope.setViewSplit();
		comparableIdeasChartConfig = initializeProfitLossChartConfig2();

		$scope.breakEvenPoints = [];
		for (var i = 0; i < $scope.comparableIdeas.length; i++) {
			var trade = $scope.comparableIdeas[i].idea.trade;
			var breakEven = null;
			if (trade.profitZone && trade.profitZone.length > 0) {
				var profitZone = trade.profitZone[0];
				if (Number(profitZone.lower) === 0 || Number(profitZone.upper) === Infinity) {
					breakEven = Number(profitZone.lower) === 0 ? profitZone.upper : profitZone.lower;
				}
			}
			$scope.breakEvenPoints[i] = breakEven;
		}
	};

	if ($scope.initializeOnLoad) {
		initializeAlternativeTrades();
		$scope.updateSelectedIdea($scope.getSelectedTradeIdea());
	}

	// deferred initialization
	$scope.$on('deferredInitialization', function(){
		initializeAlternativeTrades();
	});

}]);

'use strict';

recogniaApp.controller('AutoSussgestCtrl',
['$scope', 'Lexicon','REST','CommonConstants','UserPreferences',
function ($scope, Lexicon,REST,CommonConstants, UserPreferences) {

	var questionId = $scope.questionId;
	angular.element("[name='focusAutoSuggestField']").attr("placeholder", Lexicon.translateDefaultNS('instrument_lookup.symbol-placeholder'));
	var showResultNumber = 8 ;

	$scope.questionsTranslated = angular.copy(UserPreferences.getUserPreferences().settings[questionId]);
	if(!$scope.questionsTranslated ){
		$scope.questionsTranslated = [];
	}

	$scope.removeTag = function (qid) {
		for(var i=0; i<UserPreferences.getUserPreferences().settings[questionId].length;i++){
			if(UserPreferences.getUserPreferences().settings[questionId][i]){
					if(UserPreferences.getUserPreferences().settings[questionId][i].id===qid){
						UserPreferences.getUserPreferences().settings[questionId].splice(i, 1);
						break;
					}
			}
		}

		for(var j=0; j<$scope.questionsTranslated.length;j++){
				if($scope.questionsTranslated[j].id===qid){
					$scope.questionsTranslated.splice(j, 1);
					break;
				}
		}
	};

	$scope.isSelectedTag = function(question) {
		if(UserPreferences.getUserPreferences().settings[questionId]===undefined){
			return false;
		}
		for(var i=0; i<UserPreferences.getUserPreferences().settings[questionId].length;i++){
			if(UserPreferences.getUserPreferences().settings[questionId][i]){
					if(UserPreferences.getUserPreferences().settings[questionId][i].id===question.id){
						return UserPreferences.getUserPreferences().settings[questionId];
					}
			}
		}
		return false;
	};

	$scope.hasSelectedTags = function(){
		if (!UserPreferences.getUserPreferences().settings[questionId]){
			return false;
		}
		return UserPreferences.getUserPreferences().settings[questionId].length>0;
	};

	function getSelectedTagsSize (){
		return !$scope.questionsTranslated ? 0 : $scope.questionsTranslated.length;
	}

	function addForexPairs (selectedItem) {
		if (!UserPreferences.getUserPreferences().settings[questionId]){
			UserPreferences.getUserPreferences().settings[questionId] = [];
		}
		var item = {};
		item.symbol = selectedItem.symbol;
		item.exchange = selectedItem.exchange;
		item.id = selectedItem.id;

		UserPreferences.getUserPreferences().settings[questionId].push(item);

		$scope.questionsTranslated.push(item);
		$scope.$apply();
	}

	//remove currency pairs when it already be selected
	function filterResult (currencyPairs,alreadySelected){
		for(var k=0; k<currencyPairs.length;k++){
			currencyPairs[k].exchange = currencyPairs[k]['exchangeSymbol'];
			delete  currencyPairs[k]['exchangeSymbol'];
		}

		if(alreadySelected===undefined){
			return currencyPairs;
		}
		for(var i=0; i<alreadySelected.length;i++){
			for(var j=0; j<currencyPairs.length;j++){
				if(alreadySelected[i].id===currencyPairs[j].id){
					currencyPairs.splice(j, 1);
					break;
				}
			}
		}
		return currencyPairs;
	}

	var autoCompleteObj = RecogniaCoreServices.getAutoComplete("flexdatalist",{
		minLength: 1,
		selectionRequired: true,
		visibleProperties: ["symbol","name"],
		searchIn: ["symbol","name"],
		searchContain:true,
		focusFirstResult: true
	},selectedItemCallbackFunc, keyCallback,'(^|\\s)');

	function selectedItemCallbackFunc(selectedObj){
		addForexPairs(selectedObj);
	}

	var xhr;
	function keyCallback(selectedChar){
		var limit = getSelectedTagsSize()+showResultNumber;
		//Optimizing AJAX requests
		try {
			if(xhr){
				xhr.abort();
			}
		} catch(e){
		}
		xhr = REST.Search(selectedChar,CommonConstants.PRODUCT.forex,false,false,limit).success(function (response) {
			//console.log(callback++);
			var item = filterResult(response.result.items,$scope.questionsTranslated);
			if(item.length===0){
				autoCompleteObj._receiveResults(null);
			}
			//only show 8 results in the resultset
			else if(item.length>showResultNumber){
				item.splice(showResultNumber,item.length-showResultNumber);
				autoCompleteObj._receiveResults(item);
			}
			else{
				autoCompleteObj._receiveResults(item);
			}
		});
	}

}]);

/**
 * Created by Hosam on 2/27/2014.
 */
'use strict';

recogniaApp.controller('CompanyInfoCtrl',
['$scope',
function ($scope) {
	var thisCtrl = this;

	thisCtrl.instrument = $scope.instrument;
	thisCtrl.fundamentals = thisCtrl.instrument.fundamentals;

	if (thisCtrl.instrument.company){
		thisCtrl.website = thisCtrl.instrument.company.website;
		if (thisCtrl.website && thisCtrl.website.indexOf('http') === -1) {
			thisCtrl.website = 'http://' + thisCtrl.website.toLowerCase();
		}
	}
}]);

'use strict';
/**
 * Created by aahmed on 20/11/14.
 */
/** This controller inherits methods from its parent controller.
 * The methods in parent controller are shared among mobile & desktop views.
 */
recogniaApp.controller('compareAlternativesCtrl',
['$scope','Lexicon',
function ($scope, Lexicon) {
	$scope.compareTitle = Lexicon.translateDefaultNS('comparealternatives.compare-title');

	$scope.initializeOnLoad = true;
	$scope.show = false;

	// Ignore remove events, as they are not available
	$scope.$on('removeIdea', function (e) {
		e.stopPropagation();
	});
}]);

'use strict';
/** This controller inherits methods from its parent controller.
 * The methods in parent controller are shared among mobile & desktop views.
 */
recogniaApp.controller('compareIdeasCtrl',
['$scope', 'Ideas', 'Lexicon',
function ($scope, Ideas, Lexicon) {
	$scope.show = false;

	$scope.compareTitle = Lexicon.translateDefaultNS('compareideas.compare-title');
	$scope.invalidTrade = Lexicon.translateDefaultNS('compareideas.invalid-trade');
	$scope.remove = Lexicon.translateDefaultNS('compareideas.remove');

	// local variables used when no ideas are available
	$scope.title = Lexicon.translateDefaultNS('compareideas.no-ideas-title');
	$scope.howToCompare = Lexicon.translateDefaultNS('compareideas.no-ideas-how-to-compare');
	$scope.findCompare = Lexicon.translateDefaultNS('compareideas.no-ideas-find-compare');
	$scope.clickCompare = Lexicon.translateDefaultNS('compareideas.no-ideas-click-compare');
	$scope.viewCompare = Lexicon.translateDefaultNS('compareideas.no-ideas-view-compare');
	$scope.compare = Lexicon.translateDefaultNS('compareideas.compare');
	$scope.comparing = Lexicon.translateDefaultNS('compareideas.comparing');
	$scope.compare2 = Lexicon.translateDefaultNS('compareideas.compare-2-4');
	$scope.goBack = Lexicon.translateDefaultNS('compareideas.no-ideas-go-back');

	$scope.isCompare = true;

	var checkIfTableRequired = function() {
		// look for one valid idea
		$scope.hideTable = true;
		for (var i=0; i<$scope.comparableIdeas.length; i+=1) {
			if (!$scope.comparableIdeas[i].isExpired) {
				$scope.hideTable = false;
				break;
			}
		}
	};

	var checkExpired = function() {
		// check for contract expiry
		var i, legs, legName, today = Date.parse(Date());
		for (i=0; i<$scope.comparableIdeas.length; i+=1) {

			// find the first non-instrument trade leg
			legs =  $scope.comparableIdeas[i].idea.trade.legs;
			for (legName in legs) {
				if (legs.hasOwnProperty(legName) && (legName !== 'instrument')) {
					if (today >= Date.parse(legs[legName].instrument.expiryDate)) {
						$scope.comparableIdeas[i].isExpired = true;
					} else {
						$scope.comparableIdeas[i].isExpired = false;
					}
					break;
				}
			}
		}
	};

	// remove the compared idea
	$scope.$on('removeIdea', function (e, idea, index) {
		e.stopPropagation();
		Ideas.compared.remove($scope.comparableIdeas[index]).then(function() {
			$scope.comparableIdeas.splice(index,1);
			// tell child to re-initialize columns in modal
			$scope.$broadcast('reinitializeModalColumns');
			checkIfTableRequired();
		}, function(error) {
			// better error handling required?
			console.error('Failed to delete the compared idea:' + error);
		});
	});

	// initialize the data on display
	$scope.$on('updateCompareIdeas', function(event, comparableIdeas) {
		// Ideas singleton service has already been initialized in Options Lookup
		$scope.comparableIdeas = comparableIdeas;

		// check if table is required on display
		checkIfTableRequired();

		// check expiry on display
		checkExpired();

		// tell child to initialize
		$scope.$broadcast('deferredInitialization');
	});
}]);

'use strict';

recogniaApp.controller('CountryDropdownCtrl',
['$scope', 'HostedWebsite',
function ($scope, HostedWebsite) {

	var parameterForLoadingExchanges = null;
	//set dynamic name for the btn_country_dropdown button
	var button_name = 'btn_country_dropdown'+ $scope.buttonIndex;
	/* Emit change events */
	// exchange selected
	$scope.setExchange = function(exchange,focus) {
		$scope.$emit('exchangeChanged', exchange, $scope.selectedExchange);
		$scope.selectedExchange = exchange;
		//set focus when item be selected
		if(focus===undefined)
		document.getElementsByName(button_name)[0].focus();
	};

	/* respond to events */
	// reset model
	$scope.$on('reset', function() {
		$scope.setExchange($scope.exchanges[0],false);
	});

	$scope.flagMap = {
		"I-XX":"index",
		"C-XX":"forex",
		"M-XX":"futures"
	};

	$scope.getFlagStyleName = function(exchange) {
		if (exchange===undefined) {
			return '';
		} else if (exchange.type === 'S') {
			return 'sprite-flag-' + exchange.exchange;
		} else {
			return 'sprite-flag-' + $scope.flagMap[exchange.type + '-' + exchange.exchange];
		}
	};

	if($scope.parameterForLoadingExchanges !== undefined && $scope.parameterForLoadingExchanges !== null){
		parameterForLoadingExchanges = 'type=' + $scope.parameterForLoadingExchanges;
	}

	/* Get the list of exchanges for symbol entry */
	HostedWebsite.instrumentLookupExchanges(function (data) {
		$scope.exchanges = data;
		$scope.setExchange(data[0],false);
		$scope.isOneExchange();
		$scope.$emit('exchangeSet', data.length);
	},parameterForLoadingExchanges);

	$scope.isOneExchange = function(){
		return $scope.exchanges && $scope.exchanges.length === 1;
	};
}]);

'use strict';

recogniaApp.controller('CustomSettingsCtrl',
['$scope', '$q', 'REST', 'Lexicon', 'NumberFormatter', 'Broadcast', 'UserPreferences',
function ($scope, $q, REST, Lexicon, NumberFormatter, Broadcast, UserPreferences) {

	var storedQuestionIds;
	var callList;
	$scope.updateCustomSettings = false;


	/**
	 * Calculate the percentage for custom settings
	 * @param questionIds
	 * @param answers
	 */
	function calculatePercentComplete(questionIds, answers) {
		// Boolean scope variable to invoke the custom settings so it can be updated
		$scope.updateCustomSettings = !$scope.updateCustomSettings;

		if (!questionIds || !answers || questionIds.length === 0) {
			$scope.percentComplete = 0;
		} else {
			// check for answered questions
			var answered = 0;
			questionIds.forEach(function(question) {
				if (answers.hasOwnProperty(question) && answers[question].length > 0) {
					answered++;
				}
			});
			$scope.percentComplete = answered / questionIds.length;
		}
	}

	/**
	 * Update the percentage for the custom settings based on the product
	 */
	function updatePercentComplete() {
		callList = [
			// can use the cached version here because the button is right on the page when it loads.
			// In the future, if this button is placed somewhere that is not on first page load, it
			// should probably use the non-cached version
			REST.UserPreferences($scope.selectedProduct),
			REST.PersonalizedSettingsDefinition($scope.selectedProduct)
		];

		$q.all(callList).then(function (responses){
			UserPreferences.setUserPreferences(responses[0].data.result);
			var answer = UserPreferences.getUserPreferences().settings;

			storedQuestionIds = responses[1].data.result.settings.reduce(function (listSoFar, group) {
				return listSoFar.concat(
					group.questions.map(function (question) {
						return question['linkId'];
					})
				);
			}, []);

			calculatePercentComplete(storedQuestionIds, answer);
		});
	}


	// Update custom settings
	$scope.$on(Broadcast.SETTINGS_CHANGED_MESSAGE, function() {
		REST.UserPreferences($scope.selectedProduct).then(function (response){
			calculatePercentComplete(storedQuestionIds, response.data.result.settings);
		});
	});

	$scope.$watch('selectedProduct', function () {
		updatePercentComplete();
	});
}]);

'use strict';

// TODO this parent controller should be refactored and split the functionality among the three child controllers
recogniaApp.controller('EventDetailsCtrl',
['$scope', 'HostedWebsite', 'JsonUtil', 'REST', '$interpolate', 'ChartConfig', 'Lexicon', 'Config', 'EventFormatter', 'SectorFormatter', 'CriteriaApi',
	'ClientServices', 'NumberFormatter', 'BooleanFormatter', 'HasNoTarget', '$q', 'CommonConstants', 'CriteriaConstants', 'DateFormatter', 'Platform',
	'OptionsStrategy', 'Ideas', 'EventTypes', '$timeout', 'Broadcast', 'LoopHttpCallService', 'EventEducationStaticService',
function ($scope, HostedWebsite, JsonUtil, REST, $interpolate, ChartConfig, Lexicon, Config, EventFormatter, SectorFormatter, CriteriaApi,
		  ClientServices, NumberFormatter, BooleanFormatter, HasNoTarget, $q, CommonConstants, CriteriaConstants, DateFormatter, Platform,
		  OptionsStrategy, Ideas, EventTypes, $timeout, Broadcast, LoopHttpCallService, EventEducationStaticService) {

	var thisCtrl = this;


	var featured = $scope.featured,
			largeChartIndex, optionAPICalls, infoIconIndex;
	$scope.modalLayer = '';

		// Checkbox label (shown only on large chart for Forex ideas)
	$scope.alwaysCandlesticksForLargeForexChartLabel = Lexicon.translateDefaultNS('eventdetails.candlesticks-always');


	// Used for commentary - DO NOT MODIFY
	$scope.event = angular.copy(featured.idea.events[0] || {});
	$scope.targetPrice = angular.copy(featured.idea.targetPrice || {});
	$scope.tagsMatched = [];

	$scope.targetLabel = Lexicon.translateDefaultNS('eventdetails.target');

	$scope.currencyLabel = Lexicon.translateDefaultNS('currency.' + $scope.featured.idea.instrument.currencySymbol);

	$scope.eventLookupText = Lexicon.translateDefaultNS('eventdetails.see-all-technical-analysis', {
		'sprintf': {
			'symbol': $scope.featured.idea.instrument.symbol
		}
	});

	$scope.noLongerValidIdea = Lexicon.translateDefaultNS('eventdetails.idea-no-longer-valid');

	// Tags Translation
	for (var i = 0; i < featured.tagsMatched.length; i++) {
		// No need to translate some tag types
		if ([CommonConstants.market, CommonConstants.exchange,CommonConstants.instrument].indexOf(featured.tagsMatched[i].dataType) !== -1
				|| featured.tagsMatched[i].name === ''
				|| featured.tagsMatched[i].name === undefined
				|| featured.tagsMatched[i].name === null) {

			if([CommonConstants.instrument].indexOf(featured.tagsMatched[i].dataType) !== -1){
				$scope.tagsMatched.push(featured.tagsMatched[i].symbol);
			}else{
				$scope.tagsMatched.push(featured.tagsMatched[i].id);

			}
		}
		else {
			$scope.tagsMatched.push(Lexicon.translateDefaultNS('personalization.' + featured.tagsMatched[i].name));
		}
	}


	$scope.isForexIdea = function (featured) {
		return featured.idea.ideaType === CommonConstants.IDEA_TYPE.forex;
	};


	$scope.text = {};

	function setIdeaErrorText(headerKey, bodyKey, footerKey, footerKeyDeleted) {
		$scope.text.watchedModalHeader = Lexicon.translateDefaultNS(headerKey || '');
		$scope.text.watchedModalIdeas = Lexicon.translateDefaultNS(bodyKey || '');
		$scope.text.watchedModalDelete = Lexicon.translateDefaultNS(footerKey || '');
        $scope.text.watchedModalDeleted = Lexicon.translateDefaultNS(footerKeyDeleted || '');
	}

	// initial error message state
	$scope.watchedModalIcon = true;

	if ($scope.featured.idea.events.length === 0) {
		setIdeaErrorText('eventdetails.no-event-watched-header',
				'eventdetails.no-event-watched-ideas',
				'eventdetails.no-event-watched-delete', 'eventdetails.no-event-watched-deleted');
		$scope.ideaHasError = true;
	}

	// children can $emit this so that the error covers the whole event
	// details area
	$scope.$on('showIdeaError',
			function (event, setVisible, headerKey, bodyKey, footerKey, footerKeyDeleted) {
				if (setVisible === undefined) {
					setVisible = false;
				}
				if (setVisible) {
					setIdeaErrorText(headerKey, bodyKey, footerKey, footerKeyDeleted);
				}
				$scope.ideaHasError = setVisible;
				event.stopPropagation();
			}
	);

	// Called by idea error dialogue
	$scope.removeWatched = function (idea) {
		Ideas.watched(idea.idea.ideaType).remove(idea).then(null, function (reason) {
			$scope.$emit(Ideas.watched(idea.idea.ideaType).REMOVE_ERROR, reason);
		});

        $scope.watchedModalIcon = false;
        $scope.watchedModalIconRemoved = true;
	};

	$scope.bullishBearish = Ideas.findIdeaType(featured.idea);

	$scope.language = CommonConstants.LANGUAGE_MAP.en;
	$scope.backtest_strategy_view = CommonConstants.BackTesting;
	$scope.instrument = $scope.featured.idea.instrument;
	$scope.optionable = false;
	if ($scope.instrument.optionable) {
		$scope.optionable = true;
	}
	$scope.strategy = featured.idea.strategy;
	$scope.criteriaTags = null;
	if ($scope.strategy !== null&&$scope.strategy !== undefined) {
		$scope.criteriaTags = $scope.strategy.criteria.values;
	}

	$scope.setEventFormPattern = function (eventTypeCode) {
		// Get the event education/description, which will show when the user hovers over the event title (or clicks/tabs to it).
		// This call is needed because the new api eventtypes/v3 is not returning the education of the event.
		EventEducationStaticService.getEventShortDescription(eventTypeCode).then(function (response) {
			// Adjust the quotes for html usage
			$scope.dataContent = '"' + response.data.split('"').join('&#34;') + '"';

			$scope.eventFormPattern = Lexicon.translateDefaultNS('eventdetails.event-form-pattern', {
				'sprintf': {
					'symbol': $scope.featured.idea.instrument.symbol,
					event_name: '<a role="button" class=event-type-name-link pop-over tabindex="0" data-title=' + $scope.eventTypeNameHtml + ' data-content=' + $scope.dataContent + '>' + $scope.eventTypeName + '</a>'
				}
			});
		});
	};

	var ideaEventType;
	featured.idea.events.forEach(function(entry) {
		if (typeof(entry.eventType) === 'string') {
			var legacyEventLinkIdParts = entry.eventType.split('/');
			ideaEventType = EventTypes.byId(legacyEventLinkIdParts[legacyEventLinkIdParts.length - 1]);
			entry.eventType = ideaEventType;
			$scope.event.eventType = ideaEventType;
		} else {
			ideaEventType = entry.eventType;
		}
	});

	var eventType;
	var primaryEvent;
	if (featured.idea.events.length > 0) {
		//use the first event as the primary event, which will be a classic pattern
		primaryEvent =featured.idea.events[0];

		if (typeof(primaryEvent.eventType) === 'string') {
			var legacyEventLinkIdParts = primaryEvent.eventType.split('/');
			eventType = EventTypes.byId(legacyEventLinkIdParts[legacyEventLinkIdParts.length - 1]);
			primaryEvent.eventType = eventType;
		} else {
			eventType = primaryEvent.eventType;
		}

		$scope.eventTypeId = eventType.eventTypeId;
		$scope.eventTypeName = eventType.name;
		$scope.eventTypeCode = eventType.eventTypeCode;


		if ($scope.eventTypeId !== undefined) {
			// Adjust the quotes for html usage
			$scope.eventTypeNameHtml = '"' + $scope.eventTypeName.split('"').join('&#34;') + '"';

			$scope.setEventFormPattern($scope.eventTypeCode);
		}
	}

	// initialize the values to prevent errors.
	$scope.lastPrice = "";
	$scope.priceDiff = 0.0;
	$scope.priceDiffPercent = 0.0;
	$scope.underlyingLatestPriceObj = {};


	$scope.displayExchanges = function (exchange) {
		if($scope.isForexIdea(featured)){
			return false;
		}
		if ($scope.symbolsIncludeExchange === true) {
			for (var index = 0; index < $scope.symbolsIncludeExchangeExceptions.length; index++) {
				if ($scope.symbolsIncludeExchangeExceptions[index] === exchange) {
					return true;
				}
			}
			return false;
		}
		return true;
	};

	$scope.pageDirectionRtl = Config.getPageDirection().rtl;

	function updatePriceMovement (lastPriceForInstrument,latestPriceTimeStamp) {
		$scope.underlyingLatestPriceObj = $scope.instrument.latestPrice;
		var lastprice = Number(lastPriceForInstrument);
		var dataType = $scope.instrument.latestPrice.dataType;
		var precision = $scope.instrument.precision;

		if (lastprice) {
			$scope.price = lastprice;
			$scope.lastPrice = NumberFormatter.formatCurrency(lastprice, precision);

			/*
			 * Display timestamp for latestPrice or 'last close' if it's not intraday.
			 */
			switch (dataType) {
				case CommonConstants.PRICE_DATA_TYPES.tick:
					$scope.latestPriceTimeStamp = DateFormatter.formatTime(DateFormatter.parseDate(latestPriceTimeStamp), false);
					break;

				case CommonConstants.PRICE_DATA_TYPES.close:
					$scope.latestPriceTimeStamp = '';
					break;
			}
			if (featured.idea.events[0]) {
				if (featured.idea.events[0].endPrices !== null) {
					var closePrice, priceDiff, priceDiffPercent;
					//candlesticks, the price move should be calculated based on the close price on the event date
					// classic patterns should based on their breakout price, else use closePrice
					if (eventType['class'] === CommonConstants.EVENT_CATEGORY.classic) {
						var breakoutPrice = Number(featured.idea.events[0].endPrices.breakout);
						priceDiff = lastprice - breakoutPrice;
					} else { //indicators and oscillators use close price
						closePrice = Number(featured.idea.events[0].endPrices.close);
						priceDiff = lastprice - closePrice;
					}
					priceDiffPercent = priceDiff / lastprice;


					$scope.priceDiff = NumberFormatter.formatCurrency(priceDiff, precision);
					if (parseFloat($scope.priceDiff) > 0) {
						$scope.priceDiff = "+" + $scope.priceDiff;
					}

					$scope.priceDiffPercent = NumberFormatter.percentWithLessThanThreshold(Math.abs(priceDiffPercent),
							undefined, 0.1);

					// set the css style of the price and percent change based on move up or down.
					if (parseFloat($scope.priceDiff) > 0) {
						$scope.priceMoveClass = CommonConstants.EVENT_TYPE.bullish;
					} else if (parseFloat($scope.priceDiff) < 0) {
						$scope.priceMoveClass = CommonConstants.EVENT_TYPE.bearish;
					} else {
						$scope.priceMoveClass = "";
					}
				}

				var price;
				if (eventType.barType === CommonConstants.BAR_TYPE.candleStick ||
						$scope.featured.idea.events[0].endPrices.breakout === null) {
					price = NumberFormatter.formatCurrency(featured.idea.events[0].endPrices.close, precision);
				} else {
					price = NumberFormatter.formatCurrency($scope.featured.idea.events[0].endPrices.breakout, precision);
				}

				var lexiconKey, actualChange, change;
				if($scope.isForexIdea(featured)){
					var pip = NumberFormatter.forexPip(priceDiff, featured.idea.instrument);
					var micropip = '';
					if (pip.micropip !== "0") {
						micropip = pip.micropip;
					}
					$scope.changeSinceTechnicalEventDesc = Lexicon.translateDefaultNS('eventdetails.change-since-technical-event-desc-forex', {
						'sprintf': {
							'actualChange': $scope.priceDiff,
							'pipChange': pip.pip,
							'micropipChange': micropip,
							'price': price,
							'class': $scope.priceMoveClass || '""',
                            'micropipSuperscriptClass': 'fs-price-move-micropip',
                            'micropipFadedClass' : 'microPIP-Char-Format',
                            'charFormatLength': '1'
						}
					});
				} else {
					// need to escape percent since there is html in this lexicon and
					// value could be something like < 0.1%
					var escapedDiffPercent = $scope.priceDiffPercent.replace(/</g, '&lt;').replace(/>/g, '&gt;');
					$scope.changeSinceTechnicalEventDesc = Lexicon.translateDefaultNS('eventdetails.change-since-technical-event-desc', {
						'sprintf': {
							'actualChange': $scope.priceDiff,
							'change': escapedDiffPercent,
							'price': price,
							'class': $scope.priceMoveClass || '""'
						}
					});
				}
			}
		}
	}

	updatePriceMovement($scope.instrument.latestPrice.price,$scope.instrument.latestPrice.timestamp);

	// get the translated text for Short/Inter/Long Term event.
	// check if events exist before accessing them
	if (featured.idea.events[0]) {
		var tradeHorizon = featured.idea.events[0].tradingHorizon;
		if (tradeHorizon) {
			$scope.event.tradingHorizon = Lexicon.translateDefaultNS('eventdetails.trading-horizon-' + tradeHorizon);
			var eventEndDate = DateFormatter.formatDate(DateFormatter.parseDate(
					$scope.featured.idea.events[0].dates.eventEnd), 'short');
			$scope.eventTradingHorizon = Lexicon.translateDefaultNS('eventdetails.'+ tradeHorizon,{'sprintf':{'event_date': eventEndDate}});
		}
	}

	// check if session info is available (Kevin to provide)
	$scope.getSessionUrl = function () {
		var sessionInfo = "";
		if (typeof(window.getSessionInfo) === 'function') {
			sessionInfo = window.getSessionInfo();
		}
		return sessionInfo;
	};



	thisCtrl.GoToUrl = function (link) {
		var url = $scope.$eval($interpolate(link));
		window.location = url + $scope.getSessionUrl();
	};

	$scope.GoToUrlForIE8 = function (link) {
		window.location = link;
	};

	$scope.AddURL = function (link) {
		var url = $scope.$eval($interpolate(link));
		return url + $scope.getSessionUrl();
	};


	$scope.candlestickCheckboxChanged = function () {
		// Save the new always-candlesticks setting
		$scope.saveUserSettings();
	};

	/* ****************************************
	 * "Layer" Section.
	 */

	var data = Platform.data(), whatWeFound;
	if(data.brand === CommonConstants.BRAND.tradnig_central) {
		whatWeFound = Lexicon.translateDefaultNS('eventdetails.what-we-found-' + data.brand);
	}
	else if (data.brand === CommonConstants.BRAND.recognia){
		whatWeFound = Lexicon.translateDefaultNS('eventdetails.what-we-found');
	}
	$scope.layers = [
		{
			icon: "fa fa-list fa-lg",
			page: 'event_details/template_idea.html',
			drawSmallChart: true,
			gaClickEvent: 'click-summary',
			text: whatWeFound
		},
		{
			icon: "fa fa-area-chart fa-lg rtl-exempt-flip",
			page: 'event_details/template_largechart.html',
			gaClickEvent: 'view-large-chart',
			text: Lexicon.translateDefaultNS('eventdetails.largeChart')
		},
		{
			icon: "fa fa-info-circle fa-lg rtl-exempt-flip",
			page: 'company_info/template.html',
			gaClickEvent: 'click-company-info',
			text: Lexicon.translateDefaultNS('eventdetails.companyInformation')
		}
	];

	$scope.findLayer = function (string) {
		var len = $scope.layers.length;

		for (var i = 0; i < len; i++) {
			if ($scope.layers[i].page === string) {
				return $scope.layers[i];
			}
		}
	};


	var regobj = {
		entityId: "EventDetailsCtrl",
		keyData: featured.idea.instrument.latestPrice,
		callbackFunc: function (data) {
			$timeout(function() {
				updatePriceMovement(data.price, data.timestamp);
			}, 0);
		}
	};

	// check whether the user has stream permission or not
	if (typeof featured.idea.instrument.latestPrice.streamable !== 'undefined') {
		LoopHttpCallService.subscribe($scope, 'selectedIdea', 'featured', regobj, CommonConstants.SUBSCRIPTION_TYPE.quote);
	}

	// whenever the active state changes we also need to change the valid state
	// active state will change only the style for the idea ribbon
	// valid state will change visibility for the notification ( This idea is no longer valid. Refresh now to ...)
	$scope.$watch('featured.idea.active', function(newActiveState) {
		// change visibility for notification
		$scope.isValidIdea = newActiveState;
	});

	// Removing large-charts for mobile devices (standalone).
	if (Config.isStandalonePlatform()) {
		largeChartIndex = ($scope.layers.indexOf($scope.findLayer('event_details/template_largechart.html')));
		$scope.layers.splice(largeChartIndex, 1);
	}

	//Removing info-icon for Forex Ideas- for now
	//if(featured.idea.ideaType === CommonConstants.IDEA_TYPE.forex){
	if($scope.isForexIdea(featured)){
		infoIconIndex = ($scope.layers.indexOf($scope.findLayer('company_info/template.html')));
		$scope.layers.splice(infoIconIndex, 1);
	}

	$scope.selectedLayer = $scope.layers[0];

	$scope.layerPage = $scope.layers[0].page;

	$scope.viewSelected = function (layer) {
		$scope.selectedLayer = layer;
		$scope.layerPage = layer.page;
		$scope.backtest_strategy_view = CommonConstants.BackTesting;
	};


	$scope.viewStrategy = function () {
		$scope.layerPage = 'event_details/template_strategy.html';
		$scope.selectedLayer = null;
		$scope.backtest_strategy_view = CommonConstants.StrategyBuilder;
	};

	// functionality for the back button
	thisCtrl.viewBack = function () {
		$scope.selectedLayer = $scope.layers[0];
		$scope.layerPage = $scope.selectedLayer.page;
		$scope.backtest_strategy_view = CommonConstants.BackTesting;
		//keyboard accessibility: when the back button be clicked, move the focus on the company name
		$(company_name_id).focus();

	};

	// Strategy variables section
	$scope.strategyName = "N/A";
	if ($scope.strategy !== null&&$scope.strategy !== undefined) {
		$scope.strategyName = featured.idea.strategy.name || featured.idea.strategy.name.original;

		$scope.strategy_return_percentage = NumberFormatter.percentInTextBlock($scope.featured.idea.strategy.annualisedReturn, 0);
		$scope.strategyPerformanceComments = Lexicon.translateDefaultNS('eventdetails.strategy_performance_comments',

				{'sprintf': {'strategy_return': $scope.strategy_return_percentage}});
		$scope.strategyMatch = Lexicon.translateDefaultNS('eventdetails.strategy-match', {
			'sprintf': {
				'strategy_return': $scope.strategy_return_percentage,
				'strategy_name': $scope.strategyName,
				'percentsign': ''
			}
		});
	};
	$scope.quotedName = Lexicon.translateDefaultNS('eventdetails.quoted-name',
		{'sprintf': {'name': $scope.strategyName}});



	$scope.getMove = function (idea, eventtype) {
		$scope.targetLabel = '';
		$scope.pips = '';
		$scope.micropip = '';
		var move = '';

		if (idea.targetPrice && idea.targetPrice.expectedMove && $scope.isForexIdea(featured)) {
			var forexTarget = NumberFormatter.forexPip(idea.targetPrice.expectedMove, idea.instrument);
			if (eventtype === 1 || eventtype === 0) { // bullish or bearish
				move = forexTarget.sign + forexTarget.pip;
			} else {
				$scope.targetLabel = Lexicon.translateDefaultNS('eventdetails.no-target-upper');
			}
			if (forexTarget.micropip !== "0") {
				$scope.micropip = forexTarget.micropip;
			}
			$scope.pips = Lexicon.translateDefaultNS('eventdetails.pips');
			$scope.targetLabel = Lexicon.translateDefaultNS('eventdetails.target');
		} else if (idea.targetPrice && idea.targetPrice.percentageMove) {
			if (eventtype === 1) { // bullish
				move = NumberFormatter.percentWithSign(idea.targetPrice.percentageMove, 0);
			} else if (eventtype === 0) { // bearish
				move = NumberFormatter.percentWithSign(-1 * idea.targetPrice.percentageMove, 0);
			} else {
				$scope.targetLabel = Lexicon.translateDefaultNS('eventdetails.no-target-upper');
			}
			$scope.targetLabel = Lexicon.translateDefaultNS('eventdetails.target');
		}
		return move;
	};

	$scope.refreshIdeas = function(){
		Broadcast.sendSettingsChangedMessage();
	}
	$scope.isValidIdea = $scope.featured.idea.active;
	//only watched idea has watched bar time
	$scope.isWatchedIdea = $scope.featured.idea.watchedBarTime;

	$scope.priceChartParams = {

		source: featured.idea.events[0],
		targetPrice: featured.idea.targetPrice,
		instrument: featured.idea.instrument,
		type: ChartConfig.Type.Candlestick,
		showTooltip: true,
		chartTopSpacing: 30,
		disablePanning: true,
		enabled: false,

		chartMarkers: [
			ChartConfig.MarkersList.EventName,
			ChartConfig.MarkersList.LastPrice,
			//			ChartConfig.MarkersList.EventClosePrice,
			ChartConfig.MarkersList.EventTargetPrice,
			ChartConfig.MarkersList.VolumeName,
			ChartConfig.MarkersList.TargetProfit
		],

		eventMarkup: [
			//			ChartConfig.EventMarkup.Region,
			ChartConfig.EventMarkup.InboundTrendLines,
			ChartConfig.EventMarkup.EventMarker
		],
		series: [
			{
				series: ChartConfig.Series.Price,
				type: ChartConfig.Type.Candlestick,
				height: ( $scope.featured.idea.ideaType === CommonConstants.IDEA_TYPE.option ) ? 154 : 174
			},
			{
				series: ChartConfig.Series.Volume,
				type: ChartConfig.Type.Bar,
				height: ( $scope.featured.idea.ideaType === CommonConstants.IDEA_TYPE.option ) ? 40 : 50
			}
		]
	};

	$scope.largeChartParams = {

		source: featured.idea.events[0],
		targetPrice: featured.idea.targetPrice,
		instrument: featured.idea.instrument,
		type: ChartConfig.Type.Candlestick,
		showTooltip: true,
		showNavigator: {
			enabled: true,
			height: 24
		},
		chartTopSpacing: 30,

		enabled: true,

		chartMarkers: [
			ChartConfig.MarkersList.EventName,
			ChartConfig.MarkersList.LastPrice,
			//			ChartConfig.MarkersList.EventClosePrice,
			ChartConfig.MarkersList.EventTargetPrice,
			ChartConfig.MarkersList.VolumeName
//            ChartConfig.MarkersList.TargetProfit // do not draw this for large chart for now.
		],

		eventMarkup: [
			//			ChartConfig.EventMarkup.Region,
			ChartConfig.EventMarkup.InboundTrendLines,
			ChartConfig.EventMarkup.EventMarker
		],
		series: [
			{
				series: ChartConfig.Series.Price,
				type: ChartConfig.Type.Candlestick,
				height: 211
			},
			{
				series: ChartConfig.Series.Volume,
				type: ChartConfig.Type.Bar,
				height: 50
			}
		]
	};

	REST.User().success(function (response) {
		$scope.permission = response.result.permissions;
		$scope.symbolsIncludeExchange = response.result.client.symbolsIncludeExchange;
		$scope.symbolsIncludeExchangeExceptions = response.result.client.symbolsIncludeExchangeExceptions;
	});

	$scope.$watch('featured.enabled', function (newValue) {

		if (newValue !== true) {
			return;
		}

		/*
		 Listing Criteria (Strategy)
		 */
		$scope.getCriteria = function (criteriaTag) {
			var returnString;
			$scope.criteriaTag = criteriaTag;
			/*
			 TODO:
			 *  $scope.type = Refer to the type that the number formatter would use (e.g, volume, currency);
			 */

			CriteriaApi.getData(function (criteriaAPI) {
				if (criteriaAPI.criteria[criteriaTag.id] !== undefined) {
					$scope.criteriaTag.name = criteriaAPI.criteria[criteriaTag.id].name;
				}
			});

			// Lexicon value for Events
			if ((criteriaTag.id === CriteriaConstants.event || criteriaTag.id === CriteriaConstants.bullishClassic ||
					criteriaTag.id === CriteriaConstants.bearishClassic || criteriaTag.id === CriteriaConstants.bearishShortTerm ||
					criteriaTag.id === CriteriaConstants.bullishShortTerm || criteriaTag.id === CriteriaConstants.bullishIndicatorsOscillators ||
					criteriaTag.id === CriteriaConstants.bearishIndicatorsOscillators) && criteriaTag.refine.length !== 0 && criteriaTag.refine[0].values.length !== 0) {
				returnString = EventFormatter.process(criteriaTag.refine[0].values);
			}

			// Lexicon Options
			else if (criteriaTag.id === CriteriaConstants.options && criteriaTag.values.length !== 0) {
				returnString = BooleanFormatter.process(criteriaTag.values[0]);
			}

			// Lexicon value for Exchanges
			else if (criteriaTag.id === CriteriaConstants.exchangeSymbol && criteriaTag.values.length !== 0) {
				returnString = criteriaTag.values[0]; // Lexicon to be Added
			}

			// Lexicon value for Issue Type
			else if (criteriaTag.id === CriteriaConstants.issueType && criteriaTag.values.length !== 0) {
				returnString = $scope.$eval($interpolate(Lexicon.translateDefaultNS('criteria.' + criteriaTag.values[0])));
			}

			// Lexicon value for Sector Ids
			else if (criteriaTag.id === CriteriaConstants.sectorId && criteriaTag.values.length !== 0) {
				returnString = SectorFormatter.process(criteriaTag.values);
			}

			// Lexicon value for 90 day volume
			else if (criteriaTag.id === CriteriaConstants.volume90DayAvg) {
				returnString = $scope.$eval($interpolate(Lexicon.translateDefaultNS('operators.' + criteriaTag.operator+ '-integer')));
			}

			else {
				// Lexicon value for Criteria Operator (e.g between, ge, lt). non-event types
				returnString = $scope.$eval($interpolate(Lexicon.translateDefaultNS('operators.' + criteriaTag.operator)));
			}
			return returnString;
		};

		$scope.criteria = null;
		if (featured.idea.strategy !== null && featured.idea.strategy !== undefined) {
			$scope.criteria = JsonUtil.objArrayToDict(featured.idea.strategy.criteria.values, "id");
		};

		var promiseList = [
			REST.User(),
			Platform.data()
		];

		// Check user permissions for eventLookup, valueLookup, strategyBuilder
		$q.all(promiseList).then(function (responses) {
			var valueAnalyzer = responses[0].data.result.permissions.products.valueAnalyzer,
					strategyBuilder = responses[0].data.result.permissions.products.strategyBuilder,
				featuredStocks = responses[0].data.result.permissions.products.featuredStocks;

			$scope.uri = responses[1].uri;
			if ($scope.uri !== undefined && $scope.uri !== null) {
				try {
					// Additional parameters on a client by client basis
					$scope.userParameters = ClientServices.getUserParameters();

					// Creating Scope variable to point to the HostedWebsite Service
					$scope.HostedWebsite = HostedWebsite;
					if (featuredStocks === true && $scope.uri.eventLookup !== undefined && $scope.uri.eventLookup.length > 0 &&
							$scope.uri.eventLookup[0].uri !== undefined && $scope.uri.eventLookup[0].uri !== '') {
						var showEventLookupButton = new Function ('return ' + $scope.$eval($interpolate($scope.uri.eventLookup[0].show)));
						if (showEventLookupButton()) {
							$scope.eventLookupHyperlink = $scope.$eval($interpolate($scope.uri.eventLookup[0].uri));
						}
					}
					if (valueAnalyzer === true && $scope.uri.valueLookup !== undefined && $scope.uri.valueLookup !== null && $scope.uri.valueLookup.length > 0 &&
							$scope.uri.valueLookup[0].uri !== undefined && $scope.uri.valueLookup[0].uri !== '') {
						var showValueLookupButton = new Function ('return ' + $scope.$eval($interpolate($scope.uri.valueLookup[0].show)));
						if (showValueLookupButton()) {
							thisCtrl.valueAnalyzerHyperlink = $scope.$eval($interpolate($scope.uri.valueLookup[0].uri));
						}
					}
					if (strategyBuilder === true && $scope.uri.strategyBuilder !== undefined && $scope.uri.strategyBuilder.length > 0 &&
							$scope.uri.strategyBuilder[0].uri !== undefined && $scope.uri.strategyBuilder[0].uri !== '') {
						var showStrategyBuilderButton = new Function ('return ' + $scope.$eval($interpolate($scope.uri.strategyBuilder[0].show)));
						if (showStrategyBuilderButton()) {
							$scope.strategyBuilderHyperlink = $scope.$eval($interpolate($scope.uri.strategyBuilder[0].uri));
						}
					}
				}
				catch (err) {
					console.warn(err);
				}
			}
		});


		$scope.initializeModal = function (index) {
			$scope.modalLayer = "compare_alternatives/template.html";
			$scope.selectedTradeIdeaIndex = index;
		};

		// Methods for the alternative trades modal to get/set the alternative that was clicked.
		// If it accessed them directly, then it would be accessing its own scope's copy, and wouldn't
		// get the right selection after being dismissed and re-opened.
		$scope.getSelectedTradeIdea = function () {
			return $scope.comparableIdeas[$scope.selectedTradeIdeaIndex];
		};
		$scope.setSelectedTradeIdea = function (idea) {
			var i;
			for (i = 0; i < $scope.comparableIdeas.length; i++) {
				if ($scope.comparableIdeas[i] === idea) {
					$scope.selectedTradeIdeaIndex = i;
					break;
				}
			}
		};

		// Check if given idea has target or not
		$scope.callNoTarget = function (featured) {
			return HasNoTarget.process(featured.idea);
		};

		// Enable the highchart
		$scope.priceChartParams.enabled = true;

		// Content is specific to options
		if (featured.idea.ideaType === CommonConstants.IDEA_TYPE.option) {

			var tradeToPost;
			featured.idea.perShareValues = OptionsStrategy.getPerShareValues(featured.idea.trade);
			$scope.comparableIdeas = [featured];

			// TODO Remove this once options ideas come from ideas service
			if (featured.earliestExpiryDate === undefined) {
				featured.earliestExpiryDate = DateFormatter.formatDate(
						DateFormatter.parseISO8601(OptionsStrategy.getEarliestExpiryDate(featured.idea.trade.legs)),
						'short'
				);
			}

			// Options Strategy Translation
			$scope.optionsStrategyIdDescription = Lexicon.translateDefaultNS('eventdetails.' + featured.idea.trade.tradeStrategy.strategyId + '-description');

			if ($scope.selectedProduct === CommonConstants.VIEW.options) {
				tradeToPost = angular.copy(featured.idea.trade);  // Trade to post

				// Collapse "company","exchange" & "fundamentals" for marriedPut & buyWrite
				if (featured.idea.trade.legs.instrument) {
					var collapse = {};
					var omitKeys = {latestPrice: 'latestPrice'};
					collapse = JsonUtil.collapse(collapse, tradeToPost.legs.instrument.instrument, omitKeys);
					tradeToPost.legs.instrument.instrument = collapse;
				}

				/***************************/
				/* BEGIN MODAL INFORMATION */
				/***************************/

				// Make API Call for alternate trades
				optionAPICalls = [
					REST.alternativeTrades(featured.idea.alternativeTrades, tradeToPost)
				];
				$q.all(optionAPICalls).then(function (responses) {

					responses[0].data.result.trades.forEach(
							function (trade) {
								var aTuple = {"idea": null, "criteria": null};
								aTuple.idea = angular.copy(featured.idea);
								aTuple.idea.trade = angular.copy(trade);
								aTuple.idea.perShareValues = OptionsStrategy.getPerShareValues(aTuple.idea.trade);
								aTuple.criteria = $scope.criteria;
								aTuple.earliestExpiryDate = DateFormatter.formatDate(
										DateFormatter.parseISO8601(OptionsStrategy.getEarliestExpiryDate(aTuple.idea.trade.legs)),
										'short'
								);
								aTuple.tagsMatched = [];
								$scope.comparableIdeas.push(aTuple);
							}
					);
					$scope.emptyCompareRows = new Array(($scope.comparableIdeas.length < 4) ? (4 - $scope.comparableIdeas.length) : 0);
					thisCtrl.noAlternativeIdeas = ($scope.comparableIdeas.length === 1);
					/**************************/
					/* END MODAL INFORMATION */
					/************************/
				});
			}
		}
	});

	//keyboard accessibility: during the init period only show the first idea.
	$scope.$on('onRepeatLast', function () {

        for (var j = 0; j < $scope.ideaLength; j++) {
			$("#event-details-" + j).hide();
		}
		//$("#event-details-" + 0).show();

        $('[id*="event-details-"]').first().show();

	});

	var company_name_id = "#instrument-name-" + $scope.ideaId;

	function commentaryFormatter(text,precision) {
		var FILTER_FACTORY = {
			criterionValue: 'criterionValue:criteriaTag.values[0]:' + precision,
			formatCurrency: 'formatCurrency:' + precision
		};

		Object.keys(FILTER_FACTORY).forEach(function (filterName) {
			text = text.replace(new RegExp(filterName, 'g'), FILTER_FACTORY[filterName]);
		});

		return text;
	}
}]);

'use strict';

recogniaApp.controller('IdeaController',
['$scope', '$compile', '$templateCache', 'Lexicon', 'OptionsIdeasScore', 'NumberFormatter', 'CommonConstants', '$interpolate', 'Ideas','Platform','DateFormatter',
function ($scope, $compile, $templateCache, Lexicon, OptionsIdeasScore, NumberFormatter, CommonConstants, $interpolate, Ideas, Platform, DateFormatter) {
	$scope.targetPercentageTooltip = Lexicon.translateDefaultNS('fsTarget.target_percentage_tooltip');
	/*
	 * Option Target Data
	*/
	// Retrieve brand from Platform API
	var data = Platform.data();
	if(data.brand === CommonConstants.BRAND.tradnig_central) {
		$scope.whatFound = Lexicon.translateDefaultNS('eventdetails.what-we-found-' + data.brand);
	}
	else if (data.brand === CommonConstants.BRAND.recognia){
		$scope.whatFound = Lexicon.translateDefaultNS('eventdetails.what-we-found');
	}


	if ($scope.featured.idea.ideaType === CommonConstants.IDEA_TYPE.option){
		var precision = $scope.featured.idea.instrument.precision;
		var strategyId = $scope.featured.idea.trade.tradeStrategy.strategyId;
		$scope.targetProfit = NumberFormatter.percentInTextBlock($scope.featured.idea.trade.targetProfitPercent, 0);
		$scope.targetPrice = NumberFormatter.formatCurrency(Ideas.getConservativeTargetPrice($scope.featured.idea),precision);
		$scope.targetProfitAbsolute = NumberFormatter.formatCurrency($scope.featured.idea.trade.targetProfit,precision);
		$scope.maxLoss = NumberFormatter.formatCurrency($scope.featured.idea.trade.maxLoss,precision);
		$scope.maxLossPercent = NumberFormatter.percentInTextBlock($scope.featured.idea.trade.maxLossPercent, 0);
		$scope.legs = $scope.featured.idea.trade.legs;
		$scope.zeroPrice = NumberFormatter.formatCurrency(0.00,precision);
		/* ********************************
		 * BEGIN Scoring info and tooltip
		 */

		$scope.scoreHeading = Lexicon.translateDefaultNS('fsTarget.score_header', {
			context: $scope.featured.idea.trade.scoreGrade.toLowerCase()
		});

		// TODO should use AngularStrap or something when we go to Angular v1.2+
		// making html by string joining is BAD
		// have to do this because we don't have a tooltip directive that can take a template for content
		$scope.justificationList = OptionsIdeasScore.getScoreJustificationList($scope.featured.idea)
			.reduce(function (result, justification){
				return [result, '<li>', justification, '</li>'].join('');
			}, '');

		$scope.newTooltip = $interpolate($templateCache.get( 'event_details/template_scorer_tooltip.html') )($scope);

		/*
		 * END Scoring info and tooltip
		 ******************************* */
		$scope.maxLossTooltip = $scope.$eval($interpolate(Lexicon.translateDefaultNS('fsTarget.max_loss_tooltip_'+strategyId)));
		$scope.targetProfitTooltip = $scope.$eval($interpolate(Lexicon.translateDefaultNS('fsTarget.target_profit_tooltip_'+strategyId)));

		/**
		 * Chart Parameters
		 */
		$scope.profitAndLossChartParams ={
			featured: $scope.featured
		};
	}

	$scope.isBullish = function (idea){
		var bullish = CommonConstants.EVENT_TYPE.bullish;
		return Ideas.findIdeaType(idea) === bullish;
	};


	$scope.isBearish = function (idea){
		var bearish = CommonConstants.EVENT_TYPE.bearish;
		return Ideas.findIdeaType(idea) === bearish;

	};

    $scope.$on(Ideas.action($scope.idea.linkId).WATCHING,function(event,watchedBarTime){
        showWatchedBarTimeInfoFunc(watchedBarTime.value);
    });

    $scope.$on(Ideas.action($scope.idea.linkId).UNWACTHING,function(){
        $scope.showWatchedBarTimeInfo = false;
    });

	var showWatchedBarTimeInfo = CommonConstants.WATCHED_IDEAS_TYPE.hasOwnProperty($scope.selectedProduct);
	$scope.showWatchedBarTimeInfo = showWatchedBarTimeInfo;
	if(showWatchedBarTimeInfo) {
		$scope.watchedBarTimeInfo = getWatchBarTimeInfo($scope.featured.idea.watchedBarTime);
	}
    else {
        var isWatched = Ideas.watched($scope.idea.ideaType).isWatched({'idea' :$scope.idea});
        if(isWatched){
            var watchedBarTime = Ideas.watched($scope.idea.ideaType).getWatchedTime({'idea' :$scope.idea});
            showWatchedBarTimeInfoFunc(watchedBarTime);
        }
    }

    function showWatchedBarTimeInfoFunc(watchedBarTime){
        if(typeof watchedBarTime === 'undefined'){
            return;
        }
        $scope.showWatchedBarTimeInfo = true;
        $scope.watchedBarTimeInfo = getWatchBarTimeInfo(watchedBarTime);
    }

    function getWatchBarTimeInfo(watchedBarTime){
        var bundleKey = ($scope.selectedProduct === CommonConstants.WATCHED_IDEAS_TYPE.watchedForex || $scope.selectedProduct === CommonConstants.VIEW.forex)
            ? 'common.watched-idea-stop-info-watchedForex' : 'common.watched-idea-stop-info';
		if (watchedBarTime === null) {
			return "";
		}

        return Lexicon.translateDefaultNS(bundleKey,{
            'sprintf': {
                "watchedBarDate" : DateFormatter.formatDate(DateFormatter.parseDate(watchedBarTime), 'short'),
                "watchedBarTime" : DateFormatter.formatTime(watchedBarTime, true)
            }
        });
    }
}]);

/**
 * Created by Hosam on 2/27/2014.
 */
'use strict';

recogniaApp.controller('LargeChartController',
[
function () {
	// Left empty as it inherits from the parent controller
	// TODO the parent controller should be refactored and split the functionality among the three child controllers

}]);

'use strict';

recogniaApp.controller('EventDetailsStrategyCtrl',
['$scope', 'Lexicon',
function ($scope, Lexicon) {

	var idea = $scope.featured.idea;

	$scope.backtestChartParams = {
		source: idea.strategy,
		height: 250,
		title: 'eventdetails.historical_return'
	};

	$scope.backtestChartParams.title = Lexicon.translateDefaultNS($scope.backtestChartParams.title);

	$("#fs-button-back").focus();
}]);

'use strict';

recogniaApp.controller('NavCtrl',
['$scope', 'Lexicon', 'NumberFormatter', 'OptionsStrategy', 'HasNoTarget', 'CommonConstants','Config','Ideas',
function ($scope, Lexicon, NumberFormatter, OptionsStrategy, HasNoTarget, CommonConstants,Config, Ideas) {

	$scope.showTargetLabel = false;

	$scope.targetLabel = Lexicon.translateDefaultNS('eventdetails.target');

	$scope.bullishLexicon = Lexicon.translateDefaultNS('eventdetails.bullish').toUpperCase();

	$scope.bearishLexicon = Lexicon.translateDefaultNS('eventdetails.bearish').toUpperCase();

	$scope.isSelectedIdea = function (featured) {
		return $scope.selectedIdea === featured;
	};

	$scope.isOptionsIdea = function (featured) {
		return featured.idea.ideaType === CommonConstants.IDEA_TYPE.option;
	};

	$scope.ideaTypes = [];
	$scope.$watch('ideas', function () {
		if (typeof($scope.ideas) === "undefined") {
			return;
		}
		$scope.ideaTypes = [];
		for (var index=0; index<$scope.ideas.length; index+=1) {
			$scope.ideaTypes.push($scope.ideas[index].idea.ideaType);
		}
	});

	$scope.setRibbonPosition = function(position, suppressAnimation) {
		var maxPosition = $('#en-widget-inner').width() - $('#en-widget-outer').width();
		if (position < 0) {
			position = 0;
		}
		if (position > maxPosition) {
			position = maxPosition;
		}
		if (suppressAnimation) {
			$('#en-widget-outer').scrollLeft(position);
		}
		else {
			$('#en-widget-outer').animate({scrollLeft: position}, 500);
		}
		$scope.ribbonPosition = position;
	};

	// Ensure that the selected idea is visible in the ribbon when selection changes
	// (i.e. when the user swipes left or right to change selection without using
	// the ribbon in mobile)
	$scope.$watch('selectedIdea', function() {
		// Get index of newly selected idea

		if (typeof($scope.ideas) == "undefined") {
			return;
		}
		var index;
		var found = false;
		for (index = 0; index < $scope.ideas.length; index++) {
			if ($scope.ideas[index] === $scope.selectedIdea) {
				found = true;
				break;
			}
		}
		if (!found) {
			// Something went wrong
			return;
		}

		// Get horizontal pixel position of selected idea in ribbon
		var outerWidget = $('#en-widget-outer'),
			innerWidget = $('#en-widget-inner');
		var selectionWidth = $(innerWidget.children()[index]).width();
		var offset = 0;
		for (var i = 0; i < index; i++) {
			offset += $(innerWidget.children()[i]).width();
			offset += 3;  // space between elements
		}

		// If we are in a right-to-left language, index 0 is rightmost idea, so we've calculated the offset from
		// the right end. Convert to offset from left.
		if (!$scope.ltr) {
			offset = innerWidget.width() - offset - selectionWidth;
		}

		// Check if both edges of the selected idea box are in the visible area of the ribbon
		if (offset < outerWidget.scrollLeft()) {
			// Left edge of selection is outside the left side of the viewable area
			$scope.setRibbonPosition(offset);
		}
		else if (outerWidget.scrollLeft() + outerWidget.width() < offset + selectionWidth) {
			// Right edge of selection is outside the right side of the viewable area
			$scope.setRibbonPosition(offset + selectionWidth - outerWidget.width());
		}

	}, false); // false => only watch for changes in reference equality

	$scope.getFirstTradeProfit = function (idea) {
		return NumberFormatter.percent(idea.trade.targetProfitPercent, 0);
	};

	$scope.getMove = function (idea) {
		$scope.showTargetLabel = false;
		$scope.micropip = '';
		var move = '';

		if (!HasNoTarget.process(idea)) {
			$scope.showTargetLabel = true;
			if (isForexIdea(idea)) {
				var forexTarget = NumberFormatter.forexPip(idea.targetPrice.expectedMove, idea.instrument);
				move = forexTarget.sign + forexTarget.pip;
				if (forexTarget.micropip !== "0") {
					$scope.micropip = forexTarget.micropip;
				}
			} else {
				if ($scope.isBullish(idea)) {
					move = NumberFormatter.percentWithSign(idea.targetPrice.percentageMove, 0);
				} else {
					move = NumberFormatter.percentWithSign(-1*idea.targetPrice.percentageMove, 0);
				}
			}
		}
		return move;
	};

	$scope.callNoTarget = function (featured) {
		return HasNoTarget.process(featured.idea);
	};

	if(Config.getPageDirection().ltr){
		$scope.ltr = true;
	}else{
		$scope.ltr = false;
	}

	$scope.isBullish = function (idea){
		return Ideas.findIdeaType(idea) === CommonConstants.EVENT_TYPE.bullish;
	};

	$scope.isBearish = function (idea){
		return Ideas.findIdeaType(idea) === CommonConstants.EVENT_TYPE.bearish;
	};

	$scope.getIdeaType = function(idea){
		return Ideas.findIdeaType(idea);
	};

	function isForexIdea (idea) {
		return idea.ideaType === CommonConstants.IDEA_TYPE.forex;
	};

}]);

'use strict';

recogniaApp.controller('FollowedComponentCtrl',
['$scope', 'REST', 'Lexicon', 'Config', 'KeyCode', 'LegacyApi', 'HostedWebsite', 'DateFormatter',
function ($scope, REST, Lexicon, Config, KeyCode, LegacyApi, HostedWebsite, DateFormatter) {
	$scope.followedShowText = '';
	$scope.showAll = false;
	$scope.showAddInstrument = false;
	$scope.showEditInstrument = false;
	$scope.showAddEditDialogue = false;
	$scope.add = {
		dateFormat: HostedWebsite.programmingFieldValue('DateFormat'),
		maxDate: HostedWebsite.programmingFieldValue('TodayDate')
	};
	$scope.text = {};

	$scope.edit = {
		dateFormat: HostedWebsite.programmingFieldValue('DateFormat')
	};

	$("#input-datepicker").focusout(function() {
		$scope.add.date = $("#input-datepicker").val();
	});

	$scope.text.bullish =  Lexicon.translateDefaultNS('technicalinsight.followed-bullish');
	$scope.text.bearish =  Lexicon.translateDefaultNS('technicalinsight.followed-bearish');
	$scope.text.help = Lexicon.translateDefaultNS('technicalinsight.help-hover-instruments-im-following', {
		'sprintf': {'link': HostedWebsite.pageUrl('panel_instruments_guide') }
	});
	$scope.upText = Lexicon.translateDefaultNS('technicalinsight.up');
	$scope.downText = Lexicon.translateDefaultNS('technicalinsight.down');
	$scope.sampleDateFormat = DateFormatter.getSampleDateFormat();

	/* load list of followed instruments */
	function loadInstruments() {
		LegacyApi.api('userfollowedinstruments', Config.getLegacyApiParameters()).success(function (data) {
			if (!data.pri || data.pri.list === null) {
				$scope.fakeFollowedDataAll = [];
			} else {
				$scope.fakeFollowedDataAll = data.pri.list;
			}
			$scope.fakeFollowedData = $scope.fakeFollowedDataAll.slice(0,5);

			if ($scope.fakeFollowedDataAll.length <= 5) {
				$scope.showAll = false;
				$scope.followedShowText = '';
			} else if ($scope.followedShowText === '') {
				$scope.showAll = false;
				$scope.followedShowText = Lexicon.translateDefaultNS('technicalinsight.spotlight-show-all');
			}
		});
	}
	loadInstruments();


	function instrumentLookup(symbol, exchange, callback) {
		HostedWebsite.instrumentDetails(symbol, exchange.exchange, exchange.type, function(data) {
			$scope.add.instruments = data;
			if (typeof callback !== 'undefined') {
				callback(data.length === 1);
			}
		});
	}

	// Watch the instrument select for changes
	$scope.$on('exchangeChanged', function(e, exchange) {
		$scope.add.exchange = exchange;
		e.stopPropagation();
	});
	$scope.$on('symbolChanged', function(e, symbol) {
		$scope.add.symbol = symbol;
		e.stopPropagation();
	});
	$scope.$on('search', function(e, symbol, exchange) {
		// Find the requested instrument
		instrumentLookup(symbol, exchange);
		e.stopPropagation();
	});

	// Show the add followed instrument dialogue
	$scope.addInstrumentDialog = function() {
		// reset all the visible fields
		$scope.$broadcast('reset');
		$scope.add.date = HostedWebsite.programmingFieldValue('TodayDate');
		$scope.add.instruments = null;
		$scope.add.message = null;
		$scope.add.note = '';
		$scope.add.view = 'L';
		$scope.showAddInstrument = true;
		$scope.showEditInstrument = false;
		$scope.addEditFocus = '#focusId';
		$scope.showAddEditDialogue = true;
	};

	// Show the edit followed instrument dialogue
	$scope.editInstrumentDialog = function(element) {
		// reset all the visible fields
		$scope.$broadcast('reset');
		// share some elements with the add code
		$scope.add.view = element.opinion;
		$scope.add.date =  element.base_timestamp;
		$scope.add.message = null;
		$scope.add.note = element.note;

		$scope.edit.fid =  element.id;
		$scope.edit.date =  $scope.getFollowedInstrumentsDate(element.base_timestamp);
		$scope.edit.companyName = element.instrument.name;
		$scope.edit.symbol = element.instrument.symbol_DISPLAY;
		$scope.edit.exchangeSymbol = element.instrument.exchange_symbol_DISPLAY;
		$scope.edit.opinion = element.opinion;
		// get the bullish/beaish text
		if (element.opinion === "L"){
			$scope.edit.viewText = $scope.text.bullish;
		} else if (element.opinion === "S")  {
			$scope.edit.viewText = $scope.text.bearish;
		}
		// set the dialog state variables
		$scope.showEditInstrument = true;
		$scope.showAddInstrument = false;
		$scope.addEditFocus = '#node-textarea';
		$scope.showAddEditDialogue = true;
	};

	// Handle key-presses on edit icon
	$scope.editKeyPress = function($event, followed) {
		if ($event.keyCode === KeyCode.ENTER || $event.charCode === KeyCode.SPACE) {
			$scope.editInstrumentDialog(followed);
		}
	};

	// Add a new followed instrument
	$scope.addInstrument = function () {
		instrumentLookup($scope.add.symbol, $scope.add.exchange, function (success) {
			//reset date input field
			$scope.add.message = null;
			//check the string length if  it is above or below 10 and the format
			if($scope.add.date.length!==10||!DateFormatter.isVaildFormat($scope.add.date,$scope.add.dateFormat)){
				$scope.add.message = Lexicon.translateDefaultNS('technicalinsight.followed-dialog-invalid-date');
				return;
			}
			var choosedate = DateFormatter.fetchDateForDifferentFormat($scope.add.date,$scope.add.dateFormat);
			//check the date is valid or not based on different client data format
			var valid = DateFormatter.isValidDate(choosedate.substring(0,4),choosedate.substring(5,7),choosedate.substring(8,10));
			if(!valid){
				$scope.add.message = Lexicon.translateDefaultNS('technicalinsight.followed-dialog-invalid-date');
				return;
			}
			var maxdate = DateFormatter.fetchDateForDifferentFormat($scope.add.maxDate,$scope.add.dateFormat);

			//Create a new date because safari do not date support format (YYYY-MM-DD)
			maxdate = new Date(maxdate.substring(0,4),maxdate.substring(5,7)-1,maxdate.substring(8,10));
			choosedate =  new Date(choosedate.substring(0,4),choosedate.substring(5,7)-1,choosedate.substring(8,10));
			if(choosedate>maxdate){
				$scope.add.message = Lexicon.translateDefaultNS('technicalinsight.followed-dialog-invalid-date_beyond_today');
				return ;
			}

			// Convert format of the date that is compatible with legacy API
			var apiDate = DateFormatter.convertDateToLegacyApiFormat(
				DateFormatter.parseDateWithFormat($scope.add.dateFormat, $scope.add.date)
			);

			if (success) {
				LegacyApi.api('followedinstrumentadd',
						'iid=' + $scope.add.instruments[0].Id +
						'&tty=' + $scope.add.view +
						'&bts=' + apiDate +
						'&nte=' + encodeURIComponent($scope.add.note) +
						'&_xsl_id=asjson'
				).success(function (data) {
						if (data.pri.status === 'ok') {
							$scope.showAddEditDialogue = false;
							$scope.showAddInstrument = false;
							loadInstruments();
						} else if (data.pri.status === 'exists') {
							$scope.add.message = Lexicon.translateDefaultNS('technicalinsight.already-submitted');
						} else if (data.pri.status === 'failed') {
							$scope.add.message = data.pri.header.errors.parameter.message;
						}
					});
			}
		});
	};

	// Add a new followed instrument
	$scope.saveFollowedInstrument = function() {
		LegacyApi.api('followedinstrumentupdate',
				'fid=' + $scope.edit.fid +
					'&editable_instrument=0' +
					'&editable_direction=0'  +
					'&tty=' + $scope.add.view +
					'&bts=' + $scope.add.date +
					'&nte=' + encodeURIComponent($scope.add.note) +
					'&_xsl_id=asjson'
			).success(function (data) {
				if (data.pri.status === 'ok') {
					$scope.showAddEditDialogue = false;
					$scope.showEditInstrument = false;
					loadInstruments();
				} else if (data.pri.status === 'failed') {
					$scope.add.message = data.pri.header.errors.parameter.message;
				}
			});
	};

	// delete a followed instrument when user clicks the trash icon next to symbol
	$scope.deleteFollowedInstrument = function(fid) {
		var fid_param = 'fid=' + fid;
		LegacyApi.api('followedinstrumentdelete', fid_param).success(function () {
			// if the delete call is successful, the reload the followed instruments which will remove the deleted entry
			loadInstruments();
			$('a[id="add_instrument_id"]').focus();
		});
	};

	// Handle key-presses on trash icon
	$scope.deleteKeyPress = function($event, followed_id) {
		if ($event.keyCode === KeyCode.ENTER || $event.charCode === KeyCode.SPACE) {
			$scope.deleteFollowedInstrument(followed_id);
		}
	};



	//Get all the instruments that should be shown
	$scope.getShownInstruments = function() {
		if($scope.showAll) {
			return $scope.fakeFollowedDataAll;
		}
		return $scope.fakeFollowedData;
	};

	//Toggles the show button
	$scope.toggleShow = function() {
		if ($scope.showAll) {
			$scope.showAll = false;
			$scope.followedShowText = Lexicon.translateDefaultNS('technicalinsight.spotlight-show-all');
		} else {
			$scope.showAll = true;
			$scope.followedShowText = Lexicon.translateDefaultNS('technicalinsight.spotlight-show-less');
		}
	};

	//Get face icon for followed instrument panel
	$scope.getFaceIcon = function(percentMove,opinion) {
		var faceIcon = 'fa fa-meh-o';
		if (opinion === "S") {
			percentMove *= -1;
		}

		if (percentMove > 5) {
			faceIcon = 'fa fa-smile-o ti-following-instrument-status-icon-hightlight';
		} else if (percentMove < -5) {
			faceIcon = 'fa fa-frown-o ti-following-instrument-status-icon-hightlight';
		} else if (percentMove >= 1) {
			faceIcon = 'fa fa-smile-o';
		} else if (percentMove <= -1) {
			faceIcon = 'fa fa-frown-o';	
		}

		return  faceIcon;
	};

	$scope.getTradeTypeText = function(tradeType) {
		var tradeText = '';
		if (tradeType === 'L') {
			tradeText =  $scope.text.bullish;
		} else if (tradeType === 'S') {
			tradeText =  $scope.text.bearish;
		} else  {
			tradeText = '';
		}
		return  tradeText;
	};

	$scope.getMove = function(percentageMove) {
		var move = Math.round(percentageMove);

		var moveString = '';

		//Must fix this to do this in the Lexicon file instead
		if (move < 0) {
			moveString = $scope.downText + ' ' + Math.abs(move) + '%';
		} else {
			moveString = $scope.upText + ' ' + move + '%';
		}

		return moveString;
	};

	$scope.getFollowedInstrumentsDate = function(timestamp) {
		var followedDate = DateFormatter.parseLegacyDate(timestamp);
		return DateFormatter.formatDate(followedDate,"none");
	};

	$scope.checkElements=function() {
		if ($scope.fakeFollowedDataAll === undefined || $scope.fakeFollowedDataAll === null || $scope.fakeFollowedDataAll.length === 0) {
			return false;
		} else {
			return true;
		}
	};

	REST.User().success(function(response){
		$scope.symbolsIncludeExchange = response.result.client.symbolsIncludeExchange;
		$scope.symbolsIncludeExchangeExceptions = response.result.client.symbolsIncludeExchangeExceptions;
	});

	$scope.displayExchanges = function(exchange) {

		if ($scope.symbolsIncludeExchange === true) {
			for (var index=0; index<$scope.symbolsIncludeExchangeExceptions.length; index++) {
				if ($scope.symbolsIncludeExchangeExceptions[index] === exchange) {
					return true;
				}
			}
			return false;
		}
		return true;
	};
}]);

'use strict';

recogniaApp.controller('InstrumentActionCtrl',
['$scope', 'REST', '$interpolate', 'ClientServices', 'Lexicon','Platform',
function ($scope, REST, $interpolate, ClientServices, Lexicon, Platform) {
	$scope.actions = [];
	$scope.dropdowActions = {};

	$scope.userParameters = ClientServices.getUserParameters();

	var data = Platform.data();
	if (data.uri !== undefined && data.uri !== null) {
		try {
			if (data.uri.instrumentActions !== undefined &&
				data.uri.instrumentActions.length > 0 &&
				data.uri.instrumentActions[0].uri !== undefined &&
				data.uri.instrumentActions[0].uri !== '') {

				$scope.actions = data.uri.instrumentActions;

				//skip the instrumentActions that are not allowed to show trade button
				$scope.actionOptions = [];
				for(var i=0;i<$scope.actions.length;i++){
					var showButton = new Function ('return ' + $scope.$eval($interpolate($scope.actions[i].show)));
					if(showButton()){
						$scope.actionOptions.push(angular.copy($scope.actions[i]));
					}
				}

				// Get options uri and replace it with computed uri
				$scope.actionOptions.forEach(function(option){
					if (option !== undefined) {

						// TODO need a database change script to update these keys
						// instead of of doing a string replace here
						var lexiconKey = option.titleLexicon.replace(':', '.');
						option.title = Lexicon.translateDefaultNS(lexiconKey);

						try {
							option.uri = $scope.$eval($interpolate(option.uri)) + $scope.getSessionUrl();
						}
						catch(e){
							// This only means the passed string doesn't contain methods so no need to utilize eval & interpolate.
							option.uri = option.uri + $scope.getSessionUrl();
						}
					}
				});

				$scope.toggleLabel = Lexicon.translateDefaultNS('technicalinsight.spotlight-more');
				$scope.mainAction = $scope.actionOptions[0];
			}
		}
		catch (err) {
			console.warn(err);
		}
	}

	// check if session info is available (Kevin to provide)
	$scope.getSessionUrl = function () {
		var sessionInfo = "";
		if (typeof(window.getSessionInfo) === 'function') {
			sessionInfo = window.getSessionInfo();
		}
		return sessionInfo;
	};

	$scope.doAction = function (action) {
		try {
			eval(action); //jshint ignore:line
		} catch (e) {
			console.error(action);
			throw e;
		}
	};

	$scope.setMainAction = function (option) {
		$scope.mainAction = option;
	};
}]);

'use strict';

recogniaApp.controller('InstrumentSelectCtrl',
['$scope', 'HostedWebsite',
function ($scope, HostedWebsite) {

	$scope.symbol = '';
	$scope.$emit('symbolChanged', $scope.symbol);
	$scope.text = {};
	//set dynamic button name for btn_dropdown
	var button_name = 'btn_dropdown'+ $scope.buttonIndex;


	/* Emit changes to the form */
	// symbol change
	$scope.$watch('symbol', function(newValue, oldValue) {
		$scope.$emit('symbolChanged', newValue, oldValue);
	});
	// exchange selected
	$scope.setExchange = function(exchange,focus) {
		$scope.$emit('exchangeChanged', exchange, $scope.selectedExchange);
		$scope.selectedExchange = exchange;
		//set focus when one of the item be selected
		if(focus===undefined)
			document.getElementsByName(button_name)[0].focus();
	};

    $scope.setDefaultExchange = function() {
        var i;
        for (i =0; i < $scope.exchanges.length; i += 1) {
            if ($scope.exchanges[i].isDefault) {
                $scope.setExchange($scope.exchanges[i],false);
                break;
            }
        }
    };
	// search button clicked
	$scope.search = function() {
		$scope.$emit('search', $scope.symbol, $scope.selectedExchange);
	};

	/* respond to events */
	// reset model
	$scope.$on('reset', function() {
		$scope.symbol = '';
		$scope.$emit('symbolChanged', $scope.symbol);
		$scope.setDefaultExchange();
	});

	$scope.text.symbolPlaceholder = '';

	/* Get the list of exchanges for symbol entry */
	HostedWebsite.instrumentLookupExchanges(function (data) {
		$scope.exchanges = data;
		$scope.setDefaultExchange();
		$scope.isOneExchange();
	},"type=lookup");


	/*drop down: set keyboard listener for tab key and shift+tab key
	 * to close the button
	 */
	$scope.buttonOnKeyDown = function ($event) {
			//close dropdown menu when press shift + tab
			if ($event.keyCode === 9 && $event.shiftKey&&$(".dropdown-menu:visible").size()) {
				$(this).dropdown("toggle");
			}
			else if($event.keyCode === 9&&$(".dropdown-menu:visible").size()){
				$(this).dropdown("toggle");
			}
	};

	$scope.dropdownOnKeyDown = function ($event) {
		//close dropdown menu when press shift + tab
		if($event.keyCode === 9&&$(".dropdown-menu:visible").size()){
			$(this).dropdown("toggle");
		}
	};

	$scope.isOneExchange = function () {
		return $scope.exchanges && $scope.exchanges.length === 1;
	};

}]);

'use strict';

recogniaApp.controller('NoMatchingTagsMessageController',
['$scope', 'Lexicon', 'CommonConstants',
function ($scope, Lexicon , CommonConstants) {
	$scope.$watch('selectedProduct', function () {
			switch($scope.selectedProduct) {
				case CommonConstants.PRODUCT.forex:
					$scope.message = Lexicon.translateDefaultNS('personalsettings.filter-not-applied-notification-forex');
					break;
				case CommonConstants.PRODUCT.options:
					$scope.message = Lexicon.translateDefaultNS('personalsettings.filter-not-applied-notification-options');
					break;
				case CommonConstants.PRODUCT.stocks:
					$scope.message = Lexicon.translateDefaultNS('personalsettings.filter-not-applied-notification-stocks');
					break;
				default:
					$scope.message.hide;
					break;
			}
	});
}]);

'use strict';

recogniaApp.controller('MostFollowedInstrumentsCtrl',
['$scope', 'REST', 'Lexicon', 'LegacyApi', 'Config',
function ($scope, REST, Lexicon, LegacyApi, Config) {
	var exchange;

	/* Handle events */
	$scope.$on('exchangeChanged', function(e, newExchange) {
		exchange = newExchange.exchange;
		loadEntries();

		if (e.stopPropogation) { e.stopPropogation(); }
	});

	/* Initialise scope */
	$scope.text = {};

	$scope.text.bullish = Lexicon.translateDefaultNS('technicalinsight.spotlight-bullish');
	$scope.text.bearish = Lexicon.translateDefaultNS('technicalinsight.spotlight-bearish');

	/* Display the given list of widget data */
	function setEntries(list) {
		if (list === undefined || list === null || list.length === 0) {
			$scope.noMatches = true;
			$scope.entries = [];
			return;
		}

		$scope.noMatches = false;
		$scope.entries = list.map(function(e) {
			var instrument = e.instrument,
				bullish = e.num_bullish / e.num_opinions,
				bearish = e.num_bearish / e.num_opinions,
				style =
					(bullish - bearish >= 0.05) ? 'bullish'
					: (bearish - bullish >= 0.05) ? 'bearish'
					: null;

			return {
				bullish: {
					percent: bullish,
					style: { width: 100 * bullish + '%' }
				},
				bearish: {
					percent: bearish,
					style: { width: 100 * bearish + '%' }
				},
				exchange: instrument.exchange_symbol_DISPLAY,
				exchangeSymbol: instrument.exchange_symbol,
				symbol: instrument.symbol_DISPLAY,
				style: style
			};
		});
	}

	REST.User().success(function(response){
		$scope.symbolsIncludeExchange = response.result.client.symbolsIncludeExchange;
		$scope.symbolsIncludeExchangeExceptions = response.result.client.symbolsIncludeExchangeExceptions;
	});

	$scope.displayExchanges = function(exchange) {

		if ($scope.symbolsIncludeExchange === true) {
			for (var index=0; index<$scope.symbolsIncludeExchangeExceptions.length; index++) {
				if ($scope.symbolsIncludeExchangeExceptions[index] === exchange) {
					return true;
				}
			}
			return false;
		}
		return true;
	};

    /* Call the API to get and display the widget data */
    function loadEntries() {
        var parameters = 'exc=' + exchange + '&qty=5&' + Config.getLegacyApiParameters();

        LegacyApi.api('mostfollowedinstruments', parameters).success(function (data) {
            if(data.pri) setEntries(data.pri.list);
        });
    }

	/*drop down: set keyboard listener for tab key and shift+tab key
	 * to close the button
	 */
	$scope.buttonOnKeyDown = function ($event) {
		//close dropdown menu when press shift + tab
		if ($event.keyCode === 9 && $event.shiftKey&&$(".dropdown-menu:visible").size()) {
			$(this).dropdown("toggle");
		}
		else if($event.keyCode === 9&&$(".dropdown-menu:visible").size()){
			$(this).dropdown("toggle");
		}
	};

	$scope.dropdownOnKeyDown = function ($event) {
		//close dropdown menu when press shift + tab
		if($event.keyCode === 9&&$(".dropdown-menu:visible").size()){
			$(this).dropdown("toggle");
		}
	};

	// If there is only one exchange in country drop-down the lable "Most Followed Instrument" should not be wrapped
	$scope.$on('exchangeSet', function(e, exchangesSize) {
		$scope.oneExchange = exchangesSize === 1;
		if(e.stopPropagation()){e.stopPropagation(); }
	});

}]);

'use strict';

recogniaApp.controller('OptionsProfitLossChartCtrl',
['$scope', 'HighChartsTheme', 'Lexicon', 'OptionsStrategy', 'OptionsProfitLossChart', 'NumberFormatter', '$interpolate', 'DateFormatter', 'OptionsStrategyConstants','HighChartsUtils', 'Ideas',
function ($scope, HighChartsTheme, Lexicon, OptionsStrategy, OptionsProfitLossChart, NumberFormatter, $interpolate, DateFormatter, OptionsStrategyConstants, HighChartsUtils, Ideas) {

	$scope.lexiconLastPrice = HighChartsUtils.getLexiconLastPrice($scope.underlyingLatestPriceObj);

	/***
	 * Chart Configurations
	 */
	$scope.profitLossChartConfig = angular.copy(
		OptionsProfitLossChart.buildChartConfig(
			$scope.profitAndLossChart.featured.idea,
			$scope.profitAndLossChart.featured.idea.trade,
			$scope.underlyingLatestPriceObj.price
		)
	);
	$scope.profitLossChartConfig.chart.height = 240;

	$scope.profitLossChartConfig.series[1].data.map(function(point){
		if (point._tooltip){
			point._tooltip.content = Lexicon.translateDefaultNS(point._tooltip.contentLexiconKey);
		}
	});

	var oplTTStyles = HighChartsTheme.chartOPLTooltip();
	$scope.profitLossChartConfig.tooltip = {
		useHTML: true,
		followPointer: false,
		backgroundColor: oplTTStyles.bgColor,
		borderColor: 'none',
		opacity: 0.8,
		style: {
			color: oplTTStyles.textColor
		},
		formatter: function () {
			var innerHTML,
				ttPrice,
				ttProfit;
			if (this.point.options._tooltip) {
				// tooltip may have custom values not the same as x,y of the point it hovers
				if (this.point.options._tooltip.price !== undefined){
					ttPrice = this.point.options._tooltip.price;
				} else {
					ttPrice = this.x;
				}
				if (this.point.options._tooltip.profit !== undefined){
					ttProfit = this.point.options._tooltip.profit;
				} else {
					ttProfit = this.y;
				}

				$scope.opPLChartTooltip = {};
				var precision = $scope.featured.idea.instrument.precision;
				$scope.opPLChartTooltip.price = NumberFormatter.formatCurrency(ttPrice, precision);
				if (ttProfit < 0) {
					$scope.opPLChartTooltip.loss =  NumberFormatter.formatCurrency(-1 * ttProfit, precision);
				} else {
					$scope.opPLChartTooltip.profit =  NumberFormatter.formatCurrency(ttProfit, precision);
				}
				if (this.point.options._tooltip.breakEvens) {
					$scope.opPLChartTooltip.breakEvens = this.point.options._tooltip.breakEvens.map(
						function (price){
							return NumberFormatter.formatCurrency(price, precision);
						}
					);
				}
				innerHTML = '<div id="tooltip-label"><p>' + $scope.$eval($interpolate(this.point.options._tooltip.content)) + '</p></div>';
			} else {
				innerHTML = false;
			}
			return innerHTML;
		}
	};


	var tradeLegs = $scope.featured.idea.trade.legs;
	var earliestExpiry = DateFormatter.parseISO8601(OptionsStrategy.getEarliestExpiryDate(tradeLegs));
	$scope.earliestExpiryFrmted = DateFormatter.formatDate(earliestExpiry, 'short');

	$scope.profitLossChartConfig.xAxis.title.text = $scope.$eval($interpolate(Lexicon.translateDefaultNS('optionsProfitLossChart.stock-price-at-expiry')));
	$scope.profitLossChartConfig.yAxis.title.text = Lexicon.translateDefaultNS('optionsProfitLossChart.profit-or-loss');

	/**
	 * ProfitAndLoss Chart Legends
	 * Strike Price & Target Price
	 */
	/**Configurations for Strike Price*/
	var strikePriceLineConfig = {
		color: HighChartsTheme.chartProfitLossStrikePrice(),
		dashStyle: 'ShortDash',
		zIndex: 2,
		_originalWidth: '2',
		_type:'strikePrice'
	};

	/** Configurations for Target Price**/
	var targetPriceLineConfig = {
		color: HighChartsTheme.chartProfitLossTargetPrice(),
		dashStyle: 'Solid',
		zIndex: 2,
		_originalWidth: '2',
		_type: 'targetPrice'
	};

	var lastPriceLineConfig = {
		color: HighChartsTheme.chartOplLastPriceColor(),
		dashStyle: 'Solid',
		zIndex: 2,
		_originalWidth: '2',
		_type: 'lastPrice'
	};

	$scope.profitLossChartLegends={
		showStrikePrice: false,
		showTargetPrice: true,
		showLastPrice: true
	};

	// initialize target price line, there's only 1, so can use base
	if ($scope.profitLossChartLegends.showTargetPrice) {
		targetPriceLineConfig.width = targetPriceLineConfig._originalWidth;
	} else {
		targetPriceLineConfig.width = 0;
	}
	targetPriceLineConfig.id = targetPriceLineConfig._type;
	targetPriceLineConfig.value = Ideas.getConservativeTargetPrice($scope.profitAndLossChart.featured.idea) || null;
	$scope.profitLossChartConfig.xAxis.plotLines.push(targetPriceLineConfig);

	// initialize latest price line, there's only 1, so can use base
	if ($scope.profitLossChartLegends.showLastPrice) {
		lastPriceLineConfig.width = lastPriceLineConfig._originalWidth;
	} else {
		lastPriceLineConfig.width = 0;
	}
	lastPriceLineConfig.id = lastPriceLineConfig._type;
	lastPriceLineConfig.value = Number($scope.underlyingLatestPriceObj.price) || null;
	$scope.profitLossChartConfig.xAxis.plotLines.push(lastPriceLineConfig);


	// initialize all strike price lines
	Object.keys(tradeLegs).forEach(
		function (legName, index) {
			if (tradeLegs[legName].instrument['resourceType'] === OptionsStrategyConstants.CONTRACT_TYPE.optionsContract) {
				var newLine = angular.copy(strikePriceLineConfig);
				newLine.value = tradeLegs[legName].instrument.strikePrice || null;
				newLine.id = newLine._type + index;
				if ($scope.profitLossChartLegends.showStrikePrice) {
					newLine.width = newLine._originalWidth;
				} else {
					newLine.width = 0;
				}
				$scope.profitLossChartConfig.xAxis.plotLines.push(newLine);
			}
		}
	);

	function toggleLineByType(line, type, enabled){
		if (line._type === type){
			if (enabled === true){
				line.width = line._originalWidth;
			} else {
				line.width = 0;
			}
		}
		return line;
	}

	// to toggle lines, switching width from X to zero and vise versa is more
	// efficient than ripping apart / rebuilding the array of lines

	$scope.toggleStrikePrice = function(){
		$scope.profitLossChartLegends.showStrikePrice = !$scope.profitLossChartLegends.showStrikePrice;

		$scope.profitLossChartConfig.xAxis.plotLines.map(function (line) {
			return toggleLineByType(line, strikePriceLineConfig._type, $scope.profitLossChartLegends.showStrikePrice);
		});
	};
	$scope.toggleTargetPrice = function(){
		$scope.profitLossChartLegends.showTargetPrice = !$scope.profitLossChartLegends.showTargetPrice;

		$scope.profitLossChartConfig.xAxis.plotLines.map(function (line) {
			return toggleLineByType(line, targetPriceLineConfig._type, $scope.profitLossChartLegends.showTargetPrice);
		});
	};
	$scope.toggleLastPrice = function(){
		$scope.profitLossChartLegends.showLastPrice = !$scope.profitLossChartLegends.showLastPrice;

		$scope.profitLossChartConfig.xAxis.plotLines.map(function (line) {
			return toggleLineByType(line, lastPriceLineConfig._type, $scope.profitLossChartLegends.showLastPrice);
		});
	};

}]);

/**
 * Created by arizvi on 6/27/14.
 */
'use strict';

recogniaApp.controller('OptionsStrategyDetails',
['$scope', '$interpolate', 'Lexicon', 'OptionsStrategy', 'ArrayUtil', 'DateFormatter', 'NumberFormatter', 'OptionsStrategyConstants', 'CommonConstants', 'Ideas',
function ($scope,$interpolate, Lexicon, OptionsStrategy, ArrayUtil, DateFormatter, NumberFormatter, OptionsStrategyConstants, CommonConstants, Ideas){
	$scope.optionsType =  $scope.featured.idea.trade.tradeStrategy.name;

	$scope.legsCount = Object.keys($scope.featured.idea.trade.legs).length;

	$scope.contractsEachLegText = Object.keys($scope.featured.idea.trade.legs).map(function (key){
		return $scope.featured.idea.trade.legs[key].quantity;
	}).join(', ');

	var popoverText = OptionsStrategy.getPopoverText($scope, $interpolate, $scope.featured.idea, $scope.featured.idea.trade);
	var precision = $scope.featured.idea.instrument.precision;
	//Variables to be used in the Lexicon Translations
	$scope.netCost = NumberFormatter.formatCurrency(
		Math.abs($scope.featured.idea.trade.netCost),
		precision
	);
	$scope.maxLoss = NumberFormatter.formatCurrency(
		Math.abs($scope.featured.idea.trade.maxLoss),
		precision
	);
	$scope.maxLossPrecentage = NumberFormatter.percent(
		Math.abs($scope.featured.idea.trade.maxLossPercent), 0
	);

	$scope.generatedAt = Lexicon.translateDefaultNS('options_strategy_details.generated-at', {
		'sprintf': {
			"generatedDate": DateFormatter.formatDate(DateFormatter.parseDate($scope.featured.idea.trade.generatedAt), 'short'),
			"generatedTime": DateFormatter.formatTime(DateFormatter.parseDate($scope.featured.idea.trade.generatedAt), false)
		}
	});

	$scope.maxProfit = NumberFormatter.formatCurrency(
		Math.abs($scope.featured.idea.trade.maxProfit),
		precision
	);
	$scope.maxProfitPrecentage = NumberFormatter.percent(
		Math.abs($scope.featured.idea.trade.maxProfitPercent), 0
	);
	$scope.targetPrice = NumberFormatter.formatCurrency(
		Ideas.getConservativeTargetPrice($scope.featured.idea),
		precision
	);
	$scope.premiumPaid = NumberFormatter.formatCurrency(
		$scope.featured.idea.trade.netCost,
		precision
	);


	Object.keys($scope.featured.idea.trade.legs).forEach(function (legType) {
		var leg = $scope.featured.idea.trade.legs[legType];

		if (leg.instrument['resourceType'] === OptionsStrategyConstants.CONTRACT_TYPE.optionsContract) {
			$scope.sharesPerContract = NumberFormatter.formatInteger(
				leg.instrument.blockSize,
				$scope.featured.idea.instrument
			);
			$scope.premiumPaidPerShare = NumberFormatter.formatCurrency(
				($scope.featured.idea.trade.netCost/leg.instrument.blockSize),
				precision
			);
			$scope.strikePrice = NumberFormatter.formatCurrency(
				leg.instrument.strikePrice,
				precision
			);
		}
	});

	$scope.targetProfit = NumberFormatter.formatCurrency(
		$scope.featured.idea.trade.targetProfit,
		precision
	);
	$scope.targetProfitPerShare = NumberFormatter.formatCurrency(
		$scope.featured.idea.trade.targetProfit/$scope.sharesPerContract,
		precision
	);
	$scope.targetProfitPerc = NumberFormatter.percent(
		$scope.featured.idea.trade.targetProfitPercent, 0
	);
	$scope.targetLower = NumberFormatter.formatCurrency(
		$scope.featured.idea.targetPrice.lower,
		precision
	);
	$scope.targetUpper = NumberFormatter.formatCurrency(
		$scope.featured.idea.targetPrice.upper,
		precision
	);
	$scope.showCalc = false;
	$scope.breakEvenPoint = NumberFormatter.formatCurrency(
		$scope.featured.idea.trade.breakevenPrice,
		precision
	);

	if (Object.keys($scope.featured.idea.trade.legs).length <= 1) {
		$scope.contractsInLegText = Lexicon.translateDefaultNS('options_strategy_details.contracts-without-leg');
	} else {
		$scope.contractsInLegText = Lexicon.translateDefaultNS('options_strategy_details.contracts-in-leg');
	}

	if ( !isFinite($scope.featured.idea.trade.maxProfit)) {
		$scope.maxProfit = Lexicon.translateDefaultNS('options_strategy_details.unlimited');
		$scope.maxProfitPrecentage = '';
	} else {
		$scope.maxProfitPrecentage = '(' + $scope.maxProfitPrecentage + ')';
	}

	if (popoverText.netCost !== undefined ) {
		$scope.netCostPopoverText = popoverText.netCost;
		$scope.netCostText = Lexicon.translateDefaultNS('options_strategy_details.net-cost');
	} else if (popoverText.netReceived !== undefined ) {
		$scope.netCostPopoverText = popoverText.netReceived;
		$scope.netCostText = Lexicon.translateDefaultNS('options_strategy_details.net-received');
	}


	$scope.maxProfitPopoverText = popoverText.maxProfit;
	$scope.maxLossPopoverText 	= popoverText.maxLoss;
	$scope.targetProfitPopoverText = popoverText.targetProfit;
	$scope.targetPricePopoverText  = popoverText.targetPrice;

	$scope.isSelectedProductWatched = function (selectedProduct){
		return ([CommonConstants.VIEW.watchedStocks,CommonConstants.VIEW.watchedOptions,CommonConstants.VIEW.watchedForex]).indexOf(selectedProduct) >=0;
	};
}]);

'use strict';

recogniaApp.controller('PerformanceChartCtrl',
['$scope', 'REST', 'ChartConfig', 'JsonUtil', 'HighChartsUtils', 'HighChartsTheme','Lexicon', 'CheckIE8', 'Config',
function ($scope, REST, ChartConfig, JsonUtil, HighChartsUtils, HighChartsTheme, Lexicon, CheckIE8, Config) {

	function getTooltipConfig() {
		var tooltipConfig = {};

		if (!$scope.chart.showTooltip) {
			tooltipConfig.enabled = false;
		} else {
			tooltipConfig.enabled = true;
		}

		return tooltipConfig;
	}

	var xAxisConfig = {
		startOnTick: false,
		type: 'datetime',
		dateTimeLabelFormats: {
			month: '%Y'
		},
		lineColor: HighChartsTheme.chartXL(),
		gridLineWidth: 1,
		gridLineColor: HighChartsTheme.chartGL(),
		gridLineDashStyle: 'ShortDot',
		ordinal: true,
		labels: {
			style: {
				color: HighChartsTheme.chartLabel()
			}
		},
		tickColor: HighChartsTheme.chartTick()
	};

	/**
	 * HightCharts configuration
	 *
	 */
	var titleMarginToPlot = 25;
	var legendY = titleMarginToPlot - 10;
	$scope.performanceChartConfig = {

		chart: {
			spacingRight: 15,
			spacingBottom: 25,
			style: {
				'font-family': "'Open Sans', Arial, Helvetica, sans-serif"
			},
			height: $scope.chart.height,
			spacingTop: $scope.chart.chartTopSpacing || ChartConfig.DefaultConstants.ChartTopSpacing,
			backgroundColor: HighChartsTheme.chartBG(),
			panning:false
		},

		tooltip: getTooltipConfig(),
		navigator: {
			enabled: false
		},
		scrollbar: {
			enabled: false
		},

		xAxis: xAxisConfig,

		title: {
			margin: titleMarginToPlot,
			text: $scope.chart.title,
			style: {
				color: HighChartsTheme.chartTitle()
			}
		},

		legend:   {
			enabled: true,
			align: 'left',
			verticalAlign: 'top',
			x: 27,
			y: legendY,
			floating: true,
			borderWidth: 0,
			itemStyle: {
				color: HighChartsTheme.chartLegend(),
				// IE (all versions as of March 2015) has a bug that it doesn't interpret text-anchor correctly in RTL mode.
				// So always use LTR value for IE.
				textAnchor:(Config.getPageDirection().ltr || CheckIE8.isIE())? 'start':'end'
			},
			itemHoverStyle: {
				color: HighChartsTheme.chartLegend()
			}
		},

		yAxis: {
			offset: 30,
			gridLineColor: HighChartsTheme.chartGL(),
			labels: {
				align: 'center',
				x: 15,
				y: -2,
				formatter: function () {
					if (Config.getPageDirection().ltr) {
						return this.value + "%";
					}
					if (this.value < 0)
						return "-" + "%" + -1 * this.value;
					return "%" + this.value;
				},
				style: {
					color: HighChartsTheme.chartLabel()
				}
			}
		},


		series: []
	};

	$scope.performanceChartConfig = JsonUtil.deepExtend($scope.performanceChartConfig, ChartConfig.DefaultConfig);


	/**
	 * Called whenever the source is updated
	 * @param newSource
	 */
	function onSourceUpdate(newSource) {

		$scope.performanceChartConfig.series = [];

		$scope.strategy = newSource;

	}

	/*
		Source object
	 */
	$scope.$watch("chart.showStops", function (newValue) {

		if (newValue === true && $scope.performanceChartConfig.series.length<2 && $scope.trailingStops!==undefined) {
			$scope.performanceChartConfig.series.push($scope.trailingStops);
		} else {
			if (newValue === false && $scope.performanceChartConfig.series.length===2) {
				$scope.performanceChartConfig.series.pop();
			}
		}
	});

	/*
		Source object
	 */
	$scope.$watch("chart.source", function (newSource, oldSource) {

		//do nothing when called on registration
		if (newSource === oldSource) {
			return;
		}
		onSourceUpdate(newSource);

	});

	/*
		Watch for strategy to load data from the REST API
	 */
	$scope.$watch('strategy', function (newValue) {

		if (newValue === undefined ||
			newValue === null) {
			return;
		}

		REST.get($scope.strategy.performance).success(function (data) {

			$scope.performanceChartConfig.series.length = 0;

			var performanceData = data.result.performance;
			if (performanceData !== null) {

				$scope.performanceConfig = {
					data: HighChartsUtils.transformPerformanceData(performanceData.time, performanceData.hold),
					name: 'eventdetails.strategy',
					color: HighChartsTheme.strategyTS()
				};
				$scope.performanceChartConfig.series.push($scope.performanceConfig);

				$scope.trailingStops = {
					data: HighChartsUtils.transformPerformanceData(performanceData.time, performanceData.stop),
					name: 'eventdetails.stops',
					color:HighChartsTheme.stopTS()
				};

				if ($scope.chart.showStops) {
					$scope.performanceChartConfig.series.push($scope.trailingStops);
				}

				$scope.performanceConfig.name = Lexicon.translateDefaultNS($scope.performanceConfig.name);
				$scope.trailingStops.name = Lexicon.translateDefaultNS($scope.trailingStops.name);

			}
		});
	});

	// Initialize
	if ($scope.chart.source !== undefined && $scope.chart.source !== null) {
		onSourceUpdate($scope.chart.source);
	}

}]);

'use strict';

recogniaApp.controller('PriceChartCtrl',
	['$scope', '$q', 'REST', 'Lexicon', 'OptionsStrategy', 'NumberFormatter', 'DateFormatter', 'CommonConstants', 'Config', 'ChartSections', 'Ideas', '$timeout', 'Platform', 'LoopHttpCallService',
		function ($scope, $q, REST, Lexicon, OptionsStrategy, NumberFormatter, DateFormatter, CommonConstants, Config, ChartSections, Ideas, $timeout, Platform, LoopHttpCallService) {

			var unregister = $scope.$watch('parentElement', function (newval, oldval) {

				var services = {
					$q: $q,
					REST: REST,
					Ideas: Ideas,
					CommonConstants: CommonConstants,
					DateFormatter: DateFormatter,
					NumberFormatter: NumberFormatter,
					Lexicon: Lexicon,
					Config: Config,
					OptionsStrategy: OptionsStrategy,
					ChartSections: ChartSections,
					$scope :$scope,
					$timeout : $timeout,
					Platform: Platform,
					LoopHttpCallService: LoopHttpCallService
				};
				var config = {
					productType: $scope.selectedProduct,
					ideaType: $scope.featured.idea.ideaType,
					largeChart: $scope.largeChart
				};
				// Check if we should force the chart to show candlesticks - only for the Forex large chart
				config.forceCandlesticks = config.ideaType === 'forex' && config.largeChart && $scope.userSettings.forexLargeChartAlwaysCandlesticks;

				$scope.blingChartInst = RecogniaChart.PriceChartGenerator(services, $scope.parentElement, config, $scope.featured.idea);

				if (config.ideaType === 'forex' && config.largeChart) {
					// Detect if option for forcing candlesticks is changed, and update the chart style
					$scope.$watch('userSettings.forexLargeChartAlwaysCandlesticks', function(newValue) {
						if ($scope.blingChartInst && $scope.blingChartInst.getById('price')) {
							$scope.blingChartInst.getById('price').attr({
									barType: !newValue && $scope.featured.idea.events[0].eventType.barType === CommonConstants.BAR_TYPE.bar ? "ohlc" : "candlestick",
									'class': !newValue && $scope.featured.idea.events[0].eventType.barType === CommonConstants.BAR_TYPE.bar ? charting.definition.plot["plot-price-ohlc"].class : charting.definition.plot["plot-price-candlestick"].class,
									strokeWidth: !newValue && $scope.featured.idea.events[0].eventType.barType === CommonConstants.BAR_TYPE.bar ? charting.definition.plot["plot-price-ohlc"].strokeWidth : charting.definition.plot["plot-price-candlestick"].strokeWidth,
							});
						}
					});
				}
			});

			var unregister = $scope.$watch('chartParams.enabled', function (newval, oldval) {
				// if chart is not enabled, then don't draw it yet because it is not safe to do so. If chart is safe to be drawn
				// then unregister the watch variable for this chart, and then proceed to draw it.
				if (!$scope.chartParams.enabled) {
					return;
				} else {
					unregister();
				}

				$scope.$watch('selectedIdea.idea', function (newval, oldval) {
					RecogniaChart.enableDisableIdea($scope.blingChartInst,newval,$scope.idea);
				});
			});

			//Trun on watched stop style when the idea is watched
			$scope.$on(Ideas.action($scope.idea.linkId).WATCHING,function(){
				RecogniaChart.turnOnWatchIdeaStyle($scope.blingChartInst,true);
			});

			//Trun off watched stop style when the idea is watched
			$scope.$on(Ideas.action($scope.idea.linkId).UNWACTHING,function(){
				RecogniaChart.turnOnWatchIdeaStyle($scope.blingChartInst,false);
			});
		}
	]
);

'use strict';

recogniaApp.controller('SpotlightComponentCtrl',
['$scope',
function ($scope) {

	$scope.elements = ["ELEMENT 1", "ELEMENT 2", "ELEMENT 3", "ELEMENT 4", "ELEMENT 5", "ELEMENT 6"];
	$scope.selectedElements = $scope.elements.slice(0,5);
}]);

'use strict';

recogniaApp.controller('StyleCheckboxCtrl',
['$scope', 'Lexicon','UserPreferences',
function ($scope, Lexicon, UserPreferences) {

	var selectedQuestion = $scope.selectedQuestion,
		questionId = selectedQuestion["linkId"];

	$scope.id = questionId;
	$scope.questions = selectedQuestion.answers;
	$scope.uiControl = selectedQuestion.uiControl;

	if (selectedQuestion.hasOwnProperty(('name'))) {
		$scope.title = selectedQuestion.name;
		// Translated scope variables
		$scope.settingsTitle = Lexicon.translateDefaultNS('personalization.' + $scope.title);
	}

	if (selectedQuestion.hasOwnProperty(('uiControlText'))){
		$scope.btnDropdownTitle = Lexicon.translateDefaultNS('personalization.' + selectedQuestion.uiControlText);
	}

	$scope.questionsTranslated = angular.copy($scope.questions);

	if($scope.questionsTranslated){
		$scope.questionsTranslated.forEach(
			function(value, index) {
				if ($scope.questionsTranslated[index].name === 'USA' || $scope.questionsTranslated[index].name === 'Canada') {
					$scope.questionsTranslated[index].name = Lexicon.translateDefaultNS('personalization.lexicon_options_' + $scope.questionsTranslated[index].name);
				}
			}
		);
	}
	//this check should not be here when we have a better solution.
	if (['exchange', 'market','instrument'].indexOf(selectedQuestion.dataType) === -1) {

		for (var k = 0, l = $scope.questionsTranslated.length; k < l; k++) {
			$scope.questionsTranslated[k].name = Lexicon.translateDefaultNS(
				'personalization.' + $scope.questions[k].name);
		}
	}

	if ($scope.uiControl === 'native' ) {
		$scope.style = 'checkbox';
	} else if($scope.uiControl === 'instrumentList'){
		$scope.style = 'tags';
	}else if($scope.uiControl === 'button'||$scope.uiControl === 'buttonToDropdown'){
		$scope.style = 'button';
	}

	if (selectedQuestion.selectionStyle === 'group') {
		$scope.titleStyle = 'check';
	}
	else if ( !selectedQuestion.hasOwnProperty(('name')) ) {
		$scope.titleStyle = null;
	}
	else {
		$scope.titleStyle = 'non-check';
	}

	$scope.checkParent = false;
	$scope.isSelected = function (qid) {
		if (UserPreferences.getUserPreferences().settings[questionId] &&
			UserPreferences.getUserPreferences().settings[questionId].indexOf(qid) !== -1) {
			$scope.checkParent = true;
			return true;
		} else {
			return false;
		}
	};

	$scope.onClick = function (qid) {
		if (!UserPreferences.getUserPreferences().settings[questionId]){
			UserPreferences.getUserPreferences().settings[questionId] = [];
		}
		// if clicking a parent group control, toggle everything inside
		if (qid === questionId) {
			// if nothing selected, select all
			if (UserPreferences.getUserPreferences().settings[questionId].length === 0) {
				var answers = selectedQuestion.answers;
				for (var item in answers) {
					if (answers.hasOwnProperty(item)) {
						UserPreferences.getUserPreferences().settings[questionId].push(answers[item].id);
					}
				}
			}
			// if some or all selected, deselect all
			else if (UserPreferences.getUserPreferences().settings[questionId].length <= selectedQuestion.answers.length) {
				$scope.checkParent = false;
				UserPreferences.getUserPreferences().settings[questionId].length = 0;
			}
		}
		// otherwise just clicked an individual answer
		else {
			var idx = UserPreferences.getUserPreferences().settings[questionId].indexOf(qid);
			if (idx === -1) {
				UserPreferences.getUserPreferences().settings[questionId].push(qid);
			}
			else {
				UserPreferences.getUserPreferences().settings[questionId].splice(idx, 1);
				// if we unchecked the last thing in a group, uncheck the parent checkbox
				if (UserPreferences.getUserPreferences().settings[questionId].length === 0) {
					$scope.checkParent = false;
				}
				// set focus back on drop-down in example site in case of deselecting exchanges
				if (questionId === 'stocks_exchanges'){
					angular.element('#focusButton').focus();
				}
			}
		}
	};

	$scope.selectedQuestion = function(question) {
		if ($scope.uiControl ==='buttonToDropdown') {
			return (UserPreferences.getUserPreferences().settings[questionId] &&
			UserPreferences.getUserPreferences().settings[questionId].indexOf(question.id) !== -1);
		} else {
			return true;
		}
	};

	$scope.addQuestionButton=function(question) {
		if (!UserPreferences.getUserPreferences().settings[questionId]){
			UserPreferences.getUserPreferences().settings[questionId] = [];
		}
		UserPreferences.getUserPreferences().settings[questionId].push(question.id);
		$scope.minusIndex = -50;
		angular.element('#focusButton').focus();
	};


	$scope.isDDL = function() {
		return $scope.uiControl === 'buttonToDropdown';
	};


	/*drop down: set keyboard listener for tab key and shift+tab key
	 * to close the button
	 */
	$scope.buttonOnKeyDown = function ($event) {
		//close dropdown menu when press shift + tab
		if ($event.keyCode === 9 && $event.shiftKey&&angular.element('.dropdown-menu:visible').size()) {
			angular.element('.dropdown-menu').dropdown("toggle");

		}
		else if($event.keyCode === 9&&angular.element('.dropdown-menu:visible').size()){
			angular.element('.dropdown-menu').dropdown("toggle");
		}
	};

	$scope.dropdownOnKeyDown = function ($event) {
		//close dropdown menu when press shift + tab
		if($event.keyCode === 9&&angular.element('.dropdown-menu:visible').size()){
			angular.element('.dropdown-menu').dropdown("toggle");
		}
	};
}]);

'use strict';

recogniaApp.controller('TechnicalEventScreenersCtrl',
['$scope', 'Lexicon', 'HostedWebsite', 'LegacyApi',
function ($scope, Lexicon, HostedWebsite, LegacyApi) {
	$scope.followingCountry = 'US';
	$scope.technicalEvents = {};
	$scope.technicalEventsShowAllLink = HostedWebsite.pageUrl('stock_screener_advanced');

	LegacyApi.comp('/components/screener_preset_screens.mason', 'VALUE_TYPE=url&WITH_FORM=0&LIST_TYPE=json').success(function (data) {
		$scope.technicalEvents = data;

		$scope.elements = $scope.technicalEvents.list;
		$scope.selectedElements = $scope.elements.slice(0,5);
	});

}]);

'use strict';

recogniaApp.controller('TechnicalInsightAlertCtrl',
['$scope', 'Lexicon', 'LegacyApi', 'HostedWebsite',
function ($scope, Lexicon, LegacyApi, HostedWebsite) {

	$scope.userAlertData = {};
	$scope.tiAlertCounter = 0;

	LegacyApi.api('useralerttriggeredcount', '_xsl_id=asjson').success(function (data) {
		$scope.userAlertData = data;

		var eventList = $scope.userAlertData.pri.list || [];

		for (var i = 0; i < eventList.length; i++) {
			$scope.tiAlertCounter += eventList[i].count;
		}

		$scope.tiAlertMessage = Lexicon.translateDefaultNS('technicalinsight.ti-alert-message');
	});
	$scope.tiAlertLink = HostedWebsite.pageUrl('alert_edit');
}]);

'use strict';

recogniaApp.controller('MostViewedComponentCtrl',
['$scope', 'REST', 'Lexicon', 'HostedWebsite', 'LegacyApi', 'Config', 'DateFormatter',
function ($scope, REST, Lexicon, HostedWebsite, LegacyApi,Config, DateFormatter) {
	var exchange, api, tradeType;

	/* Handle events */
	$scope.$on('exchangeChanged', function (e, newExchange) {
		exchange = newExchange.exchange;
		loadEntries();

		if (e.stopPropogation) { e.stopPropogation(); }
	});

	/* Initialise scope */
	$scope.text = {};

	$scope.text.noMatches = Lexicon.translateDefaultNS('technicalinsight.no-data');
	if ($scope.type === "bullish") {
		$scope.text.title = Lexicon.translateDefaultNS('technicalinsight.spotlight-bullish-most-viewed');
		$scope.text.help = Lexicon.translateDefaultNS('technicalinsight.help-hover-most-viewed-bullish-bearish');
		$scope.text.helpTitle = Lexicon.translateDefaultNS('technicalinsight.help-title-most-viewed-bullish-bearish');
		//set button name by type
		$scope.button_name = "1";
		api = 'topviewedevents';
		tradeType = 'L';
	} else if ($scope.type === "bearish") {
		$scope.text.title = Lexicon.translateDefaultNS('technicalinsight.spotlight-bearish-most-viewed');
		$scope.text.help = Lexicon.translateDefaultNS('technicalinsight.help-hover-most-viewed-bullish-bearish');
		$scope.text.helpTitle = Lexicon.translateDefaultNS('technicalinsight.help-title-most-viewed-bullish-bearish');
		//set button name by type
		$scope.button_name = "3";
		api = 'topviewedevents';
		tradeType = 'S';
	} else if ($scope.type === "rated") {
		$scope.text.title = Lexicon.translateDefaultNS('technicalinsight.spotlight-top-user-rated');
		$scope.text.help = Lexicon.translateDefaultNS('technicalinsight.help-hover-top-rated');
		$scope.text.helpTitle = Lexicon.translateDefaultNS('technicalinsight.help-title-top-rated');
		//set button name by type
		$scope.button_name = "4";
		api = 'topratedevents';
		tradeType = null;
	}


	/* Call the API to get and display the widget data */
	function loadEntries() {
		var parameters = 'exc=' + exchange + '&drn=1week&qty=5&' + Config.getLegacyApiParameters();
		if (tradeType) {
			parameters += '&tty=' + tradeType;
		}

		LegacyApi.api(api, parameters).success(function (data) {
			if (data.pri)	setEntries(data.pri.list);
		});
	}

	REST.User().success(function(response){
		$scope.symbolsIncludeExchange = response.result.client.symbolsIncludeExchange;
		$scope.symbolsIncludeExchangeExceptions = response.result.client.symbolsIncludeExchangeExceptions;
	});

	$scope.displayExchanges = function(exchange) {

		if ($scope.symbolsIncludeExchange === true) {
			for (var index=0; index<$scope.symbolsIncludeExchangeExceptions.length; index++) {
				if ($scope.symbolsIncludeExchangeExceptions[index] === exchange) {
					return true;
				}
			}
			return false;
		}
		return true;
	};

	/* Display the given list of widget data */
	function setEntries(list) {
		if (list === undefined || list === null || list.length === 0) {
			$scope.noMatches = true;
			$scope.entries = [];
			return;
		}

		$scope.noMatches = false;
		$scope.entries = list.map(function(e) {
			var event = e.event,
				instrument = event.instrument,
				linkParams = "eid=" + event.id,
				style = (event.trade_type === 'L') ? 'bullish'
					: (event.trade_type === 'S') ? 'bearish'
					: null;

			return {
				date: DateFormatter.formatDate(DateFormatter.parseISO8601(event.end_date)),
				eventName: event.event_type_name,
				exchange: instrument.exchange_symbol_DISPLAY,
				exchangeSymbol: instrument.exchange_symbol,
				style: style,
				symbol: instrument.symbol_DISPLAY,
				url: HostedWebsite.pageUrl('chart_eid', linkParams)
			};
		});
	}

	/*drop down: set keyboard listener for tab key and shift+tab key
	 * to close the button
	 */
	$scope.buttonOnKeyDown = function ($event) {
		//close dropdown menu when press shift + tab
		if ($event.keyCode === 9 && $event.shiftKey&&$(".dropdown-menu:visible").size()) {
			$(this).dropdown("toggle");
		}
		else if($event.keyCode === 9&&$(".dropdown-menu:visible").size()){
			$(this).dropdown("toggle");
		}
	};

	$scope.dropdownOnKeyDown = function ($event) {
		//close dropdown menu when press shift + tab
		if($event.keyCode === 9&&$(".dropdown-menu:visible").size()){
			$(this).dropdown("toggle");
		}
	};
	
	// If there is only one exchange in country drop-down the lable "Most Followed Instrument" should not be wrapped
	$scope.$on('exchangeSet', function(e, exchangesSize) {
		$scope.oneExchange = exchangesSize === 1;
		if(e.stopPropagation()){e.stopPropagation(); }
	});

}]);

// Directive for top viewed and rated components
recogniaApp.directive('topViewedRated', function() {
	return {
		restrict: 'A',
		scope: {
			type: '=type'
		},
		templateUrl: 'viewed_rated_component/template.html'
	};
});

'use strict';

recogniaApp.controller('WatchButtonCtrl',
['$rootScope','$scope', 'Ideas', 'Lexicon','CommonConstants','$q','REST',
function ($rootScope,$scope, Ideas, Lexicon,CommonConstants,$q,REST) {
	// Build lexicon text
	$scope.text = {
		watch: Lexicon.translateDefaultNS('instrument_tags.watch-tag'),
		watched: Lexicon.translateDefaultNS('instrument_tags.watching-tag')
	};

	// Handle toggle behaviour
	$scope.toggle = function() {
		if ($scope.watched) {
			Ideas.watched($scope.idea.idea.ideaType).remove($scope.idea).then(function(){
				$rootScope.$broadcast(Ideas.action($scope.idea.idea.linkId).UNWACTHING);
			}, function (reason) {
				$scope.$emit(Ideas.watched($scope.idea.idea.ideaType).REMOVE_ERROR, reason);
			});
		} else {
			var firstEvent = $scope.idea.idea.events[0],
				pricePeriod = firstEvent.pricePeriod;

			var timeseriesParameters = {
				instrumentId: $scope.idea.idea.instrument.id,
				series: 'close',
				period: pricePeriod,
				latest: '1'
			};

			var promiseList = [];
			//if watchedBarTime is undefined which means this is a normal idea, the watched bar time for this idea may change,so
			//it need a timeseries api call to get the latest timestamp.
			//otherwise it in the already watched section, the watch bar time won't change
			if($scope.idea.idea.watchedBarTime === undefined){
				promiseList.push(REST.instrumentTimeseries(timeseriesParameters));
			}

			$q.all(promiseList).then(function (responses) {
				var watchedBarTime
				if(responses.length!==0){
					 watchedBarTime = responses[0].result.timestamp[0];
				}
				Ideas.watched($scope.idea.idea.ideaType).add($scope.idea,watchedBarTime).then(function(){
					$rootScope.$broadcast(Ideas.action($scope.idea.idea.linkId).WATCHING,{'value': watchedBarTime});
				}, function (reason) {
					$scope.$emit(Ideas.watched($scope.idea.idea.ideaType).ADD_ERROR, reason,$scope.idea.idea.ideaType);
				});
			});
		}
	};

	// Update on changes to watched list
	function update() {
		$scope.watched = Ideas.watched($scope.idea.idea.ideaType).isWatched($scope.idea);
		// If the idea be successfuly watched then boradcast the watched bar time to price chart controller so that it can update the style
		if($scope.watched){
			var watchedBarTime = Ideas.watched($scope.idea.idea.ideaType).getWatchedTime($scope.idea);
			$rootScope.$broadcast(Ideas.action($scope.idea.idea.linkId).WATCHING,{'value': watchedBarTime});
		}
	}
	$scope.$on(Ideas.watched(CommonConstants.IDEA_TYPE.stock).IDEAS_UPDATED, update);
	$scope.$on(Ideas.watched(CommonConstants.IDEA_TYPE.option).IDEAS_UPDATED, update);
	$scope.$on(Ideas.watched(CommonConstants.IDEA_TYPE.forex).IDEAS_UPDATED, update);

	update();
}]);

// Directive for top viewed and rated components
recogniaApp.directive('watchButton', function() {
	return {
		restrict: 'A',
		scope: {
			idea:   '=', // The idea object associated to the button
			widget: '@',  // The widget name for google analytics
			counter: '='
		},
		templateUrl: 'watch_button/template.html'
	};
});

'use strict';

recogniaApp.controller('WatchedOptionProgress',
['$scope', 'OptionsStrategy', 'NumberFormatter', 'Lexicon',
function ($scope, OptionsStrategy, NumberFormatter, Lexicon) {
	if ($scope.featured.idea.ideaType !== 'option') {
		console.error ('this component only works with an options idea');
		return;
	}

	$scope.priceMove = {};
	$scope.priceMove.lossIfClosed = false;

	$scope.$watch('featured.enabled', function (newValue) {

		if (newValue !== true) {
			return;
		}
		OptionsStrategy.getPriceMove($scope.featured.idea.trade).then(function (result) {

					$scope.priceMove.status = result.status;

					if (isNaN(result.priceDifference) || result.priceDifference === null) {
						$scope.priceAvailable = false;
						$scope.returnOnInitialCostLine = Lexicon.translateDefaultNS(
								'eventdetails.watched-option-not-available');
					} else {

						$scope.priceAvailable = true;

						$scope.priceMove.percentageDifference = NumberFormatter.percentWithLessThanThreshold(
								Math.abs(result.percentageDifference), undefined, 1);

						var precision = $scope.featured.idea.instrument.precision;
						$scope.priceMove.priceDifference = NumberFormatter.formatCurrency(Math.abs(result.priceDifference), precision);

						// values to be used in the popover lexicons
						// FIXME don't use absolute values to hide data issues.
						var roiDetails = {
							tradeWithLatestPrices: result.tradeWithLatestPrices,
							currentClosePrice: NumberFormatter.formatCurrency(
									Math.abs(result.currentClosePrice), precision),
							initialNetCost: NumberFormatter.formatCurrency(
									Math.abs($scope.featured.idea.trade.netCost), precision),
							maxLossAbsolute: NumberFormatter.formatCurrency(
									Math.abs($scope.featured.idea.trade.maxLoss), precision),
							priceMove: $scope.priceMove
						};
						// for each leg, format currency values
						Object.keys(roiDetails.tradeWithLatestPrices.legs).forEach(function (legType) {
							['bid', 'ask', 'price'].forEach(function (priceType) {
								roiDetails.tradeWithLatestPrices.legs[legType].instrument.latestPrice[priceType + '_fmtd'] =
										NumberFormatter.formatCurrency(
												roiDetails.tradeWithLatestPrices.legs[legType].instrument.latestPrice[priceType],
												precision);
							});
						});

						if (result.priceDifference >= 0) {

							$scope.priceMove.style = 'bullish';

							$scope.currentPriceHeading = Lexicon.translateDefaultNS('eventdetails.current-price-heading-gain');

							// Gets translated lexicon key for the return explanation
							$scope.returnOnInitialCostLine = Lexicon.translateDefaultNS(
									'eventdetails.watched-option-'
									+ result.tradeWithLatestPrices.tradeStrategy.strategyId + '-gain',
									roiDetails);

						} else {
							// check if closing now costs more than letting options expire
							if (Math.abs(result.priceDifference) > Math.abs($scope.featured.idea.trade.maxLoss)) {
								$scope.priceMove.lossIfClosed = true;
								$scope.greaterLossIfClosed = Lexicon.translateDefaultNS('eventdetails.greater-loss-if-closed');
							}

							$scope.priceMove.style = 'bearish';

							$scope.currentPriceHeading = Lexicon.translateDefaultNS('eventdetails.current-price-heading-loss');

							// Gets translated lexicon key for the return explanation
							$scope.returnOnInitialCostLine = Lexicon.translateDefaultNS(
									'eventdetails.watched-option-'
									+ result.tradeWithLatestPrices.tradeStrategy.strategyId + '-loss',
									roiDetails);
						}
					}
				},
				function (errResult) {
					$scope.priceMove.status = errResult.status;
					$scope.$emit('showIdeaError', true,
							'eventdetails.no-event-watched-header',
							'eventdetails.no-event-watched-ideas',
							'eventdetails.no-event-watched-delete', 'eventdetails.no-event-watched-deleted');
				});
	});

}]);

'use strict';

recogniaApp.controller('DisclaimerCtrl',
['Lexicon', 'REST', '$sce',
function (Lexicon, REST, $sce) {

	var thisCtrl = this;

	REST.User().success(function (data) {
		// Since these values are from the lexicon, we can trust that they are valid, acceptable HTML
		thisCtrl.mainText = $sce.trustAsHtml(Lexicon.translateDefaultNS('disclaimer.text', {
			company: data.result.client.name,
			year: (new Date()).getFullYear()
		}));

		thisCtrl.dataProvider = $sce.trustAsHtml(Lexicon.translateDefaultNS('disclaimer.disclaimer', {
			context: data.result.permissions.fundamentalsSource
		}));
	});
		thisCtrl.footerText = $sce.trustAsHtml(Lexicon.translateDefaultNS('disclaimer.footerText'));

}]);

'use strict';

recogniaApp.controller('FeaturedStocksCtrl',
['$scope', '$q', 'REST', 'Lexicon', 'Config', 'CommonConstants', 'Ideas', 'Broadcast', 'Platform', 'LoopHttpCallService',
function ($scope, $q, REST, Lexicon, Config, CommonConstants, Ideas, Broadcast, Platform, LoopHttpCallService) {

	LoopHttpCallService.oneTimeSubscribeToIdeasState($scope);

	var thisCtrl = this;

	var ideasScroller,
		STOCK_IDEAS_FULL_EXPAND = 'stockIdea(instrument(exchange,company,fundamentals),event,strategy)',
		FOREX_IDEAS_FULL_EXPAND = 'forexIdea(instrument(exchange,company,fundamentals),event)',
		OPTIONS_IDEAS_FULL_EXPAND = 'optionsIdea(instrument(exchange,company,fundamentals),event,strategy,optionsStrategy,optionsContract(quote))',
		WATCHED_STOCK_IDEAS_FULL_EXPAND = 'stockWatchedIdea(instrument(exchange,company,fundamentals),event,strategy)',
		WATCHED_FOREX_IDEAS_FULL_EXPAND = 'forexWatchedIdea(instrument(exchange,company,fundamentals),event)',
		WATCHED_OPTIONS_IDEAS_FULL_EXPAND = 'optionsWatchedIdea(instrument(exchange,company,fundamentals),event,strategy,optionsStrategy,optionsContract(quote))';

	// TAB key and click handling:
	$('.fs-watched-modal').one('shown.bs.modal', function () {
		$(this)
			.find('.modal-footer')
			.keydown(function (e) {
				var key = e.which, TAB_KEY = 9;
				if (key == TAB_KEY) {
					// Cancel TAB press so that focus remains on the button.
					e.preventDefault();
					return false;  
				}
			})
			// Close the dialog if the user clicks anywhere else, including the browser address bar.
			.on('blur', function (e) {
				$(this).click();
			});
	});
	
	var stockIdeas,
	forexIdeas,
	optionsIdeas;
	var items = {};

	// Retrieve brand from Platform API
	var data = Platform.data();
	$scope.brand = Lexicon.translateDefaultNS('featuredstocks.title', {
		'sprintf': {
			'brand': Lexicon.translateDefaultNS('common.featured-' + data.brand)
		}
	});

	$scope.watchedIdeas = [];
	$scope.text = {};
	$scope.watching = false;

	$scope.selectedProduct = $scope.initialProductView;

	// Compares user ideas with a special case for the idea object where the comparison is done based on the idea id only for performance reasons
	function compareIdeaProperty(currentIdea, newIdea, propertyName) {

		if (propertyName === 'idea') {
			return angular.equals(currentIdea.idea['linkId'], newIdea.idea['linkId']);
		}

		return angular.equals(currentIdea[propertyName], newIdea[propertyName]);
	}

	// Checks if the ideas array are the same or not, to save on ui refresh
	function compareIdeas(currentIdeas, newIdeas) {

		var index, keys, keysIndex;

		if (newIdeas === currentIdeas) {
			return true;
		}

		if (currentIdeas === undefined || newIdeas.length !== currentIdeas.length || currentIdeas.initState !==newIdeas.initState) {
			return false;
		}

		for (index = 0; index < newIdeas.length; index += 1) {
			keys = Object.keys(newIdeas[index]);
			for (keysIndex = 0; keysIndex < keys.length; keysIndex++) {
				if (!compareIdeaProperty(currentIdeas[index], newIdeas[index], keys[keysIndex])) {
					return false;
				}
			}
		}
		return true;
	}

	function isSelectedProductWatched(selectedProduct){
		return ([CommonConstants.VIEW.watchedStocks,CommonConstants.VIEW.watchedOptions,CommonConstants.VIEW.watchedForex]).indexOf(selectedProduct) >=0;
	}

	function populateIdeas (ideas, currentProduct) {

		// Initialize the category names with counts.
		// Note this must be done after any suppressed instruments are removed.
		updateFeaturedStocksDisplayedCount(currentProduct, ideas.length);

		if ($scope.selectedProduct === CommonConstants.VIEW.stocks) {
			$scope.selectedItem = items.stocks.name;
		} else if ($scope.selectedProduct === CommonConstants.VIEW.options) {
			$scope.selectedItem = items.options.name;
		} else if ($scope.selectedProduct === CommonConstants.VIEW.forex) {
			$scope.selectedItem = items.forex.name;
		} else if ($scope.selectedProduct === CommonConstants.VIEW.watchedStocks) {
			$scope.selectedItem = items.watchedStocks.name;
		} else if ($scope.selectedProduct === CommonConstants.VIEW.watchedOptions) {
			$scope.selectedItem = items.watchedOptions.name;
		} else if ($scope.selectedProduct === CommonConstants.VIEW.watchedForex) {
			$scope.selectedItem = items.watchedForex.name;
		}

		if (currentProduct === $scope.selectedProduct && !compareIdeas($scope.ideas, ideas)) {
			ideas.initState = ideas.length===0 ?  "noIdeas" : "hasIdeas";
			$scope.ideas = ideas;
			if ($scope.ideas.length>0) {
				$scope.selectedIdea = $scope.ideas[0];
				$scope.selectedIdea.enabled = true;
				$scope.onIdeaSelect($scope.ideas[0]);
			}
		}

		if (Config.getEnableDebug() === '1') {
			for (var i = 0; i < $scope.ideas.length; i++) {
				$scope.ideas[i].enabled = true;
			}
		}

		// for some reason, ideas are not updated in the UI when changing custom settings
		$scope.$apply();
	}

	// Update the ideas for a single product
	function updateProductIdeas () {
		if (!isSelectedProductWatched($scope.selectedProduct)&& typeof $scope.ideas !== 'undefined'){
			$scope.ideas = [];
			$scope.ideas.initState = "loading";
		}

		var updater = angular.noop;

		switch($scope.selectedProduct) {
			case CommonConstants.VIEW.stocks:
			case CommonConstants.VIEW.watchedStocks:
				updater = updateFeaturedStocks;
				break;
			case CommonConstants.VIEW.options:
			case CommonConstants.VIEW.watchedOptions:
				updater = updateFeaturedOptions;
				break;
			case CommonConstants.VIEW.forex:
			case CommonConstants.VIEW.watchedForex:
				updater = updateFeaturedForex;
				break;
			default:
				break;
		}

		return updater();
	}

	// Update all the ideas with making api calls
	function updateIdeas () {
		// if ideas are reloaded by custom settings, the width gets messed up by
		// the swipe libary. Need to set the length of the array to 0 so that
		// the width of parent container is reset.
		// Ideally would show a loading screen after custom settings are updated
		// Exception: watched ideas don't change based on custom settings
		if (!isSelectedProductWatched($scope.selectedProduct)&& typeof $scope.ideas !== 'undefined'){
			$scope.ideas = [];
		}

		return REST.User().then(function (response) {
			$scope.hasStocks = (response.data.result.permissions.products.featuredStocks === true);
			// The options portion of this project has been retired, but the permission ID was re-used for a new product.
			// So hard-code options as disabled.
			$scope.hasOptions = false;
			$scope.hasForex = (response.data.result.permissions.products.forexInsight === true);

			items = {
				"stocks" : {
					product: CommonConstants.VIEW.stocks,
					name: Lexicon.translateDefaultNS('featuredstocks.current', {
						'sprintf': { 'count': 0 }
					})
				},
				"options" : {
					product: CommonConstants.VIEW.options,
					name: Lexicon.translateDefaultNS('featuredstocks.options', {
						'sprintf': { 'count': 0 }
					})
				},
				"forex" : {
					product: CommonConstants.VIEW.forex,
					name: Lexicon.translateDefaultNS('featuredstocks.forex', {
						'sprintf': { 'count': 0 }
					})
				},
				"watchedStocks" : {
					product: CommonConstants.VIEW.watchedStocks,
					name: Lexicon.translateDefaultNS('featuredstocks.watchedStocks', {
						'sprintf': { 'count': 0 }
					})
				},
				"watchedOptions" : {
					product: CommonConstants.VIEW.watchedOptions,
					name: Lexicon.translateDefaultNS('featuredstocks.watchedOptions', {
						'sprintf': { 'count': 0 }
					})
				},
				"watchedForex" : {
					product: CommonConstants.VIEW.watchedForex,
					name: Lexicon.translateDefaultNS('featuredstocks.watchedForex', {
						'sprintf': { 'count': 0 }
					})
				}

			};
			$scope.dropDownItems = [];
			if ($scope.hasStocks) {
				$scope.dropDownItems.push(items.stocks);
				$scope.dropDownItems.push(items.watchedStocks);
			}
			if ($scope.hasOptions) {
				$scope.dropDownItems.push(items.options);
				$scope.dropDownItems.push(items.watchedOptions);
			}
			if ($scope.hasForex) {
				$scope.dropDownItems.push(items.forex);
				$scope.dropDownItems.push(items.watchedForex);
			}

			// don't load everything at once, load the view the user will see first
			var first, second, third,firstWatched,secondWatched,thirdWatched;
			switch($scope.selectedProduct) {
				case CommonConstants.PRODUCT.stocks:
					first = updateFeaturedStocks;
					firstWatched = getWatchedStock;
					second = ($scope.hasOptions) ? updateFeaturedOptions : angular.noop;
					secondWatched = ($scope.hasOptions) ? getWatchedOption : angular.noop;
					third = ($scope.hasForex) ? updateFeaturedForex : angular.noop;
					thirdWatched = ($scope.hasForex) ? getWatchedForex : angular.noop;
					break;
				case CommonConstants.PRODUCT.options:
					first = updateFeaturedOptions;
					firstWatched = getWatchedOption;
					second = ($scope.hasStocks) ? updateFeaturedStocks : angular.noop;
					secondWatched =($scope.hasStocks) ? getWatchedStock : angular.noop;
					third = ($scope.hasForex) ? updateFeaturedForex : angular.noop;
					thirdWatched =  ($scope.hasForex) ? getWatchedForex : angular.noop;
					break;
				case CommonConstants.PRODUCT.forex:
					first = updateFeaturedForex;
					firstWatched = getWatchedForex;
					second = ($scope.hasStocks) ? updateFeaturedStocks : angular.noop;
					secondWatched = ($scope.hasStocks) ? getWatchedStock : angular.noop;
					third = ($scope.hasOptions) ? updateFeaturedOptions : angular.noop;
					thirdWatched = ($scope.hasOptions) ? getWatchedOption : angular.noop;
					break;
				default:
					break;
			}
			if (first !== undefined){
				return first().then(firstWatched).then(second).then(secondWatched).then(third).then(thirdWatched);
			} else {
				// if can't tell where we are, load without priority
				var loads = [];
				if ($scope.hasStocks){
					loads.push(updateFeaturedStocks());
					loads.push(getWatchedStock());
				}
				if ($scope.hasOptions){
					loads.push(updateFeaturedOptions());
					loads.push(getWatchedOption());
				}
				if ($scope.hasForex){
					loads.push(updateFeaturedForex());
					loads.push(getWatchedForex());
				}
				return $q.all(loads);
			}
		});
	}

	function updateFeaturedStocksDisplayedCount(ideaType, count) {
		switch (ideaType) {
			case CommonConstants.PRODUCT.stocks:
				items.stocks.name = Lexicon.translateDefaultNS('featuredstocks.current', {
					'sprintf': {'count': count || 0}
				});
				break;
			case CommonConstants.PRODUCT.options:
				items.options.name = Lexicon.translateDefaultNS('featuredstocks.options', {
					'sprintf': {'count': count || 0}
				});
				break;
			case CommonConstants.PRODUCT.forex:
				items.forex.name = Lexicon.translateDefaultNS('featuredstocks.forex', {
					'sprintf': {'count': count || 0}
				});
				break;
		}
	}

	function populateIdeasWithPrices(ideas, ideaType) {
		if (ideas.length === 0) {
			populateIdeas(ideas, ideaType);
		} else {
			var instrumentList = [];
			ideas.forEach(function (ideaObj) {
				instrumentList.push(ideaObj.idea.instrument.id);
			});
			REST.getLatestPrices(instrumentList.join()).then(function (response) {
				response.quotes.forEach(function (quotePrice) {
					ideas.forEach(function (ideaObj) {
						if (ideaObj.idea.instrument.id === quotePrice.instrument.instrumentId) {
							ideaObj.idea.instrument.latestPrice =
							{
								price: quotePrice.price,
								resourceType: quotePrice.dataType,
								dataType: quotePrice.dataType,
								timestamp: quotePrice.timestamp
							};
						}
					});
				});

				// Filter out suppressed instruments for the client if it's the case.
				// This is needed because old wildfly quote API was ignoring the instrument suppression,
				// while the new API takes it into account.
				// It returns the suppressed instrument ids under the unmatchedIds array.
				response.unmatchedIds.forEach(function (unmatchedId) {
					// After splice is called, the item at index i will be what was the next item in the list,
					// then a normal for loop (going from the first to the last element from array)
					// will trigger a i++, which goes to the next next item, leaving an item unchecked,
					// so do a reverse traversal of the array in order to avoid skipping any element.
					for (var i = ideas.length - 1; i >= 0; --i) {
						if (ideas[i].idea.instrument.id === unmatchedId) {
							ideas.splice(i, 1);
						}
					}
				});
				
				populateIdeas(ideas, ideaType);
			});
		}
	}

	// Update featured ideas
	function updateFeaturedStocks () {
		return REST.UserStocksIdeas(STOCK_IDEAS_FULL_EXPAND).then(function (response) {
			stockIdeas = response.data.result.ideas;
			populateIdeasWithPrices(stockIdeas, CommonConstants.PRODUCT.stocks);
		});
	}

	// Update featured options
	function updateFeaturedOptions () {
		return REST.UserOptionsIdeas(OPTIONS_IDEAS_FULL_EXPAND).then(function (response) {
			optionsIdeas = response.data.result.ideas;
			populateIdeasWithPrices(optionsIdeas, CommonConstants.PRODUCT.options);
		});
	}

	// Update featured forex ideas
	function updateFeaturedForex () {
		return REST.UserForexIdeas(FOREX_IDEAS_FULL_EXPAND).then(function (response) {
			forexIdeas = response.data.result.ideas;
			populateIdeasWithPrices(forexIdeas, CommonConstants.PRODUCT.forex);
		});
	}

	function getWatchedStock() {
		return Ideas.watched(CommonConstants.IDEA_TYPE.stock).get({ expand: WATCHED_STOCK_IDEAS_FULL_EXPAND});
	}

	function getWatchedOption() {
		return Ideas.watched(CommonConstants.IDEA_TYPE.option).get({ expand: WATCHED_OPTIONS_IDEAS_FULL_EXPAND});
	}

	function getWatchedForex() {
		return Ideas.watched(CommonConstants.IDEA_TYPE.forex).get({ expand: WATCHED_FOREX_IDEAS_FULL_EXPAND});
	}

	$scope.onSwiperCreate = function (swiperId, swiperRef) {
		ideasScroller = swiperRef;
	};

	// This will be only called in modern browsers, do not rely on it
	$scope.onSwipeEnd = function (swiperId, index) {

		$scope.selectedIdea = $scope.ideas[index];
		// Enable the idea (important for swipe based idea selection)
		$scope.selectedIdea.enabled = true;
		var index = $scope.ideas.indexOf($scope.selectedIdea);
		if (index<$scope.ideas.length-1) {
			$scope.ideas[index+1].prepare = true;
		}		// Need to apply as this is an event that is not fired by angular
		$scope.$apply();
	};

	$scope.onIdeaSelect = function (featured) {
		if(featured){
			var currentIdeaObjIndex = $scope.ideas.indexOf(featured);

			$scope.selectedIdea = featured;
            $scope.selectedIdea.enabled = true;
            
			if (ideasScroller) {
				ideasScroller.slide(currentIdeaObjIndex);				
			}else{
               // console.warn('No swipe library has been defined');
            }
		}        
	};

	function setWatchedCount(name, assetType){
		if ($scope.selectedProduct === assetType) {
			$scope.selectedItem = name;
		}
	}

	function setStarWatchedCount(type){
		if (isStocks(type)) {
			$scope.assetLexicon = Lexicon.translateDefaultNS('eventdetails.watchedStocksIdeas');
			$scope.watchedCount = $scope.watchedStocksCount;
			$scope.watchedProduct = CommonConstants.VIEW.watchedStocks;

		} else if (isOptions(type)) {
			$scope.assetLexicon = Lexicon.translateDefaultNS('eventdetails.watchedOptionsIdeas');
			$scope.watchedCount = $scope.watchedOptionsCount;
			$scope.watchedProduct = CommonConstants.VIEW.watchedOptions;

		} else if (isForex(type)) {
			$scope.assetLexicon = Lexicon.translateDefaultNS('eventdetails.watchedForexIdeas');
			$scope.watchedCount = $scope.watchedForexCount;
			$scope.watchedProduct = CommonConstants.VIEW.watchedForex;
		}
	}

	var watchedStocksIdeas =[];
	var watchedOptionsIdeas=[];
	var watchedForexIdeas  = [];
	function updateWatchedIdeasCount(type) {
		switch (type) {
			case CommonConstants.IDEA_TYPE.stock:
				watchedStocksIdeas = Ideas.watched(type).list();
				$scope.watchedStocksCount = watchedStocksIdeas.length || 0;
				break;
			case CommonConstants.IDEA_TYPE.option:
				watchedOptionsIdeas = Ideas.watched(type).list();
				$scope.watchedOptionsCount = watchedOptionsIdeas.length || 0;
				break;
			case CommonConstants.IDEA_TYPE.forex:
				watchedForexIdeas = Ideas.watched(type).list();
				$scope.watchedForexCount = watchedForexIdeas.length || 0;
				break;
		}
			setStarWatchedCount($scope.selectedProduct);
	}

	// Track changes in watched stock ideas list
	$scope.$on(Ideas.watched(CommonConstants.IDEA_TYPE.stock).IDEAS_UPDATED, function() {
		updateWatchedIdeasCount(CommonConstants.IDEA_TYPE.stock);
		items.watchedStocks.name = Lexicon.translateDefaultNS('featuredstocks.watchedStocks', {
			'sprintf': {'count': $scope.watchedStocksCount}
		});
		setWatchedCount(items.watchedStocks.name, CommonConstants.VIEW.watchedStocks);
	});

	// Track changes in watched option ideas list
	$scope.$on(Ideas.watched(CommonConstants.IDEA_TYPE.option).IDEAS_UPDATED, function() {
		updateWatchedIdeasCount(CommonConstants.IDEA_TYPE.option);
		items.watchedOptions.name = Lexicon.translateDefaultNS('featuredstocks.watchedOptions', {
			'sprintf': {'count': $scope.watchedOptionsCount}
		});
		setWatchedCount(items.watchedOptions.name, CommonConstants.VIEW.watchedOptions);
	});

	// Track changes in watched forex ideas list
	$scope.$on(Ideas.watched(CommonConstants.IDEA_TYPE.forex).IDEAS_UPDATED, function() {
		updateWatchedIdeasCount(CommonConstants.IDEA_TYPE.forex);
		items.watchedForex.name = Lexicon.translateDefaultNS('featuredstocks.watchedForex', {
			'sprintf': {'count': $scope.watchedForexCount}
		});
		setWatchedCount(items.watchedForex.name, CommonConstants.VIEW.watchedForex);
	});

	// FIXME Probably want a nicer way of doing this. Perhaps error dialogue is
	// a directive and the watched button itself can call it?
	$scope.$on(Ideas.watched(CommonConstants.IDEA_TYPE.stock).ADD_ERROR, function (event, reason,type) {
			updateWatchedAddError(reason,type);
	});

	$scope.$on(Ideas.watched(CommonConstants.IDEA_TYPE.option).ADD_ERROR, function (event, reason,type) {
			updateWatchedAddError(reason,type);
	});

	$scope.$on(Ideas.watched(CommonConstants.IDEA_TYPE.forex).ADD_ERROR, function (event, reason,type) {
		updateWatchedAddError(reason,type);
	});

	function updateWatchedAddError(reason,type){
		if (typeof(reason) === "object" && typeof(reason.data) === "object" && typeof(reason.data.error) === "object"
			&& reason.data.error.code === CommonConstants.ERROR_CODE.limit_exceeded
		) {
			$scope.text.watchedModalHeader = Lexicon.translateDefaultNS('watchedModal.' + type + '.many_watched_header');
			$scope.text.watchedModalIdeas = Lexicon.translateDefaultNS('watchedModal.' + type + '.many_watched_ideas');
			$scope.text.watchedModalClose = Lexicon.translateDefaultNS('featuredstocks.watched-close');
			$scope.text.watchedModalButton = Lexicon.translateDefaultNS('instrument_tags.watching-tag');
			$scope.watchedModalIcon = false;
			$scope.watching = true;
			$scope.showWatchedModal = true;
		}
	}

	function noWatchedState(type){
		$scope.text.watchedModalHeader = Lexicon.translateDefaultNS('watchedModal.'+type+'.no_watched_header');
		$scope.text.watchedModalIdeas = Lexicon.translateDefaultNS('watchedModal.'+type+'.no_watched_ideas');
		$scope.text.watchedModalClose = Lexicon.translateDefaultNS('featuredstocks.watched-close');
		$scope.text.watchedModalButton = Lexicon.translateDefaultNS('instrument_tags.watch-tag');
		$scope.watchedModalIcon = true;
		$scope.showWatchedModal = true;

		return;
	}

	function setScopeIdeaProps(type, name, newIdeasList){
		$scope.selectedProduct = type;
		$scope.selectedItem = name;
     
        $scope.ideas.forEach(function (idea){
            idea.enabled = false;            
        });
        $scope.ideas = newIdeasList;

        // make the first idea visible by sliding it into the view and setting its display property
        $scope.onIdeaSelect($scope.ideas[0]);

        // after digest cycle is completed and the ideas list is updated, hide/show ideas elements based on the new list
        $scope.$$postDigest(function() {
            // this is called so swipe library can re-arrange ideas properly after removing an idea from a list
	        if(ideasScroller)
            ideasScroller.setup();             
        });
	}

	thisCtrl.switchProductView = function (type) {
		//drop down: set focus on the button when item be selected
		document.getElementsByName("btn_stock_dropdown")[0].focus();
		if (type === CommonConstants.VIEW.watchedStocks) {
			if (watchedStocksIdeas.length < 1) {
				return noWatchedState(CommonConstants.IDEA_TYPE.stock);
			}
			setScopeIdeaProps(type,items.watchedStocks.name, watchedStocksIdeas);
		}
		else if (type === CommonConstants.VIEW.watchedOptions) {
			if (watchedOptionsIdeas.length < 1) {
				return noWatchedState(CommonConstants.IDEA_TYPE.option);
			}
			setScopeIdeaProps(type, items.watchedOptions.name, watchedOptionsIdeas);
		}
		else if (type === CommonConstants.VIEW.watchedForex) {
			if (watchedForexIdeas.length < 1) {
				return noWatchedState(CommonConstants.IDEA_TYPE.forex);
			}
			setScopeIdeaProps(type,items.watchedForex.name,watchedForexIdeas);
		}
		else if (type === CommonConstants.VIEW.stocks) {
			setScopeIdeaProps(type,items.stocks.name,stockIdeas);
			$scope.ideas.initState = stockIdeas.length===0 ?  "noIdeas" : "hasIdeas";

		}
		else if (type === CommonConstants.VIEW.options) {
			setScopeIdeaProps(type,items.options.name,optionsIdeas);
			$scope.ideas.initState = optionsIdeas.length===0 ?  "noIdeas" : "hasIdeas";
		}
		else if (type === CommonConstants.VIEW.forex) {
			setScopeIdeaProps(type,items.forex.name,forexIdeas);
			$scope.ideas.initState = forexIdeas.length===0 ?  "noIdeas" : "hasIdeas";
		}
		setStarWatchedCount($scope.selectedProduct);
	};

	$scope.$on(Broadcast.SETTINGS_CHANGED_MESSAGE, function () {
		//updateIdeas();
		updateProductIdeas();
	});

	// Update all ideas
	updateIdeas();

	//drop down: set keyboard listener of tab key and shift+tab key to close the drop down
	$scope.buttonOnKeyDown = function ($event) {
		//close dropdown menu when press shift + tab
		if ($event.keyCode === 9 && $event.shiftKey&&$(".dropdown-menu:visible").size()) {
			$(this).dropdown("toggle");
		}
		else if($event.keyCode === 9&&$(".dropdown-menu:visible").size()){
			$(this).dropdown("toggle");
		}
	};

	$scope.dropdownOnKeyDown = function ($event) {
		//close dropdown menu when press shift + tab
		if($event.keyCode === 9&&$(".dropdown-menu:visible").size()){
			$(this).dropdown("toggle");
		}
	};

	$scope.userSettings = {};

	REST.getUserSettings('featuredIdeas').success(function (response) {
		$scope.userSettings = response.result.settings;
	});

	$scope.saveUserSettings = function () {
		REST.saveUserSettings('featuredIdeas', 
			{
				"resourceType":"userSettings",
				"category":"featuredIdeas",
				"settings": $scope.userSettings
			}
		);
	}

	function isStocks(selectedProduct){
		return [CommonConstants.VIEW.stocks,CommonConstants.VIEW.watchedStocks].indexOf(selectedProduct) >= 0;
	}

	function isOptions(selectedProduct){
		return [CommonConstants.VIEW.options,CommonConstants.VIEW.watchedOptions].indexOf(selectedProduct) >= 0;
	}

	function isForex(selectedProduct){
		return [CommonConstants.VIEW.forex,CommonConstants.VIEW.watchedForex].indexOf(selectedProduct) >= 0;
	}
}]);

'use strict';

recogniaApp.controller('InstrumentLookupCtrl',
['$scope', 'HostedWebsite', 'Lexicon',
function ($scope, HostedWebsite, Lexicon) {

	$scope.symbol = '';
	$scope.text = {};
	$scope.hideIndexSelector = false;

	/* Default is build the event_lookup URI and redirect */
	var search = function(symbol, exchange) {
		var url = HostedWebsite.pageUrl(
			'event_lookup',
			'instrument_type=' + exchange.type +
				'&exchange=' + exchange.exchange +
				'&symbol=' + encodeURIComponent(symbol)
		);
		window.location = url;
	};

	/* override defaults with passed config */
	if ($scope.config) {
		if ($scope.config.hideIndexSelector) {
			$scope.hideIndexSelector = $scope.config.hideIndexSelector;
		}
		if ($scope.config.search) {
			search = $scope.config.search;
		}
	}

	/* Handle clicking search on symbol entry */
	$scope.$on('search', function(e, symbol, exchange) {
		if (symbol) {
			search(symbol, exchange);
		} else {
			alert(Lexicon.translateDefaultNS('instrument_lookup.missing-symbol'));
		}
		e.stopPropagation();
	});
	// cancel other messages
	$scope.$on('exchangeChanged', function(e) { e.stopPropagation(); });
	$scope.$on('symbolChanged', function(e) { e.stopPropagation(); });

	/* Handle selecting index from dropdown */
	$scope.searchIndex = function(index) {
		search(index.symbol, index);
	};

	$scope.text.indexSelector = Lexicon.translateDefaultNS('instrument_lookup.index-selector');

	/* Get the list if indexes for dropdown */
	HostedWebsite.instrumentLookupIndexes(function (data) {
		$scope.indexes = data;
	});

	/*drop down: set keyboard listener for tab key and shift+tab key
	 * to close the button
	 */
	$scope.buttonOnKeyDown = function ($event) {
		//close dropdown menu when press shift + tab
		if ($event.keyCode === 9 && $event.shiftKey&&$(".dropdown-menu:visible").size()) {
			$(this).dropdown("toggle");
		}
		else if($event.keyCode === 9&&$(".dropdown-menu:visible").size()){
			$(this).dropdown("toggle");
		}
	};

	$scope.dropdownOnKeyDown = function ($event) {
		//close dropdown menu when press shift + tab
		if($event.keyCode === 9&&$(".dropdown-menu:visible").size()){
			$(this).dropdown("toggle");
		}
	};
}]);

'use strict';

recogniaApp.controller('OptionsIdeasCsvCtrl',
['$scope', 'HostedWebsite', 'OptionsIdeasCsv', 'Lexicon',
function ($scope, HostedWebsite, OptionsIdeasCsv, Lexicon) {
	$scope.dates = {
		format: HostedWebsite.programmingFieldValue('DateFormat'),
		min: HostedWebsite.programmingFieldValue('TodayDate')
	};
	$scope.target = 'custom';
	$scope.price = 1.0;
	$scope.eventId = '';
	$scope.output = '';

	var search = function(symbol, exchange) {
		HostedWebsite.instrumentDetails(symbol, exchange.exchange, exchange.type, function(data) {
			if (data.length === 1) {
				$scope.output = 'Finding options ideas for ' + data[0].Name;
				var params;
				if ($scope.target === 'custom') {
					params = {
						target: $scope.price,
						date:   $scope.dates.begin,
						date2:  $scope.dates.end,
						period: 'day',
						source: 'target'
					};
				} else {
					params = {
						event: $scope.eventId,
						source: 'event'
					};
				}

				OptionsIdeasCsv.instrumentIdeas(data[0].Id, params,
					function (data) {

						var blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
						//works on IE
						if (navigator.msSaveBlob) {
							navigator.msSaveBlob(blob, "options_ideas.csv");
						} else {
							var link = document.createElement("a");
							if (link.download !== undefined) { // feature detection
								// Browsers that support HTML5 download attribute
								var url = URL.createObjectURL(blob);
								link.setAttribute("href", url);
								link.setAttribute("download", "options_ideas.csv");
								link.style = "visibility:hidden";
								document.body.appendChild(link);
								link.click();
							document.body.removeChild(link);
							}
						}
						$scope.output = 'Finished finding options ideas.';
					},
					function (data) { $scope.output = data.error.developerMessage; });
			} else if (data.length === 0) {
				$scope.output = 'No instrument found.';

			} else {
				var instruments = '';
				for (var i = 0; i < data.length; i++) {
					instruments += '\n' + data[i].DisplaySymbol + ':' + data[i].DisplayExchange +
						' ' + data[i].Name;
				}
				$scope.output = 'Multiple instruments found:' + instruments;
			}
		});
	};

	/* Handle clicking search on symbol entry */
	$scope.$on('search', function(e, symbol, exchange) {
		if (symbol) {
			search(symbol, exchange);
		} else {
			alert(Lexicon.translateDefaultNS('instrument_lookup.missing-symbol'));
		}
		e.stopPropagation();
	});
	// cancel other messages
	$scope.$on('exchangeChanged', function(e) { e.stopPropagation(); });
	$scope.$on('symbolChanged', function(e) { e.stopPropagation(); });
}]);

'use strict';

recogniaApp.controller('OptionsLookupCtrl',
['$scope', '$timeout', 'HostedWebsite', 'REST', 'OptionsStrategy', 'Ideas', 'CommonConstants',
function ($scope, $timeout, HostedWebsite, REST, OptionsStrategy, Ideas, CommonConstants) {

	var allIdeas = [], comparableIdeas, selectedTradeIdeaIndex;

	function days_between(date1, date2) {

		// The number of milliseconds in one day
		var ONE_DAY = 1000 * 60 * 60 * 24;

		// Convert both dates to milliseconds
		var date1_ms = date1.getTime();
		var date2_ms = date2.getTime();

		// Calculate the difference in milliseconds
		var difference_ms = Math.abs(date1_ms - date2_ms);

		// Convert back to days and return
		return Math.round(difference_ms/ONE_DAY);
	}

	function array_highlighter(arrayOfObj, searchStr, fieldList) {
		for (var i = 0; i < arrayOfObj.length; i++) { arrayOfObj[i] = highlight_matches(arrayOfObj[i], searchStr, fieldList); }
		return arrayOfObj;
	}

	function highlight_matches(contentObj, searchStr, fieldList) {
		var searchRegEx = new RegExp( "(\\b" + searchStr + ")", "gi"); //not being used atm
		Object.keys(contentObj).forEach(function (property) {
			var found = false;
			for (var i = 0; i < fieldList.length && !found; i++) {
				if (fieldList[i] === property) {
					found = true;
				}
			}
			if ( (typeof contentObj[property] === 'string') && (found === true) ) {
				contentObj[property] = contentObj[property].replace( searchRegEx, '<strong>$1</strong>');
			}
		});
		return contentObj;
	}

	$scope.selectAutoSuggestRow = function(index, id) {
		$scope.selectedInstrumentId = id;
		$scope.selectedRowIndex = index;
	};

	$scope.showCompareLimit = false;
	$scope.text = {
		errorDismiss: 'Dismiss'
	};

	$scope.initializeModal = function() {
		$scope.comparableIdeasModal = 'compare_ideas/template.html';
		Ideas.compared.get({ expand: 'idea(event,strategy,instrument(exchange,sector,quote),optionsContract(quote),optionsStrategy)' })
		.then(function () {
			$scope.comparableIdeas = Ideas.compared.list();
			$scope.$broadcast('updateCompareIdeas', comparableIdeas);
		});
	};

	$scope.autoSuggest = [];
	var _timeout;

	$scope.getAutoSuggestResults = function() {
		if ( (typeof $scope.searchSymbol === 'undefined')
				|| ( $scope.searchSymbol === '' )
				|| ( $scope.searchSymbol === null )
		) { return; }
		$scope.selectedRowIndex = null;
		var optionable  = $scope.optionableSearch  === true ? true : false;
		var fundamental = $scope.fundamentalSearch === true ? true : false;

		if ( _timeout ) { $timeout.cancel(_timeout); }
		 _timeout = $timeout(
			function() {
				REST.Search(
					$scope.searchSymbol,
					optionable,
					fundamental,
					$scope.limit
				).then( function(response) {
					$scope.autoSuggest = array_highlighter(
						response.data.result.items,
						$scope.searchSymbol,
						["symbol", "name", "exchangeSymbol"]
					);
					_timeout = null;
				} );
			},
			100
		);

	};

	// Methods for the alternative trades modal to get/set the alternative that was clicked.
	// If it accessed them directly, then it would be accessing its own scope's copy, and wouldn't
	// get the right selection after being dismissed and re-opened.
	selectedTradeIdeaIndex = 0;
	$scope.getSelectedTradeIdea = function() {
		return comparableIdeas[selectedTradeIdeaIndex];
	};
	$scope.setSelectedTradeIdea = function(idea) {
		var i;
		for (i = 0; i < comparableIdeas.length; i++) {
			if (comparableIdeas[i] === idea) {
				selectedTradeIdeaIndex = i;
				break;
			}
		}
	};

	// Updated ideas and status for compared
	function updateCompared() {
		$scope.comparedCount = Ideas.compared.count();
		allIdeas.forEach(function (idea) {
// FIXME: figure out proper representation of idea
			idea.isCompared = Ideas.compared.isCompared({'idea': idea});
		});
	}


	//TODO there should be an api to get these values
	$scope.scores = [
		{
			name: 'Any Score',
			value: ''
		},
		{
			name: 'AAA Only',
			value: 'ANY:AAA'
		},
		{
			name: 'AA and above',
			value: 'ANY:AA:AAA'
		},
		{
			name: 'A and above',
			value: 'ANY:A:AA:AAA'
		}
	];
	$scope.scoreParam = $scope.scores[0];

	var now = new Date();
	var dates = [];
	for (var i = 3; i <= 12; i += 3) {
		var date = new Date(now.setMonth(now.getMonth() + i));
		var dateStr = date.getFullYear() + '-';
		if (date.getMonth()<9) {
			dateStr += '0';
		}
		dateStr +=(date.getMonth() + 1) + '-';
		if (date.getDate()<10) {
			dateStr += '0';
		}
		dateStr += date.getDate();

		dates.push(dateStr);
	}

	$scope.sortOrder = [

		{
			name: 'Highest Score',
			value: 'sort;score:desc,absolute-reward-risk:desc'
		}, {
			name: 'Best Reward to Risk',
			value: 'sort;absolute-reward-risk:desc,score:desc'
		}, {
			name: 'Lowest Possible Loss',
			value: 'sort;max-loss-percent:asc,max-loss:asc,score:desc'
		}, {
			name: 'Highest Target Profit ',
			value: 'sort;target-profit-percent:desc,target-profit:desc,absolute-reward-risk:desc'
		}, {
			name: 'Nearest Profit Zone',
			value: 'nearest-profit-zone:asc,score:desc'
		}, {
			name: 'Lowest Cost',
			value: 'net-cost:desc,score:desc'
		}, {
			name: 'Shortest Term',
			value: 'expiry:asc,score:desc'
		}, {
			name: 'Longest Term',
			value: 'expiry:desc,score:desc'
		}
	];
	$scope.sortParam = $scope.sortOrder[0];

	$scope.timeHorizon = [
		{
			name: 'Any Time Horizon',
			value: ''
		},
		{
			name: 'Within 3 months',
			value: 'LE:' + dates[0]
		},
		{
			name: '3-6 months',
			value: 'BETWEEN:' + dates[0] + ':' + dates[1]
		},
		{
			name: '6-9 months',
			value: 'BETWEEN:' + dates[1] + ':' + dates[2]
		},
		{
			name: '9-12 months',
			value: 'BETWEEN:' + dates[2] + ':' + dates[3]
		},
		{
			name: 'Greater than 12 months',
			value: 'GE:' + dates[3]
		}
	];
	$scope.timeParam = $scope.timeHorizon[0];

	$scope.budget = [
		{
			name: 'Any Budget',
			value: ''
		},
		{
			name: 'Less than 500',
			value: 'LE:500'
		},
		{
			name: '500 - 1000',
			value: 'BETWEEN:500:1000'
		},
		{
			name: '1000 - 3000',
			value: 'BETWEEN:1000:3000'
		},
		{
			name: '3000 - 5000',
			value: 'BETWEEN:3000:5000'
		},
		{
			name: '5000 - 10000',
			value: 'BETWEEN:5000:10000'
		},
		{
			name: 'Greater than 10000',
			value: 'GE:10000'
		}
	];
	$scope.budgetParam = $scope.budget[0];

	$scope.openInterest = false;

	$scope.volume = false;

	$scope.rewardRisk = [
		{
			name: 'At least 1:1',
			value: 'GE:1'
		},
		{
			name: 'At least 2:1',
			value: 'GE:2'
		},
		{
			name: 'At least 3:1',
			value: 'GE:3'
		}
	];
	$scope.rewardRiskParam = $scope.rewardRisk[0];


		// Initialise list of expand trade strategies
		REST.OptionsStrategiesExpand().then(function (response) {
			$scope.strategies = [{
				strategyId: '',
				name: 'Any strategy'
			}].concat(response.data.result.optionsStrategies);

			$scope.strategyParam = [$scope.strategies[0].strategyId];
		});


	// Initialise compared ideas
	$scope.comparedCount = 0;
	$scope.maxComparedCount = Ideas.compared.MAX_COUNT;
	Ideas.compared.get({expand: 'idea'});
	// Watch for remove events from the compare modal
	$scope.$on(Ideas.compared.IDEAS_UPDATED, updateCompared);

	$scope.message = '';

	$scope.toggleCompared = function (idea) {
// FIXME: figure out proper representation of idea
		var promise = idea.isCompared
			? Ideas.compared.add({'idea': idea})
			: Ideas.compared.remove({'idea': idea});

		promise.then(function () {
			// handled by IDEAS_UPDATED
		}, function (reason) {
			if (typeof(reason) === "object" && typeof(reason.data) === "object" && typeof(reason.data.error) === "object"
				&& reason.data.error.code === CommonConstants.ERROR_CODE.limit_exceeded
			) {
				$scope.text.errorHeader = 'Compare Limit';
				$scope.text.error = 'You may only compare 4 trade ideas at a time. Remove a trade idea from your compare list to add this trade idea.';
				$scope.showErrorModal = true;
			} else {
				$scope.text.errorHeader = 'Request Failed';
				$scope.text.error = 'Please try again later.';
				$scope.showErrorModal = true;
			}
			updateCompared();
		});
	};

	$scope.search = function () {
		if ( ($scope.selectedInstrumentId === '')
				|| ($scope.selectedInstrumentId === null)
					|| (typeof $scope.selectedInstrumentId === 'undefined')
		) { return; }
		$scope.message = '';
		var params = {
			expand: 'idea(event,strategy,instrument(exchange,sector,quote),optionsContract(quote),optionsStrategy)',
			uid:'MeVhBjW+PD5GIAYeYRXgPWbr+zVzSsD1vTFTK5GdAOY8lS6ZvdIJ/AG6H2h+Pad85hurwTUZ97IuNaX9h6GB42Q='
		};
		// if (!$scope.symbol){
		// 	$scope.message = 'Please enter a symbol.';
		// 	return;
		// }
		var strategiesList = '';

		for (var s in $scope.strategyParam) {
			if ($scope.strategyParam[s]) {
				if (strategiesList) {
					strategiesList += ':';
				}
				strategiesList += $scope.strategyParam[s];
			}
		}

		if (strategiesList) params.strategy = 'ANY:' + strategiesList;
		if ($scope.scoreParam.value) params['score-grade'] = $scope.scoreParam.value;
		if ($scope.budgetParam.value) params['net-cost'] = $scope.budgetParam.value;
		if ($scope.timeParam.value) params.expiry = $scope.timeParam.value;
		if ($scope.rewardRiskParam.value) params['absolute-reward-risk'] = $scope.rewardRiskParam.value;
		if ($scope.volume) params.volume = 1;
		if ($scope.openInterest) params['open-interest'] = 1;
		params.sort = $scope.sortParam.value;

		$scope.ideaResults = {};
		$scope.meta = {};

		var instrumentId = $scope.selectedInstrumentId.slice($scope.selectedInstrumentId.lastIndexOf('/')+1);

		REST.InstrumentOptionsIdeas(instrumentId, params)
		.then(function (response) {
			allIdeas = response.data.result.ideas;
			updateCompared();
			$scope.message = 'Found ' + allIdeas.length + ' ideas.';
			allIdeas.forEach(function (idea) {
				var targetKey = Number(Ideas.getConservativeTargetPrice(idea)).toFixed(2);
				if (!$scope.ideaResults[targetKey]) {
					$scope.ideaResults[targetKey] = {};
					$scope.meta[targetKey] = {};
					$scope.meta[targetKey]._horizonLexKey = 'eventdetails.' + idea.events[0].tradingHorizon;
					$scope.meta[targetKey]._stratNames = {};
				}
				if ($scope.meta[targetKey]._stratNames[idea.strategy.name] === undefined) {
					$scope.meta[targetKey]._stratNames[idea.strategy.name] = 0;
				}
				$scope.meta[targetKey]._stratNames[idea.strategy.name] += 1;
				if (!$scope.ideaResults[targetKey][idea.trade.tradeStrategy.name]) {
					$scope.ideaResults[targetKey][idea.trade.tradeStrategy.name] = [];
				}

				idea.daysToExpire = 0;

				for (var legName in idea.trade.legs) {
					if (idea.trade.legs[legName].instrument.expiryDate) {
						var expiryDate = new Date(Date.parse(idea.trade.legs[legName].instrument.expiryDate));
						idea.daysToExpiry = days_between(expiryDate, new Date(Date.now()));
					}
				}
				$scope.ideaResults[targetKey][idea.trade.tradeStrategy.name].push(idea);
			});
		});
	};

}]);

'use strict';

/*
 * This is the settings windows that is shown when the user clicks on Custom Settings
 */
recogniaApp.controller('PersonalSettingsCtrl',
['$scope', '$q', 'REST', 'Config', 'Lexicon', 'SettingsTemplate', 'DateFormatter', 'GoogleAnalytics', 'Broadcast', 'PSBeforeApp', 'UserPreferences',
function ($scope, $q, REST, Config, Lexicon, SettingsTemplate, DateFormatter, GoogleAnalytics, Broadcast, PSBeforeApp, UserPreferences) {
	var thisCtrl = this;

	$scope.showPersonalSettings = PSBeforeApp.shouldShowSettingsBeforeApp();

	var preferenceBackup = {};
	var promiseList;

	/**
	 * Update the content of the custom settings based on the product
	 */
	function updateCustomSettings() {
		promiseList = [
			SettingsTemplate.getSettings($scope.selectedProduct)
		];

		$q.all(promiseList).then(function (responses) {
			preferenceBackup = angular.copy(UserPreferences.getUserPreferences());

			if (UserPreferences.getUserPreferences().settings === null) {
				UserPreferences.getUserPreferences().settings = {};
				//UserPreferences.setUserPreferences(UserPreferences.getUserPreferences());
			}

			$scope.groupsTranslated = responses[0].map(function (group){
				return {
					name: group.name,
					// FIXME this lexicon has html in it, could be avoided,
					// should be 2 separate keys
					subTitle: Lexicon.translateDefaultNS('personalization.' + group.subTitle),
					questions: group.questions
				};
			});

			// Only show message if there are no custom settings to display
			$scope.noPersonalSettings = null;
			if ($scope.groupsTranslated.length === 0) {
				$scope.noPersonalSettings = Lexicon.translateDefaultNS('personalsettings.no-personal-settings');
			}
		});
	}

	$scope.$watch('updateCustomSettings', function (newVal, oldVal) {
		if(newVal!==oldVal){
			updateCustomSettings();
		}
	});

	thisCtrl.save = function () {

		if (!angular.equals(UserPreferences.getUserPreferences(), preferenceBackup)) {

			UserPreferences.getUserPreferences().lastUpdate = DateFormatter.formatTimestampREST(new Date());
			preferenceBackup = angular.copy(UserPreferences.getUserPreferences());

			REST.put(UserPreferences.getUserPreferences()["linkId"], angular.toJson(UserPreferences.getUserPreferences()))
			.then(function () {
				Broadcast.sendSettingsChangedMessage();
			},
			function (reason) {
				console.error('Failed to update custom settings!');
				console.error(reason);
			})
			['finally'](function () {
				$scope.$emit('switchToApp');
			});

			GoogleAnalytics.sendEvent(
				'ideas-platform',
				'close-custom-settings',
				'changed'
			);
		} else {

			GoogleAnalytics.sendEvent(
				'ideas-platform',
				'close-custom-settings',
				'no-change'
			);
			$scope.$emit('switchToApp');
		}
	};

	$scope.standalone = Config.isStandalonePlatform();


	/**
	 * Function to restrict tab navigation to the popup window
	 */
	$scope.$on('tabdown', function( msg, obj ) {
		var selectedAttrs = angular.element(document.activeElement)[0].attributes;
		if (selectedAttrs.id !== undefined) {
			var selectedId = selectedAttrs.id.value;
			if (!obj.shiftKey && (selectedId === $scope.lastTab)) {
				angular.element.find('#' + $scope.firstTab)[0].focus();
				event.preventDefault();
			} else if (obj.shiftKey && (selectedId === $scope.firstTab)) {
				angular.element.find('#' + $scope.lastTab)[0].focus();
				event.preventDefault();
			}
		}
	});
}]);

/**
 * Wrapper to conditionally show custom settings before some content
 */
recogniaApp.directive('showSettingsFirstWrapper',
['PSBeforeApp',
function(){
	return {
		scope: {
			showSettingsFirstWrapper: '&'
		},
		controller: ['$scope', 'PSBeforeApp',
		function ($scope, PSBeforeApp) {
			function setShowing(shouldShow){
				$scope.showSettingsBeforeApp = shouldShow;
				PSBeforeApp.setShowSettingsBeforeApp(shouldShow);
			}
			setShowing($scope.showSettingsFirstWrapper());

			$scope.$on('switchToApp', function (event){
				setShowing(false);
				event.stopPropagation();
			});
		}]
	};
}]);

/**
 * This is used to communicate between the wrapper controller and the modal
 * controller
 */
recogniaApp.factory('PSBeforeApp', function () {
	var showSettingsBeforeApp = false;
	return {
		setShowSettingsBeforeApp: function(show){
			showSettingsBeforeApp = show;
		},
		shouldShowSettingsBeforeApp: function(){
			return showSettingsBeforeApp;
		}
	};
});

'use strict';

/*
 * This is the questionaire that pops up when the user first logs in
 */
recogniaApp.controller('QuestionnaireCtrl',
['$scope', '$q', 'REST', 'Lexicon', 'Config', 'Broadcast', 'SettingsTemplate', 'ArrayUtil' , 'DateFormatter','CommonConstants', 'UserPreferences' ,
function ($scope, $q, REST, Lexicon, Config, Broadcast, SettingsTemplate, ArrayUtil, DateFormatter, CommonConstants, UserPreferences) {

	var DAYS_BETWEEN_POPUP = 2;

	// Scope boolean used to determine whether to update ideas main page or not
	$scope.updateIdeasPage = false;
	$scope.showProfileQuestionnaire = false;

	var link,
		groupNumber = 0,
		preferenceBackup = {},
		items = {};

	// This is a preference where user clicks 'Don’t Ask Again'
	// The pop-up will never appear again, saving all answered questions and nulls for unanswered questions
	var dontAskAgainPreference = {};

	var promiseList = [
		REST.ExpandedUserPreferences('productPreferences'),
		REST.ExpandedPersonalizedSettingsDefinition('personalizedProductSettingsDefinition'),
		REST.CountriesWithExchanges()
	];

	var firstTimeLogin = function () {
		if ($scope.links !== undefined) {
			for (var j = 0; j < $scope.links.length; j++) {
				$scope.links[j].settings = {};
			}
		}
		persistPreferences();
		$scope.showProfileQuestionnaire = false;
	};

	$q.all(promiseList).then(function (responses) {
		$scope.links = [];
		items = {};
		var settings;

		if (responses[0].data.result.stocksPreferences !== undefined && responses[1].data.result.stocksSettings !== undefined) {
			settings = SettingsTemplate.updateSettings(responses[1].data.result.stocksSettings.settings, responses[2].data.result.countries);
			items['stocks'] = {
				preference: responses[0].data.result.stocksPreferences,
				setting: settings
			};
			$scope.links.push(items.stocks.preference);
		}
		if (responses[0].data.result.optionsPreferences !== undefined && responses[1].data.result.optionsSettings !== undefined) {
			settings = SettingsTemplate.updateSettings(responses[1].data.result.optionsSettings.settings, responses[2].data.result.countries);
			items['options'] = {
				preference: responses[0].data.result.optionsPreferences,
				setting: settings
			};
			$scope.links.push(items.options.preference);
		}
		if (responses[0].data.result.forexPreferences !== undefined && responses[1].data.result.forexSettings !== undefined) {
			settings = SettingsTemplate.updateSettings(responses[1].data.result.forexSettings.settings, responses[2].data.result.countries);
			items['forex'] = {
				preference: responses[0].data.result.forexPreferences,
				setting: settings
			};
			$scope.links.push(items.forex.preference);
		}
		// get the latest last_update date out of all the different products
		var lastUpdate = findLatestLastUpdate(items);

		for (var item in items){
			if (items.hasOwnProperty(item)) {
				if (!items[item].preference.dismissPersonalization) {
					preferenceBackup = angular.copy(UserPreferences.getUserPreferences());

					if (UserPreferences.getUserPreferences().settings === null) {
						UserPreferences.getUserPreferences().settings = {};
						UserPreferences.setUserPreferences(UserPreferences.getUserPreferences());
					}
					link = UserPreferences.getUserPreferences()["linkId"];
					dontAskAgainPreference = angular.copy(UserPreferences.getUserPreferences());

					var days = 0;
					if (UserPreferences.getUserPreferences().lastUpdate === null) {
						// Hide pop-up for first time login.
						firstTimeLogin();
					} else {
						var hours = getHoursFromTimestamp(lastUpdate);
						days = Math.round(hours / 24);
					}

					if (days > DAYS_BETWEEN_POPUP) {
						$scope.showProfileQuestionnaire = true;

						$scope.groups = items[item].setting;

						// Selects the group of question which hasn't been answered
						// Loop through all the groups
						var showPopup = false;
						for (var group = 0; group < $scope.groups.length; group++) {
							var skip = false;
							// Loop through all the questions in that group
							for (var k = 0; k < $scope.groups[group].questions.length; k++) {
								// Check if the user has already answered that question
								for (var answer in UserPreferences.getUserPreferences().settings) {
									if ($scope.groups[group].questions[k]["linkId"] === answer) {
										skip = true;
										// Exit current loop if the user has answered any single question
										break;
									}
								}
								// Exit current loop if the user has answered any question from this group
								if (skip) {
									break;
								}
							}
							if (!skip) {
								showPopup = true;
								// If user hasn't answered this group of questions, then select this group
								groupNumber = group;
								// Set dismiss to true if its the last group remaining
								if (group === ($scope.groups.length - 1)) {
									UserPreferences.getUserPreferences().dismissPersonalization = true;
								}
								// Exit Loop - we have a question to display
								break;
							}
							// This is security check for dismissPersonalization boolean
							if (group >= ($scope.groups.length - 1)) {
								$scope.showProfileQuestionnaire = false;
							}
						}
						if (showPopup) {
							$scope.questions = $scope.groups[groupNumber].questions;
							$scope.title = $scope.groups[groupNumber].name;
							$scope.settingsTitle = Lexicon.translateDefaultNS('personalization.' + $scope.title);

							$scope.subtitle = $scope.groups[groupNumber].subTitle;
							$scope.settingsSubtitle = Lexicon.translateDefaultNS('personalization.' + $scope.subtitle);
							for (var i = 0; i < $scope.questions.length; i++) {
								var questionId = $scope.questions[i]["linkId"];
								if (!UserPreferences.getUserPreferences().settings.hasOwnProperty(questionId)) {
									UserPreferences.getUserPreferences().settings[questionId] = [];
								}
							}
							break;
						}
					}
				}
			}
		}
	});


	function getHoursFromTimestamp(timestamp) {
		var lastupdate_UTC = DateFormatter.getEpoch(timestamp),
			now_UTC = (new Date()).getTime(),
			dateDifference = now_UTC - lastupdate_UTC,
			seconds = Math.abs(dateDifference) / 1000,
			minutes = Math.round(seconds / 60),
			hours = Math.round(minutes / 60);
		return hours;
	}

	function findLatestLastUpdate(items) {
		var lastUpdate = null;

		for (var item in items) {
			if (items[item].preference.lastUpdate === null) continue;

			if (lastUpdate === null) {
				lastUpdate = items[item].preference.lastUpdate;
			} else {
				var lastUpdateHours = getHoursFromTimestamp(lastUpdate);
				var newUpdateHours = getHoursFromTimestamp(items[item].preference.lastUpdate);
				if (lastUpdateHours > newUpdateHours) {
					lastUpdate = items[item].preference.lastUpdate;
				}
			}
		}

		return lastUpdate;
	}

	function persistPreferences () {
		for(var j = 0; j < $scope.links.length; j++){
			$scope.links[j].lastUpdate = DateFormatter.formatTimestampREST(new Date());

			REST.put($scope.links[j]["linkId"], JSON.stringify($scope.links[j])).success(function (data, status) {
				$scope.status = status;
			}).error(function (data, status) {
				$scope.status = status;
				$scope.data = data || "Request failed";
			});
		}
	}

	function persistSinglePreferences (preferences) {
		preferences.lastUpdate = DateFormatter.formatTimestampREST(new Date());

		if (preferences.settings.currencyPairs) {
			preferences.settings.currencyPairs.forEach(function(currencyPair) {
				if (currencyPair.hasOwnProperty('$$hashKey')) {
					delete currencyPair['$$hashKey'];
				}
			});
		}

		REST.put(link, JSON.stringify(preferences)).success(function (data, status) {
			$scope.status = status;
		}).error(function (data, status) {
			$scope.status = status;
			$scope.data = data || "Request failed";
		}).then(function() {
			$scope.updateIdeasPage = !$scope.updateIdeasPage;
			$scope.updateCustomSettings = !$scope.updateCustomSettings;
		});
	}

	$scope.saveEmpty = function () {
		if ($scope.groups !== undefined) {
			for (var j = 0; j < $scope.groups.length; j++) {
				for (var i = 0; i < $scope.groups[j].questions.length; i++) {
					var questionId = $scope.groups[j].questions[i]["linkId"];
					if (!dontAskAgainPreference.settings.hasOwnProperty(questionId)) {
						dontAskAgainPreference.settings[questionId] = [];
					}
				}
			}
		}
		if ($scope.links !== undefined) {
			for (var link = 0; link < $scope.links.length; link++) {
				$scope.links[link].dismissPersonalization = true;
			}
		}
		persistSinglePreferences(dontAskAgainPreference);
		persistPreferences();
		$scope.showProfileQuestionnaire = false;
	};

	$scope.save = function () {
		if (JSON.stringify(UserPreferences.getUserPreferences()) !== JSON.stringify(preferenceBackup)) {
			persistSinglePreferences(UserPreferences.getUserPreferences());
		}
		$scope.showProfileQuestionnaire = false;
	};

	// update ideas page when this changes
	$scope.$watch('updateIdeasPage', function() {
		if ($scope.updateIdeasPage === true) {
			Broadcast.sendSettingsChangedMessage();
		}
	});

}]);

//
angular.module('recognia').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('alternative_trades/template_desktop.html',
    "<div ng-controller=\"AlternativeTradesCtrl\">\n" +
    "\t<div id=\"compare_strat_header\" class=\"alternative-strategy\">\n" +
    "\t\t<div class=\"alt_strat_title_bar\">\n" +
    "\t\t\t<h1>{{compareTitle}} <span ng-hide=\"isCompare\">{{featured.idea.instrument.name}}</span></h1>\n" +
    "\t\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" id=\"focusId\" data-tabindex=\"1\">&times;</button>\n" +
    "\t\t</div>\n" +
    "\t\t<hr/>\n" +
    "\t\t<hr/>\n" +
    "\t\t<div class=\"alternative-strategy header\" ng-class=\"viewSplit\" ng-repeat=\"feature in comparableIdeas\"\n" +
    "\t\t\t ng-init=\"tradevar=feature.idea.trade.legs; expired=feature.isExpired; sectionIndex = $index * 2 \">\n" +
    "\n" +
    "\t\t\t<div class=\"compare-ideas-expired\" ng-hide=\"!expired\">\n" +
    "\t\t\t\t<div class=\"compare-ideas-instrument\">{{feature.idea.instrument.name}} ({{feature.idea.instrument.symbol}})</div>\n" +
    "\t\t\t\t<div>&nbsp;</div>\n" +
    "\t\t\t\t<div>&nbsp;</div>\n" +
    "\t\t\t\t<div class=\"compare-ideas-invalid\">{{invalidTrade}}\n" +
    "\t\t\t\t\t<div class=\"compare-ideas-remove\">\n" +
    "\t\t\t\t\t\t<div class=\"icon-compare-ideas-remove\"><i class=\"fa fa-times-circle\" ng-click=\"removeIdea($index)\"></i></div>\n" +
    "\t\t\t\t\t\t<div class=\"compare-ideas-remove-text\">{{remove}}</div>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\n" +
    "\t\t\t<div class=\"compare-ideas-header-content-wrap\" ng-hide=\"expired\">\n" +
    "\t\t\t\t<div ng-hide=\"!isCompare\">\n" +
    "\t\t\t\t\t<div class=\"icon-compare-ideas-remove\"><i class=\"fa fa-times-circle\" ng-click=\"$emit('removeIdea', featured, $index)\"></i></div>\n" +
    "\t\t\t\t\t<div class=\"compare-ideas-instrument\">{{feature.idea.instrument.name}} ({{feature.idea.instrument.symbol}})</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<div class=\"compare-ideas-score-name\">{{'fsTarget.target_score_' + feature.idea.trade.scoreGrade | lexicon}}</div>\n" +
    "\t\t\t\t<div class=\"compare-ideas-strategy\">{{feature.idea.trade.tradeStrategy.name}}</div>\n" +
    "\n" +
    "\t\t\t\t<div class=\"modal-chart\" ng-init=\"chartConfig=initializeProfitLossChartConfig(feature.idea.trade)\">\n" +
    "\t\t\t\t\t<div highstocks-enhanced id=\"chart-{{ideaId}}\" config=\"chartConfig\" reflow=\"reflow\"></div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<div class=\"as-modal-chart-footer\">\n" +
    "\t\t\t\t\t<span class=\"watch-btn-wrapper\">\n" +
    "\t\t\t\t\t\t<span watch-button idea=\"feature\" widget=\"{{ isCompare ? 'compared' : 'alternatives' }}\" counter=\"$index\"/>\n" +
    "\t\t\t\t\t</span>\n" +
    "\t\t\t\t</div>\n" +
    "\n" +
    "\t\t\t\t<p class=\"small\">{{compareText['expiry-sub-heading']}} {{feature.earliestExpiryDate}}</p>\n" +
    "\n" +
    "\t\t\t\t<div class=\"alternative-trade-legs\">\n" +
    "\t\t\t\t\t<table>\n" +
    "\t\t\t\t\t\t<tr ng-repeat=\"leg in feature.idea.trade.legs | tradeLegSort:feature.idea.trade\">\n" +
    "\t\t\t\t\t\t\t<td class=\"trade-action\">\n" +
    "\t\t\t\t\t\t\t\t<div>{{ 'featuredoptions.' + leg.action | lexicon | uppercase }}</div>\n" +
    "\t\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t\t<td>\n" +
    "\t\t\t\t\t\t\t\t<div>{{ leg | tradeLegOneLineFormat:instrument.precision:true }}</div>\n" +
    "\t\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t</table>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<span ng-init=\"idea=feature.idea;permission=permission\" ng-include=\"'instrument_action/alternative_trades.html'\"></span>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "\t<br style=\"clear: both;\">\n" +
    "\n" +
    "\t<div class=\"modal-body\" ng-hide=\"hideTable\">\n" +
    "\t\t<!--Header-->\n" +
    "\t\t<div id=\"alt_strat_body\">\n" +
    "\t\t\t<div ng-class=\"viewSplit\">\n" +
    "\t\t\t\t<table class=\"compare-strategy\" title=\"\">\n" +
    "\t\t\t\t\t<tr class=\"row-header\">\n" +
    "\t\t\t\t\t\t<th colspan=\"2\">\n" +
    "\t\t\t\t\t\t\t{{compareText['to-open']}}\n" +
    "\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t\t<th ng-repeat=\"feature in comparableIdeas\" ng-hide=\"$first\"></th>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th class=\"compare-strat-short\">{{compareText['net-cost-in-total']}}</th>\n" +
    "\t\t\t\t\t\t<td ng-repeat=\"feature in comparableIdeas\"\n" +
    "\t\t\t\t\t\t\tng-class=\"{'compare-strat-short': $first, 'expired-data': feature.isExpired}\">\n" +
    "\t\t\t\t\t\t\t\t{{ {true: \"--\",\n" +
    "\t\t\t\t\t\t\t\tfalse: (feature.idea.trade.netCost | formatCurrency:instrument.precision)}\n" +
    "\t\t\t\t\t\t\t\t[feature.idea.trade.tradeStrategy.isNetCredit] }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th class=\"compare-strat-short\">{{compareText['net-cost-per-share']}}</th>\n" +
    "\t\t\t\t\t\t<td ng-repeat=\"feature in comparableIdeas\"\n" +
    "\t\t\t\t\t\t\tng-class=\"{'compare-strat-short': $first, 'expired-data': feature.isExpired}\">\n" +
    "\t\t\t\t\t\t\t\t{{ {true: \"--\",\n" +
    "\t\t\t\t\t\t\t\tfalse: (feature.idea.perShareValues.netCost | formatCurrency:instrument.precision)}\n" +
    "\t\t\t\t\t\t\t\t[feature.idea.trade.tradeStrategy.isNetCredit] }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th class=\"compare-strat-short\">{{compareText['net-received-in-total']}}</th>\n" +
    "\t\t\t\t\t\t<td ng-repeat=\"feature in comparableIdeas\"\n" +
    "\t\t\t\t\t\t\tng-class=\"{'compare-strat-short': $first, 'expired-data': feature.isExpired}\">\n" +
    "\t\t\t\t\t\t\t\t{{ {true: (feature.idea.trade.netCost * -1 | formatCurrency:instrument.precision),\n" +
    "\t\t\t\t\t\t\t\tfalse: \"--\"}[feature.idea.trade.tradeStrategy.isNetCredit] }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th class=\"compare-strat-short\">{{compareText['net-received-per-share']}}</th>\n" +
    "\t\t\t\t\t\t<td ng-repeat=\"feature in comparableIdeas\"\n" +
    "\t\t\t\t\t\t\tng-class=\"{'compare-strat-short': $first, 'expired-data': feature.isExpired}\">\n" +
    "\t\t\t\t\t\t\t\t{{ {true: (feature.idea.perShareValues.premiumReceived | formatCurrency:instrument.precision),\n" +
    "\t\t\t\t\t\t\t\tfalse: \"--\"}[feature.idea.trade.tradeStrategy.isNetCredit] }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t<tr class=\"row-header\">\n" +
    "\t\t\t\t\t\t<th colspan=\"2\">\n" +
    "\t\t\t\t\t\t\t{{compareText['risk']}}\n" +
    "\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t\t<th ng-repeat=\"feature in comparableIdeas\" ng-hide=\"$first\"></th>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th class=\"compare-strat-short\">{{compareText['max-loss-in-total']}}</th>\n" +
    "\t\t\t\t\t\t<td ng-repeat=\"feature in comparableIdeas\" ng-class=\"{'compare-strat-short': $first, 'expired-data': feature.isExpired}\">\n" +
    "\t\t\t\t\t\t\t{{(feature.idea.trade.maxLoss | formatCurrency:instrument.precision) || \"--\"}}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th class=\"compare-strat-short\">{{compareText['max-loss-per-share']}}</th>\n" +
    "\t\t\t\t\t\t<td ng-repeat=\"feature in comparableIdeas\" ng-class=\"{'compare-strat-short': $first, 'expired-data': feature.isExpired}\">\n" +
    "\t\t\t\t\t\t\t{{(feature.idea.perShareValues.maxLoss | formatCurrency:instrument.precision) || \"--\"}}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th class=\"compare-strat-short\">{{compareText['max-loss-as-a-percent']}}</th>\n" +
    "\t\t\t\t\t\t<td ng-repeat=\"feature in comparableIdeas\" ng-class=\"{'compare-strat-short': $first, 'expired-data': feature.isExpired}\">\n" +
    "\t\t\t\t\t\t\t{{(feature.idea.trade.maxLossPercent | nf_percent:0) || \"--\"}}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"row-header\">\n" +
    "\t\t\t\t\t\t<th colspan=\"2\">\n" +
    "\t\t\t\t\t\t\t{{compareText['reward']}}\n" +
    "\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t\t<th ng-repeat=\"feature in comparableIdeas\" ng-hide=\"$first\"></th>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th class=\"compare-strat-short\">{{compareText['target-price']}}</th>\n" +
    "\t\t\t\t\t\t<td ng-repeat=\"feature in comparableIdeas\" ng-class=\"{'compare-strat-short': $first, 'expired-data': feature.isExpired}\">\n" +
    "\t\t\t\t\t\t\t{{(feature.idea.targetPrice.target | formatCurrency:instrument.precision) || \"--\"}}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th class=\"compare-strat-short\">{{compareText['target-profit-in-total']}}</th>\n" +
    "\t\t\t\t\t\t<td ng-repeat=\"feature in comparableIdeas\" ng-class=\"{'compare-strat-short': $first, 'expired-data': feature.isExpired}\">\n" +
    "\t\t\t\t\t\t\t{{(feature.idea.trade.targetProfit | formatCurrency:instrument.precision) || \"--\"}}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th class=\"compare-strat-short\">{{compareText['target-profit-per-share']}}</th>\n" +
    "\t\t\t\t\t\t<td ng-repeat=\"feature in comparableIdeas\" ng-class=\"{'compare-strat-short': $first, 'expired-data': feature.isExpired}\">\n" +
    "\t\t\t\t\t\t\t{{(feature.idea.perShareValues.targetProfit | formatCurrency:instrument.precision) || \"--\"}}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th class=\"compare-strat-short\">{{compareText['return-on-investment']}}</th>\n" +
    "\t\t\t\t\t\t<td ng-repeat=\"feature in comparableIdeas\" ng-class=\"{'compare-strat-short': $first, 'expired-data': feature.isExpired}\">\n" +
    "\t\t\t\t\t\t\t{{(feature.idea.trade.targetProfitPercent | nf_percent:0) || \"--\"}}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th class=\"compare-strat-short\">{{'alternativetrades.reward-to-risk' | lexicon}}</th>\n" +
    "\t\t\t\t\t\t<td ng-repeat=\"feature in comparableIdeas\" ng-class=\"{'compare-strat-short': $first, 'expired-data': feature.isExpired}\">\n" +
    "\t\t\t\t\t\t\t{{(feature.idea.trade.rewardRiskRatio | realRoundedToPlaces:2) || \"--\" }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th class=\"compare-strat-short\">\n" +
    "\t\t\t\t\t\t\t<div style=\"word-break: break-all\">{{compareText['breakeven-point']}}</div>\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t<td ng-repeat=\"feature in comparableIdeas\" ng-class=\"{'compare-strat-short': $first, 'expired-data': feature.isExpired}\">{{\n" +
    "\t\t\t\t\t\t\t(breakEvenPoints[$index] | formatCurrency:instrument.precision) || \"--\" }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th class=\"compare-strat-short\">{{compareText['profit-zone']}}</th>\n" +
    "\t\t\t\t\t\t<td ng-repeat=\"feature in comparableIdeas\" ng-class=\"{'compare-strat-short': $first, 'expired-data': feature.isExpired}\">\n" +
    "\t\t\t\t\t\t\t<span ng-show=\"breakEvenPoints[$index]\">\n" +
    "\t\t\t\t\t\t\t\t{{ {true: compareText['below'] ,\n" +
    "\t\t\t\t\t\t\t\t\tfalse: compareText['above']}[feature.idea.trade.profitZone[0].lower == 0]  }}&nbsp;\n" +
    "\t\t\t\t\t\t\t{{ breakEvenPoints[$index] | formatCurrency:instrument.precision }}</span>\n" +
    "\t\t\t\t\t\t\t<span ng-show=\"breakEvenPoints[$index] == null\">\n" +
    "\t\t\t\t\t\t\t\t{{feature.idea.trade.profitZone[0].lower | formatCurrency:instrument.precision}}\n" +
    "\t\t\t\t\t\t\t&nbsp;-&nbsp;\n" +
    "\t\t\t\t\t\t\t{{ feature.idea.trade.profitZone[0].upper | formatCurrency:instrument.precision }}</span>\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t</table>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "\t<div class=\"footer-frame\"></div>\n" +
    "\n" +
    "</div>\n"
  );


  $templateCache.put('alternative_trades/template_mobile.html',
    "<div ng-controller=\"AlternativeTradesCtrl\">\n" +
    "\t<div class=\"alt_strat_title_bar\" >\n" +
    "\t\t<h1>{{compareTitle}} <span ng-hide=\"isCompare\">{{featured.idea.instrument.name}}</span></h1>\n" +
    "\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n" +
    "\t</div>\n" +
    "\t<div>\n" +
    "\t\t<table class=\"compare-tabs-container\">\n" +
    "\t\t\t<tr class=\"compare-tabs\">\n" +
    "\t\t\t\t<td ng-repeat=\"tradeIdea in comparableIdeas\"\n" +
    "\t\t\t\t\tng-class=\"{active: tradeIdea == getSelectedTradeIdea(), ledge: tradeIdea == getSelectedTradeIdea(), 'compare-tab': true}\"\n" +
    "\t\t\t\t\tng-click=\"updateSelectedIdea(tradeIdea)\" data-toggle=\"tab\">{{'fsTarget.target_score_' + tradeIdea.idea.trade.scoreGrade | lexicon}}<br/>{{tradeIdea.idea.trade.tradeStrategy.name}}</td>\n" +
    "\t\t\t\t<td class=\"horizontal-spacer\"></td>\n" +
    "\t\t\t</tr>\n" +
    "\t\t\t<tr class=\"compare-tabs-spacer\">\n" +
    "\t\t\t\t<td ng-repeat=\"tradeIdea in comparableIdeas\"\n" +
    "\t\t\t\t\tng-class=\"{active: tradeIdea == getSelectedTradeIdea(), ledge: tradeIdea == getSelectedTradeIdea(), 'compare-tab': true, first: $first}\"></td>\n" +
    "\t\t\t\t<td class=\"compare-tab horizontal-spacer\"></td>\n" +
    "\t\t\t</tr>\n" +
    "\t\t</table>\n" +
    "\t\t<div id=\"alt_strat_mobile_spacer\"></div>\n" +
    "\t\t<div id=\"alt_strat_header\" class=\"alternative-strategy\">\n" +
    "\t\t\t<div class=\"alt-mobile-header-content-wrap\">\n" +
    "\t\t\t\t<div class=\"modal-chart-mobile\">\n" +
    "\t\t\t\t\t<div highstocks-enhanced id=\"chart-{{ideaId}}\" config=\"chartConfig\">\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<div class=\"as-modal-chart-footer\">\n" +
    "\t\t\t\t\t<span class=\"watch-btn-wrapper\">\n" +
    "\t\t\t\t\t\t<span watch-button idea=\"getSelectedTradeIdea()\" widget=\"{{ isCompare ? 'compared' : 'alternatives' }}\" />\n" +
    "\t\t\t\t\t</span>\n" +
    "\t\t\t\t</div>\n" +
    "\n" +
    "\t\t\t\t<p class=\"small\">{{compareText['expiry-sub-heading']}} {{getSelectedTradeIdea().earliestExpiryDate}}</p>\n" +
    "\n" +
    "\t\t\t\t<div class=\"alternative-trade-legs\">\n" +
    "\t\t\t\t\t<table>\n" +
    "\t\t\t\t\t\t<tr ng-repeat=\"leg in getSelectedTradeIdea().idea.trade.legs | tradeLegSort:getSelectedTradeIdea().idea.trade\">\n" +
    "\t\t\t\t\t\t\t<td class=\"trade-action\">\n" +
    "\t\t\t\t\t\t\t\t<div>{{ 'featuredoptions.' + leg.action | lexicon | uppercase }}</div>\n" +
    "\t\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t\t<td>\n" +
    "\t\t\t\t\t\t\t\t<div>{{ leg | tradeLegOneLineFormat:instrument.precision }}</div>\n" +
    "\t\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t</table>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<span ng-repeat=\"feature in [comparableIdeas[selectedTradeIdeaIndex]]\" >\n" +
    "\t\t\t\t\t<span ng-init=\"idea=feature.idea;permission=permission;\" ng-include=\"'instrument_action/alternative_trades.html'\"></span>\n" +
    "\t\t\t\t</span>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"modal-body\">\n" +
    "\t\t\t<div id=\"alt_strat_body_mobile\">\n" +
    "\t\t\t\t<table class=\"compare-strategy\">\n" +
    "\t\t\t\t\t<tr class=\"row-header\">\n" +
    "\t\t\t\t\t\t<th colspan=\"2\">\n" +
    "\t\t\t\t\t\t\t{{compareText['to-open']}}\n" +
    "\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th>{{compareText['net-cost-in-total']}}</th>\n" +
    "\t\t\t\t\t\t<td>\n" +
    "\t\t\t\t\t\t\t{{ {true: \"--\",\n" +
    "\t\t\t\t\t\t\tfalse: (getSelectedTradeIdea().idea.trade.netCost | formatCurrency:instrument.precision)}\n" +
    "\t\t\t\t\t\t\t[getSelectedTradeIdea().idea.trade.tradeStrategy.isNetCredit] }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>{{compareText['net-cost-per-share']}}</th>\n" +
    "\t\t\t\t\t\t<td>\n" +
    "\t\t\t\t\t\t\t{{ {true: \"--\",\n" +
    "\t\t\t\t\t\t\tfalse: (getSelectedTradeIdea().idea.perShareValues.netCost | formatCurrency:instrument.precision)}\n" +
    "\t\t\t\t\t\t\t[getSelectedTradeIdea().idea.trade.tradeStrategy.isNetCredit] }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th>{{compareText['net-received-in-total']}}</th>\n" +
    "\t\t\t\t\t\t<td>\n" +
    "\t\t\t\t\t\t\t{{ {true: (getSelectedTradeIdea().idea.trade.netCost * -1 | formatCurrency:instrument.precision),\n" +
    "\t\t\t\t\t\t\tfalse: \"--\"}\n" +
    "\t\t\t\t\t\t\t[getSelectedTradeIdea().idea.trade.tradeStrategy.isNetCredit] }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>{{compareText['net-received-per-share']}}</th>\n" +
    "\t\t\t\t\t\t<td>\n" +
    "\t\t\t\t\t\t\t{{ {true: (getSelectedTradeIdea().idea.perShareValues.premiumReceived | formatCurrency:instrument.precision),\n" +
    "\t\t\t\t\t\t\tfalse: \"--\"}\n" +
    "\t\t\t\t\t\t\t[getSelectedTradeIdea().idea.trade.tradeStrategy.isNetCredit] }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t<tr class=\"row-header\">\n" +
    "\t\t\t\t\t\t<th colspan=\"2\" ng-show=\"$first\">\n" +
    "\t\t\t\t\t\t\t{{compareText['risk']}}\n" +
    "\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t\t<td colspan=\"2\" ng-hide=\"$first\"></td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th>{{compareText['max-loss-in-total']}}</th>\n" +
    "\t\t\t\t\t\t<td>{{(getSelectedTradeIdea().idea.trade.maxLoss | formatCurrency:instrument.precision) || \"--\"}}</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>{{compareText['max-loss-per-share']}}</th>\n" +
    "\t\t\t\t\t\t<td>{{(getSelectedTradeIdea().idea.perShareValues.maxLoss | formatCurrency:instrument.precision) || \"--\"}}</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th>{{compareText['max-loss-as-a-percent']}}</th>\n" +
    "\t\t\t\t\t\t<td>{{(getSelectedTradeIdea().idea.trade.maxLossPercent | nf_percent:0) || \"--\"}}</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"row-header\">\n" +
    "\t\t\t\t\t\t<th colspan=\"2\" ng-show=\"$first\">\n" +
    "\t\t\t\t\t\t\t{{compareText['reward']}}\n" +
    "\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t\t<td colspan=\"2\" ng-hide=\"$first\"></td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th>{{compareText['target-price']}}</th>\n" +
    "\t\t\t\t\t\t<td>{{(getSelectedTradeIdea().idea.targetPrice.target | formatCurrency:instrument.precision) || \"--\"}}</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>{{compareText['target-profit-in-total']}}</th>\n" +
    "\t\t\t\t\t\t<td>{{(getSelectedTradeIdea().idea.trade.targetProfit | formatCurrency:instrument.precision) || \"--\"}}</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th>{{compareText['target-profit-per-share']}}</th>\n" +
    "\t\t\t\t\t\t<td>{{(getSelectedTradeIdea().idea.perShareValues.targetProfit | formatCurrency:instrument.precision) || \"--\"}}</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>{{compareText['return-on-investment']}}</th>\n" +
    "\t\t\t\t\t\t<td>{{(getSelectedTradeIdea().idea.trade.targetProfitPercent | nf_percent:0) || \"--\"}}</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th>{{'alternativetrades.reward-to-risk' | lexicon}}</th>\n" +
    "\t\t\t\t\t\t<td>{{(getSelectedTradeIdea().idea.trade.rewardRiskRatio | realRoundedToPlaces: 2) || \"--\"}}</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th><div   style=\"word-break: break-all\">{{compareText['breakeven-point']}}</div></th>\n" +
    "\t\t\t\t\t\t<td>{{ (breakEvenPoints[selectedTradeIdeaIndex] | formatCurrency:instrument.precision) || \"--\"  }}</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr class=\"alt\">\n" +
    "\t\t\t\t\t\t<th>{{compareText['profit-zone']}}</th>\n" +
    "\t\t\t\t\t\t<td>\n" +
    "\t\t\t\t\t\t\t<span ng-show=\"breakEvenPoints[selectedTradeIdeaIndex]\">{{ compareText[{true: \"below\", false: \"above\"}[getSelectedTradeIdea().idea.trade.profitZone[0].lower == 0]]  }}&nbsp;\n" +
    "\t\t\t\t\t\t\t\t{{ breakEvenPoints[selectedTradeIdeaIndex] | formatCurrency:instrument.precision }}\n" +
    "\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t\t<span ng-show=\"breakEvenPoints[selectedTradeIdeaIndex] == null\">\n" +
    "\t\t\t\t\t\t\t\t{{ getSelectedTradeIdea().idea.trade.profitZone[0].lower | formatCurrency:instrument.precision }}\n" +
    "\t\t\t\t\t\t\t\t&nbsp;-&nbsp;\n" +
    "\t\t\t\t\t\t\t\t{{ getSelectedTradeIdea().idea.trade.profitZone[0].upper | formatCurrency:instrument.precision }}\n" +
    "\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t</table>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('auto_suggest_inputfield/template.html',
    "<div ng-controller=\"AutoSussgestCtrl\">\n" +
    "\t<div class=\"ps-list-exchange-group\">\n" +
    "\t\t<div class=\"btn-group ps-auto-suggest-group\">\n" +
    "\t\t\t<i class=\"fa fa-search fa-lg ps-search-icon\"></i>\n" +
    "\n" +
    "\t\t\t<input type=\"text\" class='flexdatalist form-control  ps-search-box' name =\"focusAutoSuggestField\" maxlength=\"30\" aria-labelledby=\"tc-settings-title-label\">\n" +
    "\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "\n" +
    "\t<div ng-class=\"[{true:'ps-tags-block-with-tags',false:'ps-tags-block-without-tags'}[hasSelectedTags()]]\">\n" +
    "\t\t<span ng-repeat=\"question in questionsTranslated\">\n" +
    "\t\t\t<span ng-show=\"isSelectedTag(question)\">\n" +
    "\t\t\t\t<button class=\"btn personalize-btn btn-normal btn-outer btn-contrast btn-selected ps-forex-tags\" ng-click=\"removeTag(question.id)\" type=\"button\" >\n" +
    "\t\t\t\t\t<span class=\"btn-text ps-btn-text\">{{question.symbol}}</span>\n" +
    "\t\t\t\t\t<span class=\"fa fa-times ps-x\"></span>\n" +
    "\t\t\t\t</button>\n" +
    "\t\t\t</span>\n" +
    "\t\t\t</span>\n" +
    "\t\t<div class=\"ps-tag-notice\" ng-show=\"!hasSelectedTags()\" ng-bind=\"'personalsettings.no-currency-pairs' | lexicon\"></div>\n" +
    "\t</div>\n" +
    "</div>"
  );


  $templateCache.put('company_info/template.html',
    "<div ng-controller=\"CompanyInfoCtrl as companyInfo\">\n" +
    "\t<div class=\"container-fluid fs-company-layer\">\n" +
    "\t\t<div class=\"row  fs-details-title\">\n" +
    "\t\t\t<div class=\"col-md-12\">\n" +
    "\t\t\t<span class=\"info-text\">{{'eventdetails.company-info' | lexicon}}</span>\n" +
    "\t\t\t<span class=\"fs-backbutton-container\">\n" +
    "\t\t\t\t<button class =\"btn btn-normal fs-back-button btn-contrast\" ng-click=\"eventDetails.viewBack()\">\n" +
    "\t\t\t\t\t<i class=\"fa fa-reply\"></i> {{'common.back' | lexicon}}\n" +
    "\t\t\t\t</button>\n" +
    "\t\t\t</span>\n" +
    "\t\t\t<span class=\"fs-backbutton-container-short\">\n" +
    "\t\t\t\t<button class =\"btn btn-normal fs-back-button btn-contrast\" aria-label=\"{{'common.back' | lexicon}}\" ng-click=\"eventDetails.viewBack()\">\n" +
    "\t\t\t\t\t<i class=\"fa fa-reply\"></i>\n" +
    "\t\t\t\t</button>\n" +
    "\t\t\t</span>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"row fs-company-details\">\n" +
    "\t\t\t<div class=\"fs-company-summary col-md-6\">\n" +
    "\t\t\t\t<span>{{companyInfo.instrument.company.description}}</span>\n" +
    "\t\t\t\t<p>{{companyInfo.website}}</p>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<div class=\"col-md-6 fs-company-data\">\n" +
    "\t\t\t\t<table role=\"presentation\">\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>{{'eventdetails.market-cap' | lexicon}}</th>\n" +
    "\t\t\t\t\t\t<td ng-if=\"companyInfo.fundamentals.marketCap == null\">&nbsp;{{'common.not-applicable' | lexicon }}</td>\n" +
    "\t\t\t\t\t\t<td ng-if=\"companyInfo.fundamentals.marketCap != null\">&nbsp;{{companyInfo.fundamentals.marketCap | formatCurrencyShort:instrument.precision}}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>{{'eventdetails.revenue-ttm' | lexicon}}</th>\n" +
    "\t\t\t\t\t\t<td ng-if=\"companyInfo.fundamentals.revenueTtm == null\">&nbsp;{{'common.not-applicable' | lexicon }}</td>\n" +
    "\t\t\t\t\t\t<td ng-if=\"companyInfo.fundamentals.revenueTtm != null\">&nbsp;{{\n" +
    "\t\t\t\t\t\t\tcompanyInfo.fundamentals.revenueTtm | formatCurrencyShort:instrument.precision}}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>{{'eventdetails.revenue-growth' | lexicon}}</th>\n" +
    "\t\t\t\t\t\t<td ng-if=\"companyInfo.fundamentals.revenueGrowthLastQuarterToPriorYear == null\">&nbsp;{{\n" +
    "\t\t\t\t\t\t\t'common.not-applicable' | lexicon }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t<td ng-if=\"companyInfo.fundamentals.revenueGrowthLastQuarterToPriorYear != null\">&nbsp;{{\n" +
    "\t\t\t\t\t\t\tcompanyInfo.fundamentals.revenueGrowthLastQuarterToPriorYear | nf_percentWithSign:0}} {{\n" +
    "\t\t\t\t\t\t\t'eventdetails.last-quarter-prior-year' | lexicon }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>{{'eventdetails.price-earnings' | lexicon}}</th>\n" +
    "\t\t\t\t\t\t<td ng-if=\"companyInfo.fundamentals.priceEarnings == null\">&nbsp;{{'common.not-applicable' | lexicon }}</td>\n" +
    "\t\t\t\t\t\t<td ng-if=\"companyInfo.fundamentals.priceEarnings != null\">&nbsp;{{\n" +
    "\t\t\t\t\t\t\tcompanyInfo.fundamentals.priceEarnings | formatCurrencyShort:instrument.precision}}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>{{'eventdetails.earnings-growth' | lexicon}}</th>\n" +
    "\t\t\t\t\t\t<td ng-if=\"companyInfo.fundamentals.epsGrowthLastQuarterToPriorYear == null\">&nbsp;{{\n" +
    "\t\t\t\t\t\t\t'common.not-applicable' | lexicon }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t<td ng-if=\"companyInfo.fundamentals.epsGrowthLastQuarterToPriorYear != null\">&nbsp;{{\n" +
    "\t\t\t\t\t\t\tcompanyInfo.fundamentals.epsGrowthLastQuarterToPriorYear | nf_percentWithSign:0}} {{\n" +
    "\t\t\t\t\t\t\t'eventdetails.last-quarter-prior-year' | lexicon }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>{{'eventdetails.dividend-yield' | lexicon}}</th>\n" +
    "\t\t\t\t\t\t<td ng-if=\"companyInfo.fundamentals.dividendYield == null\">&nbsp;{{'common.not-applicable' | lexicon }}</td>\n" +
    "\t\t\t\t\t\t<td ng-if=\"companyInfo.fundamentals.dividendYield != null\">&nbsp;{{\n" +
    "\t\t\t\t\t\t\tcompanyInfo.fundamentals.dividendYield | nf_percent}}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>{{'eventdetails.dividend-growth' | lexicon}}</th>\n" +
    "\t\t\t\t\t\t<td ng-if=\"companyInfo.fundamentals.dividendGrowthRateCurrentToPriorYear == null\">&nbsp;{{\n" +
    "\t\t\t\t\t\t\t'common.not-applicable' | lexicon }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t<td ng-if=\"companyInfo.fundamentals.dividendGrowthRateCurrentToPriorYear != null\">&nbsp;{{\n" +
    "\t\t\t\t\t\t\tcompanyInfo.fundamentals.dividendGrowthRateCurrentToPriorYear | nf_percentWithSign:0}} {{\n" +
    "\t\t\t\t\t\t\t'eventdetails.current-to-prior-year' | lexicon }}\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t</table>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<hr class=\"horizontal-border\"/>\n" +
    "\t\t<div class=\"container-fluid\" ng-hide=\"eventDetails.valueAnalyzerHyperlink==undefined\">\n" +
    "\t\t\t<div class=\"row\">\n" +
    "\t\t\t\t<div class=\"col-md-4 fs-value-analyzer-description\" >{{'eventdetails.value-analyzer-desc' | lexicon}}</div>\n" +
    "\t\t\t\t<div class=\"col-md-7 col-md-offset-1 fs-value-analyzer-button\">\n" +
    "\t\t\t\t\t<a ng-href=\"{{eventDetails.valueAnalyzerHyperlink}}\">\n" +
    "\t\t\t\t\t\t<button class=\"btn btn-normal btn-external-link\" ng-click=\"eventDetails.GoToUrl(eventDetails.valueAnalyzerHyperlink)\">\n" +
    "\t\t\t\t\t\t\t<span class=\"fs-btn-font\">{{'common.value-analyzer' | lexicon}}</span>\n" +
    "\t\t\t\t\t\t</button>\n" +
    "\t\t\t\t\t</a>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('compare_alternatives/template.html',
    "<div ng-controller=\"compareAlternativesCtrl\">\n" +
    "\t<div class=\"alt-strategy-modal-background\">\n" +
    "\t\t<div id=\"alt_strategy_modal-{{ideaId}}\"\n" +
    "\t\t\t\tclass=\"modal fade fs-scroll-modal-width fs-scroll-modal-center alt_strategy_modal\"\n" +
    "\t\t\t\ttabindex=\"-1\" disable-scrollbar role=\"dialog\"\n" +
    "\t\t\t\taria-labelledby=\"myModalLabel\" aria-hidden=\"true\" data-manager=\"div.recognia\"\n" +
    "\t\t\t\tmodal-show=\"show\" modal-focus-show=\"#focusId\" modal-resize-fix>\n" +
    "\n" +
    "\t\t\t<div id=\"alt_strat_wrap\">\n" +
    "\t\t\t\t<div id=\"alt_strat_desktop\" ng-include=\"'alternative_trades/template_desktop.html'\"></div>\n" +
    "\t\t\t\t<div id=\"alt_strat_mobile\"  ng-include=\"'alternative_trades/template_mobile.html'\"></div>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('compare_ideas/template.html',
    "<div ng-controller=\"compareIdeasCtrl\">\n" +
    "\t<div class=\"alt-strategy-modal-background\">\n" +
    "\t\t<div id=\"alt_strategy_modal\"\n" +
    "\t\t\t\tclass=\"modal fade fs-scroll-modal-width fs-scroll-modal-center alt_strategy_modal\"\n" +
    "\t\t\t\ttabindex=\"-1\" disable-scrollbar role=\"dialog\"\n" +
    "\t\t\t\taria-labelledby=\"myModalLabel\" aria-hidden=\"true\" data-manager=\"div.recognia\"\n" +
    "\t\t\t\tmodal-show=\"show\" modal-resize-fix>\n" +
    "\t\t\t<div id=\"alt_strat_wrap\">\n" +
    "\t\t\t\t<div id=\"no_strat_desktop\" ng-include=\"'compare_ideas/template_no_ideas_desktop.html'\" ng-hide=\"comparableIdeas.length != 0\"></div>\n" +
    "\t\t\t\t<div id=\"alt_strat_desktop\" ng-include=\"'alternative_trades/template_desktop.html'\" ng-hide=\"comparableIdeas.length == 0\"></div>\n" +
    "\t\t\t\t<!--div id=\"no_strat_mobile\" ng-include=\"'compare_ideas/template_no_ideas_mobile.html'\"></div-->\n" +
    "\t\t\t\t<!--div id=\"alt_strat_mobile\"  ng-include=\"'alternative_trades/template_mobile.html'\"></div-->\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('compare_ideas/template_no_ideas_desktop.html',
    "<div ng-hide=\"comparableIdeas.length != 0\">\n" +
    "\t<div id=\"compare_strat_header\" class=\"alternative-strategy\">\n" +
    "\t\t<div class=\"alt_strat_title_bar\">\n" +
    "\t\t\t<h1>{{compareTitle}}</h1>\n" +
    "\t\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n" +
    "\t\t</div>\n" +
    "\t\t<hr/>\n" +
    "\t\t<hr/>\n" +
    "\t</div>\n" +
    "\t<div class=\"compare-no-ideas-box\">\n" +
    "\t\t<p class=\"title\">{{title}}</p>\n" +
    "\t\t<table class=\"desktop-table-style\">\n" +
    "\t\t\t<tr>\n" +
    "\t\t\t\t<td colspan=\"3\" class=\"how-to-compare\">{{howToCompare}}</td>\n" +
    "\t\t\t</tr>\n" +
    "\t\t\t<tr>\n" +
    "\t\t\t\t<td class=\"numbers\">1</td>\n" +
    "\t\t\t\t<td class=\"numbers\">2</td>\n" +
    "\t\t\t\t<td class=\"numbers\">3</td>\n" +
    "\t\t\t</tr>\n" +
    "\t\t\t<tr>\n" +
    "\t\t\t\t<td class=\"description\">{{findCompare}}</td>\n" +
    "\t\t\t\t<td class=\"description\">{{clickCompare}}</td>\n" +
    "\t\t\t\t<td class=\"description\">{{viewCompare}}</td>\n" +
    "\t\t\t</tr>\n" +
    "\t\t\t<tr>\n" +
    "\t\t\t\t<td class=\"compare-text\"><span class=\"fa fa-tasks\"></span>{{compare}}</td>\n" +
    "\t\t\t\t<td class=\"comparing-text\"><span class=\"fa fa-tasks\"></span>{{comparing}}</td>\n" +
    "\t\t\t\t<td class=\"comparing-text\"><span class=\"fa fa-tasks\"></span>{{compare2}}</td>\n" +
    "\t\t\t</tr>\n" +
    "\t\t</table>\n" +
    "\t\t<div class=\"go-back-text\">\n" +
    "\t\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"><span class=\"arrow\"><i class=\"fa fa-arrow-left\"></i></span><span class=\"text\">{{goBack}}</span></button>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>"
  );


  $templateCache.put('compare_ideas/template_no_ideas_mobile.html',
    "<div ng-hide=\"comparableIdeas.length != 0\">\n" +
    "\t<div id=\"compare_strat_header\" class=\"alternative-strategy\">\n" +
    "\t\t<div class=\"alt_strat_title_bar\">\n" +
    "\t\t\t<h1>{{compareTitle}}</h1>\n" +
    "\t\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button>\n" +
    "\t\t</div>\n" +
    "\t\t<hr/>\n" +
    "\t\t<hr/>\n" +
    "\t</div>\n" +
    "\t<div class=\"compare-no-ideas-box\">\n" +
    "\t\t<p class=\"title decrease-padding\">{{title}}</p>\n" +
    "\t\t<table class=\"mobile-table-style\">\n" +
    "\t\t\t<tr>\n" +
    "\t\t\t\t<td colspan=\"2\" class=\"how-to-compare\">{{howToCompare}}</td>\n" +
    "\t\t\t</tr>\n" +
    "\t\t\t<tr class=\"border-top\">\n" +
    "\t\t\t\t<td colspan=\"2\" class=\"numbers\">1</td>\n" +
    "\t\t\t</tr>\n" +
    "\t\t\t<tr>\n" +
    "\t\t\t\t<td class=\"description\">{{findCompare}}</td>\n" +
    "\t\t\t\t<td class=\"compare-text\"><span class=\"fa fa-tasks\"></span>{{compare}}</td>\n" +
    "\t\t\t</tr>\n" +
    "\t\t\t<tr class=\"border-top\">\n" +
    "\t\t\t\t<td colspan=\"2\" class=\"numbers\">2</td>\n" +
    "\t\t\t</tr>\n" +
    "\t\t\t<tr>\n" +
    "\t\t\t\t<td class=\"description\">{{clickCompare}}</td>\n" +
    "\t\t\t\t<td class=\"comparing-text\"><span class=\"fa fa-tasks\"></span>{{comparing}}</td>\n" +
    "\t\t\t</tr>\n" +
    "\t\t\t<tr class=\"border-top\">\n" +
    "\t\t\t\t<td colspan=\"2\" class=\"numbers\">3</td>\n" +
    "\t\t\t</tr>\n" +
    "\t\t\t<tr class=\"border-bottom\">\n" +
    "\t\t\t\t<td class=\"description\">{{viewCompare}}</td>\n" +
    "\t\t\t\t<td class=\"comparing-text\"><span class=\"fa fa-tasks\"></span>{{compare2}}</td>\n" +
    "\t\t\t</tr>\n" +
    "\t\t</table>\n" +
    "\t\t<div class=\"go-back-text mobile-footer-style\">\n" +
    "\t\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"><span class=\"arrow\"><i class=\"fa fa-arrow-left\"></i></span><span class=\"text\">{{goBack}}</span></button>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>"
  );


  $templateCache.put('country_dropdown/template.html',
    "<div ng-controller=\"CountryDropdownCtrl\" class=\"componentContainer btn-group\">\n" +
    "\t<span ng-hide=\"isOneExchange()\">\n" +
    "\t\t<button class=\"btn cd-btn btn-normal dropdown-toggle\" name=\"{{'btn_country_dropdown'+buttonIndex}}\" ng-keydown=\"buttonOnKeyDown($event)\" data-toggle=\"dropdown\" >\n" +
    "\t\t\t<span aria-label=\"{{selectedExchange.name}}\" class=\"{{getFlagStyleName(selectedExchange)}} hidden-text\"></span><span class=\"caret\"></span>\n" +
    "\t\t</button>\n" +
    "\t\t<ul class=\"dropdown-menu pull-left\" role=\"menu\" ng-keydown=\"dropdownOnKeyDown($event)\">\n" +
    "\t\t\t<li ng-repeat=\"exchange in exchanges\">\n" +
    "\t\t\t\t<a ng-click=\"setExchange(exchange)\"  role=\"menuitem\"  href=\"#\">\n" +
    "\t\t\t\t\t<span class=\"{{getFlagStyleName(exchange)}}\"></span>\n" +
    "\t\t\t\t\t<span>{{ exchange.name }}</span>\n" +
    "\t\t\t\t</a>\n" +
    "\t\t\t</li>\n" +
    "\t\t</ul>\n" +
    "\t</span>\n" +
    "</div>\n"
  );


  $templateCache.put('custom_settings_btn/template.html',
    "<div ng-controller=\"CustomSettingsCtrl\">\n" +
    "\t<span ng-include src=\"'widgets/personal_settings/template.html'\"></span>\n" +
    "\t<button class=\"fs-btn-custom-settings\" data-toggle=\"modal\" data-target=\"#myModal\" id=\"custom_setting_button\">\n" +
    "\t\t<span class=\"fs-icon-text-style\">\n" +
    "\t\t\t<i class=\"fa fa-cog fs-icon-text-style\"></i>\n" +
    "\t\t</span>\n" +
    "\t\t<span class=\"fs-btn-custom-settings-text hidden-xs hidden-sm\">{{'featuredstocks.custom-settings' | lexicon}}</span>\n" +
    "\t\t<br>\n" +
    "\t\t<span class=\"fs-custom-settings-complete\">\n" +
    "\t\t\t<span class=\"hidden-xs hidden-sm\">\n" +
    "\t\t\t\t{{'featuredstocks.percent-complete' | lexicon:{\n" +
    "\t\t\t\t\t'percent': (percentComplete | nf_percentInTextBlock)\n" +
    "\t\t\t\t} }}\n" +
    "\t\t\t</span>\n" +
    "\t\t\t<span class=\"visible-xs-inline visible-sm-inline\">{{percentComplete | nf_percent}}</span>\n" +
    "\t\t</span>\n" +
    "\t</button>\n" +
    "</div>\n"
  );


  $templateCache.put('event_details/template.html',
    "<div ng-controller=\"EventDetailsCtrl as eventDetails\" id=\"event-details-{{ideaId}}\" show-hide-idea>\n" +
    "\t\t<div ng-show=\"!isValidIdea && !ideaHasError\" class=\"ti-featured-ideas-alert-bar\" >\n" +
    "\t\t\t<div class = \"ti-featured-ideas-alert-message\">\n" +
    "\t\t\t\t<div>\n" +
    "\t\t\t\t\t<i class=\"fa fa-exclamation-triangle ti-featured-ideas-alert-exclamation\" aria-hidden=\"true\"></i>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<div class=\"ti-featured-ideas-alert-message-block\" bind-html-unsafe=\"noLongerValidIdea\"></div>\n" +
    "\t\t\t\t<div class=\"ti-featured-ideas-alert-more_detail\">{{ 'eventdetails.more-details'| lexicon}}\n" +
    "\t\t\t\t\t<Button class=\"ti-featured-ideas-alert-chevron\" aria-label=\"{{'eventdetails.more-details'| lexicon}}\" data-toggle=\"collapse\" data-target=\"#featured-idea-alert-{{ideaId}}\" ng-click=\"isCollapsed = !isCollapsed\">\n" +
    "\t\t\t\t\t\t<i ng-class=\"{'fa fa-chevron-up':isCollapsed,'fa fa-chevron-down':!isCollapsed}\" class=\"pull-right fa fa-chevron-down\">\n" +
    "\t\t\t\t\t\t</i>\n" +
    "\t\t\t\t\t</Button>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<div id=\"featured-idea-alert-{{ideaId}}\" class=\"collapse ti-featured-ideas-alert-message-detail\">\n" +
    "\t\t\t\t{{'eventdetails.idea-no-longer-valid-detail'| lexicon }}\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\n" +
    "\n" +
    "\t\t<div class=\"fs-no-event-watched-modal-wrapper\" ng-if=\"ideaHasError\">\n" +
    "\t\t\t<div class=\"fs-no-event-watched-modal\">\n" +
    "\t\t\t\t<div class=\"modal-header\">{{text.watchedModalHeader}}</div>\n" +
    "\t\t\t\t<div class=\"modal-body\">\n" +
    "\t\t\t\t\t<p class=\"fs-no-event-watched-modal-text\">{{text.watchedModalIdeas}}</p>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<div class=\"modal-footer\" ng-show=\"watchedModalIcon\">\n" +
    "\t\t\t\t\t<span class=\"cursor-pointer\" ng-click=\"removeWatched(featured)\" ng-keydown=\"removeWatched(featured)\" tabindex=\"0\">{{text.watchedModalDelete}}</span>\n" +
    "\t\t\t\t</div>\n" +
    "                <div class=\"modal-footer\" ng-show=\"watchedModalIconRemoved\" id=\"watchedDeleted\">\n" +
    "\t\t\t\t\t<i class=\"fa fa-check\" aria-hidden=\"true\" style=\"margin-right:.5em\"></i><span>{{text.watchedModalDeleted}}</span>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\n" +
    "\n" +
    "\t\t<div class=\"container-fluid eventcontainer\" ng-if=\"!ideaHasError\">\n" +
    "\t\t\t<!--top section-->\n" +
    "\t\t\t<div class=\"row fs-instrument-row\">\n" +
    "\t\t\t\t<div class=\"col-md-4 col-sm-12 fs-title no-padding\">\n" +
    "\t\t\t\t\t<div class=\"instrument-title\">\n" +
    "\t\t\t\t\t\t<!-- Show instrument title as a link only if we have company info to show -->\n" +
    "\t\t\t\t\t\t<a ng-show=\"findLayer('company_info/template.html')\" href=\"\" id=\"instrument-name-{{ideaId}}\"\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t ng-click=\"viewSelected(findLayer('company_info/template.html'))\">{{featured.idea.instrument.name}}</a>\n" +
    "\t\t\t\t\t\t<span ng-hide=\"findLayer('company_info/template.html')\" id=\"instrument-name-{{ideaId}}\">{{featured.idea.instrument.name}}</span>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t<div class=\"exchange-title\" id=\"exchangeName\">\n" +
    "\t\t\t\t\t\t<span>{{featured.idea.instrument.symbol}}</span><span ng-show=\"pageDirectionRtl\">&rlm;</span>\n" +
    "\t\t\t\t\t\t<span ng-show=\"displayExchanges(featured.idea.instrument.exchange.symbol)\">: {{featured.idea.instrument.exchange.symbol}}</span><span\n" +
    "\t\t\t\t\t\t\tng-show=\"pageDirectionRtl\">&rlm;</span>                        \n" +
    "                            <span class=\"lastprice\">                         \n" +
    "                                <formatstringchars dynamic-update=\"true\" chars-to-format=\"{{isForexIdea(featured)? 1:0 }}\" value =\"{{lastPrice}}\" css-class=\"microPIP-Char-Format\"></formatstringchars>\n" +
    "                            </span>                                                 \n" +
    "                        <span ng-show=\"pageDirectionRtl\">&rlm;</span>\n" +
    "\t\t\t\t\t\t<span ng-hide=\"isForexIdea(featured)\">\n" +
    "\t\t\t\t\t\t\t<span class=\"font-smaller fs-last-updated\">{{currencyLabel}}</span>\n" +
    "\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t<span ng-show=\"pageDirectionRtl\">&rlm;</span>\n" +
    "\t\t\t\t\t\t<span class=\"font-smaller fs-last-updated\" ng-hide=\"!latestPriceTimeStamp\">\n" +
    "\t\t\t\t\t\t\t{{latestPriceTimeStamp}}\n" +
    "\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t<div class=\"showoptions\" ng-show=\"optionable\">\n" +
    "\t\t\t\t\t\t<div ng-switch on=\"featured.idea.ideaType\">\n" +
    "\t\t\t\t\t\t<span ng-switch-when=\"option\">{{'featuredoptions.options-strategy' | lexicon}}\n" +
    "\t\t\t\t\t\t\t<span class=\"fs-option-strategy-name fs-options-name\">\n" +
    "\t\t\t\t\t\t\t\t<a class=\"fs-options-name-link\"\n" +
    "\t\t\t\t\t\t\t\t   data-original-title=\"{{featured.idea.trade.tradeStrategy.name}}\"\n" +
    "\t\t\t\t\t\t\t\t   data-content=\"{{optionsStrategyIdDescription}}\" pop-over>\n" +
    "\t\t\t\t\t\t\t\t\t{{featured.idea.trade.tradeStrategy.name}}</a>\n" +
    "\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t<span ng-hide=\"isForexIdea(featured)\">\n" +
    "\t\t\t\t\t\t\t<span ng-switch-default><i class=\"fa fa-check rtl-exempt-flip\"></i>&nbsp;{{'eventdetails.options-available' | lexicon}}</span>\n" +
    "\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<div class=\"col-md-8 col-sm-12 fs-buttons\">\n" +
    "\t\t\t\t\t<span watch-button idea=\"featured\" widget=\"{{selectedProduct}}\" />\n" +
    "\t\t\t\t\t<span id=\"fs-btn-group-layer\">\n" +
    "\t\t\t\t\t\t<button\n" +
    "\t\t\t\t\t\t\t\tng-repeat=\"layer in layers\"\n" +
    "\t\t\t\t\t\t\t\tclass=\"btn btn-layer fs-info-button\"\n" +
    "\t\t\t\t\t\t\t\tga-click-event=\"{{layer.gaClickEvent}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-category=\"ideas-platform\"\n" +
    "\t\t\t\t\t\t\t\tdata-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-widget=\"{{selectedProduct}}\"\n" +
    "\t\t\t\t\t\t\t\tng-class=\"{'active': (layer==selectedLayer), 'spaced-btn':!$first}\"\n" +
    "\t\t\t\t\t\t\t\tng-click=\"viewSelected(layer)\"\n" +
    "\t\t\t\t\t\t\t\taria-label=\"{{layer.text| lexicon}}\">\n" +
    "\t\t\t\t\t\t\t<i class={{layer.icon}} ng-class=\"{true:'active', false:''}[layer==selectedLayer]\" />\n" +
    "\t\t\t\t\t\t</button>\n" +
    "\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t<span ng-init=\"idea=featured.idea;permission=permission;\" ng-include=\"'instrument_action/template.html'\"></span>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\n" +
    "\t\t\t<!-- Layer Buttons Rows for smaller screen-->\n" +
    "\t\t\t<div class=\"row fs-instrument-row-hide\">\n" +
    "\t\t\t\t<div class=\"col-md-12 fs-btn-group-layer-hide\">\n" +
    "\t\t\t\t<span ng-repeat=\"layer in layers\">\n" +
    "\t\t\t\t\t<button class=\"btn btn-layer fs-info-button\"\n" +
    "\t\t\t\t\t\t\tga-click-event=\"{{layer.gaClickEvent}}\"\n" +
    "\t\t\t\t\t\t\tdata-category=\"ideas-platform\"\n" +
    "\t\t\t\t\t\t\tdata-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\n" +
    "\t\t\t\t\t\t\tdata-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "\t\t\t\t\t\t\tdata-widget=\"{{selectedProduct}}\"\n" +
    "\t\t\t\t\t\t\tng-class=\"{true:'active', false:''}[layer==selectedLayer]\"\n" +
    "\t\t\t\t\t\t\tng-click=\"viewSelected(layer)\"\n" +
    "\t\t\t\t\t\t\taria-label=\"{{layer.text| lexicon}}\">\n" +
    "\t\t\t\t\t\t<i class={{layer.icon}} ng-class=\"{true:'active', false:''}[layer==selectedLayer]\"></i>\n" +
    "\t\t\t\t\t</button>\n" +
    "\t\t\t\t</span>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\n" +
    "\t\t\t<div class=\"row bottomborder-split\">\n" +
    "\t\t\t\t<span ng-include src=\"layerPage\"></span>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<span ng-hide=\"isForexIdea(featured)\">\n" +
    "\t\t\t\t<div class=\"row info-boxes\">\n" +
    "\t\t\t\t<div class=\"info-box-outer \"\n" +
    "\t\t\t\t\t ng-class=\"{'col-md-6':eventLookupHyperlink || featured.idea.ideaType=='option', 'col-md-12':eventLookupHyperlink==undefined}\"\n" +
    "\t\t\t\t\t ng-hide=\"(strategyBuilderHyperlink==undefined || strategyBuilderHyperlink=='') && backtest_strategy_view=='Strategy Builder'\">\n" +
    "\t\t\t\t\t<div ng-switch on=\"backtest_strategy_view\">\n" +
    "\t\t\t\t\t\t<div class=\"info-box\" ng-switch-when=\"BackTesting\">\n" +
    "\t\t\t\t\t\t\t<div class=\"info-box-text\">\n" +
    "\t\t\t\t\t\t\t\t<p>{{strategyMatch}}</p>\n" +
    "\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t<button class=\"btn btn-normal btn-internal-link\"\n" +
    "\t\t\t\t\t\t\t\t\tng-click=\"viewStrategy()\"\n" +
    "\t\t\t\t\t\t\t\t\tga-click-event=\"view-backtesting\"\n" +
    "\t\t\t\t\t\t\t\t\tdata-category=\"ideas-platform\"\n" +
    "\t\t\t\t\t\t\t\t\tdata-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\n" +
    "\t\t\t\t\t\t\t\t\tdata-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "\t\t\t\t\t\t\t\t\tdata-widget=\"{{selectedProduct}}\">\n" +
    "\t\t\t\t\t\t\t\t<span class=\"fs-btn-font\">{{'eventdetails.view-strategy' | lexicon}}</span>\n" +
    "\t\t\t\t\t\t\t</button>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t<div class=\"info-box\" ng-switch-when=\"Strategy Builder\"\n" +
    "\t\t\t\t\t\t\t ng-hide=\"(strategyBuilderHyperlink==undefined || strategyBuilderHyperlink=='')\">\n" +
    "\t\t\t\t\t\t\t<div class=\"info-box-text\">\n" +
    "\t\t\t\t\t\t\t\t<p>{{'eventdetails.strategy-note' | lexicon}}</p>\n" +
    "\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t<a href={{strategyBuilderHyperlink}} tabindex=\"-1\">\n" +
    "\t\t\t\t\t\t\t\t<button class=\"btn btn-normal btn-external-link\"\n" +
    "\t\t\t\t\t\t\t\t\t\t\tng-click=\"GoToUrlForIE8(strategyBuilderHyperlink)\"\n" +
    "\t\t\t\t\t\t\t\t\t\t\tga-event=\"link-to-event-lookup\" data-product=\"{{selectedProduct}}\"\n" +
    "\t\t\t\t\t\t\t\t\t\t\tdata-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "\t\t\t\t\t\t\t\t\t\t\tdata-index=\"{{ideas.indexOf(selectedIdea)}}\"><span\n" +
    "\t\t\t\t\t\t\t\t\t\t\tclass=\"fs-btn-font\">{{'common.strategy-builder' | lexicon}}</span></button>\n" +
    "\t\t\t\t\t\t\t</a>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<div ng-switch on=\"selectedProduct\">\n" +
    "\t\t\t\t\t<!-- Show event-lookup -->\n" +
    "\t\t\t\t\t<div ng-switch-default>\n" +
    "\t\t\t\t\t\t<div class=\"info-box-outer\"\n" +
    "\t\t\t\t\t\t\t ng-class=\"{'col-md-6': backtest_strategy_view=='BackTesting' || (backtest_strategy_view=='Strategy Builder'\n" +
    "\t\t\t\t\t\t && strategyBuilderHyperlink!=undefined), 'col-md-12': strategyBuilderHyperlink==undefined && backtest_strategy_view=='Strategy Builder'}\"\n" +
    "\t\t\t\t\t\t\t ng-hide=\"eventLookupHyperlink==undefined || eventLookupHyperlink==''\">\n" +
    "\t\t\t\t\t\t\t<div class=\"info-box\">\n" +
    "\t\t\t\t\t\t\t\t<div class=\"info-box-text align-center\">\n" +
    "\t\t\t\t\t\t\t\t\t<p>{{eventLookupText}}</p>\n" +
    "\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t\t\t<button class=\"btn btn-normal btn-external-link\"\n" +
    "\t\t\t\t\t\t\t\t\t\t\tng-click=\"GoToUrlForIE8(eventLookupHyperlink)\">\n" +
    "\t\t\t\t\t\t\t\t\t\t<span class=\"fs-btn-font\">{{'common.event-lookup' | lexicon}}</span>\n" +
    "\t\t\t\t\t\t\t\t\t</button>\n" +
    "\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t<!-- Show alternate-strategy table-->\n" +
    "\t\t\t\t\t<div ng-switch-when=\"options\">\n" +
    "\t\t\t\t\t\t<div class=\"info-box-outer\"\n" +
    "\t\t\t\t\t\t\t ng-class=\"{'col-md-6': backtest_strategy_view=='BackTesting' || (backtest_strategy_view=='Strategy Builder'\n" +
    "\t\t\t\t\t\t && strategyBuilderHyperlink!=undefined), 'col-md-12': strategyBuilderHyperlink==undefined && backtest_strategy_view=='Strategy Builder'}\"\n" +
    "\t\t\t\t\t\t\t ga-click-event=\"view-alternative-strategies\"\n" +
    "\t\t\t\t\t\t\t data-category=\"ideas-platform\"\n" +
    "\t\t\t\t\t\t\t data-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\n" +
    "\t\t\t\t\t\t\t data-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "\t\t\t\t\t\t\t data-widget=\"{{selectedProduct}}\">\n" +
    "\t\t\t\t\t\t\t<table class=\"alternate-strategy\">\n" +
    "\t\t\t\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t\t\t\t<th class=\"middle-align\">\n" +
    "\t\t\t\t\t\t\t\t\t\t<div class=\"large-text\">\n" +
    "\t\t\t\t\t\t\t\t\t\t\t{{'options_strategy_details.alternative-strategies' | lexicon}}\n" +
    "\t\t\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t\t\t\t\t<th>\n" +
    "\t\t\t\t\t\t\t\t\t\t<div class=\"text\">{{'options_strategy_details.score' | lexicon}}</div>\n" +
    "\t\t\t\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t\t\t\t\t<th>\n" +
    "\t\t\t\t\t\t\t\t\t\t<div class=\"text\">{{'options_strategy_details.target-profit' | lexicon}}</div>\n" +
    "\t\t\t\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t\t\t\t\t<th>\n" +
    "\t\t\t\t\t\t\t\t\t\t<div class=\"text\">{{'options_strategy_details.max-loss' | lexicon}}</div>\n" +
    "\t\t\t\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t\t\t\t\t<th>\n" +
    "\t\t\t\t\t\t\t\t\t\t<div class=\"text\">{{'options_strategy_details.to-open' | lexicon}}</div>\n" +
    "\t\t\t\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t\t\t\t</tr>\n" +
    "\n" +
    "\t\t\t\t\t\t\t\t<!--\n" +
    "\t\t\t\t\t\t\t\t*\tLoop the alternate strategies exactly 3-times.\n" +
    "\t\t\t\t\t\t\t\t*\tLeaving the cells empty if there is no strategy to display.\n" +
    "\t\t\t\t\t\t\t\t-->\n" +
    "\t\t\t\t\t\t\t\t<tr data-toggle=\"modal\" data-target=\"#alt_strategy_modal-{{ideaId}}\"\n" +
    "\t\t\t\t\t\t\t\t\tng-click=\"initializeModal($index)\"\n" +
    "\t\t\t\t\t\t\t\t\tng-class=\"{'body cursor-pointer':tradeIdea}\"\n" +
    "\t\t\t\t\t\t\t\t\tng-repeat=\"tradeIdea in comparableIdeas\" ng-hide=\"$first\">\n" +
    "\t\t\t\t\t\t\t\t\t<td class=\"alternate-strategy-name\">{{tradeIdea.idea.trade.tradeStrategy.name}}</td>\n" +
    "\t\t\t\t\t\t\t\t\t<td class=\"alternate-strategy-score\">{{'fsTarget.target_score_' +\n" +
    "\t\t\t\t\t\t\t\t\t\ttradeIdea.idea.trade.scoreGrade | lexicon}}\n" +
    "\t\t\t\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t\t\t\t<td class=\"alternate-strategy-target-profit\">{{tradeIdea.idea.trade.targetProfit |\n" +
    "\t\t\t\t\t\t\t\t\t\tformatCurrency:instrument.precision }}\n" +
    "\t\t\t\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t\t\t\t<td class=\"alternate-strategy-max-loss\">{{tradeIdea.idea.trade.maxLoss |\n" +
    "\t\t\t\t\t\t\t\t\t\tformatCurrency:instrument.precision }}\n" +
    "\t\t\t\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t\t\t\t<td class=\"alternate-strategy-net-cost\"\n" +
    "\t\t\t\t\t\t\t\t\t\tng-switch=\"tradeIdea.idea.trade.tradeStrategy.isNetCredit\">\n" +
    "\t\t\t\t\t\t\t\t\t<span ng-switch-when=\"false\">\n" +
    "\t\t\t\t\t\t\t\t\t\t{{ tradeIdea.idea.trade.netCost | formatCurrency:instrument.precision }}\n" +
    "\t\t\t\t\t\t\t\t\t\t<br/>\n" +
    "\t\t\t\t\t\t\t\t\t\t<span class=\"alternate-strategy-credit-description\">\n" +
    "\t\t\t\t\t\t\t\t\t\t\t({{ 'options_strategy_details.cost' | lexicon }})\n" +
    "\t\t\t\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t\t\t\t<span ng-switch-when=\"true\">\n" +
    "\t\t\t\t\t\t\t\t\t\t{{ tradeIdea.idea.trade.netCost * -1 | formatCurrency:instrument.precision }}\n" +
    "\t\t\t\t\t\t\t\t\t\t<br/>\n" +
    "\t\t\t\t\t\t\t\t\t\t<span class=\"alternate-strategy-credit-description\">\n" +
    "\t\t\t\t\t\t\t\t\t\t\t({{ 'options_strategy_details.received' | lexicon }})\n" +
    "\t\t\t\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t\t\t\t<tr ng-repeat=\"row in (emptyCompareRows || [0,0,0]) track by $index\">\n" +
    "\t\t\t\t\t\t\t\t\t<td class=\"no-alternate-strategy-message\" ng-if=\"$first && !eventDetails.noAlternativeIdeas &&\n" +
    "\t\t\t\t\t\t\t\t\t\t(!comparableIdeas || comparableIdeas.length <= 1)\">{{'common.loading-dotdot' |\n" +
    "\t\t\t\t\t\t\t\t\t\tlexicon}}\n" +
    "\t\t\t\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t\t\t\t<td class=\"no-alternate-strategy-message\"\n" +
    "\t\t\t\t\t\t\t\t\t\tng-if=\"$first && eventDetails.noAlternativeIdeas\">{{\n" +
    "\t\t\t\t\t\t\t\t\t\t'options_strategy_details.no-alternatives-found' | lexicon}}\n" +
    "\t\t\t\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t\t\t\t<td ng-if=\"!$first || comparableIdeas.length > 1\"></td>\n" +
    "\t\t\t\t\t\t\t\t\t<td></td>\n" +
    "\t\t\t\t\t\t\t\t\t<td></td>\n" +
    "\t\t\t\t\t\t\t\t\t<td></td>\n" +
    "\t\t\t\t\t\t\t\t\t<td></td>\n" +
    "\t\t\t\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t\t\t</table>\n" +
    "\t\t\t\t\t\t\t<span ng-include src=\"modalLayer\"></span>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t</span>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "\n"
  );


  $templateCache.put('event_details/template_idea.html',
    "<div ng-controller=\"IdeaController\" class=\"container-fluid idea-container\">\n" +
    "\t<div class=\"row fs-price-row fs-price-row-wrap\">\n" +
    "\t\t<!-- Target Area -->\n" +
    "\t\t<div class=\"col-xs-3 col-sm-3 no-padding\"\n" +
    "\t\t\tng-class=\"{true: 'col-md-4', false: 'col-md-3'}[bullishBearish == 'option']\">\n" +
    "\t\t\t<div class=\"fs-target {{bullishBearish}}\" ng-switch on=\"bullishBearish\">\n" +
    "\t\t\t\t<!-- option -->\n" +
    "\t\t\t\t<div ng-switch-when=\"option\" class=\"fs-option-target-wrapper\">\n" +
    "\t\t\t\t\t<span class=\"score-wrapper\" bs-tooltip=\"newTooltip\" data-placement=\"auto right\">\n" +
    "\t\t\t\t\t\t<span class=\"score-label\">{{'fsTarget.score_upper' | lexicon}}: </span>\n" +
    "\t\t\t\t\t\t<span class=\"score-value\">{{'fsTarget.target_score' | lexicon:{context: featured.idea.trade.scoreGrade} }}</span>\n" +
    "\t\t\t\t\t</span>\n" +
    "\n" +
    "\t\t\t\t\t<div class=\"div-table\">\n" +
    "\t\t\t\t\t\t<div class=\"div-td target-profit\">\n" +
    "\t\t\t\t\t\t\t<div bs-tooltip=\"targetProfitTooltip\" >\n" +
    "\t\t\t\t\t\t\t\t{{'fsTarget.target_profit_upper' | lexicon}}<br/>\n" +
    "\t\t\t\t\t\t\t\t<span class=\"target-value\">{{featured.idea.trade.targetProfitPercent | nf_percent:0}}</span>\n" +
    "\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t<div class=\"div-td max-loss\">\n" +
    "\t\t\t\t\t\t\t<div bs-tooltip=\"maxLossTooltip\" >\n" +
    "\t\t\t\t\t\t\t\t{{'fsTarget.max_loss_upper' | lexicon}}<br/>\n" +
    "\t\t\t\t\t\t\t\t<span class=\"target-value\">{{featured.idea.trade.maxLossPercent | nf_percent:0}}</span>\n" +
    "\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<!-- bullish or bearish -->\n" +
    "\t\t\t\t<div ng-switch-default class=\"fs-stock-target-wrapper\">\n" +
    "\t\t\t\t\t<span class=\"fs-target-block {{bullishBearish}}\">\n" +
    "\t\t\t\t\t\t<div ng-if=\"featured.idea.targetPrice && (featured.idea.targetPrice.expectedMove != null || featured.idea.targetPrice.percentageMove != null)\" bs-tooltip=\"targetPercentageTooltip\" role=\"button\" tabindex=\"0\">\n" +
    "\t\t\t\t\t\t\t<span ng-switch on=\"bullishBearish\">\n" +
    "\t\t\t\t\t\t\t\t<div class=\"fs-target-percent {{bullishBearish}}\" ng-switch-when=\"bullish\"  data-placement=\"right\">\n" +
    "\t\t\t\t\t\t\t\t\t<span>{{getMove(featured.idea,1)}}</span><span class=\"fs-target-micropips\">{{micropip}}</span><span class=\"fs-target-pips\">&ZeroWidthSpace;{{pips}}</span>\n" +
    "\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t\t<div class=\"fs-target-percent {{bullishBearish}}\" ng-switch-when=\"bearish\" data-placement=\"right\">\n" +
    "\t\t\t\t\t\t\t\t\t<span>{{getMove(featured.idea,0)}}</span><span class=\"fs-target-micropips\">{{micropip}}</span><span class=\"fs-target-pips \">&ZeroWidthSpace;{{pips}}</span>\n" +
    "\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t\t<span class=\"{{bullishBearish}}-inverted\">{{targetLabel}}</span>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t<i ng-class=\"{true:'fa fa-arrow-up fs-icon-arrow-size',false:''}[callNoTarget(featured) && isBullish(featured.idea)]\"></i>\n" +
    "\t\t\t\t\t\t<i ng-class=\"{true:'fa fa-arrow-down fs-icon-arrow-size',false:''}[callNoTarget(featured) && isBearish(featured.idea)]\"></i>\n" +
    "\n" +
    "\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t<span class=\"fs-target-dir {{bullishBearish}}\">{{'eventdetails.' + bullishBearish | lexicon}}</span>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<!-- Event Details Area -->\n" +
    "\t\t<div class=\"col-xs-9 col-sm-9 fs-event-details\"\n" +
    "\t\t\tng-class=\"{true: 'col-md-8', false: 'col-md-9'}[bullishBearish == 'option']\">\n" +
    "\t\t\t<strong bind-html-unsafe=\"eventFormPattern\"></strong>\n" +
    "\t\t\t<div class=\"icons\">\n" +
    "\t\t\t\t<div class=\"font-small\" ng-switch on=\"!!featured.idea.events[0].tradingHorizon\">\n" +
    "\t\t\t\t\t<span ng-switch-when=\"true\">\n" +
    "\t\t\t\t\t\t<i class=\"fa fa-caret-right\"></i>\n" +
    "\t\t\t\t\t\t<span class=\"bullet-text\">\n" +
    "\t\t\t\t\t\t\t{{eventTradingHorizon}}\n" +
    "\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t</span>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<div class=\"font-small\" ng-switch on=\"!!price\">\n" +
    "\t\t\t\t\t<span ng-switch-when=\"true\">\n" +
    "\t\t\t\t\t\t<i class=\"fa fa-caret-right\"></i>\n" +
    "\t\t\t\t\t\t<!-- switch the price move/percent style from green to red based on whether move is up or down -->\n" +
    "\t\t\t\t\t\t<span class=\"bullet-text\" bind-html-unsafe=\"changeSinceTechnicalEventDesc\"></span>\n" +
    "\t\t\t\t\t</span>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "\t<div class=\"row\" ng-class=\"{true:'fs-default-options-chart-background-color', false:''}[featured.idea.ideaType == 'option']\">\n" +
    "\t\t<div ng-switch on=\"featured.idea.ideaType\">\n" +
    "\t\t\t<!--Options Tabs -->\n" +
    "\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-7 fs-chart-full-span no-padding\" ng-switch-when=\"option\">\n" +
    "\t\t\t\t<div id=\"option_chart_nav_wrap\">\n" +
    "\t\t\t\t\t<ul class=\"nav nav-tabs nav-options\">\n" +
    "\t\t\t\t\t\t<!-- The tabs are each given a number based on the idea selected. This is so they have a unique id. If I didn't do this, the code would confuse the\n" +
    "\t\t\t\t\t\t\t\t tabs between different ideas and wouldn't switch the content properly. The proft and config tabs are commented out because they have no content yet -->\n" +
    "\t\t\t\t\t\t<li class=\"active ledge\"><a href=\"#chart-{{ideaId}}\" data-toggle=\"tab\">{{'eventdetails.optionsChartTab' | lexicon}}</a></li>\n" +
    "\t\t\t\t\t\t<li>\n" +
    "\t\t\t\t\t\t\t<a \thref=\"#profit-{{ideaId}}\"\n" +
    "\t\t\t\t\t\t\t\tga-click-event=\"view-profit-loss\"\n" +
    "\t\t\t\t\t\t\t\tdata-category=\"ideas-platform\"\n" +
    "\t\t\t\t\t\t\t\tdata-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-widget=\"{{selectedProduct}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-toggle=\"tab\"\n" +
    "\t\t\t\t\t\t\t\tdeferred-tab-src=\"options_profit_loss_chart/template.html\">{{'eventdetails.optionsProfitAndLossTab' | lexicon}}</a>\n" +
    "\t\t\t\t\t\t</li>\n" +
    "\t\t\t\t\t\t<li>\n" +
    "\t\t\t\t\t\t\t<a \thref=\"#commentary-{{ideaId}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-toggle=\"tab\"\n" +
    "\t\t\t\t\t\t\t\tga-click-event=\"click-commentary\"\n" +
    "\t\t\t\t\t\t\t\tdata-category=\"ideas-platform\"\n" +
    "\t\t\t\t\t\t\t\tdata-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-widget=\"{{selectedProduct}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-index=\"{{ideas.indexOf(selectedIdea)}}\">{{'eventdetails.optionsCommentaryTab' | lexicon}}</a>\n" +
    "\t\t\t\t\t\t</li>\n" +
    "\t\t\t\t\t</ul>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<!-- tab content -->\n" +
    "\t\t\t\t<div class=\"tab-content options-tab-content\">\n" +
    "\t\t\t\t\t<div class=\"tab-pane active\" id=\"chart-{{ideaId}}\">\n" +
    "\t\t\t\t\t\t<span ng-include ng-init=\"chartParams=priceChartParams\" src=\"'price_chart/template.html'\"></span>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t<div class=\"tab-pane\" id=\"profit-{{ideaId}}\">\n" +
    "\t\t\t\t\t\t<span ng-include=\"deferredTabSrc\" ng-init=\"profitAndLossChart=profitAndLossChartParams\" ></span>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t<div class=\"tab-pane fs-what-found-tab\" id=\"commentary-{{ideaId}}\">\n" +
    "\t\t\t\t\t\t<div ng-include=\"'event_details/template_what_found.html'\"></div>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\n" +
    "\t\t\t<!-- Just display the chart if options isn't selected -->\n" +
    "\t\t\t<div ng-switch-default>\n" +
    "\t\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-7 rightborder-split fs-chart-full-span\" ng-include ng-init=\"chartParams=priceChartParams\"\n" +
    "\t\t\t\t\tsrc=\"'price_chart/template.html'\"></div>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\n" +
    "\t\t<div class=\"col-xs-12 col-sm-12 col-md-5\" style=\"padding-left: 0px; padding-right: 0px;\"\n" +
    "\t\t\t\tng-switch on=\"featured.idea.ideaType\">\n" +
    "\t\t\t\t<!-- option -->\n" +
    "\t\t\t\t<div ng-switch-when=\"option\">\n" +
    "\t\t\t\t\t<span ng-include src=\"'options_strategy_details/template.html'\"></span>\n" +
    "\t\t\t\t</div>\n" +
    "\n" +
    "\t\t\t\t<!-- bullish / bearish featured ideas -->\n" +
    "\t\t\t\t<div ng-switch-default>\n" +
    "\t\t\t\t\t<div ng-include=\"'event_details/template_what_found.html'\"></div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('event_details/template_largechart.html',
    "<div ng-controller=\"IdeaController\">\r" +
    "\n" +
    "\t<div class=\"fs-large-chart\">\r" +
    "\n" +
    "\t\t<span ng-init=\"chartParams=largeChartParams;largeChart=true\" ng-include src=\"'price_chart/template.html'\"></span>\r" +
    "\n" +
    "\t\t<span ng-if=\"featured.idea.ideaType == 'forex'\" ng-class=\"{'fs-candlesticks-only-selected': userSettings.forexLargeChartAlwaysCandlesticks}\" class=\"fs-candlesticks-only\">\r" +
    "\n" +
    "\t\t\t<label><input type=\"checkbox\" ng-model=\"userSettings.forexLargeChartAlwaysCandlesticks\" ng-change=\"candlestickCheckboxChanged()\">{{alwaysCandlesticksForLargeForexChartLabel}}</label>\r" +
    "\n" +
    "\t\t</span>\r" +
    "\n" +
    "\t</div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('event_details/template_scorer_tooltip.html',
    "<div id=\"score_details_tooltip\" class=\"tooltip-text\">\n" +
    "\t<h4>{{scoreHeading}}</h4>\n" +
    "\t<ul>\n" +
    "\t\t{{justificationList}}\n" +
    "\t</ul>\n" +
    "</div>"
  );


  $templateCache.put('event_details/template_strategy.html',
    "<div ng-controller=\"EventDetailsStrategyCtrl\">\r" +
    "\n" +
    "\t<div class=\"container-fluid fs-strategy-layer\">\r" +
    "\n" +
    "\t\t<div class=\"row fs-details-title\">\r" +
    "\n" +
    "\t\t\t<div class=\"col-md-12\">\r" +
    "\n" +
    "\t\t\t\t<div class=\"info-text fs-strategy-text\">{{'eventdetails.underlying-strategy' | lexicon}}</div>\r" +
    "\n" +
    "\t\t\t\t<div class=\"fs-backbutton-container\">\r" +
    "\n" +
    "\t\t\t\t\t<button id=\"fs-button-back\" class =\"btn btn-normal fs-back-button btn-contrast\" ng-click=\"eventDetails.viewBack()\">\r" +
    "\n" +
    "\t\t\t\t\t\t<i class=\"fa fa-reply\"></i> {{'common.back' | lexicon}}\r" +
    "\n" +
    "\t\t\t\t\t</button>\r" +
    "\n" +
    "\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t<div class=\"fs-backbutton-container-short\">\r" +
    "\n" +
    "\t\t\t\t\t<button class =\"btn btn-normal fs-back-button btn-contrast\" aria-label=\"{{'common.back' | lexicon}}\" ng-click=\"eventDetails.viewBack()\">\r" +
    "\n" +
    "\t\t\t\t\t\t<i class=\"fa fa-reply\"></i>\r" +
    "\n" +
    "\t\t\t\t\t</button>\r" +
    "\n" +
    "\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t<div class=\"fs-backtest-popover-container\">\r" +
    "\n" +
    "\t\t\t\t\t<div class=\"backtest-name\"><!-- this span should be removed, and the two styles here renamed and moved -->\r" +
    "\n" +
    "\t\t\t\t\t\t<a class=\"backtest-name-link\"  data-original-title=\"{{'eventdetails.how-backtesting-works-title' | lexicon}}\" data-content=\"{{'eventdetails.how-backtesting-works-text' | lexicon}}\"  pop-over data-jason=\"{{'eventdetails.how-backtesting-works-text' | lexicon}}\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t{{'eventdetails.how-backtesting-works' | lexicon}}\t</a>\r" +
    "\n" +
    "\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t</div>\r" +
    "\n" +
    "\t\t</div>\r" +
    "\n" +
    "\t\t<div class=\"row fs-strategy-body\">\r" +
    "\n" +
    "\t\t\t<div class=\"col-md-5\">\r" +
    "\n" +
    "\t\t\t\t<div class=\"fs-strategy-title\">{{quotedName}}</div>\r" +
    "\n" +
    "\t\t\t\t<div class=\"fs-strategy-summary\"><span>{{'eventdetails.matching-criteria' | lexicon}}</span></div>\r" +
    "\n" +
    "\t\t\t\t<div class=\"fs-criteria\">\r" +
    "\n" +
    "\t\t\t\t\t<div class=\"fs-criteria-list icons\">\r" +
    "\n" +
    "\t\t\t\t\t\t\t<div ng-repeat=\"criteriaTag in criteriaTags\"><i class=\"fa fa-caret-right\"></i><span class=\"bullet-text\"><b>{{criteriaTag.name}}</b>: {{getCriteria(criteriaTag)}}</span></div>\r" +
    "\n" +
    "\t\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t\t</div>\r" +
    "\n" +
    "\t\t\t</div>\r" +
    "\n" +
    "\t\t\t<div class=\"col-md-7 fs-strategy-right\">\r" +
    "\n" +
    "\t\t\t\t<div><span class=\"fs-strategy-chart-description\">{{strategyPerformanceComments}}</span></div>\r" +
    "\n" +
    "\t\t\t\t<div ng-init=\"chart=backtestChartParams\" ng-include src=\"'performance_chart/template.html'\"></div>\r" +
    "\n" +
    "\t\t\t</div>\r" +
    "\n" +
    "\t\t</div>\r" +
    "\n" +
    "\t</div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('event_details/template_what_found.html',
    "<div class=\"fs-what-found\">\n" +
    "\t<div class=\"fs-what-found-text\">{{whatFound}}</div>\n" +
    "\t<div class=\"fs-what-found-box\" scroll-bar tabindex=\"0\">\n" +
    "\t\t<div class=\"matched-tag-row\" ng-show=\"tagsMatched.length > 0\">\n" +
    "\t\t\t<div><i class=\"fa fa-tag fi-commentary-tag-icon\"></i></div>\n" +
    "\t\t\t<div>\n" +
    "\t\t\t\t<ul>\n" +
    "\t\t\t\t\t<li ng-repeat=\"tag in tagsMatched\" class=\"fi-commentary-tag\">{{tag}}</li>\n" +
    "\t\t\t\t</ul>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"fs-what-found-box-bullets\">\n" +
    "\t\t\t<ul>\n" +
    "\t\t\t\t<li ng-repeat=\"commentary in featured.idea.commentaries\" class=\"font-small fs-found-item\">\n" +
    "\t\t\t\t\t<i class=\"fa fa-chevron-circle-right fa-lg tips\"></i>\n" +
    "\t\t\t\t\t{{commentary}}\n" +
    "\t\t\t\t</li>\n" +
    "\t\t\t</ul>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>"
  );


  $templateCache.put('event_navigation/template.html',
    "<div ng-controller=\"NavCtrl\">\n" +
    "\t<div ng-switch on=\"ideas.initState\">\n" +
    "\t\t<div ng-switch-when=\"noIdeas\">\n" +
    "\t\t\t\t<div class=\"en-widget-empty-block\">\n" +
    "\t\t\t\t\t<div class=\"en-widget-empty-message-title\">{{'eventdetails.no-ideas-found-title' | lexicon}}</div>\n" +
    "\t\t\t\t\t<div class=\"en-widget-empty-message-desc\">{{'eventdetails.no-ideas-found-desc' | lexicon}}</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<div ng-switch-default>\n" +
    "\t\t\t<div class=\"en-widget-container\">\n" +
    "\t\t\t<div id=\"scroll-back\" class=\"backScroll\" navi-scroll=\"{{ideas[0]}}\"><i id=\"arrow-back\"\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass=\"fa fa-chevron-left fa-lg en-arrow-icon\"></i>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<div class=\"en-widget\" id=\"en-widget-outer\" dir=\"ltr\">\n" +
    "\t\t\t\t<div id=\"en-widget-inner\" dir=\"{{{true: 'ltr', false:'rtl'}[ltr]}}\">\n" +
    "\t\t\t\t\t<div class=\"en-item-box\"\n" +
    "\t\t\t\t\t\t ng-repeat=\"featured in ideas track by featured.idea['linkId']+$index\">\n" +
    "\t\t\t\t\t\t<div class=\"en-item-container\" ng-class=\"{true:'en-item-box-large', false:'en-item-box'}[isOptionsIdea(featured)]\">\n" +
    "\t\t\t\t\t\t\t\t<a  href=\"\"\n" +
    "\t\t\t\t\t\t\t\t\tng-click=\"onIdeaSelect(featured)\"\n" +
    "\t\t\t\t\t\t\t\t\tclass=\"en-item featured.idea.ideaType\"\n" +
    "\t\t\t\t\t\t\t\t\tng-class=\"[{true:'en-active',false:'en-inactive'}[isSelectedIdea(featured)], getIdeaType(featured.idea), {true:'null-nav-item'}[featured.idea.events.length === 0 || !featured.idea.active]]\"\n" +
    "\t\t\t\t\t\t\t\t\tid=\"idea-{{'linkId'}}\"\n" +
    "\t\t\t\t\t\t\t\t\tga-click-event=\"click-idea\"\n" +
    "\t\t\t\t\t\t\t\t\tdata-category=\"ideas-platform\"\n" +
    "\t\t\t\t\t\t\t\t\tdata-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\n" +
    "\t\t\t\t\t\t\t\t\tdata-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "\t\t\t\t\t\t\t\t\tdata-widget=\"{{selectedProduct}}\"\n" +
    "\t\t\t\t\t\t\t\t\tmobile-hover>\n" +
    "\t\t\t\t\t\t\t\t\t<div ng-switch on=\"featured.idea.ideaType\">\n" +
    "\t\t\t\t\t\t\t\t\t\t<div ng-switch-when=\"option\">\n" +
    "\t\t\t\t\t\t\t\t\t\t\t<div class=\"en-options-strategy-name\">{{featured.idea.trade.tradeStrategy.name}}</div>\n" +
    "\t\t\t\t\t\t\t\t\t\t\t<div class=\"en-symbol\">{{featured.idea.instrument.symbol}}</div>\n" +
    "\t\t\t\t\t\t\t\t\t\t\t<div class=\"en-profit-options\">{{getFirstTradeProfit(featured.idea)}}</div>\n" +
    "\t\t\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t\t\t\t<div ng-switch-default>\n" +
    "\t\t\t\t\t\t\t\t\t\t\t<div class=\"en-symbol en-symbol-stocks\">{{featured.idea.instrument.symbol}}</div>\n" +
    "\t\t\t\t\t\t\t\t\t\t\t<div ng-class=\"{true:'en-no-target',false:'en-target'}[hasNoTarget(featured.idea)]\">\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"en-summary\">\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t<i ng-class=\"{true:'fa fa-arrow-up fs-icon-arrow-nav-size',false:''}[callNoTarget(featured) && isBullish(featured.idea)]\"></i>\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t<i ng-class=\"{true:'fa fa-arrow-down fs-icon-arrow-nav-size',false:''}[callNoTarget(featured) && isBearish(featured.idea)]\"></i>\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t{{getMove(featured.idea)}}<span class=\"fs-target-micropips-nav\">{{micropip}}</span>\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"en-target-label\">\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t{{{true:targetLabel}[showTargetLabel]}}\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t{{{true:bullishLexicon}[callNoTarget(featured) && isBullish(featured.idea)]}}\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t{{{true:bearishLexicon}[callNoTarget(featured) && isBearish(featured.idea)]}}\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t\t</a>\n" +
    "\t\t\t\t\t\t\t<div>\n" +
    "\t\t\t\t\t\t\t\t<span ng-show=\"isSelectedIdea(featured)\">\n" +
    "\t\t\t\t\t\t\t\t\t<i class=\"fa fa-caret-down fa-2x en-down-arrow\"\n" +
    "\t\t\t\t\t\t\t\t\t\tng-class=\"['en-arrow-'+ getIdeaType(featured.idea), {false:'null-nav-item'}[featured.idea.active] ]\">\n" +
    "\t\t\t\t\t\t\t\t\t</i>\n" +
    "\t\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<div id=\"scroll-forward\" class=\"forwardScroll\" navi-scroll=\"{{ideas[0]}}\"><i id=\"arrow-forward\"\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t class=\"fa fa-chevron-right fa-lg en-arrow-icon\"></i>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('followed_instruments/template.html',
    "<div ng-controller=\"FollowedComponentCtrl\">\n" +
    "\t<div class=\"ti-spotlight-component\">\n" +
    "\t\t<div class=\"ti-spotlight-title-bar\">\n" +
    "\t\t\t<span class=\"ti-spotlight-title\">{{'technicalinsight.followed-instruments-title' | lexicon}} </span>\n" +
    "\t\t\t<span>\n" +
    "\t\t\t\t<a class=\"ti-spotlight-help-btn\"  data-original-title=\"{{'technicalinsight.help-title-instruments-im-following' | lexicon}}\" data-content=\"{{text.help}}\" data-placement=\"left\" pop-over tabindex=\"0\">\n" +
    "\t\t\t\t\t<i class='fa fa-question-circle'></i>\n" +
    "\t\t\t\t</a>\n" +
    "\t\t\t</span>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"ti-spotlight-body\">\n" +
    "\t\t\t<div ng-show=\"checkElements() == false\" class=\"ti-spotlight-element\">\n" +
    "\t\t\t\t<div class=\"ti-no-matches\">{{'technicalinsight.followed-add-an-instrument' | lexicon}}</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<div ng-show=\"checkElements()\" ng-repeat=\"element in getShownInstruments()\"\n" +
    "\t\t\t\t\tclass=\"ti-spotlight-element\">\n" +
    "\t\t\t\t<div>\n" +
    "\t\t\t\t\t<div class=\"ti-following-note-icon ti-following-icons\"\n" +
    "\t\t\t\t\t\t\tng-click=\"editInstrumentDialog(element)\"\n" +
    "\t\t\t\t\t\t\tng-keypress=\"editKeyPress($event, element)\"\n" +
    "\t\t\t\t\t\t\ttabindex=\"0\"><i class=\"fa fa-pencil-square-o\"></i></div>\n" +
    "\t\t\t\t\t<div class=\"ti-following-symbol\">\n" +
    "\t\t\t\t\t\t{{element.instrument.symbol_DISPLAY}}<span ng-show=\"displayExchanges(element.instrument.exchange_symbol)\">:<br />\n" +
    "\t\t\t\t\t\t\t<span class=\"ti-exchange\">{{element.instrument.exchange_symbol_DISPLAY}}</span>\n" +
    "\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t<div class=\"ti-following-instrument-status\">\n" +
    "\t\t\t\t\t\t<span ng-switch on=\"element.opinion\">\n" +
    "\t\t\t\t\t\t\t<span class=\"bullish\" ng-switch-when=\"L\">{{getTradeTypeText(element.opinion)}}</span>\n" +
    "\t\t\t\t\t\t\t<span class=\"bearish\" ng-switch-when=\"S\">{{getTradeTypeText(element.opinion)}}</span>\n" +
    "\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t{{getMove(element.percent_move)}}<br />{{getFollowedInstrumentsDate(element.base_timestamp)}}</div>\n" +
    "\t\t\t\t\t<div class=\"ti-following-instrument-status-icon ti-following-icons\"><i class=\"{{getFaceIcon(element.percent_move, element.opinion)}}\"></i></div>\n" +
    "\t\t\t\t\t<div class=\"ti-following-instrument-delete-icon ti-following-icons\"\n" +
    "\t\t\t\t\t\t\tng-click=\"deleteFollowedInstrument(element.id)\"\n" +
    "\t\t\t\t\t\t\tng-keypress=\"deleteKeyPress($event, element.id)\"\n" +
    "\t\t\t\t\t\t\ttabindex=\"0\"><i class=\"fa fa-trash-o\" ></i></div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"ti-spotlight-footer\">\n" +
    "\t\t\t<span ng-switch=\"!followedShowText\">\n" +
    "\t\t\t\t<span ng-switch-when=\"false\">\n" +
    "\t\t\t\t\t<a class=\"ti-spotlight-footer-left\" href=\"\" ng-click=\"toggleShow()\">{{followedShowText}}</a>\n" +
    "\t\t\t\t</span>\n" +
    "\t\t\t</span>\n" +
    "\t\t\t<a class=\"ti-spotlight-footer-right\" href=\"\" ng-click=\"addInstrumentDialog()\" id=\"add_instrument_id\">{{'technicalinsight.followed-add-instrument' | lexicon}}</a>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"modal ti-following-modal\"\n" +
    "\t\t\t\trole=\"dialog\" disable-scrollbar\n" +
    "\t\t\t\tdata-modal-overflow=\"true\" data-manager=\"div.recognia\"\n" +
    "\t\t\t\tmodal-show=\"showAddEditDialogue\"\n" +
    "\t\t\t\tmodal-focus-show=\"{{addEditFocus}}\"\n" +
    "\t\t\t\tmodal-focus-hide=\"a[id=&quot;add_instrument_id&quot;]\"\n" +
    "\t\t\t>\n" +
    "\t\t\t<div class=\"modal-header\">\n" +
    "\t\t\t\t<div ng-show=\"showAddInstrument == true\">\n" +
    "\t\t\t\t\t<h4 id=\"myDialog\">{{'technicalinsight.followed-dialog-title' | lexicon}}</h4>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<div ng-show=\"showEditInstrument == true\">\n" +
    "\t\t\t\t\t<h4>{{'technicalinsight.edit-followed-dialog-title' | lexicon}}</h4>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<div class=\"modal-body ti-following-modal-body\">\n" +
    "\t\t\t\t<div ng-show=\"showAddInstrument == true\">\n" +
    "\t\t\t\t\t<div ng-include src=\"'instrument_select/template.html'\" ng-init=\"buttonIndex='2'\"></div>\n" +
    "\t\t\t\t\t<div ng-show=\"add.instruments != null\" ng-switch=\"add.instruments.length\">\n" +
    "\t\t\t\t\t\t<span ng-switch-when=\"0\" class=\"text-danger\">{{'technicalinsight.followed-dialog-no-instruments' | lexicon}}</span>\n" +
    "\t\t\t\t\t\t<span ng-switch-when=\"1\" class=\"text-success\">{{add.instruments[0].Name}}</span>\n" +
    "\t\t\t\t\t\t<span ng-switch-default class=\"text-danger\">{{'technicalinsight.followed-dialog-multiple-instruments' | lexicon}}\n" +
    "\t\t\t\t\t\t\t<ul>\n" +
    "\t\t\t\t\t\t\t\t<li ng-repeat=\"instrument in add.instruments\">{{instrument.DisplaySymbol}}\n" +
    "\t\t\t\t\t\t\t\t\t{{instrument.DisplayExchange}}</li>\n" +
    "\t\t\t\t\t\t\t</ul>\n" +
    "\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t<div class=\"ti-following-modal-row\">\n" +
    "\t\t\t\t\t\t<label for=\"my-view\">{{'technicalinsight.followed-dialog-my-view' | lexicon}}</label>\n" +
    "\t\t\t\t\t\t<select ng-model=\"add.view\" id=\"my-view\" data-tabindex=\"200\">\n" +
    "\t\t\t\t\t\t\t<option value=\"L\">{{text.bullish}}</option>\n" +
    "\t\t\t\t\t\t\t<option value=\"S\">{{text.bearish}}</option>\n" +
    "\t\t\t\t\t\t</select>\n" +
    "\t\t\t\t\t\t<label for=\"input-datepicker\">{{'technicalinsight.followed-dialog-on' | lexicon}}</label>\n" +
    "\t\t\t\t\t\t<input type=\"text\" size=\"10\" id=\"input-datepicker\" date-value=\"add.date\" datepicker max-date=\"add.maxDate\"\n" +
    "\t\t\t\t\t\t\tdate-format=\"add.dateFormat\" data-tabindex=\"201\"/>{{(sampleDateFormat)}}\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\n" +
    "\t\t\t\t<div ng-show=\"showEditInstrument == true\">\n" +
    "\t\t\t\t\t<div class=\"ti-following-modal-instrument-name\">{{edit.companyName}}</div>\n" +
    "\t\t\t\t\t<div>{{edit.symbol}}<span ng-show=\"displayExchanges(edit.exchangeSymbol)\">:{{edit.exchangeSymbol}}</span></div>\n" +
    "\t\t\t\t\t<div><span ng-class=\"{true:'bullish',false:'bearish'}[edit.opinion == 'L']\">{{edit.viewText}} </span>{{'technicalinsight.followed-dialog-on' | lexicon}} {{edit.date}}</div>\n" +
    "\t\t\t\t\t<br/>\n" +
    "\t\t\t\t\t<div class=\"ti-following-modal-note\">{{'technicalinsight.followed-update-note' | lexicon}}</div>\n" +
    "\t\t\t\t</div>\n" +
    "\n" +
    "\t\t\t\t<div class=\"ti-following-modal-row\">\n" +
    "\t\t\t\t\t<label for=\"node-textarea\">{{'technicalinsight.followed-dialog-note' | lexicon}}</label><br/>\n" +
    "\t\t\t\t\t<textarea id=\"node-textarea\" ng-model=\"add.note\" rows=\"3\" data-tabindex=\"202\"></textarea>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<p class=\"text-danger\" ng-show=\"add.message\" >{{add.message}}</p>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<div class=\"modal-footer\">\n" +
    "\t\t\t\t<button ng-click=\"showAddEditDialogue = false\" data-dismiss=\"modal\" class=\"btn btn-normal btn-addinstrument-close\" data-tabindex=\"203\">\n" +
    "\t\t\t\t\t{{'technicalinsight.followed-dialog-close' | lexicon}}\n" +
    "\t\t\t\t</button>\n" +
    "\t\t\t\t<span ng-show=\"showAddInstrument == true\">\n" +
    "\t\t\t\t\t<button ng-click=\"addInstrument()\" class=\"btn btn-primary follow-instrument-save\" data-tabindex=\"204\">\n" +
    "\t\t\t\t\t\t{{'technicalinsight.followed-dialog-title' | lexicon}}\n" +
    "\t\t\t\t\t</button>\n" +
    "\t\t\t\t</span>\n" +
    "\t\t\t\t<span ng-show=\"showEditInstrument == true\">\n" +
    "\t\t\t\t\t<button ng-click=\"saveFollowedInstrument()\" class=\"btn btn-normal follow-instrument-save\" data-tabindex=\"204\">\n" +
    "\t\t\t\t\t\t{{'technicalinsight.save-followed-dialog' | lexicon}}\n" +
    "\t\t\t\t\t</button>\n" +
    "\t\t\t\t</span>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n" +
    "\n"
  );


  $templateCache.put('instrument_action/alternative_trades.html',
    "<div class=\"trade-idea\">\n" +
    "    <div ng-controller=\"InstrumentActionCtrl\" class=\"componentContainer alt-trade-btn\" >\n" +
    "        <div class=\"trade-btn\" ng-if=\"actionOptions[0].uri\">\n" +
    "            <a  href=\"javascript: void(0)\"\n" +
    "                     ng-click=\"doAction(mainAction.uri)\"\n" +
    "                     class=\"btn btn-normal\"\n" +
    "                     ng-class=\"{false:'btn-action',true:'btn-options-trade-action'}[optionsStrategy == true]\"\n" +
    "                     ga-click-event=\"click-trade-button\"\n" +
    "                     data-category=\"ideas-platform\"\n" +
    "                     data-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\n" +
    "                     data-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "                     data-widget=\"{{selectedProduct}}\">\n" +
    "\n" +
    "                <div ng-class=\"{false:'fs-instrument-action-btn-text-wrapper',\n" +
    "                                    true:'fs-instrument-action-options-btn-text-wrapper'}[optionsStrategy == true]\">\n" +
    "                    {{actionOptions[0].title | uppercase}}\n" +
    "                </div>\n" +
    "            </a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "\n"
  );


  $templateCache.put('instrument_action/template.html',
    "<div ng-controller=\"InstrumentActionCtrl\" class=\"componentContainer\">\r" +
    "\n" +
    "\t<div class=\"btn-group\" ng-class=\"{'trade-btn': actionOptions.length == 1}\" ng-if=\"actionOptions[0].uri\">\r" +
    "\n" +
    "\t\t<a href=\"javascript: void(0)\"\r" +
    "\n" +
    "\t\t\tng-click=\"doAction(mainAction.uri)\"\r" +
    "\n" +
    "\t\t\tclass=\"btn btn-normal\"\r" +
    "\n" +
    "\t\t\tng-class=\"{false:'btn-action',true:'btn-options-trade-action'}[optionsStrategy == true]\"\r" +
    "\n" +
    "\t\t\tga-click-event=\"click-trade-button\"\r" +
    "\n" +
    "\t\t\tdata-category=\"ideas-platform\"\r" +
    "\n" +
    "\t\t\tdata-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\r" +
    "\n" +
    "\t\t\tdata-idea-type=\"{{selectedIdea.idea.ideaType}}\"\r" +
    "\n" +
    "\t\t\tdata-widget=\"{{selectedProduct}}\"\r" +
    "\n" +
    "\t\t\trole=\"button\">\r" +
    "\n" +
    "\t\t\t<div ng-class=\"{false:'fs-instrument-action-btn-text-wrapper',true:'fs-instrument-action-options-btn-text-wrapper'}[optionsStrategy == true]\">\r" +
    "\n" +
    "\t\t\t\t{{mainAction.title | uppercase}}\r" +
    "\n" +
    "\t\t\t</div>\r" +
    "\n" +
    "\t\t</a>\r" +
    "\n" +
    "\t<button ng-if=\"actionOptions.length > 1\" class=\"btn btn-normal dropdown-toggle btn-action-toggle\" data-toggle=\"dropdown\" aria-expanded=\"false\" aria-label=\"{{toggleLabel}}\">\r" +
    "\n" +
    "\t\t\t<span class=\"caret\"></span>\r" +
    "\n" +
    "\t\t</button>\r" +
    "\n" +
    "\t\t<ul ng-if=\"actionOptions.length > 1\" class=\"text-ellipsis dropdown-menu pull-right custom-dropdown-menu\">\r" +
    "\n" +
    "\t\t\t<li class=\"custom-dropdown-li\" ng-repeat=\"option in actionOptions\">\r" +
    "\n" +
    "\t\t\t\t<a href=\"javascript: void(0)\" ng-click=\"setMainAction(option); doAction(option.uri)\" class=\"text-ellipsis font-small\">{{option.title | uppercase}}</a>\r" +
    "\n" +
    "\t\t\t</li>\r" +
    "\n" +
    "\t\t</ul>\r" +
    "\n" +
    "\t</div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('instrument_select/template.html',
    "<div class=\"btn-group input-group\" ng-controller=\"InstrumentSelectCtrl\">\n" +
    "\t<button ng-hide=\"isOneExchange(exchanges)\" class=\"btn btn-normal dropdown-toggle\" data-toggle=\"dropdown\" ng-keydown=\"buttonOnKeyDown($event)\"  name=\"{{'btn_dropdown'+buttonIndex}}\" id=\"focusId\" data-tabindex=\"99\">\n" +
    "\t\t{{selectedExchange.name}}&nbsp;&nbsp;<span class=\"caret\"></span>\n" +
    "\t</button>\n" +
    "\t<ul ng-hide=\"isOneExchange(exchanges)\" class=\"dropdown-menu pull-left\" role=\"menu\"  ng-keydown=\"dropdownOnKeyDown($event)\">\n" +
    "\t\t<li ng-repeat=\"exchange in exchanges\">\n" +
    "\t\t\t<a ng-click=\"setExchange(exchange)\" tabindex=\"-1\" role=\"menuitem\"  href=\"#\">\n" +
    "\t\t\t\t<span>{{ exchange.name }}</span></a>\n" +
    "\t\t</li>\n" +
    "\t</ul>\n" +
    "\t<input type=\"text\"  class=\"pull-left form-control ti-input-symbol-search\" name =\"symbol_input\"  input-click-event click-button-id =\"'search_button'+buttonIndex\"\n" +
    "\t\t\taira-label=\"{{'instrument_lookup.symbol-or-name' | lexicon}}\"placeholder=\"{{'instrument_lookup.symbol-placeholder' | lexicon}}\" ng-model=\"symbol\" data-tabindex=\"100\">\n" +
    "\t<button class=\"btn btn-normal btn-search\" ng-click=\"search()\" data-tabindex=\"101\" id=\"{{'search_button'+buttonIndex}}\">\n" +
    "\t\t<i class=\"fa fa-search fa-lg\"></i>\n" +
    "\t\t<span class= \"hidden-text\" > {{'common.searchText' | lexicon}} </span>\n" +
    "\t</button>\n" +
    "</div>\n" +
    "\n"
  );


  $templateCache.put('matched_tags/template.html',
    "<div ng-controller=\"NoMatchingTagsMessageController\">\n" +
    "    <div ng-show=\"message\" id=\"ti-preference-alert\" class=\"ti-preference-alert-bar\" >\n" +
    "        <p class = \"ti-preference-alert-message\">\n" +
    "            {{message}}\n" +
    "        </p>\n" +
    "    </div>\n" +
    "</div>"
  );


  $templateCache.put('most_followed_instruments/template.html',
    "<div ng-controller=\"MostFollowedInstrumentsCtrl\" xmlns=\"http://www.w3.org/1999/html\">\n" +
    "\t<div class=\"ti-spotlight-component\">\n" +
    "\t\t<div class=\"ti-spotlight-title-bar\">\n" +
    "\t\t\t\t<span ng-include=\"'country_dropdown/template.html'\" ng-init=\"parameterForLoadingExchanges='instrument';buttonIndex='2'\"></span>\n" +
    "\t\t\t<span ng-switch on=\"oneExchange\">\n" +
    "\t\t\t\t<span ng-switch-when=\"false\" class=\"ti-spotlight-title ti-spotlight-title-flag\">{{'technicalinsight.spotlight-most-followed-instruments' | lexicon}}</span>\n" +
    "\t\t\t\t<span ng-switch-when=\"true\" class=\"ti-spotlight-title\">{{'technicalinsight.spotlight-most-followed-instruments' | lexicon}}</span>\n" +
    "\t\t\t</span>\n" +
    "\t\t\t<span>\n" +
    "\t\t\t\t<a class=\"ti-spotlight-help-btn\"\n" +
    "\t\t\t\t\tdata-original-title=\"{{'technicalinsight.help-title-most-followed-instruments' | lexicon}}\"\n" +
    "\t\t\t\t\tdata-content=\"{{'technicalinsight.help-hover-most-followed-instruments' | lexicon}}\"\n" +
    "\t\t\t\t\tdata-placement=\"left\"  pop-over tabindex=\"0\" >\n" +
    "\t\t\t\t\t<i class='fa fa-question-circle'></i>\n" +
    "\t\t\t\t</a>\n" +
    "\t\t\t</span>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"ti-spotlight-body\">\n" +
    "\t\t\t<div ng-show=\"noMatches\" class=\"ti-spotlight-element\">\n" +
    "\t\t\t\t<div class=\"ti-no-matches\">{{'technicalinsight.no-data' | lexicon}}</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<div ng-repeat=\"e in entries\" class=\"ti-spotlight-element\">\n" +
    "\t\t\t\t<div class=\"ti-column-symbol\">\n" +
    "\t\t\t\t\t{{e.symbol}}<span ng-show=\"displayExchanges(e.exchangeSymbol)\">:<br>\n" +
    "\t\t\t\t\t\t<span class=\"ti-exchange\">{{e.exchange}}</span>\n" +
    "\t\t\t\t\t</span>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<div class=\"ti-column-percentage\">\n" +
    "\t\t\t\t\t<div class=\"ti-progress\">\n" +
    "\t\t\t\t\t\t<div class=\"ti-progress-text\" ng-style=\"e.bullish.style\">\n" +
    "\t\t\t\t\t\t\t{{e.bullish.percent | nf_percent:0}}\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t<div class=\"ti-bar\" ng-style=\"e.bearish.style\">\n" +
    "\t\t\t\t\t\t\t<div class=\"ti-bar-text\" ng-style=\"e.bearish.style\">\n" +
    "\t\t\t\t\t\t\t\t{{e.bearish.percent | nf_percent:0}}\n" +
    "\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<div class=\"ti-column-trade\" ng-class=\"e.style\">{{text[e.style]}}</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"ti-spotlight-footer\">\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('options_profit_loss_chart/template.html',
    "<div ng-controller=\"OptionsProfitLossChartCtrl\">\n" +
    "\n" +
    "\t<div class=\"profit-loss-chart-legends\">\n" +
    "\t\t<div class=\"profit-loss-chart-legend custom-checkbox\">\n" +
    "\t\t\t<label ng-click=\"toggleStrikePrice()\">\n" +
    "\t\t\t\t<i class=\"fa fa-stop legend-icon strike-price\"/>\n" +
    "\t\t\t\t<i  ng-class=\"{true:'fa fa-check-square rtl-exempt-flip checkbox-check',false:'fa fa-square-o checkbox-empty'}[profitLossChartLegends.showStrikePrice]\"/>\n" +
    "\t\t\t\t<span class=\"legend-title\">{{'optionsProfitLossChart.strike-price' | lexicon}}</span>\n" +
    "\t\t\t</label>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"profit-loss-chart-legend custom-checkbox\">\n" +
    "\t\t\t<label ng-click=\"toggleTargetPrice()\">\n" +
    "\t\t\t\t<i class=\"fa fa-stop legend-icon target-price\"/>\n" +
    "\t\t\t\t<i  ng-class=\"{true:'fa fa-check-square rtl-exempt-flip checkbox-check',false:'fa fa-square-o checkbox-empty'}[profitLossChartLegends.showTargetPrice]\"/>\n" +
    "\t\t\t\t<span class=\"legend-title\">{{'optionsProfitLossChart.target-price' | lexicon}}</span>\n" +
    "\t\t\t</label>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"profit-loss-chart-legend custom-checkbox\">\n" +
    "\t\t\t<label ng-click=\"toggleLastPrice()\">\n" +
    "\t\t\t\t<i class=\"fa fa-stop legend-icon chart-lastprice\"/>\n" +
    "\t\t\t\t<i  ng-class=\"{true:'fa fa-check-square rtl-exempt-flip checkbox-check',false:'fa fa-square-o checkbox-empty'}[profitLossChartLegends.showLastPrice]\"/>\n" +
    "\t\t\t\t<span class=\"legend-title\">{{lexiconLastPrice}}</span>\n" +
    "\t\t\t</label>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "\n" +
    "\t<div highstocks-enhanced id=\"chart\" config=\"profitLossChartConfig\"></div>\n" +
    "</div>\n" +
    "\n"
  );


  $templateCache.put('options_strategy_details/template.html',
    "<div ng-controller=\"OptionsStrategyDetails\" id=\"option_strategy_detail\">\n" +
    "\t<div class=\"fs-options-strategy-details-component\">\n" +
    "\t\t<div class=\"navbar navbar-inner-options-strategy-details\">\n" +
    "\t\t\t<div class=\"fs-options-strategy-details-title-bar\">\n" +
    "\t\t\t\t<span class=\"fs-options-strategy-details-title\">\n" +
    "\t\t\t\t\t{{'options_strategy_details.main-strategy' | lexicon}}\n" +
    "\t\t\t\t</span>\n" +
    "\t\t\t\t<span class=\"fs-options-strategy-details-title-desc\">\n" +
    "\t\t\t\t\t{{optionsType}}\n" +
    "\t\t\t\t</span>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"fs-options-strategy-details-body\" ng-class=\"{'calc-activated': showCalc}\">\n" +
    "\t\t\t<div class=\"fs-options-strategy-details-legs-count\"\n" +
    "\t\t\t\tclass=\"options-strategy-subheader-wrap\"\n" +
    "\t\t\t\tng-class=\"{'calc-activated': showCalc, 'trade-frozen': !featured.idea.trade.current && !isSelectedProductWatched(selectedProduct)}\">\n" +
    "\t\t\t\t<div id=\"option_strategy_left_subheader\" ng-class=\"{deactivated: showCalc}\">\n" +
    "\t\t\t\t\t<div id=\"leg_count_heading\" ng-class=\"{deactivated: showCalc}\">\n" +
    "\t\t\t\t\t\t<p>{{generatedAt}}</p>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<div id=\"calc_btn_wrap\" ng-class=\"{activated: showCalc}\">\n" +
    "\t\t\t\t\t<button ng-click=\"showCalc = !showCalc\"\n" +
    "\t\t\t\t\t\t\tid=\"option_strategy_calc_btn\"\n" +
    "\t\t\t\t\t\t\tng-class=\"{activated: showCalc}\"\n" +
    "\t\t\t\t\t\t\tga-click-event=\"{{ {true: 'view-options-calculations', false: ''}[showCalc] }}\"\n" +
    "\t\t\t\t\t\t\tdata-category=\"ideas-platform\"\n" +
    "\t\t\t\t\t\t\tdata-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\n" +
    "\t\t\t\t\t\t\tdata-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "\t\t\t\t\t\t\tdata-widget=\"{{selectedProduct}}\">\n" +
    "\t\t\t\t\t\t<i class=\"fa fa-calculator fs-icon-text-style calc-icon\"  ng-class=\"{activated: showCalc}\"></i>\n" +
    "\t\t\t\t\t</button>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<div class=\"fs-options-strategy-details-legs\" ng-show=\"!showCalc\">\n" +
    "\t\t\t\t<div class=\"fs-options-trade-legs\">\n" +
    "\t\t\t\t\t<table>\n" +
    "\t\t\t\t\t\t<tr ng-repeat=\"leg in featured.idea.trade.legs | tradeLegSort:featured.idea.trade\">\n" +
    "\t\t\t\t\t\t\t<td class=\"leg-number\"><strong>{{$index + 1}}</strong></td>\n" +
    "\t\t\t\t\t\t\t<td class=\"trade-action\">\n" +
    "\t\t\t\t\t\t\t\t<div>{{ 'featuredoptions.' + leg.action | lexicon | uppercase }}</div>\n" +
    "\t\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t\t<td>\n" +
    "\t\t\t\t\t\t\t\t<div>{{ leg | tradeLegOneLineFormat:featured.idea.instrument.precision }}</div>\n" +
    "\t\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t</table>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<div id=\"options_calculator_wrap\" style=\"clear:both;\" ng-show=\"showCalc\">\n" +
    "\t\t\t\t<table id=\"options_calculator\" class=\"calculator\" style='table-layout:fixed;'>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>{{contractsInLegText}}</th>\n" +
    "\t\t\t\t\t\t<td>{{contractsEachLegText}}</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>\n" +
    "\t\t\t\t\t\t\t<span id=\"calc_net_cost\" class=\"dotted-underline\"\n" +
    "\t\t\t\t\t\t\t\tdata-original-title=\"{{netCostText}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-content=\"{{netCostPopoverText}}\" data-placement=\"right\"\n" +
    "\t\t\t\t\t\t\t\tdata-container=\"#options_calculator\" pop-over>{{netCostText}}\n" +
    "\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t\t<td ng-switch=\"featured.idea.trade.tradeStrategy.isNetCredit\">\n" +
    "\t\t\t\t\t\t\t<span ng-switch-when=\"false\">\n" +
    "\t\t\t\t\t\t\t\t{{featured.idea.trade.netCost | formatCurrency:featured.idea.instrument.precision}}\n" +
    "\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t\t<span ng-switch-when=\"true\">\n" +
    "\t\t\t\t\t\t\t\t{{featured.idea.trade.netCost * -1 | formatCurrency:featured.idea.instrument.precision}}\n" +
    "\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>\n" +
    "\t\t\t\t\t\t\t<span id=\"calc_max_loss\" class=\"dotted-underline\"\n" +
    "\t\t\t\t\t\t\t\tdata-original-title=\"{{'options_strategy_details.max-loss' | lexicon}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-content=\"{{maxLossPopoverText}}\" data-placement=\"right\"\n" +
    "\t\t\t\t\t\t\t\tdata-container=\"#options_calculator\" pop-over>\n" +
    "\t\t\t\t\t\t\t\t\t{{'options_strategy_details.max-loss' | lexicon}}\n" +
    "\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t\t<td>{{maxLoss}} ({{maxLossPrecentage}})</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>\n" +
    "\t\t\t\t\t\t\t<span id=\"calc_max_profit\" class=\"dotted-underline\"\n" +
    "\t\t\t\t\t\t\t\tdata-original-title=\"{{'options_strategy_details.max-profit' | lexicon}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-content=\"{{maxProfitPopoverText}}\" data-placement=\"right\"\n" +
    "\t\t\t\t\t\t\t\tdata-container=\"#options_calculator\" pop-over>\n" +
    "\t\t\t\t\t\t\t\t\t{{'options_strategy_details.max-profit' | lexicon}}\n" +
    "\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t\t<td style=\"word-wrap:break-word;\">{{maxProfit}} {{maxProfitPrecentage}}</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>\n" +
    "\t\t\t\t\t\t\t<span id=\"calc_target_price\" class=\"dotted-underline\"\n" +
    "\t\t\t\t\t\t\t\tdata-original-title=\"{{'options_strategy_details.target-price' | lexicon}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-content=\"{{targetPricePopoverText}}\" data-placement=\"right\"\n" +
    "\t\t\t\t\t\t\t\tdata-container=\"#options_calculator\" pop-over>\n" +
    "\t\t\t\t\t\t\t\t\t{{'options_strategy_details.target-price' | lexicon}}\n" +
    "\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t\t<td>{{targetPrice}}</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t\t<tr>\n" +
    "\t\t\t\t\t\t<th>\n" +
    "\t\t\t\t\t\t\t<span id=\"calc_target_profit\" class=\"dotted-underline\"\n" +
    "\t\t\t\t\t\t\t\tdata-original-title=\"{{'options_strategy_details.target-profit' | lexicon}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-content=\"{{targetProfitPopoverText}}\"\n" +
    "\t\t\t\t\t\t\t\tdata-placement=\"right\"\n" +
    "\t\t\t\t\t\t\t\tdata-container=\"#options_calculator\" pop-over>\n" +
    "\t\t\t\t\t\t\t\t\t{{'options_strategy_details.target-profit' | lexicon}}\n" +
    "\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t</th>\n" +
    "\t\t\t\t\t\t<td>{{targetProfit}} ({{targetProfitPerc}})</td>\n" +
    "\t\t\t\t\t</tr>\n" +
    "\t\t\t\t</table>\n" +
    "\t\t\t\t<div   class=\"options-strategy-footer\" >\n" +
    "\t\t\t\t\t<p>{{'options_strategy_details.exclude-commissions' | lexicon}}</p>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<script>\n" +
    "\n" +
    "\t\t\t</script>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"fs-options-strategy-details-footer\" ng-show=\"!showCalc\"\n" +
    "\t\t\t\tng-switch=\"featured.idea.trade.tradeStrategy.isNetCredit\">\n" +
    "\t\t\t<span ng-switch-when=\"false\">\n" +
    "\t\t\t\t{{'options_strategy_details.net-cost-colon' | lexicon}} {{featured.idea.trade.netCost | formatCurrency:featured.idea.instrument.precision}}\n" +
    "\t\t\t</span>\n" +
    "\t\t\t<span ng-switch-when=\"true\">\n" +
    "\t\t\t\t{{'options_strategy_details.net-received-colon' | lexicon}} {{featured.idea.trade.netCost * -1 | formatCurrency:featured.idea.instrument.precision}}\n" +
    "\t\t\t</span>\n" +
    "\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "\t<div ng-show=\"!showCalc\" id=\"options-strategy-details-trade-now\" ng-switch on=\"selectedProduct\">\n" +
    "\t\t<span ng-switch-when=\"watchedOptions\">\n" +
    "\t\t\t<span ng-include=\"'watched_option_progress/template.html'\"></span>\n" +
    "\t\t</span>\n" +
    "\t\t<div ng-switch-default class=\"trade-btn-wrapper\">\n" +
    "\t\t\t<span ng-init=\"idea=featured.idea;permission=permission;\" ng-include=\"'instrument_action/template.html'\" template-vars=\"optionsStrategy\"></span>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('performance_chart/template.html',
    "<div ng-controller=\"PerformanceChartCtrl\">\n" +
    "\t<div class=\"backtest-chart-wrapper\">\n" +
    "\t\t<div highstocks-enhanced id=\"chart\" config=\"performanceChartConfig\"></div>\n" +
    "\t</div>\n" +
    "\t<div class=\"checkbox\">\n" +
    "\t\t<label class=\"question-font\">\n" +
    "\t\t\t<input  type=\"checkbox\"\n" +
    "\t\t\t\t\tng-model=\"chart.showStops\"\n" +
    "\t\t\t\t\tga-click-event=\"toggle-backtesting-trailing-stop\"\n" +
    "\t\t\t\t\tdata-category=\"ideas-platform\"\n" +
    "\t\t\t\t\tdata-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\n" +
    "\t\t\t\t\tdata-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "\t\t\t\t\tdata-widget=\"{{selectedProduct}}\" />{{'eventdetails.show-stop' | lexicon}}</label>\n" +
    "\t</div>\n" +
    "</div>\n" +
    "\n"
  );


  $templateCache.put('price_chart/template.html',
    "<div ng-show=\"showWatchedBarTimeInfo\" >\n" +
    "\t<div class=\"watched-bar-time\">\n" +
    "\t\t<i class=\"fa fa-star fs-icon-text-style watched-bar-time\"></i>\n" +
    "\t\t<span class=\"watched-bar-time\">{{watchedBarTimeInfo}}</span>\n" +
    "\t</div>\n" +
    "</div>\n" +
    "<div ng-controller=\"PriceChartCtrl\" id=\"chart{{ideaId}}\" bling class=\"bling floating-block\"\n" +
    "\t ng-style=\"featured.idea.ideaType === 'stock' && {'min-height': '307px'} ||\n" +
    "\t featured.idea.ideaType === 'option' && {'min-height': '267'} ||\n" +
    "\t featured.idea.ideaType === 'forex' && {'min-height': '307px'}\">\n" +
    "</div>\n" +
    "\n"
  );


  $templateCache.put('spotlight_component/template.html',
    "<div class=\"col-md-4\" ng-controller=\"SpotlightComponentCtrl\">\n" +
    "\t<div class=\"ti-spotlight-component\">\n" +
    "\t\t<div class=\"ti-spotlight-title-bar\">\n" +
    "\t\t\t<span class=\"ti-spotlight-title\">{{'technicalinsight.spotlight-bullish-most-viewed' | lexicon}} </span>\n" +
    "\t\t\t<span class=\"ti-spotlight-title-desc\">{{'technicalinsight.spotlight-title-desc' | lexicon}}</span>\n" +
    "\t\t\t<span class=\"ti-spotlight-help-btn\"><i class=\"glyph-question-sign\"></i></span>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"ti-spotlight-body\">\n" +
    "\t\t\t<div ng-repeat=\"element in selectedElements\">\n" +
    "\t\t\t\t<div class=\"ti-spotlight-element-list\">\n" +
    "\t\t\t\t\t<span class=\"ti-spotlight-element\">{{element}}</span>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"ti-spotlight-footer\">\n" +
    "\t\t\t<span class=\"ti-spotlight-footer-left\">{{'technicalinsight.spotlight-more' | lexicon}}</span>\n" +
    "\t\t\t<span class=\"ti-spotlight-footer-right\">{{'technicalinsight.spotlight-add-instrument' | lexicon}}</span>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('style_checkbox/template.html',
    "<div ng-controller=\"StyleCheckboxCtrl\" class=\"container-fluid\">\n" +
    "\t<div ng-switch on=\"titleStyle\" class=\"row\">\n" +
    "\t\t<div class=\"question-font personal-settings-questions-container\" ng-switch-when=\"non-check\">\n" +
    "\t\t\t<div ng-switch on=\"style\">\n" +
    "\t\t\t\t<div id=\"tc-settings-title-label\" ng-switch-when=\"tags\">\n" +
    "\t\t\t\t\t<strong>{{settingsTitle}}</strong>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<div ng-switch-default>\n" +
    "\t\t\t\t\t<strong>{{settingsTitle}}</strong>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<hr class=\"personal-settings-question-horizontal-line\" />\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"settings-question-checkbox-style checkbox\" ng-switch-when=\"check\">\n" +
    "\t\t\t<label>\n" +
    "\t\t\t\t<input type=\"checkbox\" ng-click=\"onClick(id)\" ng-checked=\"checkParent\"/>\n" +
    "\t\t\t\t{{settingsTitle}}\n" +
    "\t\t\t</label>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "\t<div class=\"row settings-checkbox-style\" ng-switch on=\"style\">\n" +
    "\t\t<div class=\"settings-answer-checkbox-style inner-question\" ng-switch-when=\"checkbox\">\n" +
    "\t\t\t<span ng-repeat=\"question in questionsTranslated\">\n" +
    "\t\t\t\t<label class=\"col-xs-12 col-sm-6 col-md-4 question-font\" >\n" +
    "\t\t\t\t\t\t<input type=\"checkbox\" ng-model=\"question.isSelected\" ng-checked=\"isSelected(question.id)\" ng-click=\"onClick(question.id)\"/>\n" +
    "\t\t\t\t\t\t{{question.name}}\n" +
    "\t\t\t\t</label>\n" +
    "\t\t\t</span>\n" +
    "\t\t</div>\n" +
    "\n" +
    "\t\t<div class=\"inner-question\" ng-switch-when=\"button\">\n" +
    "\t\t\t<!--button dropdown list-->\n" +
    "\t\t\t<div ng-show=\"isDDL()\">\n" +
    "\t\t\t\t<div class=\"ps-list-exchange-group\">\n" +
    "\t\t\t\t\t<div class=\"btn-group \">\n" +
    "\n" +
    "\t\t\t\t\t\t<span ng-switch=\"!btnDropdownTitle\">\n" +
    "\t\t\t\t\t\t\t<span ng-switch-when=\"false\">\n" +
    "\t\t\t\t\t\t\t\t<button class=\"btn btn-normal dropdown-toggle\" data-toggle=\"dropdown\" id=\"focusButton\">{{btnDropdownTitle}}\n" +
    "\t\t\t\t\t\t\t\t\t<span class=\"personal-settings-dropdown-arrow\"><span class=\"caret caret-exchange\"></span></span>\n" +
    "\t\t\t\t\t\t\t\t</button>\n" +
    "\n" +
    "\t\t\t\t\t\t\t\t<ul class=\"dropdown-menu\" role=\"menu\" ng-keydown=\"dropdownOnKeyDown($event)\">\n" +
    "\t\t\t\t\t\t\t\t\t<li ng-repeat=\"question in questionsTranslated\" ng-hide=\"selectedQuestion(question)\">\n" +
    "\t\t\t\t\t\t\t\t\t\t<a href=\"\" role=\"menuitem\"  ng-click=\"addQuestionButton(question)\">{{question.name}}</a>\n" +
    "\t\t\t\t\t\t\t\t\t</li>\n" +
    "\t\t\t\t\t\t\t\t</ul>\n" +
    "\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\n" +
    "\t\t\t<span ng-repeat=\"question in questionsTranslated\">\n" +
    "\t\t\t\t<div class=\"col-md-6 question-checkbox\" ng-show=\"selectedQuestion(question)\">\n" +
    "\t\t\t\t\t<div class=\"button-container\">\n" +
    "\t\t\t\t\t\t<button class=\"btn personalize-btn btn-normal btn-outer btn-contrast\" ng-class=\"{'btn-selected':isSelected(question.id)}\" ng-click=\"onClick(question.id)\" type=\"button\" >\n" +
    "\t\t\t\t\t\t\t<div class=\"btn-text\">{{question.name}}</div>\n" +
    "\t\t\t\t\t\t\t<div class=\"btn-icon\" ng-switch on=\"uiControl\" >\n" +
    "\t\t\t\t\t\t\t\t<i ng-switch-default ng-class=\"{'fa fa-check rtl-exempt-flip':isSelected(question.id), 'fa fa-plus':!isSelected(question.id)}\" ></i>\n" +
    "\t\t\t\t\t\t\t\t<i ng-switch-when=\"buttonToDropdown\" class=\"fa fa-minus\"></i>\n" +
    "\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t</button>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t </span>\n" +
    "\t\t</div>\n" +
    "\n" +
    "\n" +
    "\t\t<div class=\"inner-question\" ng-switch-when=\"tags\">\n" +
    "\t\t\t<!--Auto complete input field-->\n" +
    "\t\t\t<span ng-include ng-init=\"questionId=question['linkId']\" src=\"'auto_suggest_inputfield/template.html'\"></span>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n" +
    "\n" +
    "\n"
  );


  $templateCache.put('technical_event_screeners/template.html',
    "<div ng-controller=\"TechnicalEventScreenersCtrl\">\n" +
    "\t<div class=\"ti-spotlight-component\">\n" +
    "\t\t<div class=\"ti-spotlight-title-bar\">\n" +
    "\t\t\t<span class=\"ti-spotlight-title\">{{'technicalinsight.spotlight-technical-event-screeners' | lexicon}}</span>\n" +
    "\t\t\t<span>\n" +
    "\t\t\t\t<a class=\"ti-spotlight-help-btn\"\n" +
    "\t\t\t\t\tdata-original-title=\"{{'technicalinsight.help-title-technical-event-screener' | lexicon}}\"\n" +
    "\t\t\t\t\tdata-content=\"{{'technicalinsight.help-hover-technical-event-screener' | lexicon}}\"\n" +
    "\t\t\t\t\tdata-placement=\"left\" pop-over tabindex=\"0\">\n" +
    "\t\t\t\t\t<i class='fa fa-question-circle'></i>\n" +
    "\t\t\t\t</a>\n" +
    "\t\t\t</span>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"ti-spotlight-event-screeners-body\">\n" +
    "\t\t\t<a ng-repeat=\"element in selectedElements\"\n" +
    "\t\t\t\t\tng-href=\"{{element.value}}\"\n" +
    "\t\t\t\t\tclass=\"ti-spotlight-element\">\n" +
    "\t\t\t\t<span class=\"ti-spotlight-screener\">{{element.option}}</span>\n" +
    "\t\t\t\t<span class=\"ti-spotlight-screener-icon\"><i class=\"fa fa-chevron-right\"></i></span>\n" +
    "\t\t\t</a>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"ti-spotlight-footer\">\n" +
    "\t\t\t<a ng-href=\"{{technicalEventsShowAllLink}}\"\n" +
    "\t\t\t\tclass=\"ti-spotlight-footer-right\">{{'technicalinsight.spotlight-advanced-screener' | lexicon}}</a>\n" +
    "\t\t\t</a>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('technical_insight_alert/template.html',
    "<div ng-controller=\"TechnicalInsightAlertCtrl\">\n" +
    "\t<div id=\"ti-alert\" class=\"ti-alert-bar\" ng-show=\"tiAlertCounter\">\n" +
    "\t\t<span class=\"fa-stack fa-lg\">\n" +
    "\t\t\t<i id=\"ti-alert-icon-envelope\" class=\"fa fa-envelope fa-stack-1x\"></i>\n" +
    "\t\t\t<i id=\"ti-alert-fa fa-circle\" class=\"fa fa-circle fa-stack-1x\"></i>\n" +
    "\t\t\t<span id=\"ti-alert-icon-count\" class=\"icon-light fa-stack-1x\">{{tiAlertCounter}}</span>\n" +
    "\t\t</span>\n" +
    "\t\t<a href={{tiAlertLink}}>\n" +
    "\t\t\t<span class = \"ti-alert-message\">\n" +
    "\t\t\t\t<span ng-bind-html=\"tiAlertMessage\"></span>\n" +
    "\t\t\t</span>\n" +
    "\t\t</a>\n" +
    "\t\t<span hide-container=\"#ti-alert\" class=\"ti-alert-close\" tabindex=\"0\">&times;</span>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('viewed_rated_component/template.html',
    "<div ng-controller=\"MostViewedComponentCtrl\">\n" +
    "\t<div>\n" +
    "\t\t<div class=\"ti-spotlight-component\">\n" +
    "\t\t\t<div class=\"ti-spotlight-title-bar\">\n" +
    "\t\t\t\t<span ng-include=\"'country_dropdown/template.html'\" ng-init=\"parameterForLoadingExchanges='event';buttonIndex=button_name\"></span>\n" +
    "\t\t\t\t<span ng-switch on=\"oneExchange\">\n" +
    "\t\t\t\t\t<span ng-switch-when=\"false\" class=\"ti-spotlight-title ti-spotlight-title-flag\">{{text.title}}</span>\n" +
    "\t\t\t\t\t<span ng-switch-when=\"true\" class=\"ti-spotlight-title\">{{text.title}}</span>\n" +
    "\t\t\t\t</span>\n" +
    "\t\t\t\t<span>\n" +
    "\t\t\t\t\t<a class=\"ti-spotlight-help-btn\"  data-original-title=\"{{text.helpTitle}}\" data-content=\"{{text.help}}\" data-placement=\"left\" pop-over tabindex=\"0\">\n" +
    "\t\t\t\t\t\t<i class='fa fa-question-circle'></i>\n" +
    "\t\t\t\t\t</a>\n" +
    "\t\t\t\t</span>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<div class=\"ti-spotlight-body\">\n" +
    "\t\t\t\t<div ng-show=\"noMatches\" class=\"ti-spotlight-element\">\n" +
    "\t\t\t\t\t<div class=\"ti-no-matches\">{{text.noMatches}}</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<a ng-repeat=\"e in entries\"\n" +
    "\t\t\t\t\t\thref={{e.url}} class=\"ti-spotlight-element\">\n" +
    "\t\t\t\t\t<div>\n" +
    "\t\t\t\t\t\t<div class=\"ti-column-symbol\">\n" +
    "\t\t\t\t\t\t\t{{e.symbol}}<span ng-show=\"displayExchanges(e.exchangeSymbol)\">:<br />\n" +
    "\t\t\t\t\t\t\t\t<span class=\"ti-exchange\">{{e.exchange}}</span>\n" +
    "\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t<div class=\"ti-column-event overflow\" ng-class=\"e.style\"><div>{{e.eventName}}</div></div>\n" +
    "\t\t\t\t\t\t<div class=\"ti-column-date\">{{e.date}}</div>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</a>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<div class=\"ti-spotlight-footer\">\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('watch_button/template.html',
    "<button class=\"btn btn-normal btn-xs btn-watch\"\n" +
    "\t\ttype=\"button\"\n" +
    "\t\tng-controller=\"WatchButtonCtrl\"\n" +
    "\t\tng-class=\"{'not-watched':!watched, 'is-watched':watched}\"\n" +
    "\t\tng-click=\"toggle()\"\n" +
    "\t\tga-click-event=\"click-{{ watched ? 'unwatch' : 'watch' }}\"\n" +
    "\t\tdata-category=\"ideas-platform\"\n" +
    "\t\tdata-idea-type=\"{{idea.idea.ideaType}}\"\n" +
    "\t\tdata-symbol=\"{{idea.idea.instrument.symbol}}\"\n" +
    "\t\tdata-widget=\"{{widget}}\"\n" +
    "\t\tdata-tabindex=\"{{counter + 5}}\"\n" +
    ">\n" +
    "\t<span ng-hide=\"watched\"><i class=\"fa fa-star\"></i></span>\n" +
    "\t<span class=\"fs-instrument-tag\">{{watched ? text.watched : text.watch}}</span>\n" +
    "</button>\n"
  );


  $templateCache.put('watched_option_progress/template.html',
    "<div ng-controller=\"WatchedOptionProgress\">\n" +
    "\t<div class=\"light-box\" ng-switch on=\"priceMove.status\" ng-hide=\"priceMove.status==null\">\n" +
    "\t\t<div ng-switch-when=\"success\">\n" +
    "\t\t\t<i class=\"watched-progress-info-icon\"\n" +
    "\t\t\t\tng-class=\"{true: 'fa fa-exclamation-triangle', false: 'fa fa-question-circle'}[priceMove.lossIfClosed]\"\n" +
    "\t\t\t\tdata-content=\"{{{true: greaterLossIfClosed}[priceMove.lossIfClosed]}} {{returnOnInitialCostLine}}\"\n" +
    "\t\t\t\tdata-placement=\"left\"\n" +
    "\t\t\t\tdata-title=\"{{'eventdetails.status' | lexicon}}\"\n" +
    "\t\t\t\tng-show=\"priceAvailable\" pop-over></i>\n" +
    "\t\t\t<div class=\"light-box-inner\" ng-switch on=\"priceAvailable\" >\n" +
    "\t\t\t\t<p class=\"large\" ng-switch-when=\"true\">\n" +
    "\t\t\t\t\t{{currentPriceHeading}}: <span ng-class=\"priceMove.style\">{{priceMove.priceDifference}} ({{priceMove.percentageDifference}})</span>\n" +
    "\t\t\t\t</p>\n" +
    "\t\t\t\t<p class=\"large\" ng-switch-when=\"false\">\n" +
    "                    {{'eventdetails.current-price-heading-loss-gain' | lexicon}}: {{'eventdetails.current-price-not-available' | lexicon}}\n" +
    "\t\t\t\t</p>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"light-box-inner-padded\" ng-switch-when=\"expired\">\n" +
    "\t\t\t<h4>{{'eventdetails.expired-heading' | lexicon}}</h4>\n" +
    "\t\t</div>\n" +
    "\n" +
    "\t\t<div class=\"light-box-inner-padded\" ng-switch-when=\"error\">\n" +
    "\t\t\t<h4>{{'eventdetails.deleted-heading' | lexicon}}</h4>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('widgets/disclaimer/template.html',
    "<div ng-controller=\"DisclaimerCtrl as disclaimer\" class=\"container-fluid\">\n" +
    "\t<div class=\"row di-recognia-text\">\n" +
    "\t\t<div class=\"col-md-12 \">\n" +
    "\t\t\t<span ng-bind-html=\"disclaimer.mainText\" />\n" +
    "\t\t\t<span ng-bind-html=\"disclaimer.dataProvider\" />\n" +
    "\t\t\t<span ng-bind-html=\"disclaimer.footerText\" />\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('widgets/featured_stocks/template.html',
    "<div ng-controller=\"FeaturedStocksCtrl as featuredIdeas\" class=\"widgetContainer\">\n" +
    "\n" +
    "\t<div class=\"modal fs-watched-modal\" disable-scrollbar data-manager=\"div.recognia\"\n" +
    "\t\t\tmodal-show=\"showWatchedModal\" modal-focus-show=\".modal-footer\" modal-focus-hide=\"button.fs-watched-button\">\n" +
    "\t\t<div class=\"modal-header\">{{text.watchedModalHeader}}</div>\n" +
    "\t\t<div class=\"modal-body\">\n" +
    "\t\t\t<p class=\"fs-watched-modal-text\">{{text.watchedModalIdeas}}</p>\n" +
    "\t\t</div>\n" +
    "\t\t<button class=\"modal-footer cursor-pointer\" data-dismiss=\"modal\">{{text.watchedModalClose}}</button>\n" +
    "\t</div>\n" +
    "\n" +
    "\t<div ng-show=\"selectedIdea.filtersApplied==false\"  ng-include src=\"'matched_tags/template.html'\"></div>\n" +
    "\t<div class=\"container-fluid\" >\n" +
    "\t\t\n" +
    "\t\t<div style=\"display: none\">\n" +
    "\t\t\t<span id=\"chartBackground\" class=\"chart-background\"></span>\n" +
    "\t\t\t<span id=\"chartGridline\" class=\"chart-gridline\"></span>\n" +
    "\t\t\t<span id=\"chartxAxisline\" class=\"chart-xAxisLine\"></span>\n" +
    "\t\t\t<span id=\"chartTitleColor\" class=\"chart-title-color\"></span>\n" +
    "\t\t\t<span id=\"chartLabelColor\" class=\"chart-label-color\"></span>\n" +
    "\t\t\t<span id=\"chartLegendColor\" class=\"chart-legend-color\"></span>\n" +
    "\t\t\t<span id=\"chartTickColor\" class=\"chart-tick-color\"></span>\n" +
    "\t\t\t<span id=\"chartTTBackground\" class=\"chart-tooltip-background\"></span>\n" +
    "\t\t\t<span id=\"chartTTBorderColor\" class=\"chart-tooltip-border-color\"></span>\n" +
    "\t\t\t<span id=\"chartTTFontColor\" class=\"chart-tooltip-font-color\"></span>\n" +
    "\t\t\t<span id=\"seriesColor\" class=\"chart-series\"></span>\n" +
    "\t\t\t<span id=\"volumeColor\" class=\"chart-volume\"></span>\n" +
    "\t\t\t<span id=\"navigatorColor\" class=\"chart-navigator\"></span>\n" +
    "\t\t\t<span id=\"navigatorOutlineColor\" class=\"chart-navigator-outline\"></span>\n" +
    "\t\t\t<span id=\"seriesStrategy\" class=\"chart-strategy-ts\"></span>\n" +
    "\t\t\t<span id=\"seriesStop\" class=\"chart-stop-ts\"></span>\n" +
    "\t\t\t<span id=\"chartMarkerDark\" class=\"chart-marker-dark\"></span>\n" +
    "\t\t\t<span id=\"chartMarkerLight\" class=\"chart-marker-light\"></span>\n" +
    "\t\t\t<span id=\"chartMarkerBullish\" class=\"chart-marker-bullish\"></span>\n" +
    "\t\t\t<span id=\"chartMarkerTargetProfitBackground\" class=\"chart-marker-target-profit-background\"></span>\n" +
    "\t\t\t<span id=\"chartBorderColor\" class=\"chart-border-color\"></span>\n" +
    "\t\t\t<span id=\"chartProfitLossStrikePrice\" class=\"chart-profit-loss-strike-price\"></span>\n" +
    "\t\t\t<span id=\"chartProfitLossTargetPrice\" class=\"chart-profit-loss-target-price\"></span>\n" +
    "\t\t\t<span id=\"chartProfitLossLine\" class=\"chart-profit-loss-line\"></span>\n" +
    "\t\t\t<span id=\"chartProfitLossLineHighlightColor\" class=\"chart-profit-loss-line-highlight\"></span>\n" +
    "\t\t\t<span id=\"chartTargetProfitText\" class=\"chart-target-profit-text\"></span>\n" +
    "\t\t\t<span id=\"chartMarkerLegendText\" class=\"chart-marker-legend-text\"></span>\n" +
    "\t\t\t<span id=\"chartLastPriceNumeric\" class=\"chart-last-price-numeric\"></span>\n" +
    "\t\t\t<span id=\"chartMarkerTargetValue\" class=\"chart-marker-target-value\"></span>\n" +
    "\t\t\t<span id=\"chartVolumeSeries\"></span>\n" +
    "\t\t\t<span id=\"chartAxisTitle\"></span>\n" +
    "\t\t\t<span id=\"chartMinorGridline\"></span>\n" +
    "\t\t\t<span id=\"chartOPLTooltip\"></span>\n" +
    "\t\t\t<span id=\"chartOplLastPriceColor\" class=\"chart-lastprice\"></span>\n" +
    "\t\t\t<span id=\"chartMarkerText\" class=\"chart-marker-text\"></span>\n" +
    "\t\t</div>\n" +
    "\t\t\n" +
    "\t\t<div class=\"row vertical-padding-5\">\n" +
    "\t\t\t<div class=\"col-md-12  horizontal-padding-10 fs-header\">\n" +
    "\t\t\t\t<div class=\"pull-left\">\n" +
    "\t\t\t\t\t<div class=\"dropdown\">\n" +
    "\t\t\t\t\t\t<button class=\"btn btn-normal btn-sm drowdowp-toggle btn-source-chooser\" id=\"fs-source-chooser\"\n" +
    "\t\t\t\t\t\t\trole=\"button\" data-toggle=\"dropdown\" ng-keydown=\"buttonOnKeyDown($event)\" name=\"btn_stock_dropdown\" data-target=\"#\">\n" +
    "\t\t\t\t\t\t\t<span>{{selectedItem}}</span>\n" +
    "\t\t\t\t\t\t\t<b class=\"caret\"></b>\n" +
    "\t\t\t\t\t\t</button>\n" +
    "\t\t\t\t\t\t<ul id=\"dropDownUL\" class=\"dropdown-menu pull-left\" role=\"menu\" ng-keydown=\"dropdownOnKeyDown($event)\" aria-labelledby=\"fs-source-chooser\">\n" +
    "\t\t\t\t\t\t\t<li ng-repeat=\"value in dropDownItems\">\n" +
    "\t\t\t\t\t\t\t\t<a ng-click=\"featuredIdeas.switchProductView(value.product)\"\n" +
    "\t\t\t\t\t\t\t\t   role=\"menuitem\"\n" +
    "\t\t\t\t\t\t\t\t   href=\"#\"\n" +
    "\t\t\t\t\t\t\t\t   ga-click-event=\"select-category\"\n" +
    "\t\t\t\t\t\t\t\t   data-category=\"ideas-platform\"\n" +
    "\t\t\t\t\t\t\t\t   data-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\n" +
    "\t\t\t\t\t\t\t\t   data-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "\t\t\t\t\t\t\t\t   data-widget=\"{{selectedProduct}}\">{{value.name}}\n" +
    "\t\t\t\t\t\t\t\t</a>\n" +
    "\t\t\t\t\t\t\t</li>\n" +
    "\t\t\t\t\t\t</ul>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<div class=\"pull-right\">\n" +
    "\t\t\t\t\t<div class=\"pull-left horizontal-padding-10 fs-header\">\n" +
    "\t\t\t\t\t\t<personal-url-button name=\"featured_stocks_personal_url\" product=\"selectedProduct\" popover-position=\"'bottom'\" first-tab=\"personal_link\" last-tab=\"personal_cancel\"></personal-url-button>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t<div class=\"pull-left fs-header-links\" >\n" +
    "\t\t\t\t\t\t\t<button class=\"fs-watched-button fs-btn-custom-settings\"\n" +
    "\t\t\t\t\t\t\t\t\tga-click-event=\"click-category\"\n" +
    "\t\t\t\t\t\t\t\t\tdata-category=\"ideas-platform\"\n" +
    "\t\t\t\t\t\t\t\t\tdata-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\n" +
    "\t\t\t\t\t\t\t\t\tdata-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "\t\t\t\t\t\t\t\t\tdata-widget=\"{{selectedProduct}}\"\n" +
    "\t\t\t\t\t\t\t\t\tng-click=\"featuredIdeas.switchProductView(watchedProduct)\"\n" +
    "\t\t\t\t\t\t\t\t\taria-label=\"{{watchedCount}} {{assetLexicon}}\">\n" +
    "\t\t\t\t\t\t\t\t<div class=\"fs-icon-text-style\"><i class=\"fa fa-star fs-icon-text-style\"></i></div>\n" +
    "\t\t\t\t\t\t\t\t<div class=\"fs-watched-count-number\">{{watchedCount}}</div>\n" +
    "\t\t\t\t\t\t\t</button>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t<div class=\"pull-left fs-header-links\" >\n" +
    "\t\t\t\t\t\t<span ng-include src=\"'custom_settings_btn/template.html'\"></span>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"row\">\n" +
    "\t\t\t<div class=\"col-md-12  horizontal-padding-10\">\n" +
    "\t\t\t\t<span >\n" +
    "\t\t\t\t\t<span ng-include src=\"'event_navigation/template.html'\" ></span>\n" +
    "\t\t\t\t</span>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"row\">\n" +
    "\t\t\t<div class=\"swipe-item-container\">\n" +
    "\t\t\t\t<div ng-repeat=\"featured in ideas track by featured.idea['linkId']+$index\" swipe-scroll=\"idea_scroller\" class=\"col-md-12 horizontal-padding-10\"  repeat-directive>\n" +
    "\t\t\t\t\t<span ng-init=\"featured=featured;ideaId=$index;ideaLength=ideas.length\" ng-include src=\"'event_details/template.html'\"></span>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('widgets/instrument_lookup/template.html',
    "<div ng-controller=\"InstrumentLookupCtrl\" class=\"container-fluid\">\n" +
    "\t<div class=\"row\">\n" +
    "\n" +
    "\t\t<!--Instrument Select-->\n" +
    "\t\t<div class=\"col-md-8 il-symbol-entry no-padding\">\n" +
    "\t\t\t<form ng-include src=\"'instrument_select/template.html'\" ng-init=\"buttonIndex='1'\"></form>\n" +
    "\t\t</div>\n" +
    "\n" +
    "\t\t<!--Index Shortcuts-->\n" +
    "\t\t<div class=\"col-md-4 btn-group  il-index-select no-padding\" ng-show=\"!hideIndexSelector && indexes.length > 0\">\n" +
    "\t\t\t<button class=\"btn btn-normal dropdown-toggle pull-right\" data-toggle=\"dropdown\"  data-tabindex=\"102\" ng-keydown=\"buttonOnKeyDown($event)\">\n" +
    "\t\t\t\t{{text.indexSelector}}&nbsp;&nbsp;<span class=\"caret\"></span>\n" +
    "\t\t\t</button>\n" +
    "\t\t\t<ul class=\"dropdown-menu pull-right\" role=\"menu\" ng-keydown=\"dropdownOnKeyDown($event)\">\n" +
    "\t\t\t\t<li ng-repeat=\"index in indexes\">\n" +
    "\t\t\t\t\t<a ng-click=\"searchIndex(index)\" role=\"menuitem\"  href=\"#\">\n" +
    "\t\t\t\t\t\t<span>{{ index.name }}</span>\n" +
    "\t\t\t\t\t</a>\n" +
    "\t\t\t\t</li>\n" +
    "\t\t\t</ul>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('widgets/options_ideas_csv/template.html',
    "<div ng-controller=\"OptionsIdeasCsvCtrl\" class=\"container-fluid\">\n" +
    "\n" +
    "\t<!-- Select instrument -->\n" +
    "\t<div class=\"row\">\n" +
    "\t\t<div class=\"col-md-6 il-symbol-entry no-padding\">\n" +
    "\t\t\t<form ng-include src=\"'instrument_select/template.html'\"></form>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "\n" +
    "\tSpecify target with:\n" +
    "\t<!-- Select custom target -->\n" +
    "\t<div class=\"row\">\n" +
    "\t\t<div class=\"col-md-3\">\n" +
    "\t\t\t<input type=\"radio\" id=\"target_custom\" ng-model=\"target\" value=\"custom\" />\n" +
    "\t\t\t<label for=\"target_custom\">Custom price and date range</label>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"col-md-9\" ng-show=\"target == 'custom'\">\n" +
    "\t\t\tPrice: <input type=\"number\" step=\"0.01\" min=\"0.01\" size=\"10\" ng-model=\"price\">\n" +
    "\t\t\tbetween: <input type=\"text\" size=\"10\" datepicker\n" +
    "\t\t\t\tdate-value=\"dates.begin\" min-date=\"dates.min\" date-format=\"dates.format\" />\n" +
    "\t\t\tand: <input type=\"text\" size=\"10\" datepicker\n" +
    "\t\t\t\tdate-value=\"dates.end\" min-date=\"dates.min\" date-format=\"dates.format\" />\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "\n" +
    "\t<!-- Select event target -->\n" +
    "\t<div class=\"row\">\n" +
    "\t\t<div class=\"col-md-3\">\n" +
    "\t\t\t<input type=\"radio\" id=\"target_event\" ng-model=\"target\" value=\"eventId\" />\n" +
    "\t\t\t<label for=\"target_event\">Event ID</label>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"col-md-9\" ng-show=\"target == 'eventId'\">\n" +
    "\t\t\t<input type=\"text\" size=\"32\" ng-model=\"eventId\" />\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "\n" +
    "\t<div class=\"row\">\n" +
    "\t\t<div class=\"col-md-12\" style=\"overflow: auto; width: 980px; max-height: 600px; white-space: pre;\">{{output}}</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('widgets/options_lookup/template.html',
    "<div ng-controller=\"OptionsLookupCtrl\" class=\"container-fluid\">\n" +
    "\t<a href=\"\" data-toggle=\"modal\" data-target=\"#alt_strategy_modal\" ng-click=\"initializeModal()\">Compare ({{comparedCount}}/{{maxComparedCount}})</a>\n" +
    "\t<span ng-include src=\"comparableIdeasModal\"></span>\n" +
    "\n" +
    "\t<div class=\"modal fs-watched-modal\" disable-scrollbar data-manager=\"div.recognia\"\n" +
    "\t\t\tmodal-show=\"showErrorModal\">\n" +
    "\t\t<div class=\"modal-header\">{{text.errorHeader}}</div>\n" +
    "\t\t<div class=\"modal-body\">\n" +
    "\t\t\t<p class=\"ol-error-modal-text\">{{text.error}}</p>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"modal-footer\">\n" +
    "\t\t\t<div class=\"cursor-pointer\" data-dismiss=\"modal\">{{text.errorDismiss}}</div>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "\n" +
    "\t<h1>Options Lookup</h1>\n" +
    "\t<br/>\n" +
    "\t<!-- Select instrument -->\n" +
    "\t<div class=\"row\">\n" +
    "\t\t<div class=\"col-md-8\">\n" +
    "\t\t\t<div>\n" +
    "\t\t\t\t<input type=\"checkbox\" name=\"optionableSearch\" id=\"optionableSearchInp\" ng-model=\"optionableSearch\" ng-change=\"getAutoSuggestResults()\">\n" +
    "\t\t\t\t<label for=\"optionableSearchInp\">Optionable</label>\n" +
    "\t\t\t\t<br>\n" +
    "\t\t\t\t<input type=\"checkbox\" name=\"fundamentalSearch\" id=\"fundamentalSearchInp\" ng-model=\"fundamentalSearch\"  ng-change=\"getAutoSuggestResults()\">\n" +
    "\t\t\t\t<label for=\"fundamentalSearchInp\">Fundamentals</label>\n" +
    "\t\t\t\t<br>\n" +
    "\t\t\t\t<label for=\"limitInp\">LIMIT</label>\n" +
    "\t\t\t\t<input type=\"text\" name=\"limit\" id=\"limitInp\" value=\"\" size=\"3\" ng-model=\"limit\" ng-change=\"getAutoSuggestResults()\">\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<br>\n" +
    "\t\t\t<div class=\"btn-group input-group\">\n" +
    "\t\t\t\t<input type=\"text\" id=\"symbol_search_txt_inp\" placeholder=\"{{'instrument_lookup.symbol-placeholder' | lexicon}}\" ng-model=\"searchSymbol\" class=\"pull-left form-control auto-width\" ng-change=\"getAutoSuggestResults()\">\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<style type=\"text/css\">\n" +
    "\t\t\t\tdiv#auto_suggest_box {\n" +
    "\t\t\t\t\tborder:1px solid #CCCCCC;\n" +
    "\t\t\t\t\tpadding: 14px;\n" +
    "\t\t\t\t\tmargin: 4px 0;\n" +
    "\t\t\t\t}\n" +
    "\t\t\t\t.select-row:hover {\n" +
    "\t\t\t\t\tbackground-color: #FFFF00;\n" +
    "\t\t\t\t\tcolor: #000;\n" +
    "\t\t\t\t\tcursor: pointer;\n" +
    "\t\t\t\t}\n" +
    "\t\t\t\t.selected-row {\n" +
    "\t\t\t\t\tbackground-color: #000050;\n" +
    "\t\t\t\t\tcolor: #fff;\n" +
    "\t\t\t\t}\n" +
    "\t\t\t\t.lighten {\n" +
    "\t\t\t\t\tcolor:#CCCCCC;\n" +
    "\t\t\t\t}\n" +
    "\t\t\t</style>\n" +
    "\t\t\t<div ng-hide=\"!autoSuggest.length\" id=\"auto_suggest_box\">\n" +
    "\t\t\t\t<div class=\"row select-row\" ng-repeat=\"suggestion in autoSuggest\" ng-class=\"{ 'selected-row': $index == selectedRowIndex }\" ng-click=\"selectAutoSuggestRow($index, suggestion.id)\" data-instrument-id=\"suggestion.id\">\n" +
    "\t\t\t\t\t<div class=\"col-md-2 col-sm-6 col-xs-6\">\n" +
    "\t\t\t\t\t\t<span ng-bind-html=\"suggestion.symbol\">{{suggestion.symbol}}</span>\n" +
    "\t\t\t\t\t\t<span class=\"lighten hidden-md hidden-lg visible-sm visible-xs\">:{{suggestion.exchangeSymbol}}</span>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t<div ng-bind-html=\"suggestion.name\" class=\"col-md-8 col-sm-6 col-xs-6\">{{suggestion.name}}</div>\n" +
    "\t\t\t\t\t<div ng-bind-html=\"suggestion.exchangeSymbol\" class=\"col-md-2 hidden-sm hidden-xs visible-md visible-lg\">{{suggestion.exchange}}</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t\t<br/>\n" +
    "\t\t\tSort By:\n" +
    "\t\t\t<select class=\"form-control\"  ng-options=\"sort as sort.name for sort in sortOrder\"\n" +
    "\t\t\t\t\tng-model=\"sortParam\">\n" +
    "\t\t\t</select>\n" +
    "\t\t\t<br/>\n" +
    "\t\t\tStrategy:\n" +
    "\t\t\t<select class=\"form-control\" ng-model=\"strategyParam\"\n" +
    "\t\t\t\t\tmultiple ng-multiple=\"true\" ng-options=\"strategy.strategyId as strategy.name for strategy in strategies\">\n" +
    "\t\t\t</select>\n" +
    "\n" +
    "\t\t\t<br/>\n" +
    "\t\t\tScore:\n" +
    "\t\t\t<select class=\"form-control\"  ng-options=\"score as score.name for score in scores\"\n" +
    "\t\t\t\t\tng-model=\"scoreParam\">\n" +
    "\t\t\t</select>\n" +
    "\t\t\t<br/>\n" +
    "\t\t\tTime Frame:\n" +
    "\t\t\t<select class=\"form-control\"  ng-options=\"time as time.name for time in timeHorizon\"\n" +
    "\t\t\t\t\tng-model=\"timeParam\">\n" +
    "\t\t\t</select>\n" +
    "\t\t\t<br/>\n" +
    "\t\t\tBudget:\n" +
    "\t\t\t<select class=\"form-control\"  ng-options=\"budget as budget.name for budget in budget\"\n" +
    "\t\t\t\t\tng-model=\"budgetParam\">\n" +
    "\t\t\t</select>\n" +
    "\t\t\t<br/>\n" +
    "\t\t\tReward Risk:\n" +
    "\t\t\t<select class=\"form-control\"  ng-options=\"rr as rr.name for rr in rewardRisk\"\n" +
    "\t\t\t\t\tng-model=\"rewardRiskParam\">\n" +
    "\t\t\t</select>\n" +
    "\t\t\t<br/>\n" +
    "\n" +
    "\t\t\t<input type=\"checkbox\"\n" +
    "\t\t\t\t   ng-model=\"openInterest\"> Open Interest Required\n" +
    "\t\t\t<br/>\n" +
    "\t\t\t<br/>\n" +
    "\t\t\t<input type=\"checkbox\"\n" +
    "\t\t\t\t   ng-model=\"volume\"> Options Contract Volume Required\n" +
    "\t\t\t<br/>\n" +
    "\t\t\t<br/>\n" +
    "\n" +
    "\t\t\t<button class=\"btn btn-normal btn-search\" ng-click=\"search()\" style=\"height: 34px;\">\n" +
    "\t\t\t\t<i class=\"fa fa-search fa-lg\"></i>\n" +
    "\t\t\t</button>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "\t<hr/>\n" +
    "\t<div class=\"row\">\n" +
    "\t\t<div class=\"col-md-12\" style=\"overflow: auto; max-height: 600px;\">\n" +
    "\t\t\t{{message}}\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "\t<div ng-repeat=\"(key, targetIdeas) in ideaResults\">\n" +
    "\t\t<hr/>\n" +
    "\t\t<h3>Target {{key}} {{meta[key]._horizonLexKey | lexicon}}</h3>\n" +
    "\t\tMatching Screens:\n" +
    "\t\t<ul>\n" +
    "\t\t\t<li ng-repeat=\"(name,count) in meta[key]._stratNames\">\n" +
    "\t\t\t\t{{count}} - {{name}}\n" +
    "\t\t\t</li>\n" +
    "\t\t</ul>\n" +
    "\t\t<div ng-repeat=\"(stratName, ideas) in targetIdeas\">\n" +
    "\t\t\t<h4>{{stratName}}</h4>\n" +
    "\t\t\t<table ng-repeat=\"idea in ideas | orderBy: '-trade.score'\" class=\"table table-bordered table-condensed\">\n" +
    "\t\t\t\t<tr>\n" +
    "\t\t\t\t\t<td>\n" +
    "\t\t\t\t\t\t{{idea.trade.scoreGrade}}<br/>\n" +
    "\t\t\t\t\t\t{{idea.trade.score | realRoundedToPlaces:2}}\n" +
    "\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t<td colspan=\"2\">\n" +
    "\t\t\t\t\t\t{{idea.instrument.name}}<br/>\n" +
    "\t\t\t\t\t\t{{idea.instrument.symbol + ': ' + idea.instrument.exchange.symbol}} {{idea.instrument.latestPrice.price | formatCurrency:idea.instrument.precision}} {{idea.instrument.currencySymbol}} - {{idea.instrument.latestPrice.timestamp}}<br/>\n" +
    "\n" +
    "\t\t\t\t\t\tScreening Mode: {{idea.strategy.name}}<br/>\n" +
    "\t\t\t\t\t</td>\n" +
    "\t\t\t\t</tr>\n" +
    "\t\t\t\t<tr>\n" +
    "\t\t\t\t\t<td>\n" +
    "\t\t\t\t\t\t<label><input type=\"checkbox\" ng-model=\"idea.isCompared\" ng-change=\"toggleCompared(idea)\"</input> Compare</label>\n" +
    "\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t<td>\n" +
    "\t\t\t\t\t\t<b>{{idea.trade.tradeStrategy.name}}</b>\n" +
    "\t\t\t\t\t\t<div ng-repeat=\"leg in idea.trade.legs\">\n" +
    "\t\t\t\t\t\t\t{{leg | tradeLegOneLineFormat:idea.instrument.precision}} - {{leg.instrument.latestPrice.timestamp}}\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\tDays to Expire : {{idea.daysToExpiry}}\n" +
    "\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t<td>\n" +
    "\t\t\t\t\t\tProfit Zone:\n" +
    "\t\t\t\t\t\t<span ng-show=\"idea.trade.profitZone[0].lower == 0\">below {{(idea.trade.profitZone[0].upper | formatCurrency:idea.instrument.precision)}}</span>\n" +
    "\t\t\t\t\t\t<span ng-show=\"idea.trade.profitZone[0].upper == 'Infinity'\">above {{(idea.trade.profitZone[0].lower | formatCurrency:idea.instrument.precision)}}</span>\n" +
    "\t\t\t\t\t\t<span ng-show=\"idea.trade.profitZone[0].lower > 0 && idea.trade.profitZone[0].upper != 'Ininity'\">{{idea.trade.profitZone[0].lower | formatCurrency:idea.instrument.precision}} &nbsp; - &nbsp; {{ idea.trade.profitZone[0].upper | formatCurrency:idea.instrument.precision }}<br/>\n" +
    "\t\t\t\t\t\tTarget Price: {{idea.targetPrice.target | formatCurrency:idea.instrument.precision}} <br/>\n" +
    "\t\t\t\t\t\tTarget Profit: {{idea.trade.targetProfit | formatCurrency:idea.instrument.precision}} ({{idea.trade.targetProfitPercent | nf_percent}})<br/>\n" +
    "\t\t\t\t\t\tMax Loss: {{idea.trade.maxLoss | formatCurrency:idea.instrument.precision}} ({{idea.trade.maxLossPercent | nf_percent}})\n" +
    "\t\t\t\t\t</td>\n" +
    "\t\t\t\t</tr>\n" +
    "\t\t\t\t<tr>\n" +
    "\t\t\t\t\t<td></td>\n" +
    "\t\t\t\t\t<td>\n" +
    "\t\t\t\t\t\tNet Cost: {{idea.trade.netCost | formatCurrency:idea.instrument.precision}}\n" +
    "\t\t\t\t\t</td>\n" +
    "\t\t\t\t\t<td>\n" +
    "\t\t\t\t\t\tReward to Risk Ratio: {{idea.trade.rewardRiskRatio | realRoundedToPlaces:2}}\n" +
    "\t\t\t\t\t</td>\n" +
    "\t\t\t\t</tr>\n" +
    "\t\t\t</table>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "\n" +
    "\t<span ng-include src=\"'compare_ideas/template.html'\"></span>\n" +
    "</div>\n"
  );


  $templateCache.put('widgets/personal_settings/template.html',
    "<div ng-controller=\"PersonalSettingsCtrl as personalSettings\" >\n" +
    "\t<div id=\"myModal\" class=\"modal fade personal-settings-modal\"\n" +
    "\t\t\trole=\"dialog\" aria-hidden=\"true\" disable-scrollbar\n" +
    "\t\t\tdata-manager=\"div.recognia\" data-backdrop=\"static\"\n" +
    "\t\t\tmodal-show=\"showPersonalSettings\"\n" +
    "\t\t\tmodal-focus-show=\"#firstFocus\" modal-focus-hide=\"#custom_setting_button\"\n" +
    "\t\t\tfocus-tab first-tab=\"firstFocus\" last-tab=\"bottom-settings-done-btn\">\n" +
    "\t\t<div class=\"modal-body\">\n" +
    "\t\t\t<div class=\"container-fluid \">\n" +
    "\t\t\t\t<!--Header-->\n" +
    "\t\t\t\t<div class=\"row\">\n" +
    "\t\t\t\t\t<div class=\"container-narrow\">\n" +
    "\t\t\t\t\t\t<!--Visible for desktops and tablets-->\n" +
    "\t\t\t\t\t\t<div class=\"col-md-12 \">\n" +
    "\t\t\t\t\t\t\t<div class=\"personal-settings-title\">\n" +
    "\t\t\t\t\t\t\t\t<button id=\"firstFocus\"\n" +
    "\t\t\t\t\t\t\t\t\t\ttype=\"button\"\n" +
    "\t\t\t\t\t\t\t\t\t\tclass=\"btn pull-right personal-settings-save\"\n" +
    "\t\t\t\t\t\t\t\t\t\tng-click=\"personalSettings.save()\" data-dismiss=\"modal\" tabindex=\"0\">\n" +
    "\t\t\t\t\t\t\t\t\t{{'personalsettings.settings-save' | lexicon}}\n" +
    "\t\t\t\t\t\t\t\t</button>\n" +
    "\t\t\t\t\t\t\t\t<span class=\"personal-settings-title-text\">{{'personalsettings.settings-title' | lexicon}}</span>\n" +
    "\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<!--Body-->\n" +
    "\t\t\t\t<div class=\"container-narrow\">\n" +
    "\t\t\t\t\t<!-- Bootstrap component to be able to collapse content -->\n" +
    "\t\t\t\t\t<div class=\"panel-group\" id=\"settings-accordion\">\n" +
    "\t\t\t\t\t\t<div align=\"center\">{{ noPersonalSettings }}</div>\n" +
    "\t\t\t\t\t\t<div ng-repeat=\"group in groupsTranslated\">\n" +
    "\t\t\t\t\t\t\t<div class=\"panel panel-default\" ng-class=\"{'panel-first':$first}\">\n" +
    "\t\t\t\t\t\t\t\t<div class=\"panel-heading\">\n" +
    "\t\t\t\t\t\t\t\t\t<button data-toggle=\"collapse\"\n" +
    "\t\t\t\t\t\t\t\t\t   data-parent=\"#settings-accordion\"\n" +
    "\t\t\t\t\t\t\t\t\t   href=\"#{{group.questions[0]['linkId']}}\" ng-click=\"isCollapsed = !isCollapsed\" class=\"btn-panel-button\" >\n" +
    "\t\t\t\t\t\t\t\t\t\t<h1 class=\"personal-settings-group-title\">{{'personalization.'+group.name | lexicon}}\n" +
    "\t\t\t\t\t\t\t\t\t\t\t<i ng-class=\"{'fa fa-chevron-left':isCollapsed,'fa fa-chevron-down':!isCollapsed}\"\n" +
    "\t\t\t\t\t\t\t\t\t\t\t   class=\"pull-right\"></i>\n" +
    "\t\t\t\t\t\t\t\t\t\t</h1>\n" +
    "\t\t\t\t\t\t\t\t\t</button>\n" +
    "\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t\t<div id=\"{{group.questions[0]['linkId']}}\" class=\"panel-collapse collapse in\">\n" +
    "\t\t\t\t\t\t\t\t\t<div class=\"panel-body\">\n" +
    "\t\t\t\t\t\t\t\t\t\t<hr class=\"personal-settings-horizontal-line\">\n" +
    "\t\t\t\t\t\t\t\t\t\t<div class=\"personal-settings-answer-container\">\n" +
    "\t\t\t\t\t\t\t\t\t\t\t<div class=\"personal-settings-group-subtitle\"><span\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\tng-bind-html=\"group.subTitle\"></span></div>\n" +
    "\t\t\t\t\t\t\t\t\t\t\t<div>\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t<div ng-repeat=\"question in group.questions\">\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-init=\"selectedQuestion=question\"\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-include src=\"'style_checkbox/template.html'\">\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n" +
    "\t\t\t\t\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<!--Footer-->\n" +
    "\t\t\t\t<div class=\"row\">\n" +
    "\t\t\t\t\t<!--Visible for desktops and tablets-->\n" +
    "\t\t\t\t\t<div class=\"container-narrow\">\n" +
    "\t\t\t\t\t\t<div class=\"col-md-12\">\n" +
    "\t\t\t\t\t\t\t<div class=\"personal-settings-title-footer\">\n" +
    "\t\t\t\t\t\t\t\t<button id=\"bottom-settings-done-btn\"\n" +
    "\t\t\t\t\t\t\t\t\t\ttype=\"button\"\n" +
    "\t\t\t\t\t\t\t\t\t\tclass=\"btn btn-primary pull-right personal-settings-save\"\n" +
    "\t\t\t\t\t\t\t\t\t\tng-click=\"personalSettings.save()\" data-dismiss=\"modal\" tabindex=\"0\" >\n" +
    "\t\t\t\t\t\t\t\t\t{{'personalsettings.settings-save' | lexicon}}\n" +
    "\t\t\t\t\t\t\t\t</button>\n" +
    "\t\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('widgets/profile_questionnaire/template.html',
    "<div ng-controller=\"QuestionnaireCtrl\">\n" +
    "\t<!-- Modal -->\n" +
    "\t<div class=\"modal fs-popup-modal\" role=\"dialog\"\n" +
    "\t\t\tdata-modal-overflow=\"true\" data-manager=\"div.recognia\" disable-scrollbar\n" +
    "\t\t\tmodal-show=\"showProfileQuestionnaire\" modal-focus-show=\"#questionnaire-close\">\n" +
    "\t\t<div class=\"modal-header\">\n" +
    "\t\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"showProfileQuestionnaire = false;\" id=\"questionnaire-close\" data-tabindex=\"1\">&times;</button>\n" +
    "\t\t\t<h1 ng-if=\"settingsTitle\" class=\"tc-profile-questionnaire-header\">{{settingsTitle}}</h1>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"modal-body\">\n" +
    "\t\t\t<div class=\"container-fluid personal-settings-answer-container\">\n" +
    "\t\t\t\t<div class=\"row personal-settings-group-subtitle\">\n" +
    "\t\t\t\t\t<span ng-bind-html=\"settingsSubtitle\"></span>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t\t<div class=\"row\">\n" +
    "\t\t\t\t\t<div class=\"col-md-12\">\n" +
    "\t\t\t\t\t\t<div ng-repeat=\"question in questions\" ng-init=\"sectionIndex = $index * 20\">\n" +
    "\t\t\t\t\t\t\t<span ng-init=\"selectedQuestion=question\" ng-include\n" +
    "\t\t\t\t\t\t\t\t  src=\"'style_checkbox/template.html'\"></span>\n" +
    "\t\t\t\t\t\t</div>\n" +
    "\t\t\t\t\t</div>\n" +
    "\t\t\t\t</div>\n" +
    "\t\t\t</div>\n" +
    "\t\t</div>\n" +
    "\t\t<div class=\"modal-footer\">\n" +
    "\t\t\t<button class=\"btn btn-normal\"\n" +
    "\t\t\t\t\tdata-dismiss=\"modal\"\n" +
    "\t\t\t\t\tga-click-event=\"prompt-custom-settings-dismissed\"\n" +
    "\t\t\t\t\tdata-category=\"ideas-platform\"\n" +
    "\t\t\t\t\tdata-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\n" +
    "\t\t\t\t\tdata-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "\t\t\t\t\tdata-widget=\"{{selectedProduct}}\"\n" +
    "\t\t\t\t\tng-click=\"saveEmpty()\" data-tabindex=\"300\">{{'personalsettings.settings-ignore' | lexicon}}</button>\n" +
    "\t\t\t<button class=\"btn btn-primary\"\n" +
    "\t\t\t\t\tdata-dismiss=\"modal\"\n" +
    "\t\t\t\t\tga-click-event=\"prompt-custom-settings-answered\"\n" +
    "\t\t\t\t\tdata-category=\"ideas-platform\"\n" +
    "\t\t\t\t\tdata-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\n" +
    "\t\t\t\t\tdata-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "\t\t\t\t\tdata-widget=\"{{selectedProduct}}\"\n" +
    "\t\t\t\t\tng-click=\"save()\" data-tabindex=\"301\">{{'personalsettings.settings-save' | lexicon}}</button>\n" +
    "\t\t</div>\n" +
    "\t</div>\n" +
    "</div>\n"
  );


  $templateCache.put('templates/directives/personal_url_button.html',
    "<button class=\"btn btn-info personal-url-button wrap-white-space\"\n" +
    "\tng-hide=\"!showMobileLink || getPersonalUrl()==null || getPersonalUrl()==''\"\n" +
    "\tga-click-event=\"view-personal-link\"\n" +
    "\tdata-category=\"ideas-platform\"\n" +
    "\tdata-symbol=\"{{selectedIdea.idea.instrument.symbol}}\"\n" +
    "\tdata-idea-type=\"{{selectedIdea.idea.ideaType}}\"\n" +
    "\tdata-widget=\"{{selectedProduct}}\"\n" +
    "\tpop-over-click=\"{{getPopoverPosition()}}\"\n" +
    "\tpop-over-init-focus=\"personal_link\"\n" +
    "\tpop-over-instance=\"{{instanceName}}\"\n" +
    "\tdata-original-title=\"{{personalUrlPopoverTitle}}\"\n" +
    "\tdata-content=\"{{personalUrlPopoverContent}}\n" +
    "\t\t<div class='wrap-text'>\n" +
    "\t\t\t<a id='personal_link' href={{getPersonalUrl()}} target='_blank'>{{getPersonalUrl()}}</a>\n" +
    "\t\t\t<input type='hidden' id='personalUrlContent' name='urlContent' value='{{getPersonalUrl()}}' />\n" +
    "\t\t</div>\n" +
    "\t\t<br>\n" +
    "\t\t<div class='no-underline send-to-mobile-buttons'>\n" +
    "\t\t\t<script>\n" +
    "\t\t\t\tfunction setClipboard() {\n" +
    "\t\t\t\t\tvar copyText = document.getElementById('personalUrlContent');\n" +
    "\t\t\t\t\tvar tempInput = document.createElement('input');\n" +
    "\t\t\t\t\ttempInput.style = 'position: absolute; left: -1000px; top: -1000px';\n" +
    "\t\t\t\t\ttempInput.value = copyText.value;\n" +
    "\t\t\t\t\tdocument.body.appendChild(tempInput);\n" +
    "\t\t\t\t\ttempInput.select();\n" +
    "\t\t\t\t\tdocument.execCommand('copy');\n" +
    "\t\t\t\t\tdocument.body.removeChild(tempInput);\n" +
    "\t\t\t\t}\n" +
    "\t\t\t\tvar closePopOver = function(elem) {\n" +
    "\t\t\t\t\t$('button[pop-over-instance=&quot;{{instanceName}}&quot;]').focus();\n" +
    "\t\t\t\t\telem.parent().parent().parent().hide();\n" +
    "\t\t\t\t};\n" +
    "\t\t\t</script>\n" +
    "\t\t\t<button class='btn btn-normal' onclick='setClipboard()' >{{sendButtonCopy}}</button>\n" +
    "\t\t\t<button id='personal_cancel' class='btn btn-normal' onclick='closePopOver($(this))'>{{sendButtonCancel}}</button>\n" +
    "\t\t</div>\"\n" +
    ">\n" +
    "\t<span>\n" +
    "\t\t<span class=\"personal-settings-url-img\"><i class=\"fa fa-mobile fa-2x\"></i></span>\n" +
    "\t\t<span class=\"personal-settings-url-text\">{{personalUrl}}</span>\n" +
    "\t</span>\n" +
    "</button>\n"
  );

}]);

'use strict';

recogniaApp.controller('PageController',
['$scope', '$window', 'Config', 'REST',
function ($scope, $window, Config, REST) {

	function getQueryParameter(location, name) {
		name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
			results = regex.exec(location.search);
		return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	}

	// Set the user authentication string
	var auth = getQueryParameter($window.location, REST.PARAMS.AUTHORIZATION),
		pageid = getQueryParameter($window.location, 'pageid'),
		token = getQueryParameter($window.location, 'token');

	// Set the language parameter
	var lang = getQueryParameter($window.location, REST.PARAMS.LANG);

	if (lang !== undefined && lang !== "") {
		Config.setLanguage(lang);
	}

	var debug = getQueryParameter($window.location, 'debug');
	if (debug !== undefined && debug !== "") {
		Config.setEnableDebug(debug);
	}

	Config.setUserAuthorization(auth);
	Config.setUserTokenAuthorization(token);
	Config.setStandalonePlatform();

	if (!pageid){
		console.error('No pageid parameter specified');
	} else {
		$scope.page = 'pages/' + pageid + '.html';
	}

}]);

//# sourceMappingURL=recognia.min.js.map